import { FluenceApiClientBase, AuthClient } from './ApiClientBase';
// <auto-generated>
//     Generated using the NSwag toolchain v14.1.0.0 (NJsonSchema v11.0.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

export class AcctRecClient extends FluenceApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    generateCode(): Promise<void> {
        let url_ = this.baseUrl + "/AcctRec/process";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGenerateCode(_response));
        });
    }

    protected processGenerateCode(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    accountRecCodeAutogenerate(): Promise<void> {
        let url_ = this.baseUrl + "/AcctRec/accountreccodeautogenerate";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAccountRecCodeAutogenerate(_response));
        });
    }

    protected processAccountRecCodeAutogenerate(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class AiClient extends FluenceApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    helpChatTurn(message: HelpChatMessage): Promise<HelpChatMessage> {
        let url_ = this.baseUrl + "/Ai/HelpChatTurn";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(message);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processHelpChatTurn(_response));
        });
    }

    protected processHelpChatTurn(response: Response): Promise<HelpChatMessage> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HelpChatMessage.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HelpChatMessage>(null as any);
    }

    getHelpArticles(): Promise<HelpArticle[]> {
        let url_ = this.baseUrl + "/Ai";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetHelpArticles(_response));
        });
    }

    protected processGetHelpArticles(response: Response): Promise<HelpArticle[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(HelpArticle.fromJS(resultData200[item]));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HelpArticle[]>(null as any);
    }
}

export class AnaplanClient extends FluenceApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getADOActionTypes(datasource: string): Promise<ADOActionType[]> {
        let url_ = this.baseUrl + "/Anaplan/actiontypes/{datasource}";
        if (datasource === undefined || datasource === null)
            throw new Error("The parameter 'datasource' must be defined.");
        url_ = url_.replace("{datasource}", encodeURIComponent("" + datasource));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetADOActionTypes(_response));
        });
    }

    protected processGetADOActionTypes(response: Response): Promise<ADOActionType[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(ADOActionType.fromJS(resultData200[item]));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ADOActionType[]>(null as any);
    }

    getADOActionsWithDataspace(datasource: string, actiontype: string, dataspace: string): Promise<ADOAction[]> {
        let url_ = this.baseUrl + "/Anaplan/actions/{datasource}/{actiontype}/dataspace/{dataspace}";
        if (datasource === undefined || datasource === null)
            throw new Error("The parameter 'datasource' must be defined.");
        url_ = url_.replace("{datasource}", encodeURIComponent("" + datasource));
        if (actiontype === undefined || actiontype === null)
            throw new Error("The parameter 'actiontype' must be defined.");
        url_ = url_.replace("{actiontype}", encodeURIComponent("" + actiontype));
        if (dataspace === undefined || dataspace === null)
            throw new Error("The parameter 'dataspace' must be defined.");
        url_ = url_.replace("{dataspace}", encodeURIComponent("" + dataspace));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetADOActionsWithDataspace(_response));
        });
    }

    protected processGetADOActionsWithDataspace(response: Response): Promise<ADOAction[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(ADOAction.fromJS(resultData200[item]));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ADOAction[]>(null as any);
    }

    triggerJob(datasource: string): Promise<string> {
        let url_ = this.baseUrl + "/Anaplan/actiontypes/{datasource}/pipeline";
        if (datasource === undefined || datasource === null)
            throw new Error("The parameter 'datasource' must be defined.");
        url_ = url_.replace("{datasource}", encodeURIComponent("" + datasource));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processTriggerJob(_response));
        });
    }

    protected processTriggerJob(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    getADOPipelines(datasource: string): Promise<PipelineDefinitionItem[]> {
        let url_ = this.baseUrl + "/Anaplan/actions/{datasource}/pipeline";
        if (datasource === undefined || datasource === null)
            throw new Error("The parameter 'datasource' must be defined.");
        url_ = url_.replace("{datasource}", encodeURIComponent("" + datasource));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetADOPipelines(_response));
        });
    }

    protected processGetADOPipelines(response: Response): Promise<PipelineDefinitionItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(PipelineDefinitionItem.fromJS(resultData200[item]));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PipelineDefinitionItem[]>(null as any);
    }

    getADOPipelinesWithDataspace(datasource: string, dataspace: string): Promise<PipelineDefinitionItem[]> {
        let url_ = this.baseUrl + "/Anaplan/actions/{datasource}/pipeline/dataspace/{dataspace}";
        if (datasource === undefined || datasource === null)
            throw new Error("The parameter 'datasource' must be defined.");
        url_ = url_.replace("{datasource}", encodeURIComponent("" + datasource));
        if (dataspace === undefined || dataspace === null)
            throw new Error("The parameter 'dataspace' must be defined.");
        url_ = url_.replace("{dataspace}", encodeURIComponent("" + dataspace));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetADOPipelinesWithDataspace(_response));
        });
    }

    protected processGetADOPipelinesWithDataspace(response: Response): Promise<PipelineDefinitionItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(PipelineDefinitionItem.fromJS(resultData200[item]));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PipelineDefinitionItem[]>(null as any);
    }

    getADOActions(datasource: string, actiontype: string): Promise<ADOAction[]> {
        let url_ = this.baseUrl + "/Anaplan/actions/{datasource}/{actiontype}";
        if (datasource === undefined || datasource === null)
            throw new Error("The parameter 'datasource' must be defined.");
        url_ = url_.replace("{datasource}", encodeURIComponent("" + datasource));
        if (actiontype === undefined || actiontype === null)
            throw new Error("The parameter 'actiontype' must be defined.");
        url_ = url_.replace("{actiontype}", encodeURIComponent("" + actiontype));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetADOActions(_response));
        });
    }

    protected processGetADOActions(response: Response): Promise<ADOAction[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(ADOAction.fromJS(resultData200[item]));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ADOAction[]>(null as any);
    }

    getWorkflows(datasource: string): Promise<AnaplanWorkflow[]> {
        let url_ = this.baseUrl + "/Anaplan/workflows/{datasource}";
        if (datasource === undefined || datasource === null)
            throw new Error("The parameter 'datasource' must be defined.");
        url_ = url_.replace("{datasource}", encodeURIComponent("" + datasource));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetWorkflows(_response));
        });
    }

    protected processGetWorkflows(response: Response): Promise<AnaplanWorkflow[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(AnaplanWorkflow.fromJS(resultData200[item]));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AnaplanWorkflow[]>(null as any);
    }

    getDataspaces(datasource: string): Promise<ADODataspace[]> {
        let url_ = this.baseUrl + "/Anaplan/dataspaces/{datasource}";
        if (datasource === undefined || datasource === null)
            throw new Error("The parameter 'datasource' must be defined.");
        url_ = url_.replace("{datasource}", encodeURIComponent("" + datasource));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDataspaces(_response));
        });
    }

    protected processGetDataspaces(response: Response): Promise<ADODataspace[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(ADODataspace.fromJS(resultData200[item]));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ADODataspace[]>(null as any);
    }

    getDatasetsWithDataspace(datasource: string, dataspace: string): Promise<ADODataset[]> {
        let url_ = this.baseUrl + "/Anaplan/datasets/{datasource}/dataspace/{dataspace}";
        if (datasource === undefined || datasource === null)
            throw new Error("The parameter 'datasource' must be defined.");
        url_ = url_.replace("{datasource}", encodeURIComponent("" + datasource));
        if (dataspace === undefined || dataspace === null)
            throw new Error("The parameter 'dataspace' must be defined.");
        url_ = url_.replace("{dataspace}", encodeURIComponent("" + dataspace));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDatasetsWithDataspace(_response));
        });
    }

    protected processGetDatasetsWithDataspace(response: Response): Promise<ADODataset[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(ADODataset.fromJS(resultData200[item]));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ADODataset[]>(null as any);
    }

    getDatasets(datasource: string): Promise<ADODataset[]> {
        let url_ = this.baseUrl + "/Anaplan/datasets/{datasource}";
        if (datasource === undefined || datasource === null)
            throw new Error("The parameter 'datasource' must be defined.");
        url_ = url_.replace("{datasource}", encodeURIComponent("" + datasource));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDatasets(_response));
        });
    }

    protected processGetDatasets(response: Response): Promise<ADODataset[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(ADODataset.fromJS(resultData200[item]));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ADODataset[]>(null as any);
    }
}

export class AuditTrailClient extends FluenceApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getMetadataAuditLogs(paging: FilteredSortedPaging, timezoneOffsetMinutes?: number | undefined): Promise<MetadataAuditLogResult> {
        let url_ = this.baseUrl + "/AuditTrail?";
        if (timezoneOffsetMinutes === null)
            throw new Error("The parameter 'timezoneOffsetMinutes' cannot be null.");
        else if (timezoneOffsetMinutes !== undefined)
            url_ += "timezoneOffsetMinutes=" + encodeURIComponent("" + timezoneOffsetMinutes) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(paging);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetMetadataAuditLogs(_response));
        });
    }

    protected processGetMetadataAuditLogs(response: Response): Promise<MetadataAuditLogResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MetadataAuditLogResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MetadataAuditLogResult>(null as any);
    }

    exportMetadataAuditTrail(paging: FilteredSortedPaging, format?: string | null | undefined, timezoneOffsetMinutes?: number | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/AuditTrail/export?";
        if (format !== undefined && format !== null)
            url_ += "format=" + encodeURIComponent("" + format) + "&";
        if (timezoneOffsetMinutes === null)
            throw new Error("The parameter 'timezoneOffsetMinutes' cannot be null.");
        else if (timezoneOffsetMinutes !== undefined)
            url_ += "timezoneOffsetMinutes=" + encodeURIComponent("" + timezoneOffsetMinutes) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(paging);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExportMetadataAuditTrail(_response));
        });
    }

    protected processExportMetadataAuditTrail(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export class Auth0ConfigClient extends FluenceApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    get(): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/Auth0Config";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGet(_response));
        });
    }

    protected processGet(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export class DashboardClient extends FluenceApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getDashboards(): Promise<DashboardSection[]> {
        let url_ = this.baseUrl + "/Dashboard/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDashboards(_response));
        });
    }

    protected processGetDashboards(response: Response): Promise<DashboardSection[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(DashboardSection.fromJS(resultData200[item]));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DashboardSection[]>(null as any);
    }

    myDashboards(): Promise<DashboardSection[]> {
        let url_ = this.baseUrl + "/Dashboard";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processMyDashboards(_response));
        });
    }

    protected processMyDashboards(response: Response): Promise<DashboardSection[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(DashboardSection.fromJS(resultData200[item]));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DashboardSection[]>(null as any);
    }

    createNewDashboard(dashboardSection?: DashboardSection | undefined, source?: number | null | undefined): Promise<DashboardSection> {
        let url_ = this.baseUrl + "/Dashboard?";
        if (source !== undefined && source !== null)
            url_ += "source=" + encodeURIComponent("" + source) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dashboardSection);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateNewDashboard(_response));
        });
    }

    protected processCreateNewDashboard(response: Response): Promise<DashboardSection> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DashboardSection.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DashboardSection>(null as any);
    }

    updateDashboards(dashboardSections: DashboardSection[], ignoreDashboardControls?: boolean | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Dashboard?";
        if (ignoreDashboardControls === null)
            throw new Error("The parameter 'ignoreDashboardControls' cannot be null.");
        else if (ignoreDashboardControls !== undefined)
            url_ += "ignoreDashboardControls=" + encodeURIComponent("" + ignoreDashboardControls) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dashboardSections);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateDashboards(_response));
        });
    }

    protected processUpdateDashboards(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getDashboard(id?: number | undefined): Promise<DashboardSection> {
        let url_ = this.baseUrl + "/Dashboard/id?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDashboard(_response));
        });
    }

    protected processGetDashboard(response: Response): Promise<DashboardSection> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DashboardSection.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DashboardSection>(null as any);
    }

    deleteDashboard(id?: number | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Dashboard/id?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteDashboard(_response));
        });
    }

    protected processDeleteDashboard(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    updateDashboard(id: number, dashboardSection: DashboardSection): Promise<void> {
        let url_ = this.baseUrl + "/Dashboard/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dashboardSection);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateDashboard(_response));
        });
    }

    protected processUpdateDashboard(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    export(sectionIds: number[]): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/Dashboard/export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sectionIds);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExport(_response));
        });
    }

    protected processExport(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    import(file?: FileParameter | null | undefined): Promise<DashboardSection[]> {
        let url_ = this.baseUrl + "/Dashboard/import";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("File", file.data, file.fileName ? file.fileName : "File");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processImport(_response));
        });
    }

    protected processImport(response: Response): Promise<DashboardSection[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(DashboardSection.fromJS(resultData200[item]));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DashboardSection[]>(null as any);
    }
}

export class DataSourceClient extends FluenceApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getAvailableDataSources(): Promise<DataSource[]> {
        let url_ = this.baseUrl + "/DataSource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAvailableDataSources(_response));
        });
    }

    protected processGetAvailableDataSources(response: Response): Promise<DataSource[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(DataSource.fromJS(resultData200[item]));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DataSource[]>(null as any);
    }

    getAvailableDataSourceDetails(): Promise<DataSourceExtended[]> {
        let url_ = this.baseUrl + "/DataSource/ConnectionStrings";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAvailableDataSourceDetails(_response));
        });
    }

    protected processGetAvailableDataSourceDetails(response: Response): Promise<DataSourceExtended[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(DataSourceExtended.fromJS(resultData200[item]));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DataSourceExtended[]>(null as any);
    }

    saveDataSources(datasources: DataSourceExtended[]): Promise<void> {
        let url_ = this.baseUrl + "/DataSource/ConnectionStrings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(datasources);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSaveDataSources(_response));
        });
    }

    protected processSaveDataSources(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class DevOpsClient extends FluenceApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Returns the DevOps environment hierarchy from SYSDB.
     */
    getEnvironments(): Promise<DevOpsEnvironment[]> {
        let url_ = this.baseUrl + "/DevOps";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetEnvironments(_response));
        });
    }

    protected processGetEnvironments(response: Response): Promise<DevOpsEnvironment[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(DevOpsEnvironment.fromJS(resultData200[item]));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DevOpsEnvironment[]>(null as any);
    }
}

export class EntraConfigClient extends FluenceApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    get(): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/EntraConfig";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGet(_response));
        });
    }

    protected processGet(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export class EtlClient extends FluenceApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getStagingTables(): Promise<StagingTableInfo[]> {
        let url_ = this.baseUrl + "/Etl/stagingtables";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetStagingTables(_response));
        });
    }

    protected processGetStagingTables(response: Response): Promise<StagingTableInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(StagingTableInfo.fromJS(resultData200[item]));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StagingTableInfo[]>(null as any);
    }

    getStagingTableFields(tableName?: string | null | undefined): Promise<StagingTableField[]> {
        let url_ = this.baseUrl + "/Etl/stagingtable?";
        if (tableName !== undefined && tableName !== null)
            url_ += "tableName=" + encodeURIComponent("" + tableName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetStagingTableFields(_response));
        });
    }

    protected processGetStagingTableFields(response: Response): Promise<StagingTableField[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(StagingTableField.fromJS(resultData200[item]));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StagingTableField[]>(null as any);
    }

    createStagingTable(fields: StagingTableField[], tableName?: string | null | undefined): Promise<number> {
        let url_ = this.baseUrl + "/Etl/stagingtable?";
        if (tableName !== undefined && tableName !== null)
            url_ += "tableName=" + encodeURIComponent("" + tableName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(fields);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateStagingTable(_response));
        });
    }

    protected processCreateStagingTable(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result201 = resultData201 !== undefined ? resultData201 : <any>null;
    
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    updateStagingTable(fields: StagingTableField[], tableName?: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Etl/stagingtable?";
        if (tableName !== undefined && tableName !== null)
            url_ += "tableName=" + encodeURIComponent("" + tableName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(fields);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateStagingTable(_response));
        });
    }

    protected processUpdateStagingTable(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    deleteStagingTable(tableName?: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Etl/stagingtable?";
        if (tableName !== undefined && tableName !== null)
            url_ += "tableName=" + encodeURIComponent("" + tableName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteStagingTable(_response));
        });
    }

    protected processDeleteStagingTable(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    prepare(table?: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Etl/prepare?";
        if (table !== undefined && table !== null)
            url_ += "table=" + encodeURIComponent("" + table) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processPrepare(_response));
        });
    }

    protected processPrepare(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    validate(table?: string | null | undefined, importDefinition?: string | null | undefined, processRunId?: string | undefined, activityRunId?: string | undefined, fileName?: string | null | undefined): Promise<CommandOutput> {
        let url_ = this.baseUrl + "/Etl/validate?";
        if (table !== undefined && table !== null)
            url_ += "table=" + encodeURIComponent("" + table) + "&";
        if (importDefinition !== undefined && importDefinition !== null)
            url_ += "importDefinition=" + encodeURIComponent("" + importDefinition) + "&";
        if (processRunId === null)
            throw new Error("The parameter 'processRunId' cannot be null.");
        else if (processRunId !== undefined)
            url_ += "processRunId=" + encodeURIComponent("" + processRunId) + "&";
        if (activityRunId === null)
            throw new Error("The parameter 'activityRunId' cannot be null.");
        else if (activityRunId !== undefined)
            url_ += "activityRunId=" + encodeURIComponent("" + activityRunId) + "&";
        if (fileName !== undefined && fileName !== null)
            url_ += "fileName=" + encodeURIComponent("" + fileName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processValidate(_response));
        });
    }

    protected processValidate(response: Response): Promise<CommandOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CommandOutput.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CommandOutput>(null as any);
    }

    execute(table?: string | null | undefined, importdef?: string | null | undefined, skipValidation?: boolean | undefined, processRunIdTest?: string | null | undefined, activityRunIdTest?: string | null | undefined, fileName?: string | null | undefined): Promise<CommandOutput> {
        let url_ = this.baseUrl + "/Etl/execute?";
        if (table !== undefined && table !== null)
            url_ += "table=" + encodeURIComponent("" + table) + "&";
        if (importdef !== undefined && importdef !== null)
            url_ += "importdef=" + encodeURIComponent("" + importdef) + "&";
        if (skipValidation === null)
            throw new Error("The parameter 'skipValidation' cannot be null.");
        else if (skipValidation !== undefined)
            url_ += "skipValidation=" + encodeURIComponent("" + skipValidation) + "&";
        if (processRunIdTest !== undefined && processRunIdTest !== null)
            url_ += "processRunIdTest=" + encodeURIComponent("" + processRunIdTest) + "&";
        if (activityRunIdTest !== undefined && activityRunIdTest !== null)
            url_ += "activityRunIdTest=" + encodeURIComponent("" + activityRunIdTest) + "&";
        if (fileName !== undefined && fileName !== null)
            url_ += "fileName=" + encodeURIComponent("" + fileName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExecute(_response));
        });
    }

    protected processExecute(response: Response): Promise<CommandOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CommandOutput.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CommandOutput>(null as any);
    }

    copyModelMapping(origModelMappingId: number, request: ModelMappingInfo): Promise<ModelMappingInfo> {
        let url_ = this.baseUrl + "/Etl/copymodelmapping/{origModelMappingId}";
        if (origModelMappingId === undefined || origModelMappingId === null)
            throw new Error("The parameter 'origModelMappingId' must be defined.");
        url_ = url_.replace("{origModelMappingId}", encodeURIComponent("" + origModelMappingId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCopyModelMapping(_response));
        });
    }

    protected processCopyModelMapping(response: Response): Promise<ModelMappingInfo> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = ModelMappingInfo.fromJS(resultData201);
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ModelMappingInfo>(null as any);
    }

    createModelMapping(request: ModelMappingInfo): Promise<ModelMappingInfo> {
        let url_ = this.baseUrl + "/Etl/modelmapping";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateModelMapping(_response));
        });
    }

    protected processCreateModelMapping(response: Response): Promise<ModelMappingInfo> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = ModelMappingInfo.fromJS(resultData201);
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ModelMappingInfo>(null as any);
    }

    getModelMappings(): Promise<ModelMappingInfo[]> {
        let url_ = this.baseUrl + "/Etl/modelmapping";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetModelMappings(_response));
        });
    }

    protected processGetModelMappings(response: Response): Promise<ModelMappingInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(ModelMappingInfo.fromJS(resultData200[item]));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ModelMappingInfo[]>(null as any);
    }

    updateModelMapping(modelMappingId: number, request: ModelMappingInfo): Promise<ModelMappingInfo> {
        let url_ = this.baseUrl + "/Etl/modelmapping/{modelMappingId}";
        if (modelMappingId === undefined || modelMappingId === null)
            throw new Error("The parameter 'modelMappingId' must be defined.");
        url_ = url_.replace("{modelMappingId}", encodeURIComponent("" + modelMappingId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateModelMapping(_response));
        });
    }

    protected processUpdateModelMapping(response: Response): Promise<ModelMappingInfo> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ModelMappingInfo.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ModelMappingInfo>(null as any);
    }

    deleteModelMapping(modelMappingId: number): Promise<void> {
        let url_ = this.baseUrl + "/Etl/modelmapping/{modelMappingId}";
        if (modelMappingId === undefined || modelMappingId === null)
            throw new Error("The parameter 'modelMappingId' must be defined.");
        url_ = url_.replace("{modelMappingId}", encodeURIComponent("" + modelMappingId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteModelMapping(_response));
        });
    }

    protected processDeleteModelMapping(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getModelMappingData(): Promise<ModelMappingDataInfo> {
        let url_ = this.baseUrl + "/Etl/modelmappingdata";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetModelMappingData(_response));
        });
    }

    protected processGetModelMappingData(response: Response): Promise<ModelMappingDataInfo> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ModelMappingDataInfo.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ModelMappingDataInfo>(null as any);
    }

    getDataSlicers(): Promise<DataSlicerInfo[]> {
        let url_ = this.baseUrl + "/Etl/dataslicers";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDataSlicers(_response));
        });
    }

    protected processGetDataSlicers(response: Response): Promise<DataSlicerInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(DataSlicerInfo.fromJS(resultData200[item]));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DataSlicerInfo[]>(null as any);
    }

    getModelFieldMappings(mappingId: number): Promise<ModelFieldMappingInfo[]> {
        let url_ = this.baseUrl + "/Etl/modelfieldmapping/{mappingId}";
        if (mappingId === undefined || mappingId === null)
            throw new Error("The parameter 'mappingId' must be defined.");
        url_ = url_.replace("{mappingId}", encodeURIComponent("" + mappingId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetModelFieldMappings(_response));
        });
    }

    protected processGetModelFieldMappings(response: Response): Promise<ModelFieldMappingInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(ModelFieldMappingInfo.fromJS(resultData200[item]));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ModelFieldMappingInfo[]>(null as any);
    }

    getFields(): Promise<SimpleKeyValue[]> {
        let url_ = this.baseUrl + "/Etl/dbfields";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetFields(_response));
        });
    }

    protected processGetFields(response: Response): Promise<SimpleKeyValue[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(SimpleKeyValue.fromJS(resultData200[item]));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SimpleKeyValue[]>(null as any);
    }

    saveFieldMappings(list: ModelFieldMappingInfo[]): Promise<ModelFieldMappingInfo[]> {
        let url_ = this.baseUrl + "/Etl/modelfieldsmappings/save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(list);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSaveFieldMappings(_response));
        });
    }

    protected processSaveFieldMappings(response: Response): Promise<ModelFieldMappingInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData201)) {
                result201 = [] as any;
                for (let item in resultData201)
                    result201!.push(ModelFieldMappingInfo.fromJS(resultData201[item]));
            }
            else {
                result201 = <any>null;
            }
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ModelFieldMappingInfo[]>(null as any);
    }

    saveClearData(list: DataSlicerInfo[]): Promise<DefaultMappingInfo[]> {
        let url_ = this.baseUrl + "/Etl/cleardata/save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(list);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSaveClearData(_response));
        });
    }

    protected processSaveClearData(response: Response): Promise<DefaultMappingInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData201)) {
                result201 = [] as any;
                for (let item in resultData201)
                    result201!.push(DefaultMappingInfo.fromJS(resultData201[item]));
            }
            else {
                result201 = <any>null;
            }
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DefaultMappingInfo[]>(null as any);
    }

    saveModelMapRoleWrite(list: RoleWriteObject[], sourceName?: string | null | undefined, parentController?: string | null | undefined): Promise<RoleWriteObject[]> {
        let url_ = this.baseUrl + "/Etl/modelmaprolewrite/save?";
        if (sourceName !== undefined && sourceName !== null)
            url_ += "sourceName=" + encodeURIComponent("" + sourceName) + "&";
        if (parentController !== undefined && parentController !== null)
            url_ += "parentController=" + encodeURIComponent("" + parentController) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(list);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSaveModelMapRoleWrite(_response));
        });
    }

    protected processSaveModelMapRoleWrite(response: Response): Promise<RoleWriteObject[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData201)) {
                result201 = [] as any;
                for (let item in resultData201)
                    result201!.push(RoleWriteObject.fromJS(resultData201[item]));
            }
            else {
                result201 = <any>null;
            }
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RoleWriteObject[]>(null as any);
    }

    getModelMappingRoleWrite(sourceName: string): Promise<RoleWriteObject[]> {
        let url_ = this.baseUrl + "/Etl/modelmappingrolewrite/{sourceName}";
        if (sourceName === undefined || sourceName === null)
            throw new Error("The parameter 'sourceName' must be defined.");
        url_ = url_.replace("{sourceName}", encodeURIComponent("" + sourceName));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetModelMappingRoleWrite(_response));
        });
    }

    protected processGetModelMappingRoleWrite(response: Response): Promise<RoleWriteObject[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(RoleWriteObject.fromJS(resultData200[item]));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RoleWriteObject[]>(null as any);
    }

    getAllModelMappingRoleWrite(sourceName?: string | null | undefined): Promise<RoleWriteObject[]> {
        let url_ = this.baseUrl + "/Etl/allmodelmappingrolewrite?";
        if (sourceName !== undefined && sourceName !== null)
            url_ += "sourceName=" + encodeURIComponent("" + sourceName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAllModelMappingRoleWrite(_response));
        });
    }

    protected processGetAllModelMappingRoleWrite(response: Response): Promise<RoleWriteObject[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(RoleWriteObject.fromJS(resultData200[item]));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RoleWriteObject[]>(null as any);
    }

    getEtlLogHeader(): Promise<EtlLogHeaderInfo[]> {
        let url_ = this.baseUrl + "/Etl/etllogheader";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetEtlLogHeader(_response));
        });
    }

    protected processGetEtlLogHeader(response: Response): Promise<EtlLogHeaderInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(EtlLogHeaderInfo.fromJS(resultData200[item]));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EtlLogHeaderInfo[]>(null as any);
    }

    getEtlLogDetails(take?: number | undefined, skip?: number | undefined, etlLogHeaderid?: number | undefined, recordType?: string | null | undefined): Promise<DrillbackDetailInfo> {
        let url_ = this.baseUrl + "/Etl/etllogdetails?";
        if (take === null)
            throw new Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (etlLogHeaderid === null)
            throw new Error("The parameter 'etlLogHeaderid' cannot be null.");
        else if (etlLogHeaderid !== undefined)
            url_ += "etlLogHeaderid=" + encodeURIComponent("" + etlLogHeaderid) + "&";
        if (recordType !== undefined && recordType !== null)
            url_ += "recordType=" + encodeURIComponent("" + recordType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetEtlLogDetails(_response));
        });
    }

    protected processGetEtlLogDetails(response: Response): Promise<DrillbackDetailInfo> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DrillbackDetailInfo.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DrillbackDetailInfo>(null as any);
    }

    exportDrillBackDetails(etlLogHeaderId?: number | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/Etl/etllogdetails/export?";
        if (etlLogHeaderId === null)
            throw new Error("The parameter 'etlLogHeaderId' cannot be null.");
        else if (etlLogHeaderId !== undefined)
            url_ += "etlLogHeaderId=" + encodeURIComponent("" + etlLogHeaderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExportDrillBackDetails(_response));
        });
    }

    protected processExportDrillBackDetails(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    getEtlLogInfo(etlLogHeaderId?: number | undefined): Promise<EtlLogInfo[]> {
        let url_ = this.baseUrl + "/Etl/etlloginfo?";
        if (etlLogHeaderId === null)
            throw new Error("The parameter 'etlLogHeaderId' cannot be null.");
        else if (etlLogHeaderId !== undefined)
            url_ += "etlLogHeaderId=" + encodeURIComponent("" + etlLogHeaderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetEtlLogInfo(_response));
        });
    }

    protected processGetEtlLogInfo(response: Response): Promise<EtlLogInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(EtlLogInfo.fromJS(resultData200[item]));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EtlLogInfo[]>(null as any);
    }

    exportEtlLogInfo(etlLogHeaderId?: number | undefined, timezoneOffset?: number | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/Etl/etlloginfo/export?";
        if (etlLogHeaderId === null)
            throw new Error("The parameter 'etlLogHeaderId' cannot be null.");
        else if (etlLogHeaderId !== undefined)
            url_ += "etlLogHeaderId=" + encodeURIComponent("" + etlLogHeaderId) + "&";
        if (timezoneOffset === null)
            throw new Error("The parameter 'timezoneOffset' cannot be null.");
        else if (timezoneOffset !== undefined)
            url_ += "timezoneOffset=" + encodeURIComponent("" + timezoneOffset) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExportEtlLogInfo(_response));
        });
    }

    protected processExportEtlLogInfo(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    getDataMaps(): Promise<DataMapInfo[]> {
        let url_ = this.baseUrl + "/Etl/datamap";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDataMaps(_response));
        });
    }

    protected processGetDataMaps(response: Response): Promise<DataMapInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(DataMapInfo.fromJS(resultData200[item]));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DataMapInfo[]>(null as any);
    }

    deleteDataMap(sourceName?: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Etl/datamap?";
        if (sourceName !== undefined && sourceName !== null)
            url_ += "sourceName=" + encodeURIComponent("" + sourceName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteDataMap(_response));
        });
    }

    protected processDeleteDataMap(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    saveDataMap(dataMap: DataMapInfo): Promise<DataMapInfo> {
        let url_ = this.baseUrl + "/Etl/datamap/save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dataMap);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSaveDataMap(_response));
        });
    }

    protected processSaveDataMap(response: Response): Promise<DataMapInfo> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = DataMapInfo.fromJS(resultData201);
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DataMapInfo>(null as any);
    }

    updateDataMap(sourceName: string, request: UpdateDataMapRequest): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/Etl/datamap/{sourceName}";
        if (sourceName === undefined || sourceName === null)
            throw new Error("The parameter 'sourceName' must be defined.");
        url_ = url_.replace("{sourceName}", encodeURIComponent("" + sourceName));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateDataMap(_response));
        });
    }

    protected processUpdateDataMap(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    getDataMapsRoles(): Promise<DataMapInfo[]> {
        let url_ = this.baseUrl + "/Etl/datamaproles";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDataMapsRoles(_response));
        });
    }

    protected processGetDataMapsRoles(response: Response): Promise<DataMapInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(DataMapInfo.fromJS(resultData200[item]));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DataMapInfo[]>(null as any);
    }

    getDataMapRoleWrite(sourceName: string): Promise<RoleWriteObject[]> {
        let url_ = this.baseUrl + "/Etl/datamaprolewrite/{sourceName}";
        if (sourceName === undefined || sourceName === null)
            throw new Error("The parameter 'sourceName' must be defined.");
        url_ = url_.replace("{sourceName}", encodeURIComponent("" + sourceName));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDataMapRoleWrite(_response));
        });
    }

    protected processGetDataMapRoleWrite(response: Response): Promise<RoleWriteObject[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(RoleWriteObject.fromJS(resultData200[item]));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RoleWriteObject[]>(null as any);
    }

    saveDataMapRoleWrite(list: RoleWriteObject[], sourceName?: string | null | undefined, parentController?: string | null | undefined): Promise<RoleWriteObject[]> {
        let url_ = this.baseUrl + "/Etl/datamaprolewrite/save?";
        if (sourceName !== undefined && sourceName !== null)
            url_ += "sourceName=" + encodeURIComponent("" + sourceName) + "&";
        if (parentController !== undefined && parentController !== null)
            url_ += "parentController=" + encodeURIComponent("" + parentController) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(list);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSaveDataMapRoleWrite(_response));
        });
    }

    protected processSaveDataMapRoleWrite(response: Response): Promise<RoleWriteObject[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData201)) {
                result201 = [] as any;
                for (let item in resultData201)
                    result201!.push(RoleWriteObject.fromJS(resultData201[item]));
            }
            else {
                result201 = <any>null;
            }
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RoleWriteObject[]>(null as any);
    }

    getMemberMappings(sourceName: string, translation?: string | null | undefined): Promise<DataMappingInfo[]> {
        let url_ = this.baseUrl + "/Etl/membermapping/{sourceName}?";
        if (sourceName === undefined || sourceName === null)
            throw new Error("The parameter 'sourceName' must be defined.");
        url_ = url_.replace("{sourceName}", encodeURIComponent("" + sourceName));
        if (translation !== undefined && translation !== null)
            url_ += "translation=" + encodeURIComponent("" + translation) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetMemberMappings(_response));
        });
    }

    protected processGetMemberMappings(response: Response): Promise<DataMappingInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(DataMappingInfo.fromJS(resultData200[item]));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DataMappingInfo[]>(null as any);
    }

    saveMemberMappings(input: SaveDataMappingRequest): Promise<DataMappingInfo[]> {
        let url_ = this.baseUrl + "/Etl/membermapping/save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSaveMemberMappings(_response));
        });
    }

    protected processSaveMemberMappings(response: Response): Promise<DataMappingInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData201)) {
                result201 = [] as any;
                for (let item in resultData201)
                    result201!.push(DataMappingInfo.fromJS(resultData201[item]));
            }
            else {
                result201 = <any>null;
            }
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DataMappingInfo[]>(null as any);
    }

    exportWorkflowErrorsAsMemberMappings(sourceName: string, list: DataMappingInfo[]): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/Etl/membermapping/exporterrors/{sourceName}";
        if (sourceName === undefined || sourceName === null)
            throw new Error("The parameter 'sourceName' must be defined.");
        url_ = url_.replace("{sourceName}", encodeURIComponent("" + sourceName));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(list);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExportWorkflowErrorsAsMemberMappings(_response));
        });
    }

    protected processExportWorkflowErrorsAsMemberMappings(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    exportMemberMappings(sourceName: string, format?: string | null | undefined, includeCaptions?: boolean | undefined, translation?: string | null | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/Etl/membermapping/export/{sourceName}?";
        if (sourceName === undefined || sourceName === null)
            throw new Error("The parameter 'sourceName' must be defined.");
        url_ = url_.replace("{sourceName}", encodeURIComponent("" + sourceName));
        if (format !== undefined && format !== null)
            url_ += "format=" + encodeURIComponent("" + format) + "&";
        if (includeCaptions === null)
            throw new Error("The parameter 'includeCaptions' cannot be null.");
        else if (includeCaptions !== undefined)
            url_ += "includeCaptions=" + encodeURIComponent("" + includeCaptions) + "&";
        if (translation !== undefined && translation !== null)
            url_ += "translation=" + encodeURIComponent("" + translation) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExportMemberMappings(_response));
        });
    }

    protected processExportMemberMappings(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    importMemberMappings(sourceName: string, isAppend?: boolean | undefined, file?: FileParameter | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Etl/membermapping/import/{sourceName}?";
        if (sourceName === undefined || sourceName === null)
            throw new Error("The parameter 'sourceName' must be defined.");
        url_ = url_.replace("{sourceName}", encodeURIComponent("" + sourceName));
        if (isAppend === null)
            throw new Error("The parameter 'isAppend' cannot be null.");
        else if (isAppend !== undefined)
            url_ += "isAppend=" + encodeURIComponent("" + isAppend) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("File", file.data, file.fileName ? file.fileName : "File");

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processImportMemberMappings(_response));
        });
    }

    protected processImportMemberMappings(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    importMemberMappingsClient(sourceName: string, isAppend?: boolean | undefined, file?: FileParameter | null | undefined, translation?: string | null | undefined): Promise<DataMappingInfo[]> {
        let url_ = this.baseUrl + "/Etl/membermapping/importclient/{sourceName}?";
        if (sourceName === undefined || sourceName === null)
            throw new Error("The parameter 'sourceName' must be defined.");
        url_ = url_.replace("{sourceName}", encodeURIComponent("" + sourceName));
        if (isAppend === null)
            throw new Error("The parameter 'isAppend' cannot be null.");
        else if (isAppend !== undefined)
            url_ += "isAppend=" + encodeURIComponent("" + isAppend) + "&";
        if (translation !== undefined && translation !== null)
            url_ += "translation=" + encodeURIComponent("" + translation) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("File", file.data, file.fileName ? file.fileName : "File");

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processImportMemberMappingsClient(_response));
        });
    }

    protected processImportMemberMappingsClient(response: Response): Promise<DataMappingInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(DataMappingInfo.fromJS(resultData200[item]));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DataMappingInfo[]>(null as any);
    }

    getMultiDimMappings(sourceName: string, translation?: string | null | undefined): Promise<MultiDimMappingsDto> {
        let url_ = this.baseUrl + "/Etl/multidimmapping/{sourceName}?";
        if (sourceName === undefined || sourceName === null)
            throw new Error("The parameter 'sourceName' must be defined.");
        url_ = url_.replace("{sourceName}", encodeURIComponent("" + sourceName));
        if (translation !== undefined && translation !== null)
            url_ += "translation=" + encodeURIComponent("" + translation) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetMultiDimMappings(_response));
        });
    }

    protected processGetMultiDimMappings(response: Response): Promise<MultiDimMappingsDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MultiDimMappingsDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MultiDimMappingsDto>(null as any);
    }

    editMultiDimMappings(request: EditMultiDimMappingsRequestDto): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/Etl/multidimmapping";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processEditMultiDimMappings(_response));
        });
    }

    protected processEditMultiDimMappings(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    importMultiDimMappingInsertRowsFromFile(sourceName: string, isAppend?: boolean | undefined, file?: FileParameter | null | undefined): Promise<MultiDimRowInsertDto[]> {
        let url_ = this.baseUrl + "/Etl/multidimmapping/importclient/{sourceName}?";
        if (sourceName === undefined || sourceName === null)
            throw new Error("The parameter 'sourceName' must be defined.");
        url_ = url_.replace("{sourceName}", encodeURIComponent("" + sourceName));
        if (isAppend === null)
            throw new Error("The parameter 'isAppend' cannot be null.");
        else if (isAppend !== undefined)
            url_ += "isAppend=" + encodeURIComponent("" + isAppend) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("File", file.data, file.fileName ? file.fileName : "File");

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processImportMultiDimMappingInsertRowsFromFile(_response));
        });
    }

    protected processImportMultiDimMappingInsertRowsFromFile(response: Response): Promise<MultiDimRowInsertDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(MultiDimRowInsertDto.fromJS(resultData200[item]));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MultiDimRowInsertDto[]>(null as any);
    }

    exportMultiDimMappings(sourceName: string, format?: string | null | undefined, includeCaptions?: boolean | undefined, translation?: string | null | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/Etl/multidimmapping/export/{sourceName}?";
        if (sourceName === undefined || sourceName === null)
            throw new Error("The parameter 'sourceName' must be defined.");
        url_ = url_.replace("{sourceName}", encodeURIComponent("" + sourceName));
        if (format !== undefined && format !== null)
            url_ += "format=" + encodeURIComponent("" + format) + "&";
        if (includeCaptions === null)
            throw new Error("The parameter 'includeCaptions' cannot be null.");
        else if (includeCaptions !== undefined)
            url_ += "includeCaptions=" + encodeURIComponent("" + includeCaptions) + "&";
        if (translation !== undefined && translation !== null)
            url_ += "translation=" + encodeURIComponent("" + translation) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExportMultiDimMappings(_response));
        });
    }

    protected processExportMultiDimMappings(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export class ExtensionClient extends FluenceApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    dashboardExtensions(): Promise<DashboardExtension[]> {
        let url_ = this.baseUrl + "/Extension/dashboardextensions";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDashboardExtensions(_response));
        });
    }

    protected processDashboardExtensions(response: Response): Promise<DashboardExtension[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(DashboardExtension.fromJS(resultData200[item]));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DashboardExtension[]>(null as any);
    }

    homeExtensions(): Promise<HomeExtension[]> {
        let url_ = this.baseUrl + "/Extension/homeextensions";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processHomeExtensions(_response));
        });
    }

    protected processHomeExtensions(response: Response): Promise<HomeExtension[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(HomeExtension.fromJS(resultData200[item]));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HomeExtension[]>(null as any);
    }
}

export class FactDataClient extends FluenceApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getIntercompanyGaps(modelName?: string | null | undefined, scenario?: string | null | undefined, time?: string | null | undefined, currency?: string | null | undefined, entity?: string | null | undefined, matchingAccount?: string | null | undefined): Promise<IntercompanyGapResponse[]> {
        let url_ = this.baseUrl + "/FactData/intercompanyGaps?";
        if (modelName !== undefined && modelName !== null)
            url_ += "modelName=" + encodeURIComponent("" + modelName) + "&";
        if (scenario !== undefined && scenario !== null)
            url_ += "scenario=" + encodeURIComponent("" + scenario) + "&";
        if (time !== undefined && time !== null)
            url_ += "time=" + encodeURIComponent("" + time) + "&";
        if (currency !== undefined && currency !== null)
            url_ += "currency=" + encodeURIComponent("" + currency) + "&";
        if (entity !== undefined && entity !== null)
            url_ += "entity=" + encodeURIComponent("" + entity) + "&";
        if (matchingAccount !== undefined && matchingAccount !== null)
            url_ += "matchingAccount=" + encodeURIComponent("" + matchingAccount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetIntercompanyGaps(_response));
        });
    }

    protected processGetIntercompanyGaps(response: Response): Promise<IntercompanyGapResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(IntercompanyGapResponse.fromJS(resultData200[item]));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<IntercompanyGapResponse[]>(null as any);
    }

    getIntercompanyGapsByAccount(modelName?: string | null | undefined, scenario?: string | null | undefined, time?: string | null | undefined, currency?: string | null | undefined, entity?: string | null | undefined, matchingAccount?: string | null | undefined): Promise<IntercompanyGapAccountDetailResponse[]> {
        let url_ = this.baseUrl + "/FactData/intercompanyGapsByAccount?";
        if (modelName !== undefined && modelName !== null)
            url_ += "modelName=" + encodeURIComponent("" + modelName) + "&";
        if (scenario !== undefined && scenario !== null)
            url_ += "scenario=" + encodeURIComponent("" + scenario) + "&";
        if (time !== undefined && time !== null)
            url_ += "time=" + encodeURIComponent("" + time) + "&";
        if (currency !== undefined && currency !== null)
            url_ += "currency=" + encodeURIComponent("" + currency) + "&";
        if (entity !== undefined && entity !== null)
            url_ += "entity=" + encodeURIComponent("" + entity) + "&";
        if (matchingAccount !== undefined && matchingAccount !== null)
            url_ += "matchingAccount=" + encodeURIComponent("" + matchingAccount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetIntercompanyGapsByAccount(_response));
        });
    }

    protected processGetIntercompanyGapsByAccount(response: Response): Promise<IntercompanyGapAccountDetailResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(IntercompanyGapAccountDetailResponse.fromJS(resultData200[item]));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<IntercompanyGapAccountDetailResponse[]>(null as any);
    }
}

export class FeatureFlagClient extends FluenceApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getFeatureFlag(featureName: string): Promise<boolean> {
        let url_ = this.baseUrl + "/FeatureFlag/{featureName}";
        if (featureName === undefined || featureName === null)
            throw new Error("The parameter 'featureName' must be defined.");
        url_ = url_.replace("{featureName}", encodeURIComponent("" + featureName));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetFeatureFlag(_response));
        });
    }

    protected processGetFeatureFlag(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export class FileSystemClient extends FluenceApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getFileOld(path: string, content?: string | null | undefined, descendants?: boolean | undefined): Promise<FileSystemObjectContent> {
        let url_ = this.baseUrl + "/FileSystem/{path}?";
        if (path === undefined || path === null)
            throw new Error("The parameter 'path' must be defined.");
        url_ = url_.replace("{path}", encodeURIComponent("" + path));
        if (content !== undefined && content !== null)
            url_ += "content=" + encodeURIComponent("" + content) + "&";
        if (descendants === null)
            throw new Error("The parameter 'descendants' cannot be null.");
        else if (descendants !== undefined)
            url_ += "descendants=" + encodeURIComponent("" + descendants) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetFileOld(_response));
        });
    }

    protected processGetFileOld(response: Response): Promise<FileSystemObjectContent> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileSystemObjectContent.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileSystemObjectContent>(null as any);
    }

    delete(path: string): Promise<FileSystemChangeNotification> {
        let url_ = this.baseUrl + "/FileSystem/{path}";
        if (path === undefined || path === null)
            throw new Error("The parameter 'path' must be defined.");
        url_ = url_.replace("{path}", encodeURIComponent("" + path));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDelete(_response));
        });
    }

    protected processDelete(response: Response): Promise<FileSystemChangeNotification> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileSystemChangeNotification.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileSystemChangeNotification>(null as any);
    }

    post(path: string, request: FileSystemObjectBase, createPath?: boolean | undefined): Promise<FileSystemChangeNotification> {
        let url_ = this.baseUrl + "/FileSystem/{path}?";
        if (path === undefined || path === null)
            throw new Error("The parameter 'path' must be defined.");
        url_ = url_.replace("{path}", encodeURIComponent("" + path));
        if (createPath === null)
            throw new Error("The parameter 'createPath' cannot be null.");
        else if (createPath !== undefined)
            url_ += "createPath=" + encodeURIComponent("" + createPath) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processPost(_response));
        });
    }

    protected processPost(response: Response): Promise<FileSystemChangeNotification> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = FileSystemChangeNotification.fromJS(resultData201);
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileSystemChangeNotification>(null as any);
    }

    getFile(path: string, content?: string | null | undefined, descendants?: boolean | undefined, tenant?: string | null | undefined, refreshCache?: boolean | undefined): Promise<FileSystemObjectContent> {
        let url_ = this.baseUrl + "/FileSystem/Specific/{path}?";
        if (path === undefined || path === null)
            throw new Error("The parameter 'path' must be defined.");
        url_ = url_.replace("{path}", encodeURIComponent("" + path));
        if (content !== undefined && content !== null)
            url_ += "content=" + encodeURIComponent("" + content) + "&";
        if (descendants === null)
            throw new Error("The parameter 'descendants' cannot be null.");
        else if (descendants !== undefined)
            url_ += "descendants=" + encodeURIComponent("" + descendants) + "&";
        if (tenant !== undefined && tenant !== null)
            url_ += "tenant=" + encodeURIComponent("" + tenant) + "&";
        if (refreshCache === null)
            throw new Error("The parameter 'refreshCache' cannot be null.");
        else if (refreshCache !== undefined)
            url_ += "refreshCache=" + encodeURIComponent("" + refreshCache) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetFile(_response));
        });
    }

    protected processGetFile(response: Response): Promise<FileSystemObjectContent> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileSystemObjectContent.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileSystemObjectContent>(null as any);
    }

    update(path: string, newContent: FileSystemObjectBase): Promise<FileSystemChangeNotification> {
        let url_ = this.baseUrl + "/FileSystem/Content/{path}";
        if (path === undefined || path === null)
            throw new Error("The parameter 'path' must be defined.");
        url_ = url_.replace("{path}", encodeURIComponent("" + path));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(newContent);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdate(_response));
        });
    }

    protected processUpdate(response: Response): Promise<FileSystemChangeNotification> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileSystemChangeNotification.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileSystemChangeNotification>(null as any);
    }

    move(path: string, moveTo: string): Promise<FileSystemChangeNotification[]> {
        let url_ = this.baseUrl + "/FileSystem/Move/{path}";
        if (path === undefined || path === null)
            throw new Error("The parameter 'path' must be defined.");
        url_ = url_.replace("{path}", encodeURIComponent("" + path));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(moveTo);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processMove(_response));
        });
    }

    protected processMove(response: Response): Promise<FileSystemChangeNotification[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(FileSystemChangeNotification.fromJS(resultData200[item]));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileSystemChangeNotification[]>(null as any);
    }

    copy(path: string, copyTo: string): Promise<FileSystemChangeNotification> {
        let url_ = this.baseUrl + "/FileSystem/Copy/{path}";
        if (path === undefined || path === null)
            throw new Error("The parameter 'path' must be defined.");
        url_ = url_.replace("{path}", encodeURIComponent("" + path));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(copyTo);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCopy(_response));
        });
    }

    protected processCopy(response: Response): Promise<FileSystemChangeNotification> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileSystemChangeNotification.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileSystemChangeNotification>(null as any);
    }

    setupNotifications(): Promise<void> {
        let url_ = this.baseUrl + "/FileSystem/SetupNotifications";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSetupNotifications(_response));
        });
    }

    protected processSetupNotifications(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getRelativeObject(fileId: number, relativePath?: string | null | undefined): Promise<FileSystemObject> {
        let url_ = this.baseUrl + "/FileSystem/relative/{fileId}?";
        if (fileId === undefined || fileId === null)
            throw new Error("The parameter 'fileId' must be defined.");
        url_ = url_.replace("{fileId}", encodeURIComponent("" + fileId));
        if (relativePath !== undefined && relativePath !== null)
            url_ += "relativePath=" + encodeURIComponent("" + relativePath) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetRelativeObject(_response));
        });
    }

    protected processGetRelativeObject(response: Response): Promise<FileSystemObject> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileSystemObject.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileSystemObject>(null as any);
    }

    export(path: string): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/FileSystem/Export/{path}";
        if (path === undefined || path === null)
            throw new Error("The parameter 'path' must be defined.");
        url_ = url_.replace("{path}", encodeURIComponent("" + path));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExport(_response));
        });
    }

    protected processExport(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    import(path: string, file?: FileParameter | null | undefined): Promise<FileSystemChangeNotification[]> {
        let url_ = this.baseUrl + "/FileSystem/Import/{path}";
        if (path === undefined || path === null)
            throw new Error("The parameter 'path' must be defined.");
        url_ = url_.replace("{path}", encodeURIComponent("" + path));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("File", file.data, file.fileName ? file.fileName : "File");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processImport(_response));
        });
    }

    protected processImport(response: Response): Promise<FileSystemChangeNotification[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(FileSystemChangeNotification.fromJS(resultData200[item]));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileSystemChangeNotification[]>(null as any);
    }

    openGenericFile(pathOrId: string): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/FileSystem/Generic/{pathOrId}";
        if (pathOrId === undefined || pathOrId === null)
            throw new Error("The parameter 'pathOrId' must be defined.");
        url_ = url_.replace("{pathOrId}", encodeURIComponent("" + pathOrId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processOpenGenericFile(_response));
        });
    }

    protected processOpenGenericFile(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    getMyFavorites(): Promise<string[]> {
        let url_ = this.baseUrl + "/FileSystem/MyFavorites";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetMyFavorites(_response));
        });
    }

    protected processGetMyFavorites(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(resultData200[item]);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }

    setMyFavorites(path: string, isFavorite?: boolean | undefined): Promise<void> {
        let url_ = this.baseUrl + "/FileSystem/MyFavorites/{path}?";
        if (path === undefined || path === null)
            throw new Error("The parameter 'path' must be defined.");
        url_ = url_.replace("{path}", encodeURIComponent("" + path));
        if (isFavorite === null)
            throw new Error("The parameter 'isFavorite' cannot be null.");
        else if (isFavorite !== undefined)
            url_ += "isFavorite=" + encodeURIComponent("" + isFavorite) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSetMyFavorites(_response));
        });
    }

    protected processSetMyFavorites(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getDefaulttXl3Server(): Promise<string> {
        let url_ = this.baseUrl + "/FileSystem/DefaultXl3Server";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDefaulttXl3Server(_response));
        });
    }

    protected processGetDefaulttXl3Server(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    getXL3DefaultAjaxCallbackUriTemplate(): Promise<string> {
        let url_ = this.baseUrl + "/FileSystem/XL3DefaultAjaxCallbackUriTemplate";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetXL3DefaultAjaxCallbackUriTemplate(_response));
        });
    }

    protected processGetXL3DefaultAjaxCallbackUriTemplate(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    getDefaulttStandaloneXl3Server(): Promise<string> {
        let url_ = this.baseUrl + "/FileSystem/DefaultStandaloneXl3Server";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDefaulttStandaloneXl3Server(_response));
        });
    }

    protected processGetDefaulttStandaloneXl3Server(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    renderXL3Report(path: string, format?: ArchiveXL3ReportFormat | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/FileSystem/RenderXL3Report/{path}?";
        if (path === undefined || path === null)
            throw new Error("The parameter 'path' must be defined.");
        url_ = url_.replace("{path}", encodeURIComponent("" + path));
        if (format === null)
            throw new Error("The parameter 'format' cannot be null.");
        else if (format !== undefined)
            url_ += "format=" + encodeURIComponent("" + format) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRenderXL3Report(_response));
        });
    }

    protected processRenderXL3Report(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export class FirewallClient extends FluenceApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Sets the firewall rule.
     * @param ipstr (optional) 
     * @return Details about the actions performed.
     */
    setFirewallRule(ipstr?: string | null | undefined): Promise<string> {
        let url_ = this.baseUrl + "/Firewall?";
        if (ipstr !== undefined && ipstr !== null)
            url_ += "ipstr=" + encodeURIComponent("" + ipstr) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSetFirewallRule(_response));
        });
    }

    protected processSetFirewallRule(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }
}

export class FluenceXLClient extends FluenceApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getParameters(pathOrId: string): Promise<FormParameterList> {
        let url_ = this.baseUrl + "/FluenceXL/parameters/{pathOrId}";
        if (pathOrId === undefined || pathOrId === null)
            throw new Error("The parameter 'pathOrId' must be defined.");
        url_ = url_.replace("{pathOrId}", encodeURIComponent("" + pathOrId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetParameters(_response));
        });
    }

    protected processGetParameters(response: Response): Promise<FormParameterList> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FormParameterList.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FormParameterList>(null as any);
    }
}

export class FormClient extends FluenceApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getFormParameters(pathOrId: string): Promise<FormParameterList> {
        let url_ = this.baseUrl + "/Form/parameters/{pathOrId}";
        if (pathOrId === undefined || pathOrId === null)
            throw new Error("The parameter 'pathOrId' must be defined.");
        url_ = url_.replace("{pathOrId}", encodeURIComponent("" + pathOrId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetFormParameters(_response));
        });
    }

    protected processGetFormParameters(response: Response): Promise<FormParameterList> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FormParameterList.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FormParameterList>(null as any);
    }

    openForm(pathOrId: string, parameters: FormParameterCurrentValue[]): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/Form/parameters/{pathOrId}";
        if (pathOrId === undefined || pathOrId === null)
            throw new Error("The parameter 'pathOrId' must be defined.");
        url_ = url_.replace("{pathOrId}", encodeURIComponent("" + pathOrId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(parameters);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processOpenForm(_response));
        });
    }

    protected processOpenForm(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    refreshParameterValues(formId: number, parameterName: string, currentValues: FormParameterCurrentValue[]): Promise<FormParameter[]> {
        let url_ = this.baseUrl + "/Form/parameters/{formId}/{parameterName}";
        if (formId === undefined || formId === null)
            throw new Error("The parameter 'formId' must be defined.");
        url_ = url_.replace("{formId}", encodeURIComponent("" + formId));
        if (parameterName === undefined || parameterName === null)
            throw new Error("The parameter 'parameterName' must be defined.");
        url_ = url_.replace("{parameterName}", encodeURIComponent("" + parameterName));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(currentValues);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRefreshParameterValues(_response));
        });
    }

    protected processRefreshParameterValues(response: Response): Promise<FormParameter[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(FormParameter.fromJS(resultData200[item]));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FormParameter[]>(null as any);
    }

    /**
     * Opens a generic form, not from the file system, given an arbitrary xml and xlsx template. This is intended to preview forms from the form builder.
     * @param template (optional) 
     * @param build (optional) 
     */
    openFormPreview(template?: FileParameter | null | undefined, build?: string | null | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/Form/form";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (template !== null && template !== undefined)
            content_.append("Template", template.data, template.fileName ? template.fileName : "Template");
        if (build !== null && build !== undefined)
            content_.append("Build", build.toString());

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processOpenFormPreview(_response));
        });
    }

    protected processOpenFormPreview(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    openFormPreviewParameters(form_Template?: FileParameter | null | undefined, form_Build?: string | null | undefined, parameterList?: string | null | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/Form/previewformparameter";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (form_Template !== null && form_Template !== undefined)
            content_.append("Form.Template", form_Template.data, form_Template.fileName ? form_Template.fileName : "Form.Template");
        if (form_Build !== null && form_Build !== undefined)
            content_.append("Form.Build", form_Build.toString());
        if (parameterList !== null && parameterList !== undefined)
            content_.append("ParameterList", parameterList.toString());

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processOpenFormPreviewParameters(_response));
        });
    }

    protected processOpenFormPreviewParameters(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    getFormPreviewParameters(template?: FileParameter | null | undefined, build?: string | null | undefined): Promise<FormParameterList> {
        let url_ = this.baseUrl + "/Form/parameters";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (template !== null && template !== undefined)
            content_.append("Template", template.data, template.fileName ? template.fileName : "Template");
        if (build !== null && build !== undefined)
            content_.append("Build", build.toString());

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetFormPreviewParameters(_response));
        });
    }

    protected processGetFormPreviewParameters(response: Response): Promise<FormParameterList> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FormParameterList.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FormParameterList>(null as any);
    }

    /**
     * Opens a form from the file system, without parameters
     * @param pathOrId /form/parameters/form_id
     */
    openFormNoParams(pathOrId: string): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/Form/form/{pathOrId}";
        if (pathOrId === undefined || pathOrId === null)
            throw new Error("The parameter 'pathOrId' must be defined.");
        url_ = url_.replace("{pathOrId}", encodeURIComponent("" + pathOrId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processOpenFormNoParams(_response));
        });
    }

    protected processOpenFormNoParams(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    createNewForm(pathOrId: string, template?: FileParameter | null | undefined, build?: string | null | undefined): Promise<HttpStatusCodeException> {
        let url_ = this.baseUrl + "/Form/form/publish/{pathOrId}";
        if (pathOrId === undefined || pathOrId === null)
            throw new Error("The parameter 'pathOrId' must be defined.");
        url_ = url_.replace("{pathOrId}", encodeURIComponent("" + pathOrId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (template !== null && template !== undefined)
            content_.append("Template", template.data, template.fileName ? template.fileName : "Template");
        if (build !== null && build !== undefined)
            content_.append("Build", build.toString());

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateNewForm(_response));
        });
    }

    protected processCreateNewForm(response: Response): Promise<HttpStatusCodeException> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HttpStatusCodeException.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HttpStatusCodeException>(null as any);
    }

    /**
     * Generates a Control Tab file for opening the form at the specified path (or file system id)
    If a processRunId and an activityRunId are provided, then parameters are retrieved through the InteractiveProcessRunner
     * @param pathOrId file system path or id of the form
     * @param processRunId (optional) the run ID of the the interactive process containing the form
     * @param activityRunId (optional) the run ID of the the interactive process containing the form
     */
    generateOpenControlTab(pathOrId: string, processRunId?: string | null | undefined, activityRunId?: string | null | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/Form/control/open/{pathOrId}?";
        if (pathOrId === undefined || pathOrId === null)
            throw new Error("The parameter 'pathOrId' must be defined.");
        url_ = url_.replace("{pathOrId}", encodeURIComponent("" + pathOrId));
        if (processRunId !== undefined && processRunId !== null)
            url_ += "processRunId=" + encodeURIComponent("" + processRunId) + "&";
        if (activityRunId !== undefined && activityRunId !== null)
            url_ += "activityRunId=" + encodeURIComponent("" + activityRunId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGenerateOpenControlTab(_response));
        });
    }

    protected processGenerateOpenControlTab(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    /**
     * Generates a Control Tab file for editing the form at the specified path (or file system id)
     * @param pathOrId file system path or id of the form
     */
    generateEditControlTab(pathOrId: string): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/Form/control/edit/{pathOrId}";
        if (pathOrId === undefined || pathOrId === null)
            throw new Error("The parameter 'pathOrId' must be defined.");
        url_ = url_.replace("{pathOrId}", encodeURIComponent("" + pathOrId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGenerateEditControlTab(_response));
        });
    }

    protected processGenerateEditControlTab(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    saveFormData(formData: string): Promise<void> {
        let url_ = this.baseUrl + "/Form/data";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(formData);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSaveFormData(_response));
        });
    }

    protected processSaveFormData(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    updateFormDefinition(pathOrId: string, template?: FileParameter | null | undefined, build?: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Form/definition/{pathOrId}";
        if (pathOrId === undefined || pathOrId === null)
            throw new Error("The parameter 'pathOrId' must be defined.");
        url_ = url_.replace("{pathOrId}", encodeURIComponent("" + pathOrId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (template !== null && template !== undefined)
            content_.append("Template", template.data, template.fileName ? template.fileName : "Template");
        if (build !== null && build !== undefined)
            content_.append("Build", build.toString());

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateFormDefinition(_response));
        });
    }

    protected processUpdateFormDefinition(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    runRelationalQuery(formId: number, queryName: string, variables: string[]): Promise<QueryResult[]> {
        let url_ = this.baseUrl + "/Form/relationalquery/{formId}/{queryName}";
        if (formId === undefined || formId === null)
            throw new Error("The parameter 'formId' must be defined.");
        url_ = url_.replace("{formId}", encodeURIComponent("" + formId));
        if (queryName === undefined || queryName === null)
            throw new Error("The parameter 'queryName' must be defined.");
        url_ = url_.replace("{queryName}", encodeURIComponent("" + queryName));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(variables);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRunRelationalQuery(_response));
        });
    }

    protected processRunRelationalQuery(response: Response): Promise<QueryResult[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(QueryResult.fromJS(resultData200[item]));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryResult[]>(null as any);
    }

    runDimensionQuery(formId: number, queryName: string, variables: string[], fulltreeview?: boolean | undefined, rootelementkey?: string | null | undefined, rootelementname?: string | null | undefined): Promise<QueryResult[]> {
        let url_ = this.baseUrl + "/Form/dimensionquery/{formId}/{queryName}?";
        if (formId === undefined || formId === null)
            throw new Error("The parameter 'formId' must be defined.");
        url_ = url_.replace("{formId}", encodeURIComponent("" + formId));
        if (queryName === undefined || queryName === null)
            throw new Error("The parameter 'queryName' must be defined.");
        url_ = url_.replace("{queryName}", encodeURIComponent("" + queryName));
        if (fulltreeview === null)
            throw new Error("The parameter 'fulltreeview' cannot be null.");
        else if (fulltreeview !== undefined)
            url_ += "fulltreeview=" + encodeURIComponent("" + fulltreeview) + "&";
        if (rootelementkey !== undefined && rootelementkey !== null)
            url_ += "rootelementkey=" + encodeURIComponent("" + rootelementkey) + "&";
        if (rootelementname !== undefined && rootelementname !== null)
            url_ += "rootelementname=" + encodeURIComponent("" + rootelementname) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(variables);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRunDimensionQuery(_response));
        });
    }

    protected processRunDimensionQuery(response: Response): Promise<QueryResult[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(QueryResult.fromJS(resultData200[item]));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryResult[]>(null as any);
    }

    runDrillDownQuery(formId: number, queryName: string, drillDownRequest: DrillDownRequest): Promise<DrillDownResult> {
        let url_ = this.baseUrl + "/Form/drilldownquery/{formId}/{queryName}";
        if (formId === undefined || formId === null)
            throw new Error("The parameter 'formId' must be defined.");
        url_ = url_.replace("{formId}", encodeURIComponent("" + formId));
        if (queryName === undefined || queryName === null)
            throw new Error("The parameter 'queryName' must be defined.");
        url_ = url_.replace("{queryName}", encodeURIComponent("" + queryName));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(drillDownRequest);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRunDrillDownQuery(_response));
        });
    }

    protected processRunDrillDownQuery(response: Response): Promise<DrillDownResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DrillDownResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DrillDownResult>(null as any);
    }

    getFormAuditEntries(formId: number): Promise<AuditEntryId[]> {
        let url_ = this.baseUrl + "/Form/audit/{formId}";
        if (formId === undefined || formId === null)
            throw new Error("The parameter 'formId' must be defined.");
        url_ = url_.replace("{formId}", encodeURIComponent("" + formId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetFormAuditEntries(_response));
        });
    }

    protected processGetFormAuditEntries(response: Response): Promise<AuditEntryId[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(AuditEntryId.fromJS(resultData200[item]));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AuditEntryId[]>(null as any);
    }

    getFormAuditHighlight(formId: number, auditEntryId: string): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/Form/audit/{formId}/{auditEntryId}";
        if (formId === undefined || formId === null)
            throw new Error("The parameter 'formId' must be defined.");
        url_ = url_.replace("{formId}", encodeURIComponent("" + formId));
        if (auditEntryId === undefined || auditEntryId === null)
            throw new Error("The parameter 'auditEntryId' must be defined.");
        url_ = url_.replace("{auditEntryId}", encodeURIComponent("" + auditEntryId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetFormAuditHighlight(_response));
        });
    }

    protected processGetFormAuditHighlight(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    getCellAuditEntries(formId: number, queryName: string, keys: { [key: string]: number; }): Promise<ModelAuditEntry[]> {
        let url_ = this.baseUrl + "/Form/cellaudit/{formId}/{queryName}";
        if (formId === undefined || formId === null)
            throw new Error("The parameter 'formId' must be defined.");
        url_ = url_.replace("{formId}", encodeURIComponent("" + formId));
        if (queryName === undefined || queryName === null)
            throw new Error("The parameter 'queryName' must be defined.");
        url_ = url_.replace("{queryName}", encodeURIComponent("" + queryName));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(keys);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetCellAuditEntries(_response));
        });
    }

    protected processGetCellAuditEntries(response: Response): Promise<ModelAuditEntry[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(ModelAuditEntry.fromJS(resultData200[item]));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ModelAuditEntry[]>(null as any);
    }

    getAttachment(formId: number, buildElement: string, keyValues: { [key: string]: any; }): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/Form/attachment/{formId}/{buildElement}";
        if (formId === undefined || formId === null)
            throw new Error("The parameter 'formId' must be defined.");
        url_ = url_.replace("{formId}", encodeURIComponent("" + formId));
        if (buildElement === undefined || buildElement === null)
            throw new Error("The parameter 'buildElement' must be defined.");
        url_ = url_.replace("{buildElement}", encodeURIComponent("" + buildElement));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(keyValues);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAttachment(_response));
        });
    }

    protected processGetAttachment(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    removeAttachment(formId: number, buildElement: string, keyValues: { [key: string]: any; }): Promise<void> {
        let url_ = this.baseUrl + "/Form/attachment/{formId}/{buildElement}";
        if (formId === undefined || formId === null)
            throw new Error("The parameter 'formId' must be defined.");
        url_ = url_.replace("{formId}", encodeURIComponent("" + formId));
        if (buildElement === undefined || buildElement === null)
            throw new Error("The parameter 'buildElement' must be defined.");
        url_ = url_.replace("{buildElement}", encodeURIComponent("" + buildElement));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(keyValues);

        let options_: RequestInit = {
            body: content_,
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRemoveAttachment(_response));
        });
    }

    protected processRemoveAttachment(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    uploadAttachment(formId: number, attachmentName: string, attachmentData: string): Promise<number> {
        let url_ = this.baseUrl + "/Form/attachment/{formId}/{attachmentName}";
        if (formId === undefined || formId === null)
            throw new Error("The parameter 'formId' must be defined.");
        url_ = url_.replace("{formId}", encodeURIComponent("" + formId));
        if (attachmentName === undefined || attachmentName === null)
            throw new Error("The parameter 'attachmentName' must be defined.");
        url_ = url_.replace("{attachmentName}", encodeURIComponent("" + attachmentName));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(attachmentData);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUploadAttachment(_response));
        });
    }

    protected processUploadAttachment(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    updateFormAttachment(formId: number, buildElement: string, attachmentId: number, keyValues: { [key: string]: any; }): Promise<void> {
        let url_ = this.baseUrl + "/Form/attachment/{formId}/{buildElement}/{attachmentId}";
        if (formId === undefined || formId === null)
            throw new Error("The parameter 'formId' must be defined.");
        url_ = url_.replace("{formId}", encodeURIComponent("" + formId));
        if (buildElement === undefined || buildElement === null)
            throw new Error("The parameter 'buildElement' must be defined.");
        url_ = url_.replace("{buildElement}", encodeURIComponent("" + buildElement));
        if (attachmentId === undefined || attachmentId === null)
            throw new Error("The parameter 'attachmentId' must be defined.");
        url_ = url_.replace("{attachmentId}", encodeURIComponent("" + attachmentId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(keyValues);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateFormAttachment(_response));
        });
    }

    protected processUpdateFormAttachment(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    runLIDQuery(formId: number, queryName: string, request: LIDRequest): Promise<LIDResult> {
        let url_ = this.baseUrl + "/Form/lidquery/{formId}/{queryName}";
        if (formId === undefined || formId === null)
            throw new Error("The parameter 'formId' must be defined.");
        url_ = url_.replace("{formId}", encodeURIComponent("" + formId));
        if (queryName === undefined || queryName === null)
            throw new Error("The parameter 'queryName' must be defined.");
        url_ = url_.replace("{queryName}", encodeURIComponent("" + queryName));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRunLIDQuery(_response));
        });
    }

    protected processRunLIDQuery(response: Response): Promise<LIDResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LIDResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LIDResult>(null as any);
    }

    runCommmand(formId: number, commandName: string, variables: string[]): Promise<CommandOutput> {
        let url_ = this.baseUrl + "/Form/command/{formId}/{commandName}";
        if (formId === undefined || formId === null)
            throw new Error("The parameter 'formId' must be defined.");
        url_ = url_.replace("{formId}", encodeURIComponent("" + formId));
        if (commandName === undefined || commandName === null)
            throw new Error("The parameter 'commandName' must be defined.");
        url_ = url_.replace("{commandName}", encodeURIComponent("" + commandName));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(variables);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRunCommmand(_response));
        });
    }

    protected processRunCommmand(response: Response): Promise<CommandOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CommandOutput.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CommandOutput>(null as any);
    }

    runModelQuery(queryLimit: number, query: string): Promise<ModelQueryResult> {
        let url_ = this.baseUrl + "/Form/modelquery/{queryLimit}";
        if (queryLimit === undefined || queryLimit === null)
            throw new Error("The parameter 'queryLimit' must be defined.");
        url_ = url_.replace("{queryLimit}", encodeURIComponent("" + queryLimit));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRunModelQuery(_response));
        });
    }

    protected processRunModelQuery(response: Response): Promise<ModelQueryResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ModelQueryResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ModelQueryResult>(null as any);
    }
}

export class JournalClient extends FluenceApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getJournals(replaceGlobals?: boolean | undefined, strongRead?: boolean | undefined): Promise<JournalDefinition[]> {
        let url_ = this.baseUrl + "/Journal?";
        if (replaceGlobals === null)
            throw new Error("The parameter 'replaceGlobals' cannot be null.");
        else if (replaceGlobals !== undefined)
            url_ += "replaceGlobals=" + encodeURIComponent("" + replaceGlobals) + "&";
        if (strongRead === null)
            throw new Error("The parameter 'strongRead' cannot be null.");
        else if (strongRead !== undefined)
            url_ += "strongRead=" + encodeURIComponent("" + strongRead) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetJournals(_response));
        });
    }

    protected processGetJournals(response: Response): Promise<JournalDefinition[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(JournalDefinition.fromJS(resultData200[item]));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<JournalDefinition[]>(null as any);
    }

    getJournalAuditLogs(query: { [key: string]: any; }, journalName?: string | null | undefined, dimensionsSet?: boolean | undefined): Promise<JournalAuditLogInfo[]> {
        let url_ = this.baseUrl + "/Journal?";
        if (journalName !== undefined && journalName !== null)
            url_ += "journalName=" + encodeURIComponent("" + journalName) + "&";
        if (dimensionsSet === null)
            throw new Error("The parameter 'dimensionsSet' cannot be null.");
        else if (dimensionsSet !== undefined)
            url_ += "dimensionsSet=" + encodeURIComponent("" + dimensionsSet) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetJournalAuditLogs(_response));
        });
    }

    protected processGetJournalAuditLogs(response: Response): Promise<JournalAuditLogInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(JournalAuditLogInfo.fromJS(resultData200[item]));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<JournalAuditLogInfo[]>(null as any);
    }

    getJournalsV2(replaceGlobals?: boolean | undefined, strongRead?: boolean | undefined): Promise<JournalDefinition[]> {
        let url_ = this.baseUrl + "/Journal/GetJournalsV2?";
        if (replaceGlobals === null)
            throw new Error("The parameter 'replaceGlobals' cannot be null.");
        else if (replaceGlobals !== undefined)
            url_ += "replaceGlobals=" + encodeURIComponent("" + replaceGlobals) + "&";
        if (strongRead === null)
            throw new Error("The parameter 'strongRead' cannot be null.");
        else if (strongRead !== undefined)
            url_ += "strongRead=" + encodeURIComponent("" + strongRead) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetJournalsV2(_response));
        });
    }

    protected processGetJournalsV2(response: Response): Promise<JournalDefinition[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(JournalDefinition.fromJS(resultData200[item]));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<JournalDefinition[]>(null as any);
    }

    newJournal(journalName?: string | null | undefined, modelName?: string | null | undefined): Promise<JournalDefinition> {
        let url_ = this.baseUrl + "/Journal/NewJournal?";
        if (journalName !== undefined && journalName !== null)
            url_ += "journalName=" + encodeURIComponent("" + journalName) + "&";
        if (modelName !== undefined && modelName !== null)
            url_ += "modelName=" + encodeURIComponent("" + modelName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processNewJournal(_response));
        });
    }

    protected processNewJournal(response: Response): Promise<JournalDefinition> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = JournalDefinition.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<JournalDefinition>(null as any);
    }

    deleteJournal(journalName?: string | null | undefined, testifPossibleOny?: boolean | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/Journal/DeleteJournal?";
        if (journalName !== undefined && journalName !== null)
            url_ += "journalName=" + encodeURIComponent("" + journalName) + "&";
        if (testifPossibleOny === null)
            throw new Error("The parameter 'testifPossibleOny' cannot be null.");
        else if (testifPossibleOny !== undefined)
            url_ += "testifPossibleOny=" + encodeURIComponent("" + testifPossibleOny) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteJournal(_response));
        });
    }

    protected processDeleteJournal(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    deleteJournalV2(journalName?: string | null | undefined, testifPossibleOny?: boolean | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/Journal/DeleteJournal-v2?";
        if (journalName !== undefined && journalName !== null)
            url_ += "journalName=" + encodeURIComponent("" + journalName) + "&";
        if (testifPossibleOny === null)
            throw new Error("The parameter 'testifPossibleOny' cannot be null.");
        else if (testifPossibleOny !== undefined)
            url_ += "testifPossibleOny=" + encodeURIComponent("" + testifPossibleOny) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteJournalV2(_response));
        });
    }

    protected processDeleteJournalV2(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    fixJournal(journalID?: number | undefined, dims?: string[] | null | undefined, isheader?: boolean[] | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Journal/FixJournal?";
        if (journalID === null)
            throw new Error("The parameter 'journalID' cannot be null.");
        else if (journalID !== undefined)
            url_ += "journalID=" + encodeURIComponent("" + journalID) + "&";
        if (dims !== undefined && dims !== null)
            dims && dims.forEach(item => { url_ += "dims=" + encodeURIComponent("" + item) + "&"; });
        if (isheader !== undefined && isheader !== null)
            isheader && isheader.forEach(item => { url_ += "isheader=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processFixJournal(_response));
        });
    }

    protected processFixJournal(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    fixJournalV2(journalID?: number | undefined, dims?: string[] | null | undefined, isheader?: boolean[] | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Journal/FixJournalV2?";
        if (journalID === null)
            throw new Error("The parameter 'journalID' cannot be null.");
        else if (journalID !== undefined)
            url_ += "journalID=" + encodeURIComponent("" + journalID) + "&";
        if (dims !== undefined && dims !== null)
            dims && dims.forEach(item => { url_ += "dims=" + encodeURIComponent("" + item) + "&"; });
        if (isheader !== undefined && isheader !== null)
            isheader && isheader.forEach(item => { url_ += "isheader=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processFixJournalV2(_response));
        });
    }

    protected processFixJournalV2(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    editJournalDefinition(journal: JournalDefinition, recreateTables?: boolean | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Journal/EditJournalDefinition?";
        if (recreateTables === null)
            throw new Error("The parameter 'recreateTables' cannot be null.");
        else if (recreateTables !== undefined)
            url_ += "recreateTables=" + encodeURIComponent("" + recreateTables) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(journal);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processEditJournalDefinition(_response));
        });
    }

    protected processEditJournalDefinition(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    searchHeaders(filters: JournalFilter[], journal?: string | null | undefined, status?: JournalHeaderStatus | null | undefined, name?: string | null | undefined, description?: string | null | undefined, id?: string | null | undefined): Promise<JournalHeaderSecure[]> {
        let url_ = this.baseUrl + "/Journal/headers?";
        if (journal !== undefined && journal !== null)
            url_ += "journal=" + encodeURIComponent("" + journal) + "&";
        if (status !== undefined && status !== null)
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        if (name !== undefined && name !== null)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        if (description !== undefined && description !== null)
            url_ += "description=" + encodeURIComponent("" + description) + "&";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filters);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSearchHeaders(_response));
        });
    }

    protected processSearchHeaders(response: Response): Promise<JournalHeaderSecure[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(JournalHeaderSecure.fromJS(resultData200[item]));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<JournalHeaderSecure[]>(null as any);
    }

    searchHeadersV2(filters: JournalFilter[], journal?: string | null | undefined, status?: JournalHeaderStatus | null | undefined, name?: string | null | undefined, description?: string | null | undefined, id?: string | null | undefined): Promise<string> {
        let url_ = this.baseUrl + "/Journal/headers-v2?";
        if (journal !== undefined && journal !== null)
            url_ += "journal=" + encodeURIComponent("" + journal) + "&";
        if (status !== undefined && status !== null)
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        if (name !== undefined && name !== null)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        if (description !== undefined && description !== null)
            url_ += "description=" + encodeURIComponent("" + description) + "&";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filters);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSearchHeadersV2(_response));
        });
    }

    protected processSearchHeadersV2(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    searchDetails(filters: JournalFilter[], journal?: string | null | undefined, status?: JournalHeaderStatus | null | undefined, name?: string | null | undefined, description?: string | null | undefined): Promise<JournalDetail[]> {
        let url_ = this.baseUrl + "/Journal/details?";
        if (journal !== undefined && journal !== null)
            url_ += "journal=" + encodeURIComponent("" + journal) + "&";
        if (status !== undefined && status !== null)
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        if (name !== undefined && name !== null)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        if (description !== undefined && description !== null)
            url_ += "description=" + encodeURIComponent("" + description) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filters);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSearchDetails(_response));
        });
    }

    protected processSearchDetails(response: Response): Promise<JournalDetail[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(JournalDetail.fromJS(resultData200[item]));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<JournalDetail[]>(null as any);
    }

    searchDetailsV2(filters: JournalFilter[], journal?: string | null | undefined): Promise<string> {
        let url_ = this.baseUrl + "/Journal/details-v2?";
        if (journal !== undefined && journal !== null)
            url_ += "journal=" + encodeURIComponent("" + journal) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filters);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSearchDetailsV2(_response));
        });
    }

    protected processSearchDetailsV2(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    saveJournalData(data: SaveJournalDataModel, journal?: string | null | undefined): Promise<JournalHeaderWithDetails[]> {
        let url_ = this.baseUrl + "/Journal/save-journal-data?";
        if (journal !== undefined && journal !== null)
            url_ += "journal=" + encodeURIComponent("" + journal) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSaveJournalData(_response));
        });
    }

    protected processSaveJournalData(response: Response): Promise<JournalHeaderWithDetails[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(JournalHeaderWithDetails.fromJS(resultData200[item]));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<JournalHeaderWithDetails[]>(null as any);
    }

    saveJournalDataV2(jsonData: string, journal?: string | null | undefined): Promise<JournalHeaderWithDetails[]> {
        let url_ = this.baseUrl + "/Journal/save-journal-dataV2?";
        if (journal !== undefined && journal !== null)
            url_ += "journal=" + encodeURIComponent("" + journal) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(jsonData);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSaveJournalDataV2(_response));
        });
    }

    protected processSaveJournalDataV2(response: Response): Promise<JournalHeaderWithDetails[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(JournalHeaderWithDetails.fromJS(resultData200[item]));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<JournalHeaderWithDetails[]>(null as any);
    }

    post(jeGroupIds: number[], journal?: string | null | undefined): Promise<number[]> {
        let url_ = this.baseUrl + "/Journal/post?";
        if (journal !== undefined && journal !== null)
            url_ += "journal=" + encodeURIComponent("" + journal) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(jeGroupIds);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processPost(_response));
        });
    }

    protected processPost(response: Response): Promise<number[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(resultData200[item]);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number[]>(null as any);
    }

    postV2(jeGroupIds: number[], journal?: string | null | undefined): Promise<number[]> {
        let url_ = this.baseUrl + "/Journal/postv2?";
        if (journal !== undefined && journal !== null)
            url_ += "journal=" + encodeURIComponent("" + journal) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(jeGroupIds);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processPostV2(_response));
        });
    }

    protected processPostV2(response: Response): Promise<number[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(resultData200[item]);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number[]>(null as any);
    }

    unPost(jeGroupIds: number[], journal?: string | null | undefined): Promise<number[]> {
        let url_ = this.baseUrl + "/Journal/unpost?";
        if (journal !== undefined && journal !== null)
            url_ += "journal=" + encodeURIComponent("" + journal) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(jeGroupIds);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUnPost(_response));
        });
    }

    protected processUnPost(response: Response): Promise<number[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(resultData200[item]);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number[]>(null as any);
    }

    unPostV2(jeGroupIds: number[], journal?: string | null | undefined): Promise<number[]> {
        let url_ = this.baseUrl + "/Journal/unpostv2?";
        if (journal !== undefined && journal !== null)
            url_ += "journal=" + encodeURIComponent("" + journal) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(jeGroupIds);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUnPostV2(_response));
        });
    }

    protected processUnPostV2(response: Response): Promise<number[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(resultData200[item]);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number[]>(null as any);
    }

    getAttachments(model?: string | null | undefined, headerId?: number | undefined): Promise<JournalAttachmentInfo[]> {
        let url_ = this.baseUrl + "/Journal/attachments?";
        if (model !== undefined && model !== null)
            url_ += "model=" + encodeURIComponent("" + model) + "&";
        if (headerId === null)
            throw new Error("The parameter 'headerId' cannot be null.");
        else if (headerId !== undefined)
            url_ += "headerId=" + encodeURIComponent("" + headerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAttachments(_response));
        });
    }

    protected processGetAttachments(response: Response): Promise<JournalAttachmentInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(JournalAttachmentInfo.fromJS(resultData200[item]));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<JournalAttachmentInfo[]>(null as any);
    }

    getAttachment(journal?: string | null | undefined, id?: number | undefined): Promise<JournalAttachment> {
        let url_ = this.baseUrl + "/Journal/attachment?";
        if (journal !== undefined && journal !== null)
            url_ += "journal=" + encodeURIComponent("" + journal) + "&";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAttachment(_response));
        });
    }

    protected processGetAttachment(response: Response): Promise<JournalAttachment> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = JournalAttachment.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<JournalAttachment>(null as any);
    }

    addAttachment(journal?: string | null | undefined, idHeader?: number | undefined, journal_Id?: number | undefined, journal_CreatedBy?: string | null | undefined, journal_CreatedOn?: Date | undefined, journal_Description?: string | null | undefined, journal_Name?: string | null | undefined, journal_Url?: string | null | undefined, postedFile_File?: FileParameter | null | undefined): Promise<JournalAttachment> {
        let url_ = this.baseUrl + "/Journal/attachment?";
        if (journal !== undefined && journal !== null)
            url_ += "journal=" + encodeURIComponent("" + journal) + "&";
        if (idHeader === null)
            throw new Error("The parameter 'idHeader' cannot be null.");
        else if (idHeader !== undefined)
            url_ += "idHeader=" + encodeURIComponent("" + idHeader) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (journal_Id === null || journal_Id === undefined)
            throw new Error("The parameter 'journal_Id' cannot be null.");
        else
            content_.append("Journal.Id", journal_Id.toString());
        if (journal_CreatedBy !== null && journal_CreatedBy !== undefined)
            content_.append("Journal.CreatedBy", journal_CreatedBy.toString());
        if (journal_CreatedOn === null || journal_CreatedOn === undefined)
            throw new Error("The parameter 'journal_CreatedOn' cannot be null.");
        else
            content_.append("Journal.CreatedOn", journal_CreatedOn.toJSON());
        if (journal_Description !== null && journal_Description !== undefined)
            content_.append("Journal.Description", journal_Description.toString());
        if (journal_Name !== null && journal_Name !== undefined)
            content_.append("Journal.Name", journal_Name.toString());
        if (journal_Url !== null && journal_Url !== undefined)
            content_.append("Journal.Url", journal_Url.toString());
        if (postedFile_File !== null && postedFile_File !== undefined)
            content_.append("PostedFile.File", postedFile_File.data, postedFile_File.fileName ? postedFile_File.fileName : "PostedFile.File");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAddAttachment(_response));
        });
    }

    protected processAddAttachment(response: Response): Promise<JournalAttachment> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = JournalAttachment.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<JournalAttachment>(null as any);
    }

    deleteAttachment(journal?: string | null | undefined, attachmentId?: number | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Journal/attachment?";
        if (journal !== undefined && journal !== null)
            url_ += "journal=" + encodeURIComponent("" + journal) + "&";
        if (attachmentId === null)
            throw new Error("The parameter 'attachmentId' cannot be null.");
        else if (attachmentId !== undefined)
            url_ += "attachmentId=" + encodeURIComponent("" + attachmentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteAttachment(_response));
        });
    }

    protected processDeleteAttachment(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getAttachmentV2(model?: string | null | undefined, id?: number | undefined): Promise<JournalAttachment> {
        let url_ = this.baseUrl + "/Journal/attachment-v2?";
        if (model !== undefined && model !== null)
            url_ += "model=" + encodeURIComponent("" + model) + "&";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAttachmentV2(_response));
        });
    }

    protected processGetAttachmentV2(response: Response): Promise<JournalAttachment> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = JournalAttachment.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<JournalAttachment>(null as any);
    }

    addAttachmentV2(model?: string | null | undefined, idHeader?: number | undefined, journal_Id?: number | undefined, journal_CreatedBy?: string | null | undefined, journal_CreatedOn?: Date | undefined, journal_Description?: string | null | undefined, journal_Name?: string | null | undefined, journal_Url?: string | null | undefined, postedFile_File?: FileParameter | null | undefined): Promise<JournalAttachment> {
        let url_ = this.baseUrl + "/Journal/attachment-v2?";
        if (model !== undefined && model !== null)
            url_ += "model=" + encodeURIComponent("" + model) + "&";
        if (idHeader === null)
            throw new Error("The parameter 'idHeader' cannot be null.");
        else if (idHeader !== undefined)
            url_ += "idHeader=" + encodeURIComponent("" + idHeader) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (journal_Id === null || journal_Id === undefined)
            throw new Error("The parameter 'journal_Id' cannot be null.");
        else
            content_.append("Journal.Id", journal_Id.toString());
        if (journal_CreatedBy !== null && journal_CreatedBy !== undefined)
            content_.append("Journal.CreatedBy", journal_CreatedBy.toString());
        if (journal_CreatedOn === null || journal_CreatedOn === undefined)
            throw new Error("The parameter 'journal_CreatedOn' cannot be null.");
        else
            content_.append("Journal.CreatedOn", journal_CreatedOn.toJSON());
        if (journal_Description !== null && journal_Description !== undefined)
            content_.append("Journal.Description", journal_Description.toString());
        if (journal_Name !== null && journal_Name !== undefined)
            content_.append("Journal.Name", journal_Name.toString());
        if (journal_Url !== null && journal_Url !== undefined)
            content_.append("Journal.Url", journal_Url.toString());
        if (postedFile_File !== null && postedFile_File !== undefined)
            content_.append("PostedFile.File", postedFile_File.data, postedFile_File.fileName ? postedFile_File.fileName : "PostedFile.File");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAddAttachmentV2(_response));
        });
    }

    protected processAddAttachmentV2(response: Response): Promise<JournalAttachment> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = JournalAttachment.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<JournalAttachment>(null as any);
    }

    deleteAttachmentV2(model?: string | null | undefined, attachmentId?: number | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Journal/attachment-v2?";
        if (model !== undefined && model !== null)
            url_ += "model=" + encodeURIComponent("" + model) + "&";
        if (attachmentId === null)
            throw new Error("The parameter 'attachmentId' cannot be null.");
        else if (attachmentId !== undefined)
            url_ += "attachmentId=" + encodeURIComponent("" + attachmentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteAttachmentV2(_response));
        });
    }

    protected processDeleteAttachmentV2(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getAuthorizedMemberKeys(model?: string | null | undefined): Promise<JournalDimensionAuthorizedKeys[]> {
        let url_ = this.baseUrl + "/Journal/authorized-member-keys?";
        if (model !== undefined && model !== null)
            url_ += "model=" + encodeURIComponent("" + model) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAuthorizedMemberKeys(_response));
        });
    }

    protected processGetAuthorizedMemberKeys(response: Response): Promise<JournalDimensionAuthorizedKeys[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(JournalDimensionAuthorizedKeys.fromJS(resultData200[item]));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<JournalDimensionAuthorizedKeys[]>(null as any);
    }

    getJournalAuditLogsV2(query: { [key: string]: any; }, journalName?: string | null | undefined, dimensionsSet?: boolean | undefined): Promise<JournalAuditLogInfo[]> {
        let url_ = this.baseUrl + "/Journal/journal-audit-logs-v2?";
        if (journalName !== undefined && journalName !== null)
            url_ += "journalName=" + encodeURIComponent("" + journalName) + "&";
        if (dimensionsSet === null)
            throw new Error("The parameter 'dimensionsSet' cannot be null.");
        else if (dimensionsSet !== undefined)
            url_ += "dimensionsSet=" + encodeURIComponent("" + dimensionsSet) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetJournalAuditLogsV2(_response));
        });
    }

    protected processGetJournalAuditLogsV2(response: Response): Promise<JournalAuditLogInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(JournalAuditLogInfo.fromJS(resultData200[item]));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<JournalAuditLogInfo[]>(null as any);
    }

    importDetails(csvDelim?: string | undefined, file?: FileParameter | null | undefined): Promise<{ [key: string]: any; }[]> {
        let url_ = this.baseUrl + "/Journal/import?";
        if (csvDelim === null)
            throw new Error("The parameter 'csvDelim' cannot be null.");
        else if (csvDelim !== undefined)
            url_ += "csvDelim=" + encodeURIComponent("" + csvDelim) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("File", file.data, file.fileName ? file.fileName : "File");

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processImportDetails(_response));
        });
    }

    protected processImportDetails(response: Response): Promise<{ [key: string]: any; }[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(resultData200[item]);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<{ [key: string]: any; }[]>(null as any);
    }

    exportJEAuditLog(auditLogInfo: JournalAuditLogInfo[], journalName?: string | null | undefined, format?: string | null | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/Journal/export?";
        if (journalName !== undefined && journalName !== null)
            url_ += "journalName=" + encodeURIComponent("" + journalName) + "&";
        if (format !== undefined && format !== null)
            url_ += "format=" + encodeURIComponent("" + format) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(auditLogInfo);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExportJEAuditLog(_response));
        });
    }

    protected processExportJEAuditLog(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    getFailedValidationRules(journal?: string | null | undefined, headerId?: number | undefined): Promise<JournalRule[]> {
        let url_ = this.baseUrl + "/Journal/ValidationRules?";
        if (journal !== undefined && journal !== null)
            url_ += "journal=" + encodeURIComponent("" + journal) + "&";
        if (headerId === null)
            throw new Error("The parameter 'headerId' cannot be null.");
        else if (headerId !== undefined)
            url_ += "headerId=" + encodeURIComponent("" + headerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetFailedValidationRules(_response));
        });
    }

    protected processGetFailedValidationRules(response: Response): Promise<JournalRule[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(JournalRule.fromJS(resultData200[item]));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<JournalRule[]>(null as any);
    }

    movementClassificationValidation(journal?: string | null | undefined): Promise<JournalMovementClasificationValidation> {
        let url_ = this.baseUrl + "/Journal/MovementClassificationValidation?";
        if (journal !== undefined && journal !== null)
            url_ += "journal=" + encodeURIComponent("" + journal) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processMovementClassificationValidation(_response));
        });
    }

    protected processMovementClassificationValidation(response: Response): Promise<JournalMovementClasificationValidation> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = JournalMovementClasificationValidation.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<JournalMovementClasificationValidation>(null as any);
    }

    getJEFeatureFlag(): Promise<boolean> {
        let url_ = this.baseUrl + "/Journal/jefeatureflag";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetJEFeatureFlag(_response));
        });
    }

    protected processGetJEFeatureFlag(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export class LandscapeManagementClient extends FluenceApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    manage(): Promise<string> {
        let url_ = this.baseUrl + "/LandscapeManagement";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processManage(_response));
        });
    }

    protected processManage(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    getTenants(): Promise<TenantDTO[]> {
        let url_ = this.baseUrl + "/LandscapeManagement/tenants";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetTenants(_response));
        });
    }

    protected processGetTenants(response: Response): Promise<TenantDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(TenantDTO.fromJS(resultData200[item]));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TenantDTO[]>(null as any);
    }

    createChangeSet(changeSetDTO: ChangeSetDTO): Promise<ChangeSet> {
        let url_ = this.baseUrl + "/LandscapeManagement/changeset";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(changeSetDTO);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateChangeSet(_response));
        });
    }

    protected processCreateChangeSet(response: Response): Promise<ChangeSet> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ChangeSet.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ChangeSet>(null as any);
    }

    updateChangeSet(changeSetId: number, changeSetDTO: ChangeSetDTO): Promise<ChangeSet> {
        let url_ = this.baseUrl + "/LandscapeManagement/changeset/{changeSetId}";
        if (changeSetId === undefined || changeSetId === null)
            throw new Error("The parameter 'changeSetId' must be defined.");
        url_ = url_.replace("{changeSetId}", encodeURIComponent("" + changeSetId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(changeSetDTO);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateChangeSet(_response));
        });
    }

    protected processUpdateChangeSet(response: Response): Promise<ChangeSet> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ChangeSet.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ChangeSet>(null as any);
    }

    deleteChangeSet(changeSetId: number): Promise<void> {
        let url_ = this.baseUrl + "/LandscapeManagement/changeset/{changeSetId}";
        if (changeSetId === undefined || changeSetId === null)
            throw new Error("The parameter 'changeSetId' must be defined.");
        url_ = url_.replace("{changeSetId}", encodeURIComponent("" + changeSetId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteChangeSet(_response));
        });
    }

    protected processDeleteChangeSet(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    createChangeSetItems(changeSetId: number, changeSetItemsDTO: ChangeSetItemDTO[]): Promise<void> {
        let url_ = this.baseUrl + "/LandscapeManagement/changeset/{changeSetId}/changesetitems";
        if (changeSetId === undefined || changeSetId === null)
            throw new Error("The parameter 'changeSetId' must be defined.");
        url_ = url_.replace("{changeSetId}", encodeURIComponent("" + changeSetId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(changeSetItemsDTO);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateChangeSetItems(_response));
        });
    }

    protected processCreateChangeSetItems(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getChangeSetItems(changeSetId: number): Promise<ChangeSetItem[]> {
        let url_ = this.baseUrl + "/LandscapeManagement/changeset/{changeSetId}/changesetitems";
        if (changeSetId === undefined || changeSetId === null)
            throw new Error("The parameter 'changeSetId' must be defined.");
        url_ = url_.replace("{changeSetId}", encodeURIComponent("" + changeSetId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetChangeSetItems(_response));
        });
    }

    protected processGetChangeSetItems(response: Response): Promise<ChangeSetItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(ChangeSetItem.fromJS(resultData200[item]));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ChangeSetItem[]>(null as any);
    }

    initiateDeployment(changeSetId: number, targetTenantIds: number[]): Promise<void> {
        let url_ = this.baseUrl + "/LandscapeManagement/changeset/{changeSetId}/initiatedeployment";
        if (changeSetId === undefined || changeSetId === null)
            throw new Error("The parameter 'changeSetId' must be defined.");
        url_ = url_.replace("{changeSetId}", encodeURIComponent("" + changeSetId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(targetTenantIds);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processInitiateDeployment(_response));
        });
    }

    protected processInitiateDeployment(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class MaintenanceClient extends FluenceApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getForms(): Promise<AdminForm[]> {
        let url_ = this.baseUrl + "/Maintenance";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetForms(_response));
        });
    }

    protected processGetForms(response: Response): Promise<AdminForm[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(AdminForm.fromJS(resultData200[item]));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AdminForm[]>(null as any);
    }

    getFormsByTableName(tableName: string): Promise<AdminForm[]> {
        let url_ = this.baseUrl + "/Maintenance/{tableName}";
        if (tableName === undefined || tableName === null)
            throw new Error("The parameter 'tableName' must be defined.");
        url_ = url_.replace("{tableName}", encodeURIComponent("" + tableName));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetFormsByTableName(_response));
        });
    }

    protected processGetFormsByTableName(response: Response): Promise<AdminForm[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(AdminForm.fromJS(resultData200[item]));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AdminForm[]>(null as any);
    }

    getFormColumns(formID?: number | undefined): Promise<Column[]> {
        let url_ = this.baseUrl + "/Maintenance/columns?";
        if (formID === null)
            throw new Error("The parameter 'formID' cannot be null.");
        else if (formID !== undefined)
            url_ += "formID=" + encodeURIComponent("" + formID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetFormColumns(_response));
        });
    }

    protected processGetFormColumns(response: Response): Promise<Column[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(Column.fromJS(resultData200[item]));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Column[]>(null as any);
    }

    getListFromTable(tableName?: string | null | undefined, tableColumn?: string | null | undefined): Promise<string[]> {
        let url_ = this.baseUrl + "/Maintenance/list?";
        if (tableName !== undefined && tableName !== null)
            url_ += "tableName=" + encodeURIComponent("" + tableName) + "&";
        if (tableColumn !== undefined && tableColumn !== null)
            url_ += "tableColumn=" + encodeURIComponent("" + tableColumn) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetListFromTable(_response));
        });
    }

    protected processGetListFromTable(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(resultData200[item]);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }

    getTableData(formId?: number | undefined, tablePrimaryKey?: string | null | undefined, type?: string | null | undefined, matchingValue?: string | null | undefined): Promise<{ [key: string]: any; }[]> {
        let url_ = this.baseUrl + "/Maintenance/data?";
        if (formId === null)
            throw new Error("The parameter 'formId' cannot be null.");
        else if (formId !== undefined)
            url_ += "formId=" + encodeURIComponent("" + formId) + "&";
        if (tablePrimaryKey !== undefined && tablePrimaryKey !== null)
            url_ += "tablePrimaryKey=" + encodeURIComponent("" + tablePrimaryKey) + "&";
        if (type !== undefined && type !== null)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        if (matchingValue !== undefined && matchingValue !== null)
            url_ += "matchingValue=" + encodeURIComponent("" + matchingValue) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetTableData(_response));
        });
    }

    protected processGetTableData(response: Response): Promise<{ [key: string]: any; }[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(resultData200[item]);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<{ [key: string]: any; }[]>(null as any);
    }

    getSpTableData(formQueryModel: AdminFormQueryModel): Promise<{ [key: string]: any; }[]> {
        let url_ = this.baseUrl + "/Maintenance/query-data";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(formQueryModel);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSpTableData(_response));
        });
    }

    protected processGetSpTableData(response: Response): Promise<{ [key: string]: any; }[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(resultData200[item]);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<{ [key: string]: any; }[]>(null as any);
    }

    getTableColumns(formId?: number | undefined): Promise<string[]> {
        let url_ = this.baseUrl + "/Maintenance/table-columns?";
        if (formId === null)
            throw new Error("The parameter 'formId' cannot be null.");
        else if (formId !== undefined)
            url_ += "formId=" + encodeURIComponent("" + formId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetTableColumns(_response));
        });
    }

    protected processGetTableColumns(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(resultData200[item]);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }

    saveFormData(data: SaveAdminFormDataModel): Promise<AdminFormHeader[]> {
        let url_ = this.baseUrl + "/Maintenance/save-data";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSaveFormData(_response));
        });
    }

    protected processSaveFormData(response: Response): Promise<AdminFormHeader[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(AdminFormHeader.fromJS(resultData200[item]));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AdminFormHeader[]>(null as any);
    }

    runSp(sp: AdminSp): Promise<void> {
        let url_ = this.baseUrl + "/Maintenance/run-sp";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sp);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRunSp(_response));
        });
    }

    protected processRunSp(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getAllCategories(): Promise<AdminCategory[]> {
        let url_ = this.baseUrl + "/Maintenance/categories";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAllCategories(_response));
        });
    }

    protected processGetAllCategories(response: Response): Promise<AdminCategory[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(AdminCategory.fromJS(resultData200[item]));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AdminCategory[]>(null as any);
    }

    getDefaultDateDimension(): Promise<string> {
        let url_ = this.baseUrl + "/Maintenance/defaultdatedimension";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDefaultDateDimension(_response));
        });
    }

    protected processGetDefaultDateDimension(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    importDetails(encodedCSVDelim?: string | null | undefined, file?: FileParameter | null | undefined): Promise<{ [key: string]: any; }[]> {
        let url_ = this.baseUrl + "/Maintenance/import?";
        if (encodedCSVDelim !== undefined && encodedCSVDelim !== null)
            url_ += "encodedCSVDelim=" + encodeURIComponent("" + encodedCSVDelim) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("File", file.data, file.fileName ? file.fileName : "File");

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processImportDetails(_response));
        });
    }

    protected processImportDetails(response: Response): Promise<{ [key: string]: any; }[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(resultData200[item]);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<{ [key: string]: any; }[]>(null as any);
    }

    getFXGlobalRatesJson(scenario?: string | null | undefined, date?: string | null | undefined, currency?: string | null | undefined, formId?: number | undefined): Promise<string> {
        let url_ = this.baseUrl + "/Maintenance/getfxglobalratesjson?";
        if (scenario !== undefined && scenario !== null)
            url_ += "scenario=" + encodeURIComponent("" + scenario) + "&";
        if (date !== undefined && date !== null)
            url_ += "date=" + encodeURIComponent("" + date) + "&";
        if (currency !== undefined && currency !== null)
            url_ += "currency=" + encodeURIComponent("" + currency) + "&";
        if (formId === null)
            throw new Error("The parameter 'formId' cannot be null.");
        else if (formId !== undefined)
            url_ += "formId=" + encodeURIComponent("" + formId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetFXGlobalRatesJson(_response));
        });
    }

    protected processGetFXGlobalRatesJson(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    saveFxGlobalRatesJson(json: string): Promise<void> {
        let url_ = this.baseUrl + "/Maintenance/savefxglobalratesjson";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(json);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSaveFxGlobalRatesJson(_response));
        });
    }

    protected processSaveFxGlobalRatesJson(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    importFxGlobalRates(isAppend?: boolean | undefined, csvDelimiter?: string | undefined, file?: FileParameter | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Maintenance/importfxglobalrates?";
        if (isAppend === null)
            throw new Error("The parameter 'isAppend' cannot be null.");
        else if (isAppend !== undefined)
            url_ += "isAppend=" + encodeURIComponent("" + isAppend) + "&";
        if (csvDelimiter === null)
            throw new Error("The parameter 'csvDelimiter' cannot be null.");
        else if (csvDelimiter !== undefined)
            url_ += "csvDelimiter=" + encodeURIComponent("" + csvDelimiter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("File", file.data, file.fileName ? file.fileName : "File");

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processImportFxGlobalRates(_response));
        });
    }

    protected processImportFxGlobalRates(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    exportFxGlobalRates(csvDelimiter?: string | undefined, scenario?: string | null | undefined, date?: string | null | undefined, currency?: string | null | undefined, formId?: number | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/Maintenance/exportfxglobalrates?";
        if (csvDelimiter === null)
            throw new Error("The parameter 'csvDelimiter' cannot be null.");
        else if (csvDelimiter !== undefined)
            url_ += "csvDelimiter=" + encodeURIComponent("" + csvDelimiter) + "&";
        if (scenario !== undefined && scenario !== null)
            url_ += "scenario=" + encodeURIComponent("" + scenario) + "&";
        if (date !== undefined && date !== null)
            url_ += "date=" + encodeURIComponent("" + date) + "&";
        if (currency !== undefined && currency !== null)
            url_ += "currency=" + encodeURIComponent("" + currency) + "&";
        if (formId === null)
            throw new Error("The parameter 'formId' cannot be null.");
        else if (formId !== undefined)
            url_ += "formId=" + encodeURIComponent("" + formId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExportFxGlobalRates(_response));
        });
    }

    protected processExportFxGlobalRates(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    getFormTableData(bulkRequest: MaintenanceBulkRequest): Promise<MaintenanceBulkResponse> {
        let url_ = this.baseUrl + "/Maintenance/FormData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(bulkRequest);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetFormTableData(_response));
        });
    }

    protected processGetFormTableData(response: Response): Promise<MaintenanceBulkResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MaintenanceBulkResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MaintenanceBulkResponse>(null as any);
    }

    copyDimensionHierarchyData(copyDataRequest: CopyDataRequest): Promise<CopyDataResponse> {
        let url_ = this.baseUrl + "/Maintenance/CopyData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(copyDataRequest);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCopyDimensionHierarchyData(_response));
        });
    }

    protected processCopyDimensionHierarchyData(response: Response): Promise<CopyDataResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CopyDataResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CopyDataResponse>(null as any);
    }

    getConfigureOpenPeriods(model?: string | null | undefined): Promise<OpenPeriod[]> {
        let url_ = this.baseUrl + "/Maintenance/ConfigureOpenPeriods?";
        if (model !== undefined && model !== null)
            url_ += "model=" + encodeURIComponent("" + model) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetConfigureOpenPeriods(_response));
        });
    }

    protected processGetConfigureOpenPeriods(response: Response): Promise<OpenPeriod[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(OpenPeriod.fromJS(resultData200[item]));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OpenPeriod[]>(null as any);
    }

    getDeferredTaxRates(scenario?: string | null | undefined, date?: string | null | undefined, country?: string | null | undefined, formId?: number | undefined): Promise<string> {
        let url_ = this.baseUrl + "/Maintenance/get-deferred-tax-rates?";
        if (scenario !== undefined && scenario !== null)
            url_ += "scenario=" + encodeURIComponent("" + scenario) + "&";
        if (date !== undefined && date !== null)
            url_ += "date=" + encodeURIComponent("" + date) + "&";
        if (country !== undefined && country !== null)
            url_ += "country=" + encodeURIComponent("" + country) + "&";
        if (formId === null)
            throw new Error("The parameter 'formId' cannot be null.");
        else if (formId !== undefined)
            url_ += "formId=" + encodeURIComponent("" + formId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDeferredTaxRates(_response));
        });
    }

    protected processGetDeferredTaxRates(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    exportDeferredTaxRates(csvDelimiter?: string | undefined, scenario?: string | null | undefined, date?: string | null | undefined, country?: string | null | undefined, formId?: number | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/Maintenance/export-deferred-tax-rates?";
        if (csvDelimiter === null)
            throw new Error("The parameter 'csvDelimiter' cannot be null.");
        else if (csvDelimiter !== undefined)
            url_ += "csvDelimiter=" + encodeURIComponent("" + csvDelimiter) + "&";
        if (scenario !== undefined && scenario !== null)
            url_ += "scenario=" + encodeURIComponent("" + scenario) + "&";
        if (date !== undefined && date !== null)
            url_ += "date=" + encodeURIComponent("" + date) + "&";
        if (country !== undefined && country !== null)
            url_ += "country=" + encodeURIComponent("" + country) + "&";
        if (formId === null)
            throw new Error("The parameter 'formId' cannot be null.");
        else if (formId !== undefined)
            url_ += "formId=" + encodeURIComponent("" + formId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExportDeferredTaxRates(_response));
        });
    }

    protected processExportDeferredTaxRates(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    importDeferredTaxRates(isAppend?: boolean | undefined, csvDelimiter?: string | undefined, file?: FileParameter | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Maintenance/import-deferred-tax-rates?";
        if (isAppend === null)
            throw new Error("The parameter 'isAppend' cannot be null.");
        else if (isAppend !== undefined)
            url_ += "isAppend=" + encodeURIComponent("" + isAppend) + "&";
        if (csvDelimiter === null)
            throw new Error("The parameter 'csvDelimiter' cannot be null.");
        else if (csvDelimiter !== undefined)
            url_ += "csvDelimiter=" + encodeURIComponent("" + csvDelimiter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("File", file.data, file.fileName ? file.fileName : "File");

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processImportDeferredTaxRates(_response));
        });
    }

    protected processImportDeferredTaxRates(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    saveDeferredTaxRates(json: string): Promise<void> {
        let url_ = this.baseUrl + "/Maintenance/save-deferred-tax-rates";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(json);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSaveDeferredTaxRates(_response));
        });
    }

    protected processSaveDeferredTaxRates(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getSettingsFormValueFromKey(key: string): Promise<string> {
        let url_ = this.baseUrl + "/Maintenance/get-settings-form-value/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSettingsFormValueFromKey(_response));
        });
    }

    protected processGetSettingsFormValueFromKey(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Returns a combined ownership tree for a given group and scenario.
     * @param scenario (optional) 
     * @param group (optional) 
     */
    getOwnershipTree(scenario?: string | null | undefined, group?: string | null | undefined): Promise<OwnershipTreeNodeDto[]> {
        let url_ = this.baseUrl + "/Maintenance/ownership-tree?";
        if (scenario !== undefined && scenario !== null)
            url_ += "scenario=" + encodeURIComponent("" + scenario) + "&";
        if (group !== undefined && group !== null)
            url_ += "group=" + encodeURIComponent("" + group) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetOwnershipTree(_response));
        });
    }

    protected processGetOwnershipTree(response: Response): Promise<OwnershipTreeNodeDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(OwnershipTreeNodeDto.fromJS(resultData200[item]));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OwnershipTreeNodeDto[]>(null as any);
    }

    /**
     * Returns direct ownership information grouped by entity.
     * @param scenario (optional) 
     * @param entity (optional) 
     * @param intercompany (optional) 
     */
    getDirectOwnership(scenario?: string | null | undefined, entity?: string | null | undefined, intercompany?: string | null | undefined): Promise<DirectOwnershipResultDto> {
        let url_ = this.baseUrl + "/Maintenance/direct-ownership?";
        if (scenario !== undefined && scenario !== null)
            url_ += "scenario=" + encodeURIComponent("" + scenario) + "&";
        if (entity !== undefined && entity !== null)
            url_ += "entity=" + encodeURIComponent("" + entity) + "&";
        if (intercompany !== undefined && intercompany !== null)
            url_ += "intercompany=" + encodeURIComponent("" + intercompany) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDirectOwnership(_response));
        });
    }

    protected processGetDirectOwnership(response: Response): Promise<DirectOwnershipResultDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DirectOwnershipResultDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DirectOwnershipResultDto>(null as any);
    }

    /**
     * Returns manage (group) ownership information grouped by entity.
     * @param scenario (optional) 
     * @param entity (optional) 
     */
    getManageOwnership(scenario?: string | null | undefined, entity?: string | null | undefined): Promise<ManageOwnershipResultDto> {
        let url_ = this.baseUrl + "/Maintenance/manage-ownership?";
        if (scenario !== undefined && scenario !== null)
            url_ += "scenario=" + encodeURIComponent("" + scenario) + "&";
        if (entity !== undefined && entity !== null)
            url_ += "entity=" + encodeURIComponent("" + entity) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetManageOwnership(_response));
        });
    }

    protected processGetManageOwnership(response: Response): Promise<ManageOwnershipResultDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ManageOwnershipResultDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ManageOwnershipResultDto>(null as any);
    }

    /**
     * Returns all consolidation methods (keys and display metadata) from the tenant configuration.
     */
    getConsolidationMethods(): Promise<ConsolidationMethodDto[]> {
        let url_ = this.baseUrl + "/Maintenance/consolidation-methods";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetConsolidationMethods(_response));
        });
    }

    protected processGetConsolidationMethods(response: Response): Promise<ConsolidationMethodDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(ConsolidationMethodDto.fromJS(resultData200[item]));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ConsolidationMethodDto[]>(null as any);
    }
}

export class MappingSuggestionsClient extends FluenceApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getMappingSuggestions(request: AiMappingRequestsDto): Promise<AiMappingResponsesDto> {
        let url_ = this.baseUrl + "/MappingSuggestions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetMappingSuggestions(_response));
        });
    }

    protected processGetMappingSuggestions(response: Response): Promise<AiMappingResponsesDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AiMappingResponsesDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AiMappingResponsesDto>(null as any);
    }
}

export class MatchingClient extends FluenceApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    generateMatchingCode(): Promise<void> {
        let url_ = this.baseUrl + "/Matching/matching/process";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGenerateMatchingCode(_response));
        });
    }

    protected processGenerateMatchingCode(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getMatchingGroups(): Promise<MatchGroupInfo[]> {
        let url_ = this.baseUrl + "/Matching/matching/groups";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetMatchingGroups(_response));
        });
    }

    protected processGetMatchingGroups(response: Response): Promise<MatchGroupInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(MatchGroupInfo.fromJS(resultData200[item]));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MatchGroupInfo[]>(null as any);
    }

    getMatchingGroup(group: string): Promise<MatchGroupInfo> {
        let url_ = this.baseUrl + "/Matching/matching/groups/{group}";
        if (group === undefined || group === null)
            throw new Error("The parameter 'group' must be defined.");
        url_ = url_.replace("{group}", encodeURIComponent("" + group));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetMatchingGroup(_response));
        });
    }

    protected processGetMatchingGroup(response: Response): Promise<MatchGroupInfo> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MatchGroupInfo.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MatchGroupInfo>(null as any);
    }

    createMatch(match: MatchInfo): Promise<MatchInfo> {
        let url_ = this.baseUrl + "/Matching/matching/match";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(match);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateMatch(_response));
        });
    }

    protected processCreateMatch(response: Response): Promise<MatchInfo> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MatchInfo.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MatchInfo>(null as any);
    }

    updateMatch(match: MatchInfo): Promise<MatchInfo> {
        let url_ = this.baseUrl + "/Matching/matching/match";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(match);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateMatch(_response));
        });
    }

    protected processUpdateMatch(response: Response): Promise<MatchInfo> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MatchInfo.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MatchInfo>(null as any);
    }

    deleteMatches(matchIds: number[]): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/Matching/matching/match";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(matchIds);

        let options_: RequestInit = {
            body: content_,
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteMatches(_response));
        });
    }

    protected processDeleteMatches(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    deleteMatch(matchId: number): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/Matching/matching/match/{matchId}";
        if (matchId === undefined || matchId === null)
            throw new Error("The parameter 'matchId' must be defined.");
        url_ = url_.replace("{matchId}", encodeURIComponent("" + matchId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteMatch(_response));
        });
    }

    protected processDeleteMatch(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    getTransactions(matchGroup: string, dataset: string, filter: TransactionFilter, accDimTable?: string | null | undefined, entityDimTable?: string | null | undefined): Promise<TransactionData> {
        let url_ = this.baseUrl + "/Matching/matching/transactions/{matchGroup}/{dataset}?";
        if (matchGroup === undefined || matchGroup === null)
            throw new Error("The parameter 'matchGroup' must be defined.");
        url_ = url_.replace("{matchGroup}", encodeURIComponent("" + matchGroup));
        if (dataset === undefined || dataset === null)
            throw new Error("The parameter 'dataset' must be defined.");
        url_ = url_.replace("{dataset}", encodeURIComponent("" + dataset));
        if (accDimTable !== undefined && accDimTable !== null)
            url_ += "accDimTable=" + encodeURIComponent("" + accDimTable) + "&";
        if (entityDimTable !== undefined && entityDimTable !== null)
            url_ += "entityDimTable=" + encodeURIComponent("" + entityDimTable) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filter);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetTransactions(_response));
        });
    }

    protected processGetTransactions(response: Response): Promise<TransactionData> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TransactionData.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TransactionData>(null as any);
    }

    deleteTransactions(matchGroup: string, dataset: string, transactionIds: string[]): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/Matching/matching/transactions/{matchGroup}/{dataset}";
        if (matchGroup === undefined || matchGroup === null)
            throw new Error("The parameter 'matchGroup' must be defined.");
        url_ = url_.replace("{matchGroup}", encodeURIComponent("" + matchGroup));
        if (dataset === undefined || dataset === null)
            throw new Error("The parameter 'dataset' must be defined.");
        url_ = url_.replace("{dataset}", encodeURIComponent("" + dataset));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(transactionIds);

        let options_: RequestInit = {
            body: content_,
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteTransactions(_response));
        });
    }

    protected processDeleteTransactions(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    getAttachment(id: number): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/Matching/attachment/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAttachment(_response));
        });
    }

    protected processGetAttachment(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    getDimensionTables(): Promise<{ [key: string]: string; }> {
        let url_ = this.baseUrl + "/Matching/matching/DimensionTables";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDimensionTables(_response));
        });
    }

    protected processGetDimensionTables(response: Response): Promise<{ [key: string]: string; }> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {} as any;
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        (<any>result200)![key] = resultData200[key] !== undefined ? resultData200[key] : <any>null;
                }
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<{ [key: string]: string; }>(null as any);
    }

    getReconciliationGroupList(acctDimTable?: string | null | undefined, accountName?: string | null | undefined): Promise<string[]> {
        let url_ = this.baseUrl + "/Matching/matching/reconciliationGroups?";
        if (acctDimTable !== undefined && acctDimTable !== null)
            url_ += "acctDimTable=" + encodeURIComponent("" + acctDimTable) + "&";
        if (accountName !== undefined && accountName !== null)
            url_ += "accountName=" + encodeURIComponent("" + accountName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetReconciliationGroupList(_response));
        });
    }

    protected processGetReconciliationGroupList(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(resultData200[item]);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }

    getAccountList(reconciliationGroup: string, acctDimTable?: string | null | undefined): Promise<string[]> {
        let url_ = this.baseUrl + "/Matching/matching/groupAccounts/{reconciliationGroup}?";
        if (reconciliationGroup === undefined || reconciliationGroup === null)
            throw new Error("The parameter 'reconciliationGroup' must be defined.");
        url_ = url_.replace("{reconciliationGroup}", encodeURIComponent("" + reconciliationGroup));
        if (acctDimTable !== undefined && acctDimTable !== null)
            url_ += "acctDimTable=" + encodeURIComponent("" + acctDimTable) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAccountList(_response));
        });
    }

    protected processGetAccountList(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(resultData200[item]);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }

    getEntityList(entityDimTable?: string | null | undefined): Promise<string[]> {
        let url_ = this.baseUrl + "/Matching/matching/entities?";
        if (entityDimTable !== undefined && entityDimTable !== null)
            url_ += "entityDimTable=" + encodeURIComponent("" + entityDimTable) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetEntityList(_response));
        });
    }

    protected processGetEntityList(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(resultData200[item]);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }

    getSupportingItemSubtypeList(reconciliationGroup: string): Promise<string[]> {
        let url_ = this.baseUrl + "/Matching/matching/supportingItemSubtypes/{reconciliationGroup}";
        if (reconciliationGroup === undefined || reconciliationGroup === null)
            throw new Error("The parameter 'reconciliationGroup' must be defined.");
        url_ = url_.replace("{reconciliationGroup}", encodeURIComponent("" + reconciliationGroup));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSupportingItemSubtypeList(_response));
        });
    }

    protected processGetSupportingItemSubtypeList(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(resultData200[item]);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }

    getSupportingItemClassList(): Promise<string[]> {
        let url_ = this.baseUrl + "/Matching/matching/itemClasses";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSupportingItemClassList(_response));
        });
    }

    protected processGetSupportingItemClassList(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(resultData200[item]);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }

    createSupportingItem(matchGroup: string, itemInfo: SupportingItemInfo, acctDimTable?: string | null | undefined, entityDimTable?: string | null | undefined): Promise<SupportingItemInfo> {
        let url_ = this.baseUrl + "/Matching/matching/createSupportingItem/{matchGroup}?";
        if (matchGroup === undefined || matchGroup === null)
            throw new Error("The parameter 'matchGroup' must be defined.");
        url_ = url_.replace("{matchGroup}", encodeURIComponent("" + matchGroup));
        if (acctDimTable !== undefined && acctDimTable !== null)
            url_ += "acctDimTable=" + encodeURIComponent("" + acctDimTable) + "&";
        if (entityDimTable !== undefined && entityDimTable !== null)
            url_ += "entityDimTable=" + encodeURIComponent("" + entityDimTable) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(itemInfo);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateSupportingItem(_response));
        });
    }

    protected processCreateSupportingItem(response: Response): Promise<SupportingItemInfo> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SupportingItemInfo.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SupportingItemInfo>(null as any);
    }

    updateSupportingItem(matchGroup: string, itemInfo: SupportingItemInfo, entityDimTable?: string | null | undefined): Promise<SupportingItemInfo> {
        let url_ = this.baseUrl + "/Matching/matching/updateSupportingItem/{matchGroup}?";
        if (matchGroup === undefined || matchGroup === null)
            throw new Error("The parameter 'matchGroup' must be defined.");
        url_ = url_.replace("{matchGroup}", encodeURIComponent("" + matchGroup));
        if (entityDimTable !== undefined && entityDimTable !== null)
            url_ += "entityDimTable=" + encodeURIComponent("" + entityDimTable) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(itemInfo);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateSupportingItem(_response));
        });
    }

    protected processUpdateSupportingItem(response: Response): Promise<SupportingItemInfo> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SupportingItemInfo.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SupportingItemInfo>(null as any);
    }

    deleteSupportingItem(itemInfo: SupportingItemInfo, entityDimTable?: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Matching/matching/deleteSupportingItem?";
        if (entityDimTable !== undefined && entityDimTable !== null)
            url_ += "entityDimTable=" + encodeURIComponent("" + entityDimTable) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(itemInfo);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteSupportingItem(_response));
        });
    }

    protected processDeleteSupportingItem(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    newSupportingItemValidation(itemInfo: SupportingItemInfo, entityDimTable?: string | null | undefined, timeDimTable?: string | null | undefined): Promise<string> {
        let url_ = this.baseUrl + "/Matching/matching/newSupportingItemValidation?";
        if (entityDimTable !== undefined && entityDimTable !== null)
            url_ += "entityDimTable=" + encodeURIComponent("" + entityDimTable) + "&";
        if (timeDimTable !== undefined && timeDimTable !== null)
            url_ += "timeDimTable=" + encodeURIComponent("" + timeDimTable) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(itemInfo);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processNewSupportingItemValidation(_response));
        });
    }

    protected processNewSupportingItemValidation(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    existingSupportingItemValidation(itemInfo: SupportingItemInfo, entityDimTable?: string | null | undefined, timeDimTable?: string | null | undefined): Promise<string> {
        let url_ = this.baseUrl + "/Matching/matching/existingSupportingItemValidation?";
        if (entityDimTable !== undefined && entityDimTable !== null)
            url_ += "entityDimTable=" + encodeURIComponent("" + entityDimTable) + "&";
        if (timeDimTable !== undefined && timeDimTable !== null)
            url_ += "timeDimTable=" + encodeURIComponent("" + timeDimTable) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(itemInfo);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExistingSupportingItemValidation(_response));
        });
    }

    protected processExistingSupportingItemValidation(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    preloadSupportingItemValidation(itemInfo: SupportingItemInfo, entityDimTable?: string | null | undefined, timeDimTable?: string | null | undefined): Promise<number> {
        let url_ = this.baseUrl + "/Matching?";
        if (entityDimTable !== undefined && entityDimTable !== null)
            url_ += "entityDimTable=" + encodeURIComponent("" + entityDimTable) + "&";
        if (timeDimTable !== undefined && timeDimTable !== null)
            url_ += "timeDimTable=" + encodeURIComponent("" + timeDimTable) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(itemInfo);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processPreloadSupportingItemValidation(_response));
        });
    }

    protected processPreloadSupportingItemValidation(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }
}

export class MetadataClient extends FluenceApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getModels(): Promise<ModelInfo[]> {
        let url_ = this.baseUrl + "/Metadata/model";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetModels(_response));
        });
    }

    protected processGetModels(response: Response): Promise<ModelInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(ModelInfo.fromJS(resultData200[item]));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ModelInfo[]>(null as any);
    }

    createModel(request: ModelInfo): Promise<ModelInfo> {
        let url_ = this.baseUrl + "/Metadata/model";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateModel(_response));
        });
    }

    protected processCreateModel(response: Response): Promise<ModelInfo> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = ModelInfo.fromJS(resultData201);
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ModelInfo>(null as any);
    }

    updateModel(modelName: string, request: ModelInfo): Promise<ModelInfo> {
        let url_ = this.baseUrl + "/Metadata/model/{modelName}";
        if (modelName === undefined || modelName === null)
            throw new Error("The parameter 'modelName' must be defined.");
        url_ = url_.replace("{modelName}", encodeURIComponent("" + modelName));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateModel(_response));
        });
    }

    protected processUpdateModel(response: Response): Promise<ModelInfo> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ModelInfo.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ModelInfo>(null as any);
    }

    deleteModel(modelName: string): Promise<void> {
        let url_ = this.baseUrl + "/Metadata/model/{modelName}";
        if (modelName === undefined || modelName === null)
            throw new Error("The parameter 'modelName' must be defined.");
        url_ = url_.replace("{modelName}", encodeURIComponent("" + modelName));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteModel(_response));
        });
    }

    protected processDeleteModel(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getMainReportingCurrencyForModel(modelName: string): Promise<MainReportingCurrencyResponse> {
        let url_ = this.baseUrl + "/Metadata/model/{modelName}/main-reporting-currency";
        if (modelName === undefined || modelName === null)
            throw new Error("The parameter 'modelName' must be defined.");
        url_ = url_.replace("{modelName}", encodeURIComponent("" + modelName));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetMainReportingCurrencyForModel(_response));
        });
    }

    protected processGetMainReportingCurrencyForModel(response: Response): Promise<MainReportingCurrencyResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MainReportingCurrencyResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MainReportingCurrencyResponse>(null as any);
    }

    getDimensionRoles(): Promise<DimensionRoleInfo[]> {
        let url_ = this.baseUrl + "/Metadata/dimensionroles";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDimensionRoles(_response));
        });
    }

    protected processGetDimensionRoles(response: Response): Promise<DimensionRoleInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(DimensionRoleInfo.fromJS(resultData200[item]));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DimensionRoleInfo[]>(null as any);
    }

    getDimensions(): Promise<DimensionInfo[]> {
        let url_ = this.baseUrl + "/Metadata/dimension";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDimensions(_response));
        });
    }

    protected processGetDimensions(response: Response): Promise<DimensionInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(DimensionInfo.fromJS(resultData200[item]));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DimensionInfo[]>(null as any);
    }

    createDimension(request: DimensionInfo): Promise<DimensionInfo> {
        let url_ = this.baseUrl + "/Metadata/dimension";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateDimension(_response));
        });
    }

    protected processCreateDimension(response: Response): Promise<DimensionInfo> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = DimensionInfo.fromJS(resultData201);
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DimensionInfo>(null as any);
    }

    deleteDimension(dimensionName: string): Promise<void> {
        let url_ = this.baseUrl + "/Metadata/dimension/{dimensionName}";
        if (dimensionName === undefined || dimensionName === null)
            throw new Error("The parameter 'dimensionName' must be defined.");
        url_ = url_.replace("{dimensionName}", encodeURIComponent("" + dimensionName));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteDimension(_response));
        });
    }

    protected processDeleteDimension(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    updateDimension(dimensionName: string, updateData: DimensionInfo): Promise<DimensionInfo> {
        let url_ = this.baseUrl + "/Metadata/dimension/{dimensionName}";
        if (dimensionName === undefined || dimensionName === null)
            throw new Error("The parameter 'dimensionName' must be defined.");
        url_ = url_.replace("{dimensionName}", encodeURIComponent("" + dimensionName));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateData);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateDimension(_response));
        });
    }

    protected processUpdateDimension(response: Response): Promise<DimensionInfo> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DimensionInfo.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DimensionInfo>(null as any);
    }

    getDimensionPropertyOptions(dimensionName: string): Promise<DimensionPropertyOptionsResponse> {
        let url_ = this.baseUrl + "/Metadata/dimension/{dimensionName}/propertyoptions";
        if (dimensionName === undefined || dimensionName === null)
            throw new Error("The parameter 'dimensionName' must be defined.");
        url_ = url_.replace("{dimensionName}", encodeURIComponent("" + dimensionName));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDimensionPropertyOptions(_response));
        });
    }

    protected processGetDimensionPropertyOptions(response: Response): Promise<DimensionPropertyOptionsResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DimensionPropertyOptionsResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DimensionPropertyOptionsResponse>(null as any);
    }

    getStandardAttributes(): Promise<StandardAttributeInfo[]> {
        let url_ = this.baseUrl + "/Metadata/standardattributes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetStandardAttributes(_response));
        });
    }

    protected processGetStandardAttributes(response: Response): Promise<StandardAttributeInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(StandardAttributeInfo.fromJS(resultData200[item]));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StandardAttributeInfo[]>(null as any);
    }

    createHierarchies(dimensionName: string, request: HierarchyInfo[]): Promise<string> {
        let url_ = this.baseUrl + "/Metadata/hierarchy/{dimensionName}";
        if (dimensionName === undefined || dimensionName === null)
            throw new Error("The parameter 'dimensionName' must be defined.");
        url_ = url_.replace("{dimensionName}", encodeURIComponent("" + dimensionName));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateHierarchies(_response));
        });
    }

    protected processCreateHierarchies(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result201 = resultData201 !== undefined ? resultData201 : <any>null;
    
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    deleteHierarchy(dimensionName: string, hierarchyName: string): Promise<void> {
        let url_ = this.baseUrl + "/Metadata/hierarchy/{dimensionName}/{hierarchyName}";
        if (dimensionName === undefined || dimensionName === null)
            throw new Error("The parameter 'dimensionName' must be defined.");
        url_ = url_.replace("{dimensionName}", encodeURIComponent("" + dimensionName));
        if (hierarchyName === undefined || hierarchyName === null)
            throw new Error("The parameter 'hierarchyName' must be defined.");
        url_ = url_.replace("{hierarchyName}", encodeURIComponent("" + hierarchyName));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteHierarchy(_response));
        });
    }

    protected processDeleteHierarchy(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    updateHierarchy(dimensionName: string, hierarchyName: string, updateData: HierarchyInfo): Promise<HierarchyInfo> {
        let url_ = this.baseUrl + "/Metadata/hierarchy/{dimensionName}/{hierarchyName}";
        if (dimensionName === undefined || dimensionName === null)
            throw new Error("The parameter 'dimensionName' must be defined.");
        url_ = url_.replace("{dimensionName}", encodeURIComponent("" + dimensionName));
        if (hierarchyName === undefined || hierarchyName === null)
            throw new Error("The parameter 'hierarchyName' must be defined.");
        url_ = url_.replace("{hierarchyName}", encodeURIComponent("" + hierarchyName));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateData);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateHierarchy(_response));
        });
    }

    protected processUpdateHierarchy(response: Response): Promise<HierarchyInfo> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HierarchyInfo.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HierarchyInfo>(null as any);
    }

    processHierarchy(dimensionName: string, hierarchyName: string): Promise<void> {
        let url_ = this.baseUrl + "/Metadata/hierarchy/{dimensionName}/{hierarchyName}";
        if (dimensionName === undefined || dimensionName === null)
            throw new Error("The parameter 'dimensionName' must be defined.");
        url_ = url_.replace("{dimensionName}", encodeURIComponent("" + dimensionName));
        if (hierarchyName === undefined || hierarchyName === null)
            throw new Error("The parameter 'hierarchyName' must be defined.");
        url_ = url_.replace("{hierarchyName}", encodeURIComponent("" + hierarchyName));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processProcessHierarchy(_response));
        });
    }

    protected processProcessHierarchy(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getSubsets(): Promise<SubsetInfo[]> {
        let url_ = this.baseUrl + "/Metadata/subset";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSubsets(_response));
        });
    }

    protected processGetSubsets(response: Response): Promise<SubsetInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(SubsetInfo.fromJS(resultData200[item]));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SubsetInfo[]>(null as any);
    }

    createSubset(subset: SubsetInfo): Promise<void> {
        let url_ = this.baseUrl + "/Metadata/subset";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(subset);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateSubset(_response));
        });
    }

    protected processCreateSubset(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    deleteSubset(dimensionName: string, subsetName: string): Promise<void> {
        let url_ = this.baseUrl + "/Metadata/subset/{dimensionName}/{subsetName}";
        if (dimensionName === undefined || dimensionName === null)
            throw new Error("The parameter 'dimensionName' must be defined.");
        url_ = url_.replace("{dimensionName}", encodeURIComponent("" + dimensionName));
        if (subsetName === undefined || subsetName === null)
            throw new Error("The parameter 'subsetName' must be defined.");
        url_ = url_.replace("{subsetName}", encodeURIComponent("" + subsetName));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteSubset(_response));
        });
    }

    protected processDeleteSubset(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    deleteHierarchySubset(dimensionName: string, hierarchyName: string, subsetName: string): Promise<void> {
        let url_ = this.baseUrl + "/Metadata/subset/{dimensionName}/{hierarchyName}/{subsetName}";
        if (dimensionName === undefined || dimensionName === null)
            throw new Error("The parameter 'dimensionName' must be defined.");
        url_ = url_.replace("{dimensionName}", encodeURIComponent("" + dimensionName));
        if (hierarchyName === undefined || hierarchyName === null)
            throw new Error("The parameter 'hierarchyName' must be defined.");
        url_ = url_.replace("{hierarchyName}", encodeURIComponent("" + hierarchyName));
        if (subsetName === undefined || subsetName === null)
            throw new Error("The parameter 'subsetName' must be defined.");
        url_ = url_.replace("{subsetName}", encodeURIComponent("" + subsetName));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteHierarchySubset(_response));
        });
    }

    protected processDeleteHierarchySubset(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    createProperties(dimensionName: string, request: PropertyInfo[]): Promise<string> {
        let url_ = this.baseUrl + "/Metadata/property/{dimensionName}";
        if (dimensionName === undefined || dimensionName === null)
            throw new Error("The parameter 'dimensionName' must be defined.");
        url_ = url_.replace("{dimensionName}", encodeURIComponent("" + dimensionName));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateProperties(_response));
        });
    }

    protected processCreateProperties(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result201 = resultData201 !== undefined ? resultData201 : <any>null;
    
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    deleteProperty(dimensionName: string, propertyName: string): Promise<void> {
        let url_ = this.baseUrl + "/Metadata/property/{dimensionName}/{propertyName}";
        if (dimensionName === undefined || dimensionName === null)
            throw new Error("The parameter 'dimensionName' must be defined.");
        url_ = url_.replace("{dimensionName}", encodeURIComponent("" + dimensionName));
        if (propertyName === undefined || propertyName === null)
            throw new Error("The parameter 'propertyName' must be defined.");
        url_ = url_.replace("{propertyName}", encodeURIComponent("" + propertyName));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteProperty(_response));
        });
    }

    protected processDeleteProperty(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    updateProperty(dimensionName: string, propertyName: string, updateData: PropertyInfo): Promise<PropertyInfo> {
        let url_ = this.baseUrl + "/Metadata/property/{dimensionName}/{propertyName}";
        if (dimensionName === undefined || dimensionName === null)
            throw new Error("The parameter 'dimensionName' must be defined.");
        url_ = url_.replace("{dimensionName}", encodeURIComponent("" + dimensionName));
        if (propertyName === undefined || propertyName === null)
            throw new Error("The parameter 'propertyName' must be defined.");
        url_ = url_.replace("{propertyName}", encodeURIComponent("" + propertyName));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateData);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateProperty(_response));
        });
    }

    protected processUpdateProperty(response: Response): Promise<PropertyInfo> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PropertyInfo.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PropertyInfo>(null as any);
    }

    getDefaultHierarchyMembers(dimensionName: string, hierarchyName?: string | null | undefined, addVirtualRoot?: boolean | undefined, effectiveDate?: string | null | undefined): Promise<MemberInfo[]> {
        let url_ = this.baseUrl + "/Metadata/member/{dimensionName}?";
        if (dimensionName === undefined || dimensionName === null)
            throw new Error("The parameter 'dimensionName' must be defined.");
        url_ = url_.replace("{dimensionName}", encodeURIComponent("" + dimensionName));
        if (hierarchyName !== undefined && hierarchyName !== null)
            url_ += "hierarchyName=" + encodeURIComponent("" + hierarchyName) + "&";
        if (addVirtualRoot === null)
            throw new Error("The parameter 'addVirtualRoot' cannot be null.");
        else if (addVirtualRoot !== undefined)
            url_ += "addVirtualRoot=" + encodeURIComponent("" + addVirtualRoot) + "&";
        if (effectiveDate !== undefined && effectiveDate !== null)
            url_ += "effectiveDate=" + encodeURIComponent("" + effectiveDate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDefaultHierarchyMembers(_response));
        });
    }

    protected processGetDefaultHierarchyMembers(response: Response): Promise<MemberInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(MemberInfo.fromJS(resultData200[item]));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MemberInfo[]>(null as any);
    }

    deleteDefaultHierarchyMembers(dimensionName: string, keys: number[]): Promise<void> {
        let url_ = this.baseUrl + "/Metadata/member/{dimensionName}";
        if (dimensionName === undefined || dimensionName === null)
            throw new Error("The parameter 'dimensionName' must be defined.");
        url_ = url_.replace("{dimensionName}", encodeURIComponent("" + dimensionName));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(keys);

        let options_: RequestInit = {
            body: content_,
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteDefaultHierarchyMembers(_response));
        });
    }

    protected processDeleteDefaultHierarchyMembers(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    createDefaultHierarchyMembers(dimensionName: string, newMembers: MemberInfo[]): Promise<string> {
        let url_ = this.baseUrl + "/Metadata/member/{dimensionName}";
        if (dimensionName === undefined || dimensionName === null)
            throw new Error("The parameter 'dimensionName' must be defined.");
        url_ = url_.replace("{dimensionName}", encodeURIComponent("" + dimensionName));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(newMembers);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateDefaultHierarchyMembers(_response));
        });
    }

    protected processCreateDefaultHierarchyMembers(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result201 = resultData201 !== undefined ? resultData201 : <any>null;
    
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    getHierarchyMembersSimple(dimensionName: string, translation?: string | null | undefined): Promise<MemberInfoSimple[]> {
        let url_ = this.baseUrl + "/Metadata/membersimple/{dimensionName}?";
        if (dimensionName === undefined || dimensionName === null)
            throw new Error("The parameter 'dimensionName' must be defined.");
        url_ = url_.replace("{dimensionName}", encodeURIComponent("" + dimensionName));
        if (translation !== undefined && translation !== null)
            url_ += "translation=" + encodeURIComponent("" + translation) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetHierarchyMembersSimple(_response));
        });
    }

    protected processGetHierarchyMembersSimple(response: Response): Promise<MemberInfoSimple[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(MemberInfoSimple.fromJS(resultData200[item]));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MemberInfoSimple[]>(null as any);
    }

    getHierarchyMembers(dimensionName: string, hierarchyName: string, addVirtualRoot?: boolean | undefined, effectiveDate?: string | null | undefined): Promise<MemberInfo[]> {
        let url_ = this.baseUrl + "/Metadata/member/{dimensionName}/{hierarchyName}?";
        if (dimensionName === undefined || dimensionName === null)
            throw new Error("The parameter 'dimensionName' must be defined.");
        url_ = url_.replace("{dimensionName}", encodeURIComponent("" + dimensionName));
        if (hierarchyName === undefined || hierarchyName === null)
            throw new Error("The parameter 'hierarchyName' must be defined.");
        url_ = url_.replace("{hierarchyName}", encodeURIComponent("" + hierarchyName));
        if (addVirtualRoot === null)
            throw new Error("The parameter 'addVirtualRoot' cannot be null.");
        else if (addVirtualRoot !== undefined)
            url_ += "addVirtualRoot=" + encodeURIComponent("" + addVirtualRoot) + "&";
        if (effectiveDate !== undefined && effectiveDate !== null)
            url_ += "effectiveDate=" + encodeURIComponent("" + effectiveDate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetHierarchyMembers(_response));
        });
    }

    protected processGetHierarchyMembers(response: Response): Promise<MemberInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(MemberInfo.fromJS(resultData200[item]));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MemberInfo[]>(null as any);
    }

    deleteHierarchyMembers(dimensionName: string, hierarchyName: string, keys: number[]): Promise<void> {
        let url_ = this.baseUrl + "/Metadata/member/{dimensionName}/{hierarchyName}";
        if (dimensionName === undefined || dimensionName === null)
            throw new Error("The parameter 'dimensionName' must be defined.");
        url_ = url_.replace("{dimensionName}", encodeURIComponent("" + dimensionName));
        if (hierarchyName === undefined || hierarchyName === null)
            throw new Error("The parameter 'hierarchyName' must be defined.");
        url_ = url_.replace("{hierarchyName}", encodeURIComponent("" + hierarchyName));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(keys);

        let options_: RequestInit = {
            body: content_,
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteHierarchyMembers(_response));
        });
    }

    protected processDeleteHierarchyMembers(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    createHierarchyMembers(dimensionName: string, hierarchyName: string, newMembers: MemberInfo[]): Promise<string> {
        let url_ = this.baseUrl + "/Metadata/member/{dimensionName}/{hierarchyName}";
        if (dimensionName === undefined || dimensionName === null)
            throw new Error("The parameter 'dimensionName' must be defined.");
        url_ = url_.replace("{dimensionName}", encodeURIComponent("" + dimensionName));
        if (hierarchyName === undefined || hierarchyName === null)
            throw new Error("The parameter 'hierarchyName' must be defined.");
        url_ = url_.replace("{hierarchyName}", encodeURIComponent("" + hierarchyName));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(newMembers);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateHierarchyMembers(_response));
        });
    }

    protected processCreateHierarchyMembers(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result201 = resultData201 !== undefined ? resultData201 : <any>null;
    
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    getMemberTimeBasedChronology(dimensionName: string, hierarchyName: string, baseKey: number): Promise<MemberChronologyInfo[]> {
        let url_ = this.baseUrl + "/Metadata/member/chronology/{dimensionName}/{hierarchyName}/{baseKey}";
        if (dimensionName === undefined || dimensionName === null)
            throw new Error("The parameter 'dimensionName' must be defined.");
        url_ = url_.replace("{dimensionName}", encodeURIComponent("" + dimensionName));
        if (hierarchyName === undefined || hierarchyName === null)
            throw new Error("The parameter 'hierarchyName' must be defined.");
        url_ = url_.replace("{hierarchyName}", encodeURIComponent("" + hierarchyName));
        if (baseKey === undefined || baseKey === null)
            throw new Error("The parameter 'baseKey' must be defined.");
        url_ = url_.replace("{baseKey}", encodeURIComponent("" + baseKey));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetMemberTimeBasedChronology(_response));
        });
    }

    protected processGetMemberTimeBasedChronology(response: Response): Promise<MemberChronologyInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(MemberChronologyInfo.fromJS(resultData200[item]));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MemberChronologyInfo[]>(null as any);
    }

    getHierarchyMembersSingleGroupByMemberKey(singleGroupRequest: SingleGroupRequest): Promise<MemberInfoSingleGroupResult> {
        let url_ = this.baseUrl + "/Metadata/member/singlegroup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(singleGroupRequest);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetHierarchyMembersSingleGroupByMemberKey(_response));
        });
    }

    protected processGetHierarchyMembersSingleGroupByMemberKey(response: Response): Promise<MemberInfoSingleGroupResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MemberInfoSingleGroupResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MemberInfoSingleGroupResult>(null as any);
    }

    getHierarchyMembersServerGrouped(paging: HierarchyMemberPaging): Promise<MemberInfoPagedResults> {
        let url_ = this.baseUrl + "/Metadata/member/twopaged";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(paging);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetHierarchyMembersServerGrouped(_response));
        });
    }

    protected processGetHierarchyMembersServerGrouped(response: Response): Promise<MemberInfoPagedResults> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MemberInfoPagedResults.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MemberInfoPagedResults>(null as any);
    }

    getMemberHasFactData(dimensionName: string, hierarchyName: string, memberKey: number): Promise<boolean> {
        let url_ = this.baseUrl + "/Metadata/member/factcheck/{dimensionName}/{hierarchyName}";
        if (dimensionName === undefined || dimensionName === null)
            throw new Error("The parameter 'dimensionName' must be defined.");
        url_ = url_.replace("{dimensionName}", encodeURIComponent("" + dimensionName));
        if (hierarchyName === undefined || hierarchyName === null)
            throw new Error("The parameter 'hierarchyName' must be defined.");
        url_ = url_.replace("{hierarchyName}", encodeURIComponent("" + hierarchyName));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(memberKey);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetMemberHasFactData(_response));
        });
    }

    protected processGetMemberHasFactData(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    updateDefaultHierarchyMembers(dimensionName: string, reorder: boolean, changedMembers: MemberInfo[]): Promise<void> {
        let url_ = this.baseUrl + "/Metadata/member/{dimensionName}/{reorder}";
        if (dimensionName === undefined || dimensionName === null)
            throw new Error("The parameter 'dimensionName' must be defined.");
        url_ = url_.replace("{dimensionName}", encodeURIComponent("" + dimensionName));
        if (reorder === undefined || reorder === null)
            throw new Error("The parameter 'reorder' must be defined.");
        url_ = url_.replace("{reorder}", encodeURIComponent("" + reorder));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(changedMembers);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateDefaultHierarchyMembers(_response));
        });
    }

    protected processUpdateDefaultHierarchyMembers(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    updateHierarchyMembers(dimensionName: string, hierarchyName: string, reorder: boolean, changedMembers: MemberInfo[]): Promise<void> {
        let url_ = this.baseUrl + "/Metadata/member/{dimensionName}/{hierarchyName}/{reorder}";
        if (dimensionName === undefined || dimensionName === null)
            throw new Error("The parameter 'dimensionName' must be defined.");
        url_ = url_.replace("{dimensionName}", encodeURIComponent("" + dimensionName));
        if (hierarchyName === undefined || hierarchyName === null)
            throw new Error("The parameter 'hierarchyName' must be defined.");
        url_ = url_.replace("{hierarchyName}", encodeURIComponent("" + hierarchyName));
        if (reorder === undefined || reorder === null)
            throw new Error("The parameter 'reorder' must be defined.");
        url_ = url_.replace("{reorder}", encodeURIComponent("" + reorder));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(changedMembers);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateHierarchyMembers(_response));
        });
    }

    protected processUpdateHierarchyMembers(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    createModelView(modelName: string, request: ModelViewInfo): Promise<ModelViewInfo> {
        let url_ = this.baseUrl + "/Metadata/view/{modelName}";
        if (modelName === undefined || modelName === null)
            throw new Error("The parameter 'modelName' must be defined.");
        url_ = url_.replace("{modelName}", encodeURIComponent("" + modelName));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateModelView(_response));
        });
    }

    protected processCreateModelView(response: Response): Promise<ModelViewInfo> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = ModelViewInfo.fromJS(resultData201);
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ModelViewInfo>(null as any);
    }

    updateModelView(viewName: string, request: ModelViewInfo): Promise<void> {
        let url_ = this.baseUrl + "/Metadata/view/{viewName}";
        if (viewName === undefined || viewName === null)
            throw new Error("The parameter 'viewName' must be defined.");
        url_ = url_.replace("{viewName}", encodeURIComponent("" + viewName));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateModelView(_response));
        });
    }

    protected processUpdateModelView(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    deleteModelView(viewName: string): Promise<void> {
        let url_ = this.baseUrl + "/Metadata/view/{viewName}";
        if (viewName === undefined || viewName === null)
            throw new Error("The parameter 'viewName' must be defined.");
        url_ = url_.replace("{viewName}", encodeURIComponent("" + viewName));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteModelView(_response));
        });
    }

    protected processDeleteModelView(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Gets all global variables
     * @return Dictionary of global variables
     */
    getGlobalVariables(): Promise<{ [key: string]: string; }> {
        let url_ = this.baseUrl + "/Metadata/globalvariable";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetGlobalVariables(_response));
        });
    }

    protected processGetGlobalVariables(response: Response): Promise<{ [key: string]: string; }> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {} as any;
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        (<any>result200)![key] = resultData200[key] !== undefined ? resultData200[key] : <any>null;
                }
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<{ [key: string]: string; }>(null as any);
    }

    /**
     * Gets tags filtered by dimension name
     * @param dimensionName (optional) Optional dimension name to filter tags
     * @return Dictionary of tags
     */
    getTags(dimensionName?: string | null | undefined): Promise<{ [key: string]: string; }> {
        let url_ = this.baseUrl + "/Metadata/tags?";
        if (dimensionName !== undefined && dimensionName !== null)
            url_ += "dimensionName=" + encodeURIComponent("" + dimensionName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetTags(_response));
        });
    }

    protected processGetTags(response: Response): Promise<{ [key: string]: string; }> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {} as any;
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        (<any>result200)![key] = resultData200[key] !== undefined ? resultData200[key] : <any>null;
                }
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<{ [key: string]: string; }>(null as any);
    }

    processAllDimensions(): Promise<void> {
        let url_ = this.baseUrl + "/Metadata/process/dimension";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processProcessAllDimensions(_response));
        });
    }

    protected processProcessAllDimensions(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    processDimension(dimensionName: string): Promise<void> {
        let url_ = this.baseUrl + "/Metadata/process/dimension/{dimensionName}";
        if (dimensionName === undefined || dimensionName === null)
            throw new Error("The parameter 'dimensionName' must be defined.");
        url_ = url_.replace("{dimensionName}", encodeURIComponent("" + dimensionName));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processProcessDimension(_response));
        });
    }

    protected processProcessDimension(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    processMetadata(): Promise<void> {
        let url_ = this.baseUrl + "/Metadata/process";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processProcessMetadata(_response));
        });
    }

    protected processProcessMetadata(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    exportDimension(dimensionName: string, exportKeys?: boolean | null | undefined, effectiveDate?: string | null | undefined, format?: string | null | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/Metadata/export/dimension/{dimensionName}?";
        if (dimensionName === undefined || dimensionName === null)
            throw new Error("The parameter 'dimensionName' must be defined.");
        url_ = url_.replace("{dimensionName}", encodeURIComponent("" + dimensionName));
        if (exportKeys !== undefined && exportKeys !== null)
            url_ += "exportKeys=" + encodeURIComponent("" + exportKeys) + "&";
        if (effectiveDate !== undefined && effectiveDate !== null)
            url_ += "effectiveDate=" + encodeURIComponent("" + effectiveDate) + "&";
        if (format !== undefined && format !== null)
            url_ += "format=" + encodeURIComponent("" + format) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExportDimension(_response));
        });
    }

    protected processExportDimension(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    exportHierarchy(dimensionName: string, hierarchyName: string, exportKeys?: boolean | null | undefined, effectiveDate?: string | null | undefined, format?: string | null | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/Metadata/export/hierarchy/{dimensionName}/{hierarchyName}?";
        if (dimensionName === undefined || dimensionName === null)
            throw new Error("The parameter 'dimensionName' must be defined.");
        url_ = url_.replace("{dimensionName}", encodeURIComponent("" + dimensionName));
        if (hierarchyName === undefined || hierarchyName === null)
            throw new Error("The parameter 'hierarchyName' must be defined.");
        url_ = url_.replace("{hierarchyName}", encodeURIComponent("" + hierarchyName));
        if (exportKeys !== undefined && exportKeys !== null)
            url_ += "exportKeys=" + encodeURIComponent("" + exportKeys) + "&";
        if (effectiveDate !== undefined && effectiveDate !== null)
            url_ += "effectiveDate=" + encodeURIComponent("" + effectiveDate) + "&";
        if (format !== undefined && format !== null)
            url_ += "format=" + encodeURIComponent("" + format) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExportHierarchy(_response));
        });
    }

    protected processExportHierarchy(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    memberAlreadyExists(dimensionName: string, hierarchyName: string, file?: FileParameter | null | undefined, isAppend?: boolean | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/Metadata/import/hierarchy/{dimensionName}/{hierarchyName}?";
        if (dimensionName === undefined || dimensionName === null)
            throw new Error("The parameter 'dimensionName' must be defined.");
        url_ = url_.replace("{dimensionName}", encodeURIComponent("" + dimensionName));
        if (hierarchyName === undefined || hierarchyName === null)
            throw new Error("The parameter 'hierarchyName' must be defined.");
        url_ = url_.replace("{hierarchyName}", encodeURIComponent("" + hierarchyName));
        if (isAppend === null)
            throw new Error("The parameter 'isAppend' cannot be null.");
        else if (isAppend !== undefined)
            url_ += "isAppend=" + encodeURIComponent("" + isAppend) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("File", file.data, file.fileName ? file.fileName : "File");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processMemberAlreadyExists(_response));
        });
    }

    protected processMemberAlreadyExists(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    importHierarchy(dimensionName: string, hierarchyName: string, file?: FileParameter | null | undefined, isAppend?: boolean | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Metadata/import/hierarchy/{dimensionName}/{hierarchyName}?";
        if (dimensionName === undefined || dimensionName === null)
            throw new Error("The parameter 'dimensionName' must be defined.");
        url_ = url_.replace("{dimensionName}", encodeURIComponent("" + dimensionName));
        if (hierarchyName === undefined || hierarchyName === null)
            throw new Error("The parameter 'hierarchyName' must be defined.");
        url_ = url_.replace("{hierarchyName}", encodeURIComponent("" + hierarchyName));
        if (isAppend === null)
            throw new Error("The parameter 'isAppend' cannot be null.");
        else if (isAppend !== undefined)
            url_ += "isAppend=" + encodeURIComponent("" + isAppend) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("File", file.data, file.fileName ? file.fileName : "File");

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processImportHierarchy(_response));
        });
    }

    protected processImportHierarchy(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    importDimension(dimensionName: string, isAppend: boolean, file?: FileParameter | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Metadata/import/dimension/{dimensionName}";
        if (dimensionName === undefined || dimensionName === null)
            throw new Error("The parameter 'dimensionName' must be defined.");
        url_ = url_.replace("{dimensionName}", encodeURIComponent("" + dimensionName));
        if (isAppend === undefined || isAppend === null)
            throw new Error("The parameter 'isAppend' must be defined.");
        url_ = url_.replace("{isAppend}", encodeURIComponent("" + isAppend));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("File", file.data, file.fileName ? file.fileName : "File");

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processImportDimension(_response));
        });
    }

    protected processImportDimension(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    updateDimensionFromFile(dimensionName: string, file?: FileParameter | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Metadata/update/hierarchy/{dimensionName}";
        if (dimensionName === undefined || dimensionName === null)
            throw new Error("The parameter 'dimensionName' must be defined.");
        url_ = url_.replace("{dimensionName}", encodeURIComponent("" + dimensionName));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("File", file.data, file.fileName ? file.fileName : "File");

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateDimensionFromFile(_response));
        });
    }

    protected processUpdateDimensionFromFile(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    updateHierarchyFromFile(dimensionName: string, hierarchyName: string, file?: FileParameter | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Metadata/update/hierarchy/{dimensionName}/{hierarchyName}";
        if (dimensionName === undefined || dimensionName === null)
            throw new Error("The parameter 'dimensionName' must be defined.");
        url_ = url_.replace("{dimensionName}", encodeURIComponent("" + dimensionName));
        if (hierarchyName === undefined || hierarchyName === null)
            throw new Error("The parameter 'hierarchyName' must be defined.");
        url_ = url_.replace("{hierarchyName}", encodeURIComponent("" + hierarchyName));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("File", file.data, file.fileName ? file.fileName : "File");

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateHierarchyFromFile(_response));
        });
    }

    protected processUpdateHierarchyFromFile(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    synchronizeDimensionFromFile(dimensionName: string, selectedSyncOption: HierarchySyncMode, outputToResultScreen: boolean, reAssignMembers: boolean, doSync: boolean, file?: FileParameter | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Metadata/synchronize/hierarchy/{dimensionName}/{selectedSyncOption}/{outputToResultScreen}/{reAssignMembers}/{doSync}";
        if (dimensionName === undefined || dimensionName === null)
            throw new Error("The parameter 'dimensionName' must be defined.");
        url_ = url_.replace("{dimensionName}", encodeURIComponent("" + dimensionName));
        if (selectedSyncOption === undefined || selectedSyncOption === null)
            throw new Error("The parameter 'selectedSyncOption' must be defined.");
        url_ = url_.replace("{selectedSyncOption}", encodeURIComponent("" + selectedSyncOption));
        if (outputToResultScreen === undefined || outputToResultScreen === null)
            throw new Error("The parameter 'outputToResultScreen' must be defined.");
        url_ = url_.replace("{outputToResultScreen}", encodeURIComponent("" + outputToResultScreen));
        if (reAssignMembers === undefined || reAssignMembers === null)
            throw new Error("The parameter 'reAssignMembers' must be defined.");
        url_ = url_.replace("{reAssignMembers}", encodeURIComponent("" + reAssignMembers));
        if (doSync === undefined || doSync === null)
            throw new Error("The parameter 'doSync' must be defined.");
        url_ = url_.replace("{doSync}", encodeURIComponent("" + doSync));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("File", file.data, file.fileName ? file.fileName : "File");

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSynchronizeDimensionFromFile(_response));
        });
    }

    protected processSynchronizeDimensionFromFile(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    synchronizeHierarchyFromFile(dimensionName: string, hierarchyName: string, selectedSyncOption: HierarchySyncMode, outputToResultScreen: boolean, reAssignMembers: boolean, doSync: boolean, file?: FileParameter | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Metadata/synchronize/hierarchy/{dimensionName}/{hierarchyName}/{selectedSyncOption}/{outputToResultScreen}/{reAssignMembers}/{doSync}";
        if (dimensionName === undefined || dimensionName === null)
            throw new Error("The parameter 'dimensionName' must be defined.");
        url_ = url_.replace("{dimensionName}", encodeURIComponent("" + dimensionName));
        if (hierarchyName === undefined || hierarchyName === null)
            throw new Error("The parameter 'hierarchyName' must be defined.");
        url_ = url_.replace("{hierarchyName}", encodeURIComponent("" + hierarchyName));
        if (selectedSyncOption === undefined || selectedSyncOption === null)
            throw new Error("The parameter 'selectedSyncOption' must be defined.");
        url_ = url_.replace("{selectedSyncOption}", encodeURIComponent("" + selectedSyncOption));
        if (outputToResultScreen === undefined || outputToResultScreen === null)
            throw new Error("The parameter 'outputToResultScreen' must be defined.");
        url_ = url_.replace("{outputToResultScreen}", encodeURIComponent("" + outputToResultScreen));
        if (reAssignMembers === undefined || reAssignMembers === null)
            throw new Error("The parameter 'reAssignMembers' must be defined.");
        url_ = url_.replace("{reAssignMembers}", encodeURIComponent("" + reAssignMembers));
        if (doSync === undefined || doSync === null)
            throw new Error("The parameter 'doSync' must be defined.");
        url_ = url_.replace("{doSync}", encodeURIComponent("" + doSync));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("File", file.data, file.fileName ? file.fileName : "File");

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSynchronizeHierarchyFromFile(_response));
        });
    }

    protected processSynchronizeHierarchyFromFile(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    deleteClientDimTable(): Promise<void> {
        let url_ = this.baseUrl + "/Metadata/synchronize";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteClientDimTable(_response));
        });
    }

    protected processDeleteClientDimTable(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getActionTable(dimensionName: string, hierarchyName: string): Promise<DataImportActionResult> {
        let url_ = this.baseUrl + "/Metadata/action/hierarchy/{dimensionName}/{hierarchyName}";
        if (dimensionName === undefined || dimensionName === null)
            throw new Error("The parameter 'dimensionName' must be defined.");
        url_ = url_.replace("{dimensionName}", encodeURIComponent("" + dimensionName));
        if (hierarchyName === undefined || hierarchyName === null)
            throw new Error("The parameter 'hierarchyName' must be defined.");
        url_ = url_.replace("{hierarchyName}", encodeURIComponent("" + hierarchyName));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetActionTable(_response));
        });
    }

    protected processGetActionTable(response: Response): Promise<DataImportActionResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DataImportActionResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DataImportActionResult>(null as any);
    }

    exportDataImportResult(dimensionName: string, reAssignMembers: boolean, format?: string | null | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/Metadata/syncexport/{dimensionName}/{reAssignMembers}?";
        if (dimensionName === undefined || dimensionName === null)
            throw new Error("The parameter 'dimensionName' must be defined.");
        url_ = url_.replace("{dimensionName}", encodeURIComponent("" + dimensionName));
        if (reAssignMembers === undefined || reAssignMembers === null)
            throw new Error("The parameter 'reAssignMembers' must be defined.");
        url_ = url_.replace("{reAssignMembers}", encodeURIComponent("" + reAssignMembers));
        if (format !== undefined && format !== null)
            url_ += "format=" + encodeURIComponent("" + format) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExportDataImportResult(_response));
        });
    }

    protected processExportDataImportResult(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    exportMemberInfoResult(dimensionName: string, hierarchyName: string, memberName: string, baseKey: number, format?: string | null | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/Metadata/exportmemberinfo/{dimensionName}/{hierarchyName}/{memberName}/{baseKey}?";
        if (dimensionName === undefined || dimensionName === null)
            throw new Error("The parameter 'dimensionName' must be defined.");
        url_ = url_.replace("{dimensionName}", encodeURIComponent("" + dimensionName));
        if (hierarchyName === undefined || hierarchyName === null)
            throw new Error("The parameter 'hierarchyName' must be defined.");
        url_ = url_.replace("{hierarchyName}", encodeURIComponent("" + hierarchyName));
        if (memberName === undefined || memberName === null)
            throw new Error("The parameter 'memberName' must be defined.");
        url_ = url_.replace("{memberName}", encodeURIComponent("" + memberName));
        if (baseKey === undefined || baseKey === null)
            throw new Error("The parameter 'baseKey' must be defined.");
        url_ = url_.replace("{baseKey}", encodeURIComponent("" + baseKey));
        if (format !== undefined && format !== null)
            url_ += "format=" + encodeURIComponent("" + format) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExportMemberInfoResult(_response));
        });
    }

    protected processExportMemberInfoResult(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    exportFile(processRunId?: string | undefined, activityRunId?: string | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/Metadata/file?";
        if (processRunId === null)
            throw new Error("The parameter 'processRunId' cannot be null.");
        else if (processRunId !== undefined)
            url_ += "processRunId=" + encodeURIComponent("" + processRunId) + "&";
        if (activityRunId === null)
            throw new Error("The parameter 'activityRunId' cannot be null.");
        else if (activityRunId !== undefined)
            url_ += "activityRunId=" + encodeURIComponent("" + activityRunId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExportFile(_response));
        });
    }

    protected processExportFile(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    importFile(processRunId?: string | undefined, activityRunId?: string | undefined, file?: FileParameter | null | undefined): Promise<number> {
        let url_ = this.baseUrl + "/Metadata/file?";
        if (processRunId === null)
            throw new Error("The parameter 'processRunId' cannot be null.");
        else if (processRunId !== undefined)
            url_ += "processRunId=" + encodeURIComponent("" + processRunId) + "&";
        if (activityRunId === null)
            throw new Error("The parameter 'activityRunId' cannot be null.");
        else if (activityRunId !== undefined)
            url_ += "activityRunId=" + encodeURIComponent("" + activityRunId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("File", file.data, file.fileName ? file.fileName : "File");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processImportFile(_response));
        });
    }

    protected processImportFile(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    exportTemplate(processRunId?: string | undefined, activityRunId?: string | undefined, fileTypeString?: string | null | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/Metadata/file/template?";
        if (processRunId === null)
            throw new Error("The parameter 'processRunId' cannot be null.");
        else if (processRunId !== undefined)
            url_ += "processRunId=" + encodeURIComponent("" + processRunId) + "&";
        if (activityRunId === null)
            throw new Error("The parameter 'activityRunId' cannot be null.");
        else if (activityRunId !== undefined)
            url_ += "activityRunId=" + encodeURIComponent("" + activityRunId) + "&";
        if (fileTypeString !== undefined && fileTypeString !== null)
            url_ += "fileTypeString=" + encodeURIComponent("" + fileTypeString) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExportTemplate(_response));
        });
    }

    protected processExportTemplate(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    publishAnalysisServicesModel(modelName: string): Promise<void> {
        let url_ = this.baseUrl + "/Metadata/as/{modelName}/publish";
        if (modelName === undefined || modelName === null)
            throw new Error("The parameter 'modelName' must be defined.");
        url_ = url_.replace("{modelName}", encodeURIComponent("" + modelName));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processPublishAnalysisServicesModel(_response));
        });
    }

    protected processPublishAnalysisServicesModel(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Refresh SSAS Model Data
     */
    refreshAnalysisServicesModel(modelName: string): Promise<void> {
        let url_ = this.baseUrl + "/Metadata/as/{modelName}/refresh";
        if (modelName === undefined || modelName === null)
            throw new Error("The parameter 'modelName' must be defined.");
        url_ = url_.replace("{modelName}", encodeURIComponent("" + modelName));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRefreshAnalysisServicesModel(_response));
        });
    }

    protected processRefreshAnalysisServicesModel(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Refresh SSAS Model Security that includes users and roles.
     */
    refreshAnalysisServicesModelSecurity(modelName: string): Promise<void> {
        let url_ = this.baseUrl + "/Metadata/as/{modelName}/refreshsecurity";
        if (modelName === undefined || modelName === null)
            throw new Error("The parameter 'modelName' must be defined.");
        url_ = url_.replace("{modelName}", encodeURIComponent("" + modelName));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRefreshAnalysisServicesModelSecurity(_response));
        });
    }

    protected processRefreshAnalysisServicesModelSecurity(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getDatabaseSchemas(): Promise<string[]> {
        let url_ = this.baseUrl + "/Metadata/database/schemas";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDatabaseSchemas(_response));
        });
    }

    protected processGetDatabaseSchemas(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(resultData200[item]);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }

    getDatabaseTables(): Promise<SimpleKeyValue[]> {
        let url_ = this.baseUrl + "/Metadata/database/tables";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDatabaseTables(_response));
        });
    }

    protected processGetDatabaseTables(response: Response): Promise<SimpleKeyValue[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(SimpleKeyValue.fromJS(resultData200[item]));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SimpleKeyValue[]>(null as any);
    }

    getLists(): Promise<ListInfo[]> {
        let url_ = this.baseUrl + "/Metadata/list";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetLists(_response));
        });
    }

    protected processGetLists(response: Response): Promise<ListInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(ListInfo.fromJS(resultData200[item]));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ListInfo[]>(null as any);
    }

    createList(list: ListInfo): Promise<number> {
        let url_ = this.baseUrl + "/Metadata/list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(list);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateList(_response));
        });
    }

    protected processCreateList(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result201 = resultData201 !== undefined ? resultData201 : <any>null;
    
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    getListContents(listID: number): Promise<{ [key: string]: any; }[]> {
        let url_ = this.baseUrl + "/Metadata/list/contents/{listID}";
        if (listID === undefined || listID === null)
            throw new Error("The parameter 'listID' must be defined.");
        url_ = url_.replace("{listID}", encodeURIComponent("" + listID));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetListContents(_response));
        });
    }

    protected processGetListContents(response: Response): Promise<{ [key: string]: any; }[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(resultData200[item]);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<{ [key: string]: any; }[]>(null as any);
    }

    deleteListContents(listID: number, contents: { [key: string]: any; }[]): Promise<void> {
        let url_ = this.baseUrl + "/Metadata/list/contents/{listID}";
        if (listID === undefined || listID === null)
            throw new Error("The parameter 'listID' must be defined.");
        url_ = url_.replace("{listID}", encodeURIComponent("" + listID));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(contents);

        let options_: RequestInit = {
            body: content_,
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteListContents(_response));
        });
    }

    protected processDeleteListContents(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    updateListContents(listID: number, contents: { [key: string]: any; }[]): Promise<void> {
        let url_ = this.baseUrl + "/Metadata/list/contents/{listID}";
        if (listID === undefined || listID === null)
            throw new Error("The parameter 'listID' must be defined.");
        url_ = url_.replace("{listID}", encodeURIComponent("" + listID));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(contents);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateListContents(_response));
        });
    }

    protected processUpdateListContents(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getListDetails(): Promise<ListDetailsInfo[]> {
        let url_ = this.baseUrl + "/Metadata/list/details";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetListDetails(_response));
        });
    }

    protected processGetListDetails(response: Response): Promise<ListDetailsInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(ListDetailsInfo.fromJS(resultData200[item]));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ListDetailsInfo[]>(null as any);
    }

    createListDetails(listDetails: ListDetailsInfo): Promise<number> {
        let url_ = this.baseUrl + "/Metadata/list/details";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(listDetails);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateListDetails(_response));
        });
    }

    protected processCreateListDetails(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result201 = resultData201 !== undefined ? resultData201 : <any>null;
    
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    deleteListDetails(listID: number): Promise<void> {
        let url_ = this.baseUrl + "/Metadata/list/details/{listID}";
        if (listID === undefined || listID === null)
            throw new Error("The parameter 'listID' must be defined.");
        url_ = url_.replace("{listID}", encodeURIComponent("" + listID));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteListDetails(_response));
        });
    }

    protected processDeleteListDetails(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getListPropertyDetails(): Promise<ListPropertyDetailsInfo[]> {
        let url_ = this.baseUrl + "/Metadata/list/propertydetails";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetListPropertyDetails(_response));
        });
    }

    protected processGetListPropertyDetails(response: Response): Promise<ListPropertyDetailsInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(ListPropertyDetailsInfo.fromJS(resultData200[item]));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ListPropertyDetailsInfo[]>(null as any);
    }

    createListPropertyDetails(listPropertyDetails: ListPropertyDetailsInfo): Promise<number> {
        let url_ = this.baseUrl + "/Metadata/list/propertydetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(listPropertyDetails);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateListPropertyDetails(_response));
        });
    }

    protected processCreateListPropertyDetails(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result201 = resultData201 !== undefined ? resultData201 : <any>null;
    
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    deleteListPropertyDetails(propertyID: number): Promise<void> {
        let url_ = this.baseUrl + "/Metadata/list/propertydetails/{propertyID}";
        if (propertyID === undefined || propertyID === null)
            throw new Error("The parameter 'propertyID' must be defined.");
        url_ = url_.replace("{propertyID}", encodeURIComponent("" + propertyID));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteListPropertyDetails(_response));
        });
    }

    protected processDeleteListPropertyDetails(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    createListProperties(listProperty: ListPropertyInfo): Promise<number> {
        let url_ = this.baseUrl + "/Metadata/list/listproperties";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(listProperty);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateListProperties(_response));
        });
    }

    protected processCreateListProperties(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result201 = resultData201 !== undefined ? resultData201 : <any>null;
    
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    deleteListProperty(id: number): Promise<void> {
        let url_ = this.baseUrl + "/Metadata/list/listproperties/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteListProperty(_response));
        });
    }

    protected processDeleteListProperty(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    consolidationCodeAutoGenerate(): Promise<void> {
        let url_ = this.baseUrl + "/Metadata/ConsolidationCodeAutoGenerate";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processConsolidationCodeAutoGenerate(_response));
        });
    }

    protected processConsolidationCodeAutoGenerate(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getDictionary(dictionary: string, language: string): Promise<{ [key: string]: string; }> {
        let url_ = this.baseUrl + "/Metadata/dictionary/{dictionary}/{language}";
        if (dictionary === undefined || dictionary === null)
            throw new Error("The parameter 'dictionary' must be defined.");
        url_ = url_.replace("{dictionary}", encodeURIComponent("" + dictionary));
        if (language === undefined || language === null)
            throw new Error("The parameter 'language' must be defined.");
        url_ = url_.replace("{language}", encodeURIComponent("" + language));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDictionary(_response));
        });
    }

    protected processGetDictionary(response: Response): Promise<{ [key: string]: string; }> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {} as any;
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        (<any>result200)![key] = resultData200[key] !== undefined ? resultData200[key] : <any>null;
                }
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<{ [key: string]: string; }>(null as any);
    }

    /**
     * Get all Extract Hierarchies from App_ExtractHierarchies table.
     */
    getAllExtractHierarchy(): Promise<ExtractHierarchyInfo[]> {
        let url_ = this.baseUrl + "/Metadata/extracthierarchy/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAllExtractHierarchy(_response));
        });
    }

    protected processGetAllExtractHierarchy(response: Response): Promise<ExtractHierarchyInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(ExtractHierarchyInfo.fromJS(resultData200[item]));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExtractHierarchyInfo[]>(null as any);
    }

    /**
     * Creates or updates a hierarchy extract.
     * @param extractHierarchy The extract hierarchy definition.
     * @param isEditMode (optional) Indicates if the extract is in edit mode (from FormRoute).
     */
    createHierarchyExtract(extractHierarchy: ExtractHierarchyDetail, isEditMode?: boolean | undefined): Promise<number> {
        let url_ = this.baseUrl + "/Metadata/hierarchyExtract?";
        if (isEditMode === null)
            throw new Error("The parameter 'isEditMode' cannot be null.");
        else if (isEditMode !== undefined)
            url_ += "isEditMode=" + encodeURIComponent("" + isEditMode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(extractHierarchy);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateHierarchyExtract(_response));
        });
    }

    protected processCreateHierarchyExtract(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    deleteHierarchyExtract(extractID: number): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/Metadata/hierarchyExtract/{extractID}";
        if (extractID === undefined || extractID === null)
            throw new Error("The parameter 'extractID' must be defined.");
        url_ = url_.replace("{extractID}", encodeURIComponent("" + extractID));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteHierarchyExtract(_response));
        });
    }

    protected processDeleteHierarchyExtract(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export class OfficeClient extends FluenceApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getReport(pathOrId: string): Promise<FileSystemObject> {
        let url_ = this.baseUrl + "/Office/{pathOrId}";
        if (pathOrId === undefined || pathOrId === null)
            throw new Error("The parameter 'pathOrId' must be defined.");
        url_ = url_.replace("{pathOrId}", encodeURIComponent("" + pathOrId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetReport(_response));
        });
    }

    protected processGetReport(response: Response): Promise<FileSystemObject> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileSystemObject.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileSystemObject>(null as any);
    }

    open(pathOrId: string, parameters: FormParameterCurrentValue[]): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/Office/{pathOrId}";
        if (pathOrId === undefined || pathOrId === null)
            throw new Error("The parameter 'pathOrId' must be defined.");
        url_ = url_.replace("{pathOrId}", encodeURIComponent("" + pathOrId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(parameters);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processOpen(_response));
        });
    }

    protected processOpen(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    getParameters(pathOrId: string): Promise<FormParameterList> {
        let url_ = this.baseUrl + "/Office/parameters/{pathOrId}";
        if (pathOrId === undefined || pathOrId === null)
            throw new Error("The parameter 'pathOrId' must be defined.");
        url_ = url_.replace("{pathOrId}", encodeURIComponent("" + pathOrId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetParameters(_response));
        });
    }

    protected processGetParameters(response: Response): Promise<FormParameterList> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FormParameterList.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FormParameterList>(null as any);
    }
}

export class PowerBIClient extends FluenceApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getEmbedInfo(idOrPath: string): Promise<PowerBIEmbedInfo> {
        let url_ = this.baseUrl + "/PowerBI/{idOrPath}";
        if (idOrPath === undefined || idOrPath === null)
            throw new Error("The parameter 'idOrPath' must be defined.");
        url_ = url_.replace("{idOrPath}", encodeURIComponent("" + idOrPath));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetEmbedInfo(_response));
        });
    }

    protected processGetEmbedInfo(response: Response): Promise<PowerBIEmbedInfo> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PowerBIEmbedInfo.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PowerBIEmbedInfo>(null as any);
    }
}

export class ProcessClient extends FluenceApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    load(path: string): Promise<Process> {
        let url_ = this.baseUrl + "/Process/{path}";
        if (path === undefined || path === null)
            throw new Error("The parameter 'path' must be defined.");
        url_ = url_.replace("{path}", encodeURIComponent("" + path));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processLoad(_response));
        });
    }

    protected processLoad(response: Response): Promise<Process> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Process.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Process>(null as any);
    }

    save(path: string, process: Process): Promise<void> {
        let url_ = this.baseUrl + "/Process/{path}";
        if (path === undefined || path === null)
            throw new Error("The parameter 'path' must be defined.");
        url_ = url_.replace("{path}", encodeURIComponent("" + path));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(process);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSave(_response));
        });
    }

    protected processSave(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    load2(path: string): Promise<Process> {
        let url_ = this.baseUrl + "/proces/{path}";
        if (path === undefined || path === null)
            throw new Error("The parameter 'path' must be defined.");
        url_ = url_.replace("{path}", encodeURIComponent("" + path));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processLoad2(_response));
        });
    }

    protected processLoad2(response: Response): Promise<Process> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Process.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Process>(null as any);
    }

    save2(path: string, process: Process): Promise<void> {
        let url_ = this.baseUrl + "/proces/{path}";
        if (path === undefined || path === null)
            throw new Error("The parameter 'path' must be defined.");
        url_ = url_.replace("{path}", encodeURIComponent("" + path));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(process);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSave2(_response));
        });
    }

    protected processSave2(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    loadInteractive(path: string): Promise<InteractiveProcess> {
        let url_ = this.baseUrl + "/Process/Interactive/{path}";
        if (path === undefined || path === null)
            throw new Error("The parameter 'path' must be defined.");
        url_ = url_.replace("{path}", encodeURIComponent("" + path));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processLoadInteractive(_response));
        });
    }

    protected processLoadInteractive(response: Response): Promise<InteractiveProcess> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InteractiveProcess.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InteractiveProcess>(null as any);
    }

    saveInteractive(path: string, process: InteractiveProcess): Promise<void> {
        let url_ = this.baseUrl + "/Process/Interactive/{path}";
        if (path === undefined || path === null)
            throw new Error("The parameter 'path' must be defined.");
        url_ = url_.replace("{path}", encodeURIComponent("" + path));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(process);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSaveInteractive(_response));
        });
    }

    protected processSaveInteractive(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    loadInteractive2(path: string): Promise<InteractiveProcess> {
        let url_ = this.baseUrl + "/proces/Interactive/{path}";
        if (path === undefined || path === null)
            throw new Error("The parameter 'path' must be defined.");
        url_ = url_.replace("{path}", encodeURIComponent("" + path));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processLoadInteractive2(_response));
        });
    }

    protected processLoadInteractive2(response: Response): Promise<InteractiveProcess> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InteractiveProcess.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InteractiveProcess>(null as any);
    }

    saveInteractive2(path: string, process: InteractiveProcess): Promise<void> {
        let url_ = this.baseUrl + "/proces/Interactive/{path}";
        if (path === undefined || path === null)
            throw new Error("The parameter 'path' must be defined.");
        url_ = url_.replace("{path}", encodeURIComponent("" + path));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(process);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSaveInteractive2(_response));
        });
    }

    protected processSaveInteractive2(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    fixInteractive(path: string): Promise<void> {
        let url_ = this.baseUrl + "/Process/FixInteractive/{path}";
        if (path === undefined || path === null)
            throw new Error("The parameter 'path' must be defined.");
        url_ = url_.replace("{path}", encodeURIComponent("" + path));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processFixInteractive(_response));
        });
    }

    protected processFixInteractive(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    fixInteractive2(path: string): Promise<void> {
        let url_ = this.baseUrl + "/proces/FixInteractive/{path}";
        if (path === undefined || path === null)
            throw new Error("The parameter 'path' must be defined.");
        url_ = url_.replace("{path}", encodeURIComponent("" + path));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processFixInteractive2(_response));
        });
    }

    protected processFixInteractive2(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getActivities(path: string): Promise<ProcessActivityExecutionState[]> {
        let url_ = this.baseUrl + "/Process/Activities/{path}";
        if (path === undefined || path === null)
            throw new Error("The parameter 'path' must be defined.");
        url_ = url_.replace("{path}", encodeURIComponent("" + path));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetActivities(_response));
        });
    }

    protected processGetActivities(response: Response): Promise<ProcessActivityExecutionState[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(ProcessActivityExecutionState.fromJS(resultData200[item]));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProcessActivityExecutionState[]>(null as any);
    }

    getActivities2(path: string): Promise<ProcessActivityExecutionState[]> {
        let url_ = this.baseUrl + "/proces/Activities/{path}";
        if (path === undefined || path === null)
            throw new Error("The parameter 'path' must be defined.");
        url_ = url_.replace("{path}", encodeURIComponent("" + path));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetActivities2(_response));
        });
    }

    protected processGetActivities2(response: Response): Promise<ProcessActivityExecutionState[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(ProcessActivityExecutionState.fromJS(resultData200[item]));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProcessActivityExecutionState[]>(null as any);
    }

    getMyActivities(): Promise<ProcessActivityExecutionState[]> {
        let url_ = this.baseUrl + "/Process/MyActivities";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetMyActivities(_response));
        });
    }

    protected processGetMyActivities(response: Response): Promise<ProcessActivityExecutionState[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(ProcessActivityExecutionState.fromJS(resultData200[item]));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProcessActivityExecutionState[]>(null as any);
    }

    getMyActivities2(): Promise<ProcessActivityExecutionState[]> {
        let url_ = this.baseUrl + "/proces/MyActivities";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetMyActivities2(_response));
        });
    }

    protected processGetMyActivities2(response: Response): Promise<ProcessActivityExecutionState[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(ProcessActivityExecutionState.fromJS(resultData200[item]));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProcessActivityExecutionState[]>(null as any);
    }

    getInteractiveProcessExecutionState(path: string): Promise<ProcessActivityExecutionState[]> {
        let url_ = this.baseUrl + "/Process/State/{path}";
        if (path === undefined || path === null)
            throw new Error("The parameter 'path' must be defined.");
        url_ = url_.replace("{path}", encodeURIComponent("" + path));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetInteractiveProcessExecutionState(_response));
        });
    }

    protected processGetInteractiveProcessExecutionState(response: Response): Promise<ProcessActivityExecutionState[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(ProcessActivityExecutionState.fromJS(resultData200[item]));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProcessActivityExecutionState[]>(null as any);
    }

    getInteractiveProcessExecutionState2(path: string): Promise<ProcessActivityExecutionState[]> {
        let url_ = this.baseUrl + "/proces/State/{path}";
        if (path === undefined || path === null)
            throw new Error("The parameter 'path' must be defined.");
        url_ = url_.replace("{path}", encodeURIComponent("" + path));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetInteractiveProcessExecutionState2(_response));
        });
    }

    protected processGetInteractiveProcessExecutionState2(response: Response): Promise<ProcessActivityExecutionState[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(ProcessActivityExecutionState.fromJS(resultData200[item]));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProcessActivityExecutionState[]>(null as any);
    }

    getActivityDetails(path: string, nodeId: string, processRunId?: string | null | undefined, activityRunId?: string | null | undefined): Promise<BaseProcessActivity> {
        let url_ = this.baseUrl + "/Process/ActivityDetails/{path}?";
        if (path === undefined || path === null)
            throw new Error("The parameter 'path' must be defined.");
        url_ = url_.replace("{path}", encodeURIComponent("" + path));
        if (processRunId !== undefined && processRunId !== null)
            url_ += "processRunId=" + encodeURIComponent("" + processRunId) + "&";
        if (activityRunId !== undefined && activityRunId !== null)
            url_ += "activityRunId=" + encodeURIComponent("" + activityRunId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(nodeId);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetActivityDetails(_response));
        });
    }

    protected processGetActivityDetails(response: Response): Promise<BaseProcessActivity> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseProcessActivity.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseProcessActivity>(null as any);
    }

    getActivityDetails2(path: string, nodeId: string, processRunId?: string | null | undefined, activityRunId?: string | null | undefined): Promise<BaseProcessActivity> {
        let url_ = this.baseUrl + "/proces/ActivityDetails/{path}?";
        if (path === undefined || path === null)
            throw new Error("The parameter 'path' must be defined.");
        url_ = url_.replace("{path}", encodeURIComponent("" + path));
        if (processRunId !== undefined && processRunId !== null)
            url_ += "processRunId=" + encodeURIComponent("" + processRunId) + "&";
        if (activityRunId !== undefined && activityRunId !== null)
            url_ += "activityRunId=" + encodeURIComponent("" + activityRunId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(nodeId);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetActivityDetails2(_response));
        });
    }

    protected processGetActivityDetails2(response: Response): Promise<BaseProcessActivity> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseProcessActivity.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseProcessActivity>(null as any);
    }

    getActivityLogs(path: string, processRunId?: string | null | undefined): Promise<RecentProcessRunLogs> {
        let url_ = this.baseUrl + "/Process/ActivityLogs/{path}?";
        if (path === undefined || path === null)
            throw new Error("The parameter 'path' must be defined.");
        url_ = url_.replace("{path}", encodeURIComponent("" + path));
        if (processRunId !== undefined && processRunId !== null)
            url_ += "processRunId=" + encodeURIComponent("" + processRunId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetActivityLogs(_response));
        });
    }

    protected processGetActivityLogs(response: Response): Promise<RecentProcessRunLogs> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RecentProcessRunLogs.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RecentProcessRunLogs>(null as any);
    }

    getActivityLogs2(path: string, processRunId?: string | null | undefined): Promise<RecentProcessRunLogs> {
        let url_ = this.baseUrl + "/proces/ActivityLogs/{path}?";
        if (path === undefined || path === null)
            throw new Error("The parameter 'path' must be defined.");
        url_ = url_.replace("{path}", encodeURIComponent("" + path));
        if (processRunId !== undefined && processRunId !== null)
            url_ += "processRunId=" + encodeURIComponent("" + processRunId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetActivityLogs2(_response));
        });
    }

    protected processGetActivityLogs2(response: Response): Promise<RecentProcessRunLogs> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RecentProcessRunLogs.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RecentProcessRunLogs>(null as any);
    }

    exportActivityLogs(path: string, processRunId?: string | null | undefined, offset?: number | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/Process/ExportActivityLogs/{path}?";
        if (path === undefined || path === null)
            throw new Error("The parameter 'path' must be defined.");
        url_ = url_.replace("{path}", encodeURIComponent("" + path));
        if (processRunId !== undefined && processRunId !== null)
            url_ += "processRunId=" + encodeURIComponent("" + processRunId) + "&";
        if (offset === null)
            throw new Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "offset=" + encodeURIComponent("" + offset) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExportActivityLogs(_response));
        });
    }

    protected processExportActivityLogs(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    exportActivityLogs2(path: string, processRunId?: string | null | undefined, offset?: number | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/proces/ExportActivityLogs/{path}?";
        if (path === undefined || path === null)
            throw new Error("The parameter 'path' must be defined.");
        url_ = url_.replace("{path}", encodeURIComponent("" + path));
        if (processRunId !== undefined && processRunId !== null)
            url_ += "processRunId=" + encodeURIComponent("" + processRunId) + "&";
        if (offset === null)
            throw new Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "offset=" + encodeURIComponent("" + offset) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExportActivityLogs2(_response));
        });
    }

    protected processExportActivityLogs2(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export class ProcessExecutionClient extends FluenceApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getProcessRunLogs(id: string): Promise<ProcessRun> {
        let url_ = this.baseUrl + "/ProcessExecution/Run/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetProcessRunLogs(_response));
        });
    }

    protected processGetProcessRunLogs(response: Response): Promise<ProcessRun> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProcessRun.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProcessRun>(null as any);
    }

    executeAnonymous(process: Process): Promise<string> {
        let url_ = this.baseUrl + "/ProcessExecution/ExecuteAnonymous";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(process);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExecuteAnonymous(_response));
        });
    }

    protected processExecuteAnonymous(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    executeFileSystem(path: string, options: string[][]): Promise<string> {
        let url_ = this.baseUrl + "/ProcessExecution/ExecuteFileSystem/{path}";
        if (path === undefined || path === null)
            throw new Error("The parameter 'path' must be defined.");
        url_ = url_.replace("{path}", encodeURIComponent("" + path));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(options);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExecuteFileSystem(_response));
        });
    }

    protected processExecuteFileSystem(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    executeInteractiveFileSystem(path: string, options: string[][], runId?: string | null | undefined): Promise<string> {
        let url_ = this.baseUrl + "/ProcessExecution/Interactive/ExecuteFileSystem/{path}?";
        if (path === undefined || path === null)
            throw new Error("The parameter 'path' must be defined.");
        url_ = url_.replace("{path}", encodeURIComponent("" + path));
        if (runId !== undefined && runId !== null)
            url_ += "runId=" + encodeURIComponent("" + runId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(options);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExecuteInteractiveFileSystem(_response));
        });
    }

    protected processExecuteInteractiveFileSystem(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    handleMessage(message: TopicActivityMessage): Promise<void> {
        let url_ = this.baseUrl + "/ProcessExecution/Interactive/HandleMessage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(message);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processHandleMessage(_response));
        });
    }

    protected processHandleMessage(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    setInteractiveActivityPercent(activityRunId: string, result: ActivityExecutionResultBase): Promise<void> {
        let url_ = this.baseUrl + "/ProcessExecution/SetInteractiveActivityPercent/{activityRunId}";
        if (activityRunId === undefined || activityRunId === null)
            throw new Error("The parameter 'activityRunId' must be defined.");
        url_ = url_.replace("{activityRunId}", encodeURIComponent("" + activityRunId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(result);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSetInteractiveActivityPercent(_response));
        });
    }

    protected processSetInteractiveActivityPercent(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    stopInteractiveProcess(processRunId: string): Promise<void> {
        let url_ = this.baseUrl + "/ProcessExecution/Stop/{processRunId}";
        if (processRunId === undefined || processRunId === null)
            throw new Error("The parameter 'processRunId' must be defined.");
        url_ = url_.replace("{processRunId}", encodeURIComponent("" + processRunId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processStopInteractiveProcess(_response));
        });
    }

    protected processStopInteractiveProcess(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    restartInteractiveProcessActivity(processRunId: string, nodeId: string, activityRunId?: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/ProcessExecution/Restart/{processRunId}/{nodeId}?";
        if (processRunId === undefined || processRunId === null)
            throw new Error("The parameter 'processRunId' must be defined.");
        url_ = url_.replace("{processRunId}", encodeURIComponent("" + processRunId));
        if (nodeId === undefined || nodeId === null)
            throw new Error("The parameter 'nodeId' must be defined.");
        url_ = url_.replace("{nodeId}", encodeURIComponent("" + nodeId));
        if (activityRunId === null)
            throw new Error("The parameter 'activityRunId' cannot be null.");
        else if (activityRunId !== undefined)
            url_ += "activityRunId=" + encodeURIComponent("" + activityRunId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRestartInteractiveProcessActivity(_response));
        });
    }

    protected processRestartInteractiveProcessActivity(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    stopAndRestartInteractiveProcessSubprocessActivity(processRunId: string, subprocessActivityRunId: string): Promise<void> {
        let url_ = this.baseUrl + "/ProcessExecution/RestartForeach/{processRunId}/{subprocessActivityRunId}";
        if (processRunId === undefined || processRunId === null)
            throw new Error("The parameter 'processRunId' must be defined.");
        url_ = url_.replace("{processRunId}", encodeURIComponent("" + processRunId));
        if (subprocessActivityRunId === undefined || subprocessActivityRunId === null)
            throw new Error("The parameter 'subprocessActivityRunId' must be defined.");
        url_ = url_.replace("{subprocessActivityRunId}", encodeURIComponent("" + subprocessActivityRunId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processStopAndRestartInteractiveProcessSubprocessActivity(_response));
        });
    }

    protected processStopAndRestartInteractiveProcessSubprocessActivity(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    setSchedule(schedule: ProcessSchedule[], path: string): Promise<void> {
        let url_ = this.baseUrl + "/ProcessExecution/Interactive/Schedule/{path}";
        if (path === undefined || path === null)
            throw new Error("The parameter 'path' must be defined.");
        url_ = url_.replace("{path}", encodeURIComponent("" + path));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(schedule);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSetSchedule(_response));
        });
    }

    protected processSetSchedule(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getSchedule(path: string): Promise<ProcessSchedule[]> {
        let url_ = this.baseUrl + "/ProcessExecution/Interactive/Schedule/{path}";
        if (path === undefined || path === null)
            throw new Error("The parameter 'path' must be defined.");
        url_ = url_.replace("{path}", encodeURIComponent("" + path));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSchedule(_response));
        });
    }

    protected processGetSchedule(response: Response): Promise<ProcessSchedule[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(ProcessSchedule.fromJS(resultData200[item]));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProcessSchedule[]>(null as any);
    }

    handleScheduleMessage(message: ProcessSchedule): Promise<void> {
        let url_ = this.baseUrl + "/ProcessExecution/Interactive/HandleScheduleMessage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(message);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processHandleScheduleMessage(_response));
        });
    }

    protected processHandleScheduleMessage(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getXl3InterpolatedParameters(pathOrId: string, processRunId?: string | undefined, activityRunId?: string | undefined): Promise<FormParameterCurrentValue[]> {
        let url_ = this.baseUrl + "/ProcessExecution/Interactive/Xl3Parameters/{pathOrId}?";
        if (pathOrId === undefined || pathOrId === null)
            throw new Error("The parameter 'pathOrId' must be defined.");
        url_ = url_.replace("{pathOrId}", encodeURIComponent("" + pathOrId));
        if (processRunId === null)
            throw new Error("The parameter 'processRunId' cannot be null.");
        else if (processRunId !== undefined)
            url_ += "processRunId=" + encodeURIComponent("" + processRunId) + "&";
        if (activityRunId === null)
            throw new Error("The parameter 'activityRunId' cannot be null.");
        else if (activityRunId !== undefined)
            url_ += "activityRunId=" + encodeURIComponent("" + activityRunId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetXl3InterpolatedParameters(_response));
        });
    }

    protected processGetXl3InterpolatedParameters(response: Response): Promise<FormParameterCurrentValue[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(FormParameterCurrentValue.fromJS(resultData200[item]));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FormParameterCurrentValue[]>(null as any);
    }

    getInterpolatedFormInteractiveActivityUrl(processRunId?: string | undefined, activityRunId?: string | undefined, url?: string | null | undefined): Promise<string> {
        let url_ = this.baseUrl + "/ProcessExecution/Interactive/GetInterpolatedFormInteractiveActivityUrl?";
        if (processRunId === null)
            throw new Error("The parameter 'processRunId' cannot be null.");
        else if (processRunId !== undefined)
            url_ += "processRunId=" + encodeURIComponent("" + processRunId) + "&";
        if (activityRunId === null)
            throw new Error("The parameter 'activityRunId' cannot be null.");
        else if (activityRunId !== undefined)
            url_ += "activityRunId=" + encodeURIComponent("" + activityRunId) + "&";
        if (url !== undefined && url !== null)
            url_ += "url=" + encodeURIComponent("" + url) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetInterpolatedFormInteractiveActivityUrl(_response));
        });
    }

    protected processGetInterpolatedFormInteractiveActivityUrl(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }
}

export class QueryClient extends FluenceApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    runDimensionQuery(dimensionQuery: string): Promise<QueryResult[]> {
        let url_ = this.baseUrl + "/Query/dimension";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dimensionQuery);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRunDimensionQuery(_response));
        });
    }

    protected processRunDimensionQuery(response: Response): Promise<QueryResult[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(QueryResult.fromJS(resultData200[item]));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryResult[]>(null as any);
    }

    runDimensionQueryCached(dimensionQuery: string): Promise<QueryResult[]> {
        let url_ = this.baseUrl + "/Query/dimension/cached";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dimensionQuery);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRunDimensionQueryCached(_response));
        });
    }

    protected processRunDimensionQueryCached(response: Response): Promise<QueryResult[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(QueryResult.fromJS(resultData200[item]));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryResult[]>(null as any);
    }

    runMultipleDimensionQueries(dimensionQueries: string[]): Promise<QueryResult[][]> {
        let url_ = this.baseUrl + "/Query/dimension/multiple";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dimensionQueries);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRunMultipleDimensionQueries(_response));
        });
    }

    protected processRunMultipleDimensionQueries(response: Response): Promise<QueryResult[][]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(resultData200[item]);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryResult[][]>(null as any);
    }

    runModelQuery(modelQuery: string): Promise<ModelQueryResult> {
        let url_ = this.baseUrl + "/Query/model";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(modelQuery);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRunModelQuery(_response));
        });
    }

    protected processRunModelQuery(response: Response): Promise<ModelQueryResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ModelQueryResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ModelQueryResult>(null as any);
    }

    runRelationalQuery(request: RelationalQueryRequest): Promise<RelationalQueryResult> {
        let url_ = this.baseUrl + "/Query/relational";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRunRelationalQuery(_response));
        });
    }

    protected processRunRelationalQuery(response: Response): Promise<RelationalQueryResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RelationalQueryResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RelationalQueryResult>(null as any);
    }

    runCalc(calcXml: string): Promise<void> {
        let url_ = this.baseUrl + "/Query/calc";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(calcXml);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRunCalc(_response));
        });
    }

    protected processRunCalc(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    runCalcFile(idOrPath: string, variables: string[], async?: boolean | null | undefined): Promise<CalcScriptResult> {
        let url_ = this.baseUrl + "/Query/calc/{idOrPath}?";
        if (idOrPath === undefined || idOrPath === null)
            throw new Error("The parameter 'idOrPath' must be defined.");
        url_ = url_.replace("{idOrPath}", encodeURIComponent("" + idOrPath));
        if (async !== undefined && async !== null)
            url_ += "async=" + encodeURIComponent("" + async) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(variables);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRunCalcFile(_response));
        });
    }

    protected processRunCalcFile(response: Response): Promise<CalcScriptResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CalcScriptResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CalcScriptResult>(null as any);
    }

    runDrillthroughQuery(query: string): Promise<RelationalQueryResult> {
        let url_ = this.baseUrl + "/Query/drillthrough";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRunDrillthroughQuery(_response));
        });
    }

    protected processRunDrillthroughQuery(response: Response): Promise<RelationalQueryResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RelationalQueryResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RelationalQueryResult>(null as any);
    }
}

export class ReportBookClient extends FluenceApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    loadDefinition(idOrPath: string): Promise<BookDefinition> {
        let url_ = this.baseUrl + "/ReportBook/definition/{idOrPath}";
        if (idOrPath === undefined || idOrPath === null)
            throw new Error("The parameter 'idOrPath' must be defined.");
        url_ = url_.replace("{idOrPath}", encodeURIComponent("" + idOrPath));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processLoadDefinition(_response));
        });
    }

    protected processLoadDefinition(response: Response): Promise<BookDefinition> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BookDefinition.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BookDefinition>(null as any);
    }

    saveDefinition(idOrPath: string, bookDefinition: BookDefinition): Promise<void> {
        let url_ = this.baseUrl + "/ReportBook/definition/{idOrPath}";
        if (idOrPath === undefined || idOrPath === null)
            throw new Error("The parameter 'idOrPath' must be defined.");
        url_ = url_.replace("{idOrPath}", encodeURIComponent("" + idOrPath));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(bookDefinition);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSaveDefinition(_response));
        });
    }

    protected processSaveDefinition(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    load(idOrPath: string): Promise<ReportBookItem> {
        let url_ = this.baseUrl + "/ReportBook/{idOrPath}";
        if (idOrPath === undefined || idOrPath === null)
            throw new Error("The parameter 'idOrPath' must be defined.");
        url_ = url_.replace("{idOrPath}", encodeURIComponent("" + idOrPath));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processLoad(_response));
        });
    }

    protected processLoad(response: Response): Promise<ReportBookItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReportBookItem.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReportBookItem>(null as any);
    }

    newEntry(idOrPath: string): Promise<ReportBookEntry> {
        let url_ = this.baseUrl + "/ReportBook/entry/{idOrPath}";
        if (idOrPath === undefined || idOrPath === null)
            throw new Error("The parameter 'idOrPath' must be defined.");
        url_ = url_.replace("{idOrPath}", encodeURIComponent("" + idOrPath));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processNewEntry(_response));
        });
    }

    protected processNewEntry(response: Response): Promise<ReportBookEntry> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReportBookEntry.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReportBookEntry>(null as any);
    }

    runReportBook(body: BookDefinitionAndCurrentParameters): Promise<FileSystemChangeNotification[]> {
        let url_ = this.baseUrl + "/ReportBook/run";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRunReportBook(_response));
        });
    }

    protected processRunReportBook(response: Response): Promise<FileSystemChangeNotification[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(FileSystemChangeNotification.fromJS(resultData200[item]));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileSystemChangeNotification[]>(null as any);
    }

    runReportBook2(idOrPath: string, output?: BookOutput | null | undefined, destination?: string | null | undefined, parameters?: FormParameterCurrentValue[] | undefined): Promise<FileSystemChangeNotification[]> {
        let url_ = this.baseUrl + "/ReportBook/run/{idOrPath}?";
        if (idOrPath === undefined || idOrPath === null)
            throw new Error("The parameter 'idOrPath' must be defined.");
        url_ = url_.replace("{idOrPath}", encodeURIComponent("" + idOrPath));
        if (output !== undefined && output !== null)
            url_ += "output=" + encodeURIComponent("" + output) + "&";
        if (destination !== undefined && destination !== null)
            url_ += "destination=" + encodeURIComponent("" + destination) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(parameters);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRunReportBook2(_response));
        });
    }

    protected processRunReportBook2(response: Response): Promise<FileSystemChangeNotification[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(FileSystemChangeNotification.fromJS(resultData200[item]));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileSystemChangeNotification[]>(null as any);
    }
}

export class RoleClient extends FluenceApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getRoles(): Promise<RoleObject[]> {
        let url_ = this.baseUrl + "/Role";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetRoles(_response));
        });
    }

    protected processGetRoles(response: Response): Promise<RoleObject[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(RoleObject.fromJS(resultData200[item]));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RoleObject[]>(null as any);
    }

    getRoleDetails(): Promise<RoleObject[]> {
        let url_ = this.baseUrl + "/Role/details";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetRoleDetails(_response));
        });
    }

    protected processGetRoleDetails(response: Response): Promise<RoleObject[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(RoleObject.fromJS(resultData200[item]));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RoleObject[]>(null as any);
    }

    addRole(roleName: string, newRole: RoleObject): Promise<RoleObject> {
        let url_ = this.baseUrl + "/Role/{roleName}";
        if (roleName === undefined || roleName === null)
            throw new Error("The parameter 'roleName' must be defined.");
        url_ = url_.replace("{roleName}", encodeURIComponent("" + roleName));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(newRole);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAddRole(_response));
        });
    }

    protected processAddRole(response: Response): Promise<RoleObject> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoleObject.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RoleObject>(null as any);
    }

    removeRole(roleName: string): Promise<void> {
        let url_ = this.baseUrl + "/Role/{roleName}";
        if (roleName === undefined || roleName === null)
            throw new Error("The parameter 'roleName' must be defined.");
        url_ = url_.replace("{roleName}", encodeURIComponent("" + roleName));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRemoveRole(_response));
        });
    }

    protected processRemoveRole(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    addUsersToRole(roleName: string, userObjects: UserObject[]): Promise<RoleObject> {
        let url_ = this.baseUrl + "/Role/AddUsers/{roleName}";
        if (roleName === undefined || roleName === null)
            throw new Error("The parameter 'roleName' must be defined.");
        url_ = url_.replace("{roleName}", encodeURIComponent("" + roleName));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(userObjects);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAddUsersToRole(_response));
        });
    }

    protected processAddUsersToRole(response: Response): Promise<RoleObject> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoleObject.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RoleObject>(null as any);
    }

    removeUsersFromRole(roleName: string, userObjects: UserObject[]): Promise<RoleObject> {
        let url_ = this.baseUrl + "/Role/RemoveUsers/{roleName}";
        if (roleName === undefined || roleName === null)
            throw new Error("The parameter 'roleName' must be defined.");
        url_ = url_.replace("{roleName}", encodeURIComponent("" + roleName));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(userObjects);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRemoveUsersFromRole(_response));
        });
    }

    protected processRemoveUsersFromRole(response: Response): Promise<RoleObject> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoleObject.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RoleObject>(null as any);
    }

    exportRolesToFile(roles: string[], format?: string | null | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/Role/roles/export?";
        if (format !== undefined && format !== null)
            url_ += "format=" + encodeURIComponent("" + format) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(roles);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExportRolesToFile(_response));
        });
    }

    protected processExportRolesToFile(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    importRoles(isAppend?: boolean | undefined, file?: FileParameter | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Role/roles/import?";
        if (isAppend === null)
            throw new Error("The parameter 'isAppend' cannot be null.");
        else if (isAppend !== undefined)
            url_ += "isAppend=" + encodeURIComponent("" + isAppend) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("File", file.data, file.fileName ? file.fileName : "File");

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processImportRoles(_response));
        });
    }

    protected processImportRoles(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class SecurityClient extends FluenceApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getUserImageOld(userName: string): Promise<string> {
        let url_ = this.baseUrl + "/Security/UserImage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(userName);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetUserImageOld(_response));
        });
    }

    protected processGetUserImageOld(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    setUserImage(file?: FileParameter | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Security/UserImage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("File", file.data, file.fileName ? file.fileName : "File");

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSetUserImage(_response));
        });
    }

    protected processSetUserImage(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getUserImage(userName: string): Promise<string> {
        let url_ = this.baseUrl + "/Security/UserImage/{userName}";
        if (userName === undefined || userName === null)
            throw new Error("The parameter 'userName' must be defined.");
        url_ = url_.replace("{userName}", encodeURIComponent("" + userName));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetUserImage(_response));
        });
    }

    protected processGetUserImage(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    getUserTenants(): Promise<Tenant[]> {
        let url_ = this.baseUrl + "/Security/UserTenants";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetUserTenants(_response));
        });
    }

    protected processGetUserTenants(response: Response): Promise<Tenant[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(Tenant.fromJS(resultData200[item]));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Tenant[]>(null as any);
    }

    validateToken(): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/Security/validate-token";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processValidateToken(_response));
        });
    }

    protected processValidateToken(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    exchangeToken(): Promise<FluenceToken> {
        let url_ = this.baseUrl + "/Security/exchange";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExchangeToken(_response));
        });
    }

    protected processExchangeToken(response: Response): Promise<FluenceToken> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FluenceToken.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FluenceToken>(null as any);
    }

    getUserData(): Promise<ExtendedUserData> {
        let url_ = this.baseUrl + "/Security/UserData";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetUserData(_response));
        });
    }

    protected processGetUserData(response: Response): Promise<ExtendedUserData> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExtendedUserData.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExtendedUserData>(null as any);
    }

    logout(): Promise<void> {
        let url_ = this.baseUrl + "/Security/Logout";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processLogout(_response));
        });
    }

    protected processLogout(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getDimensionSecurityProfiles(): Promise<string[]> {
        let url_ = this.baseUrl + "/Security/metadata/profiles";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDimensionSecurityProfiles(_response));
        });
    }

    protected processGetDimensionSecurityProfiles(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(resultData200[item]);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }

    createDimensionSecurityProfile(profileName: string, dimensionSecurity?: DimensionSecurity[] | undefined): Promise<number> {
        let url_ = this.baseUrl + "/Security/metadata/profiles/{profileName}";
        if (profileName === undefined || profileName === null)
            throw new Error("The parameter 'profileName' must be defined.");
        url_ = url_.replace("{profileName}", encodeURIComponent("" + profileName));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dimensionSecurity);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateDimensionSecurityProfile(_response));
        });
    }

    protected processCreateDimensionSecurityProfile(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result201 = resultData201 !== undefined ? resultData201 : <any>null;
    
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    deleteDimensionSecurityProfile(profileName: string): Promise<void> {
        let url_ = this.baseUrl + "/Security/metadata/profiles/{profileName}";
        if (profileName === undefined || profileName === null)
            throw new Error("The parameter 'profileName' must be defined.");
        url_ = url_.replace("{profileName}", encodeURIComponent("" + profileName));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteDimensionSecurityProfile(_response));
        });
    }

    protected processDeleteDimensionSecurityProfile(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getDimensionSecurity(profileName: string): Promise<DimensionSecurity[]> {
        let url_ = this.baseUrl + "/Security/metadata/dimension/{profileName}";
        if (profileName === undefined || profileName === null)
            throw new Error("The parameter 'profileName' must be defined.");
        url_ = url_.replace("{profileName}", encodeURIComponent("" + profileName));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDimensionSecurity(_response));
        });
    }

    protected processGetDimensionSecurity(response: Response): Promise<DimensionSecurity[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(DimensionSecurity.fromJS(resultData200[item]));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DimensionSecurity[]>(null as any);
    }

    updateDimensionSecurity(profileName: string, dimensionSecurity: DimensionSecurity[]): Promise<void> {
        let url_ = this.baseUrl + "/Security/metadata/dimension/{profileName}";
        if (profileName === undefined || profileName === null)
            throw new Error("The parameter 'profileName' must be defined.");
        url_ = url_.replace("{profileName}", encodeURIComponent("" + profileName));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dimensionSecurity);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateDimensionSecurity(_response));
        });
    }

    protected processUpdateDimensionSecurity(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getEffectiveModuleSecurity(): Promise<Module[]> {
        let url_ = this.baseUrl + "/Security/module/effective";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetEffectiveModuleSecurity(_response));
        });
    }

    protected processGetEffectiveModuleSecurity(response: Response): Promise<Module[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(Module.fromJS(resultData200[item]));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Module[]>(null as any);
    }

    getEffectiveModuleSecurityAsync2(): Promise<ModuleAccess[]> {
        let url_ = this.baseUrl + "/Security/module/effective2";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetEffectiveModuleSecurityAsync2(_response));
        });
    }

    protected processGetEffectiveModuleSecurityAsync2(response: Response): Promise<ModuleAccess[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(resultData200[item]);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ModuleAccess[]>(null as any);
    }

    getModuleList(): Promise<Module[]> {
        let url_ = this.baseUrl + "/Security/module/list";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetModuleList(_response));
        });
    }

    protected processGetModuleList(response: Response): Promise<Module[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(Module.fromJS(resultData200[item]));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Module[]>(null as any);
    }

    getModule(iD: number): Promise<Module> {
        let url_ = this.baseUrl + "/Security/module/{ID}";
        if (iD === undefined || iD === null)
            throw new Error("The parameter 'iD' must be defined.");
        url_ = url_.replace("{ID}", encodeURIComponent("" + iD));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetModule(_response));
        });
    }

    protected processGetModule(response: Response): Promise<Module> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Module.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Module>(null as any);
    }

    getRoleModuleSecurity(): Promise<ModuleSecurityInfo[]> {
        let url_ = this.baseUrl + "/Security/module/roles";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetRoleModuleSecurity(_response));
        });
    }

    protected processGetRoleModuleSecurity(response: Response): Promise<ModuleSecurityInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(ModuleSecurityInfo.fromJS(resultData200[item]));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ModuleSecurityInfo[]>(null as any);
    }

    setRoleModuleSecurity(securityInfo: ModuleSecurityInfo[]): Promise<void> {
        let url_ = this.baseUrl + "/Security/module/roles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(securityInfo);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSetRoleModuleSecurity(_response));
        });
    }

    protected processSetRoleModuleSecurity(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    exportRoleAuthorizations(exportRoleAuthInfo: ExportRoleAuthInfo, format?: string | null | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/Security/module/roles/export?";
        if (format !== undefined && format !== null)
            url_ += "format=" + encodeURIComponent("" + format) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(exportRoleAuthInfo);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExportRoleAuthorizations(_response));
        });
    }

    protected processExportRoleAuthorizations(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    importRoles(isAppend?: boolean | undefined, file?: FileParameter | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Security/module/roles/import?";
        if (isAppend === null)
            throw new Error("The parameter 'isAppend' cannot be null.");
        else if (isAppend !== undefined)
            url_ += "isAppend=" + encodeURIComponent("" + isAppend) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("File", file.data, file.fileName ? file.fileName : "File");

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processImportRoles(_response));
        });
    }

    protected processImportRoles(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getEffectiveFileSystemSecurity(): Promise<FileSystemSecurity> {
        let url_ = this.baseUrl + "/Security/filesystem/effective";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetEffectiveFileSystemSecurity(_response));
        });
    }

    protected processGetEffectiveFileSystemSecurity(response: Response): Promise<FileSystemSecurity> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileSystemSecurity.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileSystemSecurity>(null as any);
    }

    getRoleFileSystemSecurity(fileId: number): Promise<FileRoleSecurity[]> {
        let url_ = this.baseUrl + "/Security/filesystem/roles/{fileId}";
        if (fileId === undefined || fileId === null)
            throw new Error("The parameter 'fileId' must be defined.");
        url_ = url_.replace("{fileId}", encodeURIComponent("" + fileId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetRoleFileSystemSecurity(_response));
        });
    }

    protected processGetRoleFileSystemSecurity(response: Response): Promise<FileRoleSecurity[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(FileRoleSecurity.fromJS(resultData200[item]));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileRoleSecurity[]>(null as any);
    }

    setRoleFileSystemSecurity(fileId: number, securityInfo: FileRoleSecurity[]): Promise<void> {
        let url_ = this.baseUrl + "/Security/filesystem/roles/{fileId}";
        if (fileId === undefined || fileId === null)
            throw new Error("The parameter 'fileId' must be defined.");
        url_ = url_.replace("{fileId}", encodeURIComponent("" + fileId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(securityInfo);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSetRoleFileSystemSecurity(_response));
        });
    }

    protected processSetRoleFileSystemSecurity(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    releaseFormLock(id: number): Promise<void> {
        let url_ = this.baseUrl + "/Security/lock/form/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processReleaseFormLock(_response));
        });
    }

    protected processReleaseFormLock(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    setTenantBgColor(color?: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Security?";
        if (color !== undefined && color !== null)
            url_ += "color=" + encodeURIComponent("" + color) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSetTenantBgColor(_response));
        });
    }

    protected processSetTenantBgColor(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    exportSecurityProfilesToFile(profileName: string, csvDelim?: string | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/Security/securityprofile/export?";
        if (csvDelim === null)
            throw new Error("The parameter 'csvDelim' cannot be null.");
        else if (csvDelim !== undefined)
            url_ += "csvDelim=" + encodeURIComponent("" + csvDelim) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(profileName);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExportSecurityProfilesToFile(_response));
        });
    }

    protected processExportSecurityProfilesToFile(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    importSecurityProfiles(isAppend?: boolean | undefined, csvDelimiter?: string | undefined, file?: FileParameter | null | undefined): Promise<number> {
        let url_ = this.baseUrl + "/Security/securityprofile/import?";
        if (isAppend === null)
            throw new Error("The parameter 'isAppend' cannot be null.");
        else if (isAppend !== undefined)
            url_ += "isAppend=" + encodeURIComponent("" + isAppend) + "&";
        if (csvDelimiter === null)
            throw new Error("The parameter 'csvDelimiter' cannot be null.");
        else if (csvDelimiter !== undefined)
            url_ += "csvDelimiter=" + encodeURIComponent("" + csvDelimiter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("File", file.data, file.fileName ? file.fileName : "File");

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processImportSecurityProfiles(_response));
        });
    }

    protected processImportSecurityProfiles(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    securityProfilesCopyRole(profileName: string, copyFromId?: number | undefined, copyToId?: number | undefined): Promise<number> {
        let url_ = this.baseUrl + "/Security/securityprofile/copyrole?";
        if (copyFromId === null)
            throw new Error("The parameter 'copyFromId' cannot be null.");
        else if (copyFromId !== undefined)
            url_ += "copyFromId=" + encodeURIComponent("" + copyFromId) + "&";
        if (copyToId === null)
            throw new Error("The parameter 'copyToId' cannot be null.");
        else if (copyToId !== undefined)
            url_ += "copyToId=" + encodeURIComponent("" + copyToId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(profileName);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSecurityProfilesCopyRole(_response));
        });
    }

    protected processSecurityProfilesCopyRole(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    securityProfilesCopyProfile(copyFromProfile?: string | null | undefined, copyToProfile?: string | null | undefined): Promise<number> {
        let url_ = this.baseUrl + "/Security/securityprofile/copyprofile?";
        if (copyFromProfile !== undefined && copyFromProfile !== null)
            url_ += "copyFromProfile=" + encodeURIComponent("" + copyFromProfile) + "&";
        if (copyToProfile !== undefined && copyToProfile !== null)
            url_ += "copyToProfile=" + encodeURIComponent("" + copyToProfile) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSecurityProfilesCopyProfile(_response));
        });
    }

    protected processSecurityProfilesCopyProfile(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * Confluence documentation https://anaplansite.atlassian.net/wiki/x/iQE3OQE
     * @param request Migration request parameters
     */
    migrateConnectionStrings(request: MigrationRequest): Promise<any> {
        let url_ = this.baseUrl + "/Security/migrate-connection-strings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processMigrateConnectionStrings(_response));
        });
    }

    protected processMigrateConnectionStrings(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 202) {
            return response.text().then((_responseText) => {
            let result202: any = null;
            let resultData202 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result202 = resultData202 !== undefined ? resultData202 : <any>null;
    
            return result202;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result500 = resultData500 !== undefined ? resultData500 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(null as any);
    }

    /**
     * Returns the most recently started migration jobs (newest first). Useful
    from Postman when the jobId from the original POST has been lost.
     * @param take (optional) 
     */
    listMigrationJobs(take?: number | undefined): Promise<MigrationJob[]> {
        let url_ = this.baseUrl + "/Security/migrate-connection-strings?";
        if (take === null)
            throw new Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processListMigrationJobs(_response));
        });
    }

    protected processListMigrationJobs(response: Response): Promise<MigrationJob[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(MigrationJob.fromJS(resultData200[item]));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MigrationJob[]>(null as any);
    }

    /**
     * Returns the current state and (partial or final) result of a migration
    job started via POST /Security/migrate-connection-strings. While the job
    is running, the response includes the per-tenant results accumulated so
    far so callers can watch progress by polling.
     * @param jobId Identifier returned by the POST endpoint.
     */
    getMigrationJob(jobId: string): Promise<MigrationJob> {
        let url_ = this.baseUrl + "/Security/migrate-connection-strings/{jobId}";
        if (jobId === undefined || jobId === null)
            throw new Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetMigrationJob(_response));
        });
    }

    protected processGetMigrationJob(response: Response): Promise<MigrationJob> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MigrationJob.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MigrationJob>(null as any);
    }

    /**
     * Synchronously migrates a single tenant. Designed for two use cases:
      - Re-running individual tenants that failed in a previous bulk job.
      - Being driven by Postman's Collection Runner over a CSV/JSON list of
        tenant names when a fully-async flow is not desired.
            
    One tenant is small enough to comfortably complete within standard HTTP
    timeouts.
     * @param tenantName The tenant to migrate.
     * @param request Migration options (DryRun). TargetTenants is ignored.
     */
    migrateConnectionStringsForTenant(tenantName: string, request: MigrationRequest): Promise<MigrationResult> {
        let url_ = this.baseUrl + "/Security/migrate-connection-strings/tenant/{tenantName}";
        if (tenantName === undefined || tenantName === null)
            throw new Error("The parameter 'tenantName' must be defined.");
        url_ = url_.replace("{tenantName}", encodeURIComponent("" + tenantName));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processMigrateConnectionStringsForTenant(_response));
        });
    }

    protected processMigrateConnectionStringsForTenant(response: Response): Promise<MigrationResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MigrationResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 207) {
            return response.text().then((_responseText) => {
            let result207: any = null;
            let resultData207 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result207 = MigrationResult.fromJS(resultData207);
            return result207;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result500 = resultData500 !== undefined ? resultData500 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MigrationResult>(null as any);
    }

    userHasAllRequiredModuleAccess(keysSeparatedByComma?: string | null | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/Security/does-user-have-required-module-access?";
        if (keysSeparatedByComma !== undefined && keysSeparatedByComma !== null)
            url_ += "keysSeparatedByComma=" + encodeURIComponent("" + keysSeparatedByComma) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUserHasAllRequiredModuleAccess(_response));
        });
    }

    protected processUserHasAllRequiredModuleAccess(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    getRequiredModuleAccessByKey(keysSeparatedByComma?: string | null | undefined): Promise<{ [key: string]: boolean; }> {
        let url_ = this.baseUrl + "/Security/get-required-module-access-by-key?";
        if (keysSeparatedByComma !== undefined && keysSeparatedByComma !== null)
            url_ += "keysSeparatedByComma=" + encodeURIComponent("" + keysSeparatedByComma) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetRequiredModuleAccessByKey(_response));
        });
    }

    protected processGetRequiredModuleAccessByKey(response: Response): Promise<{ [key: string]: boolean; }> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {} as any;
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        (<any>result200)![key] = resultData200[key] !== undefined ? resultData200[key] : <any>null;
                }
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<{ [key: string]: boolean; }>(null as any);
    }
}

export class ServerDebugClient extends FluenceApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getServerDebugLogs(): Promise<string> {
        let url_ = this.baseUrl + "/ServerDebug/ServerDebugLogs";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetServerDebugLogs(_response));
        });
    }

    protected processGetServerDebugLogs(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }
}

export class SignalRClient extends FluenceApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getSignalRConfig(): Promise<SignalRConnfig> {
        let url_ = this.baseUrl + "/SignalR/GetSignalRConfig";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSignalRConfig(_response));
        });
    }

    protected processGetSignalRConfig(response: Response): Promise<SignalRConnfig> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SignalRConnfig.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SignalRConnfig>(null as any);
    }
}

export class SpDataClient extends FluenceApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getDataView(spName: string, dataSource?: string | null | undefined, parameters?: string[][] | null | undefined): Promise<TableData> {
        let url_ = this.baseUrl + "/SpData/{spName}?";
        if (spName === undefined || spName === null)
            throw new Error("The parameter 'spName' must be defined.");
        url_ = url_.replace("{spName}", encodeURIComponent("" + spName));
        if (dataSource !== undefined && dataSource !== null)
            url_ += "dataSource=" + encodeURIComponent("" + dataSource) + "&";
        if (parameters !== undefined && parameters !== null)
            parameters && parameters.forEach(item => { url_ += "parameters=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDataView(_response));
        });
    }

    protected processGetDataView(response: Response): Promise<TableData> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TableData.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TableData>(null as any);
    }

    getDataViewData(spName: string, parameters: string[][], dataSource?: string | null | undefined): Promise<TableData> {
        let url_ = this.baseUrl + "/SpData/data/{spName}?";
        if (spName === undefined || spName === null)
            throw new Error("The parameter 'spName' must be defined.");
        url_ = url_.replace("{spName}", encodeURIComponent("" + spName));
        if (dataSource !== undefined && dataSource !== null)
            url_ += "dataSource=" + encodeURIComponent("" + dataSource) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(parameters);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDataViewData(_response));
        });
    }

    protected processGetDataViewData(response: Response): Promise<TableData> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TableData.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TableData>(null as any);
    }
}

export class TestClient extends FluenceApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    get1(): Promise<string> {
        let url_ = this.baseUrl + "/Test/get1";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGet1(_response));
        });
    }

    protected processGet1(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    get2(): Promise<string> {
        let url_ = this.baseUrl + "/Test/get2";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGet2(_response));
        });
    }

    protected processGet2(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    ge3(): Promise<string> {
        let url_ = this.baseUrl + "/Test/get3";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGe3(_response));
        });
    }

    protected processGe3(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    getError(): Promise<string> {
        let url_ = this.baseUrl + "/Test";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetError(_response));
        });
    }

    protected processGetError(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }
}

export class ThemeClient extends FluenceApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getThemes(): Promise<ThemeInfo[]> {
        let url_ = this.baseUrl + "/Theme/themes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetThemes(_response));
        });
    }

    protected processGetThemes(response: Response): Promise<ThemeInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(ThemeInfo.fromJS(resultData200[item]));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ThemeInfo[]>(null as any);
    }

    getTheme(themeName: string): Promise<ThemeInfo> {
        let url_ = this.baseUrl + "/Theme/theme/{themeName}";
        if (themeName === undefined || themeName === null)
            throw new Error("The parameter 'themeName' must be defined.");
        url_ = url_.replace("{themeName}", encodeURIComponent("" + themeName));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetTheme(_response));
        });
    }

    protected processGetTheme(response: Response): Promise<ThemeInfo> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ThemeInfo.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ThemeInfo>(null as any);
    }

    updateTheme(themeName: string, request: any): Promise<void> {
        let url_ = this.baseUrl + "/Theme/theme/{themeName}";
        if (themeName === undefined || themeName === null)
            throw new Error("The parameter 'themeName' must be defined.");
        url_ = url_.replace("{themeName}", encodeURIComponent("" + themeName));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateTheme(_response));
        });
    }

    protected processUpdateTheme(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    createTheme(themeName: string | null, request: ThemeInfo): Promise<ThemeInfo> {
        let url_ = this.baseUrl + "/Theme/theme";
        if (themeName === undefined || themeName === null)
            throw new Error("The parameter 'themeName' must be defined.");
        url_ = url_.replace("{themeName}", encodeURIComponent("" + themeName));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateTheme(_response));
        });
    }

    protected processCreateTheme(response: Response): Promise<ThemeInfo> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = ThemeInfo.fromJS(resultData201);
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ThemeInfo>(null as any);
    }

    deleteTheme(themeName: string): Promise<void> {
        let url_ = this.baseUrl + "/Theme/model/{themeName}";
        if (themeName === undefined || themeName === null)
            throw new Error("The parameter 'themeName' must be defined.");
        url_ = url_.replace("{themeName}", encodeURIComponent("" + themeName));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteTheme(_response));
        });
    }

    protected processDeleteTheme(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class UserClient extends FluenceApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getUserDetails(): Promise<UserObject[]> {
        let url_ = this.baseUrl + "/User";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetUserDetails(_response));
        });
    }

    protected processGetUserDetails(response: Response): Promise<UserObject[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(UserObject.fromJS(resultData200[item]));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserObject[]>(null as any);
    }

    addUser(user: UserObject): Promise<SecureUserObject> {
        let url_ = this.baseUrl + "/User";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(user);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAddUser(_response));
        });
    }

    protected processAddUser(response: Response): Promise<SecureUserObject> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SecureUserObject.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SecureUserObject>(null as any);
    }

    editUser(user: UserObject): Promise<SecureUserObject> {
        let url_ = this.baseUrl + "/User";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(user);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processEditUser(_response));
        });
    }

    protected processEditUser(response: Response): Promise<SecureUserObject> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SecureUserObject.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SecureUserObject>(null as any);
    }

    getAllowedUserDomains(): Promise<string[]> {
        let url_ = this.baseUrl + "/User/Domains";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAllowedUserDomains(_response));
        });
    }

    protected processGetAllowedUserDomains(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(resultData200[item]);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }

    getUserShort(): Promise<UserDetailsShort[]> {
        let url_ = this.baseUrl + "/User/UsersShort";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetUserShort(_response));
        });
    }

    protected processGetUserShort(response: Response): Promise<UserDetailsShort[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(UserDetailsShort.fromJS(resultData200[item]));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserDetailsShort[]>(null as any);
    }

    getUserDetails2(userName: string): Promise<UserObject[]> {
        let url_ = this.baseUrl + "/User/{userName}";
        if (userName === undefined || userName === null)
            throw new Error("The parameter 'userName' must be defined.");
        url_ = url_.replace("{userName}", encodeURIComponent("" + userName));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetUserDetails2(_response));
        });
    }

    protected processGetUserDetails2(response: Response): Promise<UserObject[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(UserObject.fromJS(resultData200[item]));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserObject[]>(null as any);
    }

    removeUser(userName: string): Promise<void> {
        let url_ = this.baseUrl + "/User/{userName}";
        if (userName === undefined || userName === null)
            throw new Error("The parameter 'userName' must be defined.");
        url_ = url_.replace("{userName}", encodeURIComponent("" + userName));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRemoveUser(_response));
        });
    }

    protected processRemoveUser(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getLastLoginsInTenant(): Promise<UserObject[]> {
        let url_ = this.baseUrl + "/User/LoginDates";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetLastLoginsInTenant(_response));
        });
    }

    protected processGetLastLoginsInTenant(response: Response): Promise<UserObject[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(UserObject.fromJS(resultData200[item]));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserObject[]>(null as any);
    }

    getDateAdded(): Promise<UserObject[]> {
        let url_ = this.baseUrl + "/User/DatesAdded";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDateAdded(_response));
        });
    }

    protected processGetDateAdded(response: Response): Promise<UserObject[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(UserObject.fromJS(resultData200[item]));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserObject[]>(null as any);
    }

    export(): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/User/Export";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExport(_response));
        });
    }

    protected processExport(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    import(encodedCSVDelim?: string | null | undefined, file?: FileParameter | null | undefined): Promise<UserImportResult> {
        let url_ = this.baseUrl + "/User/Import?";
        if (encodedCSVDelim !== undefined && encodedCSVDelim !== null)
            url_ += "encodedCSVDelim=" + encodeURIComponent("" + encodedCSVDelim) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("File", file.data, file.fileName ? file.fileName : "File");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processImport(_response));
        });
    }

    protected processImport(response: Response): Promise<UserImportResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserImportResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserImportResult>(null as any);
    }

    bulkUserImport(users: UserObject[]): Promise<UserObject[]> {
        let url_ = this.baseUrl + "/User/BulkUserImport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(users);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBulkUserImport(_response));
        });
    }

    protected processBulkUserImport(response: Response): Promise<UserObject[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(UserObject.fromJS(resultData200[item]));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserObject[]>(null as any);
    }

    syncToActiveDirectory(): Promise<UserObject[]> {
        let url_ = this.baseUrl + "/User/SyncToActiveDirectory";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSyncToActiveDirectory(_response));
        });
    }

    protected processSyncToActiveDirectory(response: Response): Promise<UserObject[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(UserObject.fromJS(resultData200[item]));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserObject[]>(null as any);
    }

    syncTenant(): Promise<void> {
        let url_ = this.baseUrl + "/User/synctenant";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSyncTenant(_response));
        });
    }

    protected processSyncTenant(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getMyTokens(): Promise<ApiToken[]> {
        let url_ = this.baseUrl + "/User/ApiToken";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetMyTokens(_response));
        });
    }

    protected processGetMyTokens(response: Response): Promise<ApiToken[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(ApiToken.fromJS(resultData200[item]));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiToken[]>(null as any);
    }

    deleteMyToken(token: ApiToken): Promise<void> {
        let url_ = this.baseUrl + "/User/ApiToken";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(token);

        let options_: RequestInit = {
            body: content_,
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteMyToken(_response));
        });
    }

    protected processDeleteMyToken(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    saveMyToken(token: ApiToken): Promise<ApiToken> {
        let url_ = this.baseUrl + "/User/ApiToken";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(token);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSaveMyToken(_response));
        });
    }

    protected processSaveMyToken(response: Response): Promise<ApiToken> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiToken.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiToken>(null as any);
    }
}

export class WhatsNewClient extends FluenceApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getArticles(filter?: boolean | undefined): Promise<WhatsNewArticle[]> {
        let url_ = this.baseUrl + "/WhatsNew?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetArticles(_response));
        });
    }

    protected processGetArticles(response: Response): Promise<WhatsNewArticle[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(WhatsNewArticle.fromJS(resultData200[item]));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WhatsNewArticle[]>(null as any);
    }

    saveArticle(article: WhatsNewArticle): Promise<WhatsNewArticle> {
        let url_ = this.baseUrl + "/WhatsNew";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(article);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSaveArticle(_response));
        });
    }

    protected processSaveArticle(response: Response): Promise<WhatsNewArticle> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WhatsNewArticle.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WhatsNewArticle>(null as any);
    }

    deleteArticle(article: WhatsNewArticle): Promise<void> {
        let url_ = this.baseUrl + "/WhatsNew";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(article);

        let options_: RequestInit = {
            body: content_,
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteArticle(_response));
        });
    }

    protected processDeleteArticle(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class WriteClient extends FluenceApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    writeModelData(data: WritebackData): Promise<void> {
        let url_ = this.baseUrl + "/Write/model";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processWriteModelData(_response));
        });
    }

    protected processWriteModelData(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getSecurity(model: string): Promise<WritebackResolvedSecurity> {
        let url_ = this.baseUrl + "/Write/security/{model}";
        if (model === undefined || model === null)
            throw new Error("The parameter 'model' must be defined.");
        url_ = url_.replace("{model}", encodeURIComponent("" + model));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSecurity(_response));
        });
    }

    protected processGetSecurity(response: Response): Promise<WritebackResolvedSecurity> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WritebackResolvedSecurity.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WritebackResolvedSecurity>(null as any);
    }
}

export class XL3CommentsClient extends FluenceApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getCubeComment(commentID?: number | undefined): Promise<string> {
        let url_ = this.baseUrl + "/XL3Comments/CubeCommentById?";
        if (commentID === null)
            throw new Error("The parameter 'commentID' cannot be null.");
        else if (commentID !== undefined)
            url_ += "CommentID=" + encodeURIComponent("" + commentID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetCubeComment(_response));
        });
    }

    protected processGetCubeComment(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    addCubeComment(model: AddCubeCommentModel): Promise<number> {
        let url_ = this.baseUrl + "/XL3Comments/CubeComment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAddCubeComment(_response));
        });
    }

    protected processAddCubeComment(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    updateCubeComment(commentXml: string): Promise<void> {
        let url_ = this.baseUrl + "/XL3Comments/CubeComment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(commentXml);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateCubeComment(_response));
        });
    }

    protected processUpdateCubeComment(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    deleteCubeComment(nCommentID?: number | undefined): Promise<void> {
        let url_ = this.baseUrl + "/XL3Comments/CubeComment?";
        if (nCommentID === null)
            throw new Error("The parameter 'nCommentID' cannot be null.");
        else if (nCommentID !== undefined)
            url_ += "nCommentID=" + encodeURIComponent("" + nCommentID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteCubeComment(_response));
        });
    }

    protected processDeleteCubeComment(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getCubeComments(connectionKey?: string | null | undefined, gridMemberXml?: string | null | undefined, includeDescs?: boolean | undefined, mergeComments?: boolean | undefined): Promise<string> {
        let url_ = this.baseUrl + "/XL3Comments/CubeComment?";
        if (connectionKey !== undefined && connectionKey !== null)
            url_ += "connectionKey=" + encodeURIComponent("" + connectionKey) + "&";
        if (gridMemberXml !== undefined && gridMemberXml !== null)
            url_ += "gridMemberXml=" + encodeURIComponent("" + gridMemberXml) + "&";
        if (includeDescs === null)
            throw new Error("The parameter 'includeDescs' cannot be null.");
        else if (includeDescs !== undefined)
            url_ += "includeDescs=" + encodeURIComponent("" + includeDescs) + "&";
        if (mergeComments === null)
            throw new Error("The parameter 'mergeComments' cannot be null.");
        else if (mergeComments !== undefined)
            url_ += "mergeComments=" + encodeURIComponent("" + mergeComments) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetCubeComments(_response));
        });
    }

    protected processGetCubeComments(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    getCubeCommentsByKey(model: CubeCommentsByKeyModel): Promise<string> {
        let url_ = this.baseUrl + "/XL3Comments/CubeCommentByKey";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetCubeCommentsByKey(_response));
        });
    }

    protected processGetCubeCommentsByKey(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    getCubeCommentsWithDescByKey(model: GetCubeCommentsWithDescByKeyModel, mergeComments?: boolean | undefined, exactMatch?: boolean | undefined): Promise<string> {
        let url_ = this.baseUrl + "/XL3Comments/CubeCommentsWithDescByKey?";
        if (mergeComments === null)
            throw new Error("The parameter 'mergeComments' cannot be null.");
        else if (mergeComments !== undefined)
            url_ += "mergeComments=" + encodeURIComponent("" + mergeComments) + "&";
        if (exactMatch === null)
            throw new Error("The parameter 'exactMatch' cannot be null.");
        else if (exactMatch !== undefined)
            url_ += "exactMatch=" + encodeURIComponent("" + exactMatch) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetCubeCommentsWithDescByKey(_response));
        });
    }

    protected processGetCubeCommentsWithDescByKey(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    searchCubeComments(searchTerms: TupleOfStringAndStringAndString[], additionalKey?: string | null | undefined, dtCreatedFrom?: Date | undefined, dtCreatedTo?: Date | undefined, dtUpdatedFrom?: Date | undefined, dtUpdatedTo?: Date | undefined): Promise<string> {
        let url_ = this.baseUrl + "/XL3Comments/SearchCubeComments?";
        if (additionalKey !== undefined && additionalKey !== null)
            url_ += "additionalKey=" + encodeURIComponent("" + additionalKey) + "&";
        if (dtCreatedFrom === null)
            throw new Error("The parameter 'dtCreatedFrom' cannot be null.");
        else if (dtCreatedFrom !== undefined)
            url_ += "dtCreatedFrom=" + encodeURIComponent(dtCreatedFrom ? "" + dtCreatedFrom.toISOString() : "") + "&";
        if (dtCreatedTo === null)
            throw new Error("The parameter 'dtCreatedTo' cannot be null.");
        else if (dtCreatedTo !== undefined)
            url_ += "dtCreatedTo=" + encodeURIComponent(dtCreatedTo ? "" + dtCreatedTo.toISOString() : "") + "&";
        if (dtUpdatedFrom === null)
            throw new Error("The parameter 'dtUpdatedFrom' cannot be null.");
        else if (dtUpdatedFrom !== undefined)
            url_ += "dtUpdatedFrom=" + encodeURIComponent(dtUpdatedFrom ? "" + dtUpdatedFrom.toISOString() : "") + "&";
        if (dtUpdatedTo === null)
            throw new Error("The parameter 'dtUpdatedTo' cannot be null.");
        else if (dtUpdatedTo !== undefined)
            url_ += "dtUpdatedTo=" + encodeURIComponent(dtUpdatedTo ? "" + dtUpdatedTo.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchTerms);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSearchCubeComments(_response));
        });
    }

    protected processSearchCubeComments(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    getTaggableUsers(): Promise<any[]> {
        let url_ = this.baseUrl + "/XL3Comments/Tags";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetTaggableUsers(_response));
        });
    }

    protected processGetTaggableUsers(response: Response): Promise<any[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(resultData200[item]);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any[]>(null as any);
    }

    getCubeCommentPermission(): Promise<string> {
        let url_ = this.baseUrl + "/XL3Comments/CubeCommentPermission";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetCubeCommentPermission(_response));
        });
    }

    protected processGetCubeCommentPermission(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    getCubeCommentHistory(nCommentID?: number | undefined): Promise<string> {
        let url_ = this.baseUrl + "/XL3Comments/CubeCommentHistory?";
        if (nCommentID === null)
            throw new Error("The parameter 'nCommentID' cannot be null.");
        else if (nCommentID !== undefined)
            url_ += "nCommentID=" + encodeURIComponent("" + nCommentID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetCubeCommentHistory(_response));
        });
    }

    protected processGetCubeCommentHistory(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    addCubeCommentAttachment(data: string, name?: string | null | undefined, commentID?: number | undefined): Promise<void> {
        let url_ = this.baseUrl + "/XL3Comments/CubeCommentAttachment?";
        if (name !== undefined && name !== null)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        if (commentID === null)
            throw new Error("The parameter 'commentID' cannot be null.");
        else if (commentID !== undefined)
            url_ += "commentID=" + encodeURIComponent("" + commentID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAddCubeCommentAttachment(_response));
        });
    }

    protected processAddCubeCommentAttachment(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getCubeCommentAttachment(commentID?: number | undefined, attachmentID?: number | undefined): Promise<string> {
        let url_ = this.baseUrl + "/XL3Comments/CubeCommentAttachment?";
        if (commentID === null)
            throw new Error("The parameter 'commentID' cannot be null.");
        else if (commentID !== undefined)
            url_ += "commentID=" + encodeURIComponent("" + commentID) + "&";
        if (attachmentID === null)
            throw new Error("The parameter 'attachmentID' cannot be null.");
        else if (attachmentID !== undefined)
            url_ += "attachmentID=" + encodeURIComponent("" + attachmentID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetCubeCommentAttachment(_response));
        });
    }

    protected processGetCubeCommentAttachment(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    deleteCubeCommentAttachment(commentID?: number | undefined, attachmentID?: number | undefined): Promise<void> {
        let url_ = this.baseUrl + "/XL3Comments/CubeCommentAttachment?";
        if (commentID === null)
            throw new Error("The parameter 'commentID' cannot be null.");
        else if (commentID !== undefined)
            url_ += "commentID=" + encodeURIComponent("" + commentID) + "&";
        if (attachmentID === null)
            throw new Error("The parameter 'attachmentID' cannot be null.");
        else if (attachmentID !== undefined)
            url_ += "attachmentID=" + encodeURIComponent("" + attachmentID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteCubeCommentAttachment(_response));
        });
    }

    protected processDeleteCubeCommentAttachment(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class RootClient extends FluenceApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    get(): Promise<string[]> {
        let url_ = this.baseUrl + "/";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGet(_response));
        });
    }

    protected processGet(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(resultData200[item]);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }

    getVersionInfo(): Promise<string> {
        let url_ = this.baseUrl + "/version";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetVersionInfo(_response));
        });
    }

    protected processGetVersionInfo(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }
}

export class Client extends FluenceApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getDimensions(): Promise<void> {
        let url_ = this.baseUrl + "/api/v2305.1/metadata/dimensions";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDimensions(_response));
        });
    }

    protected processGetDimensions(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getDimensionMembers(dimensionName: string, page?: number | undefined, pageSize?: number | undefined, format?: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/v2305.1/metadata/dimensions/{dimensionName}?";
        if (dimensionName === undefined || dimensionName === null)
            throw new Error("The parameter 'dimensionName' must be defined.");
        url_ = url_.replace("{dimensionName}", encodeURIComponent("" + dimensionName));
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "format": format !== undefined && format !== null ? "" + format : "",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDimensionMembers(_response));
        });
    }

    protected processGetDimensionMembers(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getModelDimensionMembers(modelName: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v2305.1/metadata/models/{modelName}/dimensions";
        if (modelName === undefined || modelName === null)
            throw new Error("The parameter 'modelName' must be defined.");
        url_ = url_.replace("{modelName}", encodeURIComponent("" + modelName));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetModelDimensionMembers(_response));
        });
    }

    protected processGetModelDimensionMembers(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getOData(table: string): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/v2305.1/odata/{table}";
        if (table === undefined || table === null)
            throw new Error("The parameter 'table' must be defined.");
        url_ = url_.replace("{table}", encodeURIComponent("" + table));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetOData(_response));
        });
    }

    protected processGetOData(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    postOData(table: string, item: Item): Promise<void> {
        let url_ = this.baseUrl + "/api/v2305.1/odata/{table}";
        if (table === undefined || table === null)
            throw new Error("The parameter 'table' must be defined.");
        url_ = url_.replace("{table}", encodeURIComponent("" + table));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(item);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processPostOData(_response));
        });
    }

    protected processPostOData(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    putOData(table: string, item: Item2): Promise<void> {
        let url_ = this.baseUrl + "/api/v2305.1/odata/{table}";
        if (table === undefined || table === null)
            throw new Error("The parameter 'table' must be defined.");
        url_ = url_.replace("{table}", encodeURIComponent("" + table));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(item);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processPutOData(_response));
        });
    }

    protected processPutOData(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    deleteOData(table: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v2305.1/odata/{table}";
        if (table === undefined || table === null)
            throw new Error("The parameter 'table' must be defined.");
        url_ = url_.replace("{table}", encodeURIComponent("" + table));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteOData(_response));
        });
    }

    protected processDeleteOData(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    batchOData(table: string, truncateTable?: boolean | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/v2305.1/odata/batch/{table}?";
        if (table === undefined || table === null)
            throw new Error("The parameter 'table' must be defined.");
        url_ = url_.replace("{table}", encodeURIComponent("" + table));
        if (truncateTable === null)
            throw new Error("The parameter 'truncateTable' cannot be null.");
        else if (truncateTable !== undefined)
            url_ += "truncateTable=" + encodeURIComponent("" + truncateTable) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBatchOData(_response));
        });
    }

    protected processBatchOData(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    start(path: string, options: string[][], runId?: string | null | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/v2305.1/process/start/{path}?";
        if (path === undefined || path === null)
            throw new Error("The parameter 'path' must be defined.");
        url_ = url_.replace("{path}", encodeURIComponent("" + path));
        if (runId !== undefined && runId !== null)
            url_ += "runId=" + encodeURIComponent("" + runId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(options);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processStart(_response));
        });
    }

    protected processStart(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    state(path: string): Promise<string> {
        let url_ = this.baseUrl + "/api/v2305.1/process/state/{path}";
        if (path === undefined || path === null)
            throw new Error("The parameter 'path' must be defined.");
        url_ = url_.replace("{path}", encodeURIComponent("" + path));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processState(_response));
        });
    }

    protected processState(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    stopInteractiveProcess(path: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v2305.1/process/stop/{path}";
        if (path === undefined || path === null)
            throw new Error("The parameter 'path' must be defined.");
        url_ = url_.replace("{path}", encodeURIComponent("" + path));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processStopInteractiveProcess(_response));
        });
    }

    protected processStopInteractiveProcess(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getRoles(userName: string): Promise<string[]> {
        let url_ = this.baseUrl + "/api/v2305.1/user/{username}/roles";
        if (userName === undefined || userName === null)
            throw new Error("The parameter 'userName' must be defined.");
        url_ = url_.replace("{userName}", encodeURIComponent("" + userName));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetRoles(_response));
        });
    }

    protected processGetRoles(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(resultData200[item]);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }

    addRole(userName: string, role: string): Promise<string[]> {
        let url_ = this.baseUrl + "/api/v2305.1/user/{username}/roles";
        if (userName === undefined || userName === null)
            throw new Error("The parameter 'userName' must be defined.");
        url_ = url_.replace("{userName}", encodeURIComponent("" + userName));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(role);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAddRole(_response));
        });
    }

    protected processAddRole(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(resultData200[item]);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }

    removeRole(userName: string, role: string): Promise<string[]> {
        let url_ = this.baseUrl + "/api/v2305.1/user/{username}/roles";
        if (userName === undefined || userName === null)
            throw new Error("The parameter 'userName' must be defined.");
        url_ = url_.replace("{userName}", encodeURIComponent("" + userName));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(role);

        let options_: RequestInit = {
            body: content_,
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRemoveRole(_response));
        });
    }

    protected processRemoveRole(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(resultData200[item]);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }

    getUsersAll(): Promise<ApiUserDetails[]> {
        let url_ = this.baseUrl + "/api/v2305.1/users";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetUsersAll(_response));
        });
    }

    protected processGetUsersAll(response: Response): Promise<ApiUserDetails[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(ApiUserDetails.fromJS(resultData200[item]));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiUserDetails[]>(null as any);
    }

    addUser(user: UserObject): Promise<ApiUserDetails> {
        let url_ = this.baseUrl + "/api/v2305.1/users";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(user);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAddUser(_response));
        });
    }

    protected processAddUser(response: Response): Promise<ApiUserDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiUserDetails.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiUserDetails>(null as any);
    }

    editUser(user: UserObject): Promise<ApiUserDetails> {
        let url_ = this.baseUrl + "/api/v2305.1/users";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(user);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processEditUser(_response));
        });
    }

    protected processEditUser(response: Response): Promise<ApiUserDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiUserDetails.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiUserDetails>(null as any);
    }

    getUsers(userName: string): Promise<ApiUserDetails> {
        let url_ = this.baseUrl + "/api/v2305.1/users/{userName}";
        if (userName === undefined || userName === null)
            throw new Error("The parameter 'userName' must be defined.");
        url_ = url_.replace("{userName}", encodeURIComponent("" + userName));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetUsers(_response));
        });
    }

    protected processGetUsers(response: Response): Promise<ApiUserDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiUserDetails.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiUserDetails>(null as any);
    }

    removeUser(userName: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v2305.1/users/{userName}";
        if (userName === undefined || userName === null)
            throw new Error("The parameter 'userName' must be defined.");
        url_ = url_.replace("{userName}", encodeURIComponent("" + userName));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRemoveUser(_response));
        });
    }

    protected processRemoveUser(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class HelpChatMessage implements IHelpChatMessage {
    answer?: string | null;
    userMessage!: string;
    hint?: string | null;
    soft?: string | null;
    history?: HelpChatHistoryItem[] | null;

    constructor(data?: IHelpChatMessage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.answer = data["answer"] !== undefined ? data["answer"] : <any>null;
            this.userMessage = data["userMessage"] !== undefined ? data["userMessage"] : <any>null;
            this.hint = data["hint"] !== undefined ? data["hint"] : <any>null;
            this.soft = data["soft"] !== undefined ? data["soft"] : <any>null;
            if (Array.isArray(data["history"])) {
                this.history = [] as any;
                for (let item in data["history"])
                    this.history!.push(HelpChatHistoryItem.fromJS(data["history"][item]));
            }
            else {
                this.history = <any>null;
            }
        }
    }

    static fromJS(data: any): HelpChatMessage {
        data = typeof data === 'object' ? data : {};
        let result = new HelpChatMessage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["answer"] = this.answer !== undefined ? this.answer : <any>null;
        data["userMessage"] = this.userMessage !== undefined ? this.userMessage : <any>null;
        data["hint"] = this.hint !== undefined ? this.hint : <any>null;
        data["soft"] = this.soft !== undefined ? this.soft : <any>null;
        if (Array.isArray(this.history)) {
            data["history"] = [];
            for (let item in this.history)
                data["history"].push(this.history[item].toJSON());
        }
        return data;
    }

    clone(): HelpChatMessage {
        const json = this.toJSON();
        let result = new HelpChatMessage();
        result.init(json);
        return result;
    }
}

export interface IHelpChatMessage {
    answer?: string | null;
    userMessage: string;
    hint?: string | null;
    soft?: string | null;
    history?: HelpChatHistoryItem[] | null;
}

export class HelpChatHistoryItem implements IHelpChatHistoryItem {
    question?: string | null;
    answer?: string | null;

    constructor(data?: IHelpChatHistoryItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.question = data["question"] !== undefined ? data["question"] : <any>null;
            this.answer = data["answer"] !== undefined ? data["answer"] : <any>null;
        }
    }

    static fromJS(data: any): HelpChatHistoryItem {
        data = typeof data === 'object' ? data : {};
        let result = new HelpChatHistoryItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["question"] = this.question !== undefined ? this.question : <any>null;
        data["answer"] = this.answer !== undefined ? this.answer : <any>null;
        return data;
    }

    clone(): HelpChatHistoryItem {
        const json = this.toJSON();
        let result = new HelpChatHistoryItem();
        result.init(json);
        return result;
    }
}

export interface IHelpChatHistoryItem {
    question?: string | null;
    answer?: string | null;
}

export class HelpArticle implements IHelpArticle {
    key?: string | null;
    zenDeskArticleId?: string | null;

    constructor(data?: IHelpArticle) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.key = data["key"] !== undefined ? data["key"] : <any>null;
            this.zenDeskArticleId = data["zenDeskArticleId"] !== undefined ? data["zenDeskArticleId"] : <any>null;
        }
    }

    static fromJS(data: any): HelpArticle {
        data = typeof data === 'object' ? data : {};
        let result = new HelpArticle();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key !== undefined ? this.key : <any>null;
        data["zenDeskArticleId"] = this.zenDeskArticleId !== undefined ? this.zenDeskArticleId : <any>null;
        return data;
    }

    clone(): HelpArticle {
        const json = this.toJSON();
        let result = new HelpArticle();
        result.init(json);
        return result;
    }
}

export interface IHelpArticle {
    key?: string | null;
    zenDeskArticleId?: string | null;
}

export class ADOActionType implements IADOActionType {
    id?: string | null;
    label?: string | null;

    constructor(data?: IADOActionType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"] !== undefined ? data["id"] : <any>null;
            this.label = data["label"] !== undefined ? data["label"] : <any>null;
        }
    }

    static fromJS(data: any): ADOActionType {
        data = typeof data === 'object' ? data : {};
        let result = new ADOActionType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["label"] = this.label !== undefined ? this.label : <any>null;
        return data;
    }

    clone(): ADOActionType {
        const json = this.toJSON();
        let result = new ADOActionType();
        result.init(json);
        return result;
    }
}

export interface IADOActionType {
    id?: string | null;
    label?: string | null;
}

export class ADOAction implements IADOAction {
    id?: string | null;
    label?: string | null;

    constructor(data?: IADOAction) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"] !== undefined ? data["id"] : <any>null;
            this.label = data["label"] !== undefined ? data["label"] : <any>null;
        }
    }

    static fromJS(data: any): ADOAction {
        data = typeof data === 'object' ? data : {};
        let result = new ADOAction();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["label"] = this.label !== undefined ? this.label : <any>null;
        return data;
    }

    clone(): ADOAction {
        const json = this.toJSON();
        let result = new ADOAction();
        result.init(json);
        return result;
    }
}

export interface IADOAction {
    id?: string | null;
    label?: string | null;
}

export class PipelineDefinitionItem implements IPipelineDefinitionItem {
    id?: string | null;
    tenantId?: string | null;
    name?: string | null;
    pipelineDefinitionVersionId?: string | null;
    createdBy?: UserRef | null;
    updatedBy?: UserRef | null;
    createdAt?: Date | null;
    updatedAt?: Date | null;
    deletedAt?: Date | null;
    pipelineType!: number;
    dataspaceId?: string | null;
    region?: string | null;
    pipelineDefinition?: PipelineDefinitionContainer | null;
    lastExecution?: PipelineLastExecution | null;

    constructor(data?: IPipelineDefinitionItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"] !== undefined ? data["id"] : <any>null;
            this.tenantId = data["tenantId"] !== undefined ? data["tenantId"] : <any>null;
            this.name = data["name"] !== undefined ? data["name"] : <any>null;
            this.pipelineDefinitionVersionId = data["pipelineDefinitionVersionId"] !== undefined ? data["pipelineDefinitionVersionId"] : <any>null;
            this.createdBy = data["createdBy"] ? UserRef.fromJS(data["createdBy"]) : <any>null;
            this.updatedBy = data["updatedBy"] ? UserRef.fromJS(data["updatedBy"]) : <any>null;
            this.createdAt = data["createdAt"] ? new Date(data["createdAt"].toString()) : <any>null;
            this.updatedAt = data["updatedAt"] ? new Date(data["updatedAt"].toString()) : <any>null;
            this.deletedAt = data["deletedAt"] ? new Date(data["deletedAt"].toString()) : <any>null;
            this.pipelineType = data["pipelineType"] !== undefined ? data["pipelineType"] : <any>null;
            this.dataspaceId = data["dataspaceId"] !== undefined ? data["dataspaceId"] : <any>null;
            this.region = data["region"] !== undefined ? data["region"] : <any>null;
            this.pipelineDefinition = data["pipelineDefinition"] ? PipelineDefinitionContainer.fromJS(data["pipelineDefinition"]) : <any>null;
            this.lastExecution = data["lastExecution"] ? PipelineLastExecution.fromJS(data["lastExecution"]) : <any>null;
        }
    }

    static fromJS(data: any): PipelineDefinitionItem {
        data = typeof data === 'object' ? data : {};
        let result = new PipelineDefinitionItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["tenantId"] = this.tenantId !== undefined ? this.tenantId : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["pipelineDefinitionVersionId"] = this.pipelineDefinitionVersionId !== undefined ? this.pipelineDefinitionVersionId : <any>null;
        data["createdBy"] = this.createdBy ? this.createdBy.toJSON() : <any>null;
        data["updatedBy"] = this.updatedBy ? this.updatedBy.toJSON() : <any>null;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>null;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>null;
        data["deletedAt"] = this.deletedAt ? this.deletedAt.toISOString() : <any>null;
        data["pipelineType"] = this.pipelineType !== undefined ? this.pipelineType : <any>null;
        data["dataspaceId"] = this.dataspaceId !== undefined ? this.dataspaceId : <any>null;
        data["region"] = this.region !== undefined ? this.region : <any>null;
        data["pipelineDefinition"] = this.pipelineDefinition ? this.pipelineDefinition.toJSON() : <any>null;
        data["lastExecution"] = this.lastExecution ? this.lastExecution.toJSON() : <any>null;
        return data;
    }

    clone(): PipelineDefinitionItem {
        const json = this.toJSON();
        let result = new PipelineDefinitionItem();
        result.init(json);
        return result;
    }
}

export interface IPipelineDefinitionItem {
    id?: string | null;
    tenantId?: string | null;
    name?: string | null;
    pipelineDefinitionVersionId?: string | null;
    createdBy?: UserRef | null;
    updatedBy?: UserRef | null;
    createdAt?: Date | null;
    updatedAt?: Date | null;
    deletedAt?: Date | null;
    pipelineType: number;
    dataspaceId?: string | null;
    region?: string | null;
    pipelineDefinition?: PipelineDefinitionContainer | null;
    lastExecution?: PipelineLastExecution | null;
}

export class UserRef implements IUserRef {
    userGuid?: string | null;
    userLastName?: string | null;
    userFirstName?: string | null;
    emailAddress?: string | null;

    constructor(data?: IUserRef) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.userGuid = data["userGuid"] !== undefined ? data["userGuid"] : <any>null;
            this.userLastName = data["userLastName"] !== undefined ? data["userLastName"] : <any>null;
            this.userFirstName = data["userFirstName"] !== undefined ? data["userFirstName"] : <any>null;
            this.emailAddress = data["emailAddress"] !== undefined ? data["emailAddress"] : <any>null;
        }
    }

    static fromJS(data: any): UserRef {
        data = typeof data === 'object' ? data : {};
        let result = new UserRef();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userGuid"] = this.userGuid !== undefined ? this.userGuid : <any>null;
        data["userLastName"] = this.userLastName !== undefined ? this.userLastName : <any>null;
        data["userFirstName"] = this.userFirstName !== undefined ? this.userFirstName : <any>null;
        data["emailAddress"] = this.emailAddress !== undefined ? this.emailAddress : <any>null;
        return data;
    }

    clone(): UserRef {
        const json = this.toJSON();
        let result = new UserRef();
        result.init(json);
        return result;
    }
}

export interface IUserRef {
    userGuid?: string | null;
    userLastName?: string | null;
    userFirstName?: string | null;
    emailAddress?: string | null;
}

export class PipelineDefinitionContainer implements IPipelineDefinitionContainer {
    pipeline?: Pipeline | null;
    schemaVersion?: string | null;

    constructor(data?: IPipelineDefinitionContainer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.pipeline = data["pipeline"] ? Pipeline.fromJS(data["pipeline"]) : <any>null;
            this.schemaVersion = data["schemaVersion"] !== undefined ? data["schemaVersion"] : <any>null;
        }
    }

    static fromJS(data: any): PipelineDefinitionContainer {
        data = typeof data === 'object' ? data : {};
        let result = new PipelineDefinitionContainer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pipeline"] = this.pipeline ? this.pipeline.toJSON() : <any>null;
        data["schemaVersion"] = this.schemaVersion !== undefined ? this.schemaVersion : <any>null;
        return data;
    }

    clone(): PipelineDefinitionContainer {
        const json = this.toJSON();
        let result = new PipelineDefinitionContainer();
        result.init(json);
        return result;
    }
}

export interface IPipelineDefinitionContainer {
    pipeline?: Pipeline | null;
    schemaVersion?: string | null;
}

export class Pipeline implements IPipeline {
    steps?: PipelineStep[] | null;

    constructor(data?: IPipeline) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (Array.isArray(data["steps"])) {
                this.steps = [] as any;
                for (let item in data["steps"])
                    this.steps!.push(PipelineStep.fromJS(data["steps"][item]));
            }
            else {
                this.steps = <any>null;
            }
        }
    }

    static fromJS(data: any): Pipeline {
        data = typeof data === 'object' ? data : {};
        let result = new Pipeline();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.steps)) {
            data["steps"] = [];
            for (let item in this.steps)
                data["steps"].push(this.steps[item].toJSON());
        }
        return data;
    }

    clone(): Pipeline {
        const json = this.toJSON();
        let result = new Pipeline();
        result.init(json);
        return result;
    }
}

export interface IPipeline {
    steps?: PipelineStep[] | null;
}

export class PipelineStep implements IPipelineStep {
    name?: string | null;
    id?: string | null;
    sourceIds?: string[] | null;
    type?: string | null;
    config?: PipelineStepConfig | null;

    constructor(data?: IPipelineStep) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"] !== undefined ? data["name"] : <any>null;
            this.id = data["id"] !== undefined ? data["id"] : <any>null;
            if (Array.isArray(data["sourceIds"])) {
                this.sourceIds = [] as any;
                for (let item in data["sourceIds"])
                    this.sourceIds!.push(data["sourceIds"][item]);
            }
            else {
                this.sourceIds = <any>null;
            }
            this.type = data["type"] !== undefined ? data["type"] : <any>null;
            this.config = data["config"] ? PipelineStepConfig.fromJS(data["config"]) : <any>null;
        }
    }

    static fromJS(data: any): PipelineStep {
        data = typeof data === 'object' ? data : {};
        let result = new PipelineStep();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["id"] = this.id !== undefined ? this.id : <any>null;
        if (Array.isArray(this.sourceIds)) {
            data["sourceIds"] = [];
            for (let item in this.sourceIds)
                data["sourceIds"].push(this.sourceIds[item]);
        }
        data["type"] = this.type !== undefined ? this.type : <any>null;
        data["config"] = this.config ? this.config.toJSON() : <any>null;
        return data;
    }

    clone(): PipelineStep {
        const json = this.toJSON();
        let result = new PipelineStep();
        result.init(json);
        return result;
    }
}

export interface IPipelineStep {
    name?: string | null;
    id?: string | null;
    sourceIds?: string[] | null;
    type?: string | null;
    config?: PipelineStepConfig | null;
}

export class PipelineStepConfig implements IPipelineStepConfig {
    type?: string | null;
    connectionId?: string | null;
    fileId?: string | null;
    modelGuid?: string | null;
    workspaceGuid?: string | null;
    outputColumns?: OutputColumn[] | null;
    columns?: string[] | null;
    rowData?: string[][] | null;
    canModifyOutputColumns?: boolean | null;

    constructor(data?: IPipelineStepConfig) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.type = data["type"] !== undefined ? data["type"] : <any>null;
            this.connectionId = data["connectionId"] !== undefined ? data["connectionId"] : <any>null;
            this.fileId = data["fileId"] !== undefined ? data["fileId"] : <any>null;
            this.modelGuid = data["modelGuid"] !== undefined ? data["modelGuid"] : <any>null;
            this.workspaceGuid = data["workspaceGuid"] !== undefined ? data["workspaceGuid"] : <any>null;
            if (Array.isArray(data["outputColumns"])) {
                this.outputColumns = [] as any;
                for (let item in data["outputColumns"])
                    this.outputColumns!.push(OutputColumn.fromJS(data["outputColumns"][item]));
            }
            else {
                this.outputColumns = <any>null;
            }
            if (Array.isArray(data["columns"])) {
                this.columns = [] as any;
                for (let item in data["columns"])
                    this.columns!.push(data["columns"][item]);
            }
            else {
                this.columns = <any>null;
            }
            if (Array.isArray(data["rowData"])) {
                this.rowData = [] as any;
                for (let item in data["rowData"])
                    this.rowData!.push(data["rowData"][item]);
            }
            else {
                this.rowData = <any>null;
            }
            this.canModifyOutputColumns = data["canModifyOutputColumns"] !== undefined ? data["canModifyOutputColumns"] : <any>null;
        }
    }

    static fromJS(data: any): PipelineStepConfig {
        data = typeof data === 'object' ? data : {};
        let result = new PipelineStepConfig();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type !== undefined ? this.type : <any>null;
        data["connectionId"] = this.connectionId !== undefined ? this.connectionId : <any>null;
        data["fileId"] = this.fileId !== undefined ? this.fileId : <any>null;
        data["modelGuid"] = this.modelGuid !== undefined ? this.modelGuid : <any>null;
        data["workspaceGuid"] = this.workspaceGuid !== undefined ? this.workspaceGuid : <any>null;
        if (Array.isArray(this.outputColumns)) {
            data["outputColumns"] = [];
            for (let item in this.outputColumns)
                data["outputColumns"].push(this.outputColumns[item].toJSON());
        }
        if (Array.isArray(this.columns)) {
            data["columns"] = [];
            for (let item in this.columns)
                data["columns"].push(this.columns[item]);
        }
        if (Array.isArray(this.rowData)) {
            data["rowData"] = [];
            for (let item in this.rowData)
                data["rowData"].push(this.rowData[item]);
        }
        data["canModifyOutputColumns"] = this.canModifyOutputColumns !== undefined ? this.canModifyOutputColumns : <any>null;
        return data;
    }

    clone(): PipelineStepConfig {
        const json = this.toJSON();
        let result = new PipelineStepConfig();
        result.init(json);
        return result;
    }
}

export interface IPipelineStepConfig {
    type?: string | null;
    connectionId?: string | null;
    fileId?: string | null;
    modelGuid?: string | null;
    workspaceGuid?: string | null;
    outputColumns?: OutputColumn[] | null;
    columns?: string[] | null;
    rowData?: string[][] | null;
    canModifyOutputColumns?: boolean | null;
}

export class OutputColumn implements IOutputColumn {
    name?: string | null;
    alias?: string | null;
    type?: string | null;

    constructor(data?: IOutputColumn) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"] !== undefined ? data["name"] : <any>null;
            this.alias = data["alias"] !== undefined ? data["alias"] : <any>null;
            this.type = data["type"] !== undefined ? data["type"] : <any>null;
        }
    }

    static fromJS(data: any): OutputColumn {
        data = typeof data === 'object' ? data : {};
        let result = new OutputColumn();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["alias"] = this.alias !== undefined ? this.alias : <any>null;
        data["type"] = this.type !== undefined ? this.type : <any>null;
        return data;
    }

    clone(): OutputColumn {
        const json = this.toJSON();
        let result = new OutputColumn();
        result.init(json);
        return result;
    }
}

export interface IOutputColumn {
    name?: string | null;
    alias?: string | null;
    type?: string | null;
}

export class PipelineLastExecution implements IPipelineLastExecution {
    status?: string | null;
    completedAt?: Date | null;
    startedAt?: Date | null;
    createdAt?: Date | null;
    createdBy?: UserRef | null;
    startupTime?: number | null;
    executionTime?: number | null;
    totalTime?: number | null;

    constructor(data?: IPipelineLastExecution) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.status = data["status"] !== undefined ? data["status"] : <any>null;
            this.completedAt = data["completedAt"] ? new Date(data["completedAt"].toString()) : <any>null;
            this.startedAt = data["startedAt"] ? new Date(data["startedAt"].toString()) : <any>null;
            this.createdAt = data["createdAt"] ? new Date(data["createdAt"].toString()) : <any>null;
            this.createdBy = data["createdBy"] ? UserRef.fromJS(data["createdBy"]) : <any>null;
            this.startupTime = data["startupTime"] !== undefined ? data["startupTime"] : <any>null;
            this.executionTime = data["executionTime"] !== undefined ? data["executionTime"] : <any>null;
            this.totalTime = data["totalTime"] !== undefined ? data["totalTime"] : <any>null;
        }
    }

    static fromJS(data: any): PipelineLastExecution {
        data = typeof data === 'object' ? data : {};
        let result = new PipelineLastExecution();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["completedAt"] = this.completedAt ? this.completedAt.toISOString() : <any>null;
        data["startedAt"] = this.startedAt ? this.startedAt.toISOString() : <any>null;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>null;
        data["createdBy"] = this.createdBy ? this.createdBy.toJSON() : <any>null;
        data["startupTime"] = this.startupTime !== undefined ? this.startupTime : <any>null;
        data["executionTime"] = this.executionTime !== undefined ? this.executionTime : <any>null;
        data["totalTime"] = this.totalTime !== undefined ? this.totalTime : <any>null;
        return data;
    }

    clone(): PipelineLastExecution {
        const json = this.toJSON();
        let result = new PipelineLastExecution();
        result.init(json);
        return result;
    }
}

export interface IPipelineLastExecution {
    status?: string | null;
    completedAt?: Date | null;
    startedAt?: Date | null;
    createdAt?: Date | null;
    createdBy?: UserRef | null;
    startupTime?: number | null;
    executionTime?: number | null;
    totalTime?: number | null;
}

export class AnaplanWorkflow implements IAnaplanWorkflow {
    guid?: string | null;
    name?: string | null;
    description?: string | null;

    constructor(data?: IAnaplanWorkflow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.guid = data["guid"] !== undefined ? data["guid"] : <any>null;
            this.name = data["name"] !== undefined ? data["name"] : <any>null;
            this.description = data["description"] !== undefined ? data["description"] : <any>null;
        }
    }

    static fromJS(data: any): AnaplanWorkflow {
        data = typeof data === 'object' ? data : {};
        let result = new AnaplanWorkflow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid !== undefined ? this.guid : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        return data;
    }

    clone(): AnaplanWorkflow {
        const json = this.toJSON();
        let result = new AnaplanWorkflow();
        result.init(json);
        return result;
    }
}

export interface IAnaplanWorkflow {
    guid?: string | null;
    name?: string | null;
    description?: string | null;
}

export class ADODataspace implements IADODataspace {
    id?: string | null;
    name?: string | null;
    display_name?: string | null;

    constructor(data?: IADODataspace) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"] !== undefined ? data["id"] : <any>null;
            this.name = data["name"] !== undefined ? data["name"] : <any>null;
            this.display_name = data["display_name"] !== undefined ? data["display_name"] : <any>null;
        }
    }

    static fromJS(data: any): ADODataspace {
        data = typeof data === 'object' ? data : {};
        let result = new ADODataspace();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["display_name"] = this.display_name !== undefined ? this.display_name : <any>null;
        return data;
    }

    clone(): ADODataspace {
        const json = this.toJSON();
        let result = new ADODataspace();
        result.init(json);
        return result;
    }
}

export interface IADODataspace {
    id?: string | null;
    name?: string | null;
    display_name?: string | null;
}

export class ADODataset implements IADODataset {
    id?: string | null;
    name?: string | null;
    display_name?: string | null;

    constructor(data?: IADODataset) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"] !== undefined ? data["id"] : <any>null;
            this.name = data["name"] !== undefined ? data["name"] : <any>null;
            this.display_name = data["display_name"] !== undefined ? data["display_name"] : <any>null;
        }
    }

    static fromJS(data: any): ADODataset {
        data = typeof data === 'object' ? data : {};
        let result = new ADODataset();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["display_name"] = this.display_name !== undefined ? this.display_name : <any>null;
        return data;
    }

    clone(): ADODataset {
        const json = this.toJSON();
        let result = new ADODataset();
        result.init(json);
        return result;
    }
}

export interface IADODataset {
    id?: string | null;
    name?: string | null;
    display_name?: string | null;
}

export class MetadataAuditLogResult implements IMetadataAuditLogResult {
    results?: MetadataAuditLogInfo[] | null;
    rowCount!: number;

    constructor(data?: IMetadataAuditLogResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (Array.isArray(data["results"])) {
                this.results = [] as any;
                for (let item in data["results"])
                    this.results!.push(MetadataAuditLogInfo.fromJS(data["results"][item]));
            }
            else {
                this.results = <any>null;
            }
            this.rowCount = data["rowCount"] !== undefined ? data["rowCount"] : <any>null;
        }
    }

    static fromJS(data: any): MetadataAuditLogResult {
        data = typeof data === 'object' ? data : {};
        let result = new MetadataAuditLogResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item in this.results)
                data["results"].push(this.results[item].toJSON());
        }
        data["rowCount"] = this.rowCount !== undefined ? this.rowCount : <any>null;
        return data;
    }

    clone(): MetadataAuditLogResult {
        const json = this.toJSON();
        let result = new MetadataAuditLogResult();
        result.init(json);
        return result;
    }
}

export interface IMetadataAuditLogResult {
    results?: MetadataAuditLogInfo[] | null;
    rowCount: number;
}

export class MetadataAuditLogInfo implements IMetadataAuditLogInfo {
    id?: number | null;
    username?: string | null;
    category!: Category;
    action?: string | null;
    timestamp?: string | null;
    ipAddress?: string | null;
    modelName?: string | null;
    dimensionName?: string | null;
    memberKey?: string | null;
    dimensionProperty?: string | null;
    memberProperty?: string | null;
    oldValue?: string | null;
    newValue?: string | null;
    oldValueName?: string | null;
    newValueName?: string | null;
    hierarchyName?: string | null;
    object?: string | null;
    memberColumn?: MemberColumnType | null;
    processDate?: string | null;
    description?: string | null;

    constructor(data?: IMetadataAuditLogInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"] !== undefined ? data["id"] : <any>null;
            this.username = data["username"] !== undefined ? data["username"] : <any>null;
            this.category = data["category"] !== undefined ? data["category"] : <any>null;
            this.action = data["action"] !== undefined ? data["action"] : <any>null;
            this.timestamp = data["timestamp"] !== undefined ? data["timestamp"] : <any>null;
            this.ipAddress = data["ipAddress"] !== undefined ? data["ipAddress"] : <any>null;
            this.modelName = data["modelName"] !== undefined ? data["modelName"] : <any>null;
            this.dimensionName = data["dimensionName"] !== undefined ? data["dimensionName"] : <any>null;
            this.memberKey = data["memberKey"] !== undefined ? data["memberKey"] : <any>null;
            this.dimensionProperty = data["dimensionProperty"] !== undefined ? data["dimensionProperty"] : <any>null;
            this.memberProperty = data["memberProperty"] !== undefined ? data["memberProperty"] : <any>null;
            this.oldValue = data["oldValue"] !== undefined ? data["oldValue"] : <any>null;
            this.newValue = data["newValue"] !== undefined ? data["newValue"] : <any>null;
            this.oldValueName = data["oldValueName"] !== undefined ? data["oldValueName"] : <any>null;
            this.newValueName = data["newValueName"] !== undefined ? data["newValueName"] : <any>null;
            this.hierarchyName = data["hierarchyName"] !== undefined ? data["hierarchyName"] : <any>null;
            this.object = data["object"] !== undefined ? data["object"] : <any>null;
            this.memberColumn = data["memberColumn"] !== undefined ? data["memberColumn"] : <any>null;
            this.processDate = data["processDate"] !== undefined ? data["processDate"] : <any>null;
            this.description = data["description"] !== undefined ? data["description"] : <any>null;
        }
    }

    static fromJS(data: any): MetadataAuditLogInfo {
        data = typeof data === 'object' ? data : {};
        let result = new MetadataAuditLogInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["username"] = this.username !== undefined ? this.username : <any>null;
        data["category"] = this.category !== undefined ? this.category : <any>null;
        data["action"] = this.action !== undefined ? this.action : <any>null;
        data["timestamp"] = this.timestamp !== undefined ? this.timestamp : <any>null;
        data["ipAddress"] = this.ipAddress !== undefined ? this.ipAddress : <any>null;
        data["modelName"] = this.modelName !== undefined ? this.modelName : <any>null;
        data["dimensionName"] = this.dimensionName !== undefined ? this.dimensionName : <any>null;
        data["memberKey"] = this.memberKey !== undefined ? this.memberKey : <any>null;
        data["dimensionProperty"] = this.dimensionProperty !== undefined ? this.dimensionProperty : <any>null;
        data["memberProperty"] = this.memberProperty !== undefined ? this.memberProperty : <any>null;
        data["oldValue"] = this.oldValue !== undefined ? this.oldValue : <any>null;
        data["newValue"] = this.newValue !== undefined ? this.newValue : <any>null;
        data["oldValueName"] = this.oldValueName !== undefined ? this.oldValueName : <any>null;
        data["newValueName"] = this.newValueName !== undefined ? this.newValueName : <any>null;
        data["hierarchyName"] = this.hierarchyName !== undefined ? this.hierarchyName : <any>null;
        data["object"] = this.object !== undefined ? this.object : <any>null;
        data["memberColumn"] = this.memberColumn !== undefined ? this.memberColumn : <any>null;
        data["processDate"] = this.processDate !== undefined ? this.processDate : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        return data;
    }

    clone(): MetadataAuditLogInfo {
        const json = this.toJSON();
        let result = new MetadataAuditLogInfo();
        result.init(json);
        return result;
    }
}

export interface IMetadataAuditLogInfo {
    id?: number | null;
    username?: string | null;
    category: Category;
    action?: string | null;
    timestamp?: string | null;
    ipAddress?: string | null;
    modelName?: string | null;
    dimensionName?: string | null;
    memberKey?: string | null;
    dimensionProperty?: string | null;
    memberProperty?: string | null;
    oldValue?: string | null;
    newValue?: string | null;
    oldValueName?: string | null;
    newValueName?: string | null;
    hierarchyName?: string | null;
    object?: string | null;
    memberColumn?: MemberColumnType | null;
    processDate?: string | null;
    description?: string | null;
}

export enum Category {
    ALL = 0,
    MEMBER = 1,
    MODEL = 2,
    DIMENSION = 3,
    PROCESS = 4,
    MAP = 5,
    MAPPING = 6,
    MULTIDIMMAPPING = 7,
}

export enum MemberColumnType {
    MODEL = 0,
    MODELDIMENSION = 1,
    MODELDIMENSIONROLE = 2,
    CONSOLIDATIONMODEL = 3,
    DEFAULTCONSOLIDATIONMODEL = 4,
    MANAGEDSSASMODEL = 5,
    DIRECTQUERYMODE = 6,
    ASSECURITYPROFILE = 7,
    DIMENSION = 8,
    DIMENSIONPROPERTY = 9,
    DIMENSIONREPORTINGPROPERTY = 10,
    DIMENSIONSTANDARDPROPERTY = 11,
    DIMENSIONPROPERTYTYPEINFO = 12,
    DIMENSIONDEFAULTREPORTINGMEMBER = 13,
    DIMENSIONDEFAULTINPUTMEMBER = 14,
    DIMENSIONNONLEAFDATAMEMBER = 15,
    MEMBER = 16,
    NAME = 17,
    PARENTKEY = 18,
    TAG = 19,
    OPERATOR = 20,
    SHARED = 21,
    MEMBERPROPERTY = 22,
    SORTORDER = 23,
    PROCESS = 24,
    CAPTION = 25,
}

export class Paging implements IPaging {
    take?: number | null;
    skip?: number | null;

    constructor(data?: IPaging) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.take = data["take"] !== undefined ? data["take"] : <any>null;
            this.skip = data["skip"] !== undefined ? data["skip"] : <any>null;
        }
    }

    static fromJS(data: any): Paging {
        data = typeof data === 'object' ? data : {};
        let result = new Paging();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["take"] = this.take !== undefined ? this.take : <any>null;
        data["skip"] = this.skip !== undefined ? this.skip : <any>null;
        return data;
    }

    clone(): Paging {
        const json = this.toJSON();
        let result = new Paging();
        result.init(json);
        return result;
    }
}

export interface IPaging {
    take?: number | null;
    skip?: number | null;
}

export class FilteredSortedPaging extends Paging implements IFilteredSortedPaging {
    filterModel?: any | null;
    sortModel?: { [key: string]: string; }[] | null;

    constructor(data?: IFilteredSortedPaging) {
        super(data);
    }

    init(data?: any) {
        super.init(data);
        if (data) {
            this.filterModel = data["filterModel"] !== undefined ? data["filterModel"] : <any>null;
            if (Array.isArray(data["sortModel"])) {
                this.sortModel = [] as any;
                for (let item in data["sortModel"])
                    this.sortModel!.push(data["sortModel"][item]);
            }
            else {
                this.sortModel = <any>null;
            }
        }
    }

    static fromJS(data: any): FilteredSortedPaging {
        data = typeof data === 'object' ? data : {};
        let result = new FilteredSortedPaging();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filterModel"] = this.filterModel !== undefined ? this.filterModel : <any>null;
        if (Array.isArray(this.sortModel)) {
            data["sortModel"] = [];
            for (let item in this.sortModel)
                data["sortModel"].push(this.sortModel[item]);
        }
        super.toJSON(data);
        return data;
    }

    clone(): FilteredSortedPaging {
        const json = this.toJSON();
        let result = new FilteredSortedPaging();
        result.init(json);
        return result;
    }
}

export interface IFilteredSortedPaging extends IPaging {
    filterModel?: any | null;
    sortModel?: { [key: string]: string; }[] | null;
}

export class DashboardSection implements IDashboardSection {
    id!: number;
    name?: string | null;
    userName?: string | null;
    orderNo!: number;
    dashboardControls?: DashboardControl[] | null;

    constructor(data?: IDashboardSection) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"] !== undefined ? data["id"] : <any>null;
            this.name = data["name"] !== undefined ? data["name"] : <any>null;
            this.userName = data["userName"] !== undefined ? data["userName"] : <any>null;
            this.orderNo = data["orderNo"] !== undefined ? data["orderNo"] : <any>null;
            if (Array.isArray(data["dashboardControls"])) {
                this.dashboardControls = [] as any;
                for (let item in data["dashboardControls"])
                    this.dashboardControls!.push(DashboardControl.fromJS(data["dashboardControls"][item]));
            }
            else {
                this.dashboardControls = <any>null;
            }
        }
    }

    static fromJS(data: any): DashboardSection {
        data = typeof data === 'object' ? data : {};
        let result = new DashboardSection();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["userName"] = this.userName !== undefined ? this.userName : <any>null;
        data["orderNo"] = this.orderNo !== undefined ? this.orderNo : <any>null;
        if (Array.isArray(this.dashboardControls)) {
            data["dashboardControls"] = [];
            for (let item in this.dashboardControls)
                data["dashboardControls"].push(this.dashboardControls[item].toJSON());
        }
        return data;
    }

    clone(): DashboardSection {
        const json = this.toJSON();
        let result = new DashboardSection();
        result.init(json);
        return result;
    }
}

export interface IDashboardSection {
    id: number;
    name?: string | null;
    userName?: string | null;
    orderNo: number;
    dashboardControls?: DashboardControl[] | null;
}

export class DashboardControl implements IDashboardControl {
    id!: number;
    sectionId!: number;
    userName?: string | null;
    title?: string | null;
    fileSystemPath?: string | null;
    configuration?: DashboardControlConfiguration | null;
    x!: number;
    width!: number;
    y!: number;
    height!: number;
    showHeader!: boolean;
    hideBorder!: boolean;
    headerTooltip?: string | null;
    controlTooltip?: string | null;
    mode?: string | null;

    constructor(data?: IDashboardControl) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"] !== undefined ? data["id"] : <any>null;
            this.sectionId = data["sectionId"] !== undefined ? data["sectionId"] : <any>null;
            this.userName = data["userName"] !== undefined ? data["userName"] : <any>null;
            this.title = data["title"] !== undefined ? data["title"] : <any>null;
            this.fileSystemPath = data["fileSystemPath"] !== undefined ? data["fileSystemPath"] : <any>null;
            this.configuration = data["configuration"] ? DashboardControlConfiguration.fromJS(data["configuration"]) : <any>null;
            this.x = data["x"] !== undefined ? data["x"] : <any>null;
            this.width = data["width"] !== undefined ? data["width"] : <any>null;
            this.y = data["y"] !== undefined ? data["y"] : <any>null;
            this.height = data["height"] !== undefined ? data["height"] : <any>null;
            this.showHeader = data["showHeader"] !== undefined ? data["showHeader"] : <any>null;
            this.hideBorder = data["hideBorder"] !== undefined ? data["hideBorder"] : <any>null;
            this.headerTooltip = data["headerTooltip"] !== undefined ? data["headerTooltip"] : <any>null;
            this.controlTooltip = data["controlTooltip"] !== undefined ? data["controlTooltip"] : <any>null;
            this.mode = data["mode"] !== undefined ? data["mode"] : <any>null;
        }
    }

    static fromJS(data: any): DashboardControl {
        data = typeof data === 'object' ? data : {};
        let result = new DashboardControl();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["sectionId"] = this.sectionId !== undefined ? this.sectionId : <any>null;
        data["userName"] = this.userName !== undefined ? this.userName : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["fileSystemPath"] = this.fileSystemPath !== undefined ? this.fileSystemPath : <any>null;
        data["configuration"] = this.configuration ? this.configuration.toJSON() : <any>null;
        data["x"] = this.x !== undefined ? this.x : <any>null;
        data["width"] = this.width !== undefined ? this.width : <any>null;
        data["y"] = this.y !== undefined ? this.y : <any>null;
        data["height"] = this.height !== undefined ? this.height : <any>null;
        data["showHeader"] = this.showHeader !== undefined ? this.showHeader : <any>null;
        data["hideBorder"] = this.hideBorder !== undefined ? this.hideBorder : <any>null;
        data["headerTooltip"] = this.headerTooltip !== undefined ? this.headerTooltip : <any>null;
        data["controlTooltip"] = this.controlTooltip !== undefined ? this.controlTooltip : <any>null;
        data["mode"] = this.mode !== undefined ? this.mode : <any>null;
        return data;
    }

    clone(): DashboardControl {
        const json = this.toJSON();
        let result = new DashboardControl();
        result.init(json);
        return result;
    }
}

export interface IDashboardControl {
    id: number;
    sectionId: number;
    userName?: string | null;
    title?: string | null;
    fileSystemPath?: string | null;
    configuration?: DashboardControlConfiguration | null;
    x: number;
    width: number;
    y: number;
    height: number;
    showHeader: boolean;
    hideBorder: boolean;
    headerTooltip?: string | null;
    controlTooltip?: string | null;
    mode?: string | null;
}

export class DashboardControlConfiguration implements IDashboardControlConfiguration {
    url?: string | null;
    containerStyle?: string | null;
    itemStyle?: string | null;
    state?: string | null;
    zoom?: number | null;
    listContent?: DashboardListContent[] | null;
    formatAsTable!: boolean;
    expandLevel!: number;
    genericBits?: boolean[] | null;
    foreachWorkflows?: DashboardControlForeachWorkflow[] | null;

    constructor(data?: IDashboardControlConfiguration) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.url = data["url"] !== undefined ? data["url"] : <any>null;
            this.containerStyle = data["containerStyle"] !== undefined ? data["containerStyle"] : <any>null;
            this.itemStyle = data["itemStyle"] !== undefined ? data["itemStyle"] : <any>null;
            this.state = data["state"] !== undefined ? data["state"] : <any>null;
            this.zoom = data["zoom"] !== undefined ? data["zoom"] : <any>null;
            if (Array.isArray(data["listContent"])) {
                this.listContent = [] as any;
                for (let item in data["listContent"])
                    this.listContent!.push(DashboardListContent.fromJS(data["listContent"][item]));
            }
            else {
                this.listContent = <any>null;
            }
            this.formatAsTable = data["formatAsTable"] !== undefined ? data["formatAsTable"] : <any>null;
            this.expandLevel = data["expandLevel"] !== undefined ? data["expandLevel"] : <any>null;
            if (Array.isArray(data["genericBits"])) {
                this.genericBits = [] as any;
                for (let item in data["genericBits"])
                    this.genericBits!.push(data["genericBits"][item]);
            }
            else {
                this.genericBits = <any>null;
            }
            if (Array.isArray(data["foreachWorkflows"])) {
                this.foreachWorkflows = [] as any;
                for (let item in data["foreachWorkflows"])
                    this.foreachWorkflows!.push(DashboardControlForeachWorkflow.fromJS(data["foreachWorkflows"][item]));
            }
            else {
                this.foreachWorkflows = <any>null;
            }
        }
    }

    static fromJS(data: any): DashboardControlConfiguration {
        data = typeof data === 'object' ? data : {};
        let result = new DashboardControlConfiguration();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["url"] = this.url !== undefined ? this.url : <any>null;
        data["containerStyle"] = this.containerStyle !== undefined ? this.containerStyle : <any>null;
        data["itemStyle"] = this.itemStyle !== undefined ? this.itemStyle : <any>null;
        data["state"] = this.state !== undefined ? this.state : <any>null;
        data["zoom"] = this.zoom !== undefined ? this.zoom : <any>null;
        if (Array.isArray(this.listContent)) {
            data["listContent"] = [];
            for (let item in this.listContent)
                data["listContent"].push(this.listContent[item].toJSON());
        }
        data["formatAsTable"] = this.formatAsTable !== undefined ? this.formatAsTable : <any>null;
        data["expandLevel"] = this.expandLevel !== undefined ? this.expandLevel : <any>null;
        if (Array.isArray(this.genericBits)) {
            data["genericBits"] = [];
            for (let item in this.genericBits)
                data["genericBits"].push(this.genericBits[item]);
        }
        if (Array.isArray(this.foreachWorkflows)) {
            data["foreachWorkflows"] = [];
            for (let item in this.foreachWorkflows)
                data["foreachWorkflows"].push(this.foreachWorkflows[item].toJSON());
        }
        return data;
    }

    clone(): DashboardControlConfiguration {
        const json = this.toJSON();
        let result = new DashboardControlConfiguration();
        result.init(json);
        return result;
    }
}

export interface IDashboardControlConfiguration {
    url?: string | null;
    containerStyle?: string | null;
    itemStyle?: string | null;
    state?: string | null;
    zoom?: number | null;
    listContent?: DashboardListContent[] | null;
    formatAsTable: boolean;
    expandLevel: number;
    genericBits?: boolean[] | null;
    foreachWorkflows?: DashboardControlForeachWorkflow[] | null;
}

export class DashboardListContent implements IDashboardListContent {
    text?: string | null;
    url?: string | null;
    icon?: string | null;
    replacePage?: boolean | null;
    openType?: string | null;
    tooltip?: string | null;
    isExpanded!: boolean;
    isExpandable!: boolean;
    cssListStyle?: string | null;
    children?: DashboardListContent[] | null;

    constructor(data?: IDashboardListContent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.text = data["text"] !== undefined ? data["text"] : <any>null;
            this.url = data["url"] !== undefined ? data["url"] : <any>null;
            this.icon = data["icon"] !== undefined ? data["icon"] : <any>null;
            this.replacePage = data["replacePage"] !== undefined ? data["replacePage"] : <any>null;
            this.openType = data["openType"] !== undefined ? data["openType"] : <any>null;
            this.tooltip = data["tooltip"] !== undefined ? data["tooltip"] : <any>null;
            this.isExpanded = data["isExpanded"] !== undefined ? data["isExpanded"] : <any>null;
            this.isExpandable = data["isExpandable"] !== undefined ? data["isExpandable"] : <any>null;
            this.cssListStyle = data["cssListStyle"] !== undefined ? data["cssListStyle"] : <any>null;
            if (Array.isArray(data["children"])) {
                this.children = [] as any;
                for (let item in data["children"])
                    this.children!.push(DashboardListContent.fromJS(data["children"][item]));
            }
            else {
                this.children = <any>null;
            }
        }
    }

    static fromJS(data: any): DashboardListContent {
        data = typeof data === 'object' ? data : {};
        let result = new DashboardListContent();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["text"] = this.text !== undefined ? this.text : <any>null;
        data["url"] = this.url !== undefined ? this.url : <any>null;
        data["icon"] = this.icon !== undefined ? this.icon : <any>null;
        data["replacePage"] = this.replacePage !== undefined ? this.replacePage : <any>null;
        data["openType"] = this.openType !== undefined ? this.openType : <any>null;
        data["tooltip"] = this.tooltip !== undefined ? this.tooltip : <any>null;
        data["isExpanded"] = this.isExpanded !== undefined ? this.isExpanded : <any>null;
        data["isExpandable"] = this.isExpandable !== undefined ? this.isExpandable : <any>null;
        data["cssListStyle"] = this.cssListStyle !== undefined ? this.cssListStyle : <any>null;
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item in this.children)
                data["children"].push(this.children[item].toJSON());
        }
        return data;
    }

    clone(): DashboardListContent {
        const json = this.toJSON();
        let result = new DashboardListContent();
        result.init(json);
        return result;
    }
}

export interface IDashboardListContent {
    text?: string | null;
    url?: string | null;
    icon?: string | null;
    replacePage?: boolean | null;
    openType?: string | null;
    tooltip?: string | null;
    isExpanded: boolean;
    isExpandable: boolean;
    cssListStyle?: string | null;
    children?: DashboardListContent[] | null;
}

export class DashboardControlForeachWorkflow implements IDashboardControlForeachWorkflow {
    fileSystemPath?: string | null;
    foreachActivityName?: string | null;

    constructor(data?: IDashboardControlForeachWorkflow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.fileSystemPath = data["fileSystemPath"] !== undefined ? data["fileSystemPath"] : <any>null;
            this.foreachActivityName = data["foreachActivityName"] !== undefined ? data["foreachActivityName"] : <any>null;
        }
    }

    static fromJS(data: any): DashboardControlForeachWorkflow {
        data = typeof data === 'object' ? data : {};
        let result = new DashboardControlForeachWorkflow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileSystemPath"] = this.fileSystemPath !== undefined ? this.fileSystemPath : <any>null;
        data["foreachActivityName"] = this.foreachActivityName !== undefined ? this.foreachActivityName : <any>null;
        return data;
    }

    clone(): DashboardControlForeachWorkflow {
        const json = this.toJSON();
        let result = new DashboardControlForeachWorkflow();
        result.init(json);
        return result;
    }
}

export interface IDashboardControlForeachWorkflow {
    fileSystemPath?: string | null;
    foreachActivityName?: string | null;
}

export class DataSource implements IDataSource {
    name?: string | null;
    provider!: DataSourceProvider;
    type!: DataSourceType;

    constructor(data?: IDataSource) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"] !== undefined ? data["name"] : <any>null;
            this.provider = data["provider"] !== undefined ? data["provider"] : <any>null;
            this.type = data["type"] !== undefined ? data["type"] : <any>null;
        }
    }

    static fromJS(data: any): DataSource {
        data = typeof data === 'object' ? data : {};
        let result = new DataSource();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["provider"] = this.provider !== undefined ? this.provider : <any>null;
        data["type"] = this.type !== undefined ? this.type : <any>null;
        return data;
    }

    clone(): DataSource {
        const json = this.toJSON();
        let result = new DataSource();
        result.init(json);
        return result;
    }
}

export interface IDataSource {
    name?: string | null;
    provider: DataSourceProvider;
    type: DataSourceType;
}

export enum DataSourceProvider {
    AppDBMaster = "AppDBMaster",
    SqlServer = "SqlServer",
    Vena = "Vena",
    Slack = "Slack",
    Slack2 = "Slack2",
    Teams = "Teams",
    Azure = "Azure",
    AzureAS = "AzureAS",
    DataBlend = "DataBlend",
    AzureStorage = "AzureStorage",
    AzureSynapse = "AzureSynapse",
    AzureBlobStorage = "AzureBlobStorage",
    Ftp = "Ftp",
    RestApi = "RestApi",
    Anaplan = "Anaplan",
}

export enum DataSourceType {
    Relational = "Relational",
    Olap = "Olap",
    Collaboration = "Collaboration",
    External = "External",
    Unknown = "Unknown",
}

export class DataSourceExtended extends DataSource implements IDataSourceExtended {
    connectionString?: string | null;
    id?: string | null;

    constructor(data?: IDataSourceExtended) {
        super(data);
    }

    init(data?: any) {
        super.init(data);
        if (data) {
            this.connectionString = data["connectionString"] !== undefined ? data["connectionString"] : <any>null;
            this.id = data["id"] !== undefined ? data["id"] : <any>null;
        }
    }

    static fromJS(data: any): DataSourceExtended {
        data = typeof data === 'object' ? data : {};
        let result = new DataSourceExtended();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["connectionString"] = this.connectionString !== undefined ? this.connectionString : <any>null;
        data["id"] = this.id !== undefined ? this.id : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): DataSourceExtended {
        const json = this.toJSON();
        let result = new DataSourceExtended();
        result.init(json);
        return result;
    }
}

export interface IDataSourceExtended extends IDataSource {
    connectionString?: string | null;
    id?: string | null;
}

export class DevOpsEnvironment implements IDevOpsEnvironment {
    name?: string | null;
    portalUrl?: string | null;
    parent?: string | null;
    version?: string | null;
    lastUpdated?: Date | null;
    scheduledUpdate?: Date | null;
    gated?: boolean | null;
    children?: DevOpsEnvironment[] | null;

    constructor(data?: IDevOpsEnvironment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"] !== undefined ? data["name"] : <any>null;
            this.portalUrl = data["portalUrl"] !== undefined ? data["portalUrl"] : <any>null;
            this.parent = data["parent"] !== undefined ? data["parent"] : <any>null;
            this.version = data["version"] !== undefined ? data["version"] : <any>null;
            this.lastUpdated = data["lastUpdated"] ? new Date(data["lastUpdated"].toString()) : <any>null;
            this.scheduledUpdate = data["scheduledUpdate"] ? new Date(data["scheduledUpdate"].toString()) : <any>null;
            this.gated = data["gated"] !== undefined ? data["gated"] : <any>null;
            if (Array.isArray(data["children"])) {
                this.children = [] as any;
                for (let item in data["children"])
                    this.children!.push(DevOpsEnvironment.fromJS(data["children"][item]));
            }
            else {
                this.children = <any>null;
            }
        }
    }

    static fromJS(data: any): DevOpsEnvironment {
        data = typeof data === 'object' ? data : {};
        let result = new DevOpsEnvironment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["portalUrl"] = this.portalUrl !== undefined ? this.portalUrl : <any>null;
        data["parent"] = this.parent !== undefined ? this.parent : <any>null;
        data["version"] = this.version !== undefined ? this.version : <any>null;
        data["lastUpdated"] = this.lastUpdated ? this.lastUpdated.toISOString() : <any>null;
        data["scheduledUpdate"] = this.scheduledUpdate ? this.scheduledUpdate.toISOString() : <any>null;
        data["gated"] = this.gated !== undefined ? this.gated : <any>null;
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item in this.children)
                data["children"].push(this.children[item].toJSON());
        }
        return data;
    }

    clone(): DevOpsEnvironment {
        const json = this.toJSON();
        let result = new DevOpsEnvironment();
        result.init(json);
        return result;
    }
}

export interface IDevOpsEnvironment {
    name?: string | null;
    portalUrl?: string | null;
    parent?: string | null;
    version?: string | null;
    lastUpdated?: Date | null;
    scheduledUpdate?: Date | null;
    gated?: boolean | null;
    children?: DevOpsEnvironment[] | null;
}

export class StagingTableInfo implements IStagingTableInfo {
    schema?: string | null;
    tableName?: string | null;

    constructor(data?: IStagingTableInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.schema = data["schema"] !== undefined ? data["schema"] : <any>null;
            this.tableName = data["tableName"] !== undefined ? data["tableName"] : <any>null;
        }
    }

    static fromJS(data: any): StagingTableInfo {
        data = typeof data === 'object' ? data : {};
        let result = new StagingTableInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["schema"] = this.schema !== undefined ? this.schema : <any>null;
        data["tableName"] = this.tableName !== undefined ? this.tableName : <any>null;
        return data;
    }

    clone(): StagingTableInfo {
        const json = this.toJSON();
        let result = new StagingTableInfo();
        result.init(json);
        return result;
    }
}

export interface IStagingTableInfo {
    schema?: string | null;
    tableName?: string | null;
}

export class StagingTableField implements IStagingTableField {
    name?: string | null;
    dataType!: StagingTableFieldType;
    sqlDataType!: SqlDbType;
    sqlSize?: number | null;
    sqlPrecision?: number | null;
    primaryKey!: boolean;
    nullable!: boolean;
    autoincrement!: boolean;

    constructor(data?: IStagingTableField) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"] !== undefined ? data["name"] : <any>null;
            this.dataType = data["dataType"] !== undefined ? data["dataType"] : <any>null;
            this.sqlDataType = data["sqlDataType"] !== undefined ? data["sqlDataType"] : <any>null;
            this.sqlSize = data["sqlSize"] !== undefined ? data["sqlSize"] : <any>null;
            this.sqlPrecision = data["sqlPrecision"] !== undefined ? data["sqlPrecision"] : <any>null;
            this.primaryKey = data["primaryKey"] !== undefined ? data["primaryKey"] : <any>null;
            this.nullable = data["nullable"] !== undefined ? data["nullable"] : <any>null;
            this.autoincrement = data["autoincrement"] !== undefined ? data["autoincrement"] : <any>null;
        }
    }

    static fromJS(data: any): StagingTableField {
        data = typeof data === 'object' ? data : {};
        let result = new StagingTableField();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["dataType"] = this.dataType !== undefined ? this.dataType : <any>null;
        data["sqlDataType"] = this.sqlDataType !== undefined ? this.sqlDataType : <any>null;
        data["sqlSize"] = this.sqlSize !== undefined ? this.sqlSize : <any>null;
        data["sqlPrecision"] = this.sqlPrecision !== undefined ? this.sqlPrecision : <any>null;
        data["primaryKey"] = this.primaryKey !== undefined ? this.primaryKey : <any>null;
        data["nullable"] = this.nullable !== undefined ? this.nullable : <any>null;
        data["autoincrement"] = this.autoincrement !== undefined ? this.autoincrement : <any>null;
        return data;
    }

    clone(): StagingTableField {
        const json = this.toJSON();
        let result = new StagingTableField();
        result.init(json);
        return result;
    }
}

export interface IStagingTableField {
    name?: string | null;
    dataType: StagingTableFieldType;
    sqlDataType: SqlDbType;
    sqlSize?: number | null;
    sqlPrecision?: number | null;
    primaryKey: boolean;
    nullable: boolean;
    autoincrement: boolean;
}

export enum StagingTableFieldType {
    Int = 0,
    Float = 1,
    Date = 2,
    String = 3,
    Custom = 4,
}

export enum SqlDbType {
    BigInt = 0,
    Binary = 1,
    Bit = 2,
    Char = 3,
    DateTime = 4,
    Decimal = 5,
    Float = 6,
    Image = 7,
    Int = 8,
    Money = 9,
    NChar = 10,
    NText = 11,
    NVarChar = 12,
    Real = 13,
    UniqueIdentifier = 14,
    SmallDateTime = 15,
    SmallInt = 16,
    SmallMoney = 17,
    Text = 18,
    Timestamp = 19,
    TinyInt = 20,
    VarBinary = 21,
    VarChar = 22,
    Variant = 23,
    Xml = 25,
    Udt = 29,
    Structured = 30,
    Date = 31,
    Time = 32,
    DateTime2 = 33,
    DateTimeOffset = 34,
}

export class CommandOutput implements ICommandOutput {
    message?: string | null;
    dataFields?: string[] | null;
    dataValues?: string[][] | null;
    commandItems?: CommandItem[] | null;

    constructor(data?: ICommandOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.message = data["message"] !== undefined ? data["message"] : <any>null;
            if (Array.isArray(data["dataFields"])) {
                this.dataFields = [] as any;
                for (let item in data["dataFields"])
                    this.dataFields!.push(data["dataFields"][item]);
            }
            else {
                this.dataFields = <any>null;
            }
            if (Array.isArray(data["dataValues"])) {
                this.dataValues = [] as any;
                for (let item in data["dataValues"])
                    this.dataValues!.push(data["dataValues"][item]);
            }
            else {
                this.dataValues = <any>null;
            }
            if (Array.isArray(data["commandItems"])) {
                this.commandItems = [] as any;
                for (let item in data["commandItems"])
                    this.commandItems!.push(CommandItem.fromJS(data["commandItems"][item]));
            }
            else {
                this.commandItems = <any>null;
            }
        }
    }

    static fromJS(data: any): CommandOutput {
        data = typeof data === 'object' ? data : {};
        let result = new CommandOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message !== undefined ? this.message : <any>null;
        if (Array.isArray(this.dataFields)) {
            data["dataFields"] = [];
            for (let item in this.dataFields)
                data["dataFields"].push(this.dataFields[item]);
        }
        if (Array.isArray(this.dataValues)) {
            data["dataValues"] = [];
            for (let item in this.dataValues)
                data["dataValues"].push(this.dataValues[item]);
        }
        if (Array.isArray(this.commandItems)) {
            data["commandItems"] = [];
            for (let item in this.commandItems)
                data["commandItems"].push(this.commandItems[item].toJSON());
        }
        return data;
    }

    clone(): CommandOutput {
        const json = this.toJSON();
        let result = new CommandOutput();
        result.init(json);
        return result;
    }
}

export interface ICommandOutput {
    message?: string | null;
    dataFields?: string[] | null;
    dataValues?: string[][] | null;
    commandItems?: CommandItem[] | null;
}

export class CommandItem implements ICommandItem {
    sourceValue?: string | null;
    dimension?: string | null;
    dataMapName?: string | null;
    kind?: MappingCommandItemKind | null;

    constructor(data?: ICommandItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.sourceValue = data["sourceValue"] !== undefined ? data["sourceValue"] : <any>null;
            this.dimension = data["dimension"] !== undefined ? data["dimension"] : <any>null;
            this.dataMapName = data["dataMapName"] !== undefined ? data["dataMapName"] : <any>null;
            this.kind = data["kind"] !== undefined ? data["kind"] : <any>null;
        }
    }

    static fromJS(data: any): CommandItem {
        data = typeof data === 'object' ? data : {};
        let result = new CommandItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sourceValue"] = this.sourceValue !== undefined ? this.sourceValue : <any>null;
        data["dimension"] = this.dimension !== undefined ? this.dimension : <any>null;
        data["dataMapName"] = this.dataMapName !== undefined ? this.dataMapName : <any>null;
        data["kind"] = this.kind !== undefined ? this.kind : <any>null;
        return data;
    }

    clone(): CommandItem {
        const json = this.toJSON();
        let result = new CommandItem();
        result.init(json);
        return result;
    }
}

export interface ICommandItem {
    sourceValue?: string | null;
    dimension?: string | null;
    dataMapName?: string | null;
    kind?: MappingCommandItemKind | null;
}

export enum MappingCommandItemKind {
    CannotBeMapped = 0,
    InvalidMappedMember = 1,
}

export class ModelMappingInfo implements IModelMappingInfo {
    mappingId?: number | null;
    name?: string | null;
    modelName?: string | null;
    stagingTableSchema?: string | null;
    stagingTableName?: string | null;
    roleWritePermissions?: RoleWriteObject[] | null;
    isEditable!: boolean;

    constructor(data?: IModelMappingInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.mappingId = data["mappingId"] !== undefined ? data["mappingId"] : <any>null;
            this.name = data["name"] !== undefined ? data["name"] : <any>null;
            this.modelName = data["modelName"] !== undefined ? data["modelName"] : <any>null;
            this.stagingTableSchema = data["stagingTableSchema"] !== undefined ? data["stagingTableSchema"] : <any>null;
            this.stagingTableName = data["stagingTableName"] !== undefined ? data["stagingTableName"] : <any>null;
            if (Array.isArray(data["roleWritePermissions"])) {
                this.roleWritePermissions = [] as any;
                for (let item in data["roleWritePermissions"])
                    this.roleWritePermissions!.push(RoleWriteObject.fromJS(data["roleWritePermissions"][item]));
            }
            else {
                this.roleWritePermissions = <any>null;
            }
            this.isEditable = data["isEditable"] !== undefined ? data["isEditable"] : <any>null;
        }
    }

    static fromJS(data: any): ModelMappingInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ModelMappingInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mappingId"] = this.mappingId !== undefined ? this.mappingId : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["modelName"] = this.modelName !== undefined ? this.modelName : <any>null;
        data["stagingTableSchema"] = this.stagingTableSchema !== undefined ? this.stagingTableSchema : <any>null;
        data["stagingTableName"] = this.stagingTableName !== undefined ? this.stagingTableName : <any>null;
        if (Array.isArray(this.roleWritePermissions)) {
            data["roleWritePermissions"] = [];
            for (let item in this.roleWritePermissions)
                data["roleWritePermissions"].push(this.roleWritePermissions[item].toJSON());
        }
        data["isEditable"] = this.isEditable !== undefined ? this.isEditable : <any>null;
        return data;
    }

    clone(): ModelMappingInfo {
        const json = this.toJSON();
        let result = new ModelMappingInfo();
        result.init(json);
        return result;
    }
}

export interface IModelMappingInfo {
    mappingId?: number | null;
    name?: string | null;
    modelName?: string | null;
    stagingTableSchema?: string | null;
    stagingTableName?: string | null;
    roleWritePermissions?: RoleWriteObject[] | null;
    isEditable: boolean;
}

export class RoleWriteObject implements IRoleWriteObject {
    parentSourceName?: string | null;
    roleName?: string | null;
    canWrite!: boolean;
    parentController?: string | null;

    constructor(data?: IRoleWriteObject) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.parentSourceName = data["parentSourceName"] !== undefined ? data["parentSourceName"] : <any>null;
            this.roleName = data["roleName"] !== undefined ? data["roleName"] : <any>null;
            this.canWrite = data["canWrite"] !== undefined ? data["canWrite"] : <any>null;
            this.parentController = data["parentController"] !== undefined ? data["parentController"] : <any>null;
        }
    }

    static fromJS(data: any): RoleWriteObject {
        data = typeof data === 'object' ? data : {};
        let result = new RoleWriteObject();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentSourceName"] = this.parentSourceName !== undefined ? this.parentSourceName : <any>null;
        data["roleName"] = this.roleName !== undefined ? this.roleName : <any>null;
        data["canWrite"] = this.canWrite !== undefined ? this.canWrite : <any>null;
        data["parentController"] = this.parentController !== undefined ? this.parentController : <any>null;
        return data;
    }

    clone(): RoleWriteObject {
        const json = this.toJSON();
        let result = new RoleWriteObject();
        result.init(json);
        return result;
    }
}

export interface IRoleWriteObject {
    parentSourceName?: string | null;
    roleName?: string | null;
    canWrite: boolean;
    parentController?: string | null;
}

export class ModelMappingDataInfo implements IModelMappingDataInfo {
    fields?: SimpleKeyValue[] | null;
    modelMappings?: ModelMappingInfo[] | null;
    schemas?: string[] | null;
    databaseTables?: SimpleKeyValue[] | null;

    constructor(data?: IModelMappingDataInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (Array.isArray(data["fields"])) {
                this.fields = [] as any;
                for (let item in data["fields"])
                    this.fields!.push(SimpleKeyValue.fromJS(data["fields"][item]));
            }
            else {
                this.fields = <any>null;
            }
            if (Array.isArray(data["modelMappings"])) {
                this.modelMappings = [] as any;
                for (let item in data["modelMappings"])
                    this.modelMappings!.push(ModelMappingInfo.fromJS(data["modelMappings"][item]));
            }
            else {
                this.modelMappings = <any>null;
            }
            if (Array.isArray(data["schemas"])) {
                this.schemas = [] as any;
                for (let item in data["schemas"])
                    this.schemas!.push(data["schemas"][item]);
            }
            else {
                this.schemas = <any>null;
            }
            if (Array.isArray(data["databaseTables"])) {
                this.databaseTables = [] as any;
                for (let item in data["databaseTables"])
                    this.databaseTables!.push(SimpleKeyValue.fromJS(data["databaseTables"][item]));
            }
            else {
                this.databaseTables = <any>null;
            }
        }
    }

    static fromJS(data: any): ModelMappingDataInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ModelMappingDataInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.fields)) {
            data["fields"] = [];
            for (let item in this.fields)
                data["fields"].push(this.fields[item].toJSON());
        }
        if (Array.isArray(this.modelMappings)) {
            data["modelMappings"] = [];
            for (let item in this.modelMappings)
                data["modelMappings"].push(this.modelMappings[item].toJSON());
        }
        if (Array.isArray(this.schemas)) {
            data["schemas"] = [];
            for (let item in this.schemas)
                data["schemas"].push(this.schemas[item]);
        }
        if (Array.isArray(this.databaseTables)) {
            data["databaseTables"] = [];
            for (let item in this.databaseTables)
                data["databaseTables"].push(this.databaseTables[item].toJSON());
        }
        return data;
    }

    clone(): ModelMappingDataInfo {
        const json = this.toJSON();
        let result = new ModelMappingDataInfo();
        result.init(json);
        return result;
    }
}

export interface IModelMappingDataInfo {
    fields?: SimpleKeyValue[] | null;
    modelMappings?: ModelMappingInfo[] | null;
    schemas?: string[] | null;
    databaseTables?: SimpleKeyValue[] | null;
}

export class SimpleKeyValue implements ISimpleKeyValue {
    name?: string | null;
    value?: string | null;

    constructor(data?: ISimpleKeyValue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"] !== undefined ? data["name"] : <any>null;
            this.value = data["value"] !== undefined ? data["value"] : <any>null;
        }
    }

    static fromJS(data: any): SimpleKeyValue {
        data = typeof data === 'object' ? data : {};
        let result = new SimpleKeyValue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["value"] = this.value !== undefined ? this.value : <any>null;
        return data;
    }

    clone(): SimpleKeyValue {
        const json = this.toJSON();
        let result = new SimpleKeyValue();
        result.init(json);
        return result;
    }
}

export interface ISimpleKeyValue {
    name?: string | null;
    value?: string | null;
}

export class DataSlicerInfo implements IDataSlicerInfo {
    mappingId!: number;
    slicerId!: number;
    dimensionName?: string | null;
    slicer?: string | null;
    slicerType!: SlicerTypeInfo;
    value1?: string | null;
    value2?: string | null;

    constructor(data?: IDataSlicerInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.mappingId = data["mappingId"] !== undefined ? data["mappingId"] : <any>null;
            this.slicerId = data["slicerId"] !== undefined ? data["slicerId"] : <any>null;
            this.dimensionName = data["dimensionName"] !== undefined ? data["dimensionName"] : <any>null;
            this.slicer = data["slicer"] !== undefined ? data["slicer"] : <any>null;
            this.slicerType = data["slicerType"] !== undefined ? data["slicerType"] : <any>null;
            this.value1 = data["value1"] !== undefined ? data["value1"] : <any>null;
            this.value2 = data["value2"] !== undefined ? data["value2"] : <any>null;
        }
    }

    static fromJS(data: any): DataSlicerInfo {
        data = typeof data === 'object' ? data : {};
        let result = new DataSlicerInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mappingId"] = this.mappingId !== undefined ? this.mappingId : <any>null;
        data["slicerId"] = this.slicerId !== undefined ? this.slicerId : <any>null;
        data["dimensionName"] = this.dimensionName !== undefined ? this.dimensionName : <any>null;
        data["slicer"] = this.slicer !== undefined ? this.slicer : <any>null;
        data["slicerType"] = this.slicerType !== undefined ? this.slicerType : <any>null;
        data["value1"] = this.value1 !== undefined ? this.value1 : <any>null;
        data["value2"] = this.value2 !== undefined ? this.value2 : <any>null;
        return data;
    }

    clone(): DataSlicerInfo {
        const json = this.toJSON();
        let result = new DataSlicerInfo();
        result.init(json);
        return result;
    }
}

export interface IDataSlicerInfo {
    mappingId: number;
    slicerId: number;
    dimensionName?: string | null;
    slicer?: string | null;
    slicerType: SlicerTypeInfo;
    value1?: string | null;
    value2?: string | null;
}

export enum SlicerTypeInfo {
    StagingUniqueValue = 0,
    StagingRange = 1,
    Fixed = 2,
    DescendantsOf = 3,
    Everything = 4,
}

export class ModelFieldMappingInfo implements IModelFieldMappingInfo {
    mappingId!: number;
    targetType?: string | null;
    target?: string | null;
    mappingType?: string | null;
    sourceField?: string | null;
    value?: string | null;
    flipCredits!: boolean;
    securityProfile?: string | null;
    dataMapSourceName?: string | null;
    roleWritePermissions?: RoleWriteObject[] | null;

    constructor(data?: IModelFieldMappingInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.mappingId = data["mappingId"] !== undefined ? data["mappingId"] : <any>null;
            this.targetType = data["targetType"] !== undefined ? data["targetType"] : <any>null;
            this.target = data["target"] !== undefined ? data["target"] : <any>null;
            this.mappingType = data["mappingType"] !== undefined ? data["mappingType"] : <any>null;
            this.sourceField = data["sourceField"] !== undefined ? data["sourceField"] : <any>null;
            this.value = data["value"] !== undefined ? data["value"] : <any>null;
            this.flipCredits = data["flipCredits"] !== undefined ? data["flipCredits"] : <any>null;
            this.securityProfile = data["securityProfile"] !== undefined ? data["securityProfile"] : <any>null;
            this.dataMapSourceName = data["dataMapSourceName"] !== undefined ? data["dataMapSourceName"] : <any>null;
            if (Array.isArray(data["roleWritePermissions"])) {
                this.roleWritePermissions = [] as any;
                for (let item in data["roleWritePermissions"])
                    this.roleWritePermissions!.push(RoleWriteObject.fromJS(data["roleWritePermissions"][item]));
            }
            else {
                this.roleWritePermissions = <any>null;
            }
        }
    }

    static fromJS(data: any): ModelFieldMappingInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ModelFieldMappingInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mappingId"] = this.mappingId !== undefined ? this.mappingId : <any>null;
        data["targetType"] = this.targetType !== undefined ? this.targetType : <any>null;
        data["target"] = this.target !== undefined ? this.target : <any>null;
        data["mappingType"] = this.mappingType !== undefined ? this.mappingType : <any>null;
        data["sourceField"] = this.sourceField !== undefined ? this.sourceField : <any>null;
        data["value"] = this.value !== undefined ? this.value : <any>null;
        data["flipCredits"] = this.flipCredits !== undefined ? this.flipCredits : <any>null;
        data["securityProfile"] = this.securityProfile !== undefined ? this.securityProfile : <any>null;
        data["dataMapSourceName"] = this.dataMapSourceName !== undefined ? this.dataMapSourceName : <any>null;
        if (Array.isArray(this.roleWritePermissions)) {
            data["roleWritePermissions"] = [];
            for (let item in this.roleWritePermissions)
                data["roleWritePermissions"].push(this.roleWritePermissions[item].toJSON());
        }
        return data;
    }

    clone(): ModelFieldMappingInfo {
        const json = this.toJSON();
        let result = new ModelFieldMappingInfo();
        result.init(json);
        return result;
    }
}

export interface IModelFieldMappingInfo {
    mappingId: number;
    targetType?: string | null;
    target?: string | null;
    mappingType?: string | null;
    sourceField?: string | null;
    value?: string | null;
    flipCredits: boolean;
    securityProfile?: string | null;
    dataMapSourceName?: string | null;
    roleWritePermissions?: RoleWriteObject[] | null;
}

export class DefaultMappingInfo implements IDefaultMappingInfo {
    mappingId!: number;
    sequenceId!: number;
    type?: string | null;
    target?: string | null;
    value?: string | null;
    displayValue?: string | null;

    constructor(data?: IDefaultMappingInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.mappingId = data["mappingId"] !== undefined ? data["mappingId"] : <any>null;
            this.sequenceId = data["sequenceId"] !== undefined ? data["sequenceId"] : <any>null;
            this.type = data["type"] !== undefined ? data["type"] : <any>null;
            this.target = data["target"] !== undefined ? data["target"] : <any>null;
            this.value = data["value"] !== undefined ? data["value"] : <any>null;
            this.displayValue = data["displayValue"] !== undefined ? data["displayValue"] : <any>null;
        }
    }

    static fromJS(data: any): DefaultMappingInfo {
        data = typeof data === 'object' ? data : {};
        let result = new DefaultMappingInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mappingId"] = this.mappingId !== undefined ? this.mappingId : <any>null;
        data["sequenceId"] = this.sequenceId !== undefined ? this.sequenceId : <any>null;
        data["type"] = this.type !== undefined ? this.type : <any>null;
        data["target"] = this.target !== undefined ? this.target : <any>null;
        data["value"] = this.value !== undefined ? this.value : <any>null;
        data["displayValue"] = this.displayValue !== undefined ? this.displayValue : <any>null;
        return data;
    }

    clone(): DefaultMappingInfo {
        const json = this.toJSON();
        let result = new DefaultMappingInfo();
        result.init(json);
        return result;
    }
}

export interface IDefaultMappingInfo {
    mappingId: number;
    sequenceId: number;
    type?: string | null;
    target?: string | null;
    value?: string | null;
    displayValue?: string | null;
}

export class EtlLogHeaderInfo implements IEtlLogHeaderInfo {
    etlLogHeaderId!: number;
    startDateTime!: Date;
    endDateTime?: Date | null;
    userName?: string | null;
    importDefinitionName?: string | null;
    status!: LogHeaderStatus;
    workflowName?: string | null;
    taskName?: string | null;
    isDrillBackEnabled?: boolean | null;
    importFileName?: string | null;

    constructor(data?: IEtlLogHeaderInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.etlLogHeaderId = data["etlLogHeaderId"] !== undefined ? data["etlLogHeaderId"] : <any>null;
            this.startDateTime = data["startDateTime"] ? new Date(data["startDateTime"].toString()) : <any>null;
            this.endDateTime = data["endDateTime"] ? new Date(data["endDateTime"].toString()) : <any>null;
            this.userName = data["userName"] !== undefined ? data["userName"] : <any>null;
            this.importDefinitionName = data["importDefinitionName"] !== undefined ? data["importDefinitionName"] : <any>null;
            this.status = data["status"] !== undefined ? data["status"] : <any>null;
            this.workflowName = data["workflowName"] !== undefined ? data["workflowName"] : <any>null;
            this.taskName = data["taskName"] !== undefined ? data["taskName"] : <any>null;
            this.isDrillBackEnabled = data["isDrillBackEnabled"] !== undefined ? data["isDrillBackEnabled"] : <any>null;
            this.importFileName = data["importFileName"] !== undefined ? data["importFileName"] : <any>null;
        }
    }

    static fromJS(data: any): EtlLogHeaderInfo {
        data = typeof data === 'object' ? data : {};
        let result = new EtlLogHeaderInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["etlLogHeaderId"] = this.etlLogHeaderId !== undefined ? this.etlLogHeaderId : <any>null;
        data["startDateTime"] = this.startDateTime ? this.startDateTime.toISOString() : <any>null;
        data["endDateTime"] = this.endDateTime ? this.endDateTime.toISOString() : <any>null;
        data["userName"] = this.userName !== undefined ? this.userName : <any>null;
        data["importDefinitionName"] = this.importDefinitionName !== undefined ? this.importDefinitionName : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["workflowName"] = this.workflowName !== undefined ? this.workflowName : <any>null;
        data["taskName"] = this.taskName !== undefined ? this.taskName : <any>null;
        data["isDrillBackEnabled"] = this.isDrillBackEnabled !== undefined ? this.isDrillBackEnabled : <any>null;
        data["importFileName"] = this.importFileName !== undefined ? this.importFileName : <any>null;
        return data;
    }

    clone(): EtlLogHeaderInfo {
        const json = this.toJSON();
        let result = new EtlLogHeaderInfo();
        result.init(json);
        return result;
    }
}

export interface IEtlLogHeaderInfo {
    etlLogHeaderId: number;
    startDateTime: Date;
    endDateTime?: Date | null;
    userName?: string | null;
    importDefinitionName?: string | null;
    status: LogHeaderStatus;
    workflowName?: string | null;
    taskName?: string | null;
    isDrillBackEnabled?: boolean | null;
    importFileName?: string | null;
}

export enum LogHeaderStatus {
    InProgress = 1,
    Failed = 2,
    Completed = 3,
    Errors = 4,
}

export class DrillbackDetailInfo implements IDrillbackDetailInfo {
    logHeaderId!: number;
    executionInstance!: number;
    rowCount!: number;
    dimensionsInfo?: { [key: string]: string; }[] | null;
    dimensionTypeInfo?: DrillbackDimensionTypeInfo[] | null;

    constructor(data?: IDrillbackDetailInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.logHeaderId = data["logHeaderId"] !== undefined ? data["logHeaderId"] : <any>null;
            this.executionInstance = data["executionInstance"] !== undefined ? data["executionInstance"] : <any>null;
            this.rowCount = data["rowCount"] !== undefined ? data["rowCount"] : <any>null;
            if (Array.isArray(data["dimensionsInfo"])) {
                this.dimensionsInfo = [] as any;
                for (let item in data["dimensionsInfo"])
                    this.dimensionsInfo!.push(data["dimensionsInfo"][item]);
            }
            else {
                this.dimensionsInfo = <any>null;
            }
            if (Array.isArray(data["dimensionTypeInfo"])) {
                this.dimensionTypeInfo = [] as any;
                for (let item in data["dimensionTypeInfo"])
                    this.dimensionTypeInfo!.push(DrillbackDimensionTypeInfo.fromJS(data["dimensionTypeInfo"][item]));
            }
            else {
                this.dimensionTypeInfo = <any>null;
            }
        }
    }

    static fromJS(data: any): DrillbackDetailInfo {
        data = typeof data === 'object' ? data : {};
        let result = new DrillbackDetailInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["logHeaderId"] = this.logHeaderId !== undefined ? this.logHeaderId : <any>null;
        data["executionInstance"] = this.executionInstance !== undefined ? this.executionInstance : <any>null;
        data["rowCount"] = this.rowCount !== undefined ? this.rowCount : <any>null;
        if (Array.isArray(this.dimensionsInfo)) {
            data["dimensionsInfo"] = [];
            for (let item in this.dimensionsInfo)
                data["dimensionsInfo"].push(this.dimensionsInfo[item]);
        }
        if (Array.isArray(this.dimensionTypeInfo)) {
            data["dimensionTypeInfo"] = [];
            for (let item in this.dimensionTypeInfo)
                data["dimensionTypeInfo"].push(this.dimensionTypeInfo[item].toJSON());
        }
        return data;
    }

    clone(): DrillbackDetailInfo {
        const json = this.toJSON();
        let result = new DrillbackDetailInfo();
        result.init(json);
        return result;
    }
}

export interface IDrillbackDetailInfo {
    logHeaderId: number;
    executionInstance: number;
    rowCount: number;
    dimensionsInfo?: { [key: string]: string; }[] | null;
    dimensionTypeInfo?: DrillbackDimensionTypeInfo[] | null;
}

export class DrillbackDimensionTypeInfo implements IDrillbackDimensionTypeInfo {
    dimensionName?: string | null;
    isMeasure!: boolean;
    dimensionType!: number;
    isSourceOnly!: boolean;
    isSourceCaptionEmpty!: boolean;

    constructor(data?: IDrillbackDimensionTypeInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.dimensionName = data["dimensionName"] !== undefined ? data["dimensionName"] : <any>null;
            this.isMeasure = data["isMeasure"] !== undefined ? data["isMeasure"] : <any>null;
            this.dimensionType = data["dimensionType"] !== undefined ? data["dimensionType"] : <any>null;
            this.isSourceOnly = data["isSourceOnly"] !== undefined ? data["isSourceOnly"] : <any>null;
            this.isSourceCaptionEmpty = data["isSourceCaptionEmpty"] !== undefined ? data["isSourceCaptionEmpty"] : <any>null;
        }
    }

    static fromJS(data: any): DrillbackDimensionTypeInfo {
        data = typeof data === 'object' ? data : {};
        let result = new DrillbackDimensionTypeInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dimensionName"] = this.dimensionName !== undefined ? this.dimensionName : <any>null;
        data["isMeasure"] = this.isMeasure !== undefined ? this.isMeasure : <any>null;
        data["dimensionType"] = this.dimensionType !== undefined ? this.dimensionType : <any>null;
        data["isSourceOnly"] = this.isSourceOnly !== undefined ? this.isSourceOnly : <any>null;
        data["isSourceCaptionEmpty"] = this.isSourceCaptionEmpty !== undefined ? this.isSourceCaptionEmpty : <any>null;
        return data;
    }

    clone(): DrillbackDimensionTypeInfo {
        const json = this.toJSON();
        let result = new DrillbackDimensionTypeInfo();
        result.init(json);
        return result;
    }
}

export interface IDrillbackDimensionTypeInfo {
    dimensionName?: string | null;
    isMeasure: boolean;
    dimensionType: number;
    isSourceOnly: boolean;
    isSourceCaptionEmpty: boolean;
}

export class EtlLogInfo implements IEtlLogInfo {
    runId!: string;
    etlLogHeaderId!: number;
    timestamp!: Date;
    message?: string | null;

    constructor(data?: IEtlLogInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.runId = data["runId"] !== undefined ? data["runId"] : <any>null;
            this.etlLogHeaderId = data["etlLogHeaderId"] !== undefined ? data["etlLogHeaderId"] : <any>null;
            this.timestamp = data["timestamp"] ? new Date(data["timestamp"].toString()) : <any>null;
            this.message = data["message"] !== undefined ? data["message"] : <any>null;
        }
    }

    static fromJS(data: any): EtlLogInfo {
        data = typeof data === 'object' ? data : {};
        let result = new EtlLogInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["runId"] = this.runId !== undefined ? this.runId : <any>null;
        data["etlLogHeaderId"] = this.etlLogHeaderId !== undefined ? this.etlLogHeaderId : <any>null;
        data["timestamp"] = this.timestamp ? this.timestamp.toISOString() : <any>null;
        data["message"] = this.message !== undefined ? this.message : <any>null;
        return data;
    }

    clone(): EtlLogInfo {
        const json = this.toJSON();
        let result = new EtlLogInfo();
        result.init(json);
        return result;
    }
}

export interface IEtlLogInfo {
    runId: string;
    etlLogHeaderId: number;
    timestamp: Date;
    message?: string | null;
}

export class DataMapInfo implements IDataMapInfo {
    sourceName?: string | null;
    roleWritePermissions?: RoleWriteObject[] | null;
    isSignBasedMappingsEnabled!: boolean;
    isEditable!: boolean;
    canEditIsSignBasedMappingsEnabled?: boolean | null;
    dataMapType!: DataMapType;
    stagingTableName?: string | null;
    sourceFields?: string[] | null;
    canEditSourceFields?: boolean | null;

    constructor(data?: IDataMapInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.sourceName = data["sourceName"] !== undefined ? data["sourceName"] : <any>null;
            if (Array.isArray(data["roleWritePermissions"])) {
                this.roleWritePermissions = [] as any;
                for (let item in data["roleWritePermissions"])
                    this.roleWritePermissions!.push(RoleWriteObject.fromJS(data["roleWritePermissions"][item]));
            }
            else {
                this.roleWritePermissions = <any>null;
            }
            this.isSignBasedMappingsEnabled = data["isSignBasedMappingsEnabled"] !== undefined ? data["isSignBasedMappingsEnabled"] : <any>null;
            this.isEditable = data["isEditable"] !== undefined ? data["isEditable"] : <any>null;
            this.canEditIsSignBasedMappingsEnabled = data["canEditIsSignBasedMappingsEnabled"] !== undefined ? data["canEditIsSignBasedMappingsEnabled"] : <any>null;
            this.dataMapType = data["dataMapType"] !== undefined ? data["dataMapType"] : <any>null;
            this.stagingTableName = data["stagingTableName"] !== undefined ? data["stagingTableName"] : <any>null;
            if (Array.isArray(data["sourceFields"])) {
                this.sourceFields = [] as any;
                for (let item in data["sourceFields"])
                    this.sourceFields!.push(data["sourceFields"][item]);
            }
            else {
                this.sourceFields = <any>null;
            }
            this.canEditSourceFields = data["canEditSourceFields"] !== undefined ? data["canEditSourceFields"] : <any>null;
        }
    }

    static fromJS(data: any): DataMapInfo {
        data = typeof data === 'object' ? data : {};
        let result = new DataMapInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sourceName"] = this.sourceName !== undefined ? this.sourceName : <any>null;
        if (Array.isArray(this.roleWritePermissions)) {
            data["roleWritePermissions"] = [];
            for (let item in this.roleWritePermissions)
                data["roleWritePermissions"].push(this.roleWritePermissions[item].toJSON());
        }
        data["isSignBasedMappingsEnabled"] = this.isSignBasedMappingsEnabled !== undefined ? this.isSignBasedMappingsEnabled : <any>null;
        data["isEditable"] = this.isEditable !== undefined ? this.isEditable : <any>null;
        data["canEditIsSignBasedMappingsEnabled"] = this.canEditIsSignBasedMappingsEnabled !== undefined ? this.canEditIsSignBasedMappingsEnabled : <any>null;
        data["dataMapType"] = this.dataMapType !== undefined ? this.dataMapType : <any>null;
        data["stagingTableName"] = this.stagingTableName !== undefined ? this.stagingTableName : <any>null;
        if (Array.isArray(this.sourceFields)) {
            data["sourceFields"] = [];
            for (let item in this.sourceFields)
                data["sourceFields"].push(this.sourceFields[item]);
        }
        data["canEditSourceFields"] = this.canEditSourceFields !== undefined ? this.canEditSourceFields : <any>null;
        return data;
    }

    clone(): DataMapInfo {
        const json = this.toJSON();
        let result = new DataMapInfo();
        result.init(json);
        return result;
    }
}

export interface IDataMapInfo {
    sourceName?: string | null;
    roleWritePermissions?: RoleWriteObject[] | null;
    isSignBasedMappingsEnabled: boolean;
    isEditable: boolean;
    canEditIsSignBasedMappingsEnabled?: boolean | null;
    dataMapType: DataMapType;
    stagingTableName?: string | null;
    sourceFields?: string[] | null;
    canEditSourceFields?: boolean | null;
}

export enum DataMapType {
    Single = 1,
    Multi = 2,
}

export class UpdateDataMapRequest implements IUpdateDataMapRequest {
    isSignBasedMappingsEnabled!: boolean;
    multiDimSourceFields?: string[] | null;

    constructor(data?: IUpdateDataMapRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.isSignBasedMappingsEnabled = data["isSignBasedMappingsEnabled"] !== undefined ? data["isSignBasedMappingsEnabled"] : <any>null;
            if (Array.isArray(data["multiDimSourceFields"])) {
                this.multiDimSourceFields = [] as any;
                for (let item in data["multiDimSourceFields"])
                    this.multiDimSourceFields!.push(data["multiDimSourceFields"][item]);
            }
            else {
                this.multiDimSourceFields = <any>null;
            }
        }
    }

    static fromJS(data: any): UpdateDataMapRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateDataMapRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSignBasedMappingsEnabled"] = this.isSignBasedMappingsEnabled !== undefined ? this.isSignBasedMappingsEnabled : <any>null;
        if (Array.isArray(this.multiDimSourceFields)) {
            data["multiDimSourceFields"] = [];
            for (let item in this.multiDimSourceFields)
                data["multiDimSourceFields"].push(this.multiDimSourceFields[item]);
        }
        return data;
    }

    clone(): UpdateDataMapRequest {
        const json = this.toJSON();
        let result = new UpdateDataMapRequest();
        result.init(json);
        return result;
    }
}

export interface IUpdateDataMapRequest {
    isSignBasedMappingsEnabled: boolean;
    multiDimSourceFields?: string[] | null;
}

export class DataMappingInfo implements IDataMappingInfo {
    saveType?: string | null;
    orderIndex!: number;
    sourceName?: string | null;
    dimensionName?: string | null;
    sourceValue?: string | null;
    sourceSign?: string | null;
    sourceCaption?: string | null;
    sourceValueOriginal?: string | null;
    sourceSignOriginal?: string | null;
    dimensionNameOriginal?: string | null;
    targetMemberName?: string | null;
    caption?: string | null;
    mappingType?: string | null;
    isAiSuggestion?: boolean | null;

    constructor(data?: IDataMappingInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.saveType = data["saveType"] !== undefined ? data["saveType"] : <any>null;
            this.orderIndex = data["orderIndex"] !== undefined ? data["orderIndex"] : <any>null;
            this.sourceName = data["sourceName"] !== undefined ? data["sourceName"] : <any>null;
            this.dimensionName = data["dimensionName"] !== undefined ? data["dimensionName"] : <any>null;
            this.sourceValue = data["sourceValue"] !== undefined ? data["sourceValue"] : <any>null;
            this.sourceSign = data["sourceSign"] !== undefined ? data["sourceSign"] : <any>null;
            this.sourceCaption = data["sourceCaption"] !== undefined ? data["sourceCaption"] : <any>null;
            this.sourceValueOriginal = data["sourceValueOriginal"] !== undefined ? data["sourceValueOriginal"] : <any>null;
            this.sourceSignOriginal = data["sourceSignOriginal"] !== undefined ? data["sourceSignOriginal"] : <any>null;
            this.dimensionNameOriginal = data["dimensionNameOriginal"] !== undefined ? data["dimensionNameOriginal"] : <any>null;
            this.targetMemberName = data["targetMemberName"] !== undefined ? data["targetMemberName"] : <any>null;
            this.caption = data["caption"] !== undefined ? data["caption"] : <any>null;
            this.mappingType = data["mappingType"] !== undefined ? data["mappingType"] : <any>null;
            this.isAiSuggestion = data["isAiSuggestion"] !== undefined ? data["isAiSuggestion"] : <any>null;
        }
    }

    static fromJS(data: any): DataMappingInfo {
        data = typeof data === 'object' ? data : {};
        let result = new DataMappingInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["saveType"] = this.saveType !== undefined ? this.saveType : <any>null;
        data["orderIndex"] = this.orderIndex !== undefined ? this.orderIndex : <any>null;
        data["sourceName"] = this.sourceName !== undefined ? this.sourceName : <any>null;
        data["dimensionName"] = this.dimensionName !== undefined ? this.dimensionName : <any>null;
        data["sourceValue"] = this.sourceValue !== undefined ? this.sourceValue : <any>null;
        data["sourceSign"] = this.sourceSign !== undefined ? this.sourceSign : <any>null;
        data["sourceCaption"] = this.sourceCaption !== undefined ? this.sourceCaption : <any>null;
        data["sourceValueOriginal"] = this.sourceValueOriginal !== undefined ? this.sourceValueOriginal : <any>null;
        data["sourceSignOriginal"] = this.sourceSignOriginal !== undefined ? this.sourceSignOriginal : <any>null;
        data["dimensionNameOriginal"] = this.dimensionNameOriginal !== undefined ? this.dimensionNameOriginal : <any>null;
        data["targetMemberName"] = this.targetMemberName !== undefined ? this.targetMemberName : <any>null;
        data["caption"] = this.caption !== undefined ? this.caption : <any>null;
        data["mappingType"] = this.mappingType !== undefined ? this.mappingType : <any>null;
        data["isAiSuggestion"] = this.isAiSuggestion !== undefined ? this.isAiSuggestion : <any>null;
        return data;
    }

    clone(): DataMappingInfo {
        const json = this.toJSON();
        let result = new DataMappingInfo();
        result.init(json);
        return result;
    }
}

export interface IDataMappingInfo {
    saveType?: string | null;
    orderIndex: number;
    sourceName?: string | null;
    dimensionName?: string | null;
    sourceValue?: string | null;
    sourceSign?: string | null;
    sourceCaption?: string | null;
    sourceValueOriginal?: string | null;
    sourceSignOriginal?: string | null;
    dimensionNameOriginal?: string | null;
    targetMemberName?: string | null;
    caption?: string | null;
    mappingType?: string | null;
    isAiSuggestion?: boolean | null;
}

export class SaveDataMappingRequest implements ISaveDataMappingRequest {
    isAppend!: boolean;
    items?: DataMappingInfo[] | null;

    constructor(data?: ISaveDataMappingRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.isAppend = data["isAppend"] !== undefined ? data["isAppend"] : <any>null;
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item in data["items"])
                    this.items!.push(DataMappingInfo.fromJS(data["items"][item]));
            }
            else {
                this.items = <any>null;
            }
        }
    }

    static fromJS(data: any): SaveDataMappingRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SaveDataMappingRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isAppend"] = this.isAppend !== undefined ? this.isAppend : <any>null;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item in this.items)
                data["items"].push(this.items[item].toJSON());
        }
        return data;
    }

    clone(): SaveDataMappingRequest {
        const json = this.toJSON();
        let result = new SaveDataMappingRequest();
        result.init(json);
        return result;
    }
}

export interface ISaveDataMappingRequest {
    isAppend: boolean;
    items?: DataMappingInfo[] | null;
}

export class MultiDimMappingsDto implements IMultiDimMappingsDto {
    sourceName?: string | null;
    sourceColumns?: SourceColumnDto[] | null;
    targetRows?: TargetRowDto[] | null;

    constructor(data?: IMultiDimMappingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.sourceName = data["sourceName"] !== undefined ? data["sourceName"] : <any>null;
            if (Array.isArray(data["sourceColumns"])) {
                this.sourceColumns = [] as any;
                for (let item in data["sourceColumns"])
                    this.sourceColumns!.push(SourceColumnDto.fromJS(data["sourceColumns"][item]));
            }
            else {
                this.sourceColumns = <any>null;
            }
            if (Array.isArray(data["targetRows"])) {
                this.targetRows = [] as any;
                for (let item in data["targetRows"])
                    this.targetRows!.push(TargetRowDto.fromJS(data["targetRows"][item]));
            }
            else {
                this.targetRows = <any>null;
            }
        }
    }

    static fromJS(data: any): MultiDimMappingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new MultiDimMappingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sourceName"] = this.sourceName !== undefined ? this.sourceName : <any>null;
        if (Array.isArray(this.sourceColumns)) {
            data["sourceColumns"] = [];
            for (let item in this.sourceColumns)
                data["sourceColumns"].push(this.sourceColumns[item].toJSON());
        }
        if (Array.isArray(this.targetRows)) {
            data["targetRows"] = [];
            for (let item in this.targetRows)
                data["targetRows"].push(this.targetRows[item].toJSON());
        }
        return data;
    }

    clone(): MultiDimMappingsDto {
        const json = this.toJSON();
        let result = new MultiDimMappingsDto();
        result.init(json);
        return result;
    }
}

export interface IMultiDimMappingsDto {
    sourceName?: string | null;
    sourceColumns?: SourceColumnDto[] | null;
    targetRows?: TargetRowDto[] | null;
}

export class SourceColumnDto implements ISourceColumnDto {
    dataMapSourceFieldId!: string;
    displayName?: string | null;

    constructor(data?: ISourceColumnDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.dataMapSourceFieldId = data["dataMapSourceFieldId"] !== undefined ? data["dataMapSourceFieldId"] : <any>null;
            this.displayName = data["displayName"] !== undefined ? data["displayName"] : <any>null;
        }
    }

    static fromJS(data: any): SourceColumnDto {
        data = typeof data === 'object' ? data : {};
        let result = new SourceColumnDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dataMapSourceFieldId"] = this.dataMapSourceFieldId !== undefined ? this.dataMapSourceFieldId : <any>null;
        data["displayName"] = this.displayName !== undefined ? this.displayName : <any>null;
        return data;
    }

    clone(): SourceColumnDto {
        const json = this.toJSON();
        let result = new SourceColumnDto();
        result.init(json);
        return result;
    }
}

export interface ISourceColumnDto {
    dataMapSourceFieldId: string;
    displayName?: string | null;
}

export class TargetRowDto implements ITargetRowDto {
    id!: string;
    targetDimension?: string | null;
    targetMember?: string | null;
    targetMemberCaption?: string | null;
    sourceSign?: string | null;
    orderIndex!: number;
    sources?: SourceCriterionDto[] | null;

    constructor(data?: ITargetRowDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"] !== undefined ? data["id"] : <any>null;
            this.targetDimension = data["targetDimension"] !== undefined ? data["targetDimension"] : <any>null;
            this.targetMember = data["targetMember"] !== undefined ? data["targetMember"] : <any>null;
            this.targetMemberCaption = data["targetMemberCaption"] !== undefined ? data["targetMemberCaption"] : <any>null;
            this.sourceSign = data["sourceSign"] !== undefined ? data["sourceSign"] : <any>null;
            this.orderIndex = data["orderIndex"] !== undefined ? data["orderIndex"] : <any>null;
            if (Array.isArray(data["sources"])) {
                this.sources = [] as any;
                for (let item in data["sources"])
                    this.sources!.push(SourceCriterionDto.fromJS(data["sources"][item]));
            }
            else {
                this.sources = <any>null;
            }
        }
    }

    static fromJS(data: any): TargetRowDto {
        data = typeof data === 'object' ? data : {};
        let result = new TargetRowDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["targetDimension"] = this.targetDimension !== undefined ? this.targetDimension : <any>null;
        data["targetMember"] = this.targetMember !== undefined ? this.targetMember : <any>null;
        data["targetMemberCaption"] = this.targetMemberCaption !== undefined ? this.targetMemberCaption : <any>null;
        data["sourceSign"] = this.sourceSign !== undefined ? this.sourceSign : <any>null;
        data["orderIndex"] = this.orderIndex !== undefined ? this.orderIndex : <any>null;
        if (Array.isArray(this.sources)) {
            data["sources"] = [];
            for (let item in this.sources)
                data["sources"].push(this.sources[item].toJSON());
        }
        return data;
    }

    clone(): TargetRowDto {
        const json = this.toJSON();
        let result = new TargetRowDto();
        result.init(json);
        return result;
    }
}

export interface ITargetRowDto {
    id: string;
    targetDimension?: string | null;
    targetMember?: string | null;
    targetMemberCaption?: string | null;
    sourceSign?: string | null;
    orderIndex: number;
    sources?: SourceCriterionDto[] | null;
}

export class SourceCriterionDto implements ISourceCriterionDto {
    dataMapSourceFieldId!: string;
    mappingType?: string | null;
    sourceValue?: string | null;
    sourceCaption?: string | null;

    constructor(data?: ISourceCriterionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.dataMapSourceFieldId = data["dataMapSourceFieldId"] !== undefined ? data["dataMapSourceFieldId"] : <any>null;
            this.mappingType = data["mappingType"] !== undefined ? data["mappingType"] : <any>null;
            this.sourceValue = data["sourceValue"] !== undefined ? data["sourceValue"] : <any>null;
            this.sourceCaption = data["sourceCaption"] !== undefined ? data["sourceCaption"] : <any>null;
        }
    }

    static fromJS(data: any): SourceCriterionDto {
        data = typeof data === 'object' ? data : {};
        let result = new SourceCriterionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dataMapSourceFieldId"] = this.dataMapSourceFieldId !== undefined ? this.dataMapSourceFieldId : <any>null;
        data["mappingType"] = this.mappingType !== undefined ? this.mappingType : <any>null;
        data["sourceValue"] = this.sourceValue !== undefined ? this.sourceValue : <any>null;
        data["sourceCaption"] = this.sourceCaption !== undefined ? this.sourceCaption : <any>null;
        return data;
    }

    clone(): SourceCriterionDto {
        const json = this.toJSON();
        let result = new SourceCriterionDto();
        result.init(json);
        return result;
    }
}

export interface ISourceCriterionDto {
    dataMapSourceFieldId: string;
    mappingType?: string | null;
    sourceValue?: string | null;
    sourceCaption?: string | null;
}

export class ProblemDetails implements IProblemDetails {
    type?: string | null;
    title?: string | null;
    status?: number | null;
    detail?: string | null;
    instance?: string | null;
    extensions!: { [key: string]: any; };

    [key: string]: any;

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.extensions = {};
        }
    }

    init(data?: any) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
            this.type = data["type"] !== undefined ? data["type"] : <any>null;
            this.title = data["title"] !== undefined ? data["title"] : <any>null;
            this.status = data["status"] !== undefined ? data["status"] : <any>null;
            this.detail = data["detail"] !== undefined ? data["detail"] : <any>null;
            this.instance = data["instance"] !== undefined ? data["instance"] : <any>null;
            if (data["extensions"]) {
                this.extensions = {} as any;
                for (let key in data["extensions"]) {
                    if (data["extensions"].hasOwnProperty(key))
                        (<any>this.extensions)![key] = data["extensions"][key] !== undefined ? data["extensions"][key] : <any>null;
                }
            }
            else {
                this.extensions = <any>null;
            }
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type !== undefined ? this.type : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["detail"] = this.detail !== undefined ? this.detail : <any>null;
        data["instance"] = this.instance !== undefined ? this.instance : <any>null;
        if (this.extensions) {
            data["extensions"] = {};
            for (let key in this.extensions) {
                if (this.extensions.hasOwnProperty(key))
                    (<any>data["extensions"])[key] = this.extensions[key] !== undefined ? this.extensions[key] : <any>null;
            }
        }
        return data;
    }

    clone(): ProblemDetails {
        const json = this.toJSON();
        let result = new ProblemDetails();
        result.init(json);
        return result;
    }
}

export interface IProblemDetails {
    type?: string | null;
    title?: string | null;
    status?: number | null;
    detail?: string | null;
    instance?: string | null;
    extensions: { [key: string]: any; };

    [key: string]: any;
}

export class EditMultiDimMappingsRequestDto implements IEditMultiDimMappingsRequestDto {
    sourceName?: string | null;
    inserts?: MultiDimRowInsertDto[] | null;
    updates?: MultiDimRowUpdateDto[] | null;
    deleteIds?: string[] | null;
    changeIndexes?: MultiDimRowChangeIndexDto[] | null;

    constructor(data?: IEditMultiDimMappingsRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.sourceName = data["sourceName"] !== undefined ? data["sourceName"] : <any>null;
            if (Array.isArray(data["inserts"])) {
                this.inserts = [] as any;
                for (let item in data["inserts"])
                    this.inserts!.push(MultiDimRowInsertDto.fromJS(data["inserts"][item]));
            }
            else {
                this.inserts = <any>null;
            }
            if (Array.isArray(data["updates"])) {
                this.updates = [] as any;
                for (let item in data["updates"])
                    this.updates!.push(MultiDimRowUpdateDto.fromJS(data["updates"][item]));
            }
            else {
                this.updates = <any>null;
            }
            if (Array.isArray(data["deleteIds"])) {
                this.deleteIds = [] as any;
                for (let item in data["deleteIds"])
                    this.deleteIds!.push(data["deleteIds"][item]);
            }
            else {
                this.deleteIds = <any>null;
            }
            if (Array.isArray(data["changeIndexes"])) {
                this.changeIndexes = [] as any;
                for (let item in data["changeIndexes"])
                    this.changeIndexes!.push(MultiDimRowChangeIndexDto.fromJS(data["changeIndexes"][item]));
            }
            else {
                this.changeIndexes = <any>null;
            }
        }
    }

    static fromJS(data: any): EditMultiDimMappingsRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditMultiDimMappingsRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sourceName"] = this.sourceName !== undefined ? this.sourceName : <any>null;
        if (Array.isArray(this.inserts)) {
            data["inserts"] = [];
            for (let item in this.inserts)
                data["inserts"].push(this.inserts[item].toJSON());
        }
        if (Array.isArray(this.updates)) {
            data["updates"] = [];
            for (let item in this.updates)
                data["updates"].push(this.updates[item].toJSON());
        }
        if (Array.isArray(this.deleteIds)) {
            data["deleteIds"] = [];
            for (let item in this.deleteIds)
                data["deleteIds"].push(this.deleteIds[item]);
        }
        if (Array.isArray(this.changeIndexes)) {
            data["changeIndexes"] = [];
            for (let item in this.changeIndexes)
                data["changeIndexes"].push(this.changeIndexes[item].toJSON());
        }
        return data;
    }

    clone(): EditMultiDimMappingsRequestDto {
        const json = this.toJSON();
        let result = new EditMultiDimMappingsRequestDto();
        result.init(json);
        return result;
    }
}

export interface IEditMultiDimMappingsRequestDto {
    sourceName?: string | null;
    inserts?: MultiDimRowInsertDto[] | null;
    updates?: MultiDimRowUpdateDto[] | null;
    deleteIds?: string[] | null;
    changeIndexes?: MultiDimRowChangeIndexDto[] | null;
}

export class MultiDimRowInsertDto implements IMultiDimRowInsertDto {
    targetDimension?: string | null;
    targetMember?: string | null;
    sourceSign?: string | null;
    orderIndex!: number;
    sources?: MultiDimSourceUpsertDto[] | null;

    constructor(data?: IMultiDimRowInsertDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.targetDimension = data["targetDimension"] !== undefined ? data["targetDimension"] : <any>null;
            this.targetMember = data["targetMember"] !== undefined ? data["targetMember"] : <any>null;
            this.sourceSign = data["sourceSign"] !== undefined ? data["sourceSign"] : <any>null;
            this.orderIndex = data["orderIndex"] !== undefined ? data["orderIndex"] : <any>null;
            if (Array.isArray(data["sources"])) {
                this.sources = [] as any;
                for (let item in data["sources"])
                    this.sources!.push(MultiDimSourceUpsertDto.fromJS(data["sources"][item]));
            }
            else {
                this.sources = <any>null;
            }
        }
    }

    static fromJS(data: any): MultiDimRowInsertDto {
        data = typeof data === 'object' ? data : {};
        let result = new MultiDimRowInsertDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["targetDimension"] = this.targetDimension !== undefined ? this.targetDimension : <any>null;
        data["targetMember"] = this.targetMember !== undefined ? this.targetMember : <any>null;
        data["sourceSign"] = this.sourceSign !== undefined ? this.sourceSign : <any>null;
        data["orderIndex"] = this.orderIndex !== undefined ? this.orderIndex : <any>null;
        if (Array.isArray(this.sources)) {
            data["sources"] = [];
            for (let item in this.sources)
                data["sources"].push(this.sources[item].toJSON());
        }
        return data;
    }

    clone(): MultiDimRowInsertDto {
        const json = this.toJSON();
        let result = new MultiDimRowInsertDto();
        result.init(json);
        return result;
    }
}

export interface IMultiDimRowInsertDto {
    targetDimension?: string | null;
    targetMember?: string | null;
    sourceSign?: string | null;
    orderIndex: number;
    sources?: MultiDimSourceUpsertDto[] | null;
}

export class MultiDimSourceUpsertDto implements IMultiDimSourceUpsertDto {
    dataMapSourceFieldId!: string;
    mappingType?: string | null;
    sourceValue?: string | null;
    sourceCaption?: string | null;

    constructor(data?: IMultiDimSourceUpsertDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.dataMapSourceFieldId = data["dataMapSourceFieldId"] !== undefined ? data["dataMapSourceFieldId"] : <any>null;
            this.mappingType = data["mappingType"] !== undefined ? data["mappingType"] : <any>null;
            this.sourceValue = data["sourceValue"] !== undefined ? data["sourceValue"] : <any>null;
            this.sourceCaption = data["sourceCaption"] !== undefined ? data["sourceCaption"] : <any>null;
        }
    }

    static fromJS(data: any): MultiDimSourceUpsertDto {
        data = typeof data === 'object' ? data : {};
        let result = new MultiDimSourceUpsertDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dataMapSourceFieldId"] = this.dataMapSourceFieldId !== undefined ? this.dataMapSourceFieldId : <any>null;
        data["mappingType"] = this.mappingType !== undefined ? this.mappingType : <any>null;
        data["sourceValue"] = this.sourceValue !== undefined ? this.sourceValue : <any>null;
        data["sourceCaption"] = this.sourceCaption !== undefined ? this.sourceCaption : <any>null;
        return data;
    }

    clone(): MultiDimSourceUpsertDto {
        const json = this.toJSON();
        let result = new MultiDimSourceUpsertDto();
        result.init(json);
        return result;
    }
}

export interface IMultiDimSourceUpsertDto {
    dataMapSourceFieldId: string;
    mappingType?: string | null;
    sourceValue?: string | null;
    sourceCaption?: string | null;
}

export class MultiDimRowUpdateDto implements IMultiDimRowUpdateDto {
    targetRowId!: string;
    targetDimension?: string | null;
    targetMember?: string | null;
    sourceSign?: string | null;
    sources?: MultiDimSourceUpsertDto[] | null;

    constructor(data?: IMultiDimRowUpdateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.targetRowId = data["targetRowId"] !== undefined ? data["targetRowId"] : <any>null;
            this.targetDimension = data["targetDimension"] !== undefined ? data["targetDimension"] : <any>null;
            this.targetMember = data["targetMember"] !== undefined ? data["targetMember"] : <any>null;
            this.sourceSign = data["sourceSign"] !== undefined ? data["sourceSign"] : <any>null;
            if (Array.isArray(data["sources"])) {
                this.sources = [] as any;
                for (let item in data["sources"])
                    this.sources!.push(MultiDimSourceUpsertDto.fromJS(data["sources"][item]));
            }
            else {
                this.sources = <any>null;
            }
        }
    }

    static fromJS(data: any): MultiDimRowUpdateDto {
        data = typeof data === 'object' ? data : {};
        let result = new MultiDimRowUpdateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["targetRowId"] = this.targetRowId !== undefined ? this.targetRowId : <any>null;
        data["targetDimension"] = this.targetDimension !== undefined ? this.targetDimension : <any>null;
        data["targetMember"] = this.targetMember !== undefined ? this.targetMember : <any>null;
        data["sourceSign"] = this.sourceSign !== undefined ? this.sourceSign : <any>null;
        if (Array.isArray(this.sources)) {
            data["sources"] = [];
            for (let item in this.sources)
                data["sources"].push(this.sources[item].toJSON());
        }
        return data;
    }

    clone(): MultiDimRowUpdateDto {
        const json = this.toJSON();
        let result = new MultiDimRowUpdateDto();
        result.init(json);
        return result;
    }
}

export interface IMultiDimRowUpdateDto {
    targetRowId: string;
    targetDimension?: string | null;
    targetMember?: string | null;
    sourceSign?: string | null;
    sources?: MultiDimSourceUpsertDto[] | null;
}

export class MultiDimRowChangeIndexDto implements IMultiDimRowChangeIndexDto {
    targetRowId!: string;
    orderIndex!: number;

    constructor(data?: IMultiDimRowChangeIndexDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.targetRowId = data["targetRowId"] !== undefined ? data["targetRowId"] : <any>null;
            this.orderIndex = data["orderIndex"] !== undefined ? data["orderIndex"] : <any>null;
        }
    }

    static fromJS(data: any): MultiDimRowChangeIndexDto {
        data = typeof data === 'object' ? data : {};
        let result = new MultiDimRowChangeIndexDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["targetRowId"] = this.targetRowId !== undefined ? this.targetRowId : <any>null;
        data["orderIndex"] = this.orderIndex !== undefined ? this.orderIndex : <any>null;
        return data;
    }

    clone(): MultiDimRowChangeIndexDto {
        const json = this.toJSON();
        let result = new MultiDimRowChangeIndexDto();
        result.init(json);
        return result;
    }
}

export interface IMultiDimRowChangeIndexDto {
    targetRowId: string;
    orderIndex: number;
}

export class DashboardExtension implements IDashboardExtension {
    id!: number;
    type?: string | null;
    label?: string | null;
    editUrl?: string | null;
    renderUrl?: string | null;
    svg?: string | null;

    constructor(data?: IDashboardExtension) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"] !== undefined ? data["id"] : <any>null;
            this.type = data["type"] !== undefined ? data["type"] : <any>null;
            this.label = data["label"] !== undefined ? data["label"] : <any>null;
            this.editUrl = data["editUrl"] !== undefined ? data["editUrl"] : <any>null;
            this.renderUrl = data["renderUrl"] !== undefined ? data["renderUrl"] : <any>null;
            this.svg = data["svg"] !== undefined ? data["svg"] : <any>null;
        }
    }

    static fromJS(data: any): DashboardExtension {
        data = typeof data === 'object' ? data : {};
        let result = new DashboardExtension();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["type"] = this.type !== undefined ? this.type : <any>null;
        data["label"] = this.label !== undefined ? this.label : <any>null;
        data["editUrl"] = this.editUrl !== undefined ? this.editUrl : <any>null;
        data["renderUrl"] = this.renderUrl !== undefined ? this.renderUrl : <any>null;
        data["svg"] = this.svg !== undefined ? this.svg : <any>null;
        return data;
    }

    clone(): DashboardExtension {
        const json = this.toJSON();
        let result = new DashboardExtension();
        result.init(json);
        return result;
    }
}

export interface IDashboardExtension {
    id: number;
    type?: string | null;
    label?: string | null;
    editUrl?: string | null;
    renderUrl?: string | null;
    svg?: string | null;
}

export class HomeExtension implements IHomeExtension {
    id!: number;
    caption?: string | null;
    url?: string | null;
    svg?: string | null;
    allowComms!: boolean;
    postJwt!: boolean;

    constructor(data?: IHomeExtension) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"] !== undefined ? data["id"] : <any>null;
            this.caption = data["caption"] !== undefined ? data["caption"] : <any>null;
            this.url = data["url"] !== undefined ? data["url"] : <any>null;
            this.svg = data["svg"] !== undefined ? data["svg"] : <any>null;
            this.allowComms = data["allowComms"] !== undefined ? data["allowComms"] : <any>null;
            this.postJwt = data["postJwt"] !== undefined ? data["postJwt"] : <any>null;
        }
    }

    static fromJS(data: any): HomeExtension {
        data = typeof data === 'object' ? data : {};
        let result = new HomeExtension();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["caption"] = this.caption !== undefined ? this.caption : <any>null;
        data["url"] = this.url !== undefined ? this.url : <any>null;
        data["svg"] = this.svg !== undefined ? this.svg : <any>null;
        data["allowComms"] = this.allowComms !== undefined ? this.allowComms : <any>null;
        data["postJwt"] = this.postJwt !== undefined ? this.postJwt : <any>null;
        return data;
    }

    clone(): HomeExtension {
        const json = this.toJSON();
        let result = new HomeExtension();
        result.init(json);
        return result;
    }
}

export interface IHomeExtension {
    id: number;
    caption?: string | null;
    url?: string | null;
    svg?: string | null;
    allowComms: boolean;
    postJwt: boolean;
}

export class IntercompanyGapResponse implements IIntercompanyGapResponse {
    entityName?: string | null;
    entityCaption?: string | null;
    entityKey?: number | null;
    intercompanyName?: string | null;
    intercompanyCaption?: string | null;
    intercompanyKey?: number | null;
    intercompanyGapAmount?: number | null;

    constructor(data?: IIntercompanyGapResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.entityName = data["entityName"] !== undefined ? data["entityName"] : <any>null;
            this.entityCaption = data["entityCaption"] !== undefined ? data["entityCaption"] : <any>null;
            this.entityKey = data["entityKey"] !== undefined ? data["entityKey"] : <any>null;
            this.intercompanyName = data["intercompanyName"] !== undefined ? data["intercompanyName"] : <any>null;
            this.intercompanyCaption = data["intercompanyCaption"] !== undefined ? data["intercompanyCaption"] : <any>null;
            this.intercompanyKey = data["intercompanyKey"] !== undefined ? data["intercompanyKey"] : <any>null;
            this.intercompanyGapAmount = data["intercompanyGapAmount"] !== undefined ? data["intercompanyGapAmount"] : <any>null;
        }
    }

    static fromJS(data: any): IntercompanyGapResponse {
        data = typeof data === 'object' ? data : {};
        let result = new IntercompanyGapResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entityName"] = this.entityName !== undefined ? this.entityName : <any>null;
        data["entityCaption"] = this.entityCaption !== undefined ? this.entityCaption : <any>null;
        data["entityKey"] = this.entityKey !== undefined ? this.entityKey : <any>null;
        data["intercompanyName"] = this.intercompanyName !== undefined ? this.intercompanyName : <any>null;
        data["intercompanyCaption"] = this.intercompanyCaption !== undefined ? this.intercompanyCaption : <any>null;
        data["intercompanyKey"] = this.intercompanyKey !== undefined ? this.intercompanyKey : <any>null;
        data["intercompanyGapAmount"] = this.intercompanyGapAmount !== undefined ? this.intercompanyGapAmount : <any>null;
        return data;
    }

    clone(): IntercompanyGapResponse {
        const json = this.toJSON();
        let result = new IntercompanyGapResponse();
        result.init(json);
        return result;
    }
}

export interface IIntercompanyGapResponse {
    entityName?: string | null;
    entityCaption?: string | null;
    entityKey?: number | null;
    intercompanyName?: string | null;
    intercompanyCaption?: string | null;
    intercompanyKey?: number | null;
    intercompanyGapAmount?: number | null;
}

export class IntercompanyGapAccountDetailResponse implements IIntercompanyGapAccountDetailResponse {
    entityName?: string | null;
    entityCaption?: string | null;
    entityKey?: number | null;
    intercompanyName?: string | null;
    intercompanyCaption?: string | null;
    intercompanyKey?: number | null;
    accountARName?: string | null;
    accountARCaption?: string | null;
    accountAPName?: string | null;
    accountAPCaption?: string | null;
    amountAR?: number | null;
    amountAP?: number | null;
    accountGap?: number | null;

    constructor(data?: IIntercompanyGapAccountDetailResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.entityName = data["entityName"] !== undefined ? data["entityName"] : <any>null;
            this.entityCaption = data["entityCaption"] !== undefined ? data["entityCaption"] : <any>null;
            this.entityKey = data["entityKey"] !== undefined ? data["entityKey"] : <any>null;
            this.intercompanyName = data["intercompanyName"] !== undefined ? data["intercompanyName"] : <any>null;
            this.intercompanyCaption = data["intercompanyCaption"] !== undefined ? data["intercompanyCaption"] : <any>null;
            this.intercompanyKey = data["intercompanyKey"] !== undefined ? data["intercompanyKey"] : <any>null;
            this.accountARName = data["accountARName"] !== undefined ? data["accountARName"] : <any>null;
            this.accountARCaption = data["accountARCaption"] !== undefined ? data["accountARCaption"] : <any>null;
            this.accountAPName = data["accountAPName"] !== undefined ? data["accountAPName"] : <any>null;
            this.accountAPCaption = data["accountAPCaption"] !== undefined ? data["accountAPCaption"] : <any>null;
            this.amountAR = data["amountAR"] !== undefined ? data["amountAR"] : <any>null;
            this.amountAP = data["amountAP"] !== undefined ? data["amountAP"] : <any>null;
            this.accountGap = data["accountGap"] !== undefined ? data["accountGap"] : <any>null;
        }
    }

    static fromJS(data: any): IntercompanyGapAccountDetailResponse {
        data = typeof data === 'object' ? data : {};
        let result = new IntercompanyGapAccountDetailResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entityName"] = this.entityName !== undefined ? this.entityName : <any>null;
        data["entityCaption"] = this.entityCaption !== undefined ? this.entityCaption : <any>null;
        data["entityKey"] = this.entityKey !== undefined ? this.entityKey : <any>null;
        data["intercompanyName"] = this.intercompanyName !== undefined ? this.intercompanyName : <any>null;
        data["intercompanyCaption"] = this.intercompanyCaption !== undefined ? this.intercompanyCaption : <any>null;
        data["intercompanyKey"] = this.intercompanyKey !== undefined ? this.intercompanyKey : <any>null;
        data["accountARName"] = this.accountARName !== undefined ? this.accountARName : <any>null;
        data["accountARCaption"] = this.accountARCaption !== undefined ? this.accountARCaption : <any>null;
        data["accountAPName"] = this.accountAPName !== undefined ? this.accountAPName : <any>null;
        data["accountAPCaption"] = this.accountAPCaption !== undefined ? this.accountAPCaption : <any>null;
        data["amountAR"] = this.amountAR !== undefined ? this.amountAR : <any>null;
        data["amountAP"] = this.amountAP !== undefined ? this.amountAP : <any>null;
        data["accountGap"] = this.accountGap !== undefined ? this.accountGap : <any>null;
        return data;
    }

    clone(): IntercompanyGapAccountDetailResponse {
        const json = this.toJSON();
        let result = new IntercompanyGapAccountDetailResponse();
        result.init(json);
        return result;
    }
}

export interface IIntercompanyGapAccountDetailResponse {
    entityName?: string | null;
    entityCaption?: string | null;
    entityKey?: number | null;
    intercompanyName?: string | null;
    intercompanyCaption?: string | null;
    intercompanyKey?: number | null;
    accountARName?: string | null;
    accountARCaption?: string | null;
    accountAPName?: string | null;
    accountAPCaption?: string | null;
    amountAR?: number | null;
    amountAP?: number | null;
    accountGap?: number | null;
}

export class FileSystemObjectBase implements IFileSystemObjectBase {
    objectType!: FileSystemType;
    textContent?: string | null;
    binaryContent?: string | null;

    constructor(data?: IFileSystemObjectBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.objectType = data["objectType"] !== undefined ? data["objectType"] : <any>null;
            this.textContent = data["textContent"] !== undefined ? data["textContent"] : <any>null;
            this.binaryContent = data["binaryContent"] !== undefined ? data["binaryContent"] : <any>null;
        }
    }

    static fromJS(data: any): FileSystemObjectBase {
        data = typeof data === 'object' ? data : {};
        let result = new FileSystemObjectBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["objectType"] = this.objectType !== undefined ? this.objectType : <any>null;
        data["textContent"] = this.textContent !== undefined ? this.textContent : <any>null;
        data["binaryContent"] = this.binaryContent !== undefined ? this.binaryContent : <any>null;
        return data;
    }

    clone(): FileSystemObjectBase {
        const json = this.toJSON();
        let result = new FileSystemObjectBase();
        result.init(json);
        return result;
    }
}

export interface IFileSystemObjectBase {
    objectType: FileSystemType;
    textContent?: string | null;
    binaryContent?: string | null;
}

export class FileSystemObject extends FileSystemObjectBase implements IFileSystemObject {
    id!: number;
    isGlobal!: boolean;
    name?: string | null;
    path?: string | null;
    isRoot!: boolean;
    parentId!: number;
    lastModified?: Date | null;
    lastModifiedBy?: string | null;
    objectRights!: AccessRights;
    folderRights!: AccessRights;
    fullPath?: string | null;

    constructor(data?: IFileSystemObject) {
        super(data);
    }

    init(data?: any) {
        super.init(data);
        if (data) {
            this.id = data["id"] !== undefined ? data["id"] : <any>null;
            this.isGlobal = data["isGlobal"] !== undefined ? data["isGlobal"] : <any>null;
            this.name = data["name"] !== undefined ? data["name"] : <any>null;
            this.path = data["path"] !== undefined ? data["path"] : <any>null;
            this.isRoot = data["isRoot"] !== undefined ? data["isRoot"] : <any>null;
            this.parentId = data["parentId"] !== undefined ? data["parentId"] : <any>null;
            this.lastModified = data["lastModified"] ? new Date(data["lastModified"].toString()) : <any>null;
            this.lastModifiedBy = data["lastModifiedBy"] !== undefined ? data["lastModifiedBy"] : <any>null;
            this.objectRights = data["objectRights"] !== undefined ? data["objectRights"] : <any>null;
            this.folderRights = data["folderRights"] !== undefined ? data["folderRights"] : <any>null;
            this.fullPath = data["fullPath"] !== undefined ? data["fullPath"] : <any>null;
        }
    }

    static fromJS(data: any): FileSystemObject {
        data = typeof data === 'object' ? data : {};
        let result = new FileSystemObject();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["isGlobal"] = this.isGlobal !== undefined ? this.isGlobal : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["path"] = this.path !== undefined ? this.path : <any>null;
        data["isRoot"] = this.isRoot !== undefined ? this.isRoot : <any>null;
        data["parentId"] = this.parentId !== undefined ? this.parentId : <any>null;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : <any>null;
        data["lastModifiedBy"] = this.lastModifiedBy !== undefined ? this.lastModifiedBy : <any>null;
        data["objectRights"] = this.objectRights !== undefined ? this.objectRights : <any>null;
        data["folderRights"] = this.folderRights !== undefined ? this.folderRights : <any>null;
        data["fullPath"] = this.fullPath !== undefined ? this.fullPath : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): FileSystemObject {
        const json = this.toJSON();
        let result = new FileSystemObject();
        result.init(json);
        return result;
    }
}

export interface IFileSystemObject extends IFileSystemObjectBase {
    id: number;
    isGlobal: boolean;
    name?: string | null;
    path?: string | null;
    isRoot: boolean;
    parentId: number;
    lastModified?: Date | null;
    lastModifiedBy?: string | null;
    objectRights: AccessRights;
    folderRights: AccessRights;
    fullPath?: string | null;
}

export class FileSystemObjectContent extends FileSystemObject implements IFileSystemObjectContent {
    textContentSize!: number;
    binaryContentSize!: number;
    folderContent?: FileSystemObjectContent[] | null;

    constructor(data?: IFileSystemObjectContent) {
        super(data);
    }

    init(data?: any) {
        super.init(data);
        if (data) {
            this.textContentSize = data["textContentSize"] !== undefined ? data["textContentSize"] : <any>null;
            this.binaryContentSize = data["binaryContentSize"] !== undefined ? data["binaryContentSize"] : <any>null;
            if (Array.isArray(data["folderContent"])) {
                this.folderContent = [] as any;
                for (let item in data["folderContent"])
                    this.folderContent!.push(FileSystemObjectContent.fromJS(data["folderContent"][item]));
            }
            else {
                this.folderContent = <any>null;
            }
        }
    }

    static fromJS(data: any): FileSystemObjectContent {
        data = typeof data === 'object' ? data : {};
        let result = new FileSystemObjectContent();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["textContentSize"] = this.textContentSize !== undefined ? this.textContentSize : <any>null;
        data["binaryContentSize"] = this.binaryContentSize !== undefined ? this.binaryContentSize : <any>null;
        if (Array.isArray(this.folderContent)) {
            data["folderContent"] = [];
            for (let item in this.folderContent)
                data["folderContent"].push(this.folderContent[item].toJSON());
        }
        super.toJSON(data);
        return data;
    }

    clone(): FileSystemObjectContent {
        const json = this.toJSON();
        let result = new FileSystemObjectContent();
        result.init(json);
        return result;
    }
}

export interface IFileSystemObjectContent extends IFileSystemObject {
    textContentSize: number;
    binaryContentSize: number;
    folderContent?: FileSystemObjectContent[] | null;
}

export enum AccessRights {
    None = 0,
    Read = 1,
    Write = 2,
}

export enum FileSystemType {
    Folder = 0,
    Form = 1,
    Process = 2,
    InteractiveProcess = 3,
    PowerBI = 4,
    Generic = 5,
    ReportBook = 6,
    DocxReport = 7,
    PptxReport = 8,
    None = 9,
    XL3 = 10,
    CalcScript = 11,
    Url = 12,
}

export class FileSystemChangeNotification implements IFileSystemChangeNotification {
    time!: Date;
    type!: ChangeType;
    uid?: string | null;
    objectName?: string | null;
    path?: string | null;
    id?: number | null;
    parentId?: number | null;
    message?: string | null;
    tenant?: string | null;

    constructor(data?: IFileSystemChangeNotification) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.time = data["time"] ? new Date(data["time"].toString()) : <any>null;
            this.type = data["type"] !== undefined ? data["type"] : <any>null;
            this.uid = data["uid"] !== undefined ? data["uid"] : <any>null;
            this.objectName = data["objectName"] !== undefined ? data["objectName"] : <any>null;
            this.path = data["path"] !== undefined ? data["path"] : <any>null;
            this.id = data["id"] !== undefined ? data["id"] : <any>null;
            this.parentId = data["parentId"] !== undefined ? data["parentId"] : <any>null;
            this.message = data["message"] !== undefined ? data["message"] : <any>null;
            this.tenant = data["tenant"] !== undefined ? data["tenant"] : <any>null;
        }
    }

    static fromJS(data: any): FileSystemChangeNotification {
        data = typeof data === 'object' ? data : {};
        let result = new FileSystemChangeNotification();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["time"] = this.time ? this.time.toISOString() : <any>null;
        data["type"] = this.type !== undefined ? this.type : <any>null;
        data["uid"] = this.uid !== undefined ? this.uid : <any>null;
        data["objectName"] = this.objectName !== undefined ? this.objectName : <any>null;
        data["path"] = this.path !== undefined ? this.path : <any>null;
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["parentId"] = this.parentId !== undefined ? this.parentId : <any>null;
        data["message"] = this.message !== undefined ? this.message : <any>null;
        data["tenant"] = this.tenant !== undefined ? this.tenant : <any>null;
        return data;
    }

    clone(): FileSystemChangeNotification {
        const json = this.toJSON();
        let result = new FileSystemChangeNotification();
        result.init(json);
        return result;
    }
}

export interface IFileSystemChangeNotification {
    time: Date;
    type: ChangeType;
    uid?: string | null;
    objectName?: string | null;
    path?: string | null;
    id?: number | null;
    parentId?: number | null;
    message?: string | null;
    tenant?: string | null;
}

export enum ChangeType {
    Create = 0,
    Delete = 1,
    Update = 2,
    Move = 3,
    Rename = 4,
    Copy = 5,
    Import = 6,
}

export enum ArchiveXL3ReportFormat {
    Pdf = 0,
    Excel = 1,
    Powerpoint = 2,
}

export class FormParameterList implements IFormParameterList {
    formId!: number;
    parameters?: FormParameter[] | null;
    currentValues?: FormParameterCurrentValue[] | null;

    constructor(data?: IFormParameterList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.formId = data["formId"] !== undefined ? data["formId"] : <any>null;
            if (Array.isArray(data["parameters"])) {
                this.parameters = [] as any;
                for (let item in data["parameters"])
                    this.parameters!.push(FormParameter.fromJS(data["parameters"][item]));
            }
            else {
                this.parameters = <any>null;
            }
            if (Array.isArray(data["currentValues"])) {
                this.currentValues = [] as any;
                for (let item in data["currentValues"])
                    this.currentValues!.push(FormParameterCurrentValue.fromJS(data["currentValues"][item]));
            }
            else {
                this.currentValues = <any>null;
            }
        }
    }

    static fromJS(data: any): FormParameterList {
        data = typeof data === 'object' ? data : {};
        let result = new FormParameterList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["formId"] = this.formId !== undefined ? this.formId : <any>null;
        if (Array.isArray(this.parameters)) {
            data["parameters"] = [];
            for (let item in this.parameters)
                data["parameters"].push(this.parameters[item].toJSON());
        }
        if (Array.isArray(this.currentValues)) {
            data["currentValues"] = [];
            for (let item in this.currentValues)
                data["currentValues"].push(this.currentValues[item].toJSON());
        }
        return data;
    }

    clone(): FormParameterList {
        const json = this.toJSON();
        let result = new FormParameterList();
        result.init(json);
        return result;
    }
}

export interface IFormParameterList {
    formId: number;
    parameters?: FormParameter[] | null;
    currentValues?: FormParameterCurrentValue[] | null;
}

export class FormParameter implements IFormParameter {
    name?: string | null;
    label?: string | null;
    display?: string | null;
    isHidden!: boolean;
    style?: string | null;
    fullTreeView!: boolean;
    isMultiSelect!: boolean;
    separator?: string | null;
    dependencies?: string[] | null;
    isPinned!: boolean;
    values?: FormParameterValue[] | null;
    currentValue?: FormParameterValue | null;

    constructor(data?: IFormParameter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"] !== undefined ? data["name"] : <any>null;
            this.label = data["label"] !== undefined ? data["label"] : <any>null;
            this.display = data["display"] !== undefined ? data["display"] : <any>null;
            this.isHidden = data["isHidden"] !== undefined ? data["isHidden"] : <any>null;
            this.style = data["style"] !== undefined ? data["style"] : <any>null;
            this.fullTreeView = data["fullTreeView"] !== undefined ? data["fullTreeView"] : <any>null;
            this.isMultiSelect = data["isMultiSelect"] !== undefined ? data["isMultiSelect"] : <any>null;
            this.separator = data["separator"] !== undefined ? data["separator"] : <any>null;
            if (Array.isArray(data["dependencies"])) {
                this.dependencies = [] as any;
                for (let item in data["dependencies"])
                    this.dependencies!.push(data["dependencies"][item]);
            }
            else {
                this.dependencies = <any>null;
            }
            this.isPinned = data["isPinned"] !== undefined ? data["isPinned"] : <any>null;
            if (Array.isArray(data["values"])) {
                this.values = [] as any;
                for (let item in data["values"])
                    this.values!.push(FormParameterValue.fromJS(data["values"][item]));
            }
            else {
                this.values = <any>null;
            }
            this.currentValue = data["currentValue"] ? FormParameterValue.fromJS(data["currentValue"]) : <any>null;
        }
    }

    static fromJS(data: any): FormParameter {
        data = typeof data === 'object' ? data : {};
        let result = new FormParameter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["label"] = this.label !== undefined ? this.label : <any>null;
        data["display"] = this.display !== undefined ? this.display : <any>null;
        data["isHidden"] = this.isHidden !== undefined ? this.isHidden : <any>null;
        data["style"] = this.style !== undefined ? this.style : <any>null;
        data["fullTreeView"] = this.fullTreeView !== undefined ? this.fullTreeView : <any>null;
        data["isMultiSelect"] = this.isMultiSelect !== undefined ? this.isMultiSelect : <any>null;
        data["separator"] = this.separator !== undefined ? this.separator : <any>null;
        if (Array.isArray(this.dependencies)) {
            data["dependencies"] = [];
            for (let item in this.dependencies)
                data["dependencies"].push(this.dependencies[item]);
        }
        data["isPinned"] = this.isPinned !== undefined ? this.isPinned : <any>null;
        if (Array.isArray(this.values)) {
            data["values"] = [];
            for (let item in this.values)
                data["values"].push(this.values[item].toJSON());
        }
        data["currentValue"] = this.currentValue ? this.currentValue.toJSON() : <any>null;
        return data;
    }

    clone(): FormParameter {
        const json = this.toJSON();
        let result = new FormParameter();
        result.init(json);
        return result;
    }
}

export interface IFormParameter {
    name?: string | null;
    label?: string | null;
    display?: string | null;
    isHidden: boolean;
    style?: string | null;
    fullTreeView: boolean;
    isMultiSelect: boolean;
    separator?: string | null;
    dependencies?: string[] | null;
    isPinned: boolean;
    values?: FormParameterValue[] | null;
    currentValue?: FormParameterValue | null;
}

export class FormParameterValue implements IFormParameterValue {
    key?: string | null;
    name?: string | null;
    caption?: string | null;
    parentKey?: string | null;
    isLeaf!: boolean;
    displayOnly!: boolean;

    constructor(data?: IFormParameterValue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.key = data["key"] !== undefined ? data["key"] : <any>null;
            this.name = data["name"] !== undefined ? data["name"] : <any>null;
            this.caption = data["caption"] !== undefined ? data["caption"] : <any>null;
            this.parentKey = data["parentKey"] !== undefined ? data["parentKey"] : <any>null;
            this.isLeaf = data["isLeaf"] !== undefined ? data["isLeaf"] : <any>null;
            this.displayOnly = data["displayOnly"] !== undefined ? data["displayOnly"] : <any>null;
        }
    }

    static fromJS(data: any): FormParameterValue {
        data = typeof data === 'object' ? data : {};
        let result = new FormParameterValue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key !== undefined ? this.key : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["caption"] = this.caption !== undefined ? this.caption : <any>null;
        data["parentKey"] = this.parentKey !== undefined ? this.parentKey : <any>null;
        data["isLeaf"] = this.isLeaf !== undefined ? this.isLeaf : <any>null;
        data["displayOnly"] = this.displayOnly !== undefined ? this.displayOnly : <any>null;
        return data;
    }

    clone(): FormParameterValue {
        const json = this.toJSON();
        let result = new FormParameterValue();
        result.init(json);
        return result;
    }
}

export interface IFormParameterValue {
    key?: string | null;
    name?: string | null;
    caption?: string | null;
    parentKey?: string | null;
    isLeaf: boolean;
    displayOnly: boolean;
}

export class FormParameterCurrentValue implements IFormParameterCurrentValue {
    name?: string | null;
    currentValue?: FormParameterValue | null;
    isPinned!: boolean;

    constructor(data?: IFormParameterCurrentValue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"] !== undefined ? data["name"] : <any>null;
            this.currentValue = data["currentValue"] ? FormParameterValue.fromJS(data["currentValue"]) : <any>null;
            this.isPinned = data["isPinned"] !== undefined ? data["isPinned"] : <any>null;
        }
    }

    static fromJS(data: any): FormParameterCurrentValue {
        data = typeof data === 'object' ? data : {};
        let result = new FormParameterCurrentValue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["currentValue"] = this.currentValue ? this.currentValue.toJSON() : <any>null;
        data["isPinned"] = this.isPinned !== undefined ? this.isPinned : <any>null;
        return data;
    }

    clone(): FormParameterCurrentValue {
        const json = this.toJSON();
        let result = new FormParameterCurrentValue();
        result.init(json);
        return result;
    }
}

export interface IFormParameterCurrentValue {
    name?: string | null;
    currentValue?: FormParameterValue | null;
    isPinned: boolean;
}

export class Exception implements IException {
    message!: string;
    innerException?: Exception | null;
    source?: string | null;
    stackTrace?: string | null;

    constructor(data?: IException) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.message = data["Message"] !== undefined ? data["Message"] : <any>null;
            this.innerException = data["InnerException"] ? Exception.fromJS(data["InnerException"]) : <any>null;
            this.source = data["Source"] !== undefined ? data["Source"] : <any>null;
            this.stackTrace = data["StackTrace"] !== undefined ? data["StackTrace"] : <any>null;
        }
    }

    static fromJS(data: any): Exception {
        data = typeof data === 'object' ? data : {};
        let result = new Exception();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Message"] = this.message !== undefined ? this.message : <any>null;
        data["InnerException"] = this.innerException ? this.innerException.toJSON() : <any>null;
        data["Source"] = this.source !== undefined ? this.source : <any>null;
        data["StackTrace"] = this.stackTrace !== undefined ? this.stackTrace : <any>null;
        return data;
    }

    clone(): Exception {
        const json = this.toJSON();
        let result = new Exception();
        result.init(json);
        return result;
    }
}

export interface IException {
    message: string;
    innerException?: Exception | null;
    source?: string | null;
    stackTrace?: string | null;
}

export class HttpStatusCodeException extends Exception implements IHttpStatusCodeException {
    statusCode!: number;

    constructor(data?: IHttpStatusCodeException) {
        super(data);
    }

    init(data?: any) {
        super.init(data);
        if (data) {
            this.statusCode = data["statusCode"] !== undefined ? data["statusCode"] : <any>null;
        }
    }

    static fromJS(data: any): HttpStatusCodeException {
        data = typeof data === 'object' ? data : {};
        let result = new HttpStatusCodeException();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode !== undefined ? this.statusCode : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): HttpStatusCodeException {
        const json = this.toJSON();
        let result = new HttpStatusCodeException();
        result.init(json);
        return result;
    }
}

export interface IHttpStatusCodeException extends IException {
    statusCode: number;
}

export class QueryResult implements IQueryResult {

    [key: string]: any;

    constructor(data?: IQueryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }

    static fromJS(data: any): QueryResult {
        data = typeof data === 'object' ? data : {};
        let result = new QueryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        return data;
    }

    clone(): QueryResult {
        const json = this.toJSON();
        let result = new QueryResult();
        result.init(json);
        return result;
    }
}

export interface IQueryResult {

    [key: string]: any;
}

export class DrillDownResult implements IDrillDownResult {
    columnDataType?: string[] | null;
    resultRows?: DrillDownResultRow[] | null;

    constructor(data?: IDrillDownResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (Array.isArray(data["columnDataType"])) {
                this.columnDataType = [] as any;
                for (let item in data["columnDataType"])
                    this.columnDataType!.push(data["columnDataType"][item]);
            }
            else {
                this.columnDataType = <any>null;
            }
            if (Array.isArray(data["resultRows"])) {
                this.resultRows = [] as any;
                for (let item in data["resultRows"])
                    this.resultRows!.push(DrillDownResultRow.fromJS(data["resultRows"][item]));
            }
            else {
                this.resultRows = <any>null;
            }
        }
    }

    static fromJS(data: any): DrillDownResult {
        data = typeof data === 'object' ? data : {};
        let result = new DrillDownResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.columnDataType)) {
            data["columnDataType"] = [];
            for (let item in this.columnDataType)
                data["columnDataType"].push(this.columnDataType[item]);
        }
        if (Array.isArray(this.resultRows)) {
            data["resultRows"] = [];
            for (let item in this.resultRows)
                data["resultRows"].push(this.resultRows[item].toJSON());
        }
        return data;
    }

    clone(): DrillDownResult {
        const json = this.toJSON();
        let result = new DrillDownResult();
        result.init(json);
        return result;
    }
}

export interface IDrillDownResult {
    columnDataType?: string[] | null;
    resultRows?: DrillDownResultRow[] | null;
}

export class DrillDownResultRow implements IDrillDownResultRow {
    rowMetadata?: AxisTuple | null;
    data?: string[] | null;

    constructor(data?: IDrillDownResultRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.rowMetadata = data["rowMetadata"] ? AxisTuple.fromJS(data["rowMetadata"]) : <any>null;
            if (Array.isArray(data["data"])) {
                this.data = [] as any;
                for (let item in data["data"])
                    this.data!.push(data["data"][item]);
            }
            else {
                this.data = <any>null;
            }
        }
    }

    static fromJS(data: any): DrillDownResultRow {
        data = typeof data === 'object' ? data : {};
        let result = new DrillDownResultRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rowMetadata"] = this.rowMetadata ? this.rowMetadata.toJSON() : <any>null;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item in this.data)
                data["data"].push(this.data[item]);
        }
        return data;
    }

    clone(): DrillDownResultRow {
        const json = this.toJSON();
        let result = new DrillDownResultRow();
        result.init(json);
        return result;
    }
}

export interface IDrillDownResultRow {
    rowMetadata?: AxisTuple | null;
    data?: string[] | null;
}

export class AxisTuple implements IAxisTuple {
    keys?: number[] | null;
    names?: string[] | null;
    levels?: number[] | null;
    dimensions?: string[] | null;
    hierarchies?: string[] | null;
    attributes?: { [key: string]: any; } | null;
    dataType?: string | null;
    measureIndex!: number;
    queryRange!: number;

    constructor(data?: IAxisTuple) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (Array.isArray(data["keys"])) {
                this.keys = [] as any;
                for (let item in data["keys"])
                    this.keys!.push(data["keys"][item]);
            }
            else {
                this.keys = <any>null;
            }
            if (Array.isArray(data["names"])) {
                this.names = [] as any;
                for (let item in data["names"])
                    this.names!.push(data["names"][item]);
            }
            else {
                this.names = <any>null;
            }
            if (Array.isArray(data["levels"])) {
                this.levels = [] as any;
                for (let item in data["levels"])
                    this.levels!.push(data["levels"][item]);
            }
            else {
                this.levels = <any>null;
            }
            if (Array.isArray(data["dimensions"])) {
                this.dimensions = [] as any;
                for (let item in data["dimensions"])
                    this.dimensions!.push(data["dimensions"][item]);
            }
            else {
                this.dimensions = <any>null;
            }
            if (Array.isArray(data["hierarchies"])) {
                this.hierarchies = [] as any;
                for (let item in data["hierarchies"])
                    this.hierarchies!.push(data["hierarchies"][item]);
            }
            else {
                this.hierarchies = <any>null;
            }
            if (data["attributes"]) {
                this.attributes = {} as any;
                for (let key in data["attributes"]) {
                    if (data["attributes"].hasOwnProperty(key))
                        (<any>this.attributes)![key] = data["attributes"][key] !== undefined ? data["attributes"][key] : <any>null;
                }
            }
            else {
                this.attributes = <any>null;
            }
            this.dataType = data["dataType"] !== undefined ? data["dataType"] : <any>null;
            this.measureIndex = data["measureIndex"] !== undefined ? data["measureIndex"] : <any>null;
            this.queryRange = data["queryRange"] !== undefined ? data["queryRange"] : <any>null;
        }
    }

    static fromJS(data: any): AxisTuple {
        data = typeof data === 'object' ? data : {};
        let result = new AxisTuple();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.keys)) {
            data["keys"] = [];
            for (let item in this.keys)
                data["keys"].push(this.keys[item]);
        }
        if (Array.isArray(this.names)) {
            data["names"] = [];
            for (let item in this.names)
                data["names"].push(this.names[item]);
        }
        if (Array.isArray(this.levels)) {
            data["levels"] = [];
            for (let item in this.levels)
                data["levels"].push(this.levels[item]);
        }
        if (Array.isArray(this.dimensions)) {
            data["dimensions"] = [];
            for (let item in this.dimensions)
                data["dimensions"].push(this.dimensions[item]);
        }
        if (Array.isArray(this.hierarchies)) {
            data["hierarchies"] = [];
            for (let item in this.hierarchies)
                data["hierarchies"].push(this.hierarchies[item]);
        }
        if (this.attributes) {
            data["attributes"] = {};
            for (let key in this.attributes) {
                if (this.attributes.hasOwnProperty(key))
                    (<any>data["attributes"])[key] = this.attributes[key] !== undefined ? this.attributes[key] : <any>null;
            }
        }
        data["dataType"] = this.dataType !== undefined ? this.dataType : <any>null;
        data["measureIndex"] = this.measureIndex !== undefined ? this.measureIndex : <any>null;
        data["queryRange"] = this.queryRange !== undefined ? this.queryRange : <any>null;
        return data;
    }

    clone(): AxisTuple {
        const json = this.toJSON();
        let result = new AxisTuple();
        result.init(json);
        return result;
    }
}

export interface IAxisTuple {
    keys?: number[] | null;
    names?: string[] | null;
    levels?: number[] | null;
    dimensions?: string[] | null;
    hierarchies?: string[] | null;
    attributes?: { [key: string]: any; } | null;
    dataType?: string | null;
    measureIndex: number;
    queryRange: number;
}

export class DrillDownRequest implements IDrillDownRequest {
    rowTuples?: number[][] | null;
    columnTuples?: number[][] | null;
    slicerTuple?: number[] | null;
    drillDimension?: string | null;

    constructor(data?: IDrillDownRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (Array.isArray(data["rowTuples"])) {
                this.rowTuples = [] as any;
                for (let item in data["rowTuples"])
                    this.rowTuples!.push(data["rowTuples"][item]);
            }
            else {
                this.rowTuples = <any>null;
            }
            if (Array.isArray(data["columnTuples"])) {
                this.columnTuples = [] as any;
                for (let item in data["columnTuples"])
                    this.columnTuples!.push(data["columnTuples"][item]);
            }
            else {
                this.columnTuples = <any>null;
            }
            if (Array.isArray(data["slicerTuple"])) {
                this.slicerTuple = [] as any;
                for (let item in data["slicerTuple"])
                    this.slicerTuple!.push(data["slicerTuple"][item]);
            }
            else {
                this.slicerTuple = <any>null;
            }
            this.drillDimension = data["drillDimension"] !== undefined ? data["drillDimension"] : <any>null;
        }
    }

    static fromJS(data: any): DrillDownRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DrillDownRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rowTuples)) {
            data["rowTuples"] = [];
            for (let item in this.rowTuples)
                data["rowTuples"].push(this.rowTuples[item]);
        }
        if (Array.isArray(this.columnTuples)) {
            data["columnTuples"] = [];
            for (let item in this.columnTuples)
                data["columnTuples"].push(this.columnTuples[item]);
        }
        if (Array.isArray(this.slicerTuple)) {
            data["slicerTuple"] = [];
            for (let item in this.slicerTuple)
                data["slicerTuple"].push(this.slicerTuple[item]);
        }
        data["drillDimension"] = this.drillDimension !== undefined ? this.drillDimension : <any>null;
        return data;
    }

    clone(): DrillDownRequest {
        const json = this.toJSON();
        let result = new DrillDownRequest();
        result.init(json);
        return result;
    }
}

export interface IDrillDownRequest {
    rowTuples?: number[][] | null;
    columnTuples?: number[][] | null;
    slicerTuple?: number[] | null;
    drillDimension?: string | null;
}

export class AuditEntryId implements IAuditEntryId {
    id?: string | null;
    timestamp!: Date;
    userDisplayName?: string | null;

    constructor(data?: IAuditEntryId) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"] !== undefined ? data["id"] : <any>null;
            this.timestamp = data["timestamp"] ? new Date(data["timestamp"].toString()) : <any>null;
            this.userDisplayName = data["userDisplayName"] !== undefined ? data["userDisplayName"] : <any>null;
        }
    }

    static fromJS(data: any): AuditEntryId {
        data = typeof data === 'object' ? data : {};
        let result = new AuditEntryId();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["timestamp"] = this.timestamp ? this.timestamp.toISOString() : <any>null;
        data["userDisplayName"] = this.userDisplayName !== undefined ? this.userDisplayName : <any>null;
        return data;
    }

    clone(): AuditEntryId {
        const json = this.toJSON();
        let result = new AuditEntryId();
        result.init(json);
        return result;
    }
}

export interface IAuditEntryId {
    id?: string | null;
    timestamp: Date;
    userDisplayName?: string | null;
}

export class ModelAuditEntry implements IModelAuditEntry {
    timestamp!: Date;
    user?: string | null;
    newValue?: string | null;
    modelAuditEntryType?: string | null;
    formId!: number;
    formAuditId?: string | null;
    formName?: string | null;

    constructor(data?: IModelAuditEntry) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.timestamp = data["timestamp"] ? new Date(data["timestamp"].toString()) : <any>null;
            this.user = data["user"] !== undefined ? data["user"] : <any>null;
            this.newValue = data["newValue"] !== undefined ? data["newValue"] : <any>null;
            this.modelAuditEntryType = data["modelAuditEntryType"] !== undefined ? data["modelAuditEntryType"] : <any>null;
            this.formId = data["formId"] !== undefined ? data["formId"] : <any>null;
            this.formAuditId = data["formAuditId"] !== undefined ? data["formAuditId"] : <any>null;
            this.formName = data["formName"] !== undefined ? data["formName"] : <any>null;
        }
    }

    static fromJS(data: any): ModelAuditEntry {
        data = typeof data === 'object' ? data : {};
        let result = new ModelAuditEntry();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["timestamp"] = this.timestamp ? this.timestamp.toISOString() : <any>null;
        data["user"] = this.user !== undefined ? this.user : <any>null;
        data["newValue"] = this.newValue !== undefined ? this.newValue : <any>null;
        data["modelAuditEntryType"] = this.modelAuditEntryType !== undefined ? this.modelAuditEntryType : <any>null;
        data["formId"] = this.formId !== undefined ? this.formId : <any>null;
        data["formAuditId"] = this.formAuditId !== undefined ? this.formAuditId : <any>null;
        data["formName"] = this.formName !== undefined ? this.formName : <any>null;
        return data;
    }

    clone(): ModelAuditEntry {
        const json = this.toJSON();
        let result = new ModelAuditEntry();
        result.init(json);
        return result;
    }
}

export interface IModelAuditEntry {
    timestamp: Date;
    user?: string | null;
    newValue?: string | null;
    modelAuditEntryType?: string | null;
    formId: number;
    formAuditId?: string | null;
    formName?: string | null;
}

export class LIDResult implements ILIDResult {
    result!: LIDQueryResult;
    rows?: LIDRow[] | null;

    constructor(data?: ILIDResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.result = data["result"] !== undefined ? data["result"] : <any>null;
            if (Array.isArray(data["rows"])) {
                this.rows = [] as any;
                for (let item in data["rows"])
                    this.rows!.push(LIDRow.fromJS(data["rows"][item]));
            }
            else {
                this.rows = <any>null;
            }
        }
    }

    static fromJS(data: any): LIDResult {
        data = typeof data === 'object' ? data : {};
        let result = new LIDResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result !== undefined ? this.result : <any>null;
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item in this.rows)
                data["rows"].push(this.rows[item].toJSON());
        }
        return data;
    }

    clone(): LIDResult {
        const json = this.toJSON();
        let result = new LIDResult();
        result.init(json);
        return result;
    }
}

export interface ILIDResult {
    result: LIDQueryResult;
    rows?: LIDRow[] | null;
}

export enum LIDQueryResult {
    Success = 1,
    NoRequestData = 2,
    NotLeaf = 3,
}

export class LIDRow implements ILIDRow {
    rowRangeNo!: number;
    rowIndex!: number;
    description?: string | null;
    columnRangeNo?: number[] | null;
    columnIndex?: number[] | null;
    values?: string[] | null;

    constructor(data?: ILIDRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.rowRangeNo = data["rowRangeNo"] !== undefined ? data["rowRangeNo"] : <any>null;
            this.rowIndex = data["rowIndex"] !== undefined ? data["rowIndex"] : <any>null;
            this.description = data["description"] !== undefined ? data["description"] : <any>null;
            if (Array.isArray(data["columnRangeNo"])) {
                this.columnRangeNo = [] as any;
                for (let item in data["columnRangeNo"])
                    this.columnRangeNo!.push(data["columnRangeNo"][item]);
            }
            else {
                this.columnRangeNo = <any>null;
            }
            if (Array.isArray(data["columnIndex"])) {
                this.columnIndex = [] as any;
                for (let item in data["columnIndex"])
                    this.columnIndex!.push(data["columnIndex"][item]);
            }
            else {
                this.columnIndex = <any>null;
            }
            if (Array.isArray(data["values"])) {
                this.values = [] as any;
                for (let item in data["values"])
                    this.values!.push(data["values"][item]);
            }
            else {
                this.values = <any>null;
            }
        }
    }

    static fromJS(data: any): LIDRow {
        data = typeof data === 'object' ? data : {};
        let result = new LIDRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rowRangeNo"] = this.rowRangeNo !== undefined ? this.rowRangeNo : <any>null;
        data["rowIndex"] = this.rowIndex !== undefined ? this.rowIndex : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        if (Array.isArray(this.columnRangeNo)) {
            data["columnRangeNo"] = [];
            for (let item in this.columnRangeNo)
                data["columnRangeNo"].push(this.columnRangeNo[item]);
        }
        if (Array.isArray(this.columnIndex)) {
            data["columnIndex"] = [];
            for (let item in this.columnIndex)
                data["columnIndex"].push(this.columnIndex[item]);
        }
        if (Array.isArray(this.values)) {
            data["values"] = [];
            for (let item in this.values)
                data["values"].push(this.values[item]);
        }
        return data;
    }

    clone(): LIDRow {
        const json = this.toJSON();
        let result = new LIDRow();
        result.init(json);
        return result;
    }
}

export interface ILIDRow {
    rowRangeNo: number;
    rowIndex: number;
    description?: string | null;
    columnRangeNo?: number[] | null;
    columnIndex?: number[] | null;
    values?: string[] | null;
}

export class LIDRequest implements ILIDRequest {
    rowTuple?: VisibleAxisTuple | null;
    columnTuples?: VisibleAxisTuple[][] | null;
    slicerTuple?: SlicerTuple[] | null;

    constructor(data?: ILIDRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.rowTuple = data["rowTuple"] ? VisibleAxisTuple.fromJS(data["rowTuple"]) : <any>null;
            if (Array.isArray(data["columnTuples"])) {
                this.columnTuples = [] as any;
                for (let item in data["columnTuples"])
                    this.columnTuples!.push(data["columnTuples"][item]);
            }
            else {
                this.columnTuples = <any>null;
            }
            if (Array.isArray(data["slicerTuple"])) {
                this.slicerTuple = [] as any;
                for (let item in data["slicerTuple"])
                    this.slicerTuple!.push(SlicerTuple.fromJS(data["slicerTuple"][item]));
            }
            else {
                this.slicerTuple = <any>null;
            }
        }
    }

    static fromJS(data: any): LIDRequest {
        data = typeof data === 'object' ? data : {};
        let result = new LIDRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rowTuple"] = this.rowTuple ? this.rowTuple.toJSON() : <any>null;
        if (Array.isArray(this.columnTuples)) {
            data["columnTuples"] = [];
            for (let item in this.columnTuples)
                data["columnTuples"].push(this.columnTuples[item]);
        }
        if (Array.isArray(this.slicerTuple)) {
            data["slicerTuple"] = [];
            for (let item in this.slicerTuple)
                data["slicerTuple"].push(this.slicerTuple[item].toJSON());
        }
        return data;
    }

    clone(): LIDRequest {
        const json = this.toJSON();
        let result = new LIDRequest();
        result.init(json);
        return result;
    }
}

export interface ILIDRequest {
    rowTuple?: VisibleAxisTuple | null;
    columnTuples?: VisibleAxisTuple[][] | null;
    slicerTuple?: SlicerTuple[] | null;
}

export class VisibleAxisTuple implements IVisibleAxisTuple {
    tuple?: DimensionMember[] | null;
    dimensionCount!: number;

    constructor(data?: IVisibleAxisTuple) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (Array.isArray(data["tuple"])) {
                this.tuple = [] as any;
                for (let item in data["tuple"])
                    this.tuple!.push(DimensionMember.fromJS(data["tuple"][item]));
            }
            else {
                this.tuple = <any>null;
            }
            this.dimensionCount = data["dimensionCount"] !== undefined ? data["dimensionCount"] : <any>null;
        }
    }

    static fromJS(data: any): VisibleAxisTuple {
        data = typeof data === 'object' ? data : {};
        let result = new VisibleAxisTuple();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.tuple)) {
            data["tuple"] = [];
            for (let item in this.tuple)
                data["tuple"].push(this.tuple[item].toJSON());
        }
        data["dimensionCount"] = this.dimensionCount !== undefined ? this.dimensionCount : <any>null;
        return data;
    }

    clone(): VisibleAxisTuple {
        const json = this.toJSON();
        let result = new VisibleAxisTuple();
        result.init(json);
        return result;
    }
}

export interface IVisibleAxisTuple {
    tuple?: DimensionMember[] | null;
    dimensionCount: number;
}

export class DimensionMember implements IDimensionMember {
    key!: number;
    name?: string | null;
    level!: number;

    constructor(data?: IDimensionMember) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.key = data["key"] !== undefined ? data["key"] : <any>null;
            this.name = data["name"] !== undefined ? data["name"] : <any>null;
            this.level = data["level"] !== undefined ? data["level"] : <any>null;
        }
    }

    static fromJS(data: any): DimensionMember {
        data = typeof data === 'object' ? data : {};
        let result = new DimensionMember();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key !== undefined ? this.key : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["level"] = this.level !== undefined ? this.level : <any>null;
        return data;
    }

    clone(): DimensionMember {
        const json = this.toJSON();
        let result = new DimensionMember();
        result.init(json);
        return result;
    }
}

export interface IDimensionMember {
    key: number;
    name?: string | null;
    level: number;
}

export class SlicerTuple implements ISlicerTuple {
    dimension?: string | null;
    hierarchy?: string | null;
    key!: number;
    name?: string | null;

    constructor(data?: ISlicerTuple) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.dimension = data["dimension"] !== undefined ? data["dimension"] : <any>null;
            this.hierarchy = data["hierarchy"] !== undefined ? data["hierarchy"] : <any>null;
            this.key = data["key"] !== undefined ? data["key"] : <any>null;
            this.name = data["name"] !== undefined ? data["name"] : <any>null;
        }
    }

    static fromJS(data: any): SlicerTuple {
        data = typeof data === 'object' ? data : {};
        let result = new SlicerTuple();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dimension"] = this.dimension !== undefined ? this.dimension : <any>null;
        data["hierarchy"] = this.hierarchy !== undefined ? this.hierarchy : <any>null;
        data["key"] = this.key !== undefined ? this.key : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        return data;
    }

    clone(): SlicerTuple {
        const json = this.toJSON();
        let result = new SlicerTuple();
        result.init(json);
        return result;
    }
}

export interface ISlicerTuple {
    dimension?: string | null;
    hierarchy?: string | null;
    key: number;
    name?: string | null;
}

export class ModelQueryResult implements IModelQueryResult {
    rows!: number;
    columns!: number;
    axes?: number[] | null;
    rowDimensions?: ModelQueryResultDimension[] | null;
    columnDimensions?: ModelQueryResultDimension[] | null;
    axisDimensions?: ModelQueryResultDimension[][] | null;
    slicerDimensions?: ModelQueryResultDimension[] | null;
    data?: ModelQueryResultData[] | null;

    constructor(data?: IModelQueryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.rows = data["rows"] !== undefined ? data["rows"] : <any>null;
            this.columns = data["columns"] !== undefined ? data["columns"] : <any>null;
            if (Array.isArray(data["axes"])) {
                this.axes = [] as any;
                for (let item in data["axes"])
                    this.axes!.push(data["axes"][item]);
            }
            else {
                this.axes = <any>null;
            }
            if (Array.isArray(data["rowDimensions"])) {
                this.rowDimensions = [] as any;
                for (let item in data["rowDimensions"])
                    this.rowDimensions!.push(ModelQueryResultDimension.fromJS(data["rowDimensions"][item]));
            }
            else {
                this.rowDimensions = <any>null;
            }
            if (Array.isArray(data["columnDimensions"])) {
                this.columnDimensions = [] as any;
                for (let item in data["columnDimensions"])
                    this.columnDimensions!.push(ModelQueryResultDimension.fromJS(data["columnDimensions"][item]));
            }
            else {
                this.columnDimensions = <any>null;
            }
            if (Array.isArray(data["axisDimensions"])) {
                this.axisDimensions = [] as any;
                for (let item in data["axisDimensions"])
                    this.axisDimensions!.push(data["axisDimensions"][item]);
            }
            else {
                this.axisDimensions = <any>null;
            }
            if (Array.isArray(data["slicerDimensions"])) {
                this.slicerDimensions = [] as any;
                for (let item in data["slicerDimensions"])
                    this.slicerDimensions!.push(ModelQueryResultDimension.fromJS(data["slicerDimensions"][item]));
            }
            else {
                this.slicerDimensions = <any>null;
            }
            if (Array.isArray(data["data"])) {
                this.data = [] as any;
                for (let item in data["data"])
                    this.data!.push(ModelQueryResultData.fromJS(data["data"][item]));
            }
            else {
                this.data = <any>null;
            }
        }
    }

    static fromJS(data: any): ModelQueryResult {
        data = typeof data === 'object' ? data : {};
        let result = new ModelQueryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rows"] = this.rows !== undefined ? this.rows : <any>null;
        data["columns"] = this.columns !== undefined ? this.columns : <any>null;
        if (Array.isArray(this.axes)) {
            data["axes"] = [];
            for (let item in this.axes)
                data["axes"].push(this.axes[item]);
        }
        if (Array.isArray(this.rowDimensions)) {
            data["rowDimensions"] = [];
            for (let item in this.rowDimensions)
                data["rowDimensions"].push(this.rowDimensions[item].toJSON());
        }
        if (Array.isArray(this.columnDimensions)) {
            data["columnDimensions"] = [];
            for (let item in this.columnDimensions)
                data["columnDimensions"].push(this.columnDimensions[item].toJSON());
        }
        if (Array.isArray(this.axisDimensions)) {
            data["axisDimensions"] = [];
            for (let item in this.axisDimensions)
                data["axisDimensions"].push(this.axisDimensions[item]);
        }
        if (Array.isArray(this.slicerDimensions)) {
            data["slicerDimensions"] = [];
            for (let item in this.slicerDimensions)
                data["slicerDimensions"].push(this.slicerDimensions[item].toJSON());
        }
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item in this.data)
                data["data"].push(this.data[item].toJSON());
        }
        return data;
    }

    clone(): ModelQueryResult {
        const json = this.toJSON();
        let result = new ModelQueryResult();
        result.init(json);
        return result;
    }
}

export interface IModelQueryResult {
    rows: number;
    columns: number;
    axes?: number[] | null;
    rowDimensions?: ModelQueryResultDimension[] | null;
    columnDimensions?: ModelQueryResultDimension[] | null;
    axisDimensions?: ModelQueryResultDimension[][] | null;
    slicerDimensions?: ModelQueryResultDimension[] | null;
    data?: ModelQueryResultData[] | null;
}

export class ModelQueryResultDimension implements IModelQueryResultDimension {
    name?: string | null;
    metaData?: ModelQueryResultDimensionMeta[] | null;

    constructor(data?: IModelQueryResultDimension) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"] !== undefined ? data["name"] : <any>null;
            if (Array.isArray(data["metaData"])) {
                this.metaData = [] as any;
                for (let item in data["metaData"])
                    this.metaData!.push(ModelQueryResultDimensionMeta.fromJS(data["metaData"][item]));
            }
            else {
                this.metaData = <any>null;
            }
        }
    }

    static fromJS(data: any): ModelQueryResultDimension {
        data = typeof data === 'object' ? data : {};
        let result = new ModelQueryResultDimension();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        if (Array.isArray(this.metaData)) {
            data["metaData"] = [];
            for (let item in this.metaData)
                data["metaData"].push(this.metaData[item].toJSON());
        }
        return data;
    }

    clone(): ModelQueryResultDimension {
        const json = this.toJSON();
        let result = new ModelQueryResultDimension();
        result.init(json);
        return result;
    }
}

export interface IModelQueryResultDimension {
    name?: string | null;
    metaData?: ModelQueryResultDimensionMeta[] | null;
}

export class ModelQueryResultDimensionMeta implements IModelQueryResultDimensionMeta {
    index!: number;
    attributes?: { [key: string]: any; } | null;

    constructor(data?: IModelQueryResultDimensionMeta) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.index = data["index"] !== undefined ? data["index"] : <any>null;
            if (data["attributes"]) {
                this.attributes = {} as any;
                for (let key in data["attributes"]) {
                    if (data["attributes"].hasOwnProperty(key))
                        (<any>this.attributes)![key] = data["attributes"][key] !== undefined ? data["attributes"][key] : <any>null;
                }
            }
            else {
                this.attributes = <any>null;
            }
        }
    }

    static fromJS(data: any): ModelQueryResultDimensionMeta {
        data = typeof data === 'object' ? data : {};
        let result = new ModelQueryResultDimensionMeta();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["index"] = this.index !== undefined ? this.index : <any>null;
        if (this.attributes) {
            data["attributes"] = {};
            for (let key in this.attributes) {
                if (this.attributes.hasOwnProperty(key))
                    (<any>data["attributes"])[key] = this.attributes[key] !== undefined ? this.attributes[key] : <any>null;
            }
        }
        return data;
    }

    clone(): ModelQueryResultDimensionMeta {
        const json = this.toJSON();
        let result = new ModelQueryResultDimensionMeta();
        result.init(json);
        return result;
    }
}

export interface IModelQueryResultDimensionMeta {
    index: number;
    attributes?: { [key: string]: any; } | null;
}

export class ModelQueryResultData implements IModelQueryResultData {
    rowIndex!: number;
    columnIndex!: number;
    axisIndex?: number[] | null;
    data?: any | null;
    updateable?: boolean | null;

    constructor(data?: IModelQueryResultData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.rowIndex = data["rowIndex"] !== undefined ? data["rowIndex"] : <any>null;
            this.columnIndex = data["columnIndex"] !== undefined ? data["columnIndex"] : <any>null;
            if (Array.isArray(data["axisIndex"])) {
                this.axisIndex = [] as any;
                for (let item in data["axisIndex"])
                    this.axisIndex!.push(data["axisIndex"][item]);
            }
            else {
                this.axisIndex = <any>null;
            }
            this.data = data["data"] !== undefined ? data["data"] : <any>null;
            this.updateable = data["updateable"] !== undefined ? data["updateable"] : <any>null;
        }
    }

    static fromJS(data: any): ModelQueryResultData {
        data = typeof data === 'object' ? data : {};
        let result = new ModelQueryResultData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rowIndex"] = this.rowIndex !== undefined ? this.rowIndex : <any>null;
        data["columnIndex"] = this.columnIndex !== undefined ? this.columnIndex : <any>null;
        if (Array.isArray(this.axisIndex)) {
            data["axisIndex"] = [];
            for (let item in this.axisIndex)
                data["axisIndex"].push(this.axisIndex[item]);
        }
        data["data"] = this.data !== undefined ? this.data : <any>null;
        data["updateable"] = this.updateable !== undefined ? this.updateable : <any>null;
        return data;
    }

    clone(): ModelQueryResultData {
        const json = this.toJSON();
        let result = new ModelQueryResultData();
        result.init(json);
        return result;
    }
}

export interface IModelQueryResultData {
    rowIndex: number;
    columnIndex: number;
    axisIndex?: number[] | null;
    data?: any | null;
    updateable?: boolean | null;
}

export class JournalDefinition implements IJournalDefinition {
    id!: number;
    name?: string | null;
    model?: string | null;
    dimensions?: JournalDimension[] | null;
    incomplete!: boolean;
    missingDims?: string[] | null;

    constructor(data?: IJournalDefinition) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"] !== undefined ? data["id"] : <any>null;
            this.name = data["name"] !== undefined ? data["name"] : <any>null;
            this.model = data["model"] !== undefined ? data["model"] : <any>null;
            if (Array.isArray(data["dimensions"])) {
                this.dimensions = [] as any;
                for (let item in data["dimensions"])
                    this.dimensions!.push(JournalDimension.fromJS(data["dimensions"][item]));
            }
            else {
                this.dimensions = <any>null;
            }
            this.incomplete = data["incomplete"] !== undefined ? data["incomplete"] : <any>null;
            if (Array.isArray(data["missingDims"])) {
                this.missingDims = [] as any;
                for (let item in data["missingDims"])
                    this.missingDims!.push(data["missingDims"][item]);
            }
            else {
                this.missingDims = <any>null;
            }
        }
    }

    static fromJS(data: any): JournalDefinition {
        data = typeof data === 'object' ? data : {};
        let result = new JournalDefinition();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["model"] = this.model !== undefined ? this.model : <any>null;
        if (Array.isArray(this.dimensions)) {
            data["dimensions"] = [];
            for (let item in this.dimensions)
                data["dimensions"].push(this.dimensions[item].toJSON());
        }
        data["incomplete"] = this.incomplete !== undefined ? this.incomplete : <any>null;
        if (Array.isArray(this.missingDims)) {
            data["missingDims"] = [];
            for (let item in this.missingDims)
                data["missingDims"].push(this.missingDims[item]);
        }
        return data;
    }

    clone(): JournalDefinition {
        const json = this.toJSON();
        let result = new JournalDefinition();
        result.init(json);
        return result;
    }
}

export interface IJournalDefinition {
    id: number;
    name?: string | null;
    model?: string | null;
    dimensions?: JournalDimension[] | null;
    incomplete: boolean;
    missingDims?: string[] | null;
}

export class JournalDimension implements IJournalDimension {
    id!: number;
    dimensionName?: string | null;
    isTimeDimension!: boolean;
    isAccountDimension!: boolean;
    isHeader!: boolean;
    isHidden!: boolean;
    isDetail!: boolean;
    isInitialQuery!: boolean;
    defaultValue?: string | null;
    defaultQueryValue?: string | null;
    constantValue?: string | null;
    atributeFilter?: string | null;
    descendentsFilter?: string | null;
    isMultiSelect!: boolean;
    timeBasedHierarchy!: boolean;
    nonLeafDataMembers!: boolean;
    role?: string | null;

    constructor(data?: IJournalDimension) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"] !== undefined ? data["id"] : <any>null;
            this.dimensionName = data["dimensionName"] !== undefined ? data["dimensionName"] : <any>null;
            this.isTimeDimension = data["isTimeDimension"] !== undefined ? data["isTimeDimension"] : <any>null;
            this.isAccountDimension = data["isAccountDimension"] !== undefined ? data["isAccountDimension"] : <any>null;
            this.isHeader = data["isHeader"] !== undefined ? data["isHeader"] : <any>null;
            this.isHidden = data["isHidden"] !== undefined ? data["isHidden"] : <any>null;
            this.isDetail = data["isDetail"] !== undefined ? data["isDetail"] : <any>null;
            this.isInitialQuery = data["isInitialQuery"] !== undefined ? data["isInitialQuery"] : <any>null;
            this.defaultValue = data["defaultValue"] !== undefined ? data["defaultValue"] : <any>null;
            this.defaultQueryValue = data["defaultQueryValue"] !== undefined ? data["defaultQueryValue"] : <any>null;
            this.constantValue = data["constantValue"] !== undefined ? data["constantValue"] : <any>null;
            this.atributeFilter = data["atributeFilter"] !== undefined ? data["atributeFilter"] : <any>null;
            this.descendentsFilter = data["descendentsFilter"] !== undefined ? data["descendentsFilter"] : <any>null;
            this.isMultiSelect = data["isMultiSelect"] !== undefined ? data["isMultiSelect"] : <any>null;
            this.timeBasedHierarchy = data["timeBasedHierarchy"] !== undefined ? data["timeBasedHierarchy"] : <any>null;
            this.nonLeafDataMembers = data["nonLeafDataMembers"] !== undefined ? data["nonLeafDataMembers"] : <any>null;
            this.role = data["role"] !== undefined ? data["role"] : <any>null;
        }
    }

    static fromJS(data: any): JournalDimension {
        data = typeof data === 'object' ? data : {};
        let result = new JournalDimension();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["dimensionName"] = this.dimensionName !== undefined ? this.dimensionName : <any>null;
        data["isTimeDimension"] = this.isTimeDimension !== undefined ? this.isTimeDimension : <any>null;
        data["isAccountDimension"] = this.isAccountDimension !== undefined ? this.isAccountDimension : <any>null;
        data["isHeader"] = this.isHeader !== undefined ? this.isHeader : <any>null;
        data["isHidden"] = this.isHidden !== undefined ? this.isHidden : <any>null;
        data["isDetail"] = this.isDetail !== undefined ? this.isDetail : <any>null;
        data["isInitialQuery"] = this.isInitialQuery !== undefined ? this.isInitialQuery : <any>null;
        data["defaultValue"] = this.defaultValue !== undefined ? this.defaultValue : <any>null;
        data["defaultQueryValue"] = this.defaultQueryValue !== undefined ? this.defaultQueryValue : <any>null;
        data["constantValue"] = this.constantValue !== undefined ? this.constantValue : <any>null;
        data["atributeFilter"] = this.atributeFilter !== undefined ? this.atributeFilter : <any>null;
        data["descendentsFilter"] = this.descendentsFilter !== undefined ? this.descendentsFilter : <any>null;
        data["isMultiSelect"] = this.isMultiSelect !== undefined ? this.isMultiSelect : <any>null;
        data["timeBasedHierarchy"] = this.timeBasedHierarchy !== undefined ? this.timeBasedHierarchy : <any>null;
        data["nonLeafDataMembers"] = this.nonLeafDataMembers !== undefined ? this.nonLeafDataMembers : <any>null;
        data["role"] = this.role !== undefined ? this.role : <any>null;
        return data;
    }

    clone(): JournalDimension {
        const json = this.toJSON();
        let result = new JournalDimension();
        result.init(json);
        return result;
    }
}

export interface IJournalDimension {
    id: number;
    dimensionName?: string | null;
    isTimeDimension: boolean;
    isAccountDimension: boolean;
    isHeader: boolean;
    isHidden: boolean;
    isDetail: boolean;
    isInitialQuery: boolean;
    defaultValue?: string | null;
    defaultQueryValue?: string | null;
    constantValue?: string | null;
    atributeFilter?: string | null;
    descendentsFilter?: string | null;
    isMultiSelect: boolean;
    timeBasedHierarchy: boolean;
    nonLeafDataMembers: boolean;
    role?: string | null;
}

export class JournalHeader implements IJournalHeader {
    id!: number;
    groupId!: number;
    sourceJeId?: number | null;
    readOnly?: boolean | null;
    name?: string | null;
    description?: string | null;
    recurringFromKey?: string | null;
    recurringToKey?: string | null;
    status!: JournalHeaderStatus;
    validationWarnings?: number | null;
    validationErrors?: number | null;
    dimensionValues?: JournalFilter[] | null;
    attachments?: JournalAttachmentInfo[] | null;
    headerIdKeyMap?: { [key: string]: any; }[] | null;

    constructor(data?: IJournalHeader) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"] !== undefined ? data["id"] : <any>null;
            this.groupId = data["groupId"] !== undefined ? data["groupId"] : <any>null;
            this.sourceJeId = data["sourceJeId"] !== undefined ? data["sourceJeId"] : <any>null;
            this.readOnly = data["readOnly"] !== undefined ? data["readOnly"] : <any>null;
            this.name = data["name"] !== undefined ? data["name"] : <any>null;
            this.description = data["description"] !== undefined ? data["description"] : <any>null;
            this.recurringFromKey = data["recurringFromKey"] !== undefined ? data["recurringFromKey"] : <any>null;
            this.recurringToKey = data["recurringToKey"] !== undefined ? data["recurringToKey"] : <any>null;
            this.status = data["status"] !== undefined ? data["status"] : <any>null;
            this.validationWarnings = data["validationWarnings"] !== undefined ? data["validationWarnings"] : <any>null;
            this.validationErrors = data["validationErrors"] !== undefined ? data["validationErrors"] : <any>null;
            if (Array.isArray(data["dimensionValues"])) {
                this.dimensionValues = [] as any;
                for (let item in data["dimensionValues"])
                    this.dimensionValues!.push(JournalFilter.fromJS(data["dimensionValues"][item]));
            }
            else {
                this.dimensionValues = <any>null;
            }
            if (Array.isArray(data["attachments"])) {
                this.attachments = [] as any;
                for (let item in data["attachments"])
                    this.attachments!.push(JournalAttachmentInfo.fromJS(data["attachments"][item]));
            }
            else {
                this.attachments = <any>null;
            }
            if (Array.isArray(data["headerIdKeyMap"])) {
                this.headerIdKeyMap = [] as any;
                for (let item in data["headerIdKeyMap"])
                    this.headerIdKeyMap!.push(data["headerIdKeyMap"][item]);
            }
            else {
                this.headerIdKeyMap = <any>null;
            }
        }
    }

    static fromJS(data: any): JournalHeader {
        data = typeof data === 'object' ? data : {};
        let result = new JournalHeader();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["groupId"] = this.groupId !== undefined ? this.groupId : <any>null;
        data["sourceJeId"] = this.sourceJeId !== undefined ? this.sourceJeId : <any>null;
        data["readOnly"] = this.readOnly !== undefined ? this.readOnly : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["recurringFromKey"] = this.recurringFromKey !== undefined ? this.recurringFromKey : <any>null;
        data["recurringToKey"] = this.recurringToKey !== undefined ? this.recurringToKey : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["validationWarnings"] = this.validationWarnings !== undefined ? this.validationWarnings : <any>null;
        data["validationErrors"] = this.validationErrors !== undefined ? this.validationErrors : <any>null;
        if (Array.isArray(this.dimensionValues)) {
            data["dimensionValues"] = [];
            for (let item in this.dimensionValues)
                data["dimensionValues"].push(this.dimensionValues[item].toJSON());
        }
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item in this.attachments)
                data["attachments"].push(this.attachments[item].toJSON());
        }
        if (Array.isArray(this.headerIdKeyMap)) {
            data["headerIdKeyMap"] = [];
            for (let item in this.headerIdKeyMap)
                data["headerIdKeyMap"].push(this.headerIdKeyMap[item]);
        }
        return data;
    }

    clone(): JournalHeader {
        const json = this.toJSON();
        let result = new JournalHeader();
        result.init(json);
        return result;
    }
}

export interface IJournalHeader {
    id: number;
    groupId: number;
    sourceJeId?: number | null;
    readOnly?: boolean | null;
    name?: string | null;
    description?: string | null;
    recurringFromKey?: string | null;
    recurringToKey?: string | null;
    status: JournalHeaderStatus;
    validationWarnings?: number | null;
    validationErrors?: number | null;
    dimensionValues?: JournalFilter[] | null;
    attachments?: JournalAttachmentInfo[] | null;
    headerIdKeyMap?: { [key: string]: any; }[] | null;
}

export class JournalHeaderSecure extends JournalHeader implements IJournalHeaderSecure {
    accessType!: JournalHeaderAccess;

    constructor(data?: IJournalHeaderSecure) {
        super(data);
    }

    init(data?: any) {
        super.init(data);
        if (data) {
            this.accessType = data["accessType"] !== undefined ? data["accessType"] : <any>null;
        }
    }

    static fromJS(data: any): JournalHeaderSecure {
        data = typeof data === 'object' ? data : {};
        let result = new JournalHeaderSecure();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessType"] = this.accessType !== undefined ? this.accessType : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): JournalHeaderSecure {
        const json = this.toJSON();
        let result = new JournalHeaderSecure();
        result.init(json);
        return result;
    }
}

export interface IJournalHeaderSecure extends IJournalHeader {
    accessType: JournalHeaderAccess;
}

export enum JournalHeaderAccess {
    Read = 0,
    Write = 1,
}

export enum JournalHeaderStatus {
    New = 0,
    Posted = 1,
}

export class JournalFilter implements IJournalFilter {
    dimensionName?: string | null;
    dimensionMemberKey?: string | null;
    role?: string | null;

    constructor(data?: IJournalFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.dimensionName = data["dimensionName"] !== undefined ? data["dimensionName"] : <any>null;
            this.dimensionMemberKey = data["dimensionMemberKey"] !== undefined ? data["dimensionMemberKey"] : <any>null;
            this.role = data["role"] !== undefined ? data["role"] : <any>null;
        }
    }

    static fromJS(data: any): JournalFilter {
        data = typeof data === 'object' ? data : {};
        let result = new JournalFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dimensionName"] = this.dimensionName !== undefined ? this.dimensionName : <any>null;
        data["dimensionMemberKey"] = this.dimensionMemberKey !== undefined ? this.dimensionMemberKey : <any>null;
        data["role"] = this.role !== undefined ? this.role : <any>null;
        return data;
    }

    clone(): JournalFilter {
        const json = this.toJSON();
        let result = new JournalFilter();
        result.init(json);
        return result;
    }
}

export interface IJournalFilter {
    dimensionName?: string | null;
    dimensionMemberKey?: string | null;
    role?: string | null;
}

export class JournalAttachmentInfo implements IJournalAttachmentInfo {
    id!: number;
    createdBy?: string | null;
    createdOn!: Date;
    description?: string | null;
    name?: string | null;
    url?: string | null;

    constructor(data?: IJournalAttachmentInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"] !== undefined ? data["id"] : <any>null;
            this.createdBy = data["createdBy"] !== undefined ? data["createdBy"] : <any>null;
            this.createdOn = data["createdOn"] ? new Date(data["createdOn"].toString()) : <any>null;
            this.description = data["description"] !== undefined ? data["description"] : <any>null;
            this.name = data["name"] !== undefined ? data["name"] : <any>null;
            this.url = data["url"] !== undefined ? data["url"] : <any>null;
        }
    }

    static fromJS(data: any): JournalAttachmentInfo {
        data = typeof data === 'object' ? data : {};
        let result = new JournalAttachmentInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["createdBy"] = this.createdBy !== undefined ? this.createdBy : <any>null;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["url"] = this.url !== undefined ? this.url : <any>null;
        return data;
    }

    clone(): JournalAttachmentInfo {
        const json = this.toJSON();
        let result = new JournalAttachmentInfo();
        result.init(json);
        return result;
    }
}

export interface IJournalAttachmentInfo {
    id: number;
    createdBy?: string | null;
    createdOn: Date;
    description?: string | null;
    name?: string | null;
    url?: string | null;
}

export class JournalDetail implements IJournalDetail {
    id!: number;
    header_Id!: number;
    readOnly?: boolean | null;
    isGenerated?: boolean | null;
    debit?: number | null;
    credit?: number | null;
    dimensionValues?: JournalFilter[] | null;
    attachments?: JournalAttachment[] | null;

    constructor(data?: IJournalDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"] !== undefined ? data["id"] : <any>null;
            this.header_Id = data["header_Id"] !== undefined ? data["header_Id"] : <any>null;
            this.readOnly = data["readOnly"] !== undefined ? data["readOnly"] : <any>null;
            this.isGenerated = data["isGenerated"] !== undefined ? data["isGenerated"] : <any>null;
            this.debit = data["debit"] !== undefined ? data["debit"] : <any>null;
            this.credit = data["credit"] !== undefined ? data["credit"] : <any>null;
            if (Array.isArray(data["dimensionValues"])) {
                this.dimensionValues = [] as any;
                for (let item in data["dimensionValues"])
                    this.dimensionValues!.push(JournalFilter.fromJS(data["dimensionValues"][item]));
            }
            else {
                this.dimensionValues = <any>null;
            }
            if (Array.isArray(data["attachments"])) {
                this.attachments = [] as any;
                for (let item in data["attachments"])
                    this.attachments!.push(JournalAttachment.fromJS(data["attachments"][item]));
            }
            else {
                this.attachments = <any>null;
            }
        }
    }

    static fromJS(data: any): JournalDetail {
        data = typeof data === 'object' ? data : {};
        let result = new JournalDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["header_Id"] = this.header_Id !== undefined ? this.header_Id : <any>null;
        data["readOnly"] = this.readOnly !== undefined ? this.readOnly : <any>null;
        data["isGenerated"] = this.isGenerated !== undefined ? this.isGenerated : <any>null;
        data["debit"] = this.debit !== undefined ? this.debit : <any>null;
        data["credit"] = this.credit !== undefined ? this.credit : <any>null;
        if (Array.isArray(this.dimensionValues)) {
            data["dimensionValues"] = [];
            for (let item in this.dimensionValues)
                data["dimensionValues"].push(this.dimensionValues[item].toJSON());
        }
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item in this.attachments)
                data["attachments"].push(this.attachments[item].toJSON());
        }
        return data;
    }

    clone(): JournalDetail {
        const json = this.toJSON();
        let result = new JournalDetail();
        result.init(json);
        return result;
    }
}

export interface IJournalDetail {
    id: number;
    header_Id: number;
    readOnly?: boolean | null;
    isGenerated?: boolean | null;
    debit?: number | null;
    credit?: number | null;
    dimensionValues?: JournalFilter[] | null;
    attachments?: JournalAttachment[] | null;
}

export class JournalAttachment extends JournalAttachmentInfo implements IJournalAttachment {
    binaryContent?: string | null;

    constructor(data?: IJournalAttachment) {
        super(data);
    }

    init(data?: any) {
        super.init(data);
        if (data) {
            this.binaryContent = data["binaryContent"] !== undefined ? data["binaryContent"] : <any>null;
        }
    }

    static fromJS(data: any): JournalAttachment {
        data = typeof data === 'object' ? data : {};
        let result = new JournalAttachment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["binaryContent"] = this.binaryContent !== undefined ? this.binaryContent : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): JournalAttachment {
        const json = this.toJSON();
        let result = new JournalAttachment();
        result.init(json);
        return result;
    }
}

export interface IJournalAttachment extends IJournalAttachmentInfo {
    binaryContent?: string | null;
}

export class JournalHeaderWithDetails extends JournalHeader implements IJournalHeaderWithDetails {
    details?: JournalDetail[] | null;

    constructor(data?: IJournalHeaderWithDetails) {
        super(data);
    }

    init(data?: any) {
        super.init(data);
        if (data) {
            if (Array.isArray(data["details"])) {
                this.details = [] as any;
                for (let item in data["details"])
                    this.details!.push(JournalDetail.fromJS(data["details"][item]));
            }
            else {
                this.details = <any>null;
            }
        }
    }

    static fromJS(data: any): JournalHeaderWithDetails {
        data = typeof data === 'object' ? data : {};
        let result = new JournalHeaderWithDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.details)) {
            data["details"] = [];
            for (let item in this.details)
                data["details"].push(this.details[item].toJSON());
        }
        super.toJSON(data);
        return data;
    }

    clone(): JournalHeaderWithDetails {
        const json = this.toJSON();
        let result = new JournalHeaderWithDetails();
        result.init(json);
        return result;
    }
}

export interface IJournalHeaderWithDetails extends IJournalHeader {
    details?: JournalDetail[] | null;
}

export class SaveJournalDataModel implements ISaveJournalDataModel {
    deleteHeaders?: JournalHeader[] | null;
    upsertHeaders?: JournalHeaderWithDetails[] | null;

    constructor(data?: ISaveJournalDataModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (Array.isArray(data["deleteHeaders"])) {
                this.deleteHeaders = [] as any;
                for (let item in data["deleteHeaders"])
                    this.deleteHeaders!.push(JournalHeader.fromJS(data["deleteHeaders"][item]));
            }
            else {
                this.deleteHeaders = <any>null;
            }
            if (Array.isArray(data["upsertHeaders"])) {
                this.upsertHeaders = [] as any;
                for (let item in data["upsertHeaders"])
                    this.upsertHeaders!.push(JournalHeaderWithDetails.fromJS(data["upsertHeaders"][item]));
            }
            else {
                this.upsertHeaders = <any>null;
            }
        }
    }

    static fromJS(data: any): SaveJournalDataModel {
        data = typeof data === 'object' ? data : {};
        let result = new SaveJournalDataModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.deleteHeaders)) {
            data["deleteHeaders"] = [];
            for (let item in this.deleteHeaders)
                data["deleteHeaders"].push(this.deleteHeaders[item].toJSON());
        }
        if (Array.isArray(this.upsertHeaders)) {
            data["upsertHeaders"] = [];
            for (let item in this.upsertHeaders)
                data["upsertHeaders"].push(this.upsertHeaders[item].toJSON());
        }
        return data;
    }

    clone(): SaveJournalDataModel {
        const json = this.toJSON();
        let result = new SaveJournalDataModel();
        result.init(json);
        return result;
    }
}

export interface ISaveJournalDataModel {
    deleteHeaders?: JournalHeader[] | null;
    upsertHeaders?: JournalHeaderWithDetails[] | null;
}

export class JournalDimensionAuthorizedKeys implements IJournalDimensionAuthorizedKeys {
    dimensionName?: string | null;
    authorizedReadKeys?: number[] | null;
    authorizedWriteKeys?: number[] | null;

    constructor(data?: IJournalDimensionAuthorizedKeys) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.dimensionName = data["dimensionName"] !== undefined ? data["dimensionName"] : <any>null;
            if (Array.isArray(data["authorizedReadKeys"])) {
                this.authorizedReadKeys = [] as any;
                for (let item in data["authorizedReadKeys"])
                    this.authorizedReadKeys!.push(data["authorizedReadKeys"][item]);
            }
            else {
                this.authorizedReadKeys = <any>null;
            }
            if (Array.isArray(data["authorizedWriteKeys"])) {
                this.authorizedWriteKeys = [] as any;
                for (let item in data["authorizedWriteKeys"])
                    this.authorizedWriteKeys!.push(data["authorizedWriteKeys"][item]);
            }
            else {
                this.authorizedWriteKeys = <any>null;
            }
        }
    }

    static fromJS(data: any): JournalDimensionAuthorizedKeys {
        data = typeof data === 'object' ? data : {};
        let result = new JournalDimensionAuthorizedKeys();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dimensionName"] = this.dimensionName !== undefined ? this.dimensionName : <any>null;
        if (Array.isArray(this.authorizedReadKeys)) {
            data["authorizedReadKeys"] = [];
            for (let item in this.authorizedReadKeys)
                data["authorizedReadKeys"].push(this.authorizedReadKeys[item]);
        }
        if (Array.isArray(this.authorizedWriteKeys)) {
            data["authorizedWriteKeys"] = [];
            for (let item in this.authorizedWriteKeys)
                data["authorizedWriteKeys"].push(this.authorizedWriteKeys[item]);
        }
        return data;
    }

    clone(): JournalDimensionAuthorizedKeys {
        const json = this.toJSON();
        let result = new JournalDimensionAuthorizedKeys();
        result.init(json);
        return result;
    }
}

export interface IJournalDimensionAuthorizedKeys {
    dimensionName?: string | null;
    authorizedReadKeys?: number[] | null;
    authorizedWriteKeys?: number[] | null;
}

export class JournalAuditLogInfo implements IJournalAuditLogInfo {
    audit_ID!: number;
    jE_ID!: number;
    recurring_ID!: number;
    dimensions?: { [key: string]: string[]; } | null;
    description?: string | null;
    jE_Tag?: string | null;
    status?: string | null;
    creation_Date?: string | null;
    creation_User?: string | null;
    modified_Date?: string | null;
    modified_User?: string | null;
    unposting_Date?: string | null;
    unposting_User?: string | null;
    posting_Date?: string | null;
    posting_User?: string | null;

    constructor(data?: IJournalAuditLogInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.audit_ID = data["audit_ID"] !== undefined ? data["audit_ID"] : <any>null;
            this.jE_ID = data["jE_ID"] !== undefined ? data["jE_ID"] : <any>null;
            this.recurring_ID = data["recurring_ID"] !== undefined ? data["recurring_ID"] : <any>null;
            if (data["dimensions"]) {
                this.dimensions = {} as any;
                for (let key in data["dimensions"]) {
                    if (data["dimensions"].hasOwnProperty(key))
                        (<any>this.dimensions)![key] = data["dimensions"][key] !== undefined ? data["dimensions"][key] : [];
                }
            }
            else {
                this.dimensions = <any>null;
            }
            this.description = data["description"] !== undefined ? data["description"] : <any>null;
            this.jE_Tag = data["jE_Tag"] !== undefined ? data["jE_Tag"] : <any>null;
            this.status = data["status"] !== undefined ? data["status"] : <any>null;
            this.creation_Date = data["creation_Date"] !== undefined ? data["creation_Date"] : <any>null;
            this.creation_User = data["creation_User"] !== undefined ? data["creation_User"] : <any>null;
            this.modified_Date = data["modified_Date"] !== undefined ? data["modified_Date"] : <any>null;
            this.modified_User = data["modified_User"] !== undefined ? data["modified_User"] : <any>null;
            this.unposting_Date = data["unposting_Date"] !== undefined ? data["unposting_Date"] : <any>null;
            this.unposting_User = data["unposting_User"] !== undefined ? data["unposting_User"] : <any>null;
            this.posting_Date = data["posting_Date"] !== undefined ? data["posting_Date"] : <any>null;
            this.posting_User = data["posting_User"] !== undefined ? data["posting_User"] : <any>null;
        }
    }

    static fromJS(data: any): JournalAuditLogInfo {
        data = typeof data === 'object' ? data : {};
        let result = new JournalAuditLogInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["audit_ID"] = this.audit_ID !== undefined ? this.audit_ID : <any>null;
        data["jE_ID"] = this.jE_ID !== undefined ? this.jE_ID : <any>null;
        data["recurring_ID"] = this.recurring_ID !== undefined ? this.recurring_ID : <any>null;
        if (this.dimensions) {
            data["dimensions"] = {};
            for (let key in this.dimensions) {
                if (this.dimensions.hasOwnProperty(key))
                    (<any>data["dimensions"])[key] = this.dimensions[key] !== undefined ? this.dimensions[key] : <any>null;
            }
        }
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["jE_Tag"] = this.jE_Tag !== undefined ? this.jE_Tag : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["creation_Date"] = this.creation_Date !== undefined ? this.creation_Date : <any>null;
        data["creation_User"] = this.creation_User !== undefined ? this.creation_User : <any>null;
        data["modified_Date"] = this.modified_Date !== undefined ? this.modified_Date : <any>null;
        data["modified_User"] = this.modified_User !== undefined ? this.modified_User : <any>null;
        data["unposting_Date"] = this.unposting_Date !== undefined ? this.unposting_Date : <any>null;
        data["unposting_User"] = this.unposting_User !== undefined ? this.unposting_User : <any>null;
        data["posting_Date"] = this.posting_Date !== undefined ? this.posting_Date : <any>null;
        data["posting_User"] = this.posting_User !== undefined ? this.posting_User : <any>null;
        return data;
    }

    clone(): JournalAuditLogInfo {
        const json = this.toJSON();
        let result = new JournalAuditLogInfo();
        result.init(json);
        return result;
    }
}

export interface IJournalAuditLogInfo {
    audit_ID: number;
    jE_ID: number;
    recurring_ID: number;
    dimensions?: { [key: string]: string[]; } | null;
    description?: string | null;
    jE_Tag?: string | null;
    status?: string | null;
    creation_Date?: string | null;
    creation_User?: string | null;
    modified_Date?: string | null;
    modified_User?: string | null;
    unposting_Date?: string | null;
    unposting_User?: string | null;
    posting_Date?: string | null;
    posting_User?: string | null;
}

export class JournalRule implements IJournalRule {
    caption?: string | null;
    amount!: number;
    tolerance!: number;
    isError!: boolean;

    constructor(data?: IJournalRule) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.caption = data["caption"] !== undefined ? data["caption"] : <any>null;
            this.amount = data["amount"] !== undefined ? data["amount"] : <any>null;
            this.tolerance = data["tolerance"] !== undefined ? data["tolerance"] : <any>null;
            this.isError = data["isError"] !== undefined ? data["isError"] : <any>null;
        }
    }

    static fromJS(data: any): JournalRule {
        data = typeof data === 'object' ? data : {};
        let result = new JournalRule();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caption"] = this.caption !== undefined ? this.caption : <any>null;
        data["amount"] = this.amount !== undefined ? this.amount : <any>null;
        data["tolerance"] = this.tolerance !== undefined ? this.tolerance : <any>null;
        data["isError"] = this.isError !== undefined ? this.isError : <any>null;
        return data;
    }

    clone(): JournalRule {
        const json = this.toJSON();
        let result = new JournalRule();
        result.init(json);
        return result;
    }
}

export interface IJournalRule {
    caption?: string | null;
    amount: number;
    tolerance: number;
    isError: boolean;
}

export class JournalMovementClasificationValidation implements IJournalMovementClasificationValidation {
    accountDimension?: string | null;
    movementDimension?: string | null;
    validCombinations?: JournalMovementClasificationValidationItem[] | null;

    constructor(data?: IJournalMovementClasificationValidation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.accountDimension = data["accountDimension"] !== undefined ? data["accountDimension"] : <any>null;
            this.movementDimension = data["movementDimension"] !== undefined ? data["movementDimension"] : <any>null;
            if (Array.isArray(data["validCombinations"])) {
                this.validCombinations = [] as any;
                for (let item in data["validCombinations"])
                    this.validCombinations!.push(JournalMovementClasificationValidationItem.fromJS(data["validCombinations"][item]));
            }
            else {
                this.validCombinations = <any>null;
            }
        }
    }

    static fromJS(data: any): JournalMovementClasificationValidation {
        data = typeof data === 'object' ? data : {};
        let result = new JournalMovementClasificationValidation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountDimension"] = this.accountDimension !== undefined ? this.accountDimension : <any>null;
        data["movementDimension"] = this.movementDimension !== undefined ? this.movementDimension : <any>null;
        if (Array.isArray(this.validCombinations)) {
            data["validCombinations"] = [];
            for (let item in this.validCombinations)
                data["validCombinations"].push(this.validCombinations[item].toJSON());
        }
        return data;
    }

    clone(): JournalMovementClasificationValidation {
        const json = this.toJSON();
        let result = new JournalMovementClasificationValidation();
        result.init(json);
        return result;
    }
}

export interface IJournalMovementClasificationValidation {
    accountDimension?: string | null;
    movementDimension?: string | null;
    validCombinations?: JournalMovementClasificationValidationItem[] | null;
}

export class JournalMovementClasificationValidationItem implements IJournalMovementClasificationValidationItem {
    accountKey!: number;
    movementKey!: number;
    accountName?: string | null;
    movementName?: string | null;
    allowInput!: boolean;

    constructor(data?: IJournalMovementClasificationValidationItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.accountKey = data["accountKey"] !== undefined ? data["accountKey"] : <any>null;
            this.movementKey = data["movementKey"] !== undefined ? data["movementKey"] : <any>null;
            this.accountName = data["accountName"] !== undefined ? data["accountName"] : <any>null;
            this.movementName = data["movementName"] !== undefined ? data["movementName"] : <any>null;
            this.allowInput = data["allowInput"] !== undefined ? data["allowInput"] : <any>null;
        }
    }

    static fromJS(data: any): JournalMovementClasificationValidationItem {
        data = typeof data === 'object' ? data : {};
        let result = new JournalMovementClasificationValidationItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountKey"] = this.accountKey !== undefined ? this.accountKey : <any>null;
        data["movementKey"] = this.movementKey !== undefined ? this.movementKey : <any>null;
        data["accountName"] = this.accountName !== undefined ? this.accountName : <any>null;
        data["movementName"] = this.movementName !== undefined ? this.movementName : <any>null;
        data["allowInput"] = this.allowInput !== undefined ? this.allowInput : <any>null;
        return data;
    }

    clone(): JournalMovementClasificationValidationItem {
        const json = this.toJSON();
        let result = new JournalMovementClasificationValidationItem();
        result.init(json);
        return result;
    }
}

export interface IJournalMovementClasificationValidationItem {
    accountKey: number;
    movementKey: number;
    accountName?: string | null;
    movementName?: string | null;
    allowInput: boolean;
}

export class TenantDTO implements ITenantDTO {
    id!: number;
    name?: string | null;
    isALMSource!: boolean;
    isALMTarget!: boolean;

    constructor(data?: ITenantDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"] !== undefined ? data["id"] : <any>null;
            this.name = data["name"] !== undefined ? data["name"] : <any>null;
            this.isALMSource = data["isALMSource"] !== undefined ? data["isALMSource"] : <any>null;
            this.isALMTarget = data["isALMTarget"] !== undefined ? data["isALMTarget"] : <any>null;
        }
    }

    static fromJS(data: any): TenantDTO {
        data = typeof data === 'object' ? data : {};
        let result = new TenantDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["isALMSource"] = this.isALMSource !== undefined ? this.isALMSource : <any>null;
        data["isALMTarget"] = this.isALMTarget !== undefined ? this.isALMTarget : <any>null;
        return data;
    }

    clone(): TenantDTO {
        const json = this.toJSON();
        let result = new TenantDTO();
        result.init(json);
        return result;
    }
}

export interface ITenantDTO {
    id: number;
    name?: string | null;
    isALMSource: boolean;
    isALMTarget: boolean;
}

export class ChangeSet implements IChangeSet {
    id!: number;
    name?: string | null;
    description?: string | null;
    sourceTenant?: ChangeSetTenant | null;
    targetTenants?: ChangeSetTenant[] | null;
    createdBy?: string | null;
    createdAt!: Date;
    updatedAt!: Date;
    isDraft!: boolean;
    isDeleted!: boolean;

    constructor(data?: IChangeSet) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"] !== undefined ? data["id"] : <any>null;
            this.name = data["name"] !== undefined ? data["name"] : <any>null;
            this.description = data["description"] !== undefined ? data["description"] : <any>null;
            this.sourceTenant = data["sourceTenant"] ? ChangeSetTenant.fromJS(data["sourceTenant"]) : <any>null;
            if (Array.isArray(data["targetTenants"])) {
                this.targetTenants = [] as any;
                for (let item in data["targetTenants"])
                    this.targetTenants!.push(ChangeSetTenant.fromJS(data["targetTenants"][item]));
            }
            else {
                this.targetTenants = <any>null;
            }
            this.createdBy = data["createdBy"] !== undefined ? data["createdBy"] : <any>null;
            this.createdAt = data["createdAt"] ? new Date(data["createdAt"].toString()) : <any>null;
            this.updatedAt = data["updatedAt"] ? new Date(data["updatedAt"].toString()) : <any>null;
            this.isDraft = data["isDraft"] !== undefined ? data["isDraft"] : <any>null;
            this.isDeleted = data["isDeleted"] !== undefined ? data["isDeleted"] : <any>null;
        }
    }

    static fromJS(data: any): ChangeSet {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeSet();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["sourceTenant"] = this.sourceTenant ? this.sourceTenant.toJSON() : <any>null;
        if (Array.isArray(this.targetTenants)) {
            data["targetTenants"] = [];
            for (let item in this.targetTenants)
                data["targetTenants"].push(this.targetTenants[item].toJSON());
        }
        data["createdBy"] = this.createdBy !== undefined ? this.createdBy : <any>null;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>null;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>null;
        data["isDraft"] = this.isDraft !== undefined ? this.isDraft : <any>null;
        data["isDeleted"] = this.isDeleted !== undefined ? this.isDeleted : <any>null;
        return data;
    }

    clone(): ChangeSet {
        const json = this.toJSON();
        let result = new ChangeSet();
        result.init(json);
        return result;
    }
}

export interface IChangeSet {
    id: number;
    name?: string | null;
    description?: string | null;
    sourceTenant?: ChangeSetTenant | null;
    targetTenants?: ChangeSetTenant[] | null;
    createdBy?: string | null;
    createdAt: Date;
    updatedAt: Date;
    isDraft: boolean;
    isDeleted: boolean;
}

export class ChangeSetTenant implements IChangeSetTenant {
    id!: number;
    name?: string | null;

    constructor(data?: IChangeSetTenant) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"] !== undefined ? data["id"] : <any>null;
            this.name = data["name"] !== undefined ? data["name"] : <any>null;
        }
    }

    static fromJS(data: any): ChangeSetTenant {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeSetTenant();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        return data;
    }

    clone(): ChangeSetTenant {
        const json = this.toJSON();
        let result = new ChangeSetTenant();
        result.init(json);
        return result;
    }
}

export interface IChangeSetTenant {
    id: number;
    name?: string | null;
}

export class ChangeSetDTO implements IChangeSetDTO {
    name?: string | null;
    description?: string | null;
    sourceTenantId!: number;
    targetTenantIds?: number[] | null;
    isDraft!: boolean;

    constructor(data?: IChangeSetDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"] !== undefined ? data["name"] : <any>null;
            this.description = data["description"] !== undefined ? data["description"] : <any>null;
            this.sourceTenantId = data["sourceTenantId"] !== undefined ? data["sourceTenantId"] : <any>null;
            if (Array.isArray(data["targetTenantIds"])) {
                this.targetTenantIds = [] as any;
                for (let item in data["targetTenantIds"])
                    this.targetTenantIds!.push(data["targetTenantIds"][item]);
            }
            else {
                this.targetTenantIds = <any>null;
            }
            this.isDraft = data["isDraft"] !== undefined ? data["isDraft"] : <any>null;
        }
    }

    static fromJS(data: any): ChangeSetDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeSetDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["sourceTenantId"] = this.sourceTenantId !== undefined ? this.sourceTenantId : <any>null;
        if (Array.isArray(this.targetTenantIds)) {
            data["targetTenantIds"] = [];
            for (let item in this.targetTenantIds)
                data["targetTenantIds"].push(this.targetTenantIds[item]);
        }
        data["isDraft"] = this.isDraft !== undefined ? this.isDraft : <any>null;
        return data;
    }

    clone(): ChangeSetDTO {
        const json = this.toJSON();
        let result = new ChangeSetDTO();
        result.init(json);
        return result;
    }
}

export interface IChangeSetDTO {
    name?: string | null;
    description?: string | null;
    sourceTenantId: number;
    targetTenantIds?: number[] | null;
    isDraft: boolean;
}

export class ChangeSetItemDTO implements IChangeSetItemDTO {
    itemType?: string | null;
    itemId?: number | null;
    itemName?: string | null;

    constructor(data?: IChangeSetItemDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.itemType = data["itemType"] !== undefined ? data["itemType"] : <any>null;
            this.itemId = data["itemId"] !== undefined ? data["itemId"] : <any>null;
            this.itemName = data["itemName"] !== undefined ? data["itemName"] : <any>null;
        }
    }

    static fromJS(data: any): ChangeSetItemDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeSetItemDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["itemType"] = this.itemType !== undefined ? this.itemType : <any>null;
        data["itemId"] = this.itemId !== undefined ? this.itemId : <any>null;
        data["itemName"] = this.itemName !== undefined ? this.itemName : <any>null;
        return data;
    }

    clone(): ChangeSetItemDTO {
        const json = this.toJSON();
        let result = new ChangeSetItemDTO();
        result.init(json);
        return result;
    }
}

export interface IChangeSetItemDTO {
    itemType?: string | null;
    itemId?: number | null;
    itemName?: string | null;
}

export class ChangeSetItem implements IChangeSetItem {
    id!: number;
    itemType?: string | null;
    itemId?: number | null;
    itemName?: string | null;

    constructor(data?: IChangeSetItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"] !== undefined ? data["id"] : <any>null;
            this.itemType = data["itemType"] !== undefined ? data["itemType"] : <any>null;
            this.itemId = data["itemId"] !== undefined ? data["itemId"] : <any>null;
            this.itemName = data["itemName"] !== undefined ? data["itemName"] : <any>null;
        }
    }

    static fromJS(data: any): ChangeSetItem {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeSetItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["itemType"] = this.itemType !== undefined ? this.itemType : <any>null;
        data["itemId"] = this.itemId !== undefined ? this.itemId : <any>null;
        data["itemName"] = this.itemName !== undefined ? this.itemName : <any>null;
        return data;
    }

    clone(): ChangeSetItem {
        const json = this.toJSON();
        let result = new ChangeSetItem();
        result.init(json);
        return result;
    }
}

export interface IChangeSetItem {
    id: number;
    itemType?: string | null;
    itemId?: number | null;
    itemName?: string | null;
}

export class AdminForm implements IAdminForm {
    id!: number;
    name?: string | null;
    displayName?: string | null;
    tableName?: string | null;
    tableColumnRef?: string | null;
    tablePrimaryKey?: string | null;
    category?: string | null;
    headerId?: number | null;
    isActive?: number | null;
    importExport?: number | null;
    allowImport?: number | null;
    allowExport?: number | null;
    validateName?: number | null;
    querySP?: string | null;
    storedProcedures?: AdminSp[] | null;
    headerWithDetails?: HeaderWithDetails[] | null;

    constructor(data?: IAdminForm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"] !== undefined ? data["id"] : <any>null;
            this.name = data["name"] !== undefined ? data["name"] : <any>null;
            this.displayName = data["displayName"] !== undefined ? data["displayName"] : <any>null;
            this.tableName = data["tableName"] !== undefined ? data["tableName"] : <any>null;
            this.tableColumnRef = data["tableColumnRef"] !== undefined ? data["tableColumnRef"] : <any>null;
            this.tablePrimaryKey = data["tablePrimaryKey"] !== undefined ? data["tablePrimaryKey"] : <any>null;
            this.category = data["category"] !== undefined ? data["category"] : <any>null;
            this.headerId = data["headerId"] !== undefined ? data["headerId"] : <any>null;
            this.isActive = data["isActive"] !== undefined ? data["isActive"] : <any>null;
            this.importExport = data["importExport"] !== undefined ? data["importExport"] : <any>null;
            this.allowImport = data["allowImport"] !== undefined ? data["allowImport"] : <any>null;
            this.allowExport = data["allowExport"] !== undefined ? data["allowExport"] : <any>null;
            this.validateName = data["validateName"] !== undefined ? data["validateName"] : <any>null;
            this.querySP = data["querySP"] !== undefined ? data["querySP"] : <any>null;
            if (Array.isArray(data["storedProcedures"])) {
                this.storedProcedures = [] as any;
                for (let item in data["storedProcedures"])
                    this.storedProcedures!.push(AdminSp.fromJS(data["storedProcedures"][item]));
            }
            else {
                this.storedProcedures = <any>null;
            }
            if (Array.isArray(data["headerWithDetails"])) {
                this.headerWithDetails = [] as any;
                for (let item in data["headerWithDetails"])
                    this.headerWithDetails!.push(HeaderWithDetails.fromJS(data["headerWithDetails"][item]));
            }
            else {
                this.headerWithDetails = <any>null;
            }
        }
    }

    static fromJS(data: any): AdminForm {
        data = typeof data === 'object' ? data : {};
        let result = new AdminForm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["displayName"] = this.displayName !== undefined ? this.displayName : <any>null;
        data["tableName"] = this.tableName !== undefined ? this.tableName : <any>null;
        data["tableColumnRef"] = this.tableColumnRef !== undefined ? this.tableColumnRef : <any>null;
        data["tablePrimaryKey"] = this.tablePrimaryKey !== undefined ? this.tablePrimaryKey : <any>null;
        data["category"] = this.category !== undefined ? this.category : <any>null;
        data["headerId"] = this.headerId !== undefined ? this.headerId : <any>null;
        data["isActive"] = this.isActive !== undefined ? this.isActive : <any>null;
        data["importExport"] = this.importExport !== undefined ? this.importExport : <any>null;
        data["allowImport"] = this.allowImport !== undefined ? this.allowImport : <any>null;
        data["allowExport"] = this.allowExport !== undefined ? this.allowExport : <any>null;
        data["validateName"] = this.validateName !== undefined ? this.validateName : <any>null;
        data["querySP"] = this.querySP !== undefined ? this.querySP : <any>null;
        if (Array.isArray(this.storedProcedures)) {
            data["storedProcedures"] = [];
            for (let item in this.storedProcedures)
                data["storedProcedures"].push(this.storedProcedures[item].toJSON());
        }
        if (Array.isArray(this.headerWithDetails)) {
            data["headerWithDetails"] = [];
            for (let item in this.headerWithDetails)
                data["headerWithDetails"].push(this.headerWithDetails[item].toJSON());
        }
        return data;
    }

    clone(): AdminForm {
        const json = this.toJSON();
        let result = new AdminForm();
        result.init(json);
        return result;
    }
}

export interface IAdminForm {
    id: number;
    name?: string | null;
    displayName?: string | null;
    tableName?: string | null;
    tableColumnRef?: string | null;
    tablePrimaryKey?: string | null;
    category?: string | null;
    headerId?: number | null;
    isActive?: number | null;
    importExport?: number | null;
    allowImport?: number | null;
    allowExport?: number | null;
    validateName?: number | null;
    querySP?: string | null;
    storedProcedures?: AdminSp[] | null;
    headerWithDetails?: HeaderWithDetails[] | null;
}

export class AdminSp implements IAdminSp {
    id!: number;
    displayName?: string | null;
    displayType?: string | null;
    icon?: string | null;
    parametersConfig?: any | null;
    inputParameters?: { [key: string]: any; } | null;

    constructor(data?: IAdminSp) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"] !== undefined ? data["id"] : <any>null;
            this.displayName = data["displayName"] !== undefined ? data["displayName"] : <any>null;
            this.displayType = data["displayType"] !== undefined ? data["displayType"] : <any>null;
            this.icon = data["icon"] !== undefined ? data["icon"] : <any>null;
            this.parametersConfig = data["parametersConfig"] !== undefined ? data["parametersConfig"] : <any>null;
            if (data["inputParameters"]) {
                this.inputParameters = {} as any;
                for (let key in data["inputParameters"]) {
                    if (data["inputParameters"].hasOwnProperty(key))
                        (<any>this.inputParameters)![key] = data["inputParameters"][key] !== undefined ? data["inputParameters"][key] : <any>null;
                }
            }
            else {
                this.inputParameters = <any>null;
            }
        }
    }

    static fromJS(data: any): AdminSp {
        data = typeof data === 'object' ? data : {};
        let result = new AdminSp();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["displayName"] = this.displayName !== undefined ? this.displayName : <any>null;
        data["displayType"] = this.displayType !== undefined ? this.displayType : <any>null;
        data["icon"] = this.icon !== undefined ? this.icon : <any>null;
        data["parametersConfig"] = this.parametersConfig !== undefined ? this.parametersConfig : <any>null;
        if (this.inputParameters) {
            data["inputParameters"] = {};
            for (let key in this.inputParameters) {
                if (this.inputParameters.hasOwnProperty(key))
                    (<any>data["inputParameters"])[key] = this.inputParameters[key] !== undefined ? this.inputParameters[key] : <any>null;
            }
        }
        return data;
    }

    clone(): AdminSp {
        const json = this.toJSON();
        let result = new AdminSp();
        result.init(json);
        return result;
    }
}

export interface IAdminSp {
    id: number;
    displayName?: string | null;
    displayType?: string | null;
    icon?: string | null;
    parametersConfig?: any | null;
    inputParameters?: { [key: string]: any; } | null;
}

export class Header implements IHeader {
    id!: number;

    constructor(data?: IHeader) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"] !== undefined ? data["id"] : <any>null;
        }
    }

    static fromJS(data: any): Header {
        data = typeof data === 'object' ? data : {};
        let result = new Header();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        return data;
    }

    clone(): Header {
        const json = this.toJSON();
        let result = new Header();
        result.init(json);
        return result;
    }
}

export interface IHeader {
    id: number;
}

export class HeaderWithDetails extends Header implements IHeaderWithDetails {
    details?: Detail[] | null;

    constructor(data?: IHeaderWithDetails) {
        super(data);
    }

    init(data?: any) {
        super.init(data);
        if (data) {
            if (Array.isArray(data["details"])) {
                this.details = [] as any;
                for (let item in data["details"])
                    this.details!.push(Detail.fromJS(data["details"][item]));
            }
            else {
                this.details = <any>null;
            }
        }
    }

    static fromJS(data: any): HeaderWithDetails {
        data = typeof data === 'object' ? data : {};
        let result = new HeaderWithDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.details)) {
            data["details"] = [];
            for (let item in this.details)
                data["details"].push(this.details[item].toJSON());
        }
        super.toJSON(data);
        return data;
    }

    clone(): HeaderWithDetails {
        const json = this.toJSON();
        let result = new HeaderWithDetails();
        result.init(json);
        return result;
    }
}

export interface IHeaderWithDetails extends IHeader {
    details?: Detail[] | null;
}

export class Detail implements IDetail {
    id!: number;
    header_Id!: number;

    constructor(data?: IDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"] !== undefined ? data["id"] : <any>null;
            this.header_Id = data["header_Id"] !== undefined ? data["header_Id"] : <any>null;
        }
    }

    static fromJS(data: any): Detail {
        data = typeof data === 'object' ? data : {};
        let result = new Detail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["header_Id"] = this.header_Id !== undefined ? this.header_Id : <any>null;
        return data;
    }

    clone(): Detail {
        const json = this.toJSON();
        let result = new Detail();
        result.init(json);
        return result;
    }
}

export interface IDetail {
    id: number;
    header_Id: number;
}

export class Column implements IColumn {
    formId!: number;
    name?: string | null;
    displayName?: string | null;
    type?: string | null;
    displayType?: string | null;
    dateType?: string | null;
    dimension?: string | null;
    dimensionSpec?: string | null;
    tableName?: string | null;
    displayColumn?: string | null;
    returnColumnPairs?: string | null;
    role?: string | null;
    defaultValue?: string | null;
    isName?: boolean | null;
    isModel?: boolean | null;
    isHidden?: boolean | null;
    isEditable?: boolean | null;
    isRequired?: boolean | null;
    isUniqueConstraint?: boolean | null;
    isActive?: boolean | null;
    isGroupedBy?: boolean | null;
    isParameter?: boolean | null;
    refColID?: number | null;
    refColTableName?: string | null;
    refColPrimaryKey?: string | null;
    paramIsVisible?: boolean | null;
    paramTag?: string | null;
    paramDefaultValue?: string | null;
    sortOrder?: number | null;

    constructor(data?: IColumn) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.formId = data["formId"] !== undefined ? data["formId"] : <any>null;
            this.name = data["name"] !== undefined ? data["name"] : <any>null;
            this.displayName = data["displayName"] !== undefined ? data["displayName"] : <any>null;
            this.type = data["type"] !== undefined ? data["type"] : <any>null;
            this.displayType = data["displayType"] !== undefined ? data["displayType"] : <any>null;
            this.dateType = data["dateType"] !== undefined ? data["dateType"] : <any>null;
            this.dimension = data["dimension"] !== undefined ? data["dimension"] : <any>null;
            this.dimensionSpec = data["dimensionSpec"] !== undefined ? data["dimensionSpec"] : <any>null;
            this.tableName = data["tableName"] !== undefined ? data["tableName"] : <any>null;
            this.displayColumn = data["displayColumn"] !== undefined ? data["displayColumn"] : <any>null;
            this.returnColumnPairs = data["returnColumnPairs"] !== undefined ? data["returnColumnPairs"] : <any>null;
            this.role = data["role"] !== undefined ? data["role"] : <any>null;
            this.defaultValue = data["defaultValue"] !== undefined ? data["defaultValue"] : <any>null;
            this.isName = data["isName"] !== undefined ? data["isName"] : <any>null;
            this.isModel = data["isModel"] !== undefined ? data["isModel"] : <any>null;
            this.isHidden = data["isHidden"] !== undefined ? data["isHidden"] : <any>null;
            this.isEditable = data["isEditable"] !== undefined ? data["isEditable"] : <any>null;
            this.isRequired = data["isRequired"] !== undefined ? data["isRequired"] : <any>null;
            this.isUniqueConstraint = data["isUniqueConstraint"] !== undefined ? data["isUniqueConstraint"] : <any>null;
            this.isActive = data["isActive"] !== undefined ? data["isActive"] : <any>null;
            this.isGroupedBy = data["isGroupedBy"] !== undefined ? data["isGroupedBy"] : <any>null;
            this.isParameter = data["isParameter"] !== undefined ? data["isParameter"] : <any>null;
            this.refColID = data["refColID"] !== undefined ? data["refColID"] : <any>null;
            this.refColTableName = data["refColTableName"] !== undefined ? data["refColTableName"] : <any>null;
            this.refColPrimaryKey = data["refColPrimaryKey"] !== undefined ? data["refColPrimaryKey"] : <any>null;
            this.paramIsVisible = data["paramIsVisible"] !== undefined ? data["paramIsVisible"] : <any>null;
            this.paramTag = data["paramTag"] !== undefined ? data["paramTag"] : <any>null;
            this.paramDefaultValue = data["paramDefaultValue"] !== undefined ? data["paramDefaultValue"] : <any>null;
            this.sortOrder = data["sortOrder"] !== undefined ? data["sortOrder"] : <any>null;
        }
    }

    static fromJS(data: any): Column {
        data = typeof data === 'object' ? data : {};
        let result = new Column();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["formId"] = this.formId !== undefined ? this.formId : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["displayName"] = this.displayName !== undefined ? this.displayName : <any>null;
        data["type"] = this.type !== undefined ? this.type : <any>null;
        data["displayType"] = this.displayType !== undefined ? this.displayType : <any>null;
        data["dateType"] = this.dateType !== undefined ? this.dateType : <any>null;
        data["dimension"] = this.dimension !== undefined ? this.dimension : <any>null;
        data["dimensionSpec"] = this.dimensionSpec !== undefined ? this.dimensionSpec : <any>null;
        data["tableName"] = this.tableName !== undefined ? this.tableName : <any>null;
        data["displayColumn"] = this.displayColumn !== undefined ? this.displayColumn : <any>null;
        data["returnColumnPairs"] = this.returnColumnPairs !== undefined ? this.returnColumnPairs : <any>null;
        data["role"] = this.role !== undefined ? this.role : <any>null;
        data["defaultValue"] = this.defaultValue !== undefined ? this.defaultValue : <any>null;
        data["isName"] = this.isName !== undefined ? this.isName : <any>null;
        data["isModel"] = this.isModel !== undefined ? this.isModel : <any>null;
        data["isHidden"] = this.isHidden !== undefined ? this.isHidden : <any>null;
        data["isEditable"] = this.isEditable !== undefined ? this.isEditable : <any>null;
        data["isRequired"] = this.isRequired !== undefined ? this.isRequired : <any>null;
        data["isUniqueConstraint"] = this.isUniqueConstraint !== undefined ? this.isUniqueConstraint : <any>null;
        data["isActive"] = this.isActive !== undefined ? this.isActive : <any>null;
        data["isGroupedBy"] = this.isGroupedBy !== undefined ? this.isGroupedBy : <any>null;
        data["isParameter"] = this.isParameter !== undefined ? this.isParameter : <any>null;
        data["refColID"] = this.refColID !== undefined ? this.refColID : <any>null;
        data["refColTableName"] = this.refColTableName !== undefined ? this.refColTableName : <any>null;
        data["refColPrimaryKey"] = this.refColPrimaryKey !== undefined ? this.refColPrimaryKey : <any>null;
        data["paramIsVisible"] = this.paramIsVisible !== undefined ? this.paramIsVisible : <any>null;
        data["paramTag"] = this.paramTag !== undefined ? this.paramTag : <any>null;
        data["paramDefaultValue"] = this.paramDefaultValue !== undefined ? this.paramDefaultValue : <any>null;
        data["sortOrder"] = this.sortOrder !== undefined ? this.sortOrder : <any>null;
        return data;
    }

    clone(): Column {
        const json = this.toJSON();
        let result = new Column();
        result.init(json);
        return result;
    }
}

export interface IColumn {
    formId: number;
    name?: string | null;
    displayName?: string | null;
    type?: string | null;
    displayType?: string | null;
    dateType?: string | null;
    dimension?: string | null;
    dimensionSpec?: string | null;
    tableName?: string | null;
    displayColumn?: string | null;
    returnColumnPairs?: string | null;
    role?: string | null;
    defaultValue?: string | null;
    isName?: boolean | null;
    isModel?: boolean | null;
    isHidden?: boolean | null;
    isEditable?: boolean | null;
    isRequired?: boolean | null;
    isUniqueConstraint?: boolean | null;
    isActive?: boolean | null;
    isGroupedBy?: boolean | null;
    isParameter?: boolean | null;
    refColID?: number | null;
    refColTableName?: string | null;
    refColPrimaryKey?: string | null;
    paramIsVisible?: boolean | null;
    paramTag?: string | null;
    paramDefaultValue?: string | null;
    sortOrder?: number | null;
}

export class AdminFormQueryModel implements IAdminFormQueryModel {
    formId!: number;
    parameters?: { [key: string]: any; } | null;

    constructor(data?: IAdminFormQueryModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.formId = data["formId"] !== undefined ? data["formId"] : <any>null;
            if (data["parameters"]) {
                this.parameters = {} as any;
                for (let key in data["parameters"]) {
                    if (data["parameters"].hasOwnProperty(key))
                        (<any>this.parameters)![key] = data["parameters"][key] !== undefined ? data["parameters"][key] : <any>null;
                }
            }
            else {
                this.parameters = <any>null;
            }
        }
    }

    static fromJS(data: any): AdminFormQueryModel {
        data = typeof data === 'object' ? data : {};
        let result = new AdminFormQueryModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["formId"] = this.formId !== undefined ? this.formId : <any>null;
        if (this.parameters) {
            data["parameters"] = {};
            for (let key in this.parameters) {
                if (this.parameters.hasOwnProperty(key))
                    (<any>data["parameters"])[key] = this.parameters[key] !== undefined ? this.parameters[key] : <any>null;
            }
        }
        return data;
    }

    clone(): AdminFormQueryModel {
        const json = this.toJSON();
        let result = new AdminFormQueryModel();
        result.init(json);
        return result;
    }
}

export interface IAdminFormQueryModel {
    formId: number;
    parameters?: { [key: string]: any; } | null;
}

export class AdminFormHeader implements IAdminFormHeader {
    id!: number;
    tableColumnRef?: string | null;
    tablePrimaryKey?: string | null;
    data?: { [key: string]: any; } | null;
    details?: AdminFormDetail[] | null;

    constructor(data?: IAdminFormHeader) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"] !== undefined ? data["id"] : <any>null;
            this.tableColumnRef = data["tableColumnRef"] !== undefined ? data["tableColumnRef"] : <any>null;
            this.tablePrimaryKey = data["tablePrimaryKey"] !== undefined ? data["tablePrimaryKey"] : <any>null;
            if (data["data"]) {
                this.data = {} as any;
                for (let key in data["data"]) {
                    if (data["data"].hasOwnProperty(key))
                        (<any>this.data)![key] = data["data"][key] !== undefined ? data["data"][key] : <any>null;
                }
            }
            else {
                this.data = <any>null;
            }
            if (Array.isArray(data["details"])) {
                this.details = [] as any;
                for (let item in data["details"])
                    this.details!.push(AdminFormDetail.fromJS(data["details"][item]));
            }
            else {
                this.details = <any>null;
            }
        }
    }

    static fromJS(data: any): AdminFormHeader {
        data = typeof data === 'object' ? data : {};
        let result = new AdminFormHeader();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["tableColumnRef"] = this.tableColumnRef !== undefined ? this.tableColumnRef : <any>null;
        data["tablePrimaryKey"] = this.tablePrimaryKey !== undefined ? this.tablePrimaryKey : <any>null;
        if (this.data) {
            data["data"] = {};
            for (let key in this.data) {
                if (this.data.hasOwnProperty(key))
                    (<any>data["data"])[key] = this.data[key] !== undefined ? this.data[key] : <any>null;
            }
        }
        if (Array.isArray(this.details)) {
            data["details"] = [];
            for (let item in this.details)
                data["details"].push(this.details[item].toJSON());
        }
        return data;
    }

    clone(): AdminFormHeader {
        const json = this.toJSON();
        let result = new AdminFormHeader();
        result.init(json);
        return result;
    }
}

export interface IAdminFormHeader {
    id: number;
    tableColumnRef?: string | null;
    tablePrimaryKey?: string | null;
    data?: { [key: string]: any; } | null;
    details?: AdminFormDetail[] | null;
}

export class AdminFormDetail implements IAdminFormDetail {
    id!: number;
    tableColumnRef?: string | null;
    tablePrimaryKey?: string | null;
    data?: { [key: string]: any; } | null;

    constructor(data?: IAdminFormDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"] !== undefined ? data["id"] : <any>null;
            this.tableColumnRef = data["tableColumnRef"] !== undefined ? data["tableColumnRef"] : <any>null;
            this.tablePrimaryKey = data["tablePrimaryKey"] !== undefined ? data["tablePrimaryKey"] : <any>null;
            if (data["data"]) {
                this.data = {} as any;
                for (let key in data["data"]) {
                    if (data["data"].hasOwnProperty(key))
                        (<any>this.data)![key] = data["data"][key] !== undefined ? data["data"][key] : <any>null;
                }
            }
            else {
                this.data = <any>null;
            }
        }
    }

    static fromJS(data: any): AdminFormDetail {
        data = typeof data === 'object' ? data : {};
        let result = new AdminFormDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["tableColumnRef"] = this.tableColumnRef !== undefined ? this.tableColumnRef : <any>null;
        data["tablePrimaryKey"] = this.tablePrimaryKey !== undefined ? this.tablePrimaryKey : <any>null;
        if (this.data) {
            data["data"] = {};
            for (let key in this.data) {
                if (this.data.hasOwnProperty(key))
                    (<any>data["data"])[key] = this.data[key] !== undefined ? this.data[key] : <any>null;
            }
        }
        return data;
    }

    clone(): AdminFormDetail {
        const json = this.toJSON();
        let result = new AdminFormDetail();
        result.init(json);
        return result;
    }
}

export interface IAdminFormDetail {
    id: number;
    tableColumnRef?: string | null;
    tablePrimaryKey?: string | null;
    data?: { [key: string]: any; } | null;
}

export class SaveAdminFormDataModel implements ISaveAdminFormDataModel {
    headerForm?: AdminForm | null;
    detailForm?: AdminForm | null;
    deleteHeaders?: AdminFormHeader[] | null;
    deleteDetails?: AdminFormDetail[] | null;
    upsertHeaders?: AdminFormHeader[] | null;
    afterSaveParameters?: { [key: string]: any; } | null;

    constructor(data?: ISaveAdminFormDataModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.headerForm = data["headerForm"] ? AdminForm.fromJS(data["headerForm"]) : <any>null;
            this.detailForm = data["detailForm"] ? AdminForm.fromJS(data["detailForm"]) : <any>null;
            if (Array.isArray(data["deleteHeaders"])) {
                this.deleteHeaders = [] as any;
                for (let item in data["deleteHeaders"])
                    this.deleteHeaders!.push(AdminFormHeader.fromJS(data["deleteHeaders"][item]));
            }
            else {
                this.deleteHeaders = <any>null;
            }
            if (Array.isArray(data["deleteDetails"])) {
                this.deleteDetails = [] as any;
                for (let item in data["deleteDetails"])
                    this.deleteDetails!.push(AdminFormDetail.fromJS(data["deleteDetails"][item]));
            }
            else {
                this.deleteDetails = <any>null;
            }
            if (Array.isArray(data["upsertHeaders"])) {
                this.upsertHeaders = [] as any;
                for (let item in data["upsertHeaders"])
                    this.upsertHeaders!.push(AdminFormHeader.fromJS(data["upsertHeaders"][item]));
            }
            else {
                this.upsertHeaders = <any>null;
            }
            if (data["afterSaveParameters"]) {
                this.afterSaveParameters = {} as any;
                for (let key in data["afterSaveParameters"]) {
                    if (data["afterSaveParameters"].hasOwnProperty(key))
                        (<any>this.afterSaveParameters)![key] = data["afterSaveParameters"][key] !== undefined ? data["afterSaveParameters"][key] : <any>null;
                }
            }
            else {
                this.afterSaveParameters = <any>null;
            }
        }
    }

    static fromJS(data: any): SaveAdminFormDataModel {
        data = typeof data === 'object' ? data : {};
        let result = new SaveAdminFormDataModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["headerForm"] = this.headerForm ? this.headerForm.toJSON() : <any>null;
        data["detailForm"] = this.detailForm ? this.detailForm.toJSON() : <any>null;
        if (Array.isArray(this.deleteHeaders)) {
            data["deleteHeaders"] = [];
            for (let item in this.deleteHeaders)
                data["deleteHeaders"].push(this.deleteHeaders[item].toJSON());
        }
        if (Array.isArray(this.deleteDetails)) {
            data["deleteDetails"] = [];
            for (let item in this.deleteDetails)
                data["deleteDetails"].push(this.deleteDetails[item].toJSON());
        }
        if (Array.isArray(this.upsertHeaders)) {
            data["upsertHeaders"] = [];
            for (let item in this.upsertHeaders)
                data["upsertHeaders"].push(this.upsertHeaders[item].toJSON());
        }
        if (this.afterSaveParameters) {
            data["afterSaveParameters"] = {};
            for (let key in this.afterSaveParameters) {
                if (this.afterSaveParameters.hasOwnProperty(key))
                    (<any>data["afterSaveParameters"])[key] = this.afterSaveParameters[key] !== undefined ? this.afterSaveParameters[key] : <any>null;
            }
        }
        return data;
    }

    clone(): SaveAdminFormDataModel {
        const json = this.toJSON();
        let result = new SaveAdminFormDataModel();
        result.init(json);
        return result;
    }
}

export interface ISaveAdminFormDataModel {
    headerForm?: AdminForm | null;
    detailForm?: AdminForm | null;
    deleteHeaders?: AdminFormHeader[] | null;
    deleteDetails?: AdminFormDetail[] | null;
    upsertHeaders?: AdminFormHeader[] | null;
    afterSaveParameters?: { [key: string]: any; } | null;
}

export class AdminCategory implements IAdminCategory {
    id!: number;
    name?: string | null;
    icon?: string | null;
    displayName?: string | null;
    forms?: AdminForm[] | null;

    constructor(data?: IAdminCategory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"] !== undefined ? data["id"] : <any>null;
            this.name = data["name"] !== undefined ? data["name"] : <any>null;
            this.icon = data["icon"] !== undefined ? data["icon"] : <any>null;
            this.displayName = data["displayName"] !== undefined ? data["displayName"] : <any>null;
            if (Array.isArray(data["forms"])) {
                this.forms = [] as any;
                for (let item in data["forms"])
                    this.forms!.push(AdminForm.fromJS(data["forms"][item]));
            }
            else {
                this.forms = <any>null;
            }
        }
    }

    static fromJS(data: any): AdminCategory {
        data = typeof data === 'object' ? data : {};
        let result = new AdminCategory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["icon"] = this.icon !== undefined ? this.icon : <any>null;
        data["displayName"] = this.displayName !== undefined ? this.displayName : <any>null;
        if (Array.isArray(this.forms)) {
            data["forms"] = [];
            for (let item in this.forms)
                data["forms"].push(this.forms[item].toJSON());
        }
        return data;
    }

    clone(): AdminCategory {
        const json = this.toJSON();
        let result = new AdminCategory();
        result.init(json);
        return result;
    }
}

export interface IAdminCategory {
    id: number;
    name?: string | null;
    icon?: string | null;
    displayName?: string | null;
    forms?: AdminForm[] | null;
}

export class MaintenanceBulkResponse implements IMaintenanceBulkResponse {
    results?: { [key: string]: { [key: string]: any; }[]; } | null;

    constructor(data?: IMaintenanceBulkResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["results"]) {
                this.results = {} as any;
                for (let key in data["results"]) {
                    if (data["results"].hasOwnProperty(key))
                        (<any>this.results)![key] = data["results"][key] !== undefined ? data["results"][key] : [];
                }
            }
            else {
                this.results = <any>null;
            }
        }
    }

    static fromJS(data: any): MaintenanceBulkResponse {
        data = typeof data === 'object' ? data : {};
        let result = new MaintenanceBulkResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.results) {
            data["results"] = {};
            for (let key in this.results) {
                if (this.results.hasOwnProperty(key))
                    (<any>data["results"])[key] = this.results[key] !== undefined ? this.results[key] : <any>null;
            }
        }
        return data;
    }

    clone(): MaintenanceBulkResponse {
        const json = this.toJSON();
        let result = new MaintenanceBulkResponse();
        result.init(json);
        return result;
    }
}

export interface IMaintenanceBulkResponse {
    results?: { [key: string]: { [key: string]: any; }[]; } | null;
}

export class MaintenanceBulkRequest implements IMaintenanceBulkRequest {
    requests?: MaintenanceDataRequest[] | null;

    constructor(data?: IMaintenanceBulkRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (Array.isArray(data["requests"])) {
                this.requests = [] as any;
                for (let item in data["requests"])
                    this.requests!.push(MaintenanceDataRequest.fromJS(data["requests"][item]));
            }
            else {
                this.requests = <any>null;
            }
        }
    }

    static fromJS(data: any): MaintenanceBulkRequest {
        data = typeof data === 'object' ? data : {};
        let result = new MaintenanceBulkRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.requests)) {
            data["requests"] = [];
            for (let item in this.requests)
                data["requests"].push(this.requests[item].toJSON());
        }
        return data;
    }

    clone(): MaintenanceBulkRequest {
        const json = this.toJSON();
        let result = new MaintenanceBulkRequest();
        result.init(json);
        return result;
    }
}

export interface IMaintenanceBulkRequest {
    requests?: MaintenanceDataRequest[] | null;
}

export class MaintenanceDataRequest implements IMaintenanceDataRequest {
    requestId?: string | null;
    formId!: number;
    tablePrimaryKey?: string | null;
    type?: string | null;
    matchingValue?: string | null;

    constructor(data?: IMaintenanceDataRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.requestId = data["requestId"] !== undefined ? data["requestId"] : <any>null;
            this.formId = data["formId"] !== undefined ? data["formId"] : <any>null;
            this.tablePrimaryKey = data["tablePrimaryKey"] !== undefined ? data["tablePrimaryKey"] : <any>null;
            this.type = data["type"] !== undefined ? data["type"] : <any>null;
            this.matchingValue = data["matchingValue"] !== undefined ? data["matchingValue"] : <any>null;
        }
    }

    static fromJS(data: any): MaintenanceDataRequest {
        data = typeof data === 'object' ? data : {};
        let result = new MaintenanceDataRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestId"] = this.requestId !== undefined ? this.requestId : <any>null;
        data["formId"] = this.formId !== undefined ? this.formId : <any>null;
        data["tablePrimaryKey"] = this.tablePrimaryKey !== undefined ? this.tablePrimaryKey : <any>null;
        data["type"] = this.type !== undefined ? this.type : <any>null;
        data["matchingValue"] = this.matchingValue !== undefined ? this.matchingValue : <any>null;
        return data;
    }

    clone(): MaintenanceDataRequest {
        const json = this.toJSON();
        let result = new MaintenanceDataRequest();
        result.init(json);
        return result;
    }
}

export interface IMaintenanceDataRequest {
    requestId?: string | null;
    formId: number;
    tablePrimaryKey?: string | null;
    type?: string | null;
    matchingValue?: string | null;
}

export class CopyDataResponse implements ICopyDataResponse {
    updated!: number;
    deleted!: number;
    inserted!: number;

    constructor(data?: ICopyDataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.updated = data["updated"] !== undefined ? data["updated"] : <any>null;
            this.deleted = data["deleted"] !== undefined ? data["deleted"] : <any>null;
            this.inserted = data["inserted"] !== undefined ? data["inserted"] : <any>null;
        }
    }

    static fromJS(data: any): CopyDataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CopyDataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["updated"] = this.updated !== undefined ? this.updated : <any>null;
        data["deleted"] = this.deleted !== undefined ? this.deleted : <any>null;
        data["inserted"] = this.inserted !== undefined ? this.inserted : <any>null;
        return data;
    }

    clone(): CopyDataResponse {
        const json = this.toJSON();
        let result = new CopyDataResponse();
        result.init(json);
        return result;
    }
}

export interface ICopyDataResponse {
    updated: number;
    deleted: number;
    inserted: number;
}

export class CopyDataRequest implements ICopyDataRequest {
    user?: string | null;
    model?: string | null;
    json?: string | null;
    clear!: boolean;

    constructor(data?: ICopyDataRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.user = data["user"] !== undefined ? data["user"] : <any>null;
            this.model = data["model"] !== undefined ? data["model"] : <any>null;
            this.json = data["json"] !== undefined ? data["json"] : <any>null;
            this.clear = data["clear"] !== undefined ? data["clear"] : <any>null;
        }
    }

    static fromJS(data: any): CopyDataRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CopyDataRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user !== undefined ? this.user : <any>null;
        data["model"] = this.model !== undefined ? this.model : <any>null;
        data["json"] = this.json !== undefined ? this.json : <any>null;
        data["clear"] = this.clear !== undefined ? this.clear : <any>null;
        return data;
    }

    clone(): CopyDataRequest {
        const json = this.toJSON();
        let result = new CopyDataRequest();
        result.init(json);
        return result;
    }
}

export interface ICopyDataRequest {
    user?: string | null;
    model?: string | null;
    json?: string | null;
    clear: boolean;
}

export class OpenPeriod implements IOpenPeriod {
    scenario_Key?: any | null;
    date_Key?: any | null;

    constructor(data?: IOpenPeriod) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.scenario_Key = data["scenario_Key"] !== undefined ? data["scenario_Key"] : <any>null;
            this.date_Key = data["date_Key"] !== undefined ? data["date_Key"] : <any>null;
        }
    }

    static fromJS(data: any): OpenPeriod {
        data = typeof data === 'object' ? data : {};
        let result = new OpenPeriod();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["scenario_Key"] = this.scenario_Key !== undefined ? this.scenario_Key : <any>null;
        data["date_Key"] = this.date_Key !== undefined ? this.date_Key : <any>null;
        return data;
    }

    clone(): OpenPeriod {
        const json = this.toJSON();
        let result = new OpenPeriod();
        result.init(json);
        return result;
    }
}

export interface IOpenPeriod {
    scenario_Key?: any | null;
    date_Key?: any | null;
}

export class OwnershipTreeNodeDto implements IOwnershipTreeNodeDto {
    entity?: string | null;
    entityCaption?: string | null;
    groupInfo?: OwnershipGroupInfoDto | null;
    directInfo?: OwnershipDirectInfoDto | null;
    subsidiaries?: OwnershipTreeNodeDto[] | null;

    constructor(data?: IOwnershipTreeNodeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.entity = data["entity"] !== undefined ? data["entity"] : <any>null;
            this.entityCaption = data["entityCaption"] !== undefined ? data["entityCaption"] : <any>null;
            this.groupInfo = data["groupInfo"] ? OwnershipGroupInfoDto.fromJS(data["groupInfo"]) : <any>null;
            this.directInfo = data["directInfo"] ? OwnershipDirectInfoDto.fromJS(data["directInfo"]) : <any>null;
            if (Array.isArray(data["subsidiaries"])) {
                this.subsidiaries = [] as any;
                for (let item in data["subsidiaries"])
                    this.subsidiaries!.push(OwnershipTreeNodeDto.fromJS(data["subsidiaries"][item]));
            }
            else {
                this.subsidiaries = <any>null;
            }
        }
    }

    static fromJS(data: any): OwnershipTreeNodeDto {
        data = typeof data === 'object' ? data : {};
        let result = new OwnershipTreeNodeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entity"] = this.entity !== undefined ? this.entity : <any>null;
        data["entityCaption"] = this.entityCaption !== undefined ? this.entityCaption : <any>null;
        data["groupInfo"] = this.groupInfo ? this.groupInfo.toJSON() : <any>null;
        data["directInfo"] = this.directInfo ? this.directInfo.toJSON() : <any>null;
        if (Array.isArray(this.subsidiaries)) {
            data["subsidiaries"] = [];
            for (let item in this.subsidiaries)
                data["subsidiaries"].push(this.subsidiaries[item].toJSON());
        }
        return data;
    }

    clone(): OwnershipTreeNodeDto {
        const json = this.toJSON();
        let result = new OwnershipTreeNodeDto();
        result.init(json);
        return result;
    }
}

export interface IOwnershipTreeNodeDto {
    entity?: string | null;
    entityCaption?: string | null;
    groupInfo?: OwnershipGroupInfoDto | null;
    directInfo?: OwnershipDirectInfoDto | null;
    subsidiaries?: OwnershipTreeNodeDto[] | null;
}

export class OwnershipGroupInfoDto implements IOwnershipGroupInfoDto {
    group?: string | null;
    scenario?: string | null;
    method?: string | null;
    groupPercentage?: number | null;
    controlPercentage?: number | null;
    minorityPercentage?: number | null;
    groupDateRange?: DateMemberRangeDto | null;

    constructor(data?: IOwnershipGroupInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.group = data["group"] !== undefined ? data["group"] : <any>null;
            this.scenario = data["scenario"] !== undefined ? data["scenario"] : <any>null;
            this.method = data["method"] !== undefined ? data["method"] : <any>null;
            this.groupPercentage = data["groupPercentage"] !== undefined ? data["groupPercentage"] : <any>null;
            this.controlPercentage = data["controlPercentage"] !== undefined ? data["controlPercentage"] : <any>null;
            this.minorityPercentage = data["minorityPercentage"] !== undefined ? data["minorityPercentage"] : <any>null;
            this.groupDateRange = data["groupDateRange"] ? DateMemberRangeDto.fromJS(data["groupDateRange"]) : <any>null;
        }
    }

    static fromJS(data: any): OwnershipGroupInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new OwnershipGroupInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["group"] = this.group !== undefined ? this.group : <any>null;
        data["scenario"] = this.scenario !== undefined ? this.scenario : <any>null;
        data["method"] = this.method !== undefined ? this.method : <any>null;
        data["groupPercentage"] = this.groupPercentage !== undefined ? this.groupPercentage : <any>null;
        data["controlPercentage"] = this.controlPercentage !== undefined ? this.controlPercentage : <any>null;
        data["minorityPercentage"] = this.minorityPercentage !== undefined ? this.minorityPercentage : <any>null;
        data["groupDateRange"] = this.groupDateRange ? this.groupDateRange.toJSON() : <any>null;
        return data;
    }

    clone(): OwnershipGroupInfoDto {
        const json = this.toJSON();
        let result = new OwnershipGroupInfoDto();
        result.init(json);
        return result;
    }
}

export interface IOwnershipGroupInfoDto {
    group?: string | null;
    scenario?: string | null;
    method?: string | null;
    groupPercentage?: number | null;
    controlPercentage?: number | null;
    minorityPercentage?: number | null;
    groupDateRange?: DateMemberRangeDto | null;
}

export class DateMemberRangeDto implements IDateMemberRangeDto {
    start?: DateRangeDto | null;
    end?: DateRangeDto | null;

    constructor(data?: IDateMemberRangeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.start = data["start"] ? DateRangeDto.fromJS(data["start"]) : <any>null;
            this.end = data["end"] ? DateRangeDto.fromJS(data["end"]) : <any>null;
        }
    }

    static fromJS(data: any): DateMemberRangeDto {
        data = typeof data === 'object' ? data : {};
        let result = new DateMemberRangeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["start"] = this.start ? this.start.toJSON() : <any>null;
        data["end"] = this.end ? this.end.toJSON() : <any>null;
        return data;
    }

    clone(): DateMemberRangeDto {
        const json = this.toJSON();
        let result = new DateMemberRangeDto();
        result.init(json);
        return result;
    }
}

export interface IDateMemberRangeDto {
    start?: DateRangeDto | null;
    end?: DateRangeDto | null;
}

export class DateRangeDto implements IDateRangeDto {
    memberName?: string | null;
    firstDate?: Date | null;
    lastDate?: Date | null;

    constructor(data?: IDateRangeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.memberName = data["memberName"] !== undefined ? data["memberName"] : <any>null;
            this.firstDate = data["firstDate"] ? new Date(data["firstDate"].toString()) : <any>null;
            this.lastDate = data["lastDate"] ? new Date(data["lastDate"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): DateRangeDto {
        data = typeof data === 'object' ? data : {};
        let result = new DateRangeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberName"] = this.memberName !== undefined ? this.memberName : <any>null;
        data["firstDate"] = this.firstDate ? this.firstDate.toISOString() : <any>null;
        data["lastDate"] = this.lastDate ? this.lastDate.toISOString() : <any>null;
        return data;
    }

    clone(): DateRangeDto {
        const json = this.toJSON();
        let result = new DateRangeDto();
        result.init(json);
        return result;
    }
}

export interface IDateRangeDto {
    memberName?: string | null;
    firstDate?: Date | null;
    lastDate?: Date | null;
}

export class OwnershipDirectInfoDto implements IOwnershipDirectInfoDto {
    scenario?: string | null;
    directPercentage?: number | null;
    directDateRange?: DateMemberRangeDto | null;

    constructor(data?: IOwnershipDirectInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.scenario = data["scenario"] !== undefined ? data["scenario"] : <any>null;
            this.directPercentage = data["directPercentage"] !== undefined ? data["directPercentage"] : <any>null;
            this.directDateRange = data["directDateRange"] ? DateMemberRangeDto.fromJS(data["directDateRange"]) : <any>null;
        }
    }

    static fromJS(data: any): OwnershipDirectInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new OwnershipDirectInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["scenario"] = this.scenario !== undefined ? this.scenario : <any>null;
        data["directPercentage"] = this.directPercentage !== undefined ? this.directPercentage : <any>null;
        data["directDateRange"] = this.directDateRange ? this.directDateRange.toJSON() : <any>null;
        return data;
    }

    clone(): OwnershipDirectInfoDto {
        const json = this.toJSON();
        let result = new OwnershipDirectInfoDto();
        result.init(json);
        return result;
    }
}

export interface IOwnershipDirectInfoDto {
    scenario?: string | null;
    directPercentage?: number | null;
    directDateRange?: DateMemberRangeDto | null;
}

export class DirectOwnershipResultDto implements IDirectOwnershipResultDto {
    entityOwnership?: { [key: string]: DirectOwnershipEntryDto[]; } | null;

    constructor(data?: IDirectOwnershipResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["entityOwnership"]) {
                this.entityOwnership = {} as any;
                for (let key in data["entityOwnership"]) {
                    if (data["entityOwnership"].hasOwnProperty(key))
                        (<any>this.entityOwnership)![key] = data["entityOwnership"][key] ? data["entityOwnership"][key].map((i: any) => DirectOwnershipEntryDto.fromJS(i)) : [];
                }
            }
            else {
                this.entityOwnership = <any>null;
            }
        }
    }

    static fromJS(data: any): DirectOwnershipResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new DirectOwnershipResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.entityOwnership) {
            data["entityOwnership"] = {};
            for (let key in this.entityOwnership) {
                if (this.entityOwnership.hasOwnProperty(key))
                    (<any>data["entityOwnership"])[key] = this.entityOwnership[key] !== undefined ? this.entityOwnership[key] : <any>null;
            }
        }
        return data;
    }

    clone(): DirectOwnershipResultDto {
        const json = this.toJSON();
        let result = new DirectOwnershipResultDto();
        result.init(json);
        return result;
    }
}

export interface IDirectOwnershipResultDto {
    entityOwnership?: { [key: string]: DirectOwnershipEntryDto[]; } | null;
}

export class DirectOwnershipEntryDto implements IDirectOwnershipEntryDto {
    dataId!: number;
    intercompany?: string | null;
    ownership!: number;
    start?: DateRangeDto | null;
    end?: DateRangeDto | null;

    constructor(data?: IDirectOwnershipEntryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.dataId = data["dataId"] !== undefined ? data["dataId"] : <any>null;
            this.intercompany = data["intercompany"] !== undefined ? data["intercompany"] : <any>null;
            this.ownership = data["ownership"] !== undefined ? data["ownership"] : <any>null;
            this.start = data["start"] ? DateRangeDto.fromJS(data["start"]) : <any>null;
            this.end = data["end"] ? DateRangeDto.fromJS(data["end"]) : <any>null;
        }
    }

    static fromJS(data: any): DirectOwnershipEntryDto {
        data = typeof data === 'object' ? data : {};
        let result = new DirectOwnershipEntryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dataId"] = this.dataId !== undefined ? this.dataId : <any>null;
        data["intercompany"] = this.intercompany !== undefined ? this.intercompany : <any>null;
        data["ownership"] = this.ownership !== undefined ? this.ownership : <any>null;
        data["start"] = this.start ? this.start.toJSON() : <any>null;
        data["end"] = this.end ? this.end.toJSON() : <any>null;
        return data;
    }

    clone(): DirectOwnershipEntryDto {
        const json = this.toJSON();
        let result = new DirectOwnershipEntryDto();
        result.init(json);
        return result;
    }
}

export interface IDirectOwnershipEntryDto {
    dataId: number;
    intercompany?: string | null;
    ownership: number;
    start?: DateRangeDto | null;
    end?: DateRangeDto | null;
}

export class ManageOwnershipResultDto implements IManageOwnershipResultDto {
    entityOwnership?: { [key: string]: ManageOwnershipEntryDto[]; } | null;

    constructor(data?: IManageOwnershipResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["entityOwnership"]) {
                this.entityOwnership = {} as any;
                for (let key in data["entityOwnership"]) {
                    if (data["entityOwnership"].hasOwnProperty(key))
                        (<any>this.entityOwnership)![key] = data["entityOwnership"][key] ? data["entityOwnership"][key].map((i: any) => ManageOwnershipEntryDto.fromJS(i)) : [];
                }
            }
            else {
                this.entityOwnership = <any>null;
            }
        }
    }

    static fromJS(data: any): ManageOwnershipResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ManageOwnershipResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.entityOwnership) {
            data["entityOwnership"] = {};
            for (let key in this.entityOwnership) {
                if (this.entityOwnership.hasOwnProperty(key))
                    (<any>data["entityOwnership"])[key] = this.entityOwnership[key] !== undefined ? this.entityOwnership[key] : <any>null;
            }
        }
        return data;
    }

    clone(): ManageOwnershipResultDto {
        const json = this.toJSON();
        let result = new ManageOwnershipResultDto();
        result.init(json);
        return result;
    }
}

export interface IManageOwnershipResultDto {
    entityOwnership?: { [key: string]: ManageOwnershipEntryDto[]; } | null;
}

export class ManageOwnershipEntryDto implements IManageOwnershipEntryDto {
    dataId!: number;
    group?: string | null;
    methodKey!: number;
    method?: string | null;
    pown?: number | null;
    pcon?: number | null;
    pmin?: number | null;
    start?: DateRangeDto | null;
    end?: DateRangeDto | null;

    constructor(data?: IManageOwnershipEntryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.dataId = data["dataId"] !== undefined ? data["dataId"] : <any>null;
            this.group = data["group"] !== undefined ? data["group"] : <any>null;
            this.methodKey = data["methodKey"] !== undefined ? data["methodKey"] : <any>null;
            this.method = data["method"] !== undefined ? data["method"] : <any>null;
            this.pown = data["pown"] !== undefined ? data["pown"] : <any>null;
            this.pcon = data["pcon"] !== undefined ? data["pcon"] : <any>null;
            this.pmin = data["pmin"] !== undefined ? data["pmin"] : <any>null;
            this.start = data["start"] ? DateRangeDto.fromJS(data["start"]) : <any>null;
            this.end = data["end"] ? DateRangeDto.fromJS(data["end"]) : <any>null;
        }
    }

    static fromJS(data: any): ManageOwnershipEntryDto {
        data = typeof data === 'object' ? data : {};
        let result = new ManageOwnershipEntryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dataId"] = this.dataId !== undefined ? this.dataId : <any>null;
        data["group"] = this.group !== undefined ? this.group : <any>null;
        data["methodKey"] = this.methodKey !== undefined ? this.methodKey : <any>null;
        data["method"] = this.method !== undefined ? this.method : <any>null;
        data["pown"] = this.pown !== undefined ? this.pown : <any>null;
        data["pcon"] = this.pcon !== undefined ? this.pcon : <any>null;
        data["pmin"] = this.pmin !== undefined ? this.pmin : <any>null;
        data["start"] = this.start ? this.start.toJSON() : <any>null;
        data["end"] = this.end ? this.end.toJSON() : <any>null;
        return data;
    }

    clone(): ManageOwnershipEntryDto {
        const json = this.toJSON();
        let result = new ManageOwnershipEntryDto();
        result.init(json);
        return result;
    }
}

export interface IManageOwnershipEntryDto {
    dataId: number;
    group?: string | null;
    methodKey: number;
    method?: string | null;
    pown?: number | null;
    pcon?: number | null;
    pmin?: number | null;
    start?: DateRangeDto | null;
    end?: DateRangeDto | null;
}

export class ConsolidationMethodDto implements IConsolidationMethodDto {
    key!: number;
    name?: string | null;
    caption?: string | null;
    methodType?: string | null;
    sortOrder!: number;

    constructor(data?: IConsolidationMethodDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.key = data["key"] !== undefined ? data["key"] : <any>null;
            this.name = data["name"] !== undefined ? data["name"] : <any>null;
            this.caption = data["caption"] !== undefined ? data["caption"] : <any>null;
            this.methodType = data["methodType"] !== undefined ? data["methodType"] : <any>null;
            this.sortOrder = data["sortOrder"] !== undefined ? data["sortOrder"] : <any>null;
        }
    }

    static fromJS(data: any): ConsolidationMethodDto {
        data = typeof data === 'object' ? data : {};
        let result = new ConsolidationMethodDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key !== undefined ? this.key : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["caption"] = this.caption !== undefined ? this.caption : <any>null;
        data["methodType"] = this.methodType !== undefined ? this.methodType : <any>null;
        data["sortOrder"] = this.sortOrder !== undefined ? this.sortOrder : <any>null;
        return data;
    }

    clone(): ConsolidationMethodDto {
        const json = this.toJSON();
        let result = new ConsolidationMethodDto();
        result.init(json);
        return result;
    }
}

export interface IConsolidationMethodDto {
    key: number;
    name?: string | null;
    caption?: string | null;
    methodType?: string | null;
    sortOrder: number;
}

export class AiMappingResponsesDto implements IAiMappingResponsesDto {
    mappingResponses?: AiMappingResponseDto[] | null;

    constructor(data?: IAiMappingResponsesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (Array.isArray(data["mappingResponses"])) {
                this.mappingResponses = [] as any;
                for (let item in data["mappingResponses"])
                    this.mappingResponses!.push(AiMappingResponseDto.fromJS(data["mappingResponses"][item]));
            }
            else {
                this.mappingResponses = <any>null;
            }
        }
    }

    static fromJS(data: any): AiMappingResponsesDto {
        data = typeof data === 'object' ? data : {};
        let result = new AiMappingResponsesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.mappingResponses)) {
            data["mappingResponses"] = [];
            for (let item in this.mappingResponses)
                data["mappingResponses"].push(this.mappingResponses[item].toJSON());
        }
        return data;
    }

    clone(): AiMappingResponsesDto {
        const json = this.toJSON();
        let result = new AiMappingResponsesDto();
        result.init(json);
        return result;
    }
}

export interface IAiMappingResponsesDto {
    mappingResponses?: AiMappingResponseDto[] | null;
}

export class AiMappingResponseDto implements IAiMappingResponseDto {
    dimensionName?: string | null;
    mappingType!: MappingType;
    sourceName?: string | null;
    sourceCaption?: string | null;
    suggestedTargetName?: string | null;
    targetCaption?: string | null;
    confidencePercentage!: number;

    constructor(data?: IAiMappingResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.dimensionName = data["dimensionName"] !== undefined ? data["dimensionName"] : <any>null;
            this.mappingType = data["mappingType"] !== undefined ? data["mappingType"] : <any>null;
            this.sourceName = data["sourceName"] !== undefined ? data["sourceName"] : <any>null;
            this.sourceCaption = data["sourceCaption"] !== undefined ? data["sourceCaption"] : <any>null;
            this.suggestedTargetName = data["suggestedTargetName"] !== undefined ? data["suggestedTargetName"] : <any>null;
            this.targetCaption = data["targetCaption"] !== undefined ? data["targetCaption"] : <any>null;
            this.confidencePercentage = data["confidencePercentage"] !== undefined ? data["confidencePercentage"] : <any>null;
        }
    }

    static fromJS(data: any): AiMappingResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new AiMappingResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dimensionName"] = this.dimensionName !== undefined ? this.dimensionName : <any>null;
        data["mappingType"] = this.mappingType !== undefined ? this.mappingType : <any>null;
        data["sourceName"] = this.sourceName !== undefined ? this.sourceName : <any>null;
        data["sourceCaption"] = this.sourceCaption !== undefined ? this.sourceCaption : <any>null;
        data["suggestedTargetName"] = this.suggestedTargetName !== undefined ? this.suggestedTargetName : <any>null;
        data["targetCaption"] = this.targetCaption !== undefined ? this.targetCaption : <any>null;
        data["confidencePercentage"] = this.confidencePercentage !== undefined ? this.confidencePercentage : <any>null;
        return data;
    }

    clone(): AiMappingResponseDto {
        const json = this.toJSON();
        let result = new AiMappingResponseDto();
        result.init(json);
        return result;
    }
}

export interface IAiMappingResponseDto {
    dimensionName?: string | null;
    mappingType: MappingType;
    sourceName?: string | null;
    sourceCaption?: string | null;
    suggestedTargetName?: string | null;
    targetCaption?: string | null;
    confidencePercentage: number;
}

export enum MappingType {
    Exact = 1,
    In = 2,
    Range = 3,
    Wildcard = 4,
}

export class AiMappingRequestsDto implements IAiMappingRequestsDto {
    mappingRequests!: AiMappingRequestDto[];

    constructor(data?: IAiMappingRequestsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.mappingRequests = [];
        }
    }

    init(data?: any) {
        if (data) {
            if (Array.isArray(data["mappingRequests"])) {
                this.mappingRequests = [] as any;
                for (let item in data["mappingRequests"])
                    this.mappingRequests!.push(AiMappingRequestDto.fromJS(data["mappingRequests"][item]));
            }
            else {
                this.mappingRequests = <any>null;
            }
        }
    }

    static fromJS(data: any): AiMappingRequestsDto {
        data = typeof data === 'object' ? data : {};
        let result = new AiMappingRequestsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.mappingRequests)) {
            data["mappingRequests"] = [];
            for (let item in this.mappingRequests)
                data["mappingRequests"].push(this.mappingRequests[item].toJSON());
        }
        return data;
    }

    clone(): AiMappingRequestsDto {
        const json = this.toJSON();
        let result = new AiMappingRequestsDto();
        result.init(json);
        return result;
    }
}

export interface IAiMappingRequestsDto {
    mappingRequests: AiMappingRequestDto[];
}

export class AiMappingRequestDto implements IAiMappingRequestDto {
    dimensionName?: string | null;
    sourceName?: string | null;
    sourceCaption?: string | null;

    constructor(data?: IAiMappingRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.dimensionName = data["dimensionName"] !== undefined ? data["dimensionName"] : <any>null;
            this.sourceName = data["sourceName"] !== undefined ? data["sourceName"] : <any>null;
            this.sourceCaption = data["sourceCaption"] !== undefined ? data["sourceCaption"] : <any>null;
        }
    }

    static fromJS(data: any): AiMappingRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new AiMappingRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dimensionName"] = this.dimensionName !== undefined ? this.dimensionName : <any>null;
        data["sourceName"] = this.sourceName !== undefined ? this.sourceName : <any>null;
        data["sourceCaption"] = this.sourceCaption !== undefined ? this.sourceCaption : <any>null;
        return data;
    }

    clone(): AiMappingRequestDto {
        const json = this.toJSON();
        let result = new AiMappingRequestDto();
        result.init(json);
        return result;
    }
}

export interface IAiMappingRequestDto {
    dimensionName?: string | null;
    sourceName?: string | null;
    sourceCaption?: string | null;
}

export class MatchGroupInfo implements IMatchGroupInfo {
    matchGroup?: string | null;
    leftDatasets?: DatasetInfo[] | null;
    rightDatasets?: DatasetInfo[] | null;
    manualMatchMaxVariance!: number;
    active!: boolean;

    constructor(data?: IMatchGroupInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.matchGroup = data["matchGroup"] !== undefined ? data["matchGroup"] : <any>null;
            if (Array.isArray(data["leftDatasets"])) {
                this.leftDatasets = [] as any;
                for (let item in data["leftDatasets"])
                    this.leftDatasets!.push(DatasetInfo.fromJS(data["leftDatasets"][item]));
            }
            else {
                this.leftDatasets = <any>null;
            }
            if (Array.isArray(data["rightDatasets"])) {
                this.rightDatasets = [] as any;
                for (let item in data["rightDatasets"])
                    this.rightDatasets!.push(DatasetInfo.fromJS(data["rightDatasets"][item]));
            }
            else {
                this.rightDatasets = <any>null;
            }
            this.manualMatchMaxVariance = data["manualMatchMaxVariance"] !== undefined ? data["manualMatchMaxVariance"] : <any>null;
            this.active = data["active"] !== undefined ? data["active"] : <any>null;
        }
    }

    static fromJS(data: any): MatchGroupInfo {
        data = typeof data === 'object' ? data : {};
        let result = new MatchGroupInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["matchGroup"] = this.matchGroup !== undefined ? this.matchGroup : <any>null;
        if (Array.isArray(this.leftDatasets)) {
            data["leftDatasets"] = [];
            for (let item in this.leftDatasets)
                data["leftDatasets"].push(this.leftDatasets[item].toJSON());
        }
        if (Array.isArray(this.rightDatasets)) {
            data["rightDatasets"] = [];
            for (let item in this.rightDatasets)
                data["rightDatasets"].push(this.rightDatasets[item].toJSON());
        }
        data["manualMatchMaxVariance"] = this.manualMatchMaxVariance !== undefined ? this.manualMatchMaxVariance : <any>null;
        data["active"] = this.active !== undefined ? this.active : <any>null;
        return data;
    }

    clone(): MatchGroupInfo {
        const json = this.toJSON();
        let result = new MatchGroupInfo();
        result.init(json);
        return result;
    }
}

export interface IMatchGroupInfo {
    matchGroup?: string | null;
    leftDatasets?: DatasetInfo[] | null;
    rightDatasets?: DatasetInfo[] | null;
    manualMatchMaxVariance: number;
    active: boolean;
}

export class DatasetInfo implements IDatasetInfo {
    name?: string | null;
    table?: string | null;
    idField?: string | null;
    dateField?: string | null;
    amountField?: string | null;
    filterLogic?: string | null;

    constructor(data?: IDatasetInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"] !== undefined ? data["name"] : <any>null;
            this.table = data["table"] !== undefined ? data["table"] : <any>null;
            this.idField = data["idField"] !== undefined ? data["idField"] : <any>null;
            this.dateField = data["dateField"] !== undefined ? data["dateField"] : <any>null;
            this.amountField = data["amountField"] !== undefined ? data["amountField"] : <any>null;
            this.filterLogic = data["filterLogic"] !== undefined ? data["filterLogic"] : <any>null;
        }
    }

    static fromJS(data: any): DatasetInfo {
        data = typeof data === 'object' ? data : {};
        let result = new DatasetInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["table"] = this.table !== undefined ? this.table : <any>null;
        data["idField"] = this.idField !== undefined ? this.idField : <any>null;
        data["dateField"] = this.dateField !== undefined ? this.dateField : <any>null;
        data["amountField"] = this.amountField !== undefined ? this.amountField : <any>null;
        data["filterLogic"] = this.filterLogic !== undefined ? this.filterLogic : <any>null;
        return data;
    }

    clone(): DatasetInfo {
        const json = this.toJSON();
        let result = new DatasetInfo();
        result.init(json);
        return result;
    }
}

export interface IDatasetInfo {
    name?: string | null;
    table?: string | null;
    idField?: string | null;
    dateField?: string | null;
    amountField?: string | null;
    filterLogic?: string | null;
}

export class MatchInfo implements IMatchInfo {
    matchId?: string | null;
    matchGroup?: string | null;
    matchType!: number;
    confidence!: number;
    dataset1?: string | null;
    dataset2?: string | null;
    auditTimestamp?: string | null;
    ruleId?: number | null;
    ruleName?: string | null;
    subtotal1Mod?: string | null;
    subtotal1?: number | null;
    subtotal2Mod?: string | null;
    subtotal2?: number | null;
    auditUsername?: string | null;
    variance?: number | null;
    matchNotes?: MatchNote[] | null;
    matchData?: MatchData[] | null;

    constructor(data?: IMatchInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.matchId = data["matchId"] !== undefined ? data["matchId"] : <any>null;
            this.matchGroup = data["matchGroup"] !== undefined ? data["matchGroup"] : <any>null;
            this.matchType = data["matchType"] !== undefined ? data["matchType"] : <any>null;
            this.confidence = data["confidence"] !== undefined ? data["confidence"] : <any>null;
            this.dataset1 = data["dataset1"] !== undefined ? data["dataset1"] : <any>null;
            this.dataset2 = data["dataset2"] !== undefined ? data["dataset2"] : <any>null;
            this.auditTimestamp = data["auditTimestamp"] !== undefined ? data["auditTimestamp"] : <any>null;
            this.ruleId = data["ruleId"] !== undefined ? data["ruleId"] : <any>null;
            this.ruleName = data["ruleName"] !== undefined ? data["ruleName"] : <any>null;
            this.subtotal1Mod = data["subtotal1Mod"] !== undefined ? data["subtotal1Mod"] : <any>null;
            this.subtotal1 = data["subtotal1"] !== undefined ? data["subtotal1"] : <any>null;
            this.subtotal2Mod = data["subtotal2Mod"] !== undefined ? data["subtotal2Mod"] : <any>null;
            this.subtotal2 = data["subtotal2"] !== undefined ? data["subtotal2"] : <any>null;
            this.auditUsername = data["auditUsername"] !== undefined ? data["auditUsername"] : <any>null;
            this.variance = data["variance"] !== undefined ? data["variance"] : <any>null;
            if (Array.isArray(data["matchNotes"])) {
                this.matchNotes = [] as any;
                for (let item in data["matchNotes"])
                    this.matchNotes!.push(MatchNote.fromJS(data["matchNotes"][item]));
            }
            else {
                this.matchNotes = <any>null;
            }
            if (Array.isArray(data["matchData"])) {
                this.matchData = [] as any;
                for (let item in data["matchData"])
                    this.matchData!.push(MatchData.fromJS(data["matchData"][item]));
            }
            else {
                this.matchData = <any>null;
            }
        }
    }

    static fromJS(data: any): MatchInfo {
        data = typeof data === 'object' ? data : {};
        let result = new MatchInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["matchId"] = this.matchId !== undefined ? this.matchId : <any>null;
        data["matchGroup"] = this.matchGroup !== undefined ? this.matchGroup : <any>null;
        data["matchType"] = this.matchType !== undefined ? this.matchType : <any>null;
        data["confidence"] = this.confidence !== undefined ? this.confidence : <any>null;
        data["dataset1"] = this.dataset1 !== undefined ? this.dataset1 : <any>null;
        data["dataset2"] = this.dataset2 !== undefined ? this.dataset2 : <any>null;
        data["auditTimestamp"] = this.auditTimestamp !== undefined ? this.auditTimestamp : <any>null;
        data["ruleId"] = this.ruleId !== undefined ? this.ruleId : <any>null;
        data["ruleName"] = this.ruleName !== undefined ? this.ruleName : <any>null;
        data["subtotal1Mod"] = this.subtotal1Mod !== undefined ? this.subtotal1Mod : <any>null;
        data["subtotal1"] = this.subtotal1 !== undefined ? this.subtotal1 : <any>null;
        data["subtotal2Mod"] = this.subtotal2Mod !== undefined ? this.subtotal2Mod : <any>null;
        data["subtotal2"] = this.subtotal2 !== undefined ? this.subtotal2 : <any>null;
        data["auditUsername"] = this.auditUsername !== undefined ? this.auditUsername : <any>null;
        data["variance"] = this.variance !== undefined ? this.variance : <any>null;
        if (Array.isArray(this.matchNotes)) {
            data["matchNotes"] = [];
            for (let item in this.matchNotes)
                data["matchNotes"].push(this.matchNotes[item].toJSON());
        }
        if (Array.isArray(this.matchData)) {
            data["matchData"] = [];
            for (let item in this.matchData)
                data["matchData"].push(this.matchData[item].toJSON());
        }
        return data;
    }

    clone(): MatchInfo {
        const json = this.toJSON();
        let result = new MatchInfo();
        result.init(json);
        return result;
    }
}

export interface IMatchInfo {
    matchId?: string | null;
    matchGroup?: string | null;
    matchType: number;
    confidence: number;
    dataset1?: string | null;
    dataset2?: string | null;
    auditTimestamp?: string | null;
    ruleId?: number | null;
    ruleName?: string | null;
    subtotal1Mod?: string | null;
    subtotal1?: number | null;
    subtotal2Mod?: string | null;
    subtotal2?: number | null;
    auditUsername?: string | null;
    variance?: number | null;
    matchNotes?: MatchNote[] | null;
    matchData?: MatchData[] | null;
}

export class MatchNote implements IMatchNote {
    note?: string | null;
    noteId!: number;
    username?: string | null;
    timestamp?: string | null;
    fileName?: string | null;
    fileData?: string | null;
    attachmentId?: number | null;

    constructor(data?: IMatchNote) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.note = data["note"] !== undefined ? data["note"] : <any>null;
            this.noteId = data["noteId"] !== undefined ? data["noteId"] : <any>null;
            this.username = data["username"] !== undefined ? data["username"] : <any>null;
            this.timestamp = data["timestamp"] !== undefined ? data["timestamp"] : <any>null;
            this.fileName = data["fileName"] !== undefined ? data["fileName"] : <any>null;
            this.fileData = data["fileData"] !== undefined ? data["fileData"] : <any>null;
            this.attachmentId = data["attachmentId"] !== undefined ? data["attachmentId"] : <any>null;
        }
    }

    static fromJS(data: any): MatchNote {
        data = typeof data === 'object' ? data : {};
        let result = new MatchNote();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["note"] = this.note !== undefined ? this.note : <any>null;
        data["noteId"] = this.noteId !== undefined ? this.noteId : <any>null;
        data["username"] = this.username !== undefined ? this.username : <any>null;
        data["timestamp"] = this.timestamp !== undefined ? this.timestamp : <any>null;
        data["fileName"] = this.fileName !== undefined ? this.fileName : <any>null;
        data["fileData"] = this.fileData !== undefined ? this.fileData : <any>null;
        data["attachmentId"] = this.attachmentId !== undefined ? this.attachmentId : <any>null;
        return data;
    }

    clone(): MatchNote {
        const json = this.toJSON();
        let result = new MatchNote();
        result.init(json);
        return result;
    }
}

export interface IMatchNote {
    note?: string | null;
    noteId: number;
    username?: string | null;
    timestamp?: string | null;
    fileName?: string | null;
    fileData?: string | null;
    attachmentId?: number | null;
}

export class MatchData implements IMatchData {
    dataset?: string | null;
    transactionId?: string | null;

    constructor(data?: IMatchData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.dataset = data["dataset"] !== undefined ? data["dataset"] : <any>null;
            this.transactionId = data["transactionId"] !== undefined ? data["transactionId"] : <any>null;
        }
    }

    static fromJS(data: any): MatchData {
        data = typeof data === 'object' ? data : {};
        let result = new MatchData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dataset"] = this.dataset !== undefined ? this.dataset : <any>null;
        data["transactionId"] = this.transactionId !== undefined ? this.transactionId : <any>null;
        return data;
    }

    clone(): MatchData {
        const json = this.toJSON();
        let result = new MatchData();
        result.init(json);
        return result;
    }
}

export interface IMatchData {
    dataset?: string | null;
    transactionId?: string | null;
}

export class TransactionData implements ITransactionData {
    fields?: string[] | null;
    type?: string[] | null;
    moreData!: boolean;
    matchFieldIndex!: number;
    detailFieldUnmatchIndex!: number;
    detailFieldMatchIndex!: number;
    idFieldIndex!: number;
    dateFieldIndex!: number;
    amountFieldIndex!: number;
    errorMessage?: string | null;
    rows?: DataRow[] | null;
    matches?: MatchInfo[] | null;
    supportingItems?: SupportingItemInfo[] | null;

    constructor(data?: ITransactionData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (Array.isArray(data["fields"])) {
                this.fields = [] as any;
                for (let item in data["fields"])
                    this.fields!.push(data["fields"][item]);
            }
            else {
                this.fields = <any>null;
            }
            if (Array.isArray(data["type"])) {
                this.type = [] as any;
                for (let item in data["type"])
                    this.type!.push(data["type"][item]);
            }
            else {
                this.type = <any>null;
            }
            this.moreData = data["moreData"] !== undefined ? data["moreData"] : <any>null;
            this.matchFieldIndex = data["matchFieldIndex"] !== undefined ? data["matchFieldIndex"] : <any>null;
            this.detailFieldUnmatchIndex = data["detailFieldUnmatchIndex"] !== undefined ? data["detailFieldUnmatchIndex"] : <any>null;
            this.detailFieldMatchIndex = data["detailFieldMatchIndex"] !== undefined ? data["detailFieldMatchIndex"] : <any>null;
            this.idFieldIndex = data["idFieldIndex"] !== undefined ? data["idFieldIndex"] : <any>null;
            this.dateFieldIndex = data["dateFieldIndex"] !== undefined ? data["dateFieldIndex"] : <any>null;
            this.amountFieldIndex = data["amountFieldIndex"] !== undefined ? data["amountFieldIndex"] : <any>null;
            this.errorMessage = data["errorMessage"] !== undefined ? data["errorMessage"] : <any>null;
            if (Array.isArray(data["rows"])) {
                this.rows = [] as any;
                for (let item in data["rows"])
                    this.rows!.push(DataRow.fromJS(data["rows"][item]));
            }
            else {
                this.rows = <any>null;
            }
            if (Array.isArray(data["matches"])) {
                this.matches = [] as any;
                for (let item in data["matches"])
                    this.matches!.push(MatchInfo.fromJS(data["matches"][item]));
            }
            else {
                this.matches = <any>null;
            }
            if (Array.isArray(data["supportingItems"])) {
                this.supportingItems = [] as any;
                for (let item in data["supportingItems"])
                    this.supportingItems!.push(SupportingItemInfo.fromJS(data["supportingItems"][item]));
            }
            else {
                this.supportingItems = <any>null;
            }
        }
    }

    static fromJS(data: any): TransactionData {
        data = typeof data === 'object' ? data : {};
        let result = new TransactionData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.fields)) {
            data["fields"] = [];
            for (let item in this.fields)
                data["fields"].push(this.fields[item]);
        }
        if (Array.isArray(this.type)) {
            data["type"] = [];
            for (let item in this.type)
                data["type"].push(this.type[item]);
        }
        data["moreData"] = this.moreData !== undefined ? this.moreData : <any>null;
        data["matchFieldIndex"] = this.matchFieldIndex !== undefined ? this.matchFieldIndex : <any>null;
        data["detailFieldUnmatchIndex"] = this.detailFieldUnmatchIndex !== undefined ? this.detailFieldUnmatchIndex : <any>null;
        data["detailFieldMatchIndex"] = this.detailFieldMatchIndex !== undefined ? this.detailFieldMatchIndex : <any>null;
        data["idFieldIndex"] = this.idFieldIndex !== undefined ? this.idFieldIndex : <any>null;
        data["dateFieldIndex"] = this.dateFieldIndex !== undefined ? this.dateFieldIndex : <any>null;
        data["amountFieldIndex"] = this.amountFieldIndex !== undefined ? this.amountFieldIndex : <any>null;
        data["errorMessage"] = this.errorMessage !== undefined ? this.errorMessage : <any>null;
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item in this.rows)
                data["rows"].push(this.rows[item].toJSON());
        }
        if (Array.isArray(this.matches)) {
            data["matches"] = [];
            for (let item in this.matches)
                data["matches"].push(this.matches[item].toJSON());
        }
        if (Array.isArray(this.supportingItems)) {
            data["supportingItems"] = [];
            for (let item in this.supportingItems)
                data["supportingItems"].push(this.supportingItems[item].toJSON());
        }
        return data;
    }

    clone(): TransactionData {
        const json = this.toJSON();
        let result = new TransactionData();
        result.init(json);
        return result;
    }
}

export interface ITransactionData {
    fields?: string[] | null;
    type?: string[] | null;
    moreData: boolean;
    matchFieldIndex: number;
    detailFieldUnmatchIndex: number;
    detailFieldMatchIndex: number;
    idFieldIndex: number;
    dateFieldIndex: number;
    amountFieldIndex: number;
    errorMessage?: string | null;
    rows?: DataRow[] | null;
    matches?: MatchInfo[] | null;
    supportingItems?: SupportingItemInfo[] | null;
}

export class DataRow implements IDataRow {
    fieldValues?: any[] | null;

    constructor(data?: IDataRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (Array.isArray(data["fieldValues"])) {
                this.fieldValues = [] as any;
                for (let item in data["fieldValues"])
                    this.fieldValues!.push(data["fieldValues"][item]);
            }
            else {
                this.fieldValues = <any>null;
            }
        }
    }

    static fromJS(data: any): DataRow {
        data = typeof data === 'object' ? data : {};
        let result = new DataRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.fieldValues)) {
            data["fieldValues"] = [];
            for (let item in this.fieldValues)
                data["fieldValues"].push(this.fieldValues[item]);
        }
        return data;
    }

    clone(): DataRow {
        const json = this.toJSON();
        let result = new DataRow();
        result.init(json);
        return result;
    }
}

export interface IDataRow {
    fieldValues?: any[] | null;
}

export class SupportingItemInfo implements ISupportingItemInfo {
    supportingItemId?: string | null;
    description?: string | null;
    reconciliationGroup?: string | null;
    account_Name?: string | null;
    entity_Name?: string | null;
    supportingItemSubtype?: string | null;
    itemClass?: string | null;
    notes?: string | null;
    amount!: number;
    startDate?: Date | null;
    endDate?: Date | null;
    subtotal1Mod?: string | null;
    subtotal1?: number | null;
    subtotal2Mod?: string | null;
    subtotal2?: number | null;
    variance?: number | null;
    reverseAmount!: boolean;
    matchGroup?: string | null;
    dataset1?: string | null;
    dataset2?: string | null;
    auditUsername?: string | null;
    auditTimestamp?: string | null;
    transactionData?: MatchData[] | null;
    fileName?: string | null;
    fileData?: string | null;
    attachmentId?: number | null;
    oldAttachmentId?: number | null;
    matchId?: string | null;
    supportingItemDetailId?: string | null;

    constructor(data?: ISupportingItemInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.supportingItemId = data["supportingItemId"] !== undefined ? data["supportingItemId"] : <any>null;
            this.description = data["description"] !== undefined ? data["description"] : <any>null;
            this.reconciliationGroup = data["reconciliationGroup"] !== undefined ? data["reconciliationGroup"] : <any>null;
            this.account_Name = data["account_Name"] !== undefined ? data["account_Name"] : <any>null;
            this.entity_Name = data["entity_Name"] !== undefined ? data["entity_Name"] : <any>null;
            this.supportingItemSubtype = data["supportingItemSubtype"] !== undefined ? data["supportingItemSubtype"] : <any>null;
            this.itemClass = data["itemClass"] !== undefined ? data["itemClass"] : <any>null;
            this.notes = data["notes"] !== undefined ? data["notes"] : <any>null;
            this.amount = data["amount"] !== undefined ? data["amount"] : <any>null;
            this.startDate = data["startDate"] ? new Date(data["startDate"].toString()) : <any>null;
            this.endDate = data["endDate"] ? new Date(data["endDate"].toString()) : <any>null;
            this.subtotal1Mod = data["subtotal1Mod"] !== undefined ? data["subtotal1Mod"] : <any>null;
            this.subtotal1 = data["subtotal1"] !== undefined ? data["subtotal1"] : <any>null;
            this.subtotal2Mod = data["subtotal2Mod"] !== undefined ? data["subtotal2Mod"] : <any>null;
            this.subtotal2 = data["subtotal2"] !== undefined ? data["subtotal2"] : <any>null;
            this.variance = data["variance"] !== undefined ? data["variance"] : <any>null;
            this.reverseAmount = data["reverseAmount"] !== undefined ? data["reverseAmount"] : <any>null;
            this.matchGroup = data["matchGroup"] !== undefined ? data["matchGroup"] : <any>null;
            this.dataset1 = data["dataset1"] !== undefined ? data["dataset1"] : <any>null;
            this.dataset2 = data["dataset2"] !== undefined ? data["dataset2"] : <any>null;
            this.auditUsername = data["auditUsername"] !== undefined ? data["auditUsername"] : <any>null;
            this.auditTimestamp = data["auditTimestamp"] !== undefined ? data["auditTimestamp"] : <any>null;
            if (Array.isArray(data["transactionData"])) {
                this.transactionData = [] as any;
                for (let item in data["transactionData"])
                    this.transactionData!.push(MatchData.fromJS(data["transactionData"][item]));
            }
            else {
                this.transactionData = <any>null;
            }
            this.fileName = data["fileName"] !== undefined ? data["fileName"] : <any>null;
            this.fileData = data["fileData"] !== undefined ? data["fileData"] : <any>null;
            this.attachmentId = data["attachmentId"] !== undefined ? data["attachmentId"] : <any>null;
            this.oldAttachmentId = data["oldAttachmentId"] !== undefined ? data["oldAttachmentId"] : <any>null;
            this.matchId = data["matchId"] !== undefined ? data["matchId"] : <any>null;
            this.supportingItemDetailId = data["supportingItemDetailId"] !== undefined ? data["supportingItemDetailId"] : <any>null;
        }
    }

    static fromJS(data: any): SupportingItemInfo {
        data = typeof data === 'object' ? data : {};
        let result = new SupportingItemInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["supportingItemId"] = this.supportingItemId !== undefined ? this.supportingItemId : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["reconciliationGroup"] = this.reconciliationGroup !== undefined ? this.reconciliationGroup : <any>null;
        data["account_Name"] = this.account_Name !== undefined ? this.account_Name : <any>null;
        data["entity_Name"] = this.entity_Name !== undefined ? this.entity_Name : <any>null;
        data["supportingItemSubtype"] = this.supportingItemSubtype !== undefined ? this.supportingItemSubtype : <any>null;
        data["itemClass"] = this.itemClass !== undefined ? this.itemClass : <any>null;
        data["notes"] = this.notes !== undefined ? this.notes : <any>null;
        data["amount"] = this.amount !== undefined ? this.amount : <any>null;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>null;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>null;
        data["subtotal1Mod"] = this.subtotal1Mod !== undefined ? this.subtotal1Mod : <any>null;
        data["subtotal1"] = this.subtotal1 !== undefined ? this.subtotal1 : <any>null;
        data["subtotal2Mod"] = this.subtotal2Mod !== undefined ? this.subtotal2Mod : <any>null;
        data["subtotal2"] = this.subtotal2 !== undefined ? this.subtotal2 : <any>null;
        data["variance"] = this.variance !== undefined ? this.variance : <any>null;
        data["reverseAmount"] = this.reverseAmount !== undefined ? this.reverseAmount : <any>null;
        data["matchGroup"] = this.matchGroup !== undefined ? this.matchGroup : <any>null;
        data["dataset1"] = this.dataset1 !== undefined ? this.dataset1 : <any>null;
        data["dataset2"] = this.dataset2 !== undefined ? this.dataset2 : <any>null;
        data["auditUsername"] = this.auditUsername !== undefined ? this.auditUsername : <any>null;
        data["auditTimestamp"] = this.auditTimestamp !== undefined ? this.auditTimestamp : <any>null;
        if (Array.isArray(this.transactionData)) {
            data["transactionData"] = [];
            for (let item in this.transactionData)
                data["transactionData"].push(this.transactionData[item].toJSON());
        }
        data["fileName"] = this.fileName !== undefined ? this.fileName : <any>null;
        data["fileData"] = this.fileData !== undefined ? this.fileData : <any>null;
        data["attachmentId"] = this.attachmentId !== undefined ? this.attachmentId : <any>null;
        data["oldAttachmentId"] = this.oldAttachmentId !== undefined ? this.oldAttachmentId : <any>null;
        data["matchId"] = this.matchId !== undefined ? this.matchId : <any>null;
        data["supportingItemDetailId"] = this.supportingItemDetailId !== undefined ? this.supportingItemDetailId : <any>null;
        return data;
    }

    clone(): SupportingItemInfo {
        const json = this.toJSON();
        let result = new SupportingItemInfo();
        result.init(json);
        return result;
    }
}

export interface ISupportingItemInfo {
    supportingItemId?: string | null;
    description?: string | null;
    reconciliationGroup?: string | null;
    account_Name?: string | null;
    entity_Name?: string | null;
    supportingItemSubtype?: string | null;
    itemClass?: string | null;
    notes?: string | null;
    amount: number;
    startDate?: Date | null;
    endDate?: Date | null;
    subtotal1Mod?: string | null;
    subtotal1?: number | null;
    subtotal2Mod?: string | null;
    subtotal2?: number | null;
    variance?: number | null;
    reverseAmount: boolean;
    matchGroup?: string | null;
    dataset1?: string | null;
    dataset2?: string | null;
    auditUsername?: string | null;
    auditTimestamp?: string | null;
    transactionData?: MatchData[] | null;
    fileName?: string | null;
    fileData?: string | null;
    attachmentId?: number | null;
    oldAttachmentId?: number | null;
    matchId?: string | null;
    supportingItemDetailId?: string | null;
}

export class TransactionFilter implements ITransactionFilter {
    matchFilter!: MatchFilter;
    matchTypeFilter!: MatchTypeFilter;
    confidenceFilter!: ConfidenceFilter;
    supportFilter!: SupportFilter;
    supportMatchFilter!: SupportMatchFilter;
    varianceLow?: number | null;
    varianceHigh?: number | null;
    fieldFilters?: Filter[] | null;
    freeClauseFilter?: string | null;

    constructor(data?: ITransactionFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.matchFilter = data["matchFilter"] !== undefined ? data["matchFilter"] : <any>null;
            this.matchTypeFilter = data["matchTypeFilter"] !== undefined ? data["matchTypeFilter"] : <any>null;
            this.confidenceFilter = data["confidenceFilter"] !== undefined ? data["confidenceFilter"] : <any>null;
            this.supportFilter = data["supportFilter"] !== undefined ? data["supportFilter"] : <any>null;
            this.supportMatchFilter = data["supportMatchFilter"] !== undefined ? data["supportMatchFilter"] : <any>null;
            this.varianceLow = data["varianceLow"] !== undefined ? data["varianceLow"] : <any>null;
            this.varianceHigh = data["varianceHigh"] !== undefined ? data["varianceHigh"] : <any>null;
            if (Array.isArray(data["fieldFilters"])) {
                this.fieldFilters = [] as any;
                for (let item in data["fieldFilters"])
                    this.fieldFilters!.push(Filter.fromJS(data["fieldFilters"][item]));
            }
            else {
                this.fieldFilters = <any>null;
            }
            this.freeClauseFilter = data["freeClauseFilter"] !== undefined ? data["freeClauseFilter"] : <any>null;
        }
    }

    static fromJS(data: any): TransactionFilter {
        data = typeof data === 'object' ? data : {};
        let result = new TransactionFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["matchFilter"] = this.matchFilter !== undefined ? this.matchFilter : <any>null;
        data["matchTypeFilter"] = this.matchTypeFilter !== undefined ? this.matchTypeFilter : <any>null;
        data["confidenceFilter"] = this.confidenceFilter !== undefined ? this.confidenceFilter : <any>null;
        data["supportFilter"] = this.supportFilter !== undefined ? this.supportFilter : <any>null;
        data["supportMatchFilter"] = this.supportMatchFilter !== undefined ? this.supportMatchFilter : <any>null;
        data["varianceLow"] = this.varianceLow !== undefined ? this.varianceLow : <any>null;
        data["varianceHigh"] = this.varianceHigh !== undefined ? this.varianceHigh : <any>null;
        if (Array.isArray(this.fieldFilters)) {
            data["fieldFilters"] = [];
            for (let item in this.fieldFilters)
                data["fieldFilters"].push(this.fieldFilters[item].toJSON());
        }
        data["freeClauseFilter"] = this.freeClauseFilter !== undefined ? this.freeClauseFilter : <any>null;
        return data;
    }

    clone(): TransactionFilter {
        const json = this.toJSON();
        let result = new TransactionFilter();
        result.init(json);
        return result;
    }
}

export interface ITransactionFilter {
    matchFilter: MatchFilter;
    matchTypeFilter: MatchTypeFilter;
    confidenceFilter: ConfidenceFilter;
    supportFilter: SupportFilter;
    supportMatchFilter: SupportMatchFilter;
    varianceLow?: number | null;
    varianceHigh?: number | null;
    fieldFilters?: Filter[] | null;
    freeClauseFilter?: string | null;
}

export enum MatchFilter {
    All = 0,
    Matched = 1,
    Unmatched = 2,
}

export enum MatchTypeFilter {
    All = 0,
    Manual = 1,
    Automatic = 2,
    ManuallyApproved = 3,
}

export enum ConfidenceFilter {
    All = 0,
    High = 1,
    Medium = 2,
    Low = 3,
}

export enum SupportFilter {
    All = 0,
    HasSupport = 1,
    HasOpenSupport = 2,
    HasClosedSupport = 3,
    NoSupport = 4,
}

export enum SupportMatchFilter {
    All = 0,
    HasSupportMatch = 1,
    HasOpenSupportMatch = 2,
    HasClosedSupportMatch = 3,
    NoSupportMatch = 4,
}

export class Filter implements IFilter {
    filterId?: number | null;
    field?: string | null;
    operation?: string | null;
    value?: string | null;
    additionalValue?: string | null;
    sql?: string | null;

    constructor(data?: IFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.filterId = data["filterId"] !== undefined ? data["filterId"] : <any>null;
            this.field = data["field"] !== undefined ? data["field"] : <any>null;
            this.operation = data["operation"] !== undefined ? data["operation"] : <any>null;
            this.value = data["value"] !== undefined ? data["value"] : <any>null;
            this.additionalValue = data["additionalValue"] !== undefined ? data["additionalValue"] : <any>null;
            this.sql = data["sql"] !== undefined ? data["sql"] : <any>null;
        }
    }

    static fromJS(data: any): Filter {
        data = typeof data === 'object' ? data : {};
        let result = new Filter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filterId"] = this.filterId !== undefined ? this.filterId : <any>null;
        data["field"] = this.field !== undefined ? this.field : <any>null;
        data["operation"] = this.operation !== undefined ? this.operation : <any>null;
        data["value"] = this.value !== undefined ? this.value : <any>null;
        data["additionalValue"] = this.additionalValue !== undefined ? this.additionalValue : <any>null;
        data["sql"] = this.sql !== undefined ? this.sql : <any>null;
        return data;
    }

    clone(): Filter {
        const json = this.toJSON();
        let result = new Filter();
        result.init(json);
        return result;
    }
}

export interface IFilter {
    filterId?: number | null;
    field?: string | null;
    operation?: string | null;
    value?: string | null;
    additionalValue?: string | null;
    sql?: string | null;
}

export class ModelInfo implements IModelInfo {
    modelName?: string | null;
    managedModel?: boolean | null;
    directQueryMode?: boolean | null;
    analysisServiceSecurityProfile?: string | null;
    readSecurityProfile?: string | null;
    writeSecurityProfile?: string | null;
    consolidationModel?: boolean | null;
    defaultConsolidationModel?: boolean | null;
    extendedDrillback?: boolean | null;
    enforceOpenClosedForWriteback?: boolean | null;
    dimensions?: string[] | null;
    dimensionInfo?: ModelDimensionInfo[] | null;
    modelViews?: ModelViewInfo[] | null;
    processingStatus?: ProcessingStatus | null;
    isModelPostedJournal?: boolean | null;

    constructor(data?: IModelInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.modelName = data["modelName"] !== undefined ? data["modelName"] : <any>null;
            this.managedModel = data["managedModel"] !== undefined ? data["managedModel"] : <any>null;
            this.directQueryMode = data["directQueryMode"] !== undefined ? data["directQueryMode"] : <any>null;
            this.analysisServiceSecurityProfile = data["analysisServiceSecurityProfile"] !== undefined ? data["analysisServiceSecurityProfile"] : <any>null;
            this.readSecurityProfile = data["readSecurityProfile"] !== undefined ? data["readSecurityProfile"] : <any>null;
            this.writeSecurityProfile = data["writeSecurityProfile"] !== undefined ? data["writeSecurityProfile"] : <any>null;
            this.consolidationModel = data["consolidationModel"] !== undefined ? data["consolidationModel"] : <any>null;
            this.defaultConsolidationModel = data["defaultConsolidationModel"] !== undefined ? data["defaultConsolidationModel"] : <any>null;
            this.extendedDrillback = data["extendedDrillback"] !== undefined ? data["extendedDrillback"] : <any>null;
            this.enforceOpenClosedForWriteback = data["enforceOpenClosedForWriteback"] !== undefined ? data["enforceOpenClosedForWriteback"] : <any>null;
            if (Array.isArray(data["dimensions"])) {
                this.dimensions = [] as any;
                for (let item in data["dimensions"])
                    this.dimensions!.push(data["dimensions"][item]);
            }
            else {
                this.dimensions = <any>null;
            }
            if (Array.isArray(data["dimensionInfo"])) {
                this.dimensionInfo = [] as any;
                for (let item in data["dimensionInfo"])
                    this.dimensionInfo!.push(ModelDimensionInfo.fromJS(data["dimensionInfo"][item]));
            }
            else {
                this.dimensionInfo = <any>null;
            }
            if (Array.isArray(data["modelViews"])) {
                this.modelViews = [] as any;
                for (let item in data["modelViews"])
                    this.modelViews!.push(ModelViewInfo.fromJS(data["modelViews"][item]));
            }
            else {
                this.modelViews = <any>null;
            }
            this.processingStatus = data["processingStatus"] !== undefined ? data["processingStatus"] : <any>null;
            this.isModelPostedJournal = data["isModelPostedJournal"] !== undefined ? data["isModelPostedJournal"] : <any>null;
        }
    }

    static fromJS(data: any): ModelInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ModelInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["modelName"] = this.modelName !== undefined ? this.modelName : <any>null;
        data["managedModel"] = this.managedModel !== undefined ? this.managedModel : <any>null;
        data["directQueryMode"] = this.directQueryMode !== undefined ? this.directQueryMode : <any>null;
        data["analysisServiceSecurityProfile"] = this.analysisServiceSecurityProfile !== undefined ? this.analysisServiceSecurityProfile : <any>null;
        data["readSecurityProfile"] = this.readSecurityProfile !== undefined ? this.readSecurityProfile : <any>null;
        data["writeSecurityProfile"] = this.writeSecurityProfile !== undefined ? this.writeSecurityProfile : <any>null;
        data["consolidationModel"] = this.consolidationModel !== undefined ? this.consolidationModel : <any>null;
        data["defaultConsolidationModel"] = this.defaultConsolidationModel !== undefined ? this.defaultConsolidationModel : <any>null;
        data["extendedDrillback"] = this.extendedDrillback !== undefined ? this.extendedDrillback : <any>null;
        data["enforceOpenClosedForWriteback"] = this.enforceOpenClosedForWriteback !== undefined ? this.enforceOpenClosedForWriteback : <any>null;
        if (Array.isArray(this.dimensions)) {
            data["dimensions"] = [];
            for (let item in this.dimensions)
                data["dimensions"].push(this.dimensions[item]);
        }
        if (Array.isArray(this.dimensionInfo)) {
            data["dimensionInfo"] = [];
            for (let item in this.dimensionInfo)
                data["dimensionInfo"].push(this.dimensionInfo[item].toJSON());
        }
        if (Array.isArray(this.modelViews)) {
            data["modelViews"] = [];
            for (let item in this.modelViews)
                data["modelViews"].push(this.modelViews[item].toJSON());
        }
        data["processingStatus"] = this.processingStatus !== undefined ? this.processingStatus : <any>null;
        data["isModelPostedJournal"] = this.isModelPostedJournal !== undefined ? this.isModelPostedJournal : <any>null;
        return data;
    }

    clone(): ModelInfo {
        const json = this.toJSON();
        let result = new ModelInfo();
        result.init(json);
        return result;
    }
}

export interface IModelInfo {
    modelName?: string | null;
    managedModel?: boolean | null;
    directQueryMode?: boolean | null;
    analysisServiceSecurityProfile?: string | null;
    readSecurityProfile?: string | null;
    writeSecurityProfile?: string | null;
    consolidationModel?: boolean | null;
    defaultConsolidationModel?: boolean | null;
    extendedDrillback?: boolean | null;
    enforceOpenClosedForWriteback?: boolean | null;
    dimensions?: string[] | null;
    dimensionInfo?: ModelDimensionInfo[] | null;
    modelViews?: ModelViewInfo[] | null;
    processingStatus?: ProcessingStatus | null;
    isModelPostedJournal?: boolean | null;
}

export class ModelDimensionInfo implements IModelDimensionInfo {
    dimensionName?: string | null;
    dimensionType!: DimensionType;
    processingStatus?: ProcessingStatus | null;
    role?: string | null;

    constructor(data?: IModelDimensionInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.dimensionName = data["dimensionName"] !== undefined ? data["dimensionName"] : <any>null;
            this.dimensionType = data["dimensionType"] !== undefined ? data["dimensionType"] : <any>null;
            this.processingStatus = data["processingStatus"] !== undefined ? data["processingStatus"] : <any>null;
            this.role = data["role"] !== undefined ? data["role"] : <any>null;
        }
    }

    static fromJS(data: any): ModelDimensionInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ModelDimensionInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dimensionName"] = this.dimensionName !== undefined ? this.dimensionName : <any>null;
        data["dimensionType"] = this.dimensionType !== undefined ? this.dimensionType : <any>null;
        data["processingStatus"] = this.processingStatus !== undefined ? this.processingStatus : <any>null;
        data["role"] = this.role !== undefined ? this.role : <any>null;
        return data;
    }

    clone(): ModelDimensionInfo {
        const json = this.toJSON();
        let result = new ModelDimensionInfo();
        result.init(json);
        return result;
    }
}

export interface IModelDimensionInfo {
    dimensionName?: string | null;
    dimensionType: DimensionType;
    processingStatus?: ProcessingStatus | null;
    role?: string | null;
}

export enum DimensionType {
    Other = 0,
    Measure = 1,
    Account = 2,
    Time = 3,
    Entity = 4,
    Currency = 5,
    Movement = 6,
    DataView = 7,
    Audit = 8,
    Scenario = 9,
    Intercompany = 10,
    Group = 11,
    Driver = 12,
    MarketAnalysis = 13,
}

export enum ProcessingStatus {
    Active = 0,
    New = 1,
    Updated = 2,
    Deleted = -1,
}

export class ModelViewInfo implements IModelViewInfo {
    viewName?: string | null;
    modelName?: string | null;
    errorMessage?: string | null;
    modelViewDimensions?: ModelViewDimensionInfo[] | null;

    constructor(data?: IModelViewInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.viewName = data["viewName"] !== undefined ? data["viewName"] : <any>null;
            this.modelName = data["modelName"] !== undefined ? data["modelName"] : <any>null;
            this.errorMessage = data["errorMessage"] !== undefined ? data["errorMessage"] : <any>null;
            if (Array.isArray(data["modelViewDimensions"])) {
                this.modelViewDimensions = [] as any;
                for (let item in data["modelViewDimensions"])
                    this.modelViewDimensions!.push(ModelViewDimensionInfo.fromJS(data["modelViewDimensions"][item]));
            }
            else {
                this.modelViewDimensions = <any>null;
            }
        }
    }

    static fromJS(data: any): ModelViewInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ModelViewInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["viewName"] = this.viewName !== undefined ? this.viewName : <any>null;
        data["modelName"] = this.modelName !== undefined ? this.modelName : <any>null;
        data["errorMessage"] = this.errorMessage !== undefined ? this.errorMessage : <any>null;
        if (Array.isArray(this.modelViewDimensions)) {
            data["modelViewDimensions"] = [];
            for (let item in this.modelViewDimensions)
                data["modelViewDimensions"].push(this.modelViewDimensions[item].toJSON());
        }
        return data;
    }

    clone(): ModelViewInfo {
        const json = this.toJSON();
        let result = new ModelViewInfo();
        result.init(json);
        return result;
    }
}

export interface IModelViewInfo {
    viewName?: string | null;
    modelName?: string | null;
    errorMessage?: string | null;
    modelViewDimensions?: ModelViewDimensionInfo[] | null;
}

export class ModelViewDimensionInfo implements IModelViewDimensionInfo {
    dimensionName?: string | null;
    hierarchyName?: string | null;
    axis!: ViewAxis;
    order!: number;
    querySpec?: HierarchicalSpec | null;

    constructor(data?: IModelViewDimensionInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.dimensionName = data["dimensionName"] !== undefined ? data["dimensionName"] : <any>null;
            this.hierarchyName = data["hierarchyName"] !== undefined ? data["hierarchyName"] : <any>null;
            this.axis = data["axis"] !== undefined ? data["axis"] : <any>null;
            this.order = data["order"] !== undefined ? data["order"] : <any>null;
            this.querySpec = data["querySpec"] ? HierarchicalSpec.fromJS(data["querySpec"]) : <any>null;
        }
    }

    static fromJS(data: any): ModelViewDimensionInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ModelViewDimensionInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dimensionName"] = this.dimensionName !== undefined ? this.dimensionName : <any>null;
        data["hierarchyName"] = this.hierarchyName !== undefined ? this.hierarchyName : <any>null;
        data["axis"] = this.axis !== undefined ? this.axis : <any>null;
        data["order"] = this.order !== undefined ? this.order : <any>null;
        data["querySpec"] = this.querySpec ? this.querySpec.toJSON() : <any>null;
        return data;
    }

    clone(): ModelViewDimensionInfo {
        const json = this.toJSON();
        let result = new ModelViewDimensionInfo();
        result.init(json);
        return result;
    }
}

export interface IModelViewDimensionInfo {
    dimensionName?: string | null;
    hierarchyName?: string | null;
    axis: ViewAxis;
    order: number;
    querySpec?: HierarchicalSpec | null;
}

export enum ViewAxis {
    Columns = 0,
    Rows = 1,
    Hidden = -3,
    Slicer = -2,
}

export class BaseElement implements IBaseElement {
    name?: string | null;

    constructor(data?: IBaseElement) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"] !== undefined ? data["name"] : <any>null;
        }
    }

    static fromJS(data: any): BaseElement {
        data = typeof data === 'object' ? data : {};
        let result = new BaseElement();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        return data;
    }

    clone(): BaseElement {
        const json = this.toJSON();
        let result = new BaseElement();
        result.init(json);
        return result;
    }
}

export interface IBaseElement {
    name?: string | null;
}

export class HierarchicalSpec extends BaseElement implements IHierarchicalSpec {
    operation?: string | null;
    memberKey?: string | null;
    memberName?: string | null;
    memberTag?: string | null;
    memberRelationship?: string | null;
    isLeaf!: boolean;
    filterProperty?: string | null;
    filterRelationship?: string | null;
    filterValue?: string | null;
    subsetName?: string | null;
    levelNumber?: string | null;
    fromLevel?: string | null;
    removeDuplicates?: boolean | null;
    toLevel?: string | null;
    count?: string | null;
    securityProfile?: string | null;
    securityProfileType?: string | null;
    securityModel?: string | null;
    children?: HierarchicalSpec[] | null;

    constructor(data?: IHierarchicalSpec) {
        super(data);
    }

    init(data?: any) {
        super.init(data);
        if (data) {
            this.operation = data["operation"] !== undefined ? data["operation"] : <any>null;
            this.memberKey = data["memberKey"] !== undefined ? data["memberKey"] : <any>null;
            this.memberName = data["memberName"] !== undefined ? data["memberName"] : <any>null;
            this.memberTag = data["memberTag"] !== undefined ? data["memberTag"] : <any>null;
            this.memberRelationship = data["memberRelationship"] !== undefined ? data["memberRelationship"] : <any>null;
            this.isLeaf = data["isLeaf"] !== undefined ? data["isLeaf"] : <any>null;
            this.filterProperty = data["filterProperty"] !== undefined ? data["filterProperty"] : <any>null;
            this.filterRelationship = data["filterRelationship"] !== undefined ? data["filterRelationship"] : <any>null;
            this.filterValue = data["filterValue"] !== undefined ? data["filterValue"] : <any>null;
            this.subsetName = data["subsetName"] !== undefined ? data["subsetName"] : <any>null;
            this.levelNumber = data["levelNumber"] !== undefined ? data["levelNumber"] : <any>null;
            this.fromLevel = data["fromLevel"] !== undefined ? data["fromLevel"] : <any>null;
            this.removeDuplicates = data["removeDuplicates"] !== undefined ? data["removeDuplicates"] : <any>null;
            this.toLevel = data["toLevel"] !== undefined ? data["toLevel"] : <any>null;
            this.count = data["count"] !== undefined ? data["count"] : <any>null;
            this.securityProfile = data["securityProfile"] !== undefined ? data["securityProfile"] : <any>null;
            this.securityProfileType = data["securityProfileType"] !== undefined ? data["securityProfileType"] : <any>null;
            this.securityModel = data["securityModel"] !== undefined ? data["securityModel"] : <any>null;
            if (Array.isArray(data["children"])) {
                this.children = [] as any;
                for (let item in data["children"])
                    this.children!.push(HierarchicalSpec.fromJS(data["children"][item]));
            }
            else {
                this.children = <any>null;
            }
        }
    }

    static fromJS(data: any): HierarchicalSpec {
        data = typeof data === 'object' ? data : {};
        let result = new HierarchicalSpec();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["operation"] = this.operation !== undefined ? this.operation : <any>null;
        data["memberKey"] = this.memberKey !== undefined ? this.memberKey : <any>null;
        data["memberName"] = this.memberName !== undefined ? this.memberName : <any>null;
        data["memberTag"] = this.memberTag !== undefined ? this.memberTag : <any>null;
        data["memberRelationship"] = this.memberRelationship !== undefined ? this.memberRelationship : <any>null;
        data["isLeaf"] = this.isLeaf !== undefined ? this.isLeaf : <any>null;
        data["filterProperty"] = this.filterProperty !== undefined ? this.filterProperty : <any>null;
        data["filterRelationship"] = this.filterRelationship !== undefined ? this.filterRelationship : <any>null;
        data["filterValue"] = this.filterValue !== undefined ? this.filterValue : <any>null;
        data["subsetName"] = this.subsetName !== undefined ? this.subsetName : <any>null;
        data["levelNumber"] = this.levelNumber !== undefined ? this.levelNumber : <any>null;
        data["fromLevel"] = this.fromLevel !== undefined ? this.fromLevel : <any>null;
        data["removeDuplicates"] = this.removeDuplicates !== undefined ? this.removeDuplicates : <any>null;
        data["toLevel"] = this.toLevel !== undefined ? this.toLevel : <any>null;
        data["count"] = this.count !== undefined ? this.count : <any>null;
        data["securityProfile"] = this.securityProfile !== undefined ? this.securityProfile : <any>null;
        data["securityProfileType"] = this.securityProfileType !== undefined ? this.securityProfileType : <any>null;
        data["securityModel"] = this.securityModel !== undefined ? this.securityModel : <any>null;
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item in this.children)
                data["children"].push(this.children[item].toJSON());
        }
        super.toJSON(data);
        return data;
    }

    clone(): HierarchicalSpec {
        const json = this.toJSON();
        let result = new HierarchicalSpec();
        result.init(json);
        return result;
    }
}

export interface IHierarchicalSpec extends IBaseElement {
    operation?: string | null;
    memberKey?: string | null;
    memberName?: string | null;
    memberTag?: string | null;
    memberRelationship?: string | null;
    isLeaf: boolean;
    filterProperty?: string | null;
    filterRelationship?: string | null;
    filterValue?: string | null;
    subsetName?: string | null;
    levelNumber?: string | null;
    fromLevel?: string | null;
    removeDuplicates?: boolean | null;
    toLevel?: string | null;
    count?: string | null;
    securityProfile?: string | null;
    securityProfileType?: string | null;
    securityModel?: string | null;
    children?: HierarchicalSpec[] | null;
}

export class MainReportingCurrencyResponse implements IMainReportingCurrencyResponse {
    modelName?: string | null;
    dimensionName?: string | null;
    memberName?: string | null;
    memberCaption?: string | null;

    constructor(data?: IMainReportingCurrencyResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.modelName = data["modelName"] !== undefined ? data["modelName"] : <any>null;
            this.dimensionName = data["dimensionName"] !== undefined ? data["dimensionName"] : <any>null;
            this.memberName = data["memberName"] !== undefined ? data["memberName"] : <any>null;
            this.memberCaption = data["memberCaption"] !== undefined ? data["memberCaption"] : <any>null;
        }
    }

    static fromJS(data: any): MainReportingCurrencyResponse {
        data = typeof data === 'object' ? data : {};
        let result = new MainReportingCurrencyResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["modelName"] = this.modelName !== undefined ? this.modelName : <any>null;
        data["dimensionName"] = this.dimensionName !== undefined ? this.dimensionName : <any>null;
        data["memberName"] = this.memberName !== undefined ? this.memberName : <any>null;
        data["memberCaption"] = this.memberCaption !== undefined ? this.memberCaption : <any>null;
        return data;
    }

    clone(): MainReportingCurrencyResponse {
        const json = this.toJSON();
        let result = new MainReportingCurrencyResponse();
        result.init(json);
        return result;
    }
}

export interface IMainReportingCurrencyResponse {
    modelName?: string | null;
    dimensionName?: string | null;
    memberName?: string | null;
    memberCaption?: string | null;
}

export class DimensionRoleInfo implements IDimensionRoleInfo {
    dimensionType!: DimensionType;
    roles?: string[] | null;

    constructor(data?: IDimensionRoleInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.dimensionType = data["dimensionType"] !== undefined ? data["dimensionType"] : <any>null;
            if (Array.isArray(data["roles"])) {
                this.roles = [] as any;
                for (let item in data["roles"])
                    this.roles!.push(data["roles"][item]);
            }
            else {
                this.roles = <any>null;
            }
        }
    }

    static fromJS(data: any): DimensionRoleInfo {
        data = typeof data === 'object' ? data : {};
        let result = new DimensionRoleInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dimensionType"] = this.dimensionType !== undefined ? this.dimensionType : <any>null;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item in this.roles)
                data["roles"].push(this.roles[item]);
        }
        return data;
    }

    clone(): DimensionRoleInfo {
        const json = this.toJSON();
        let result = new DimensionRoleInfo();
        result.init(json);
        return result;
    }
}

export interface IDimensionRoleInfo {
    dimensionType: DimensionType;
    roles?: string[] | null;
}

export class DimensionInfo implements IDimensionInfo {
    dimensionName?: string | null;
    dimensionType?: DimensionType | null;
    nonLeafDataMembers?: boolean | null;
    timeBasedHierarchies?: boolean | null;
    translations?: string | null;
    defaultMember?: string | null;
    defaultHierarchyMaxDepth!: number;
    relatedDimension?: string | null;
    hierarchies?: HierarchyInfo[] | null;
    properties?: PropertyInfo[] | null;
    processingStatus?: ProcessingStatus | null;
    syncType?: DimensionSyncType | null;

    constructor(data?: IDimensionInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.dimensionName = data["dimensionName"] !== undefined ? data["dimensionName"] : <any>null;
            this.dimensionType = data["dimensionType"] !== undefined ? data["dimensionType"] : <any>null;
            this.nonLeafDataMembers = data["nonLeafDataMembers"] !== undefined ? data["nonLeafDataMembers"] : <any>null;
            this.timeBasedHierarchies = data["timeBasedHierarchies"] !== undefined ? data["timeBasedHierarchies"] : <any>null;
            this.translations = data["translations"] !== undefined ? data["translations"] : <any>null;
            this.defaultMember = data["defaultMember"] !== undefined ? data["defaultMember"] : <any>null;
            this.defaultHierarchyMaxDepth = data["defaultHierarchyMaxDepth"] !== undefined ? data["defaultHierarchyMaxDepth"] : <any>null;
            this.relatedDimension = data["relatedDimension"] !== undefined ? data["relatedDimension"] : <any>null;
            if (Array.isArray(data["hierarchies"])) {
                this.hierarchies = [] as any;
                for (let item in data["hierarchies"])
                    this.hierarchies!.push(HierarchyInfo.fromJS(data["hierarchies"][item]));
            }
            else {
                this.hierarchies = <any>null;
            }
            if (Array.isArray(data["properties"])) {
                this.properties = [] as any;
                for (let item in data["properties"])
                    this.properties!.push(PropertyInfo.fromJS(data["properties"][item]));
            }
            else {
                this.properties = <any>null;
            }
            this.processingStatus = data["processingStatus"] !== undefined ? data["processingStatus"] : <any>null;
            this.syncType = data["syncType"] !== undefined ? data["syncType"] : <any>null;
        }
    }

    static fromJS(data: any): DimensionInfo {
        data = typeof data === 'object' ? data : {};
        let result = new DimensionInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dimensionName"] = this.dimensionName !== undefined ? this.dimensionName : <any>null;
        data["dimensionType"] = this.dimensionType !== undefined ? this.dimensionType : <any>null;
        data["nonLeafDataMembers"] = this.nonLeafDataMembers !== undefined ? this.nonLeafDataMembers : <any>null;
        data["timeBasedHierarchies"] = this.timeBasedHierarchies !== undefined ? this.timeBasedHierarchies : <any>null;
        data["translations"] = this.translations !== undefined ? this.translations : <any>null;
        data["defaultMember"] = this.defaultMember !== undefined ? this.defaultMember : <any>null;
        data["defaultHierarchyMaxDepth"] = this.defaultHierarchyMaxDepth !== undefined ? this.defaultHierarchyMaxDepth : <any>null;
        data["relatedDimension"] = this.relatedDimension !== undefined ? this.relatedDimension : <any>null;
        if (Array.isArray(this.hierarchies)) {
            data["hierarchies"] = [];
            for (let item in this.hierarchies)
                data["hierarchies"].push(this.hierarchies[item].toJSON());
        }
        if (Array.isArray(this.properties)) {
            data["properties"] = [];
            for (let item in this.properties)
                data["properties"].push(this.properties[item].toJSON());
        }
        data["processingStatus"] = this.processingStatus !== undefined ? this.processingStatus : <any>null;
        data["syncType"] = this.syncType !== undefined ? this.syncType : <any>null;
        return data;
    }

    clone(): DimensionInfo {
        const json = this.toJSON();
        let result = new DimensionInfo();
        result.init(json);
        return result;
    }
}

export interface IDimensionInfo {
    dimensionName?: string | null;
    dimensionType?: DimensionType | null;
    nonLeafDataMembers?: boolean | null;
    timeBasedHierarchies?: boolean | null;
    translations?: string | null;
    defaultMember?: string | null;
    defaultHierarchyMaxDepth: number;
    relatedDimension?: string | null;
    hierarchies?: HierarchyInfo[] | null;
    properties?: PropertyInfo[] | null;
    processingStatus?: ProcessingStatus | null;
    syncType?: DimensionSyncType | null;
}

export class HierarchyInfo implements IHierarchyInfo {
    dimensionName?: string | null;
    hierarchyName?: string | null;
    maxDepth?: number | null;
    defaultSecurityProfile?: string | null;
    defaultReportingMemberKey?: number | null;
    defaultInputMemberKey?: number | null;
    processingStatus?: ProcessingStatus | null;
    isDefaultHierarchy!: boolean;

    constructor(data?: IHierarchyInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.dimensionName = data["dimensionName"] !== undefined ? data["dimensionName"] : <any>null;
            this.hierarchyName = data["hierarchyName"] !== undefined ? data["hierarchyName"] : <any>null;
            this.maxDepth = data["maxDepth"] !== undefined ? data["maxDepth"] : <any>null;
            this.defaultSecurityProfile = data["defaultSecurityProfile"] !== undefined ? data["defaultSecurityProfile"] : <any>null;
            this.defaultReportingMemberKey = data["defaultReportingMemberKey"] !== undefined ? data["defaultReportingMemberKey"] : <any>null;
            this.defaultInputMemberKey = data["defaultInputMemberKey"] !== undefined ? data["defaultInputMemberKey"] : <any>null;
            this.processingStatus = data["processingStatus"] !== undefined ? data["processingStatus"] : <any>null;
            this.isDefaultHierarchy = data["isDefaultHierarchy"] !== undefined ? data["isDefaultHierarchy"] : <any>null;
        }
    }

    static fromJS(data: any): HierarchyInfo {
        data = typeof data === 'object' ? data : {};
        let result = new HierarchyInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dimensionName"] = this.dimensionName !== undefined ? this.dimensionName : <any>null;
        data["hierarchyName"] = this.hierarchyName !== undefined ? this.hierarchyName : <any>null;
        data["maxDepth"] = this.maxDepth !== undefined ? this.maxDepth : <any>null;
        data["defaultSecurityProfile"] = this.defaultSecurityProfile !== undefined ? this.defaultSecurityProfile : <any>null;
        data["defaultReportingMemberKey"] = this.defaultReportingMemberKey !== undefined ? this.defaultReportingMemberKey : <any>null;
        data["defaultInputMemberKey"] = this.defaultInputMemberKey !== undefined ? this.defaultInputMemberKey : <any>null;
        data["processingStatus"] = this.processingStatus !== undefined ? this.processingStatus : <any>null;
        data["isDefaultHierarchy"] = this.isDefaultHierarchy !== undefined ? this.isDefaultHierarchy : <any>null;
        return data;
    }

    clone(): HierarchyInfo {
        const json = this.toJSON();
        let result = new HierarchyInfo();
        result.init(json);
        return result;
    }
}

export interface IHierarchyInfo {
    dimensionName?: string | null;
    hierarchyName?: string | null;
    maxDepth?: number | null;
    defaultSecurityProfile?: string | null;
    defaultReportingMemberKey?: number | null;
    defaultInputMemberKey?: number | null;
    processingStatus?: ProcessingStatus | null;
    isDefaultHierarchy: boolean;
}

export class PropertyInfo implements IPropertyInfo {
    propertyName?: string | null;
    propertyType?: string | null;
    standardProperty?: boolean | null;
    reportingProperty?: boolean | null;
    readonlyProperty!: boolean;
    processingStatus?: ProcessingStatus | null;
    typeInfo?: string | null;

    constructor(data?: IPropertyInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.propertyName = data["propertyName"] !== undefined ? data["propertyName"] : <any>null;
            this.propertyType = data["propertyType"] !== undefined ? data["propertyType"] : <any>null;
            this.standardProperty = data["standardProperty"] !== undefined ? data["standardProperty"] : <any>null;
            this.reportingProperty = data["reportingProperty"] !== undefined ? data["reportingProperty"] : <any>null;
            this.readonlyProperty = data["readonlyProperty"] !== undefined ? data["readonlyProperty"] : <any>null;
            this.processingStatus = data["processingStatus"] !== undefined ? data["processingStatus"] : <any>null;
            this.typeInfo = data["typeInfo"] !== undefined ? data["typeInfo"] : <any>null;
        }
    }

    static fromJS(data: any): PropertyInfo {
        data = typeof data === 'object' ? data : {};
        let result = new PropertyInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["propertyName"] = this.propertyName !== undefined ? this.propertyName : <any>null;
        data["propertyType"] = this.propertyType !== undefined ? this.propertyType : <any>null;
        data["standardProperty"] = this.standardProperty !== undefined ? this.standardProperty : <any>null;
        data["reportingProperty"] = this.reportingProperty !== undefined ? this.reportingProperty : <any>null;
        data["readonlyProperty"] = this.readonlyProperty !== undefined ? this.readonlyProperty : <any>null;
        data["processingStatus"] = this.processingStatus !== undefined ? this.processingStatus : <any>null;
        data["typeInfo"] = this.typeInfo !== undefined ? this.typeInfo : <any>null;
        return data;
    }

    clone(): PropertyInfo {
        const json = this.toJSON();
        let result = new PropertyInfo();
        result.init(json);
        return result;
    }
}

export interface IPropertyInfo {
    propertyName?: string | null;
    propertyType?: string | null;
    standardProperty?: boolean | null;
    reportingProperty?: boolean | null;
    readonlyProperty: boolean;
    processingStatus?: ProcessingStatus | null;
    typeInfo?: string | null;
}

export enum DimensionSyncType {
    Hierarchical = 1,
    FlatList = 2,
    None = 3,
}

export class DimensionPropertyOptionsResponse implements IDimensionPropertyOptionsResponse {
    properties?: DimensionPropertyOptionsInfo[] | null;

    constructor(data?: IDimensionPropertyOptionsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (Array.isArray(data["properties"])) {
                this.properties = [] as any;
                for (let item in data["properties"])
                    this.properties!.push(DimensionPropertyOptionsInfo.fromJS(data["properties"][item]));
            }
            else {
                this.properties = <any>null;
            }
        }
    }

    static fromJS(data: any): DimensionPropertyOptionsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DimensionPropertyOptionsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.properties)) {
            data["properties"] = [];
            for (let item in this.properties)
                data["properties"].push(this.properties[item].toJSON());
        }
        return data;
    }

    clone(): DimensionPropertyOptionsResponse {
        const json = this.toJSON();
        let result = new DimensionPropertyOptionsResponse();
        result.init(json);
        return result;
    }
}

export interface IDimensionPropertyOptionsResponse {
    properties?: DimensionPropertyOptionsInfo[] | null;
}

export class DimensionPropertyOptionsInfo implements IDimensionPropertyOptionsInfo {
    propertyName?: string | null;
    propertyType?: string | null;
    isStandard!: boolean;
    validValues?: string[] | null;
    dimensionName?: string | null;

    constructor(data?: IDimensionPropertyOptionsInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.propertyName = data["propertyName"] !== undefined ? data["propertyName"] : <any>null;
            this.propertyType = data["propertyType"] !== undefined ? data["propertyType"] : <any>null;
            this.isStandard = data["isStandard"] !== undefined ? data["isStandard"] : <any>null;
            if (Array.isArray(data["validValues"])) {
                this.validValues = [] as any;
                for (let item in data["validValues"])
                    this.validValues!.push(data["validValues"][item]);
            }
            else {
                this.validValues = <any>null;
            }
            this.dimensionName = data["dimensionName"] !== undefined ? data["dimensionName"] : <any>null;
        }
    }

    static fromJS(data: any): DimensionPropertyOptionsInfo {
        data = typeof data === 'object' ? data : {};
        let result = new DimensionPropertyOptionsInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["propertyName"] = this.propertyName !== undefined ? this.propertyName : <any>null;
        data["propertyType"] = this.propertyType !== undefined ? this.propertyType : <any>null;
        data["isStandard"] = this.isStandard !== undefined ? this.isStandard : <any>null;
        if (Array.isArray(this.validValues)) {
            data["validValues"] = [];
            for (let item in this.validValues)
                data["validValues"].push(this.validValues[item]);
        }
        data["dimensionName"] = this.dimensionName !== undefined ? this.dimensionName : <any>null;
        return data;
    }

    clone(): DimensionPropertyOptionsInfo {
        const json = this.toJSON();
        let result = new DimensionPropertyOptionsInfo();
        result.init(json);
        return result;
    }
}

export interface IDimensionPropertyOptionsInfo {
    propertyName?: string | null;
    propertyType?: string | null;
    isStandard: boolean;
    validValues?: string[] | null;
    dimensionName?: string | null;
}

export class StandardAttributeInfo implements IStandardAttributeInfo {
    dimensionType!: DimensionType;
    attributes?: StandardAttribute[] | null;

    constructor(data?: IStandardAttributeInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.dimensionType = data["dimensionType"] !== undefined ? data["dimensionType"] : <any>null;
            if (Array.isArray(data["attributes"])) {
                this.attributes = [] as any;
                for (let item in data["attributes"])
                    this.attributes!.push(StandardAttribute.fromJS(data["attributes"][item]));
            }
            else {
                this.attributes = <any>null;
            }
        }
    }

    static fromJS(data: any): StandardAttributeInfo {
        data = typeof data === 'object' ? data : {};
        let result = new StandardAttributeInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dimensionType"] = this.dimensionType !== undefined ? this.dimensionType : <any>null;
        if (Array.isArray(this.attributes)) {
            data["attributes"] = [];
            for (let item in this.attributes)
                data["attributes"].push(this.attributes[item].toJSON());
        }
        return data;
    }

    clone(): StandardAttributeInfo {
        const json = this.toJSON();
        let result = new StandardAttributeInfo();
        result.init(json);
        return result;
    }
}

export interface IStandardAttributeInfo {
    dimensionType: DimensionType;
    attributes?: StandardAttribute[] | null;
}

export class StandardAttribute implements IStandardAttribute {
    name?: string | null;
    dataType?: string | null;
    typeInfo?: string | null;

    constructor(data?: IStandardAttribute) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"] !== undefined ? data["name"] : <any>null;
            this.dataType = data["dataType"] !== undefined ? data["dataType"] : <any>null;
            this.typeInfo = data["typeInfo"] !== undefined ? data["typeInfo"] : <any>null;
        }
    }

    static fromJS(data: any): StandardAttribute {
        data = typeof data === 'object' ? data : {};
        let result = new StandardAttribute();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["dataType"] = this.dataType !== undefined ? this.dataType : <any>null;
        data["typeInfo"] = this.typeInfo !== undefined ? this.typeInfo : <any>null;
        return data;
    }

    clone(): StandardAttribute {
        const json = this.toJSON();
        let result = new StandardAttribute();
        result.init(json);
        return result;
    }
}

export interface IStandardAttribute {
    name?: string | null;
    dataType?: string | null;
    typeInfo?: string | null;
}

export class SubsetInfo implements ISubsetInfo {
    dimensionName?: string | null;
    hierarchyName?: string | null;
    subsetName?: string | null;
    members?: string[] | null;

    constructor(data?: ISubsetInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.dimensionName = data["dimensionName"] !== undefined ? data["dimensionName"] : <any>null;
            this.hierarchyName = data["hierarchyName"] !== undefined ? data["hierarchyName"] : <any>null;
            this.subsetName = data["subsetName"] !== undefined ? data["subsetName"] : <any>null;
            if (Array.isArray(data["members"])) {
                this.members = [] as any;
                for (let item in data["members"])
                    this.members!.push(data["members"][item]);
            }
            else {
                this.members = <any>null;
            }
        }
    }

    static fromJS(data: any): SubsetInfo {
        data = typeof data === 'object' ? data : {};
        let result = new SubsetInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dimensionName"] = this.dimensionName !== undefined ? this.dimensionName : <any>null;
        data["hierarchyName"] = this.hierarchyName !== undefined ? this.hierarchyName : <any>null;
        data["subsetName"] = this.subsetName !== undefined ? this.subsetName : <any>null;
        if (Array.isArray(this.members)) {
            data["members"] = [];
            for (let item in this.members)
                data["members"].push(this.members[item]);
        }
        return data;
    }

    clone(): SubsetInfo {
        const json = this.toJSON();
        let result = new SubsetInfo();
        result.init(json);
        return result;
    }
}

export interface ISubsetInfo {
    dimensionName?: string | null;
    hierarchyName?: string | null;
    subsetName?: string | null;
    members?: string[] | null;
}

export class MemberInfo implements IMemberInfo {
    memberKey?: number | null;
    memberName?: string | null;
    memberTag?: string | null;
    memberCaption?: string | null;
    hierarchy?: string | null;
    level?: number | null;
    group?: boolean | null;
    translations?: MemberTranslationInfo[] | null;
    parentKey?: number | null;
    sortOrder?: number | null;
    isLeaf?: boolean | null;
    operator?: number | null;
    startDate?: string | null;
    endDate?: string | null;
    memberStorage?: MemberStorage | null;
    baseKey?: number | null;
    timeBasedMember?: boolean | null;
    baseName?: string | null;
    properties?: MemberPropertyInfo[] | null;

    constructor(data?: IMemberInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.memberKey = data["memberKey"] !== undefined ? data["memberKey"] : <any>null;
            this.memberName = data["memberName"] !== undefined ? data["memberName"] : <any>null;
            this.memberTag = data["memberTag"] !== undefined ? data["memberTag"] : <any>null;
            this.memberCaption = data["memberCaption"] !== undefined ? data["memberCaption"] : <any>null;
            this.hierarchy = data["hierarchy"] !== undefined ? data["hierarchy"] : <any>null;
            this.level = data["level"] !== undefined ? data["level"] : <any>null;
            this.group = data["group"] !== undefined ? data["group"] : <any>null;
            if (Array.isArray(data["translations"])) {
                this.translations = [] as any;
                for (let item in data["translations"])
                    this.translations!.push(MemberTranslationInfo.fromJS(data["translations"][item]));
            }
            else {
                this.translations = <any>null;
            }
            this.parentKey = data["parentKey"] !== undefined ? data["parentKey"] : <any>null;
            this.sortOrder = data["sortOrder"] !== undefined ? data["sortOrder"] : <any>null;
            this.isLeaf = data["isLeaf"] !== undefined ? data["isLeaf"] : <any>null;
            this.operator = data["operator"] !== undefined ? data["operator"] : <any>null;
            this.startDate = data["startDate"] !== undefined ? data["startDate"] : <any>null;
            this.endDate = data["endDate"] !== undefined ? data["endDate"] : <any>null;
            this.memberStorage = data["memberStorage"] !== undefined ? data["memberStorage"] : <any>null;
            this.baseKey = data["baseKey"] !== undefined ? data["baseKey"] : <any>null;
            this.timeBasedMember = data["timeBasedMember"] !== undefined ? data["timeBasedMember"] : <any>null;
            this.baseName = data["baseName"] !== undefined ? data["baseName"] : <any>null;
            if (Array.isArray(data["properties"])) {
                this.properties = [] as any;
                for (let item in data["properties"])
                    this.properties!.push(MemberPropertyInfo.fromJS(data["properties"][item]));
            }
            else {
                this.properties = <any>null;
            }
        }
    }

    static fromJS(data: any): MemberInfo {
        data = typeof data === 'object' ? data : {};
        let result = new MemberInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberKey"] = this.memberKey !== undefined ? this.memberKey : <any>null;
        data["memberName"] = this.memberName !== undefined ? this.memberName : <any>null;
        data["memberTag"] = this.memberTag !== undefined ? this.memberTag : <any>null;
        data["memberCaption"] = this.memberCaption !== undefined ? this.memberCaption : <any>null;
        data["hierarchy"] = this.hierarchy !== undefined ? this.hierarchy : <any>null;
        data["level"] = this.level !== undefined ? this.level : <any>null;
        data["group"] = this.group !== undefined ? this.group : <any>null;
        if (Array.isArray(this.translations)) {
            data["translations"] = [];
            for (let item in this.translations)
                data["translations"].push(this.translations[item].toJSON());
        }
        data["parentKey"] = this.parentKey !== undefined ? this.parentKey : <any>null;
        data["sortOrder"] = this.sortOrder !== undefined ? this.sortOrder : <any>null;
        data["isLeaf"] = this.isLeaf !== undefined ? this.isLeaf : <any>null;
        data["operator"] = this.operator !== undefined ? this.operator : <any>null;
        data["startDate"] = this.startDate !== undefined ? this.startDate : <any>null;
        data["endDate"] = this.endDate !== undefined ? this.endDate : <any>null;
        data["memberStorage"] = this.memberStorage !== undefined ? this.memberStorage : <any>null;
        data["baseKey"] = this.baseKey !== undefined ? this.baseKey : <any>null;
        data["timeBasedMember"] = this.timeBasedMember !== undefined ? this.timeBasedMember : <any>null;
        data["baseName"] = this.baseName !== undefined ? this.baseName : <any>null;
        if (Array.isArray(this.properties)) {
            data["properties"] = [];
            for (let item in this.properties)
                data["properties"].push(this.properties[item].toJSON());
        }
        return data;
    }

    clone(): MemberInfo {
        const json = this.toJSON();
        let result = new MemberInfo();
        result.init(json);
        return result;
    }
}

export interface IMemberInfo {
    memberKey?: number | null;
    memberName?: string | null;
    memberTag?: string | null;
    memberCaption?: string | null;
    hierarchy?: string | null;
    level?: number | null;
    group?: boolean | null;
    translations?: MemberTranslationInfo[] | null;
    parentKey?: number | null;
    sortOrder?: number | null;
    isLeaf?: boolean | null;
    operator?: number | null;
    startDate?: string | null;
    endDate?: string | null;
    memberStorage?: MemberStorage | null;
    baseKey?: number | null;
    timeBasedMember?: boolean | null;
    baseName?: string | null;
    properties?: MemberPropertyInfo[] | null;
}

export class MemberTranslationInfo implements IMemberTranslationInfo {
    language?: string | null;
    caption?: string | null;

    constructor(data?: IMemberTranslationInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.language = data["language"] !== undefined ? data["language"] : <any>null;
            this.caption = data["caption"] !== undefined ? data["caption"] : <any>null;
        }
    }

    static fromJS(data: any): MemberTranslationInfo {
        data = typeof data === 'object' ? data : {};
        let result = new MemberTranslationInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["language"] = this.language !== undefined ? this.language : <any>null;
        data["caption"] = this.caption !== undefined ? this.caption : <any>null;
        return data;
    }

    clone(): MemberTranslationInfo {
        const json = this.toJSON();
        let result = new MemberTranslationInfo();
        result.init(json);
        return result;
    }
}

export interface IMemberTranslationInfo {
    language?: string | null;
    caption?: string | null;
}

export enum MemberStorage {
    Standard = 0,
    Shared = 1,
    Static = 2,
}

export class MemberPropertyInfo implements IMemberPropertyInfo {
    propertyName?: string | null;
    propertyValue?: string | null;

    constructor(data?: IMemberPropertyInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.propertyName = data["propertyName"] !== undefined ? data["propertyName"] : <any>null;
            this.propertyValue = data["propertyValue"] !== undefined ? data["propertyValue"] : <any>null;
        }
    }

    static fromJS(data: any): MemberPropertyInfo {
        data = typeof data === 'object' ? data : {};
        let result = new MemberPropertyInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["propertyName"] = this.propertyName !== undefined ? this.propertyName : <any>null;
        data["propertyValue"] = this.propertyValue !== undefined ? this.propertyValue : <any>null;
        return data;
    }

    clone(): MemberPropertyInfo {
        const json = this.toJSON();
        let result = new MemberPropertyInfo();
        result.init(json);
        return result;
    }
}

export interface IMemberPropertyInfo {
    propertyName?: string | null;
    propertyValue?: string | null;
}

export class MemberInfoSimple implements IMemberInfoSimple {
    memberKey?: number | null;
    memberName?: string | null;
    memberCaption?: string | null;
    parentKey?: number | null;
    isLeaf?: boolean | null;
    properties?: MemberPropertyInfo[] | null;

    constructor(data?: IMemberInfoSimple) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.memberKey = data["memberKey"] !== undefined ? data["memberKey"] : <any>null;
            this.memberName = data["memberName"] !== undefined ? data["memberName"] : <any>null;
            this.memberCaption = data["memberCaption"] !== undefined ? data["memberCaption"] : <any>null;
            this.parentKey = data["parentKey"] !== undefined ? data["parentKey"] : <any>null;
            this.isLeaf = data["isLeaf"] !== undefined ? data["isLeaf"] : <any>null;
            if (Array.isArray(data["properties"])) {
                this.properties = [] as any;
                for (let item in data["properties"])
                    this.properties!.push(MemberPropertyInfo.fromJS(data["properties"][item]));
            }
            else {
                this.properties = <any>null;
            }
        }
    }

    static fromJS(data: any): MemberInfoSimple {
        data = typeof data === 'object' ? data : {};
        let result = new MemberInfoSimple();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberKey"] = this.memberKey !== undefined ? this.memberKey : <any>null;
        data["memberName"] = this.memberName !== undefined ? this.memberName : <any>null;
        data["memberCaption"] = this.memberCaption !== undefined ? this.memberCaption : <any>null;
        data["parentKey"] = this.parentKey !== undefined ? this.parentKey : <any>null;
        data["isLeaf"] = this.isLeaf !== undefined ? this.isLeaf : <any>null;
        if (Array.isArray(this.properties)) {
            data["properties"] = [];
            for (let item in this.properties)
                data["properties"].push(this.properties[item].toJSON());
        }
        return data;
    }

    clone(): MemberInfoSimple {
        const json = this.toJSON();
        let result = new MemberInfoSimple();
        result.init(json);
        return result;
    }
}

export interface IMemberInfoSimple {
    memberKey?: number | null;
    memberName?: string | null;
    memberCaption?: string | null;
    parentKey?: number | null;
    isLeaf?: boolean | null;
    properties?: MemberPropertyInfo[] | null;
}

export class MemberChronologyInfo implements IMemberChronologyInfo {
    memberName?: string | null;
    memberCaption?: string | null;
    parentName?: string | null;
    parentCaption?: string | null;
    startDate?: string | null;
    endDate?: string | null;
    memberInfoType?: MemberStorage | null;
    baseName?: string | null;

    constructor(data?: IMemberChronologyInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.memberName = data["memberName"] !== undefined ? data["memberName"] : <any>null;
            this.memberCaption = data["memberCaption"] !== undefined ? data["memberCaption"] : <any>null;
            this.parentName = data["parentName"] !== undefined ? data["parentName"] : <any>null;
            this.parentCaption = data["parentCaption"] !== undefined ? data["parentCaption"] : <any>null;
            this.startDate = data["startDate"] !== undefined ? data["startDate"] : <any>null;
            this.endDate = data["endDate"] !== undefined ? data["endDate"] : <any>null;
            this.memberInfoType = data["memberInfoType"] !== undefined ? data["memberInfoType"] : <any>null;
            this.baseName = data["baseName"] !== undefined ? data["baseName"] : <any>null;
        }
    }

    static fromJS(data: any): MemberChronologyInfo {
        data = typeof data === 'object' ? data : {};
        let result = new MemberChronologyInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberName"] = this.memberName !== undefined ? this.memberName : <any>null;
        data["memberCaption"] = this.memberCaption !== undefined ? this.memberCaption : <any>null;
        data["parentName"] = this.parentName !== undefined ? this.parentName : <any>null;
        data["parentCaption"] = this.parentCaption !== undefined ? this.parentCaption : <any>null;
        data["startDate"] = this.startDate !== undefined ? this.startDate : <any>null;
        data["endDate"] = this.endDate !== undefined ? this.endDate : <any>null;
        data["memberInfoType"] = this.memberInfoType !== undefined ? this.memberInfoType : <any>null;
        data["baseName"] = this.baseName !== undefined ? this.baseName : <any>null;
        return data;
    }

    clone(): MemberChronologyInfo {
        const json = this.toJSON();
        let result = new MemberChronologyInfo();
        result.init(json);
        return result;
    }
}

export interface IMemberChronologyInfo {
    memberName?: string | null;
    memberCaption?: string | null;
    parentName?: string | null;
    parentCaption?: string | null;
    startDate?: string | null;
    endDate?: string | null;
    memberInfoType?: MemberStorage | null;
    baseName?: string | null;
}

export class MemberInfoSingleGroupResult implements IMemberInfoSingleGroupResult {
    rowCount!: number;
    rowData?: MemberInfo[] | null;

    constructor(data?: IMemberInfoSingleGroupResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.rowCount = data["rowCount"] !== undefined ? data["rowCount"] : <any>null;
            if (Array.isArray(data["rowData"])) {
                this.rowData = [] as any;
                for (let item in data["rowData"])
                    this.rowData!.push(MemberInfo.fromJS(data["rowData"][item]));
            }
            else {
                this.rowData = <any>null;
            }
        }
    }

    static fromJS(data: any): MemberInfoSingleGroupResult {
        data = typeof data === 'object' ? data : {};
        let result = new MemberInfoSingleGroupResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rowCount"] = this.rowCount !== undefined ? this.rowCount : <any>null;
        if (Array.isArray(this.rowData)) {
            data["rowData"] = [];
            for (let item in this.rowData)
                data["rowData"].push(this.rowData[item].toJSON());
        }
        return data;
    }

    clone(): MemberInfoSingleGroupResult {
        const json = this.toJSON();
        let result = new MemberInfoSingleGroupResult();
        result.init(json);
        return result;
    }
}

export interface IMemberInfoSingleGroupResult {
    rowCount: number;
    rowData?: MemberInfo[] | null;
}

export class SingleGroupRequest implements ISingleGroupRequest {
    parentMemberKey?: number | null;
    dimensionName?: string | null;
    hierarchyName?: string | null;

    constructor(data?: ISingleGroupRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.parentMemberKey = data["parentMemberKey"] !== undefined ? data["parentMemberKey"] : <any>null;
            this.dimensionName = data["dimensionName"] !== undefined ? data["dimensionName"] : <any>null;
            this.hierarchyName = data["hierarchyName"] !== undefined ? data["hierarchyName"] : <any>null;
        }
    }

    static fromJS(data: any): SingleGroupRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SingleGroupRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentMemberKey"] = this.parentMemberKey !== undefined ? this.parentMemberKey : <any>null;
        data["dimensionName"] = this.dimensionName !== undefined ? this.dimensionName : <any>null;
        data["hierarchyName"] = this.hierarchyName !== undefined ? this.hierarchyName : <any>null;
        return data;
    }

    clone(): SingleGroupRequest {
        const json = this.toJSON();
        let result = new SingleGroupRequest();
        result.init(json);
        return result;
    }
}

export interface ISingleGroupRequest {
    parentMemberKey?: number | null;
    dimensionName?: string | null;
    hierarchyName?: string | null;
}

export class MemberInfoPagedResults implements IMemberInfoPagedResults {
    results?: MemberInfo[] | null;

    constructor(data?: IMemberInfoPagedResults) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (Array.isArray(data["results"])) {
                this.results = [] as any;
                for (let item in data["results"])
                    this.results!.push(MemberInfo.fromJS(data["results"][item]));
            }
            else {
                this.results = <any>null;
            }
        }
    }

    static fromJS(data: any): MemberInfoPagedResults {
        data = typeof data === 'object' ? data : {};
        let result = new MemberInfoPagedResults();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item in this.results)
                data["results"].push(this.results[item].toJSON());
        }
        return data;
    }

    clone(): MemberInfoPagedResults {
        const json = this.toJSON();
        let result = new MemberInfoPagedResults();
        result.init(json);
        return result;
    }
}

export interface IMemberInfoPagedResults {
    results?: MemberInfo[] | null;
}

export class HierarchyMemberPaging extends Paging implements IHierarchyMemberPaging {
    serverGroupLevel!: number;
    dimensionName?: string | null;
    hierarchyName?: string | null;

    constructor(data?: IHierarchyMemberPaging) {
        super(data);
    }

    init(data?: any) {
        super.init(data);
        if (data) {
            this.serverGroupLevel = data["serverGroupLevel"] !== undefined ? data["serverGroupLevel"] : <any>null;
            this.dimensionName = data["dimensionName"] !== undefined ? data["dimensionName"] : <any>null;
            this.hierarchyName = data["hierarchyName"] !== undefined ? data["hierarchyName"] : <any>null;
        }
    }

    static fromJS(data: any): HierarchyMemberPaging {
        data = typeof data === 'object' ? data : {};
        let result = new HierarchyMemberPaging();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serverGroupLevel"] = this.serverGroupLevel !== undefined ? this.serverGroupLevel : <any>null;
        data["dimensionName"] = this.dimensionName !== undefined ? this.dimensionName : <any>null;
        data["hierarchyName"] = this.hierarchyName !== undefined ? this.hierarchyName : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): HierarchyMemberPaging {
        const json = this.toJSON();
        let result = new HierarchyMemberPaging();
        result.init(json);
        return result;
    }
}

export interface IHierarchyMemberPaging extends IPaging {
    serverGroupLevel: number;
    dimensionName?: string | null;
    hierarchyName?: string | null;
}

export enum HierarchySyncMode {
    AdditionsOnly = 0,
    AdditionsAndUpdates = 1,
    AdditionsUpdatesAndDeletes = 2,
}

export class DataImportActionResult implements IDataImportActionResult {
    insertCount!: number;
    updateCount!: number;
    deleteCount!: number;
    renameCount!: number;
    renameUpdateCount!: number;
    dataImportResult?: DataImportResult[] | null;

    constructor(data?: IDataImportActionResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.insertCount = data["insertCount"] !== undefined ? data["insertCount"] : <any>null;
            this.updateCount = data["updateCount"] !== undefined ? data["updateCount"] : <any>null;
            this.deleteCount = data["deleteCount"] !== undefined ? data["deleteCount"] : <any>null;
            this.renameCount = data["renameCount"] !== undefined ? data["renameCount"] : <any>null;
            this.renameUpdateCount = data["renameUpdateCount"] !== undefined ? data["renameUpdateCount"] : <any>null;
            if (Array.isArray(data["dataImportResult"])) {
                this.dataImportResult = [] as any;
                for (let item in data["dataImportResult"])
                    this.dataImportResult!.push(DataImportResult.fromJS(data["dataImportResult"][item]));
            }
            else {
                this.dataImportResult = <any>null;
            }
        }
    }

    static fromJS(data: any): DataImportActionResult {
        data = typeof data === 'object' ? data : {};
        let result = new DataImportActionResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["insertCount"] = this.insertCount !== undefined ? this.insertCount : <any>null;
        data["updateCount"] = this.updateCount !== undefined ? this.updateCount : <any>null;
        data["deleteCount"] = this.deleteCount !== undefined ? this.deleteCount : <any>null;
        data["renameCount"] = this.renameCount !== undefined ? this.renameCount : <any>null;
        data["renameUpdateCount"] = this.renameUpdateCount !== undefined ? this.renameUpdateCount : <any>null;
        if (Array.isArray(this.dataImportResult)) {
            data["dataImportResult"] = [];
            for (let item in this.dataImportResult)
                data["dataImportResult"].push(this.dataImportResult[item].toJSON());
        }
        return data;
    }

    clone(): DataImportActionResult {
        const json = this.toJSON();
        let result = new DataImportActionResult();
        result.init(json);
        return result;
    }
}

export interface IDataImportActionResult {
    insertCount: number;
    updateCount: number;
    deleteCount: number;
    renameCount: number;
    renameUpdateCount: number;
    dataImportResult?: DataImportResult[] | null;
}

export class DataImportResult implements IDataImportResult {
    action?: string | null;
    rowNo?: string | null;
    name?: string | null;
    newName?: string | null;
    parentName?: string | null;
    isLeaf!: boolean;
    tag?: string | null;
    operator?: string | null;
    startDate?: string | null;
    endDate?: string | null;
    captions?: DataImportKeyValue[] | null;
    properties?: DataImportKeyValue[] | null;
    type?: string | null;

    constructor(data?: IDataImportResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.action = data["action"] !== undefined ? data["action"] : <any>null;
            this.rowNo = data["rowNo"] !== undefined ? data["rowNo"] : <any>null;
            this.name = data["name"] !== undefined ? data["name"] : <any>null;
            this.newName = data["newName"] !== undefined ? data["newName"] : <any>null;
            this.parentName = data["parentName"] !== undefined ? data["parentName"] : <any>null;
            this.isLeaf = data["isLeaf"] !== undefined ? data["isLeaf"] : <any>null;
            this.tag = data["tag"] !== undefined ? data["tag"] : <any>null;
            this.operator = data["operator"] !== undefined ? data["operator"] : <any>null;
            this.startDate = data["startDate"] !== undefined ? data["startDate"] : <any>null;
            this.endDate = data["endDate"] !== undefined ? data["endDate"] : <any>null;
            if (Array.isArray(data["captions"])) {
                this.captions = [] as any;
                for (let item in data["captions"])
                    this.captions!.push(DataImportKeyValue.fromJS(data["captions"][item]));
            }
            else {
                this.captions = <any>null;
            }
            if (Array.isArray(data["properties"])) {
                this.properties = [] as any;
                for (let item in data["properties"])
                    this.properties!.push(DataImportKeyValue.fromJS(data["properties"][item]));
            }
            else {
                this.properties = <any>null;
            }
            this.type = data["type"] !== undefined ? data["type"] : <any>null;
        }
    }

    static fromJS(data: any): DataImportResult {
        data = typeof data === 'object' ? data : {};
        let result = new DataImportResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["action"] = this.action !== undefined ? this.action : <any>null;
        data["rowNo"] = this.rowNo !== undefined ? this.rowNo : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["newName"] = this.newName !== undefined ? this.newName : <any>null;
        data["parentName"] = this.parentName !== undefined ? this.parentName : <any>null;
        data["isLeaf"] = this.isLeaf !== undefined ? this.isLeaf : <any>null;
        data["tag"] = this.tag !== undefined ? this.tag : <any>null;
        data["operator"] = this.operator !== undefined ? this.operator : <any>null;
        data["startDate"] = this.startDate !== undefined ? this.startDate : <any>null;
        data["endDate"] = this.endDate !== undefined ? this.endDate : <any>null;
        if (Array.isArray(this.captions)) {
            data["captions"] = [];
            for (let item in this.captions)
                data["captions"].push(this.captions[item].toJSON());
        }
        if (Array.isArray(this.properties)) {
            data["properties"] = [];
            for (let item in this.properties)
                data["properties"].push(this.properties[item].toJSON());
        }
        data["type"] = this.type !== undefined ? this.type : <any>null;
        return data;
    }

    clone(): DataImportResult {
        const json = this.toJSON();
        let result = new DataImportResult();
        result.init(json);
        return result;
    }
}

export interface IDataImportResult {
    action?: string | null;
    rowNo?: string | null;
    name?: string | null;
    newName?: string | null;
    parentName?: string | null;
    isLeaf: boolean;
    tag?: string | null;
    operator?: string | null;
    startDate?: string | null;
    endDate?: string | null;
    captions?: DataImportKeyValue[] | null;
    properties?: DataImportKeyValue[] | null;
    type?: string | null;
}

export class DataImportKeyValue implements IDataImportKeyValue {
    key?: string | null;
    value?: string | null;

    constructor(data?: IDataImportKeyValue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.key = data["key"] !== undefined ? data["key"] : <any>null;
            this.value = data["value"] !== undefined ? data["value"] : <any>null;
        }
    }

    static fromJS(data: any): DataImportKeyValue {
        data = typeof data === 'object' ? data : {};
        let result = new DataImportKeyValue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key !== undefined ? this.key : <any>null;
        data["value"] = this.value !== undefined ? this.value : <any>null;
        return data;
    }

    clone(): DataImportKeyValue {
        const json = this.toJSON();
        let result = new DataImportKeyValue();
        result.init(json);
        return result;
    }
}

export interface IDataImportKeyValue {
    key?: string | null;
    value?: string | null;
}

export class ListInfo implements IListInfo {
    listDetails?: ListDetailsInfo | null;
    properties?: ListPropertyInfo[] | null;

    constructor(data?: IListInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.listDetails = data["listDetails"] ? ListDetailsInfo.fromJS(data["listDetails"]) : <any>null;
            if (Array.isArray(data["properties"])) {
                this.properties = [] as any;
                for (let item in data["properties"])
                    this.properties!.push(ListPropertyInfo.fromJS(data["properties"][item]));
            }
            else {
                this.properties = <any>null;
            }
        }
    }

    static fromJS(data: any): ListInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ListInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["listDetails"] = this.listDetails ? this.listDetails.toJSON() : <any>null;
        if (Array.isArray(this.properties)) {
            data["properties"] = [];
            for (let item in this.properties)
                data["properties"].push(this.properties[item].toJSON());
        }
        return data;
    }

    clone(): ListInfo {
        const json = this.toJSON();
        let result = new ListInfo();
        result.init(json);
        return result;
    }
}

export interface IListInfo {
    listDetails?: ListDetailsInfo | null;
    properties?: ListPropertyInfo[] | null;
}

export class ListDetailsInfo implements IListDetailsInfo {
    listId!: number;
    list?: string | null;
    idOnly!: boolean;
    withSelection!: boolean;
    listTypeID?: number | null;
    listType?: string | null;
    headerListID?: number | null;
    headerList?: string | null;
    sortOrder!: number;
    system!: boolean;
    afterClose?: string | null;
    folder?: string | null;

    constructor(data?: IListDetailsInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.listId = data["listId"] !== undefined ? data["listId"] : <any>null;
            this.list = data["list"] !== undefined ? data["list"] : <any>null;
            this.idOnly = data["idOnly"] !== undefined ? data["idOnly"] : <any>null;
            this.withSelection = data["withSelection"] !== undefined ? data["withSelection"] : <any>null;
            this.listTypeID = data["listTypeID"] !== undefined ? data["listTypeID"] : <any>null;
            this.listType = data["listType"] !== undefined ? data["listType"] : <any>null;
            this.headerListID = data["headerListID"] !== undefined ? data["headerListID"] : <any>null;
            this.headerList = data["headerList"] !== undefined ? data["headerList"] : <any>null;
            this.sortOrder = data["sortOrder"] !== undefined ? data["sortOrder"] : <any>null;
            this.system = data["system"] !== undefined ? data["system"] : <any>null;
            this.afterClose = data["afterClose"] !== undefined ? data["afterClose"] : <any>null;
            this.folder = data["folder"] !== undefined ? data["folder"] : <any>null;
        }
    }

    static fromJS(data: any): ListDetailsInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ListDetailsInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["listId"] = this.listId !== undefined ? this.listId : <any>null;
        data["list"] = this.list !== undefined ? this.list : <any>null;
        data["idOnly"] = this.idOnly !== undefined ? this.idOnly : <any>null;
        data["withSelection"] = this.withSelection !== undefined ? this.withSelection : <any>null;
        data["listTypeID"] = this.listTypeID !== undefined ? this.listTypeID : <any>null;
        data["listType"] = this.listType !== undefined ? this.listType : <any>null;
        data["headerListID"] = this.headerListID !== undefined ? this.headerListID : <any>null;
        data["headerList"] = this.headerList !== undefined ? this.headerList : <any>null;
        data["sortOrder"] = this.sortOrder !== undefined ? this.sortOrder : <any>null;
        data["system"] = this.system !== undefined ? this.system : <any>null;
        data["afterClose"] = this.afterClose !== undefined ? this.afterClose : <any>null;
        data["folder"] = this.folder !== undefined ? this.folder : <any>null;
        return data;
    }

    clone(): ListDetailsInfo {
        const json = this.toJSON();
        let result = new ListDetailsInfo();
        result.init(json);
        return result;
    }
}

export interface IListDetailsInfo {
    listId: number;
    list?: string | null;
    idOnly: boolean;
    withSelection: boolean;
    listTypeID?: number | null;
    listType?: string | null;
    headerListID?: number | null;
    headerList?: string | null;
    sortOrder: number;
    system: boolean;
    afterClose?: string | null;
    folder?: string | null;
}

export class ListPropertyInfo implements IListPropertyInfo {
    id!: number;
    propertyDetails?: ListPropertyDetailsInfo | null;
    listDetails?: ListDetailsInfo | null;
    propertyName?: string | null;
    propertyRename?: string | null;
    sortOrder!: number;
    system!: boolean;
    hide!: boolean;
    header!: boolean;
    filter?: string | null;
    selection!: boolean;

    constructor(data?: IListPropertyInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"] !== undefined ? data["id"] : <any>null;
            this.propertyDetails = data["propertyDetails"] ? ListPropertyDetailsInfo.fromJS(data["propertyDetails"]) : <any>null;
            this.listDetails = data["listDetails"] ? ListDetailsInfo.fromJS(data["listDetails"]) : <any>null;
            this.propertyName = data["propertyName"] !== undefined ? data["propertyName"] : <any>null;
            this.propertyRename = data["propertyRename"] !== undefined ? data["propertyRename"] : <any>null;
            this.sortOrder = data["sortOrder"] !== undefined ? data["sortOrder"] : <any>null;
            this.system = data["system"] !== undefined ? data["system"] : <any>null;
            this.hide = data["hide"] !== undefined ? data["hide"] : <any>null;
            this.header = data["header"] !== undefined ? data["header"] : <any>null;
            this.filter = data["filter"] !== undefined ? data["filter"] : <any>null;
            this.selection = data["selection"] !== undefined ? data["selection"] : <any>null;
        }
    }

    static fromJS(data: any): ListPropertyInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ListPropertyInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["propertyDetails"] = this.propertyDetails ? this.propertyDetails.toJSON() : <any>null;
        data["listDetails"] = this.listDetails ? this.listDetails.toJSON() : <any>null;
        data["propertyName"] = this.propertyName !== undefined ? this.propertyName : <any>null;
        data["propertyRename"] = this.propertyRename !== undefined ? this.propertyRename : <any>null;
        data["sortOrder"] = this.sortOrder !== undefined ? this.sortOrder : <any>null;
        data["system"] = this.system !== undefined ? this.system : <any>null;
        data["hide"] = this.hide !== undefined ? this.hide : <any>null;
        data["header"] = this.header !== undefined ? this.header : <any>null;
        data["filter"] = this.filter !== undefined ? this.filter : <any>null;
        data["selection"] = this.selection !== undefined ? this.selection : <any>null;
        return data;
    }

    clone(): ListPropertyInfo {
        const json = this.toJSON();
        let result = new ListPropertyInfo();
        result.init(json);
        return result;
    }
}

export interface IListPropertyInfo {
    id: number;
    propertyDetails?: ListPropertyDetailsInfo | null;
    listDetails?: ListDetailsInfo | null;
    propertyName?: string | null;
    propertyRename?: string | null;
    sortOrder: number;
    system: boolean;
    hide: boolean;
    header: boolean;
    filter?: string | null;
    selection: boolean;
}

export class ListPropertyDetailsInfo implements IListPropertyDetailsInfo {
    propertyID!: number;
    property?: string | null;
    propertyType?: ListPropertyType | null;
    propertyLength?: number | null;
    propertyLinkID?: number | null;
    propertyLink?: string | null;
    organization?: boolean | null;
    defaultValue?: string | null;
    sortOrder?: number | null;
    system!: boolean;

    constructor(data?: IListPropertyDetailsInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.propertyID = data["propertyID"] !== undefined ? data["propertyID"] : <any>null;
            this.property = data["property"] !== undefined ? data["property"] : <any>null;
            this.propertyType = data["propertyType"] !== undefined ? data["propertyType"] : <any>null;
            this.propertyLength = data["propertyLength"] !== undefined ? data["propertyLength"] : <any>null;
            this.propertyLinkID = data["propertyLinkID"] !== undefined ? data["propertyLinkID"] : <any>null;
            this.propertyLink = data["propertyLink"] !== undefined ? data["propertyLink"] : <any>null;
            this.organization = data["organization"] !== undefined ? data["organization"] : <any>null;
            this.defaultValue = data["defaultValue"] !== undefined ? data["defaultValue"] : <any>null;
            this.sortOrder = data["sortOrder"] !== undefined ? data["sortOrder"] : <any>null;
            this.system = data["system"] !== undefined ? data["system"] : <any>null;
        }
    }

    static fromJS(data: any): ListPropertyDetailsInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ListPropertyDetailsInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["propertyID"] = this.propertyID !== undefined ? this.propertyID : <any>null;
        data["property"] = this.property !== undefined ? this.property : <any>null;
        data["propertyType"] = this.propertyType !== undefined ? this.propertyType : <any>null;
        data["propertyLength"] = this.propertyLength !== undefined ? this.propertyLength : <any>null;
        data["propertyLinkID"] = this.propertyLinkID !== undefined ? this.propertyLinkID : <any>null;
        data["propertyLink"] = this.propertyLink !== undefined ? this.propertyLink : <any>null;
        data["organization"] = this.organization !== undefined ? this.organization : <any>null;
        data["defaultValue"] = this.defaultValue !== undefined ? this.defaultValue : <any>null;
        data["sortOrder"] = this.sortOrder !== undefined ? this.sortOrder : <any>null;
        data["system"] = this.system !== undefined ? this.system : <any>null;
        return data;
    }

    clone(): ListPropertyDetailsInfo {
        const json = this.toJSON();
        let result = new ListPropertyDetailsInfo();
        result.init(json);
        return result;
    }
}

export interface IListPropertyDetailsInfo {
    propertyID: number;
    property?: string | null;
    propertyType?: ListPropertyType | null;
    propertyLength?: number | null;
    propertyLinkID?: number | null;
    propertyLink?: string | null;
    organization?: boolean | null;
    defaultValue?: string | null;
    sortOrder?: number | null;
    system: boolean;
}

export enum ListPropertyType {
    Character = 1,
    List = 2,
    Dimension = 3,
    Integer = 5,
    DateTime = 6,
    Boolean = 7,
    Bigint = 11,
    DimensionList = 12,
    PropertyList = 14,
    Table = 15,
    Model = 16,
    TableList = 17,
    DimensionType = 19,
    Decimal = 20,
}

export class ExtractHierarchyInfo implements IExtractHierarchyInfo {
    extractID!: number;
    extractName?: string | null;

    constructor(data?: IExtractHierarchyInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.extractID = data["extractID"] !== undefined ? data["extractID"] : <any>null;
            this.extractName = data["extractName"] !== undefined ? data["extractName"] : <any>null;
        }
    }

    static fromJS(data: any): ExtractHierarchyInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ExtractHierarchyInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["extractID"] = this.extractID !== undefined ? this.extractID : <any>null;
        data["extractName"] = this.extractName !== undefined ? this.extractName : <any>null;
        return data;
    }

    clone(): ExtractHierarchyInfo {
        const json = this.toJSON();
        let result = new ExtractHierarchyInfo();
        result.init(json);
        return result;
    }
}

export interface IExtractHierarchyInfo {
    extractID: number;
    extractName?: string | null;
}

export class ExtractHierarchyDetail implements IExtractHierarchyDetail {
    dimension?: string | null;
    extractID!: number;
    extractName?: string | null;
    properties?: string[] | null;
    includePath!: boolean;
    includeKey!: boolean;
    includeShared!: boolean;
    order!: boolean;
    members?: ExtractHierarchiesMemberInfo[] | null;

    constructor(data?: IExtractHierarchyDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.dimension = data["dimension"] !== undefined ? data["dimension"] : <any>null;
            this.extractID = data["extractID"] !== undefined ? data["extractID"] : <any>null;
            this.extractName = data["extractName"] !== undefined ? data["extractName"] : <any>null;
            if (Array.isArray(data["properties"])) {
                this.properties = [] as any;
                for (let item in data["properties"])
                    this.properties!.push(data["properties"][item]);
            }
            else {
                this.properties = <any>null;
            }
            this.includePath = data["includePath"] !== undefined ? data["includePath"] : <any>null;
            this.includeKey = data["includeKey"] !== undefined ? data["includeKey"] : <any>null;
            this.includeShared = data["includeShared"] !== undefined ? data["includeShared"] : <any>null;
            this.order = data["order"] !== undefined ? data["order"] : <any>null;
            if (Array.isArray(data["members"])) {
                this.members = [] as any;
                for (let item in data["members"])
                    this.members!.push(ExtractHierarchiesMemberInfo.fromJS(data["members"][item]));
            }
            else {
                this.members = <any>null;
            }
        }
    }

    static fromJS(data: any): ExtractHierarchyDetail {
        data = typeof data === 'object' ? data : {};
        let result = new ExtractHierarchyDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dimension"] = this.dimension !== undefined ? this.dimension : <any>null;
        data["extractID"] = this.extractID !== undefined ? this.extractID : <any>null;
        data["extractName"] = this.extractName !== undefined ? this.extractName : <any>null;
        if (Array.isArray(this.properties)) {
            data["properties"] = [];
            for (let item in this.properties)
                data["properties"].push(this.properties[item]);
        }
        data["includePath"] = this.includePath !== undefined ? this.includePath : <any>null;
        data["includeKey"] = this.includeKey !== undefined ? this.includeKey : <any>null;
        data["includeShared"] = this.includeShared !== undefined ? this.includeShared : <any>null;
        data["order"] = this.order !== undefined ? this.order : <any>null;
        if (Array.isArray(this.members)) {
            data["members"] = [];
            for (let item in this.members)
                data["members"].push(this.members[item].toJSON());
        }
        return data;
    }

    clone(): ExtractHierarchyDetail {
        const json = this.toJSON();
        let result = new ExtractHierarchyDetail();
        result.init(json);
        return result;
    }
}

export interface IExtractHierarchyDetail {
    dimension?: string | null;
    extractID: number;
    extractName?: string | null;
    properties?: string[] | null;
    includePath: boolean;
    includeKey: boolean;
    includeShared: boolean;
    order: boolean;
    members?: ExtractHierarchiesMemberInfo[] | null;
}

export class ExtractHierarchiesMemberInfo implements IExtractHierarchiesMemberInfo {
    memberID!: number;
    relationship!: number;
    includeExclude!: number;

    constructor(data?: IExtractHierarchiesMemberInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.memberID = data["memberID"] !== undefined ? data["memberID"] : <any>null;
            this.relationship = data["relationship"] !== undefined ? data["relationship"] : <any>null;
            this.includeExclude = data["includeExclude"] !== undefined ? data["includeExclude"] : <any>null;
        }
    }

    static fromJS(data: any): ExtractHierarchiesMemberInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ExtractHierarchiesMemberInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberID"] = this.memberID !== undefined ? this.memberID : <any>null;
        data["relationship"] = this.relationship !== undefined ? this.relationship : <any>null;
        data["includeExclude"] = this.includeExclude !== undefined ? this.includeExclude : <any>null;
        return data;
    }

    clone(): ExtractHierarchiesMemberInfo {
        const json = this.toJSON();
        let result = new ExtractHierarchiesMemberInfo();
        result.init(json);
        return result;
    }
}

export interface IExtractHierarchiesMemberInfo {
    memberID: number;
    relationship: number;
    includeExclude: number;
}

export class PowerBIEmbedInfo implements IPowerBIEmbedInfo {
    reportId!: string;
    embedUrl?: string | null;
    accessToken?: string | null;

    constructor(data?: IPowerBIEmbedInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.reportId = data["reportId"] !== undefined ? data["reportId"] : <any>null;
            this.embedUrl = data["embedUrl"] !== undefined ? data["embedUrl"] : <any>null;
            this.accessToken = data["accessToken"] !== undefined ? data["accessToken"] : <any>null;
        }
    }

    static fromJS(data: any): PowerBIEmbedInfo {
        data = typeof data === 'object' ? data : {};
        let result = new PowerBIEmbedInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reportId"] = this.reportId !== undefined ? this.reportId : <any>null;
        data["embedUrl"] = this.embedUrl !== undefined ? this.embedUrl : <any>null;
        data["accessToken"] = this.accessToken !== undefined ? this.accessToken : <any>null;
        return data;
    }

    clone(): PowerBIEmbedInfo {
        const json = this.toJSON();
        let result = new PowerBIEmbedInfo();
        result.init(json);
        return result;
    }
}

export interface IPowerBIEmbedInfo {
    reportId: string;
    embedUrl?: string | null;
    accessToken?: string | null;
}

export class Process implements IProcess {
    activities?: BaseProcessActivity[] | null;

    constructor(data?: IProcess) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (Array.isArray(data["activities"])) {
                this.activities = [] as any;
                for (let item in data["activities"])
                    this.activities!.push(BaseProcessActivity.fromJS(data["activities"][item]));
            }
            else {
                this.activities = <any>null;
            }
        }
    }

    static fromJS(data: any): Process {
        data = typeof data === 'object' ? data : {};
        let result = new Process();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.activities)) {
            data["activities"] = [];
            for (let item in this.activities)
                data["activities"].push(this.activities[item].toJSON());
        }
        return data;
    }

    clone(): Process {
        const json = this.toJSON();
        let result = new Process();
        result.init(json);
        return result;
    }
}

export interface IProcess {
    activities?: BaseProcessActivity[] | null;
}

export abstract class BaseProcessActivity implements IBaseProcessActivity {
    name?: string | null;
    disabled?: boolean | null;
    advanceRule?: AdvanceRule | null;

    protected _discriminator: string;

    constructor(data?: IBaseProcessActivity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "BaseProcessActivity";
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"] !== undefined ? data["name"] : <any>null;
            this.disabled = data["disabled"] !== undefined ? data["disabled"] : <any>null;
            this.advanceRule = data["advanceRule"] !== undefined ? data["advanceRule"] : <any>null;
        }
    }

    static fromJS(data: any): BaseProcessActivity {
        data = typeof data === 'object' ? data : {};
        if (data["discriminator"] === "ADOImportActivity") {
            let result = new ADOImportActivity();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "NonInteractiveProcessActivity") {
            throw new Error("The abstract class 'NonInteractiveProcessActivity' cannot be instantiated.");
        }
        if (data["discriminator"] === "ADOTriggerActivity") {
            let result = new ADOTriggerActivity();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "AnaplanWorkflowActivity") {
            let result = new AnaplanWorkflowActivity();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "ArchiveXL3ReportActivity") {
            let result = new ArchiveXL3ReportActivity();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "AutomaticFileImportProcessActivity") {
            let result = new AutomaticFileImportProcessActivity();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "AutomaticHierarchySyncProcessActivity") {
            let result = new AutomaticHierarchySyncProcessActivity();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "AzureDataFactoryPipelineActivity") {
            let result = new AzureDataFactoryPipelineActivity();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "ConnectorProcessActivity") {
            let result = new ConnectorProcessActivity();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "DelayProcessActivity") {
            let result = new DelayProcessActivity();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "ExtractHierarchyProcessActivity") {
            let result = new ExtractHierarchyProcessActivity();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "ForeachProcessActivity") {
            let result = new ForeachProcessActivity();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "SubProcessProcessActivity") {
            let result = new SubProcessProcessActivity();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "HttpRequestProcessActivity") {
            let result = new HttpRequestProcessActivity();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "IfProcessActivity") {
            let result = new IfProcessActivity();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "ContainerProcessActivity") {
            throw new Error("The abstract class 'ContainerProcessActivity' cannot be instantiated.");
        }
        if (data["discriminator"] === "LockProcessActivity") {
            let result = new LockProcessActivity();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "LogMessageProcessActivity") {
            let result = new LogMessageProcessActivity();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "ModelDataExportProcessActivity") {
            let result = new ModelDataExportProcessActivity();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "NoteProcessActivity") {
            let result = new NoteProcessActivity();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "PublishModelToAnalysisServicesActivity") {
            let result = new PublishModelToAnalysisServicesActivity();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "RunReportBookProcessActivity") {
            let result = new RunReportBookProcessActivity();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "RunWorkflowProcessActivity") {
            let result = new RunWorkflowProcessActivity();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "ScriptProcessActivity") {
            let result = new ScriptProcessActivity();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "SendEmailProcessActivity") {
            let result = new SendEmailProcessActivity();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "SlackMessageProcessActivity") {
            let result = new SlackMessageProcessActivity();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "SqlServerStoredProcedureProcessActivity") {
            let result = new SqlServerStoredProcedureProcessActivity();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "StartProcessActivity") {
            let result = new StartProcessActivity();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "StopProcessActivity") {
            let result = new StopProcessActivity();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "VenaExportProcessActivity") {
            let result = new VenaExportProcessActivity();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "VenaImportProcessActivity") {
            let result = new VenaImportProcessActivity();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "DataEntryActivity") {
            let result = new DataEntryActivity();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "FormInteractiveActivity") {
            throw new Error("The abstract class 'FormInteractiveActivity' cannot be instantiated.");
        }
        if (data["discriminator"] === "InteractiveProcessActivity") {
            throw new Error("The abstract class 'InteractiveProcessActivity' cannot be instantiated.");
        }
        if (data["discriminator"] === "FileExportProcessActivity") {
            let result = new FileExportProcessActivity();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "FileImportProcessActivity") {
            let result = new FileImportProcessActivity();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "ReportingActivity") {
            let result = new ReportingActivity();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "ReviewActivity") {
            let result = new ReviewActivity();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "ToDoProcessActivity") {
            let result = new ToDoProcessActivity();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "StagingTableImportProcessActivity") {
            let result = new StagingTableImportProcessActivity();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'BaseProcessActivity' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["discriminator"] = this._discriminator;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["disabled"] = this.disabled !== undefined ? this.disabled : <any>null;
        data["advanceRule"] = this.advanceRule !== undefined ? this.advanceRule : <any>null;
        return data;
    }

    clone(): BaseProcessActivity {
        throw new Error("The abstract class 'BaseProcessActivity' cannot be instantiated.");
    }
}

export interface IBaseProcessActivity {
    name?: string | null;
    disabled?: boolean | null;
    advanceRule?: AdvanceRule | null;
}

export enum AdvanceRule {
    WhenAllPredecesors = 0,
    WhenFirstPredecesor = 1,
}

export abstract class NonInteractiveProcessActivity extends BaseProcessActivity implements INonInteractiveProcessActivity {
    timeout!: number;

    constructor(data?: INonInteractiveProcessActivity) {
        super(data);
        this._discriminator = "NonInteractiveProcessActivity";
    }

    init(data?: any) {
        super.init(data);
        if (data) {
            this.timeout = data["timeout"] !== undefined ? data["timeout"] : <any>null;
        }
    }

    static fromJS(data: any): NonInteractiveProcessActivity {
        data = typeof data === 'object' ? data : {};
        if (data["discriminator"] === "ADOImportActivity") {
            let result = new ADOImportActivity();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "ADOTriggerActivity") {
            let result = new ADOTriggerActivity();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "AnaplanWorkflowActivity") {
            let result = new AnaplanWorkflowActivity();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "ArchiveXL3ReportActivity") {
            let result = new ArchiveXL3ReportActivity();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "AutomaticFileImportProcessActivity") {
            let result = new AutomaticFileImportProcessActivity();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "AutomaticHierarchySyncProcessActivity") {
            let result = new AutomaticHierarchySyncProcessActivity();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "AzureDataFactoryPipelineActivity") {
            let result = new AzureDataFactoryPipelineActivity();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "ConnectorProcessActivity") {
            let result = new ConnectorProcessActivity();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "DelayProcessActivity") {
            let result = new DelayProcessActivity();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "ExtractHierarchyProcessActivity") {
            let result = new ExtractHierarchyProcessActivity();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "ForeachProcessActivity") {
            let result = new ForeachProcessActivity();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "SubProcessProcessActivity") {
            let result = new SubProcessProcessActivity();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "HttpRequestProcessActivity") {
            let result = new HttpRequestProcessActivity();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "IfProcessActivity") {
            let result = new IfProcessActivity();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "ContainerProcessActivity") {
            throw new Error("The abstract class 'ContainerProcessActivity' cannot be instantiated.");
        }
        if (data["discriminator"] === "LockProcessActivity") {
            let result = new LockProcessActivity();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "LogMessageProcessActivity") {
            let result = new LogMessageProcessActivity();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "ModelDataExportProcessActivity") {
            let result = new ModelDataExportProcessActivity();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "NoteProcessActivity") {
            let result = new NoteProcessActivity();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "PublishModelToAnalysisServicesActivity") {
            let result = new PublishModelToAnalysisServicesActivity();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "RunReportBookProcessActivity") {
            let result = new RunReportBookProcessActivity();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "RunWorkflowProcessActivity") {
            let result = new RunWorkflowProcessActivity();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "ScriptProcessActivity") {
            let result = new ScriptProcessActivity();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "SendEmailProcessActivity") {
            let result = new SendEmailProcessActivity();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "SlackMessageProcessActivity") {
            let result = new SlackMessageProcessActivity();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "SqlServerStoredProcedureProcessActivity") {
            let result = new SqlServerStoredProcedureProcessActivity();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "StartProcessActivity") {
            let result = new StartProcessActivity();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "StopProcessActivity") {
            let result = new StopProcessActivity();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "VenaExportProcessActivity") {
            let result = new VenaExportProcessActivity();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "VenaImportProcessActivity") {
            let result = new VenaImportProcessActivity();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "StagingTableImportProcessActivity") {
            let result = new StagingTableImportProcessActivity();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'NonInteractiveProcessActivity' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["timeout"] = this.timeout !== undefined ? this.timeout : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): NonInteractiveProcessActivity {
        throw new Error("The abstract class 'NonInteractiveProcessActivity' cannot be instantiated.");
    }
}

export interface INonInteractiveProcessActivity extends IBaseProcessActivity {
    timeout: number;
}

export class ADOImportActivity extends NonInteractiveProcessActivity implements IADOImportActivity {
    datasource?: string | null;
    dataspace?: string | null;
    dataset?: string | null;
    tablename?: string | null;

    constructor(data?: IADOImportActivity) {
        super(data);
        this._discriminator = "ADOImportActivity";
    }

    init(data?: any) {
        super.init(data);
        if (data) {
            this.datasource = data["datasource"] !== undefined ? data["datasource"] : <any>null;
            this.dataspace = data["dataspace"] !== undefined ? data["dataspace"] : <any>null;
            this.dataset = data["dataset"] !== undefined ? data["dataset"] : <any>null;
            this.tablename = data["tablename"] !== undefined ? data["tablename"] : <any>null;
        }
    }

    static fromJS(data: any): ADOImportActivity {
        data = typeof data === 'object' ? data : {};
        let result = new ADOImportActivity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["datasource"] = this.datasource !== undefined ? this.datasource : <any>null;
        data["dataspace"] = this.dataspace !== undefined ? this.dataspace : <any>null;
        data["dataset"] = this.dataset !== undefined ? this.dataset : <any>null;
        data["tablename"] = this.tablename !== undefined ? this.tablename : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): ADOImportActivity {
        const json = this.toJSON();
        let result = new ADOImportActivity();
        result.init(json);
        return result;
    }
}

export interface IADOImportActivity extends INonInteractiveProcessActivity {
    datasource?: string | null;
    dataspace?: string | null;
    dataset?: string | null;
    tablename?: string | null;
}

export class ADOTriggerActivity extends NonInteractiveProcessActivity implements IADOTriggerActivity {
    datasource?: string | null;
    actionType?: string | null;
    dataspace?: string | null;
    actionID?: string | null;
    pipelineId?: string | null;

    constructor(data?: IADOTriggerActivity) {
        super(data);
        this._discriminator = "ADOTriggerActivity";
    }

    init(data?: any) {
        super.init(data);
        if (data) {
            this.datasource = data["datasource"] !== undefined ? data["datasource"] : <any>null;
            this.actionType = data["actionType"] !== undefined ? data["actionType"] : <any>null;
            this.dataspace = data["dataspace"] !== undefined ? data["dataspace"] : <any>null;
            this.actionID = data["actionID"] !== undefined ? data["actionID"] : <any>null;
            this.pipelineId = data["pipelineId"] !== undefined ? data["pipelineId"] : <any>null;
        }
    }

    static fromJS(data: any): ADOTriggerActivity {
        data = typeof data === 'object' ? data : {};
        let result = new ADOTriggerActivity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["datasource"] = this.datasource !== undefined ? this.datasource : <any>null;
        data["actionType"] = this.actionType !== undefined ? this.actionType : <any>null;
        data["dataspace"] = this.dataspace !== undefined ? this.dataspace : <any>null;
        data["actionID"] = this.actionID !== undefined ? this.actionID : <any>null;
        data["pipelineId"] = this.pipelineId !== undefined ? this.pipelineId : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): ADOTriggerActivity {
        const json = this.toJSON();
        let result = new ADOTriggerActivity();
        result.init(json);
        return result;
    }
}

export interface IADOTriggerActivity extends INonInteractiveProcessActivity {
    datasource?: string | null;
    actionType?: string | null;
    dataspace?: string | null;
    actionID?: string | null;
    pipelineId?: string | null;
}

export class AnaplanWorkflowActivity extends NonInteractiveProcessActivity implements IAnaplanWorkflowActivity {
    datasource?: string | null;
    workflowID?: string | null;
    waitForCompletion!: boolean;
    workflowName?: string | null;

    constructor(data?: IAnaplanWorkflowActivity) {
        super(data);
        this._discriminator = "AnaplanWorkflowActivity";
    }

    init(data?: any) {
        super.init(data);
        if (data) {
            this.datasource = data["datasource"] !== undefined ? data["datasource"] : <any>null;
            this.workflowID = data["workflowID"] !== undefined ? data["workflowID"] : <any>null;
            this.waitForCompletion = data["waitForCompletion"] !== undefined ? data["waitForCompletion"] : <any>null;
            this.workflowName = data["workflowName"] !== undefined ? data["workflowName"] : <any>null;
        }
    }

    static fromJS(data: any): AnaplanWorkflowActivity {
        data = typeof data === 'object' ? data : {};
        let result = new AnaplanWorkflowActivity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["datasource"] = this.datasource !== undefined ? this.datasource : <any>null;
        data["workflowID"] = this.workflowID !== undefined ? this.workflowID : <any>null;
        data["waitForCompletion"] = this.waitForCompletion !== undefined ? this.waitForCompletion : <any>null;
        data["workflowName"] = this.workflowName !== undefined ? this.workflowName : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): AnaplanWorkflowActivity {
        const json = this.toJSON();
        let result = new AnaplanWorkflowActivity();
        result.init(json);
        return result;
    }
}

export interface IAnaplanWorkflowActivity extends INonInteractiveProcessActivity {
    datasource?: string | null;
    workflowID?: string | null;
    waitForCompletion: boolean;
    workflowName?: string | null;
}

export class ArchiveXL3ReportActivity extends NonInteractiveProcessActivity implements IArchiveXL3ReportActivity {
    dataSource?: string | null;
    share?: string | null;
    folder?: string | null;
    allowOverwrite!: boolean;
    overrideFileName?: string | null;
    useParmName!: boolean;
    format!: ArchiveXL3ReportFormat;
    activityFiles?: ActivityFile[] | null;

    constructor(data?: IArchiveXL3ReportActivity) {
        super(data);
        this._discriminator = "ArchiveXL3ReportActivity";
    }

    init(data?: any) {
        super.init(data);
        if (data) {
            this.dataSource = data["dataSource"] !== undefined ? data["dataSource"] : <any>null;
            this.share = data["share"] !== undefined ? data["share"] : <any>null;
            this.folder = data["folder"] !== undefined ? data["folder"] : <any>null;
            this.allowOverwrite = data["allowOverwrite"] !== undefined ? data["allowOverwrite"] : <any>null;
            this.overrideFileName = data["overrideFileName"] !== undefined ? data["overrideFileName"] : <any>null;
            this.useParmName = data["useParmName"] !== undefined ? data["useParmName"] : <any>null;
            this.format = data["format"] !== undefined ? data["format"] : <any>null;
            if (Array.isArray(data["activityFiles"])) {
                this.activityFiles = [] as any;
                for (let item in data["activityFiles"])
                    this.activityFiles!.push(ActivityFile.fromJS(data["activityFiles"][item]));
            }
            else {
                this.activityFiles = <any>null;
            }
        }
    }

    static fromJS(data: any): ArchiveXL3ReportActivity {
        data = typeof data === 'object' ? data : {};
        let result = new ArchiveXL3ReportActivity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dataSource"] = this.dataSource !== undefined ? this.dataSource : <any>null;
        data["share"] = this.share !== undefined ? this.share : <any>null;
        data["folder"] = this.folder !== undefined ? this.folder : <any>null;
        data["allowOverwrite"] = this.allowOverwrite !== undefined ? this.allowOverwrite : <any>null;
        data["overrideFileName"] = this.overrideFileName !== undefined ? this.overrideFileName : <any>null;
        data["useParmName"] = this.useParmName !== undefined ? this.useParmName : <any>null;
        data["format"] = this.format !== undefined ? this.format : <any>null;
        if (Array.isArray(this.activityFiles)) {
            data["activityFiles"] = [];
            for (let item in this.activityFiles)
                data["activityFiles"].push(this.activityFiles[item].toJSON());
        }
        super.toJSON(data);
        return data;
    }

    clone(): ArchiveXL3ReportActivity {
        const json = this.toJSON();
        let result = new ArchiveXL3ReportActivity();
        result.init(json);
        return result;
    }
}

export interface IArchiveXL3ReportActivity extends INonInteractiveProcessActivity {
    dataSource?: string | null;
    share?: string | null;
    folder?: string | null;
    allowOverwrite: boolean;
    overrideFileName?: string | null;
    useParmName: boolean;
    format: ArchiveXL3ReportFormat;
    activityFiles?: ActivityFile[] | null;
}

export class ActivityFile implements IActivityFile {
    name?: string | null;
    path?: string | null;
    objectType!: FileSystemType;
    description?: string | null;
    outputOverride?: BookOutput | null;
    destinationOverride?: string | null;
    parameters?: KeyValuePairOfStringAndString[] | null;
    newParameters?: FormParameterList | null;

    constructor(data?: IActivityFile) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"] !== undefined ? data["name"] : <any>null;
            this.path = data["path"] !== undefined ? data["path"] : <any>null;
            this.objectType = data["objectType"] !== undefined ? data["objectType"] : <any>null;
            this.description = data["description"] !== undefined ? data["description"] : <any>null;
            this.outputOverride = data["outputOverride"] !== undefined ? data["outputOverride"] : <any>null;
            this.destinationOverride = data["destinationOverride"] !== undefined ? data["destinationOverride"] : <any>null;
            if (Array.isArray(data["parameters"])) {
                this.parameters = [] as any;
                for (let item in data["parameters"])
                    this.parameters!.push(KeyValuePairOfStringAndString.fromJS(data["parameters"][item]));
            }
            else {
                this.parameters = <any>null;
            }
            this.newParameters = data["newParameters"] ? FormParameterList.fromJS(data["newParameters"]) : <any>null;
        }
    }

    static fromJS(data: any): ActivityFile {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityFile();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["path"] = this.path !== undefined ? this.path : <any>null;
        data["objectType"] = this.objectType !== undefined ? this.objectType : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["outputOverride"] = this.outputOverride !== undefined ? this.outputOverride : <any>null;
        data["destinationOverride"] = this.destinationOverride !== undefined ? this.destinationOverride : <any>null;
        if (Array.isArray(this.parameters)) {
            data["parameters"] = [];
            for (let item in this.parameters)
                data["parameters"].push(this.parameters[item].toJSON());
        }
        data["newParameters"] = this.newParameters ? this.newParameters.toJSON() : <any>null;
        return data;
    }

    clone(): ActivityFile {
        const json = this.toJSON();
        let result = new ActivityFile();
        result.init(json);
        return result;
    }
}

export interface IActivityFile {
    name?: string | null;
    path?: string | null;
    objectType: FileSystemType;
    description?: string | null;
    outputOverride?: BookOutput | null;
    destinationOverride?: string | null;
    parameters?: KeyValuePairOfStringAndString[] | null;
    newParameters?: FormParameterList | null;
}

export enum BookOutput {
    Email = 0,
    File = 1,
    Slack = 2,
}

export class KeyValuePairOfStringAndString implements IKeyValuePairOfStringAndString {
    key?: string | null;
    value?: string | null;

    constructor(data?: IKeyValuePairOfStringAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.key = data["key"] !== undefined ? data["key"] : <any>null;
            this.value = data["value"] !== undefined ? data["value"] : <any>null;
        }
    }

    static fromJS(data: any): KeyValuePairOfStringAndString {
        data = typeof data === 'object' ? data : {};
        let result = new KeyValuePairOfStringAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key !== undefined ? this.key : <any>null;
        data["value"] = this.value !== undefined ? this.value : <any>null;
        return data;
    }

    clone(): KeyValuePairOfStringAndString {
        const json = this.toJSON();
        let result = new KeyValuePairOfStringAndString();
        result.init(json);
        return result;
    }
}

export interface IKeyValuePairOfStringAndString {
    key?: string | null;
    value?: string | null;
}

export class AutomaticFileImportProcessActivity extends NonInteractiveProcessActivity implements IAutomaticFileImportProcessActivity {
    tableName?: string | null;
    dataSource?: string | null;
    share?: string | null;
    folder?: string | null;
    fileName?: string | null;
    query?: string | null;

    constructor(data?: IAutomaticFileImportProcessActivity) {
        super(data);
        this._discriminator = "AutomaticFileImportProcessActivity";
    }

    init(data?: any) {
        super.init(data);
        if (data) {
            this.tableName = data["tableName"] !== undefined ? data["tableName"] : <any>null;
            this.dataSource = data["dataSource"] !== undefined ? data["dataSource"] : <any>null;
            this.share = data["share"] !== undefined ? data["share"] : <any>null;
            this.folder = data["folder"] !== undefined ? data["folder"] : <any>null;
            this.fileName = data["fileName"] !== undefined ? data["fileName"] : <any>null;
            this.query = data["query"] !== undefined ? data["query"] : <any>null;
        }
    }

    static fromJS(data: any): AutomaticFileImportProcessActivity {
        data = typeof data === 'object' ? data : {};
        let result = new AutomaticFileImportProcessActivity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tableName"] = this.tableName !== undefined ? this.tableName : <any>null;
        data["dataSource"] = this.dataSource !== undefined ? this.dataSource : <any>null;
        data["share"] = this.share !== undefined ? this.share : <any>null;
        data["folder"] = this.folder !== undefined ? this.folder : <any>null;
        data["fileName"] = this.fileName !== undefined ? this.fileName : <any>null;
        data["query"] = this.query !== undefined ? this.query : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): AutomaticFileImportProcessActivity {
        const json = this.toJSON();
        let result = new AutomaticFileImportProcessActivity();
        result.init(json);
        return result;
    }
}

export interface IAutomaticFileImportProcessActivity extends INonInteractiveProcessActivity {
    tableName?: string | null;
    dataSource?: string | null;
    share?: string | null;
    folder?: string | null;
    fileName?: string | null;
    query?: string | null;
}

export class AutomaticHierarchySyncProcessActivity extends NonInteractiveProcessActivity implements IAutomaticHierarchySyncProcessActivity {
    dataSource?: string | null;
    share?: string | null;
    folder?: string | null;
    fileName?: string | null;
    stagingTable?: string | null;
    explorerLogPath?: string | null;
    dimensionName?: string | null;
    hierarchyName?: string | null;
    simulationMode!: boolean;
    reAssignMembers!: boolean;
    syncMode!: HierarchySyncMode;
    propertiesMode?: HierarchyPropertiesMode | null;

    constructor(data?: IAutomaticHierarchySyncProcessActivity) {
        super(data);
        this._discriminator = "AutomaticHierarchySyncProcessActivity";
    }

    init(data?: any) {
        super.init(data);
        if (data) {
            this.dataSource = data["dataSource"] !== undefined ? data["dataSource"] : <any>null;
            this.share = data["share"] !== undefined ? data["share"] : <any>null;
            this.folder = data["folder"] !== undefined ? data["folder"] : <any>null;
            this.fileName = data["fileName"] !== undefined ? data["fileName"] : <any>null;
            this.stagingTable = data["stagingTable"] !== undefined ? data["stagingTable"] : <any>null;
            this.explorerLogPath = data["explorerLogPath"] !== undefined ? data["explorerLogPath"] : <any>null;
            this.dimensionName = data["dimensionName"] !== undefined ? data["dimensionName"] : <any>null;
            this.hierarchyName = data["hierarchyName"] !== undefined ? data["hierarchyName"] : <any>null;
            this.simulationMode = data["simulationMode"] !== undefined ? data["simulationMode"] : <any>null;
            this.reAssignMembers = data["reAssignMembers"] !== undefined ? data["reAssignMembers"] : <any>null;
            this.syncMode = data["syncMode"] !== undefined ? data["syncMode"] : <any>null;
            this.propertiesMode = data["propertiesMode"] !== undefined ? data["propertiesMode"] : <any>null;
        }
    }

    static fromJS(data: any): AutomaticHierarchySyncProcessActivity {
        data = typeof data === 'object' ? data : {};
        let result = new AutomaticHierarchySyncProcessActivity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dataSource"] = this.dataSource !== undefined ? this.dataSource : <any>null;
        data["share"] = this.share !== undefined ? this.share : <any>null;
        data["folder"] = this.folder !== undefined ? this.folder : <any>null;
        data["fileName"] = this.fileName !== undefined ? this.fileName : <any>null;
        data["stagingTable"] = this.stagingTable !== undefined ? this.stagingTable : <any>null;
        data["explorerLogPath"] = this.explorerLogPath !== undefined ? this.explorerLogPath : <any>null;
        data["dimensionName"] = this.dimensionName !== undefined ? this.dimensionName : <any>null;
        data["hierarchyName"] = this.hierarchyName !== undefined ? this.hierarchyName : <any>null;
        data["simulationMode"] = this.simulationMode !== undefined ? this.simulationMode : <any>null;
        data["reAssignMembers"] = this.reAssignMembers !== undefined ? this.reAssignMembers : <any>null;
        data["syncMode"] = this.syncMode !== undefined ? this.syncMode : <any>null;
        data["propertiesMode"] = this.propertiesMode !== undefined ? this.propertiesMode : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): AutomaticHierarchySyncProcessActivity {
        const json = this.toJSON();
        let result = new AutomaticHierarchySyncProcessActivity();
        result.init(json);
        return result;
    }
}

export interface IAutomaticHierarchySyncProcessActivity extends INonInteractiveProcessActivity {
    dataSource?: string | null;
    share?: string | null;
    folder?: string | null;
    fileName?: string | null;
    stagingTable?: string | null;
    explorerLogPath?: string | null;
    dimensionName?: string | null;
    hierarchyName?: string | null;
    simulationMode: boolean;
    reAssignMembers: boolean;
    syncMode: HierarchySyncMode;
    propertiesMode?: HierarchyPropertiesMode | null;
}

export enum HierarchyPropertiesMode {
    IncludePropertiesInSyncSource = 0,
    ExcludeAllProperties = 1,
    AllPropertiesRequired = 2,
}

export class AzureDataFactoryPipelineActivity extends NonInteractiveProcessActivity implements IAzureDataFactoryPipelineActivity {
    dataSource?: string | null;
    resourceGroupName?: string | null;
    dataFactoryName?: string | null;
    pipelineName?: string | null;
    parameters?: PipelineParameter[] | null;

    constructor(data?: IAzureDataFactoryPipelineActivity) {
        super(data);
        this._discriminator = "AzureDataFactoryPipelineActivity";
    }

    init(data?: any) {
        super.init(data);
        if (data) {
            this.dataSource = data["dataSource"] !== undefined ? data["dataSource"] : <any>null;
            this.resourceGroupName = data["resourceGroupName"] !== undefined ? data["resourceGroupName"] : <any>null;
            this.dataFactoryName = data["dataFactoryName"] !== undefined ? data["dataFactoryName"] : <any>null;
            this.pipelineName = data["pipelineName"] !== undefined ? data["pipelineName"] : <any>null;
            if (Array.isArray(data["parameters"])) {
                this.parameters = [] as any;
                for (let item in data["parameters"])
                    this.parameters!.push(PipelineParameter.fromJS(data["parameters"][item]));
            }
            else {
                this.parameters = <any>null;
            }
        }
    }

    static fromJS(data: any): AzureDataFactoryPipelineActivity {
        data = typeof data === 'object' ? data : {};
        let result = new AzureDataFactoryPipelineActivity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dataSource"] = this.dataSource !== undefined ? this.dataSource : <any>null;
        data["resourceGroupName"] = this.resourceGroupName !== undefined ? this.resourceGroupName : <any>null;
        data["dataFactoryName"] = this.dataFactoryName !== undefined ? this.dataFactoryName : <any>null;
        data["pipelineName"] = this.pipelineName !== undefined ? this.pipelineName : <any>null;
        if (Array.isArray(this.parameters)) {
            data["parameters"] = [];
            for (let item in this.parameters)
                data["parameters"].push(this.parameters[item].toJSON());
        }
        super.toJSON(data);
        return data;
    }

    clone(): AzureDataFactoryPipelineActivity {
        const json = this.toJSON();
        let result = new AzureDataFactoryPipelineActivity();
        result.init(json);
        return result;
    }
}

export interface IAzureDataFactoryPipelineActivity extends INonInteractiveProcessActivity {
    dataSource?: string | null;
    resourceGroupName?: string | null;
    dataFactoryName?: string | null;
    pipelineName?: string | null;
    parameters?: PipelineParameter[] | null;
}

export class PipelineParameter implements IPipelineParameter {
    key?: string | null;
    value?: string | null;

    constructor(data?: IPipelineParameter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.key = data["key"] !== undefined ? data["key"] : <any>null;
            this.value = data["value"] !== undefined ? data["value"] : <any>null;
        }
    }

    static fromJS(data: any): PipelineParameter {
        data = typeof data === 'object' ? data : {};
        let result = new PipelineParameter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key !== undefined ? this.key : <any>null;
        data["value"] = this.value !== undefined ? this.value : <any>null;
        return data;
    }

    clone(): PipelineParameter {
        const json = this.toJSON();
        let result = new PipelineParameter();
        result.init(json);
        return result;
    }
}

export interface IPipelineParameter {
    key?: string | null;
    value?: string | null;
}

export class ConnectorProcessActivity extends NonInteractiveProcessActivity implements IConnectorProcessActivity {

    constructor(data?: IConnectorProcessActivity) {
        super(data);
        this._discriminator = "ConnectorProcessActivity";
    }

    init(data?: any) {
        super.init(data);
    }

    static fromJS(data: any): ConnectorProcessActivity {
        data = typeof data === 'object' ? data : {};
        let result = new ConnectorProcessActivity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }

    clone(): ConnectorProcessActivity {
        const json = this.toJSON();
        let result = new ConnectorProcessActivity();
        result.init(json);
        return result;
    }
}

export interface IConnectorProcessActivity extends INonInteractiveProcessActivity {
}

export class DelayProcessActivity extends NonInteractiveProcessActivity implements IDelayProcessActivity {
    timeInSeconds!: number;

    constructor(data?: IDelayProcessActivity) {
        super(data);
        this._discriminator = "DelayProcessActivity";
    }

    init(data?: any) {
        super.init(data);
        if (data) {
            this.timeInSeconds = data["timeInSeconds"] !== undefined ? data["timeInSeconds"] : <any>null;
        }
    }

    static fromJS(data: any): DelayProcessActivity {
        data = typeof data === 'object' ? data : {};
        let result = new DelayProcessActivity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["timeInSeconds"] = this.timeInSeconds !== undefined ? this.timeInSeconds : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): DelayProcessActivity {
        const json = this.toJSON();
        let result = new DelayProcessActivity();
        result.init(json);
        return result;
    }
}

export interface IDelayProcessActivity extends INonInteractiveProcessActivity {
    timeInSeconds: number;
}

export class ExtractHierarchyProcessActivity extends NonInteractiveProcessActivity implements IExtractHierarchyProcessActivity {
    extractID!: number;
    destinationStagingTable!: DestinationStagingTableType;
    destination!: DestinationType;
    prefix?: string | null;
    suffix?: string | null;
    override?: string | null;

    constructor(data?: IExtractHierarchyProcessActivity) {
        super(data);
        this._discriminator = "ExtractHierarchyProcessActivity";
    }

    init(data?: any) {
        super.init(data);
        if (data) {
            this.extractID = data["extractID"] !== undefined ? data["extractID"] : <any>null;
            this.destinationStagingTable = data["destinationStagingTable"] !== undefined ? data["destinationStagingTable"] : <any>null;
            this.destination = data["destination"] !== undefined ? data["destination"] : <any>null;
            this.prefix = data["prefix"] !== undefined ? data["prefix"] : <any>null;
            this.suffix = data["suffix"] !== undefined ? data["suffix"] : <any>null;
            this.override = data["override"] !== undefined ? data["override"] : <any>null;
        }
    }

    static fromJS(data: any): ExtractHierarchyProcessActivity {
        data = typeof data === 'object' ? data : {};
        let result = new ExtractHierarchyProcessActivity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["extractID"] = this.extractID !== undefined ? this.extractID : <any>null;
        data["destinationStagingTable"] = this.destinationStagingTable !== undefined ? this.destinationStagingTable : <any>null;
        data["destination"] = this.destination !== undefined ? this.destination : <any>null;
        data["prefix"] = this.prefix !== undefined ? this.prefix : <any>null;
        data["suffix"] = this.suffix !== undefined ? this.suffix : <any>null;
        data["override"] = this.override !== undefined ? this.override : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): ExtractHierarchyProcessActivity {
        const json = this.toJSON();
        let result = new ExtractHierarchyProcessActivity();
        result.init(json);
        return result;
    }
}

export interface IExtractHierarchyProcessActivity extends INonInteractiveProcessActivity {
    extractID: number;
    destinationStagingTable: DestinationStagingTableType;
    destination: DestinationType;
    prefix?: string | null;
    suffix?: string | null;
    override?: string | null;
}

export enum DestinationStagingTableType {
    AutoCreate = 0,
    AutoCreateWithPrefixSuffix = 1,
    Override = 2,
}

export enum DestinationType {
    StagingTableOnly = 0,
}

export class SubProcessProcessActivity extends NonInteractiveProcessActivity implements ISubProcessProcessActivity {
    subProcess?: InteractiveProcess | null;

    constructor(data?: ISubProcessProcessActivity) {
        super(data);
        this._discriminator = "SubProcessProcessActivity";
    }

    init(data?: any) {
        super.init(data);
        if (data) {
            this.subProcess = data["subProcess"] ? InteractiveProcess.fromJS(data["subProcess"]) : <any>null;
        }
    }

    static fromJS(data: any): SubProcessProcessActivity {
        data = typeof data === 'object' ? data : {};
        if (data["discriminator"] === "ForeachProcessActivity") {
            let result = new ForeachProcessActivity();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "LockProcessActivity") {
            let result = new LockProcessActivity();
            result.init(data);
            return result;
        }
        let result = new SubProcessProcessActivity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subProcess"] = this.subProcess ? this.subProcess.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): SubProcessProcessActivity {
        const json = this.toJSON();
        let result = new SubProcessProcessActivity();
        result.init(json);
        return result;
    }
}

export interface ISubProcessProcessActivity extends INonInteractiveProcessActivity {
    subProcess?: InteractiveProcess | null;
}

export class ForeachProcessActivity extends SubProcessProcessActivity implements IForeachProcessActivity {
    dimensionQuery?: DimensionQuery | null;

    constructor(data?: IForeachProcessActivity) {
        super(data);
        this._discriminator = "ForeachProcessActivity";
    }

    init(data?: any) {
        super.init(data);
        if (data) {
            this.dimensionQuery = data["dimensionQuery"] ? DimensionQuery.fromJS(data["dimensionQuery"]) : <any>null;
        }
    }

    static fromJS(data: any): ForeachProcessActivity {
        data = typeof data === 'object' ? data : {};
        let result = new ForeachProcessActivity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dimensionQuery"] = this.dimensionQuery ? this.dimensionQuery.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): ForeachProcessActivity {
        const json = this.toJSON();
        let result = new ForeachProcessActivity();
        result.init(json);
        return result;
    }
}

export interface IForeachProcessActivity extends ISubProcessProcessActivity {
    dimensionQuery?: DimensionQuery | null;
}

export class Query extends BaseElement implements IQuery {
    source?: string | null;

    constructor(data?: IQuery) {
        super(data);
    }

    init(data?: any) {
        super.init(data);
        if (data) {
            this.source = data["source"] !== undefined ? data["source"] : <any>null;
        }
    }

    static fromJS(data: any): Query {
        data = typeof data === 'object' ? data : {};
        let result = new Query();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["source"] = this.source !== undefined ? this.source : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): Query {
        const json = this.toJSON();
        let result = new Query();
        result.init(json);
        return result;
    }
}

export interface IQuery extends IBaseElement {
    source?: string | null;
}

export class DimensionQuery extends Query implements IDimensionQuery {
    dimension?: string | null;
    model?: string | null;
    dimensionRole?: string | null;
    hierarchy?: string | null;
    ordering?: string | null;
    effectiveDate?: string | null;
    securityProfile?: string | null;
    securityProfileType?: string | null;
    securityModel?: string | null;
    securityForDimensionEmpty?: string | null;
    querySpec?: HierarchicalSpec | null;
    text?: string | null;
    queryTextLanguage?: string | null;
    attributes?: Attribute[] | null;
    isResolved!: boolean;

    constructor(data?: IDimensionQuery) {
        super(data);
    }

    init(data?: any) {
        super.init(data);
        if (data) {
            this.dimension = data["dimension"] !== undefined ? data["dimension"] : <any>null;
            this.model = data["model"] !== undefined ? data["model"] : <any>null;
            this.dimensionRole = data["dimensionRole"] !== undefined ? data["dimensionRole"] : <any>null;
            this.hierarchy = data["hierarchy"] !== undefined ? data["hierarchy"] : <any>null;
            this.ordering = data["ordering"] !== undefined ? data["ordering"] : <any>null;
            this.effectiveDate = data["effectiveDate"] !== undefined ? data["effectiveDate"] : <any>null;
            this.securityProfile = data["securityProfile"] !== undefined ? data["securityProfile"] : <any>null;
            this.securityProfileType = data["securityProfileType"] !== undefined ? data["securityProfileType"] : <any>null;
            this.securityModel = data["securityModel"] !== undefined ? data["securityModel"] : <any>null;
            this.securityForDimensionEmpty = data["securityForDimensionEmpty"] !== undefined ? data["securityForDimensionEmpty"] : <any>null;
            this.querySpec = data["querySpec"] ? HierarchicalSpec.fromJS(data["querySpec"]) : <any>null;
            this.text = data["text"] !== undefined ? data["text"] : <any>null;
            this.queryTextLanguage = data["queryTextLanguage"] !== undefined ? data["queryTextLanguage"] : <any>null;
            if (Array.isArray(data["attributes"])) {
                this.attributes = [] as any;
                for (let item in data["attributes"])
                    this.attributes!.push(Attribute.fromJS(data["attributes"][item]));
            }
            else {
                this.attributes = <any>null;
            }
            this.isResolved = data["isResolved"] !== undefined ? data["isResolved"] : <any>null;
        }
    }

    static fromJS(data: any): DimensionQuery {
        data = typeof data === 'object' ? data : {};
        let result = new DimensionQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dimension"] = this.dimension !== undefined ? this.dimension : <any>null;
        data["model"] = this.model !== undefined ? this.model : <any>null;
        data["dimensionRole"] = this.dimensionRole !== undefined ? this.dimensionRole : <any>null;
        data["hierarchy"] = this.hierarchy !== undefined ? this.hierarchy : <any>null;
        data["ordering"] = this.ordering !== undefined ? this.ordering : <any>null;
        data["effectiveDate"] = this.effectiveDate !== undefined ? this.effectiveDate : <any>null;
        data["securityProfile"] = this.securityProfile !== undefined ? this.securityProfile : <any>null;
        data["securityProfileType"] = this.securityProfileType !== undefined ? this.securityProfileType : <any>null;
        data["securityModel"] = this.securityModel !== undefined ? this.securityModel : <any>null;
        data["securityForDimensionEmpty"] = this.securityForDimensionEmpty !== undefined ? this.securityForDimensionEmpty : <any>null;
        data["querySpec"] = this.querySpec ? this.querySpec.toJSON() : <any>null;
        data["text"] = this.text !== undefined ? this.text : <any>null;
        data["queryTextLanguage"] = this.queryTextLanguage !== undefined ? this.queryTextLanguage : <any>null;
        if (Array.isArray(this.attributes)) {
            data["attributes"] = [];
            for (let item in this.attributes)
                data["attributes"].push(this.attributes[item].toJSON());
        }
        data["isResolved"] = this.isResolved !== undefined ? this.isResolved : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): DimensionQuery {
        const json = this.toJSON();
        let result = new DimensionQuery();
        result.init(json);
        return result;
    }
}

export interface IDimensionQuery extends IQuery {
    dimension?: string | null;
    model?: string | null;
    dimensionRole?: string | null;
    hierarchy?: string | null;
    ordering?: string | null;
    effectiveDate?: string | null;
    securityProfile?: string | null;
    securityProfileType?: string | null;
    securityModel?: string | null;
    securityForDimensionEmpty?: string | null;
    querySpec?: HierarchicalSpec | null;
    text?: string | null;
    queryTextLanguage?: string | null;
    attributes?: Attribute[] | null;
    isResolved: boolean;
}

export class Attribute extends BaseElement implements IAttribute {
    dimension?: string | null;
    dimensionRole?: string | null;

    constructor(data?: IAttribute) {
        super(data);
    }

    init(data?: any) {
        super.init(data);
        if (data) {
            this.dimension = data["dimension"] !== undefined ? data["dimension"] : <any>null;
            this.dimensionRole = data["dimensionRole"] !== undefined ? data["dimensionRole"] : <any>null;
        }
    }

    static fromJS(data: any): Attribute {
        data = typeof data === 'object' ? data : {};
        let result = new Attribute();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dimension"] = this.dimension !== undefined ? this.dimension : <any>null;
        data["dimensionRole"] = this.dimensionRole !== undefined ? this.dimensionRole : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): Attribute {
        const json = this.toJSON();
        let result = new Attribute();
        result.init(json);
        return result;
    }
}

export interface IAttribute extends IBaseElement {
    dimension?: string | null;
    dimensionRole?: string | null;
}

export class InteractiveProcess implements IInteractiveProcess {
    nodes?: InteractiveProcessNode[] | null;
    edges?: InteractiveProcessEdge[] | null;
    startProperties?: InteractiveProcessStartProperties | null;

    constructor(data?: IInteractiveProcess) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (Array.isArray(data["nodes"])) {
                this.nodes = [] as any;
                for (let item in data["nodes"])
                    this.nodes!.push(InteractiveProcessNode.fromJS(data["nodes"][item]));
            }
            else {
                this.nodes = <any>null;
            }
            if (Array.isArray(data["edges"])) {
                this.edges = [] as any;
                for (let item in data["edges"])
                    this.edges!.push(InteractiveProcessEdge.fromJS(data["edges"][item]));
            }
            else {
                this.edges = <any>null;
            }
            this.startProperties = data["startProperties"] ? InteractiveProcessStartProperties.fromJS(data["startProperties"]) : <any>null;
        }
    }

    static fromJS(data: any): InteractiveProcess {
        data = typeof data === 'object' ? data : {};
        let result = new InteractiveProcess();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.nodes)) {
            data["nodes"] = [];
            for (let item in this.nodes)
                data["nodes"].push(this.nodes[item].toJSON());
        }
        if (Array.isArray(this.edges)) {
            data["edges"] = [];
            for (let item in this.edges)
                data["edges"].push(this.edges[item].toJSON());
        }
        data["startProperties"] = this.startProperties ? this.startProperties.toJSON() : <any>null;
        return data;
    }

    clone(): InteractiveProcess {
        const json = this.toJSON();
        let result = new InteractiveProcess();
        result.init(json);
        return result;
    }
}

export interface IInteractiveProcess {
    nodes?: InteractiveProcessNode[] | null;
    edges?: InteractiveProcessEdge[] | null;
    startProperties?: InteractiveProcessStartProperties | null;
}

export class InteractiveProcessNode implements IInteractiveProcessNode {
    id?: string | null;
    left!: number;
    top!: number;
    w!: number;
    h!: number;
    type?: string | null;
    text?: string | null;
    state?: string | null;
    percent?: number | null;
    activity?: BaseProcessActivity | null;

    constructor(data?: IInteractiveProcessNode) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"] !== undefined ? data["id"] : <any>null;
            this.left = data["left"] !== undefined ? data["left"] : <any>null;
            this.top = data["top"] !== undefined ? data["top"] : <any>null;
            this.w = data["w"] !== undefined ? data["w"] : <any>null;
            this.h = data["h"] !== undefined ? data["h"] : <any>null;
            this.type = data["type"] !== undefined ? data["type"] : <any>null;
            this.text = data["text"] !== undefined ? data["text"] : <any>null;
            this.state = data["state"] !== undefined ? data["state"] : <any>null;
            this.percent = data["percent"] !== undefined ? data["percent"] : <any>null;
            this.activity = data["activity"] ? BaseProcessActivity.fromJS(data["activity"]) : <any>null;
        }
    }

    static fromJS(data: any): InteractiveProcessNode {
        data = typeof data === 'object' ? data : {};
        let result = new InteractiveProcessNode();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["left"] = this.left !== undefined ? this.left : <any>null;
        data["top"] = this.top !== undefined ? this.top : <any>null;
        data["w"] = this.w !== undefined ? this.w : <any>null;
        data["h"] = this.h !== undefined ? this.h : <any>null;
        data["type"] = this.type !== undefined ? this.type : <any>null;
        data["text"] = this.text !== undefined ? this.text : <any>null;
        data["state"] = this.state !== undefined ? this.state : <any>null;
        data["percent"] = this.percent !== undefined ? this.percent : <any>null;
        data["activity"] = this.activity ? this.activity.toJSON() : <any>null;
        return data;
    }

    clone(): InteractiveProcessNode {
        const json = this.toJSON();
        let result = new InteractiveProcessNode();
        result.init(json);
        return result;
    }
}

export interface IInteractiveProcessNode {
    id?: string | null;
    left: number;
    top: number;
    w: number;
    h: number;
    type?: string | null;
    text?: string | null;
    state?: string | null;
    percent?: number | null;
    activity?: BaseProcessActivity | null;
}

export class InteractiveProcessEdge implements IInteractiveProcessEdge {
    source?: string | null;
    target?: string | null;
    data?: InteractiveProcessEdgeData | null;
    geometry?: InteractiveProcessEdgeGeometryData | null;

    constructor(data?: IInteractiveProcessEdge) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.source = data["source"] !== undefined ? data["source"] : <any>null;
            this.target = data["target"] !== undefined ? data["target"] : <any>null;
            this.data = data["data"] ? InteractiveProcessEdgeData.fromJS(data["data"]) : <any>null;
            this.geometry = data["geometry"] ? InteractiveProcessEdgeGeometryData.fromJS(data["geometry"]) : <any>null;
        }
    }

    static fromJS(data: any): InteractiveProcessEdge {
        data = typeof data === 'object' ? data : {};
        let result = new InteractiveProcessEdge();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["source"] = this.source !== undefined ? this.source : <any>null;
        data["target"] = this.target !== undefined ? this.target : <any>null;
        data["data"] = this.data ? this.data.toJSON() : <any>null;
        data["geometry"] = this.geometry ? this.geometry.toJSON() : <any>null;
        return data;
    }

    clone(): InteractiveProcessEdge {
        const json = this.toJSON();
        let result = new InteractiveProcessEdge();
        result.init(json);
        return result;
    }
}

export interface IInteractiveProcessEdge {
    source?: string | null;
    target?: string | null;
    data?: InteractiveProcessEdgeData | null;
    geometry?: InteractiveProcessEdgeGeometryData | null;
}

export class InteractiveProcessEdgeData implements IInteractiveProcessEdgeData {
    label?: string | null;
    id?: string | null;
    type?: string | null;

    constructor(data?: IInteractiveProcessEdgeData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.label = data["label"] !== undefined ? data["label"] : <any>null;
            this.id = data["id"] !== undefined ? data["id"] : <any>null;
            this.type = data["type"] !== undefined ? data["type"] : <any>null;
        }
    }

    static fromJS(data: any): InteractiveProcessEdgeData {
        data = typeof data === 'object' ? data : {};
        let result = new InteractiveProcessEdgeData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["label"] = this.label !== undefined ? this.label : <any>null;
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["type"] = this.type !== undefined ? this.type : <any>null;
        return data;
    }

    clone(): InteractiveProcessEdgeData {
        const json = this.toJSON();
        let result = new InteractiveProcessEdgeData();
        result.init(json);
        return result;
    }
}

export interface IInteractiveProcessEdgeData {
    label?: string | null;
    id?: string | null;
    type?: string | null;
}

export class InteractiveProcessEdgeGeometryData implements IInteractiveProcessEdgeGeometryData {
    segments?: number[][] | null;
    source?: number[] | null;
    target?: number[] | null;

    constructor(data?: IInteractiveProcessEdgeGeometryData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (Array.isArray(data["segments"])) {
                this.segments = [] as any;
                for (let item in data["segments"])
                    this.segments!.push(data["segments"][item]);
            }
            else {
                this.segments = <any>null;
            }
            if (Array.isArray(data["source"])) {
                this.source = [] as any;
                for (let item in data["source"])
                    this.source!.push(data["source"][item]);
            }
            else {
                this.source = <any>null;
            }
            if (Array.isArray(data["target"])) {
                this.target = [] as any;
                for (let item in data["target"])
                    this.target!.push(data["target"][item]);
            }
            else {
                this.target = <any>null;
            }
        }
    }

    static fromJS(data: any): InteractiveProcessEdgeGeometryData {
        data = typeof data === 'object' ? data : {};
        let result = new InteractiveProcessEdgeGeometryData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.segments)) {
            data["segments"] = [];
            for (let item in this.segments)
                data["segments"].push(this.segments[item]);
        }
        if (Array.isArray(this.source)) {
            data["source"] = [];
            for (let item in this.source)
                data["source"].push(this.source[item]);
        }
        if (Array.isArray(this.target)) {
            data["target"] = [];
            for (let item in this.target)
                data["target"].push(this.target[item]);
        }
        return data;
    }

    clone(): InteractiveProcessEdgeGeometryData {
        const json = this.toJSON();
        let result = new InteractiveProcessEdgeGeometryData();
        result.init(json);
        return result;
    }
}

export interface IInteractiveProcessEdgeGeometryData {
    segments?: number[][] | null;
    source?: number[] | null;
    target?: number[] | null;
}

export class InteractiveProcessStartProperties implements IInteractiveProcessStartProperties {
    dueDate?: string | null;
    processPropertiesFormPath?: string | null;

    constructor(data?: IInteractiveProcessStartProperties) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.dueDate = data["dueDate"] !== undefined ? data["dueDate"] : <any>null;
            this.processPropertiesFormPath = data["processPropertiesFormPath"] !== undefined ? data["processPropertiesFormPath"] : <any>null;
        }
    }

    static fromJS(data: any): InteractiveProcessStartProperties {
        data = typeof data === 'object' ? data : {};
        let result = new InteractiveProcessStartProperties();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dueDate"] = this.dueDate !== undefined ? this.dueDate : <any>null;
        data["processPropertiesFormPath"] = this.processPropertiesFormPath !== undefined ? this.processPropertiesFormPath : <any>null;
        return data;
    }

    clone(): InteractiveProcessStartProperties {
        const json = this.toJSON();
        let result = new InteractiveProcessStartProperties();
        result.init(json);
        return result;
    }
}

export interface IInteractiveProcessStartProperties {
    dueDate?: string | null;
    processPropertiesFormPath?: string | null;
}

export class HttpRequestProcessActivity extends NonInteractiveProcessActivity implements IHttpRequestProcessActivity {
    dataSource?: string | null;
    verb!: HttpRequestProcessActivityVerb;
    path?: string | null;
    content?: string | null;
    resultStore?: string | null;

    constructor(data?: IHttpRequestProcessActivity) {
        super(data);
        this._discriminator = "HttpRequestProcessActivity";
    }

    init(data?: any) {
        super.init(data);
        if (data) {
            this.dataSource = data["dataSource"] !== undefined ? data["dataSource"] : <any>null;
            this.verb = data["verb"] !== undefined ? data["verb"] : <any>null;
            this.path = data["path"] !== undefined ? data["path"] : <any>null;
            this.content = data["content"] !== undefined ? data["content"] : <any>null;
            this.resultStore = data["resultStore"] !== undefined ? data["resultStore"] : <any>null;
        }
    }

    static fromJS(data: any): HttpRequestProcessActivity {
        data = typeof data === 'object' ? data : {};
        let result = new HttpRequestProcessActivity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dataSource"] = this.dataSource !== undefined ? this.dataSource : <any>null;
        data["verb"] = this.verb !== undefined ? this.verb : <any>null;
        data["path"] = this.path !== undefined ? this.path : <any>null;
        data["content"] = this.content !== undefined ? this.content : <any>null;
        data["resultStore"] = this.resultStore !== undefined ? this.resultStore : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): HttpRequestProcessActivity {
        const json = this.toJSON();
        let result = new HttpRequestProcessActivity();
        result.init(json);
        return result;
    }
}

export interface IHttpRequestProcessActivity extends INonInteractiveProcessActivity {
    dataSource?: string | null;
    verb: HttpRequestProcessActivityVerb;
    path?: string | null;
    content?: string | null;
    resultStore?: string | null;
}

export enum HttpRequestProcessActivityVerb {
    Get = 0,
    Post = 1,
    Put = 2,
    Delete = 3,
}

export abstract class ContainerProcessActivity extends NonInteractiveProcessActivity implements IContainerProcessActivity {
    activities?: BaseProcessActivity[] | null;

    constructor(data?: IContainerProcessActivity) {
        super(data);
        this._discriminator = "ContainerProcessActivity";
    }

    init(data?: any) {
        super.init(data);
        if (data) {
            if (Array.isArray(data["activities"])) {
                this.activities = [] as any;
                for (let item in data["activities"])
                    this.activities!.push(BaseProcessActivity.fromJS(data["activities"][item]));
            }
            else {
                this.activities = <any>null;
            }
        }
    }

    static fromJS(data: any): ContainerProcessActivity {
        data = typeof data === 'object' ? data : {};
        if (data["discriminator"] === "IfProcessActivity") {
            let result = new IfProcessActivity();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'ContainerProcessActivity' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.activities)) {
            data["activities"] = [];
            for (let item in this.activities)
                data["activities"].push(this.activities[item].toJSON());
        }
        super.toJSON(data);
        return data;
    }

    clone(): ContainerProcessActivity {
        throw new Error("The abstract class 'ContainerProcessActivity' cannot be instantiated.");
    }
}

export interface IContainerProcessActivity extends INonInteractiveProcessActivity {
    activities?: BaseProcessActivity[] | null;
}

export class IfProcessActivity extends ContainerProcessActivity implements IIfProcessActivity {
    condition?: string | null;
    dataSource?: string | null;
    parameters?: SqlServerParameter[] | null;
    type!: IfProcessActivityScriptType;

    constructor(data?: IIfProcessActivity) {
        super(data);
        this._discriminator = "IfProcessActivity";
    }

    init(data?: any) {
        super.init(data);
        if (data) {
            this.condition = data["condition"] !== undefined ? data["condition"] : <any>null;
            this.dataSource = data["dataSource"] !== undefined ? data["dataSource"] : <any>null;
            if (Array.isArray(data["parameters"])) {
                this.parameters = [] as any;
                for (let item in data["parameters"])
                    this.parameters!.push(SqlServerParameter.fromJS(data["parameters"][item]));
            }
            else {
                this.parameters = <any>null;
            }
            this.type = data["type"] !== undefined ? data["type"] : <any>null;
        }
    }

    static fromJS(data: any): IfProcessActivity {
        data = typeof data === 'object' ? data : {};
        let result = new IfProcessActivity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["condition"] = this.condition !== undefined ? this.condition : <any>null;
        data["dataSource"] = this.dataSource !== undefined ? this.dataSource : <any>null;
        if (Array.isArray(this.parameters)) {
            data["parameters"] = [];
            for (let item in this.parameters)
                data["parameters"].push(this.parameters[item].toJSON());
        }
        data["type"] = this.type !== undefined ? this.type : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): IfProcessActivity {
        const json = this.toJSON();
        let result = new IfProcessActivity();
        result.init(json);
        return result;
    }
}

export interface IIfProcessActivity extends IContainerProcessActivity {
    condition?: string | null;
    dataSource?: string | null;
    parameters?: SqlServerParameter[] | null;
    type: IfProcessActivityScriptType;
}

export class SqlServerParameter implements ISqlServerParameter {
    key?: string | null;
    value?: string | null;

    constructor(data?: ISqlServerParameter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.key = data["key"] !== undefined ? data["key"] : <any>null;
            this.value = data["value"] !== undefined ? data["value"] : <any>null;
        }
    }

    static fromJS(data: any): SqlServerParameter {
        data = typeof data === 'object' ? data : {};
        let result = new SqlServerParameter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key !== undefined ? this.key : <any>null;
        data["value"] = this.value !== undefined ? this.value : <any>null;
        return data;
    }

    clone(): SqlServerParameter {
        const json = this.toJSON();
        let result = new SqlServerParameter();
        result.init(json);
        return result;
    }
}

export interface ISqlServerParameter {
    key?: string | null;
    value?: string | null;
}

export enum IfProcessActivityScriptType {
    CSharp = 0,
    SQL = 1,
}

export class LockProcessActivity extends SubProcessProcessActivity implements ILockProcessActivity {
    lock?: string | null;
    maxLockSeconds?: number | null;

    constructor(data?: ILockProcessActivity) {
        super(data);
        this._discriminator = "LockProcessActivity";
    }

    init(data?: any) {
        super.init(data);
        if (data) {
            this.lock = data["lock"] !== undefined ? data["lock"] : <any>null;
            this.maxLockSeconds = data["maxLockSeconds"] !== undefined ? data["maxLockSeconds"] : <any>null;
        }
    }

    static fromJS(data: any): LockProcessActivity {
        data = typeof data === 'object' ? data : {};
        let result = new LockProcessActivity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lock"] = this.lock !== undefined ? this.lock : <any>null;
        data["maxLockSeconds"] = this.maxLockSeconds !== undefined ? this.maxLockSeconds : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): LockProcessActivity {
        const json = this.toJSON();
        let result = new LockProcessActivity();
        result.init(json);
        return result;
    }
}

export interface ILockProcessActivity extends ISubProcessProcessActivity {
    lock?: string | null;
    maxLockSeconds?: number | null;
}

export class LogMessageProcessActivity extends NonInteractiveProcessActivity implements ILogMessageProcessActivity {
    message?: string | null;
    level!: LogLevel;

    constructor(data?: ILogMessageProcessActivity) {
        super(data);
        this._discriminator = "LogMessageProcessActivity";
    }

    init(data?: any) {
        super.init(data);
        if (data) {
            this.message = data["message"] !== undefined ? data["message"] : <any>null;
            this.level = data["level"] !== undefined ? data["level"] : <any>null;
        }
    }

    static fromJS(data: any): LogMessageProcessActivity {
        data = typeof data === 'object' ? data : {};
        let result = new LogMessageProcessActivity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message !== undefined ? this.message : <any>null;
        data["level"] = this.level !== undefined ? this.level : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): LogMessageProcessActivity {
        const json = this.toJSON();
        let result = new LogMessageProcessActivity();
        result.init(json);
        return result;
    }
}

export interface ILogMessageProcessActivity extends INonInteractiveProcessActivity {
    message?: string | null;
    level: LogLevel;
}

export enum LogLevel {
    Debug = 0,
    Info = 1,
    Success = 2,
    Warning = 3,
    Error = 4,
}

export class ModelDataExportProcessActivity extends NonInteractiveProcessActivity implements IModelDataExportProcessActivity {
    modelViewOrModel?: string | null;
    dataSource?: string | null;
    share?: string | null;
    folder?: string | null;
    fileName?: string | null;
    compress?: boolean | null;
    format?: ModelDataExportProcessActivityFormat | null;

    constructor(data?: IModelDataExportProcessActivity) {
        super(data);
        this._discriminator = "ModelDataExportProcessActivity";
    }

    init(data?: any) {
        super.init(data);
        if (data) {
            this.modelViewOrModel = data["modelViewOrModel"] !== undefined ? data["modelViewOrModel"] : <any>null;
            this.dataSource = data["dataSource"] !== undefined ? data["dataSource"] : <any>null;
            this.share = data["share"] !== undefined ? data["share"] : <any>null;
            this.folder = data["folder"] !== undefined ? data["folder"] : <any>null;
            this.fileName = data["fileName"] !== undefined ? data["fileName"] : <any>null;
            this.compress = data["compress"] !== undefined ? data["compress"] : <any>null;
            this.format = data["format"] !== undefined ? data["format"] : <any>null;
        }
    }

    static fromJS(data: any): ModelDataExportProcessActivity {
        data = typeof data === 'object' ? data : {};
        let result = new ModelDataExportProcessActivity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["modelViewOrModel"] = this.modelViewOrModel !== undefined ? this.modelViewOrModel : <any>null;
        data["dataSource"] = this.dataSource !== undefined ? this.dataSource : <any>null;
        data["share"] = this.share !== undefined ? this.share : <any>null;
        data["folder"] = this.folder !== undefined ? this.folder : <any>null;
        data["fileName"] = this.fileName !== undefined ? this.fileName : <any>null;
        data["compress"] = this.compress !== undefined ? this.compress : <any>null;
        data["format"] = this.format !== undefined ? this.format : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): ModelDataExportProcessActivity {
        const json = this.toJSON();
        let result = new ModelDataExportProcessActivity();
        result.init(json);
        return result;
    }
}

export interface IModelDataExportProcessActivity extends INonInteractiveProcessActivity {
    modelViewOrModel?: string | null;
    dataSource?: string | null;
    share?: string | null;
    folder?: string | null;
    fileName?: string | null;
    compress?: boolean | null;
    format?: ModelDataExportProcessActivityFormat | null;
}

export enum ModelDataExportProcessActivityFormat {
    JSON = 0,
    XML = 1,
    CSV = 2,
}

export class NoteProcessActivity extends NonInteractiveProcessActivity implements INoteProcessActivity {
    text?: string | null;

    constructor(data?: INoteProcessActivity) {
        super(data);
        this._discriminator = "NoteProcessActivity";
    }

    init(data?: any) {
        super.init(data);
        if (data) {
            this.text = data["text"] !== undefined ? data["text"] : <any>null;
        }
    }

    static fromJS(data: any): NoteProcessActivity {
        data = typeof data === 'object' ? data : {};
        let result = new NoteProcessActivity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["text"] = this.text !== undefined ? this.text : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): NoteProcessActivity {
        const json = this.toJSON();
        let result = new NoteProcessActivity();
        result.init(json);
        return result;
    }
}

export interface INoteProcessActivity extends INonInteractiveProcessActivity {
    text?: string | null;
}

export class PublishModelToAnalysisServicesActivity extends NonInteractiveProcessActivity implements IPublishModelToAnalysisServicesActivity {
    modelName?: string | null;

    constructor(data?: IPublishModelToAnalysisServicesActivity) {
        super(data);
        this._discriminator = "PublishModelToAnalysisServicesActivity";
    }

    init(data?: any) {
        super.init(data);
        if (data) {
            this.modelName = data["modelName"] !== undefined ? data["modelName"] : <any>null;
        }
    }

    static fromJS(data: any): PublishModelToAnalysisServicesActivity {
        data = typeof data === 'object' ? data : {};
        let result = new PublishModelToAnalysisServicesActivity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["modelName"] = this.modelName !== undefined ? this.modelName : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): PublishModelToAnalysisServicesActivity {
        const json = this.toJSON();
        let result = new PublishModelToAnalysisServicesActivity();
        result.init(json);
        return result;
    }
}

export interface IPublishModelToAnalysisServicesActivity extends INonInteractiveProcessActivity {
    modelName?: string | null;
}

export class RunReportBookProcessActivity extends NonInteractiveProcessActivity implements IRunReportBookProcessActivity {
    activityFiles?: ActivityFile[] | null;

    constructor(data?: IRunReportBookProcessActivity) {
        super(data);
        this._discriminator = "RunReportBookProcessActivity";
    }

    init(data?: any) {
        super.init(data);
        if (data) {
            if (Array.isArray(data["activityFiles"])) {
                this.activityFiles = [] as any;
                for (let item in data["activityFiles"])
                    this.activityFiles!.push(ActivityFile.fromJS(data["activityFiles"][item]));
            }
            else {
                this.activityFiles = <any>null;
            }
        }
    }

    static fromJS(data: any): RunReportBookProcessActivity {
        data = typeof data === 'object' ? data : {};
        let result = new RunReportBookProcessActivity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.activityFiles)) {
            data["activityFiles"] = [];
            for (let item in this.activityFiles)
                data["activityFiles"].push(this.activityFiles[item].toJSON());
        }
        super.toJSON(data);
        return data;
    }

    clone(): RunReportBookProcessActivity {
        const json = this.toJSON();
        let result = new RunReportBookProcessActivity();
        result.init(json);
        return result;
    }
}

export interface IRunReportBookProcessActivity extends INonInteractiveProcessActivity {
    activityFiles?: ActivityFile[] | null;
}

export class RunWorkflowProcessActivity extends NonInteractiveProcessActivity implements IRunWorkflowProcessActivity {
    fsWorkflow?: ActivityFile | null;
    asynchronous!: boolean;
    startOptions?: PipelineParameter[] | null;

    constructor(data?: IRunWorkflowProcessActivity) {
        super(data);
        this._discriminator = "RunWorkflowProcessActivity";
    }

    init(data?: any) {
        super.init(data);
        if (data) {
            this.fsWorkflow = data["fsWorkflow"] ? ActivityFile.fromJS(data["fsWorkflow"]) : <any>null;
            this.asynchronous = data["asynchronous"] !== undefined ? data["asynchronous"] : <any>null;
            if (Array.isArray(data["startOptions"])) {
                this.startOptions = [] as any;
                for (let item in data["startOptions"])
                    this.startOptions!.push(PipelineParameter.fromJS(data["startOptions"][item]));
            }
            else {
                this.startOptions = <any>null;
            }
        }
    }

    static fromJS(data: any): RunWorkflowProcessActivity {
        data = typeof data === 'object' ? data : {};
        let result = new RunWorkflowProcessActivity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fsWorkflow"] = this.fsWorkflow ? this.fsWorkflow.toJSON() : <any>null;
        data["asynchronous"] = this.asynchronous !== undefined ? this.asynchronous : <any>null;
        if (Array.isArray(this.startOptions)) {
            data["startOptions"] = [];
            for (let item in this.startOptions)
                data["startOptions"].push(this.startOptions[item].toJSON());
        }
        super.toJSON(data);
        return data;
    }

    clone(): RunWorkflowProcessActivity {
        const json = this.toJSON();
        let result = new RunWorkflowProcessActivity();
        result.init(json);
        return result;
    }
}

export interface IRunWorkflowProcessActivity extends INonInteractiveProcessActivity {
    fsWorkflow?: ActivityFile | null;
    asynchronous: boolean;
    startOptions?: PipelineParameter[] | null;
}

export class ScriptProcessActivity extends NonInteractiveProcessActivity implements IScriptProcessActivity {
    script?: string | null;

    constructor(data?: IScriptProcessActivity) {
        super(data);
        this._discriminator = "ScriptProcessActivity";
    }

    init(data?: any) {
        super.init(data);
        if (data) {
            this.script = data["script"] !== undefined ? data["script"] : <any>null;
        }
    }

    static fromJS(data: any): ScriptProcessActivity {
        data = typeof data === 'object' ? data : {};
        let result = new ScriptProcessActivity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["script"] = this.script !== undefined ? this.script : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): ScriptProcessActivity {
        const json = this.toJSON();
        let result = new ScriptProcessActivity();
        result.init(json);
        return result;
    }
}

export interface IScriptProcessActivity extends INonInteractiveProcessActivity {
    script?: string | null;
}

export class SendEmailProcessActivity extends NonInteractiveProcessActivity implements ISendEmailProcessActivity {
    to?: string | null;
    cc?: string | null;
    bcc?: string | null;
    from?: string | null;
    subject?: string | null;
    body?: string | null;
    isBodyHtml!: boolean;

    constructor(data?: ISendEmailProcessActivity) {
        super(data);
        this._discriminator = "SendEmailProcessActivity";
    }

    init(data?: any) {
        super.init(data);
        if (data) {
            this.to = data["to"] !== undefined ? data["to"] : <any>null;
            this.cc = data["cc"] !== undefined ? data["cc"] : <any>null;
            this.bcc = data["bcc"] !== undefined ? data["bcc"] : <any>null;
            this.from = data["from"] !== undefined ? data["from"] : <any>null;
            this.subject = data["subject"] !== undefined ? data["subject"] : <any>null;
            this.body = data["body"] !== undefined ? data["body"] : <any>null;
            this.isBodyHtml = data["isBodyHtml"] !== undefined ? data["isBodyHtml"] : <any>null;
        }
    }

    static fromJS(data: any): SendEmailProcessActivity {
        data = typeof data === 'object' ? data : {};
        let result = new SendEmailProcessActivity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["to"] = this.to !== undefined ? this.to : <any>null;
        data["cc"] = this.cc !== undefined ? this.cc : <any>null;
        data["bcc"] = this.bcc !== undefined ? this.bcc : <any>null;
        data["from"] = this.from !== undefined ? this.from : <any>null;
        data["subject"] = this.subject !== undefined ? this.subject : <any>null;
        data["body"] = this.body !== undefined ? this.body : <any>null;
        data["isBodyHtml"] = this.isBodyHtml !== undefined ? this.isBodyHtml : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): SendEmailProcessActivity {
        const json = this.toJSON();
        let result = new SendEmailProcessActivity();
        result.init(json);
        return result;
    }
}

export interface ISendEmailProcessActivity extends INonInteractiveProcessActivity {
    to?: string | null;
    cc?: string | null;
    bcc?: string | null;
    from?: string | null;
    subject?: string | null;
    body?: string | null;
    isBodyHtml: boolean;
}

export class SlackMessageProcessActivity extends NonInteractiveProcessActivity implements ISlackMessageProcessActivity {
    message?: string | null;
    dataSource?: string | null;
    slackUserName?: string | null;
    slackSenderIconUrl?: string | null;
    slackChannelOverride?: string | null;
    isMarkdown!: boolean;

    constructor(data?: ISlackMessageProcessActivity) {
        super(data);
        this._discriminator = "SlackMessageProcessActivity";
    }

    init(data?: any) {
        super.init(data);
        if (data) {
            this.message = data["message"] !== undefined ? data["message"] : <any>null;
            this.dataSource = data["dataSource"] !== undefined ? data["dataSource"] : <any>null;
            this.slackUserName = data["slackUserName"] !== undefined ? data["slackUserName"] : <any>null;
            this.slackSenderIconUrl = data["slackSenderIconUrl"] !== undefined ? data["slackSenderIconUrl"] : <any>null;
            this.slackChannelOverride = data["slackChannelOverride"] !== undefined ? data["slackChannelOverride"] : <any>null;
            this.isMarkdown = data["isMarkdown"] !== undefined ? data["isMarkdown"] : <any>null;
        }
    }

    static fromJS(data: any): SlackMessageProcessActivity {
        data = typeof data === 'object' ? data : {};
        let result = new SlackMessageProcessActivity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message !== undefined ? this.message : <any>null;
        data["dataSource"] = this.dataSource !== undefined ? this.dataSource : <any>null;
        data["slackUserName"] = this.slackUserName !== undefined ? this.slackUserName : <any>null;
        data["slackSenderIconUrl"] = this.slackSenderIconUrl !== undefined ? this.slackSenderIconUrl : <any>null;
        data["slackChannelOverride"] = this.slackChannelOverride !== undefined ? this.slackChannelOverride : <any>null;
        data["isMarkdown"] = this.isMarkdown !== undefined ? this.isMarkdown : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): SlackMessageProcessActivity {
        const json = this.toJSON();
        let result = new SlackMessageProcessActivity();
        result.init(json);
        return result;
    }
}

export interface ISlackMessageProcessActivity extends INonInteractiveProcessActivity {
    message?: string | null;
    dataSource?: string | null;
    slackUserName?: string | null;
    slackSenderIconUrl?: string | null;
    slackChannelOverride?: string | null;
    isMarkdown: boolean;
}

export class SqlServerStoredProcedureProcessActivity extends NonInteractiveProcessActivity implements ISqlServerStoredProcedureProcessActivity {
    type!: CalculationType;
    calcScriptFile?: ActivityFile | null;
    dataSource?: string | null;
    spName?: string | null;
    parameters?: SqlServerParameter[] | null;
    resultStore?: string | null;

    constructor(data?: ISqlServerStoredProcedureProcessActivity) {
        super(data);
        this._discriminator = "SqlServerStoredProcedureProcessActivity";
    }

    init(data?: any) {
        super.init(data);
        if (data) {
            this.type = data["type"] !== undefined ? data["type"] : <any>null;
            this.calcScriptFile = data["calcScriptFile"] ? ActivityFile.fromJS(data["calcScriptFile"]) : <any>null;
            this.dataSource = data["dataSource"] !== undefined ? data["dataSource"] : <any>null;
            this.spName = data["spName"] !== undefined ? data["spName"] : <any>null;
            if (Array.isArray(data["parameters"])) {
                this.parameters = [] as any;
                for (let item in data["parameters"])
                    this.parameters!.push(SqlServerParameter.fromJS(data["parameters"][item]));
            }
            else {
                this.parameters = <any>null;
            }
            this.resultStore = data["resultStore"] !== undefined ? data["resultStore"] : <any>null;
        }
    }

    static fromJS(data: any): SqlServerStoredProcedureProcessActivity {
        data = typeof data === 'object' ? data : {};
        let result = new SqlServerStoredProcedureProcessActivity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type !== undefined ? this.type : <any>null;
        data["calcScriptFile"] = this.calcScriptFile ? this.calcScriptFile.toJSON() : <any>null;
        data["dataSource"] = this.dataSource !== undefined ? this.dataSource : <any>null;
        data["spName"] = this.spName !== undefined ? this.spName : <any>null;
        if (Array.isArray(this.parameters)) {
            data["parameters"] = [];
            for (let item in this.parameters)
                data["parameters"].push(this.parameters[item].toJSON());
        }
        data["resultStore"] = this.resultStore !== undefined ? this.resultStore : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): SqlServerStoredProcedureProcessActivity {
        const json = this.toJSON();
        let result = new SqlServerStoredProcedureProcessActivity();
        result.init(json);
        return result;
    }
}

export interface ISqlServerStoredProcedureProcessActivity extends INonInteractiveProcessActivity {
    type: CalculationType;
    calcScriptFile?: ActivityFile | null;
    dataSource?: string | null;
    spName?: string | null;
    parameters?: SqlServerParameter[] | null;
    resultStore?: string | null;
}

export enum CalculationType {
    StoredProcedure = 0,
    CalcScript = 1,
}

export class StartProcessActivity extends NonInteractiveProcessActivity implements IStartProcessActivity {

    constructor(data?: IStartProcessActivity) {
        super(data);
        this._discriminator = "StartProcessActivity";
    }

    init(data?: any) {
        super.init(data);
    }

    static fromJS(data: any): StartProcessActivity {
        data = typeof data === 'object' ? data : {};
        let result = new StartProcessActivity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }

    clone(): StartProcessActivity {
        const json = this.toJSON();
        let result = new StartProcessActivity();
        result.init(json);
        return result;
    }
}

export interface IStartProcessActivity extends INonInteractiveProcessActivity {
}

export class StopProcessActivity extends NonInteractiveProcessActivity implements IStopProcessActivity {
    reason?: string | null;

    constructor(data?: IStopProcessActivity) {
        super(data);
        this._discriminator = "StopProcessActivity";
    }

    init(data?: any) {
        super.init(data);
        if (data) {
            this.reason = data["reason"] !== undefined ? data["reason"] : <any>null;
        }
    }

    static fromJS(data: any): StopProcessActivity {
        data = typeof data === 'object' ? data : {};
        let result = new StopProcessActivity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reason"] = this.reason !== undefined ? this.reason : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): StopProcessActivity {
        const json = this.toJSON();
        let result = new StopProcessActivity();
        result.init(json);
        return result;
    }
}

export interface IStopProcessActivity extends INonInteractiveProcessActivity {
    reason?: string | null;
}

export class VenaExportProcessActivity extends NonInteractiveProcessActivity implements IVenaExportProcessActivity {
    exportRequest?: ExportRequest | null;

    constructor(data?: IVenaExportProcessActivity) {
        super(data);
        this._discriminator = "VenaExportProcessActivity";
    }

    init(data?: any) {
        super.init(data);
        if (data) {
            this.exportRequest = data["exportRequest"] ? ExportRequest.fromJS(data["exportRequest"]) : <any>null;
        }
    }

    static fromJS(data: any): VenaExportProcessActivity {
        data = typeof data === 'object' ? data : {};
        let result = new VenaExportProcessActivity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["exportRequest"] = this.exportRequest ? this.exportRequest.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): VenaExportProcessActivity {
        const json = this.toJSON();
        let result = new VenaExportProcessActivity();
        result.init(json);
        return result;
    }
}

export interface IVenaExportProcessActivity extends INonInteractiveProcessActivity {
    exportRequest?: ExportRequest | null;
}

export abstract class RequestBase implements IRequestBase {

    constructor(data?: IRequestBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
    }

    static fromJS(data: any): RequestBase {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'RequestBase' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }

    clone(): RequestBase {
        throw new Error("The abstract class 'RequestBase' cannot be instantiated.");
    }
}

export interface IRequestBase {
}

export class ExportRequest extends RequestBase implements IExportRequest {
    sourceDataSource?: string | null;
    sourceQuery?: string | null;
    destinationDataSource?: string | null;
    destinationModelName?: string | null;
    jobName?: string | null;
    type!: EtlTypeEnum;

    constructor(data?: IExportRequest) {
        super(data);
    }

    init(data?: any) {
        super.init(data);
        if (data) {
            this.sourceDataSource = data["sourceDataSource"] !== undefined ? data["sourceDataSource"] : <any>null;
            this.sourceQuery = data["sourceQuery"] !== undefined ? data["sourceQuery"] : <any>null;
            this.destinationDataSource = data["destinationDataSource"] !== undefined ? data["destinationDataSource"] : <any>null;
            this.destinationModelName = data["destinationModelName"] !== undefined ? data["destinationModelName"] : <any>null;
            this.jobName = data["jobName"] !== undefined ? data["jobName"] : <any>null;
            this.type = data["type"] !== undefined ? data["type"] : <any>null;
        }
    }

    static fromJS(data: any): ExportRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ExportRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sourceDataSource"] = this.sourceDataSource !== undefined ? this.sourceDataSource : <any>null;
        data["sourceQuery"] = this.sourceQuery !== undefined ? this.sourceQuery : <any>null;
        data["destinationDataSource"] = this.destinationDataSource !== undefined ? this.destinationDataSource : <any>null;
        data["destinationModelName"] = this.destinationModelName !== undefined ? this.destinationModelName : <any>null;
        data["jobName"] = this.jobName !== undefined ? this.jobName : <any>null;
        data["type"] = this.type !== undefined ? this.type : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): ExportRequest {
        const json = this.toJSON();
        let result = new ExportRequest();
        result.init(json);
        return result;
    }
}

export interface IExportRequest extends IRequestBase {
    sourceDataSource?: string | null;
    sourceQuery?: string | null;
    destinationDataSource?: string | null;
    destinationModelName?: string | null;
    jobName?: string | null;
    type: EtlTypeEnum;
}

export enum EtlTypeEnum {
    Hierarchy = 0,
    Attributes = 1,
    Intersections = 2,
    UserDefined = 3,
    Lids = 4,
}

export class VenaImportProcessActivity extends NonInteractiveProcessActivity implements IVenaImportProcessActivity {
    importRequest?: ImportRequest | null;

    constructor(data?: IVenaImportProcessActivity) {
        super(data);
        this._discriminator = "VenaImportProcessActivity";
    }

    init(data?: any) {
        super.init(data);
        if (data) {
            this.importRequest = data["importRequest"] ? ImportRequest.fromJS(data["importRequest"]) : <any>null;
        }
    }

    static fromJS(data: any): VenaImportProcessActivity {
        data = typeof data === 'object' ? data : {};
        let result = new VenaImportProcessActivity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["importRequest"] = this.importRequest ? this.importRequest.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): VenaImportProcessActivity {
        const json = this.toJSON();
        let result = new VenaImportProcessActivity();
        result.init(json);
        return result;
    }
}

export interface IVenaImportProcessActivity extends INonInteractiveProcessActivity {
    importRequest?: ImportRequest | null;
}

export class GetRequest extends RequestBase implements IGetRequest {
    dataSource?: string | null;
    modelName?: string | null;
    importType!: EtlTypeEnum;
    fileFormat!: FileFormatEnum;
    /** Query expression for import (HQL). May not be combined with WhereClause */
    queryExpression?: string | null;
    /** Where clause for import (HQL). May not be combined with QueryExpression */
    whereClause?: string | null;
    /** Name of the Vena table in staging DB to import from. */
    tableName?: string | null;

    constructor(data?: IGetRequest) {
        super(data);
    }

    init(data?: any) {
        super.init(data);
        if (data) {
            this.dataSource = data["dataSource"] !== undefined ? data["dataSource"] : <any>null;
            this.modelName = data["modelName"] !== undefined ? data["modelName"] : <any>null;
            this.importType = data["importType"] !== undefined ? data["importType"] : <any>null;
            this.fileFormat = data["fileFormat"] !== undefined ? data["fileFormat"] : <any>null;
            this.queryExpression = data["queryExpression"] !== undefined ? data["queryExpression"] : <any>null;
            this.whereClause = data["whereClause"] !== undefined ? data["whereClause"] : <any>null;
            this.tableName = data["tableName"] !== undefined ? data["tableName"] : <any>null;
        }
    }

    static fromJS(data: any): GetRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dataSource"] = this.dataSource !== undefined ? this.dataSource : <any>null;
        data["modelName"] = this.modelName !== undefined ? this.modelName : <any>null;
        data["importType"] = this.importType !== undefined ? this.importType : <any>null;
        data["fileFormat"] = this.fileFormat !== undefined ? this.fileFormat : <any>null;
        data["queryExpression"] = this.queryExpression !== undefined ? this.queryExpression : <any>null;
        data["whereClause"] = this.whereClause !== undefined ? this.whereClause : <any>null;
        data["tableName"] = this.tableName !== undefined ? this.tableName : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): GetRequest {
        const json = this.toJSON();
        let result = new GetRequest();
        result.init(json);
        return result;
    }
}

export interface IGetRequest extends IRequestBase {
    dataSource?: string | null;
    modelName?: string | null;
    importType: EtlTypeEnum;
    fileFormat: FileFormatEnum;
    /** Query expression for import (HQL). May not be combined with WhereClause */
    queryExpression?: string | null;
    /** Where clause for import (HQL). May not be combined with QueryExpression */
    whereClause?: string | null;
    /** Name of the Vena table in staging DB to import from. */
    tableName?: string | null;
}

export class ImportRequest extends GetRequest implements IImportRequest {
    destinationDataSource?: string | null;
    destinationTable?: string | null;
    useExistingTable?: boolean | null;

    constructor(data?: IImportRequest) {
        super(data);
    }

    init(data?: any) {
        super.init(data);
        if (data) {
            this.destinationDataSource = data["destinationDataSource"] !== undefined ? data["destinationDataSource"] : <any>null;
            this.destinationTable = data["destinationTable"] !== undefined ? data["destinationTable"] : <any>null;
            this.useExistingTable = data["useExistingTable"] !== undefined ? data["useExistingTable"] : <any>null;
        }
    }

    static fromJS(data: any): ImportRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ImportRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["destinationDataSource"] = this.destinationDataSource !== undefined ? this.destinationDataSource : <any>null;
        data["destinationTable"] = this.destinationTable !== undefined ? this.destinationTable : <any>null;
        data["useExistingTable"] = this.useExistingTable !== undefined ? this.useExistingTable : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): ImportRequest {
        const json = this.toJSON();
        let result = new ImportRequest();
        result.init(json);
        return result;
    }
}

export interface IImportRequest extends IGetRequest {
    destinationDataSource?: string | null;
    destinationTable?: string | null;
    useExistingTable?: boolean | null;
}

export enum FileFormatEnum {
    CSV = 0,
    PSV = 1,
    TDF = 2,
}

export abstract class InteractiveProcessActivity extends BaseProcessActivity implements IInteractiveProcessActivity {
    supervisor?: string | null;
    contributor?: string | null;
    owner?: string | null;
    dueDate?: string | null;
    infoText?: string | null;

    constructor(data?: IInteractiveProcessActivity) {
        super(data);
        this._discriminator = "InteractiveProcessActivity";
    }

    init(data?: any) {
        super.init(data);
        if (data) {
            this.supervisor = data["Supervisor"] !== undefined ? data["Supervisor"] : <any>null;
            this.contributor = data["Contributor"] !== undefined ? data["Contributor"] : <any>null;
            this.owner = data["Owner"] !== undefined ? data["Owner"] : <any>null;
            this.dueDate = data["dueDate"] !== undefined ? data["dueDate"] : <any>null;
            this.infoText = data["infoText"] !== undefined ? data["infoText"] : <any>null;
        }
    }

    static fromJS(data: any): InteractiveProcessActivity {
        data = typeof data === 'object' ? data : {};
        if (data["discriminator"] === "DataEntryActivity") {
            let result = new DataEntryActivity();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "FormInteractiveActivity") {
            throw new Error("The abstract class 'FormInteractiveActivity' cannot be instantiated.");
        }
        if (data["discriminator"] === "FileExportProcessActivity") {
            let result = new FileExportProcessActivity();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "FileImportProcessActivity") {
            let result = new FileImportProcessActivity();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "ReportingActivity") {
            let result = new ReportingActivity();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "ReviewActivity") {
            let result = new ReviewActivity();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "ToDoProcessActivity") {
            let result = new ToDoProcessActivity();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'InteractiveProcessActivity' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Supervisor"] = this.supervisor !== undefined ? this.supervisor : <any>null;
        data["Contributor"] = this.contributor !== undefined ? this.contributor : <any>null;
        data["Owner"] = this.owner !== undefined ? this.owner : <any>null;
        data["dueDate"] = this.dueDate !== undefined ? this.dueDate : <any>null;
        data["infoText"] = this.infoText !== undefined ? this.infoText : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): InteractiveProcessActivity {
        throw new Error("The abstract class 'InteractiveProcessActivity' cannot be instantiated.");
    }
}

export interface IInteractiveProcessActivity extends IBaseProcessActivity {
    supervisor?: string | null;
    contributor?: string | null;
    owner?: string | null;
    dueDate?: string | null;
    infoText?: string | null;
}

export abstract class FormInteractiveActivity extends InteractiveProcessActivity implements IFormInteractiveActivity {
    activityFiles?: ActivityFile[] | null;

    constructor(data?: IFormInteractiveActivity) {
        super(data);
        this._discriminator = "FormInteractiveActivity";
    }

    init(data?: any) {
        super.init(data);
        if (data) {
            if (Array.isArray(data["activityFiles"])) {
                this.activityFiles = [] as any;
                for (let item in data["activityFiles"])
                    this.activityFiles!.push(ActivityFile.fromJS(data["activityFiles"][item]));
            }
            else {
                this.activityFiles = <any>null;
            }
        }
    }

    static fromJS(data: any): FormInteractiveActivity {
        data = typeof data === 'object' ? data : {};
        if (data["discriminator"] === "DataEntryActivity") {
            let result = new DataEntryActivity();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "ReportingActivity") {
            let result = new ReportingActivity();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "ReviewActivity") {
            let result = new ReviewActivity();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'FormInteractiveActivity' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.activityFiles)) {
            data["activityFiles"] = [];
            for (let item in this.activityFiles)
                data["activityFiles"].push(this.activityFiles[item].toJSON());
        }
        super.toJSON(data);
        return data;
    }

    clone(): FormInteractiveActivity {
        throw new Error("The abstract class 'FormInteractiveActivity' cannot be instantiated.");
    }
}

export interface IFormInteractiveActivity extends IInteractiveProcessActivity {
    activityFiles?: ActivityFile[] | null;
}

export class DataEntryActivity extends FormInteractiveActivity implements IDataEntryActivity {

    constructor(data?: IDataEntryActivity) {
        super(data);
        this._discriminator = "DataEntryActivity";
    }

    init(data?: any) {
        super.init(data);
    }

    static fromJS(data: any): DataEntryActivity {
        data = typeof data === 'object' ? data : {};
        let result = new DataEntryActivity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }

    clone(): DataEntryActivity {
        const json = this.toJSON();
        let result = new DataEntryActivity();
        result.init(json);
        return result;
    }
}

export interface IDataEntryActivity extends IFormInteractiveActivity {
}

export class FileExportProcessActivity extends InteractiveProcessActivity implements IFileExportProcessActivity {
    dataSource?: string | null;
    query?: string | null;
    parameters?: SqlServerParameter[] | null;
    fileType?: FileExportType | null;

    constructor(data?: IFileExportProcessActivity) {
        super(data);
        this._discriminator = "FileExportProcessActivity";
    }

    init(data?: any) {
        super.init(data);
        if (data) {
            this.dataSource = data["dataSource"] !== undefined ? data["dataSource"] : <any>null;
            this.query = data["query"] !== undefined ? data["query"] : <any>null;
            if (Array.isArray(data["parameters"])) {
                this.parameters = [] as any;
                for (let item in data["parameters"])
                    this.parameters!.push(SqlServerParameter.fromJS(data["parameters"][item]));
            }
            else {
                this.parameters = <any>null;
            }
            this.fileType = data["fileType"] !== undefined ? data["fileType"] : <any>null;
        }
    }

    static fromJS(data: any): FileExportProcessActivity {
        data = typeof data === 'object' ? data : {};
        let result = new FileExportProcessActivity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dataSource"] = this.dataSource !== undefined ? this.dataSource : <any>null;
        data["query"] = this.query !== undefined ? this.query : <any>null;
        if (Array.isArray(this.parameters)) {
            data["parameters"] = [];
            for (let item in this.parameters)
                data["parameters"].push(this.parameters[item].toJSON());
        }
        data["fileType"] = this.fileType !== undefined ? this.fileType : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): FileExportProcessActivity {
        const json = this.toJSON();
        let result = new FileExportProcessActivity();
        result.init(json);
        return result;
    }
}

export interface IFileExportProcessActivity extends IInteractiveProcessActivity {
    dataSource?: string | null;
    query?: string | null;
    parameters?: SqlServerParameter[] | null;
    fileType?: FileExportType | null;
}

export enum FileExportType {
    None = 0,
    Csv = 1,
    Tsv = 2,
    Excel = 3,
    Word = 4,
    Powerpoint = 5,
}

export class FileImportProcessActivity extends InteractiveProcessActivity implements IFileImportProcessActivity {
    tableName?: string | null;
    modelMappingName?: string | null;
    loadStagingData!: boolean;
    trackDataImport?: boolean | null;

    constructor(data?: IFileImportProcessActivity) {
        super(data);
        this._discriminator = "FileImportProcessActivity";
    }

    init(data?: any) {
        super.init(data);
        if (data) {
            this.tableName = data["tableName"] !== undefined ? data["tableName"] : <any>null;
            this.modelMappingName = data["modelMappingName"] !== undefined ? data["modelMappingName"] : <any>null;
            this.loadStagingData = data["loadStagingData"] !== undefined ? data["loadStagingData"] : <any>null;
            this.trackDataImport = data["trackDataImport"] !== undefined ? data["trackDataImport"] : <any>null;
        }
    }

    static fromJS(data: any): FileImportProcessActivity {
        data = typeof data === 'object' ? data : {};
        let result = new FileImportProcessActivity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tableName"] = this.tableName !== undefined ? this.tableName : <any>null;
        data["modelMappingName"] = this.modelMappingName !== undefined ? this.modelMappingName : <any>null;
        data["loadStagingData"] = this.loadStagingData !== undefined ? this.loadStagingData : <any>null;
        data["trackDataImport"] = this.trackDataImport !== undefined ? this.trackDataImport : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): FileImportProcessActivity {
        const json = this.toJSON();
        let result = new FileImportProcessActivity();
        result.init(json);
        return result;
    }
}

export interface IFileImportProcessActivity extends IInteractiveProcessActivity {
    tableName?: string | null;
    modelMappingName?: string | null;
    loadStagingData: boolean;
    trackDataImport?: boolean | null;
}

export class ReportingActivity extends FormInteractiveActivity implements IReportingActivity {

    constructor(data?: IReportingActivity) {
        super(data);
        this._discriminator = "ReportingActivity";
    }

    init(data?: any) {
        super.init(data);
    }

    static fromJS(data: any): ReportingActivity {
        data = typeof data === 'object' ? data : {};
        let result = new ReportingActivity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }

    clone(): ReportingActivity {
        const json = this.toJSON();
        let result = new ReportingActivity();
        result.init(json);
        return result;
    }
}

export interface IReportingActivity extends IFormInteractiveActivity {
}

export class ReviewActivity extends FormInteractiveActivity implements IReviewActivity {
    resetActivityStatesOnReject?: boolean | null;

    constructor(data?: IReviewActivity) {
        super(data);
        this._discriminator = "ReviewActivity";
    }

    init(data?: any) {
        super.init(data);
        if (data) {
            this.resetActivityStatesOnReject = data["resetActivityStatesOnReject"] !== undefined ? data["resetActivityStatesOnReject"] : <any>null;
        }
    }

    static fromJS(data: any): ReviewActivity {
        data = typeof data === 'object' ? data : {};
        let result = new ReviewActivity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resetActivityStatesOnReject"] = this.resetActivityStatesOnReject !== undefined ? this.resetActivityStatesOnReject : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): ReviewActivity {
        const json = this.toJSON();
        let result = new ReviewActivity();
        result.init(json);
        return result;
    }
}

export interface IReviewActivity extends IFormInteractiveActivity {
    resetActivityStatesOnReject?: boolean | null;
}

export class ToDoProcessActivity extends InteractiveProcessActivity implements IToDoProcessActivity {
    description?: string | null;

    constructor(data?: IToDoProcessActivity) {
        super(data);
        this._discriminator = "ToDoProcessActivity";
    }

    init(data?: any) {
        super.init(data);
        if (data) {
            this.description = data["description"] !== undefined ? data["description"] : <any>null;
        }
    }

    static fromJS(data: any): ToDoProcessActivity {
        data = typeof data === 'object' ? data : {};
        let result = new ToDoProcessActivity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description !== undefined ? this.description : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): ToDoProcessActivity {
        const json = this.toJSON();
        let result = new ToDoProcessActivity();
        result.init(json);
        return result;
    }
}

export interface IToDoProcessActivity extends IInteractiveProcessActivity {
    description?: string | null;
}

export class StagingTableImportProcessActivity extends NonInteractiveProcessActivity implements IStagingTableImportProcessActivity {
    modelMappingName?: string | null;
    trackDataImport?: boolean | null;
    skipValidation!: boolean;

    constructor(data?: IStagingTableImportProcessActivity) {
        super(data);
        this._discriminator = "StagingTableImportProcessActivity";
    }

    init(data?: any) {
        super.init(data);
        if (data) {
            this.modelMappingName = data["modelMappingName"] !== undefined ? data["modelMappingName"] : <any>null;
            this.trackDataImport = data["trackDataImport"] !== undefined ? data["trackDataImport"] : <any>null;
            this.skipValidation = data["skipValidation"] !== undefined ? data["skipValidation"] : <any>null;
        }
    }

    static fromJS(data: any): StagingTableImportProcessActivity {
        data = typeof data === 'object' ? data : {};
        let result = new StagingTableImportProcessActivity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["modelMappingName"] = this.modelMappingName !== undefined ? this.modelMappingName : <any>null;
        data["trackDataImport"] = this.trackDataImport !== undefined ? this.trackDataImport : <any>null;
        data["skipValidation"] = this.skipValidation !== undefined ? this.skipValidation : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): StagingTableImportProcessActivity {
        const json = this.toJSON();
        let result = new StagingTableImportProcessActivity();
        result.init(json);
        return result;
    }
}

export interface IStagingTableImportProcessActivity extends INonInteractiveProcessActivity {
    modelMappingName?: string | null;
    trackDataImport?: boolean | null;
    skipValidation: boolean;
}

export class ProcessActivityExecutionState implements IProcessActivityExecutionState {
    processPath?: string | null;
    processStartTime!: Date;
    processRunId!: string;
    subProcessRunId!: string;
    activityRunId!: string;
    caption?: string | null;
    parentCaption?: string | null;
    burstingKey?: string | null;
    nodeId?: string | null;
    activityName?: string | null;
    startTime?: Date | null;
    endTime?: Date | null;
    calculatedDueDate?: Date | null;
    status!: ActivityExecutionResultEnum;
    calculatedStatus!: ActivityExecutionResultEnum;
    supervisors?: string | null;
    contributors?: string | null;
    owners?: string | null;
    discriminator?: string | null;
    percentComplete!: number;

    constructor(data?: IProcessActivityExecutionState) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.processPath = data["processPath"] !== undefined ? data["processPath"] : <any>null;
            this.processStartTime = data["processStartTime"] ? new Date(data["processStartTime"].toString()) : <any>null;
            this.processRunId = data["processRunId"] !== undefined ? data["processRunId"] : <any>null;
            this.subProcessRunId = data["subProcessRunId"] !== undefined ? data["subProcessRunId"] : <any>null;
            this.activityRunId = data["activityRunId"] !== undefined ? data["activityRunId"] : <any>null;
            this.caption = data["caption"] !== undefined ? data["caption"] : <any>null;
            this.parentCaption = data["parentCaption"] !== undefined ? data["parentCaption"] : <any>null;
            this.burstingKey = data["burstingKey"] !== undefined ? data["burstingKey"] : <any>null;
            this.nodeId = data["nodeId"] !== undefined ? data["nodeId"] : <any>null;
            this.activityName = data["activityName"] !== undefined ? data["activityName"] : <any>null;
            this.startTime = data["startTime"] ? new Date(data["startTime"].toString()) : <any>null;
            this.endTime = data["endTime"] ? new Date(data["endTime"].toString()) : <any>null;
            this.calculatedDueDate = data["calculatedDueDate"] ? new Date(data["calculatedDueDate"].toString()) : <any>null;
            this.status = data["status"] !== undefined ? data["status"] : <any>null;
            this.calculatedStatus = data["calculatedStatus"] !== undefined ? data["calculatedStatus"] : <any>null;
            this.supervisors = data["supervisors"] !== undefined ? data["supervisors"] : <any>null;
            this.contributors = data["contributors"] !== undefined ? data["contributors"] : <any>null;
            this.owners = data["owners"] !== undefined ? data["owners"] : <any>null;
            this.discriminator = data["discriminator"] !== undefined ? data["discriminator"] : <any>null;
            this.percentComplete = data["percentComplete"] !== undefined ? data["percentComplete"] : <any>null;
        }
    }

    static fromJS(data: any): ProcessActivityExecutionState {
        data = typeof data === 'object' ? data : {};
        let result = new ProcessActivityExecutionState();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["processPath"] = this.processPath !== undefined ? this.processPath : <any>null;
        data["processStartTime"] = this.processStartTime ? this.processStartTime.toISOString() : <any>null;
        data["processRunId"] = this.processRunId !== undefined ? this.processRunId : <any>null;
        data["subProcessRunId"] = this.subProcessRunId !== undefined ? this.subProcessRunId : <any>null;
        data["activityRunId"] = this.activityRunId !== undefined ? this.activityRunId : <any>null;
        data["caption"] = this.caption !== undefined ? this.caption : <any>null;
        data["parentCaption"] = this.parentCaption !== undefined ? this.parentCaption : <any>null;
        data["burstingKey"] = this.burstingKey !== undefined ? this.burstingKey : <any>null;
        data["nodeId"] = this.nodeId !== undefined ? this.nodeId : <any>null;
        data["activityName"] = this.activityName !== undefined ? this.activityName : <any>null;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>null;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>null;
        data["calculatedDueDate"] = this.calculatedDueDate ? this.calculatedDueDate.toISOString() : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["calculatedStatus"] = this.calculatedStatus !== undefined ? this.calculatedStatus : <any>null;
        data["supervisors"] = this.supervisors !== undefined ? this.supervisors : <any>null;
        data["contributors"] = this.contributors !== undefined ? this.contributors : <any>null;
        data["owners"] = this.owners !== undefined ? this.owners : <any>null;
        data["discriminator"] = this.discriminator !== undefined ? this.discriminator : <any>null;
        data["percentComplete"] = this.percentComplete !== undefined ? this.percentComplete : <any>null;
        return data;
    }

    clone(): ProcessActivityExecutionState {
        const json = this.toJSON();
        let result = new ProcessActivityExecutionState();
        result.init(json);
        return result;
    }
}

export interface IProcessActivityExecutionState {
    processPath?: string | null;
    processStartTime: Date;
    processRunId: string;
    subProcessRunId: string;
    activityRunId: string;
    caption?: string | null;
    parentCaption?: string | null;
    burstingKey?: string | null;
    nodeId?: string | null;
    activityName?: string | null;
    startTime?: Date | null;
    endTime?: Date | null;
    calculatedDueDate?: Date | null;
    status: ActivityExecutionResultEnum;
    calculatedStatus: ActivityExecutionResultEnum;
    supervisors?: string | null;
    contributors?: string | null;
    owners?: string | null;
    discriminator?: string | null;
    percentComplete: number;
}

export enum ActivityExecutionResultEnum {
    Unknown = 0,
    Success = 1,
    Yes = 2,
    No = 3,
    Approved = 4,
    Rejected = 5,
    Upcoming = 6,
    Queued = 7,
    Running = 8,
    Overdue = 9,
    Error = 10,
    Stopped = 11,
}

export class RecentProcessRunLogs implements IRecentProcessRunLogs {
    processRunId!: string;
    otherRecentRuns?: ProcessHistoryRun[] | null;
    logs?: ProcessRunActivityLog[] | null;

    constructor(data?: IRecentProcessRunLogs) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.processRunId = data["processRunId"] !== undefined ? data["processRunId"] : <any>null;
            if (Array.isArray(data["otherRecentRuns"])) {
                this.otherRecentRuns = [] as any;
                for (let item in data["otherRecentRuns"])
                    this.otherRecentRuns!.push(ProcessHistoryRun.fromJS(data["otherRecentRuns"][item]));
            }
            else {
                this.otherRecentRuns = <any>null;
            }
            if (Array.isArray(data["logs"])) {
                this.logs = [] as any;
                for (let item in data["logs"])
                    this.logs!.push(ProcessRunActivityLog.fromJS(data["logs"][item]));
            }
            else {
                this.logs = <any>null;
            }
        }
    }

    static fromJS(data: any): RecentProcessRunLogs {
        data = typeof data === 'object' ? data : {};
        let result = new RecentProcessRunLogs();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["processRunId"] = this.processRunId !== undefined ? this.processRunId : <any>null;
        if (Array.isArray(this.otherRecentRuns)) {
            data["otherRecentRuns"] = [];
            for (let item in this.otherRecentRuns)
                data["otherRecentRuns"].push(this.otherRecentRuns[item].toJSON());
        }
        if (Array.isArray(this.logs)) {
            data["logs"] = [];
            for (let item in this.logs)
                data["logs"].push(this.logs[item].toJSON());
        }
        return data;
    }

    clone(): RecentProcessRunLogs {
        const json = this.toJSON();
        let result = new RecentProcessRunLogs();
        result.init(json);
        return result;
    }
}

export interface IRecentProcessRunLogs {
    processRunId: string;
    otherRecentRuns?: ProcessHistoryRun[] | null;
    logs?: ProcessRunActivityLog[] | null;
}

export class ProcessHistoryRun implements IProcessHistoryRun {
    processRunId!: string;
    startTime!: Date;

    constructor(data?: IProcessHistoryRun) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.processRunId = data["processRunId"] !== undefined ? data["processRunId"] : <any>null;
            this.startTime = data["startTime"] ? new Date(data["startTime"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): ProcessHistoryRun {
        data = typeof data === 'object' ? data : {};
        let result = new ProcessHistoryRun();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["processRunId"] = this.processRunId !== undefined ? this.processRunId : <any>null;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>null;
        return data;
    }

    clone(): ProcessHistoryRun {
        const json = this.toJSON();
        let result = new ProcessHistoryRun();
        result.init(json);
        return result;
    }
}

export interface IProcessHistoryRun {
    processRunId: string;
    startTime: Date;
}

export class ProcessRunLog implements IProcessRunLog {
    processRunId!: string;
    activityRunId?: string | null;
    time!: Date;
    level!: LogLevel;
    message?: string | null;

    constructor(data?: IProcessRunLog) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.processRunId = data["processRunId"] !== undefined ? data["processRunId"] : <any>null;
            this.activityRunId = data["activityRunId"] !== undefined ? data["activityRunId"] : <any>null;
            this.time = data["time"] ? new Date(data["time"].toString()) : <any>null;
            this.level = data["level"] !== undefined ? data["level"] : <any>null;
            this.message = data["message"] !== undefined ? data["message"] : <any>null;
        }
    }

    static fromJS(data: any): ProcessRunLog {
        data = typeof data === 'object' ? data : {};
        let result = new ProcessRunLog();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["processRunId"] = this.processRunId !== undefined ? this.processRunId : <any>null;
        data["activityRunId"] = this.activityRunId !== undefined ? this.activityRunId : <any>null;
        data["time"] = this.time ? this.time.toISOString() : <any>null;
        data["level"] = this.level !== undefined ? this.level : <any>null;
        data["message"] = this.message !== undefined ? this.message : <any>null;
        return data;
    }

    clone(): ProcessRunLog {
        const json = this.toJSON();
        let result = new ProcessRunLog();
        result.init(json);
        return result;
    }
}

export interface IProcessRunLog {
    processRunId: string;
    activityRunId?: string | null;
    time: Date;
    level: LogLevel;
    message?: string | null;
}

export class ProcessRunActivityLog extends ProcessRunLog implements IProcessRunActivityLog {
    activityName?: string | null;
    status?: string | null;
    feCaption?: string | null;

    constructor(data?: IProcessRunActivityLog) {
        super(data);
    }

    init(data?: any) {
        super.init(data);
        if (data) {
            this.activityName = data["activityName"] !== undefined ? data["activityName"] : <any>null;
            this.status = data["status"] !== undefined ? data["status"] : <any>null;
            this.feCaption = data["feCaption"] !== undefined ? data["feCaption"] : <any>null;
        }
    }

    static fromJS(data: any): ProcessRunActivityLog {
        data = typeof data === 'object' ? data : {};
        let result = new ProcessRunActivityLog();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activityName"] = this.activityName !== undefined ? this.activityName : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["feCaption"] = this.feCaption !== undefined ? this.feCaption : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): ProcessRunActivityLog {
        const json = this.toJSON();
        let result = new ProcessRunActivityLog();
        result.init(json);
        return result;
    }
}

export interface IProcessRunActivityLog extends IProcessRunLog {
    activityName?: string | null;
    status?: string | null;
    feCaption?: string | null;
}

export class ProcessRun implements IProcessRun {
    logs?: ProcessRunLog[] | null;
    processRunId!: string;
    startTime!: Date;
    endTime?: Date | null;
    process?: string | null;
    status?: string | null;
    dueDate?: Date | null;
    startedByProcessRunId?: string | null;
    startedByActivityRunId?: string | null;

    constructor(data?: IProcessRun) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (Array.isArray(data["logs"])) {
                this.logs = [] as any;
                for (let item in data["logs"])
                    this.logs!.push(ProcessRunLog.fromJS(data["logs"][item]));
            }
            else {
                this.logs = <any>null;
            }
            this.processRunId = data["processRunId"] !== undefined ? data["processRunId"] : <any>null;
            this.startTime = data["startTime"] ? new Date(data["startTime"].toString()) : <any>null;
            this.endTime = data["endTime"] ? new Date(data["endTime"].toString()) : <any>null;
            this.process = data["process"] !== undefined ? data["process"] : <any>null;
            this.status = data["status"] !== undefined ? data["status"] : <any>null;
            this.dueDate = data["dueDate"] ? new Date(data["dueDate"].toString()) : <any>null;
            this.startedByProcessRunId = data["startedByProcessRunId"] !== undefined ? data["startedByProcessRunId"] : <any>null;
            this.startedByActivityRunId = data["startedByActivityRunId"] !== undefined ? data["startedByActivityRunId"] : <any>null;
        }
    }

    static fromJS(data: any): ProcessRun {
        data = typeof data === 'object' ? data : {};
        let result = new ProcessRun();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.logs)) {
            data["logs"] = [];
            for (let item in this.logs)
                data["logs"].push(this.logs[item].toJSON());
        }
        data["processRunId"] = this.processRunId !== undefined ? this.processRunId : <any>null;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>null;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>null;
        data["process"] = this.process !== undefined ? this.process : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>null;
        data["startedByProcessRunId"] = this.startedByProcessRunId !== undefined ? this.startedByProcessRunId : <any>null;
        data["startedByActivityRunId"] = this.startedByActivityRunId !== undefined ? this.startedByActivityRunId : <any>null;
        return data;
    }

    clone(): ProcessRun {
        const json = this.toJSON();
        let result = new ProcessRun();
        result.init(json);
        return result;
    }
}

export interface IProcessRun {
    logs?: ProcessRunLog[] | null;
    processRunId: string;
    startTime: Date;
    endTime?: Date | null;
    process?: string | null;
    status?: string | null;
    dueDate?: Date | null;
    startedByProcessRunId?: string | null;
    startedByActivityRunId?: string | null;
}

export class TopicActivityMessage implements ITopicActivityMessage {
    type!: TopicActivityMessageType;
    tenant?: string | null;
    runAsUserName?: string | null;
    processRunId!: string;
    subProcessRunId?: string | null;
    activityName?: string | null;
    activityRunId!: string;
    caption?: string | null;
    burstingKey?: number | null;
    parentNodeId?: string | null;
    nodeId?: string | null;
    dueDate?: Date | null;

    constructor(data?: ITopicActivityMessage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.type = data["type"] !== undefined ? data["type"] : <any>null;
            this.tenant = data["tenant"] !== undefined ? data["tenant"] : <any>null;
            this.runAsUserName = data["runAsUserName"] !== undefined ? data["runAsUserName"] : <any>null;
            this.processRunId = data["processRunId"] !== undefined ? data["processRunId"] : <any>null;
            this.subProcessRunId = data["subProcessRunId"] !== undefined ? data["subProcessRunId"] : <any>null;
            this.activityName = data["activityName"] !== undefined ? data["activityName"] : <any>null;
            this.activityRunId = data["activityRunId"] !== undefined ? data["activityRunId"] : <any>null;
            this.caption = data["caption"] !== undefined ? data["caption"] : <any>null;
            this.burstingKey = data["burstingKey"] !== undefined ? data["burstingKey"] : <any>null;
            this.parentNodeId = data["parentNodeId"] !== undefined ? data["parentNodeId"] : <any>null;
            this.nodeId = data["nodeId"] !== undefined ? data["nodeId"] : <any>null;
            this.dueDate = data["dueDate"] ? new Date(data["dueDate"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): TopicActivityMessage {
        data = typeof data === 'object' ? data : {};
        let result = new TopicActivityMessage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type !== undefined ? this.type : <any>null;
        data["tenant"] = this.tenant !== undefined ? this.tenant : <any>null;
        data["runAsUserName"] = this.runAsUserName !== undefined ? this.runAsUserName : <any>null;
        data["processRunId"] = this.processRunId !== undefined ? this.processRunId : <any>null;
        data["subProcessRunId"] = this.subProcessRunId !== undefined ? this.subProcessRunId : <any>null;
        data["activityName"] = this.activityName !== undefined ? this.activityName : <any>null;
        data["activityRunId"] = this.activityRunId !== undefined ? this.activityRunId : <any>null;
        data["caption"] = this.caption !== undefined ? this.caption : <any>null;
        data["burstingKey"] = this.burstingKey !== undefined ? this.burstingKey : <any>null;
        data["parentNodeId"] = this.parentNodeId !== undefined ? this.parentNodeId : <any>null;
        data["nodeId"] = this.nodeId !== undefined ? this.nodeId : <any>null;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>null;
        return data;
    }

    clone(): TopicActivityMessage {
        const json = this.toJSON();
        let result = new TopicActivityMessage();
        result.init(json);
        return result;
    }
}

export interface ITopicActivityMessage {
    type: TopicActivityMessageType;
    tenant?: string | null;
    runAsUserName?: string | null;
    processRunId: string;
    subProcessRunId?: string | null;
    activityName?: string | null;
    activityRunId: string;
    caption?: string | null;
    burstingKey?: number | null;
    parentNodeId?: string | null;
    nodeId?: string | null;
    dueDate?: Date | null;
}

export enum TopicActivityMessageType {
    StartActivity = 0,
    ActivityOverdue = 1,
    RestartActivity = 2,
    DelayEnded = 3,
}

export class ActivityExecutionResultBase implements IActivityExecutionResultBase {
    type!: ActivityExecutionResultEnum;
    percentComplete!: number;

    constructor(data?: IActivityExecutionResultBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.type = data["type"] !== undefined ? data["type"] : <any>null;
            this.percentComplete = data["percentComplete"] !== undefined ? data["percentComplete"] : <any>null;
        }
    }

    static fromJS(data: any): ActivityExecutionResultBase {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityExecutionResultBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type !== undefined ? this.type : <any>null;
        data["percentComplete"] = this.percentComplete !== undefined ? this.percentComplete : <any>null;
        return data;
    }

    clone(): ActivityExecutionResultBase {
        const json = this.toJSON();
        let result = new ActivityExecutionResultBase();
        result.init(json);
        return result;
    }
}

export interface IActivityExecutionResultBase {
    type: ActivityExecutionResultEnum;
    percentComplete: number;
}

export class ProcessSchedule implements IProcessSchedule {
    id?: number | null;
    scheduleName?: string | null;
    tenant?: string | null;
    runAsUserName?: string | null;
    cronExpression?: string | null;
    nextRunId?: number | null;
    nextRunUid?: string | null;
    processPath?: string | null;
    timezone?: string | null;

    constructor(data?: IProcessSchedule) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"] !== undefined ? data["id"] : <any>null;
            this.scheduleName = data["scheduleName"] !== undefined ? data["scheduleName"] : <any>null;
            this.tenant = data["tenant"] !== undefined ? data["tenant"] : <any>null;
            this.runAsUserName = data["runAsUserName"] !== undefined ? data["runAsUserName"] : <any>null;
            this.cronExpression = data["cronExpression"] !== undefined ? data["cronExpression"] : <any>null;
            this.nextRunId = data["nextRunId"] !== undefined ? data["nextRunId"] : <any>null;
            this.nextRunUid = data["nextRunUid"] !== undefined ? data["nextRunUid"] : <any>null;
            this.processPath = data["processPath"] !== undefined ? data["processPath"] : <any>null;
            this.timezone = data["timezone"] !== undefined ? data["timezone"] : <any>null;
        }
    }

    static fromJS(data: any): ProcessSchedule {
        data = typeof data === 'object' ? data : {};
        let result = new ProcessSchedule();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["scheduleName"] = this.scheduleName !== undefined ? this.scheduleName : <any>null;
        data["tenant"] = this.tenant !== undefined ? this.tenant : <any>null;
        data["runAsUserName"] = this.runAsUserName !== undefined ? this.runAsUserName : <any>null;
        data["cronExpression"] = this.cronExpression !== undefined ? this.cronExpression : <any>null;
        data["nextRunId"] = this.nextRunId !== undefined ? this.nextRunId : <any>null;
        data["nextRunUid"] = this.nextRunUid !== undefined ? this.nextRunUid : <any>null;
        data["processPath"] = this.processPath !== undefined ? this.processPath : <any>null;
        data["timezone"] = this.timezone !== undefined ? this.timezone : <any>null;
        return data;
    }

    clone(): ProcessSchedule {
        const json = this.toJSON();
        let result = new ProcessSchedule();
        result.init(json);
        return result;
    }
}

export interface IProcessSchedule {
    id?: number | null;
    scheduleName?: string | null;
    tenant?: string | null;
    runAsUserName?: string | null;
    cronExpression?: string | null;
    nextRunId?: number | null;
    nextRunUid?: string | null;
    processPath?: string | null;
    timezone?: string | null;
}

export class RelationalQueryResult implements IRelationalQueryResult {
    noFields!: number;
    noRows!: number;
    fields?: string[] | null;
    fieldTypes?: string[] | null;
    data?: string[][] | null;

    constructor(data?: IRelationalQueryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.noFields = data["noFields"] !== undefined ? data["noFields"] : <any>null;
            this.noRows = data["noRows"] !== undefined ? data["noRows"] : <any>null;
            if (Array.isArray(data["fields"])) {
                this.fields = [] as any;
                for (let item in data["fields"])
                    this.fields!.push(data["fields"][item]);
            }
            else {
                this.fields = <any>null;
            }
            if (Array.isArray(data["fieldTypes"])) {
                this.fieldTypes = [] as any;
                for (let item in data["fieldTypes"])
                    this.fieldTypes!.push(data["fieldTypes"][item]);
            }
            else {
                this.fieldTypes = <any>null;
            }
            if (Array.isArray(data["data"])) {
                this.data = [] as any;
                for (let item in data["data"])
                    this.data!.push(data["data"][item]);
            }
            else {
                this.data = <any>null;
            }
        }
    }

    static fromJS(data: any): RelationalQueryResult {
        data = typeof data === 'object' ? data : {};
        let result = new RelationalQueryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["noFields"] = this.noFields !== undefined ? this.noFields : <any>null;
        data["noRows"] = this.noRows !== undefined ? this.noRows : <any>null;
        if (Array.isArray(this.fields)) {
            data["fields"] = [];
            for (let item in this.fields)
                data["fields"].push(this.fields[item]);
        }
        if (Array.isArray(this.fieldTypes)) {
            data["fieldTypes"] = [];
            for (let item in this.fieldTypes)
                data["fieldTypes"].push(this.fieldTypes[item]);
        }
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item in this.data)
                data["data"].push(this.data[item]);
        }
        return data;
    }

    clone(): RelationalQueryResult {
        const json = this.toJSON();
        let result = new RelationalQueryResult();
        result.init(json);
        return result;
    }
}

export interface IRelationalQueryResult {
    noFields: number;
    noRows: number;
    fields?: string[] | null;
    fieldTypes?: string[] | null;
    data?: string[][] | null;
}

export class RelationalQueryRequest implements IRelationalQueryRequest {
    datasource?: string | null;
    queryText?: string | null;

    constructor(data?: IRelationalQueryRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.datasource = data["datasource"] !== undefined ? data["datasource"] : <any>null;
            this.queryText = data["queryText"] !== undefined ? data["queryText"] : <any>null;
        }
    }

    static fromJS(data: any): RelationalQueryRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RelationalQueryRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["datasource"] = this.datasource !== undefined ? this.datasource : <any>null;
        data["queryText"] = this.queryText !== undefined ? this.queryText : <any>null;
        return data;
    }

    clone(): RelationalQueryRequest {
        const json = this.toJSON();
        let result = new RelationalQueryRequest();
        result.init(json);
        return result;
    }
}

export interface IRelationalQueryRequest {
    datasource?: string | null;
    queryText?: string | null;
}

export class CalcScriptResult implements ICalcScriptResult {
    batchId?: string | null;

    constructor(data?: ICalcScriptResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.batchId = data["batchId"] !== undefined ? data["batchId"] : <any>null;
        }
    }

    static fromJS(data: any): CalcScriptResult {
        data = typeof data === 'object' ? data : {};
        let result = new CalcScriptResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["batchId"] = this.batchId !== undefined ? this.batchId : <any>null;
        return data;
    }

    clone(): CalcScriptResult {
        const json = this.toJSON();
        let result = new CalcScriptResult();
        result.init(json);
        return result;
    }
}

export interface ICalcScriptResult {
    batchId?: string | null;
}

export class BookDefinition implements IBookDefinition {
    name?: string | null;
    password?: string | null;
    output!: BookOutput;
    compilation!: BookCompilation;
    destination?: string | null;
    parameters?: BookParameter[] | null;
    entries?: BookForm[] | null;

    constructor(data?: IBookDefinition) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"] !== undefined ? data["name"] : <any>null;
            this.password = data["password"] !== undefined ? data["password"] : <any>null;
            this.output = data["output"] !== undefined ? data["output"] : <any>null;
            this.compilation = data["compilation"] !== undefined ? data["compilation"] : <any>null;
            this.destination = data["destination"] !== undefined ? data["destination"] : <any>null;
            if (Array.isArray(data["parameters"])) {
                this.parameters = [] as any;
                for (let item in data["parameters"])
                    this.parameters!.push(BookParameter.fromJS(data["parameters"][item]));
            }
            else {
                this.parameters = <any>null;
            }
            if (Array.isArray(data["entries"])) {
                this.entries = [] as any;
                for (let item in data["entries"])
                    this.entries!.push(BookForm.fromJS(data["entries"][item]));
            }
            else {
                this.entries = <any>null;
            }
        }
    }

    static fromJS(data: any): BookDefinition {
        data = typeof data === 'object' ? data : {};
        let result = new BookDefinition();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["password"] = this.password !== undefined ? this.password : <any>null;
        data["output"] = this.output !== undefined ? this.output : <any>null;
        data["compilation"] = this.compilation !== undefined ? this.compilation : <any>null;
        data["destination"] = this.destination !== undefined ? this.destination : <any>null;
        if (Array.isArray(this.parameters)) {
            data["parameters"] = [];
            for (let item in this.parameters)
                data["parameters"].push(this.parameters[item].toJSON());
        }
        if (Array.isArray(this.entries)) {
            data["entries"] = [];
            for (let item in this.entries)
                data["entries"].push(this.entries[item].toJSON());
        }
        return data;
    }

    clone(): BookDefinition {
        const json = this.toJSON();
        let result = new BookDefinition();
        result.init(json);
        return result;
    }
}

export interface IBookDefinition {
    name?: string | null;
    password?: string | null;
    output: BookOutput;
    compilation: BookCompilation;
    destination?: string | null;
    parameters?: BookParameter[] | null;
    entries?: BookForm[] | null;
}

export enum BookCompilation {
    Merged = 0,
    Zip = 1,
}

export class BookParameter implements IBookParameter {
    name?: string | null;
    label?: string | null;
    sourceId?: number | null;
    sourcePath?: string | null;
    sourceName?: string | null;

    constructor(data?: IBookParameter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"] !== undefined ? data["name"] : <any>null;
            this.label = data["label"] !== undefined ? data["label"] : <any>null;
            this.sourceId = data["sourceId"] !== undefined ? data["sourceId"] : <any>null;
            this.sourcePath = data["sourcePath"] !== undefined ? data["sourcePath"] : <any>null;
            this.sourceName = data["sourceName"] !== undefined ? data["sourceName"] : <any>null;
        }
    }

    static fromJS(data: any): BookParameter {
        data = typeof data === 'object' ? data : {};
        let result = new BookParameter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["label"] = this.label !== undefined ? this.label : <any>null;
        data["sourceId"] = this.sourceId !== undefined ? this.sourceId : <any>null;
        data["sourcePath"] = this.sourcePath !== undefined ? this.sourcePath : <any>null;
        data["sourceName"] = this.sourceName !== undefined ? this.sourceName : <any>null;
        return data;
    }

    clone(): BookParameter {
        const json = this.toJSON();
        let result = new BookParameter();
        result.init(json);
        return result;
    }
}

export interface IBookParameter {
    name?: string | null;
    label?: string | null;
    sourceId?: number | null;
    sourcePath?: string | null;
    sourceName?: string | null;
}

export class BookForm implements IBookForm {
    description?: string | null;
    id?: number | null;
    path?: string | null;
    parameters?: KeyValuePairOfStringAndString[] | null;
    tabNames?: KeyValuePairOfStringAndString[] | null;

    constructor(data?: IBookForm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.description = data["description"] !== undefined ? data["description"] : <any>null;
            this.id = data["id"] !== undefined ? data["id"] : <any>null;
            this.path = data["path"] !== undefined ? data["path"] : <any>null;
            if (Array.isArray(data["parameters"])) {
                this.parameters = [] as any;
                for (let item in data["parameters"])
                    this.parameters!.push(KeyValuePairOfStringAndString.fromJS(data["parameters"][item]));
            }
            else {
                this.parameters = <any>null;
            }
            if (Array.isArray(data["tabNames"])) {
                this.tabNames = [] as any;
                for (let item in data["tabNames"])
                    this.tabNames!.push(KeyValuePairOfStringAndString.fromJS(data["tabNames"][item]));
            }
            else {
                this.tabNames = <any>null;
            }
        }
    }

    static fromJS(data: any): BookForm {
        data = typeof data === 'object' ? data : {};
        let result = new BookForm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["path"] = this.path !== undefined ? this.path : <any>null;
        if (Array.isArray(this.parameters)) {
            data["parameters"] = [];
            for (let item in this.parameters)
                data["parameters"].push(this.parameters[item].toJSON());
        }
        if (Array.isArray(this.tabNames)) {
            data["tabNames"] = [];
            for (let item in this.tabNames)
                data["tabNames"].push(this.tabNames[item].toJSON());
        }
        return data;
    }

    clone(): BookForm {
        const json = this.toJSON();
        let result = new BookForm();
        result.init(json);
        return result;
    }
}

export interface IBookForm {
    description?: string | null;
    id?: number | null;
    path?: string | null;
    parameters?: KeyValuePairOfStringAndString[] | null;
    tabNames?: KeyValuePairOfStringAndString[] | null;
}

export class ReportBookItem implements IReportBookItem {
    fileSystemObject?: FileSystemObjectContent | null;
    name?: string | null;
    password?: string | null;
    output!: BookOutput;
    compilation!: BookCompilation;
    destination?: string | null;
    entries?: ReportBookEntry[] | null;
    parameters?: BookAndFormParameter[] | null;

    constructor(data?: IReportBookItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.fileSystemObject = data["fileSystemObject"] ? FileSystemObjectContent.fromJS(data["fileSystemObject"]) : <any>null;
            this.name = data["name"] !== undefined ? data["name"] : <any>null;
            this.password = data["password"] !== undefined ? data["password"] : <any>null;
            this.output = data["output"] !== undefined ? data["output"] : <any>null;
            this.compilation = data["compilation"] !== undefined ? data["compilation"] : <any>null;
            this.destination = data["destination"] !== undefined ? data["destination"] : <any>null;
            if (Array.isArray(data["entries"])) {
                this.entries = [] as any;
                for (let item in data["entries"])
                    this.entries!.push(ReportBookEntry.fromJS(data["entries"][item]));
            }
            else {
                this.entries = <any>null;
            }
            if (Array.isArray(data["parameters"])) {
                this.parameters = [] as any;
                for (let item in data["parameters"])
                    this.parameters!.push(BookAndFormParameter.fromJS(data["parameters"][item]));
            }
            else {
                this.parameters = <any>null;
            }
        }
    }

    static fromJS(data: any): ReportBookItem {
        data = typeof data === 'object' ? data : {};
        let result = new ReportBookItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileSystemObject"] = this.fileSystemObject ? this.fileSystemObject.toJSON() : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["password"] = this.password !== undefined ? this.password : <any>null;
        data["output"] = this.output !== undefined ? this.output : <any>null;
        data["compilation"] = this.compilation !== undefined ? this.compilation : <any>null;
        data["destination"] = this.destination !== undefined ? this.destination : <any>null;
        if (Array.isArray(this.entries)) {
            data["entries"] = [];
            for (let item in this.entries)
                data["entries"].push(this.entries[item].toJSON());
        }
        if (Array.isArray(this.parameters)) {
            data["parameters"] = [];
            for (let item in this.parameters)
                data["parameters"].push(this.parameters[item].toJSON());
        }
        return data;
    }

    clone(): ReportBookItem {
        const json = this.toJSON();
        let result = new ReportBookItem();
        result.init(json);
        return result;
    }
}

export interface IReportBookItem {
    fileSystemObject?: FileSystemObjectContent | null;
    name?: string | null;
    password?: string | null;
    output: BookOutput;
    compilation: BookCompilation;
    destination?: string | null;
    entries?: ReportBookEntry[] | null;
    parameters?: BookAndFormParameter[] | null;
}

export class ReportBookEntry implements IReportBookEntry {
    description?: string | null;
    fileSystemObject?: FileSystemObjectContent | null;
    parameters?: FormParameterList | null;
    tabNames?: KeyValuePairOfStringAndString[] | null;

    constructor(data?: IReportBookEntry) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.description = data["description"] !== undefined ? data["description"] : <any>null;
            this.fileSystemObject = data["fileSystemObject"] ? FileSystemObjectContent.fromJS(data["fileSystemObject"]) : <any>null;
            this.parameters = data["parameters"] ? FormParameterList.fromJS(data["parameters"]) : <any>null;
            if (Array.isArray(data["tabNames"])) {
                this.tabNames = [] as any;
                for (let item in data["tabNames"])
                    this.tabNames!.push(KeyValuePairOfStringAndString.fromJS(data["tabNames"][item]));
            }
            else {
                this.tabNames = <any>null;
            }
        }
    }

    static fromJS(data: any): ReportBookEntry {
        data = typeof data === 'object' ? data : {};
        let result = new ReportBookEntry();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["fileSystemObject"] = this.fileSystemObject ? this.fileSystemObject.toJSON() : <any>null;
        data["parameters"] = this.parameters ? this.parameters.toJSON() : <any>null;
        if (Array.isArray(this.tabNames)) {
            data["tabNames"] = [];
            for (let item in this.tabNames)
                data["tabNames"].push(this.tabNames[item].toJSON());
        }
        return data;
    }

    clone(): ReportBookEntry {
        const json = this.toJSON();
        let result = new ReportBookEntry();
        result.init(json);
        return result;
    }
}

export interface IReportBookEntry {
    description?: string | null;
    fileSystemObject?: FileSystemObjectContent | null;
    parameters?: FormParameterList | null;
    tabNames?: KeyValuePairOfStringAndString[] | null;
}

export class BookAndFormParameter implements IBookAndFormParameter {
    bookParameter?: BookParameter | null;
    formParameter?: FormParameter | null;

    constructor(data?: IBookAndFormParameter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bookParameter = data["bookParameter"] ? BookParameter.fromJS(data["bookParameter"]) : <any>null;
            this.formParameter = data["formParameter"] ? FormParameter.fromJS(data["formParameter"]) : <any>null;
        }
    }

    static fromJS(data: any): BookAndFormParameter {
        data = typeof data === 'object' ? data : {};
        let result = new BookAndFormParameter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bookParameter"] = this.bookParameter ? this.bookParameter.toJSON() : <any>null;
        data["formParameter"] = this.formParameter ? this.formParameter.toJSON() : <any>null;
        return data;
    }

    clone(): BookAndFormParameter {
        const json = this.toJSON();
        let result = new BookAndFormParameter();
        result.init(json);
        return result;
    }
}

export interface IBookAndFormParameter {
    bookParameter?: BookParameter | null;
    formParameter?: FormParameter | null;
}

export class BookDefinitionAndCurrentParameters implements IBookDefinitionAndCurrentParameters {
    bookDefinition?: BookDefinition | null;
    currentParameters?: FormParameterCurrentValue[] | null;

    constructor(data?: IBookDefinitionAndCurrentParameters) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bookDefinition = data["bookDefinition"] ? BookDefinition.fromJS(data["bookDefinition"]) : <any>null;
            if (Array.isArray(data["currentParameters"])) {
                this.currentParameters = [] as any;
                for (let item in data["currentParameters"])
                    this.currentParameters!.push(FormParameterCurrentValue.fromJS(data["currentParameters"][item]));
            }
            else {
                this.currentParameters = <any>null;
            }
        }
    }

    static fromJS(data: any): BookDefinitionAndCurrentParameters {
        data = typeof data === 'object' ? data : {};
        let result = new BookDefinitionAndCurrentParameters();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bookDefinition"] = this.bookDefinition ? this.bookDefinition.toJSON() : <any>null;
        if (Array.isArray(this.currentParameters)) {
            data["currentParameters"] = [];
            for (let item in this.currentParameters)
                data["currentParameters"].push(this.currentParameters[item].toJSON());
        }
        return data;
    }

    clone(): BookDefinitionAndCurrentParameters {
        const json = this.toJSON();
        let result = new BookDefinitionAndCurrentParameters();
        result.init(json);
        return result;
    }
}

export interface IBookDefinitionAndCurrentParameters {
    bookDefinition?: BookDefinition | null;
    currentParameters?: FormParameterCurrentValue[] | null;
}

export class RoleObject implements IRoleObject {
    roleid!: number;
    roleName?: string | null;
    users?: string[] | null;

    constructor(data?: IRoleObject) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.roleid = data["roleid"] !== undefined ? data["roleid"] : <any>null;
            this.roleName = data["roleName"] !== undefined ? data["roleName"] : <any>null;
            if (Array.isArray(data["users"])) {
                this.users = [] as any;
                for (let item in data["users"])
                    this.users!.push(data["users"][item]);
            }
            else {
                this.users = <any>null;
            }
        }
    }

    static fromJS(data: any): RoleObject {
        data = typeof data === 'object' ? data : {};
        let result = new RoleObject();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["roleid"] = this.roleid !== undefined ? this.roleid : <any>null;
        data["roleName"] = this.roleName !== undefined ? this.roleName : <any>null;
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item in this.users)
                data["users"].push(this.users[item]);
        }
        return data;
    }

    clone(): RoleObject {
        const json = this.toJSON();
        let result = new RoleObject();
        result.init(json);
        return result;
    }
}

export interface IRoleObject {
    roleid: number;
    roleName?: string | null;
    users?: string[] | null;
}

export class SecureUserObject implements ISecureUserObject {
    userID!: number;
    userName?: string | null;
    fullName?: string | null;
    isDisabled!: boolean;
    isGloballyDisabled!: boolean;
    superuser?: boolean | null;
    email?: string | null;
    roles?: string[] | null;
    lastLoginDate?: Date | null;
    dateAdded?: Date | null;
    userDomain?: string | null;

    constructor(data?: ISecureUserObject) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.userID = data["userID"] !== undefined ? data["userID"] : <any>null;
            this.userName = data["userName"] !== undefined ? data["userName"] : <any>null;
            this.fullName = data["fullName"] !== undefined ? data["fullName"] : <any>null;
            this.isDisabled = data["isDisabled"] !== undefined ? data["isDisabled"] : <any>null;
            this.isGloballyDisabled = data["isGloballyDisabled"] !== undefined ? data["isGloballyDisabled"] : <any>null;
            this.superuser = data["superuser"] !== undefined ? data["superuser"] : <any>null;
            this.email = data["email"] !== undefined ? data["email"] : <any>null;
            if (Array.isArray(data["roles"])) {
                this.roles = [] as any;
                for (let item in data["roles"])
                    this.roles!.push(data["roles"][item]);
            }
            else {
                this.roles = <any>null;
            }
            this.lastLoginDate = data["lastLoginDate"] ? new Date(data["lastLoginDate"].toString()) : <any>null;
            this.dateAdded = data["dateAdded"] ? new Date(data["dateAdded"].toString()) : <any>null;
            this.userDomain = data["userDomain"] !== undefined ? data["userDomain"] : <any>null;
        }
    }

    static fromJS(data: any): SecureUserObject {
        data = typeof data === 'object' ? data : {};
        let result = new SecureUserObject();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userID"] = this.userID !== undefined ? this.userID : <any>null;
        data["userName"] = this.userName !== undefined ? this.userName : <any>null;
        data["fullName"] = this.fullName !== undefined ? this.fullName : <any>null;
        data["isDisabled"] = this.isDisabled !== undefined ? this.isDisabled : <any>null;
        data["isGloballyDisabled"] = this.isGloballyDisabled !== undefined ? this.isGloballyDisabled : <any>null;
        data["superuser"] = this.superuser !== undefined ? this.superuser : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item in this.roles)
                data["roles"].push(this.roles[item]);
        }
        data["lastLoginDate"] = this.lastLoginDate ? this.lastLoginDate.toISOString() : <any>null;
        data["dateAdded"] = this.dateAdded ? this.dateAdded.toISOString() : <any>null;
        data["userDomain"] = this.userDomain !== undefined ? this.userDomain : <any>null;
        return data;
    }

    clone(): SecureUserObject {
        const json = this.toJSON();
        let result = new SecureUserObject();
        result.init(json);
        return result;
    }
}

export interface ISecureUserObject {
    userID: number;
    userName?: string | null;
    fullName?: string | null;
    isDisabled: boolean;
    isGloballyDisabled: boolean;
    superuser?: boolean | null;
    email?: string | null;
    roles?: string[] | null;
    lastLoginDate?: Date | null;
    dateAdded?: Date | null;
    userDomain?: string | null;
}

export class UserObject extends SecureUserObject implements IUserObject {

    constructor(data?: IUserObject) {
        super(data);
    }

    init(data?: any) {
        super.init(data);
    }

    static fromJS(data: any): UserObject {
        data = typeof data === 'object' ? data : {};
        let result = new UserObject();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }

    clone(): UserObject {
        const json = this.toJSON();
        let result = new UserObject();
        result.init(json);
        return result;
    }
}

export interface IUserObject extends ISecureUserObject {
}

export class Tenant implements ITenant {
    name?: string | null;
    caption?: string | null;
    webApiUrl?: string | null;
    portalUrl?: string | null;
    license?: string | null;
    environment?: string | null;
    bgColor?: string | null;
    analysisServicesCS?: string | null;
    isALMEnabled!: boolean;

    constructor(data?: ITenant) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"] !== undefined ? data["name"] : <any>null;
            this.caption = data["caption"] !== undefined ? data["caption"] : <any>null;
            this.webApiUrl = data["webApiUrl"] !== undefined ? data["webApiUrl"] : <any>null;
            this.portalUrl = data["portalUrl"] !== undefined ? data["portalUrl"] : <any>null;
            this.license = data["license"] !== undefined ? data["license"] : <any>null;
            this.environment = data["environment"] !== undefined ? data["environment"] : <any>null;
            this.bgColor = data["bgColor"] !== undefined ? data["bgColor"] : <any>null;
            this.analysisServicesCS = data["analysisServicesCS"] !== undefined ? data["analysisServicesCS"] : <any>null;
            this.isALMEnabled = data["isALMEnabled"] !== undefined ? data["isALMEnabled"] : <any>null;
        }
    }

    static fromJS(data: any): Tenant {
        data = typeof data === 'object' ? data : {};
        let result = new Tenant();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["caption"] = this.caption !== undefined ? this.caption : <any>null;
        data["webApiUrl"] = this.webApiUrl !== undefined ? this.webApiUrl : <any>null;
        data["portalUrl"] = this.portalUrl !== undefined ? this.portalUrl : <any>null;
        data["license"] = this.license !== undefined ? this.license : <any>null;
        data["environment"] = this.environment !== undefined ? this.environment : <any>null;
        data["bgColor"] = this.bgColor !== undefined ? this.bgColor : <any>null;
        data["analysisServicesCS"] = this.analysisServicesCS !== undefined ? this.analysisServicesCS : <any>null;
        data["isALMEnabled"] = this.isALMEnabled !== undefined ? this.isALMEnabled : <any>null;
        return data;
    }

    clone(): Tenant {
        const json = this.toJSON();
        let result = new Tenant();
        result.init(json);
        return result;
    }
}

export interface ITenant {
    name?: string | null;
    caption?: string | null;
    webApiUrl?: string | null;
    portalUrl?: string | null;
    license?: string | null;
    environment?: string | null;
    bgColor?: string | null;
    analysisServicesCS?: string | null;
    isALMEnabled: boolean;
}

export class FluenceToken implements IFluenceToken {
    success!: boolean;
    username?: string | null;
    token?: string | null;
    message?: string | null;

    constructor(data?: IFluenceToken) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.success = data["success"] !== undefined ? data["success"] : <any>null;
            this.username = data["username"] !== undefined ? data["username"] : <any>null;
            this.token = data["token"] !== undefined ? data["token"] : <any>null;
            this.message = data["message"] !== undefined ? data["message"] : <any>null;
        }
    }

    static fromJS(data: any): FluenceToken {
        data = typeof data === 'object' ? data : {};
        let result = new FluenceToken();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success !== undefined ? this.success : <any>null;
        data["username"] = this.username !== undefined ? this.username : <any>null;
        data["token"] = this.token !== undefined ? this.token : <any>null;
        data["message"] = this.message !== undefined ? this.message : <any>null;
        return data;
    }

    clone(): FluenceToken {
        const json = this.toJSON();
        let result = new FluenceToken();
        result.init(json);
        return result;
    }
}

export interface IFluenceToken {
    success: boolean;
    username?: string | null;
    token?: string | null;
    message?: string | null;
}

export class UserData implements IUserData {
    name?: string | null;
    userName?: string | null;
    tenant?: string | null;
    language?: string | null;
    logId?: string | null;
    environment?: string | null;
    roles?: string[] | null;
    isSuperUser!: boolean;
    initials?: string | null;
    ip?: string | null;

    constructor(data?: IUserData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"] !== undefined ? data["name"] : <any>null;
            this.userName = data["userName"] !== undefined ? data["userName"] : <any>null;
            this.tenant = data["tenant"] !== undefined ? data["tenant"] : <any>null;
            this.language = data["language"] !== undefined ? data["language"] : <any>null;
            this.logId = data["logId"] !== undefined ? data["logId"] : <any>null;
            this.environment = data["environment"] !== undefined ? data["environment"] : <any>null;
            if (Array.isArray(data["roles"])) {
                this.roles = [] as any;
                for (let item in data["roles"])
                    this.roles!.push(data["roles"][item]);
            }
            else {
                this.roles = <any>null;
            }
            this.isSuperUser = data["isSuperUser"] !== undefined ? data["isSuperUser"] : <any>null;
            this.initials = data["initials"] !== undefined ? data["initials"] : <any>null;
            this.ip = data["ip"] !== undefined ? data["ip"] : <any>null;
        }
    }

    static fromJS(data: any): UserData {
        data = typeof data === 'object' ? data : {};
        let result = new UserData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["userName"] = this.userName !== undefined ? this.userName : <any>null;
        data["tenant"] = this.tenant !== undefined ? this.tenant : <any>null;
        data["language"] = this.language !== undefined ? this.language : <any>null;
        data["logId"] = this.logId !== undefined ? this.logId : <any>null;
        data["environment"] = this.environment !== undefined ? this.environment : <any>null;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item in this.roles)
                data["roles"].push(this.roles[item]);
        }
        data["isSuperUser"] = this.isSuperUser !== undefined ? this.isSuperUser : <any>null;
        data["initials"] = this.initials !== undefined ? this.initials : <any>null;
        data["ip"] = this.ip !== undefined ? this.ip : <any>null;
        return data;
    }

    clone(): UserData {
        const json = this.toJSON();
        let result = new UserData();
        result.init(json);
        return result;
    }
}

export interface IUserData {
    name?: string | null;
    userName?: string | null;
    tenant?: string | null;
    language?: string | null;
    logId?: string | null;
    environment?: string | null;
    roles?: string[] | null;
    isSuperUser: boolean;
    initials?: string | null;
    ip?: string | null;
}

export class ExtendedUserData extends UserData implements IExtendedUserData {
    moduleSecurity?: Module[] | null;
    featureFlags?: string[] | null;
    hasDashboard!: boolean;
    releaseInfo?: ReleaseInfo | null;
    welcomeMessage?: string | null;
    multiLanguageSupport?: string[] | null;
    themeName?: string | null;
    metadataAuditTrail?: string | null;
    modelSecurity?: string | null;
    jeSecurity?: string | null;
    allowMemberNamesWithLeadingZeroes?: string | null;
    workflowGanttChart?: string | null;
    jeConversion?: string | null;

    constructor(data?: IExtendedUserData) {
        super(data);
    }

    init(data?: any) {
        super.init(data);
        if (data) {
            if (Array.isArray(data["moduleSecurity"])) {
                this.moduleSecurity = [] as any;
                for (let item in data["moduleSecurity"])
                    this.moduleSecurity!.push(Module.fromJS(data["moduleSecurity"][item]));
            }
            else {
                this.moduleSecurity = <any>null;
            }
            if (Array.isArray(data["featureFlags"])) {
                this.featureFlags = [] as any;
                for (let item in data["featureFlags"])
                    this.featureFlags!.push(data["featureFlags"][item]);
            }
            else {
                this.featureFlags = <any>null;
            }
            this.hasDashboard = data["hasDashboard"] !== undefined ? data["hasDashboard"] : <any>null;
            this.releaseInfo = data["releaseInfo"] ? ReleaseInfo.fromJS(data["releaseInfo"]) : <any>null;
            this.welcomeMessage = data["welcomeMessage"] !== undefined ? data["welcomeMessage"] : <any>null;
            if (Array.isArray(data["multiLanguageSupport"])) {
                this.multiLanguageSupport = [] as any;
                for (let item in data["multiLanguageSupport"])
                    this.multiLanguageSupport!.push(data["multiLanguageSupport"][item]);
            }
            else {
                this.multiLanguageSupport = <any>null;
            }
            this.themeName = data["themeName"] !== undefined ? data["themeName"] : <any>null;
            this.metadataAuditTrail = data["metadataAuditTrail"] !== undefined ? data["metadataAuditTrail"] : <any>null;
            this.modelSecurity = data["modelSecurity"] !== undefined ? data["modelSecurity"] : <any>null;
            this.jeSecurity = data["jeSecurity"] !== undefined ? data["jeSecurity"] : <any>null;
            this.allowMemberNamesWithLeadingZeroes = data["allowMemberNamesWithLeadingZeroes"] !== undefined ? data["allowMemberNamesWithLeadingZeroes"] : <any>null;
            this.workflowGanttChart = data["workflowGanttChart"] !== undefined ? data["workflowGanttChart"] : <any>null;
            this.jeConversion = data["jeConversion"] !== undefined ? data["jeConversion"] : <any>null;
        }
    }

    static fromJS(data: any): ExtendedUserData {
        data = typeof data === 'object' ? data : {};
        let result = new ExtendedUserData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.moduleSecurity)) {
            data["moduleSecurity"] = [];
            for (let item in this.moduleSecurity)
                data["moduleSecurity"].push(this.moduleSecurity[item].toJSON());
        }
        if (Array.isArray(this.featureFlags)) {
            data["featureFlags"] = [];
            for (let item in this.featureFlags)
                data["featureFlags"].push(this.featureFlags[item]);
        }
        data["hasDashboard"] = this.hasDashboard !== undefined ? this.hasDashboard : <any>null;
        data["releaseInfo"] = this.releaseInfo ? this.releaseInfo.toJSON() : <any>null;
        data["welcomeMessage"] = this.welcomeMessage !== undefined ? this.welcomeMessage : <any>null;
        if (Array.isArray(this.multiLanguageSupport)) {
            data["multiLanguageSupport"] = [];
            for (let item in this.multiLanguageSupport)
                data["multiLanguageSupport"].push(this.multiLanguageSupport[item]);
        }
        data["themeName"] = this.themeName !== undefined ? this.themeName : <any>null;
        data["metadataAuditTrail"] = this.metadataAuditTrail !== undefined ? this.metadataAuditTrail : <any>null;
        data["modelSecurity"] = this.modelSecurity !== undefined ? this.modelSecurity : <any>null;
        data["jeSecurity"] = this.jeSecurity !== undefined ? this.jeSecurity : <any>null;
        data["allowMemberNamesWithLeadingZeroes"] = this.allowMemberNamesWithLeadingZeroes !== undefined ? this.allowMemberNamesWithLeadingZeroes : <any>null;
        data["workflowGanttChart"] = this.workflowGanttChart !== undefined ? this.workflowGanttChart : <any>null;
        data["jeConversion"] = this.jeConversion !== undefined ? this.jeConversion : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): ExtendedUserData {
        const json = this.toJSON();
        let result = new ExtendedUserData();
        result.init(json);
        return result;
    }
}

export interface IExtendedUserData extends IUserData {
    moduleSecurity?: Module[] | null;
    featureFlags?: string[] | null;
    hasDashboard: boolean;
    releaseInfo?: ReleaseInfo | null;
    welcomeMessage?: string | null;
    multiLanguageSupport?: string[] | null;
    themeName?: string | null;
    metadataAuditTrail?: string | null;
    modelSecurity?: string | null;
    jeSecurity?: string | null;
    allowMemberNamesWithLeadingZeroes?: string | null;
    workflowGanttChart?: string | null;
    jeConversion?: string | null;
}

export class Module implements IModule {
    id!: number;
    name?: string | null;
    category?: string | null;
    enabled!: boolean;
    displayOrder!: number;
    categoryOrder!: number;
    formID?: number | null;
    allowExport?: boolean | null;
    allowImport?: boolean | null;

    constructor(data?: IModule) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"] !== undefined ? data["id"] : <any>null;
            this.name = data["name"] !== undefined ? data["name"] : <any>null;
            this.category = data["category"] !== undefined ? data["category"] : <any>null;
            this.enabled = data["enabled"] !== undefined ? data["enabled"] : <any>null;
            this.displayOrder = data["displayOrder"] !== undefined ? data["displayOrder"] : <any>null;
            this.categoryOrder = data["categoryOrder"] !== undefined ? data["categoryOrder"] : <any>null;
            this.formID = data["formID"] !== undefined ? data["formID"] : <any>null;
            this.allowExport = data["allowExport"] !== undefined ? data["allowExport"] : <any>null;
            this.allowImport = data["allowImport"] !== undefined ? data["allowImport"] : <any>null;
        }
    }

    static fromJS(data: any): Module {
        data = typeof data === 'object' ? data : {};
        let result = new Module();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["category"] = this.category !== undefined ? this.category : <any>null;
        data["enabled"] = this.enabled !== undefined ? this.enabled : <any>null;
        data["displayOrder"] = this.displayOrder !== undefined ? this.displayOrder : <any>null;
        data["categoryOrder"] = this.categoryOrder !== undefined ? this.categoryOrder : <any>null;
        data["formID"] = this.formID !== undefined ? this.formID : <any>null;
        data["allowExport"] = this.allowExport !== undefined ? this.allowExport : <any>null;
        data["allowImport"] = this.allowImport !== undefined ? this.allowImport : <any>null;
        return data;
    }

    clone(): Module {
        const json = this.toJSON();
        let result = new Module();
        result.init(json);
        return result;
    }
}

export interface IModule {
    id: number;
    name?: string | null;
    category?: string | null;
    enabled: boolean;
    displayOrder: number;
    categoryOrder: number;
    formID?: number | null;
    allowExport?: boolean | null;
    allowImport?: boolean | null;
}

export class ReleaseInfo implements IReleaseInfo {
    platform?: string | null;
    consolidationModule?: string | null;
    accountRecModule?: string | null;
    matchingModule?: string | null;

    constructor(data?: IReleaseInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.platform = data["platform"] !== undefined ? data["platform"] : <any>null;
            this.consolidationModule = data["consolidationModule"] !== undefined ? data["consolidationModule"] : <any>null;
            this.accountRecModule = data["accountRecModule"] !== undefined ? data["accountRecModule"] : <any>null;
            this.matchingModule = data["matchingModule"] !== undefined ? data["matchingModule"] : <any>null;
        }
    }

    static fromJS(data: any): ReleaseInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ReleaseInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["platform"] = this.platform !== undefined ? this.platform : <any>null;
        data["consolidationModule"] = this.consolidationModule !== undefined ? this.consolidationModule : <any>null;
        data["accountRecModule"] = this.accountRecModule !== undefined ? this.accountRecModule : <any>null;
        data["matchingModule"] = this.matchingModule !== undefined ? this.matchingModule : <any>null;
        return data;
    }

    clone(): ReleaseInfo {
        const json = this.toJSON();
        let result = new ReleaseInfo();
        result.init(json);
        return result;
    }
}

export interface IReleaseInfo {
    platform?: string | null;
    consolidationModule?: string | null;
    accountRecModule?: string | null;
    matchingModule?: string | null;
}

export class DimensionSecurity implements IDimensionSecurity {
    dimension?: string | null;
    hierarchy?: string | null;
    security?: HierarchySecurity[] | null;

    constructor(data?: IDimensionSecurity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.dimension = data["dimension"] !== undefined ? data["dimension"] : <any>null;
            this.hierarchy = data["hierarchy"] !== undefined ? data["hierarchy"] : <any>null;
            if (Array.isArray(data["security"])) {
                this.security = [] as any;
                for (let item in data["security"])
                    this.security!.push(HierarchySecurity.fromJS(data["security"][item]));
            }
            else {
                this.security = <any>null;
            }
        }
    }

    static fromJS(data: any): DimensionSecurity {
        data = typeof data === 'object' ? data : {};
        let result = new DimensionSecurity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dimension"] = this.dimension !== undefined ? this.dimension : <any>null;
        data["hierarchy"] = this.hierarchy !== undefined ? this.hierarchy : <any>null;
        if (Array.isArray(this.security)) {
            data["security"] = [];
            for (let item in this.security)
                data["security"].push(this.security[item].toJSON());
        }
        return data;
    }

    clone(): DimensionSecurity {
        const json = this.toJSON();
        let result = new DimensionSecurity();
        result.init(json);
        return result;
    }
}

export interface IDimensionSecurity {
    dimension?: string | null;
    hierarchy?: string | null;
    security?: HierarchySecurity[] | null;
}

export class HierarchySecurity implements IHierarchySecurity {
    role?: string | null;
    details?: HierarchySecurityDetail[] | null;

    constructor(data?: IHierarchySecurity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.role = data["role"] !== undefined ? data["role"] : <any>null;
            if (Array.isArray(data["details"])) {
                this.details = [] as any;
                for (let item in data["details"])
                    this.details!.push(HierarchySecurityDetail.fromJS(data["details"][item]));
            }
            else {
                this.details = <any>null;
            }
        }
    }

    static fromJS(data: any): HierarchySecurity {
        data = typeof data === 'object' ? data : {};
        let result = new HierarchySecurity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["role"] = this.role !== undefined ? this.role : <any>null;
        if (Array.isArray(this.details)) {
            data["details"] = [];
            for (let item in this.details)
                data["details"].push(this.details[item].toJSON());
        }
        return data;
    }

    clone(): HierarchySecurity {
        const json = this.toJSON();
        let result = new HierarchySecurity();
        result.init(json);
        return result;
    }
}

export interface IHierarchySecurity {
    role?: string | null;
    details?: HierarchySecurityDetail[] | null;
}

export class HierarchySecurityDetail implements IHierarchySecurityDetail {
    allowDeny!: AllowDeny;
    memberKey!: number;
    level?: number | null;
    memberRelationship!: DimensionSecurityMemberRelationship;

    constructor(data?: IHierarchySecurityDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.allowDeny = data["allowDeny"] !== undefined ? data["allowDeny"] : <any>null;
            this.memberKey = data["memberKey"] !== undefined ? data["memberKey"] : <any>null;
            this.level = data["level"] !== undefined ? data["level"] : <any>null;
            this.memberRelationship = data["memberRelationship"] !== undefined ? data["memberRelationship"] : <any>null;
        }
    }

    static fromJS(data: any): HierarchySecurityDetail {
        data = typeof data === 'object' ? data : {};
        let result = new HierarchySecurityDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["allowDeny"] = this.allowDeny !== undefined ? this.allowDeny : <any>null;
        data["memberKey"] = this.memberKey !== undefined ? this.memberKey : <any>null;
        data["level"] = this.level !== undefined ? this.level : <any>null;
        data["memberRelationship"] = this.memberRelationship !== undefined ? this.memberRelationship : <any>null;
        return data;
    }

    clone(): HierarchySecurityDetail {
        const json = this.toJSON();
        let result = new HierarchySecurityDetail();
        result.init(json);
        return result;
    }
}

export interface IHierarchySecurityDetail {
    allowDeny: AllowDeny;
    memberKey: number;
    level?: number | null;
    memberRelationship: DimensionSecurityMemberRelationship;
}

export enum AllowDeny {
    Deny = 0,
    Allow = 1,
}

export enum DimensionSecurityMemberRelationship {
    Self = 0,
    Descendants = 1,
    SelfAndDescendants = 2,
    Children = 3,
    SelfAndChildren = 4,
}

export enum ModuleAccess {
    WorkflowManagement = 0,
    AdvancedForms = 3,
    SecurityUserManagementCreate = 4,
    SecurityUserManagementUpdate = 5,
    SecurityUserManagementDelete = 6,
    SecurityRoleManagementCreate = 7,
    SecurityRoleManagementUpdate = 8,
    SecurityRoleManagementDelete = 9,
    SecurityRoleManagementAssignAuthorization = 10,
    SecurityFileSystemSecurityAssign = 11,
    SecurityMetadataSecurityAssign = 12,
    SecuritySecurityReportingAccess = 13,
    SecurityAuditReportingAccess = 14,
    MetadataManagementModelManagementManage = 15,
    MetadataManagementModelViewsManage = 16,
    WorkflowManagementManage = 17,
    WorkflowManagementControl = 18,
    WorkflowManagementView = 19,
    ConfigurationStagingTablesManage = 20,
    ConfigurationDataSourcesConnectionsManage = 21,
    DataImportsDataImportDefinitionsManage = 22,
    DataImportsMappingsView = 23,
    DataImportsMappingsManage = 24,
    HomepagesHomepageManagementManage = 25,
    BasicForms = 26,
    ConfigurationJournalEntriesManageSettings = 29,
    JournalEntriesView = 30,
    JournalEntriesCreate = 31,
    SecurityRoleManagementUserReports = 33,
    ConsolidationMaintain = 34,
    AccountReconciliationMaintain = 35,
    FinancialReportingMaintain = 36,
    LogsEtlLogsView = 37,
    RestApiTokensCreate = 38,
    DataImportsAssignRolesToMappings = 39,
    ThemeCustomSettingsManage = 40,
    LogsMetadataAuditLogView = 41,
    DataImportsAssignRolesToDataImports = 42,
    MetadataManagementModelsCreateUpdate = 43,
    MetadataManagementModelsDelete = 44,
    MetadataManagementModelsView = 45,
    MatchingView = 46,
    MatchingMatch = 47,
    MatchingUnmatch = 48,
    MatchingSupport = 49,
    MatchingDelete = 50,
    ConfigurationJournalConfigurationDelete = 51,
    JournalEntriesUpdate = 52,
    JournalEntriesDelete = 53,
    JournalEntriesImport = 54,
    JournalEntriesPost = 55,
    JournalEntriesUnpost = 56,
    LandscapeManagementManage = 57,
}

export class ModuleSecurityInfo implements IModuleSecurityInfo {
    roleName?: string | null;
    moduleId?: Module[] | null;

    constructor(data?: IModuleSecurityInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.roleName = data["roleName"] !== undefined ? data["roleName"] : <any>null;
            if (Array.isArray(data["moduleId"])) {
                this.moduleId = [] as any;
                for (let item in data["moduleId"])
                    this.moduleId!.push(Module.fromJS(data["moduleId"][item]));
            }
            else {
                this.moduleId = <any>null;
            }
        }
    }

    static fromJS(data: any): ModuleSecurityInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ModuleSecurityInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["roleName"] = this.roleName !== undefined ? this.roleName : <any>null;
        if (Array.isArray(this.moduleId)) {
            data["moduleId"] = [];
            for (let item in this.moduleId)
                data["moduleId"].push(this.moduleId[item].toJSON());
        }
        return data;
    }

    clone(): ModuleSecurityInfo {
        const json = this.toJSON();
        let result = new ModuleSecurityInfo();
        result.init(json);
        return result;
    }
}

export interface IModuleSecurityInfo {
    roleName?: string | null;
    moduleId?: Module[] | null;
}

export class ExportRoleAuthInfo implements IExportRoleAuthInfo {
    moduleDescriptions?: ModuleDescription[] | null;
    securityParentGroups?: SecurityParentGroup[] | null;
    exportRoles?: string[] | null;

    constructor(data?: IExportRoleAuthInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (Array.isArray(data["moduleDescriptions"])) {
                this.moduleDescriptions = [] as any;
                for (let item in data["moduleDescriptions"])
                    this.moduleDescriptions!.push(ModuleDescription.fromJS(data["moduleDescriptions"][item]));
            }
            else {
                this.moduleDescriptions = <any>null;
            }
            if (Array.isArray(data["securityParentGroups"])) {
                this.securityParentGroups = [] as any;
                for (let item in data["securityParentGroups"])
                    this.securityParentGroups!.push(SecurityParentGroup.fromJS(data["securityParentGroups"][item]));
            }
            else {
                this.securityParentGroups = <any>null;
            }
            if (Array.isArray(data["exportRoles"])) {
                this.exportRoles = [] as any;
                for (let item in data["exportRoles"])
                    this.exportRoles!.push(data["exportRoles"][item]);
            }
            else {
                this.exportRoles = <any>null;
            }
        }
    }

    static fromJS(data: any): ExportRoleAuthInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ExportRoleAuthInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.moduleDescriptions)) {
            data["moduleDescriptions"] = [];
            for (let item in this.moduleDescriptions)
                data["moduleDescriptions"].push(this.moduleDescriptions[item].toJSON());
        }
        if (Array.isArray(this.securityParentGroups)) {
            data["securityParentGroups"] = [];
            for (let item in this.securityParentGroups)
                data["securityParentGroups"].push(this.securityParentGroups[item].toJSON());
        }
        if (Array.isArray(this.exportRoles)) {
            data["exportRoles"] = [];
            for (let item in this.exportRoles)
                data["exportRoles"].push(this.exportRoles[item]);
        }
        return data;
    }

    clone(): ExportRoleAuthInfo {
        const json = this.toJSON();
        let result = new ExportRoleAuthInfo();
        result.init(json);
        return result;
    }
}

export interface IExportRoleAuthInfo {
    moduleDescriptions?: ModuleDescription[] | null;
    securityParentGroups?: SecurityParentGroup[] | null;
    exportRoles?: string[] | null;
}

export class ModuleDescription implements IModuleDescription {
    moduleId!: number;
    description?: string | null;

    constructor(data?: IModuleDescription) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.moduleId = data["moduleId"] !== undefined ? data["moduleId"] : <any>null;
            this.description = data["description"] !== undefined ? data["description"] : <any>null;
        }
    }

    static fromJS(data: any): ModuleDescription {
        data = typeof data === 'object' ? data : {};
        let result = new ModuleDescription();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["moduleId"] = this.moduleId !== undefined ? this.moduleId : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        return data;
    }

    clone(): ModuleDescription {
        const json = this.toJSON();
        let result = new ModuleDescription();
        result.init(json);
        return result;
    }
}

export interface IModuleDescription {
    moduleId: number;
    description?: string | null;
}

export class SecurityParentGroup implements ISecurityParentGroup {
    name?: string | null;
    groups?: SecurityGroup[] | null;

    constructor(data?: ISecurityParentGroup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"] !== undefined ? data["name"] : <any>null;
            if (Array.isArray(data["groups"])) {
                this.groups = [] as any;
                for (let item in data["groups"])
                    this.groups!.push(SecurityGroup.fromJS(data["groups"][item]));
            }
            else {
                this.groups = <any>null;
            }
        }
    }

    static fromJS(data: any): SecurityParentGroup {
        data = typeof data === 'object' ? data : {};
        let result = new SecurityParentGroup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        if (Array.isArray(this.groups)) {
            data["groups"] = [];
            for (let item in this.groups)
                data["groups"].push(this.groups[item].toJSON());
        }
        return data;
    }

    clone(): SecurityParentGroup {
        const json = this.toJSON();
        let result = new SecurityParentGroup();
        result.init(json);
        return result;
    }
}

export interface ISecurityParentGroup {
    name?: string | null;
    groups?: SecurityGroup[] | null;
}

export class SecurityGroup implements ISecurityGroup {
    name?: string | null;
    modules?: number[] | null;

    constructor(data?: ISecurityGroup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"] !== undefined ? data["name"] : <any>null;
            if (Array.isArray(data["modules"])) {
                this.modules = [] as any;
                for (let item in data["modules"])
                    this.modules!.push(data["modules"][item]);
            }
            else {
                this.modules = <any>null;
            }
        }
    }

    static fromJS(data: any): SecurityGroup {
        data = typeof data === 'object' ? data : {};
        let result = new SecurityGroup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        if (Array.isArray(this.modules)) {
            data["modules"] = [];
            for (let item in this.modules)
                data["modules"].push(this.modules[item]);
        }
        return data;
    }

    clone(): SecurityGroup {
        const json = this.toJSON();
        let result = new SecurityGroup();
        result.init(json);
        return result;
    }
}

export interface ISecurityGroup {
    name?: string | null;
    modules?: number[] | null;
}

export class FileSystemSecurity implements IFileSystemSecurity {
    fileSystemId!: number;
    objectRights?: AccessRights | null;
    folderRights?: AccessRights | null;
    children?: FileSystemSecurity[] | null;

    constructor(data?: IFileSystemSecurity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.fileSystemId = data["fileSystemId"] !== undefined ? data["fileSystemId"] : <any>null;
            this.objectRights = data["objectRights"] !== undefined ? data["objectRights"] : <any>null;
            this.folderRights = data["folderRights"] !== undefined ? data["folderRights"] : <any>null;
            if (Array.isArray(data["children"])) {
                this.children = [] as any;
                for (let item in data["children"])
                    this.children!.push(FileSystemSecurity.fromJS(data["children"][item]));
            }
            else {
                this.children = <any>null;
            }
        }
    }

    static fromJS(data: any): FileSystemSecurity {
        data = typeof data === 'object' ? data : {};
        let result = new FileSystemSecurity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileSystemId"] = this.fileSystemId !== undefined ? this.fileSystemId : <any>null;
        data["objectRights"] = this.objectRights !== undefined ? this.objectRights : <any>null;
        data["folderRights"] = this.folderRights !== undefined ? this.folderRights : <any>null;
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item in this.children)
                data["children"].push(this.children[item].toJSON());
        }
        return data;
    }

    clone(): FileSystemSecurity {
        const json = this.toJSON();
        let result = new FileSystemSecurity();
        result.init(json);
        return result;
    }
}

export interface IFileSystemSecurity {
    fileSystemId: number;
    objectRights?: AccessRights | null;
    folderRights?: AccessRights | null;
    children?: FileSystemSecurity[] | null;
}

export class FileRoleSecurity implements IFileRoleSecurity {
    roleId!: number;
    roleName?: string | null;
    objectRights?: AccessRights | null;
    inheritObjectRights!: boolean;
    folderRights?: AccessRights | null;
    inheritFolderRights!: boolean;

    constructor(data?: IFileRoleSecurity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.roleId = data["roleId"] !== undefined ? data["roleId"] : <any>null;
            this.roleName = data["roleName"] !== undefined ? data["roleName"] : <any>null;
            this.objectRights = data["objectRights"] !== undefined ? data["objectRights"] : <any>null;
            this.inheritObjectRights = data["inheritObjectRights"] !== undefined ? data["inheritObjectRights"] : <any>null;
            this.folderRights = data["folderRights"] !== undefined ? data["folderRights"] : <any>null;
            this.inheritFolderRights = data["inheritFolderRights"] !== undefined ? data["inheritFolderRights"] : <any>null;
        }
    }

    static fromJS(data: any): FileRoleSecurity {
        data = typeof data === 'object' ? data : {};
        let result = new FileRoleSecurity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["roleId"] = this.roleId !== undefined ? this.roleId : <any>null;
        data["roleName"] = this.roleName !== undefined ? this.roleName : <any>null;
        data["objectRights"] = this.objectRights !== undefined ? this.objectRights : <any>null;
        data["inheritObjectRights"] = this.inheritObjectRights !== undefined ? this.inheritObjectRights : <any>null;
        data["folderRights"] = this.folderRights !== undefined ? this.folderRights : <any>null;
        data["inheritFolderRights"] = this.inheritFolderRights !== undefined ? this.inheritFolderRights : <any>null;
        return data;
    }

    clone(): FileRoleSecurity {
        const json = this.toJSON();
        let result = new FileRoleSecurity();
        result.init(json);
        return result;
    }
}

export interface IFileRoleSecurity {
    roleId: number;
    roleName?: string | null;
    objectRights?: AccessRights | null;
    inheritObjectRights: boolean;
    folderRights?: AccessRights | null;
    inheritFolderRights: boolean;
}

export class MigrationRequest implements IMigrationRequest {
    dryRun!: boolean;
    targetTenants?: string[] | null;

    constructor(data?: IMigrationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.dryRun = data["dryRun"] !== undefined ? data["dryRun"] : <any>null;
            if (Array.isArray(data["targetTenants"])) {
                this.targetTenants = [] as any;
                for (let item in data["targetTenants"])
                    this.targetTenants!.push(data["targetTenants"][item]);
            }
            else {
                this.targetTenants = <any>null;
            }
        }
    }

    static fromJS(data: any): MigrationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new MigrationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dryRun"] = this.dryRun !== undefined ? this.dryRun : <any>null;
        if (Array.isArray(this.targetTenants)) {
            data["targetTenants"] = [];
            for (let item in this.targetTenants)
                data["targetTenants"].push(this.targetTenants[item]);
        }
        return data;
    }

    clone(): MigrationRequest {
        const json = this.toJSON();
        let result = new MigrationRequest();
        result.init(json);
        return result;
    }
}

export interface IMigrationRequest {
    dryRun: boolean;
    targetTenants?: string[] | null;
}

export class MigrationJob implements IMigrationJob {
    jobId!: string;
    state!: MigrationJobState;
    request!: MigrationRequest;
    startedBy!: string;
    startedAt!: Date;
    completedAt?: Date | null;
    totalTenants!: number;
    processedTenants!: number;
    currentTenant?: string | null;
    result!: MigrationResult;
    failureMessage?: string | null;

    constructor(data?: IMigrationJob) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.request = new MigrationRequest();
            this.result = new MigrationResult();
        }
    }

    init(data?: any) {
        if (data) {
            this.jobId = data["jobId"] !== undefined ? data["jobId"] : <any>null;
            this.state = data["state"] !== undefined ? data["state"] : <any>null;
            this.request = data["request"] ? MigrationRequest.fromJS(data["request"]) : new MigrationRequest();
            this.startedBy = data["startedBy"] !== undefined ? data["startedBy"] : <any>null;
            this.startedAt = data["startedAt"] ? new Date(data["startedAt"].toString()) : <any>null;
            this.completedAt = data["completedAt"] ? new Date(data["completedAt"].toString()) : <any>null;
            this.totalTenants = data["totalTenants"] !== undefined ? data["totalTenants"] : <any>null;
            this.processedTenants = data["processedTenants"] !== undefined ? data["processedTenants"] : <any>null;
            this.currentTenant = data["currentTenant"] !== undefined ? data["currentTenant"] : <any>null;
            this.result = data["result"] ? MigrationResult.fromJS(data["result"]) : new MigrationResult();
            this.failureMessage = data["failureMessage"] !== undefined ? data["failureMessage"] : <any>null;
        }
    }

    static fromJS(data: any): MigrationJob {
        data = typeof data === 'object' ? data : {};
        let result = new MigrationJob();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobId"] = this.jobId !== undefined ? this.jobId : <any>null;
        data["state"] = this.state !== undefined ? this.state : <any>null;
        data["request"] = this.request ? this.request.toJSON() : <any>null;
        data["startedBy"] = this.startedBy !== undefined ? this.startedBy : <any>null;
        data["startedAt"] = this.startedAt ? this.startedAt.toISOString() : <any>null;
        data["completedAt"] = this.completedAt ? this.completedAt.toISOString() : <any>null;
        data["totalTenants"] = this.totalTenants !== undefined ? this.totalTenants : <any>null;
        data["processedTenants"] = this.processedTenants !== undefined ? this.processedTenants : <any>null;
        data["currentTenant"] = this.currentTenant !== undefined ? this.currentTenant : <any>null;
        data["result"] = this.result ? this.result.toJSON() : <any>null;
        data["failureMessage"] = this.failureMessage !== undefined ? this.failureMessage : <any>null;
        return data;
    }

    clone(): MigrationJob {
        const json = this.toJSON();
        let result = new MigrationJob();
        result.init(json);
        return result;
    }
}

export interface IMigrationJob {
    jobId: string;
    state: MigrationJobState;
    request: MigrationRequest;
    startedBy: string;
    startedAt: Date;
    completedAt?: Date | null;
    totalTenants: number;
    processedTenants: number;
    currentTenant?: string | null;
    result: MigrationResult;
    failureMessage?: string | null;
}

export enum MigrationJobState {
    Pending = 0,
    Running = 1,
    Completed = 2,
    Failed = 3,
}

export class MigrationResult implements IMigrationResult {
    success!: boolean;
    isDryRun!: boolean;
    totalProcessed!: number;
    migratedCount!: number;
    errorCount!: number;
    errorMessages!: string[];
    startTime!: Date;
    endTime?: Date | null;
    tenantResults!: TenantMigrationResult[];

    constructor(data?: IMigrationResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.errorMessages = [];
            this.tenantResults = [];
        }
    }

    init(data?: any) {
        if (data) {
            this.success = data["success"] !== undefined ? data["success"] : <any>null;
            this.isDryRun = data["isDryRun"] !== undefined ? data["isDryRun"] : <any>null;
            this.totalProcessed = data["totalProcessed"] !== undefined ? data["totalProcessed"] : <any>null;
            this.migratedCount = data["migratedCount"] !== undefined ? data["migratedCount"] : <any>null;
            this.errorCount = data["errorCount"] !== undefined ? data["errorCount"] : <any>null;
            if (Array.isArray(data["errorMessages"])) {
                this.errorMessages = [] as any;
                for (let item in data["errorMessages"])
                    this.errorMessages!.push(data["errorMessages"][item]);
            }
            else {
                this.errorMessages = <any>null;
            }
            this.startTime = data["startTime"] ? new Date(data["startTime"].toString()) : <any>null;
            this.endTime = data["endTime"] ? new Date(data["endTime"].toString()) : <any>null;
            if (Array.isArray(data["tenantResults"])) {
                this.tenantResults = [] as any;
                for (let item in data["tenantResults"])
                    this.tenantResults!.push(TenantMigrationResult.fromJS(data["tenantResults"][item]));
            }
            else {
                this.tenantResults = <any>null;
            }
        }
    }

    static fromJS(data: any): MigrationResult {
        data = typeof data === 'object' ? data : {};
        let result = new MigrationResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success !== undefined ? this.success : <any>null;
        data["isDryRun"] = this.isDryRun !== undefined ? this.isDryRun : <any>null;
        data["totalProcessed"] = this.totalProcessed !== undefined ? this.totalProcessed : <any>null;
        data["migratedCount"] = this.migratedCount !== undefined ? this.migratedCount : <any>null;
        data["errorCount"] = this.errorCount !== undefined ? this.errorCount : <any>null;
        if (Array.isArray(this.errorMessages)) {
            data["errorMessages"] = [];
            for (let item in this.errorMessages)
                data["errorMessages"].push(this.errorMessages[item]);
        }
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>null;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>null;
        if (Array.isArray(this.tenantResults)) {
            data["tenantResults"] = [];
            for (let item in this.tenantResults)
                data["tenantResults"].push(this.tenantResults[item].toJSON());
        }
        return data;
    }

    clone(): MigrationResult {
        const json = this.toJSON();
        let result = new MigrationResult();
        result.init(json);
        return result;
    }
}

export interface IMigrationResult {
    success: boolean;
    isDryRun: boolean;
    totalProcessed: number;
    migratedCount: number;
    errorCount: number;
    errorMessages: string[];
    startTime: Date;
    endTime?: Date | null;
    tenantResults: TenantMigrationResult[];
}

export class TenantMigrationResult implements ITenantMigrationResult {
    tenantName!: string;
    tenantId!: number;
    success!: boolean;
    appDataSourcesProcessed!: number;
    appDataSourcesMigrated!: number;
    tenantDataMigrated!: boolean;
    errors!: string[];

    constructor(data?: ITenantMigrationResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.errors = [];
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantName = data["tenantName"] !== undefined ? data["tenantName"] : <any>null;
            this.tenantId = data["tenantId"] !== undefined ? data["tenantId"] : <any>null;
            this.success = data["success"] !== undefined ? data["success"] : <any>null;
            this.appDataSourcesProcessed = data["appDataSourcesProcessed"] !== undefined ? data["appDataSourcesProcessed"] : <any>null;
            this.appDataSourcesMigrated = data["appDataSourcesMigrated"] !== undefined ? data["appDataSourcesMigrated"] : <any>null;
            this.tenantDataMigrated = data["tenantDataMigrated"] !== undefined ? data["tenantDataMigrated"] : <any>null;
            if (Array.isArray(data["errors"])) {
                this.errors = [] as any;
                for (let item in data["errors"])
                    this.errors!.push(data["errors"][item]);
            }
            else {
                this.errors = <any>null;
            }
        }
    }

    static fromJS(data: any): TenantMigrationResult {
        data = typeof data === 'object' ? data : {};
        let result = new TenantMigrationResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantName"] = this.tenantName !== undefined ? this.tenantName : <any>null;
        data["tenantId"] = this.tenantId !== undefined ? this.tenantId : <any>null;
        data["success"] = this.success !== undefined ? this.success : <any>null;
        data["appDataSourcesProcessed"] = this.appDataSourcesProcessed !== undefined ? this.appDataSourcesProcessed : <any>null;
        data["appDataSourcesMigrated"] = this.appDataSourcesMigrated !== undefined ? this.appDataSourcesMigrated : <any>null;
        data["tenantDataMigrated"] = this.tenantDataMigrated !== undefined ? this.tenantDataMigrated : <any>null;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item in this.errors)
                data["errors"].push(this.errors[item]);
        }
        return data;
    }

    clone(): TenantMigrationResult {
        const json = this.toJSON();
        let result = new TenantMigrationResult();
        result.init(json);
        return result;
    }
}

export interface ITenantMigrationResult {
    tenantName: string;
    tenantId: number;
    success: boolean;
    appDataSourcesProcessed: number;
    appDataSourcesMigrated: number;
    tenantDataMigrated: boolean;
    errors: string[];
}

export class SignalRConnfig implements ISignalRConnfig {
    url?: string | null;
    token?: string | null;

    constructor(data?: ISignalRConnfig) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.url = data["url"] !== undefined ? data["url"] : <any>null;
            this.token = data["token"] !== undefined ? data["token"] : <any>null;
        }
    }

    static fromJS(data: any): SignalRConnfig {
        data = typeof data === 'object' ? data : {};
        let result = new SignalRConnfig();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["url"] = this.url !== undefined ? this.url : <any>null;
        data["token"] = this.token !== undefined ? this.token : <any>null;
        return data;
    }

    clone(): SignalRConnfig {
        const json = this.toJSON();
        let result = new SignalRConnfig();
        result.init(json);
        return result;
    }
}

export interface ISignalRConnfig {
    url?: string | null;
    token?: string | null;
}

export class TableData implements ITableData {
    metadata?: TableMetadata | null;
    data?: any[][] | null;

    constructor(data?: ITableData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.metadata = data["metadata"] ? TableMetadata.fromJS(data["metadata"]) : <any>null;
            if (Array.isArray(data["data"])) {
                this.data = [] as any;
                for (let item in data["data"])
                    this.data!.push(data["data"][item]);
            }
            else {
                this.data = <any>null;
            }
        }
    }

    static fromJS(data: any): TableData {
        data = typeof data === 'object' ? data : {};
        let result = new TableData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["metadata"] = this.metadata ? this.metadata.toJSON() : <any>null;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item in this.data)
                data["data"].push(this.data[item]);
        }
        return data;
    }

    clone(): TableData {
        const json = this.toJSON();
        let result = new TableData();
        result.init(json);
        return result;
    }
}

export interface ITableData {
    metadata?: TableMetadata | null;
    data?: any[][] | null;
}

export class TableMetadata implements ITableMetadata {
    columns?: TableColumnMetadata[] | null;
    rowCount!: number;

    constructor(data?: ITableMetadata) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (Array.isArray(data["columns"])) {
                this.columns = [] as any;
                for (let item in data["columns"])
                    this.columns!.push(TableColumnMetadata.fromJS(data["columns"][item]));
            }
            else {
                this.columns = <any>null;
            }
            this.rowCount = data["rowCount"] !== undefined ? data["rowCount"] : <any>null;
        }
    }

    static fromJS(data: any): TableMetadata {
        data = typeof data === 'object' ? data : {};
        let result = new TableMetadata();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.columns)) {
            data["columns"] = [];
            for (let item in this.columns)
                data["columns"].push(this.columns[item].toJSON());
        }
        data["rowCount"] = this.rowCount !== undefined ? this.rowCount : <any>null;
        return data;
    }

    clone(): TableMetadata {
        const json = this.toJSON();
        let result = new TableMetadata();
        result.init(json);
        return result;
    }
}

export interface ITableMetadata {
    columns?: TableColumnMetadata[] | null;
    rowCount: number;
}

export class TableColumnMetadata implements ITableColumnMetadata {
    columnName?: string | null;
    columnCaption?: string | null;
    columnType?: string | null;
    validation?: TableColumnValidation | null;

    constructor(data?: ITableColumnMetadata) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.columnName = data["columnName"] !== undefined ? data["columnName"] : <any>null;
            this.columnCaption = data["columnCaption"] !== undefined ? data["columnCaption"] : <any>null;
            this.columnType = data["columnType"] !== undefined ? data["columnType"] : <any>null;
            this.validation = data["validation"] ? TableColumnValidation.fromJS(data["validation"]) : <any>null;
        }
    }

    static fromJS(data: any): TableColumnMetadata {
        data = typeof data === 'object' ? data : {};
        let result = new TableColumnMetadata();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["columnName"] = this.columnName !== undefined ? this.columnName : <any>null;
        data["columnCaption"] = this.columnCaption !== undefined ? this.columnCaption : <any>null;
        data["columnType"] = this.columnType !== undefined ? this.columnType : <any>null;
        data["validation"] = this.validation ? this.validation.toJSON() : <any>null;
        return data;
    }

    clone(): TableColumnMetadata {
        const json = this.toJSON();
        let result = new TableColumnMetadata();
        result.init(json);
        return result;
    }
}

export interface ITableColumnMetadata {
    columnName?: string | null;
    columnCaption?: string | null;
    columnType?: string | null;
    validation?: TableColumnValidation | null;
}

export class TableColumnValidation implements ITableColumnValidation {
    allowNulls!: boolean;
    rule?: string | null;

    constructor(data?: ITableColumnValidation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.allowNulls = data["allowNulls"] !== undefined ? data["allowNulls"] : <any>null;
            this.rule = data["rule"] !== undefined ? data["rule"] : <any>null;
        }
    }

    static fromJS(data: any): TableColumnValidation {
        data = typeof data === 'object' ? data : {};
        let result = new TableColumnValidation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["allowNulls"] = this.allowNulls !== undefined ? this.allowNulls : <any>null;
        data["rule"] = this.rule !== undefined ? this.rule : <any>null;
        return data;
    }

    clone(): TableColumnValidation {
        const json = this.toJSON();
        let result = new TableColumnValidation();
        result.init(json);
        return result;
    }
}

export interface ITableColumnValidation {
    allowNulls: boolean;
    rule?: string | null;
}

export class ThemeInfo implements IThemeInfo {
    themeName?: string | null;
    isCurrentTheme!: boolean;
    themeCustomSettings?: ThemeCustomSettingsInfo[] | null;

    constructor(data?: IThemeInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.themeName = data["themeName"] !== undefined ? data["themeName"] : <any>null;
            this.isCurrentTheme = data["isCurrentTheme"] !== undefined ? data["isCurrentTheme"] : <any>null;
            if (Array.isArray(data["themeCustomSettings"])) {
                this.themeCustomSettings = [] as any;
                for (let item in data["themeCustomSettings"])
                    this.themeCustomSettings!.push(ThemeCustomSettingsInfo.fromJS(data["themeCustomSettings"][item]));
            }
            else {
                this.themeCustomSettings = <any>null;
            }
        }
    }

    static fromJS(data: any): ThemeInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ThemeInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["themeName"] = this.themeName !== undefined ? this.themeName : <any>null;
        data["isCurrentTheme"] = this.isCurrentTheme !== undefined ? this.isCurrentTheme : <any>null;
        if (Array.isArray(this.themeCustomSettings)) {
            data["themeCustomSettings"] = [];
            for (let item in this.themeCustomSettings)
                data["themeCustomSettings"].push(this.themeCustomSettings[item].toJSON());
        }
        return data;
    }

    clone(): ThemeInfo {
        const json = this.toJSON();
        let result = new ThemeInfo();
        result.init(json);
        return result;
    }
}

export interface IThemeInfo {
    themeName?: string | null;
    isCurrentTheme: boolean;
    themeCustomSettings?: ThemeCustomSettingsInfo[] | null;
}

export class ThemeCustomSettingsInfo implements IThemeCustomSettingsInfo {
    settingId!: number;
    themeName?: string | null;
    elementKey?: string | null;
    elementSetting?: string | null;

    constructor(data?: IThemeCustomSettingsInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.settingId = data["settingId"] !== undefined ? data["settingId"] : <any>null;
            this.themeName = data["themeName"] !== undefined ? data["themeName"] : <any>null;
            this.elementKey = data["elementKey"] !== undefined ? data["elementKey"] : <any>null;
            this.elementSetting = data["elementSetting"] !== undefined ? data["elementSetting"] : <any>null;
        }
    }

    static fromJS(data: any): ThemeCustomSettingsInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ThemeCustomSettingsInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["settingId"] = this.settingId !== undefined ? this.settingId : <any>null;
        data["themeName"] = this.themeName !== undefined ? this.themeName : <any>null;
        data["elementKey"] = this.elementKey !== undefined ? this.elementKey : <any>null;
        data["elementSetting"] = this.elementSetting !== undefined ? this.elementSetting : <any>null;
        return data;
    }

    clone(): ThemeCustomSettingsInfo {
        const json = this.toJSON();
        let result = new ThemeCustomSettingsInfo();
        result.init(json);
        return result;
    }
}

export interface IThemeCustomSettingsInfo {
    settingId: number;
    themeName?: string | null;
    elementKey?: string | null;
    elementSetting?: string | null;
}

export class UserDetailsShort implements IUserDetailsShort {
    userName?: string | null;
    fullName?: string | null;
    email?: string | null;

    constructor(data?: IUserDetailsShort) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.userName = data["userName"] !== undefined ? data["userName"] : <any>null;
            this.fullName = data["fullName"] !== undefined ? data["fullName"] : <any>null;
            this.email = data["email"] !== undefined ? data["email"] : <any>null;
        }
    }

    static fromJS(data: any): UserDetailsShort {
        data = typeof data === 'object' ? data : {};
        let result = new UserDetailsShort();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName !== undefined ? this.userName : <any>null;
        data["fullName"] = this.fullName !== undefined ? this.fullName : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        return data;
    }

    clone(): UserDetailsShort {
        const json = this.toJSON();
        let result = new UserDetailsShort();
        result.init(json);
        return result;
    }
}

export interface IUserDetailsShort {
    userName?: string | null;
    fullName?: string | null;
    email?: string | null;
}

export class UserImportResult implements IUserImportResult {
    importResults?: ImportResult[] | null;
    usersToImport?: UserObject[] | null;

    constructor(data?: IUserImportResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (Array.isArray(data["importResults"])) {
                this.importResults = [] as any;
                for (let item in data["importResults"])
                    this.importResults!.push(ImportResult.fromJS(data["importResults"][item]));
            }
            else {
                this.importResults = <any>null;
            }
            if (Array.isArray(data["usersToImport"])) {
                this.usersToImport = [] as any;
                for (let item in data["usersToImport"])
                    this.usersToImport!.push(UserObject.fromJS(data["usersToImport"][item]));
            }
            else {
                this.usersToImport = <any>null;
            }
        }
    }

    static fromJS(data: any): UserImportResult {
        data = typeof data === 'object' ? data : {};
        let result = new UserImportResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.importResults)) {
            data["importResults"] = [];
            for (let item in this.importResults)
                data["importResults"].push(this.importResults[item].toJSON());
        }
        if (Array.isArray(this.usersToImport)) {
            data["usersToImport"] = [];
            for (let item in this.usersToImport)
                data["usersToImport"].push(this.usersToImport[item].toJSON());
        }
        return data;
    }

    clone(): UserImportResult {
        const json = this.toJSON();
        let result = new UserImportResult();
        result.init(json);
        return result;
    }
}

export interface IUserImportResult {
    importResults?: ImportResult[] | null;
    usersToImport?: UserObject[] | null;
}

export class ImportResult implements IImportResult {
    lineNumber!: number;
    errorCode?: number | null;
    warningCode?: number | null;
    variable?: any | null;
    type?: string | null;

    constructor(data?: IImportResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.lineNumber = data["lineNumber"] !== undefined ? data["lineNumber"] : <any>null;
            this.errorCode = data["errorCode"] !== undefined ? data["errorCode"] : <any>null;
            this.warningCode = data["warningCode"] !== undefined ? data["warningCode"] : <any>null;
            this.variable = data["variable"] !== undefined ? data["variable"] : <any>null;
            this.type = data["type"] !== undefined ? data["type"] : <any>null;
        }
    }

    static fromJS(data: any): ImportResult {
        data = typeof data === 'object' ? data : {};
        let result = new ImportResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lineNumber"] = this.lineNumber !== undefined ? this.lineNumber : <any>null;
        data["errorCode"] = this.errorCode !== undefined ? this.errorCode : <any>null;
        data["warningCode"] = this.warningCode !== undefined ? this.warningCode : <any>null;
        data["variable"] = this.variable !== undefined ? this.variable : <any>null;
        data["type"] = this.type !== undefined ? this.type : <any>null;
        return data;
    }

    clone(): ImportResult {
        const json = this.toJSON();
        let result = new ImportResult();
        result.init(json);
        return result;
    }
}

export interface IImportResult {
    lineNumber: number;
    errorCode?: number | null;
    warningCode?: number | null;
    variable?: any | null;
    type?: string | null;
}

export class ApiToken implements IApiToken {
    token?: string | null;
    description?: string | null;
    creationDate?: Date | null;
    expirationDate?: Date | null;

    constructor(data?: IApiToken) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.token = data["token"] !== undefined ? data["token"] : <any>null;
            this.description = data["description"] !== undefined ? data["description"] : <any>null;
            this.creationDate = data["creationDate"] ? new Date(data["creationDate"].toString()) : <any>null;
            this.expirationDate = data["expirationDate"] ? new Date(data["expirationDate"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): ApiToken {
        data = typeof data === 'object' ? data : {};
        let result = new ApiToken();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token !== undefined ? this.token : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["creationDate"] = this.creationDate ? this.creationDate.toISOString() : <any>null;
        data["expirationDate"] = this.expirationDate ? this.expirationDate.toISOString() : <any>null;
        return data;
    }

    clone(): ApiToken {
        const json = this.toJSON();
        let result = new ApiToken();
        result.init(json);
        return result;
    }
}

export interface IApiToken {
    token?: string | null;
    description?: string | null;
    creationDate?: Date | null;
    expirationDate?: Date | null;
}

export class WhatsNewArticle implements IWhatsNewArticle {
    id!: number;
    name?: string | null;
    sortOrder!: number;
    language?: string | null;
    versionFrom?: string | null;
    versionTo?: string | null;
    showDemoScheduleButton!: boolean;
    moreDetailsLink?: string | null;
    htmlText?: string | null;
    modulesCommaSeparated?: string[] | null;

    constructor(data?: IWhatsNewArticle) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"] !== undefined ? data["id"] : <any>null;
            this.name = data["name"] !== undefined ? data["name"] : <any>null;
            this.sortOrder = data["sortOrder"] !== undefined ? data["sortOrder"] : <any>null;
            this.language = data["language"] !== undefined ? data["language"] : <any>null;
            this.versionFrom = data["versionFrom"] !== undefined ? data["versionFrom"] : <any>null;
            this.versionTo = data["versionTo"] !== undefined ? data["versionTo"] : <any>null;
            this.showDemoScheduleButton = data["showDemoScheduleButton"] !== undefined ? data["showDemoScheduleButton"] : <any>null;
            this.moreDetailsLink = data["moreDetailsLink"] !== undefined ? data["moreDetailsLink"] : <any>null;
            this.htmlText = data["htmlText"] !== undefined ? data["htmlText"] : <any>null;
            if (Array.isArray(data["modulesCommaSeparated"])) {
                this.modulesCommaSeparated = [] as any;
                for (let item in data["modulesCommaSeparated"])
                    this.modulesCommaSeparated!.push(data["modulesCommaSeparated"][item]);
            }
            else {
                this.modulesCommaSeparated = <any>null;
            }
        }
    }

    static fromJS(data: any): WhatsNewArticle {
        data = typeof data === 'object' ? data : {};
        let result = new WhatsNewArticle();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["sortOrder"] = this.sortOrder !== undefined ? this.sortOrder : <any>null;
        data["language"] = this.language !== undefined ? this.language : <any>null;
        data["versionFrom"] = this.versionFrom !== undefined ? this.versionFrom : <any>null;
        data["versionTo"] = this.versionTo !== undefined ? this.versionTo : <any>null;
        data["showDemoScheduleButton"] = this.showDemoScheduleButton !== undefined ? this.showDemoScheduleButton : <any>null;
        data["moreDetailsLink"] = this.moreDetailsLink !== undefined ? this.moreDetailsLink : <any>null;
        data["htmlText"] = this.htmlText !== undefined ? this.htmlText : <any>null;
        if (Array.isArray(this.modulesCommaSeparated)) {
            data["modulesCommaSeparated"] = [];
            for (let item in this.modulesCommaSeparated)
                data["modulesCommaSeparated"].push(this.modulesCommaSeparated[item]);
        }
        return data;
    }

    clone(): WhatsNewArticle {
        const json = this.toJSON();
        let result = new WhatsNewArticle();
        result.init(json);
        return result;
    }
}

export interface IWhatsNewArticle {
    id: number;
    name?: string | null;
    sortOrder: number;
    language?: string | null;
    versionFrom?: string | null;
    versionTo?: string | null;
    showDemoScheduleButton: boolean;
    moreDetailsLink?: string | null;
    htmlText?: string | null;
    modulesCommaSeparated?: string[] | null;
}

export class WritebackData implements IWritebackData {
    model?: string | null;
    allocationMethod?: string | null;
    dimensions?: string[] | null;
    tuples?: WritebackTuple[] | null;

    constructor(data?: IWritebackData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.model = data["model"] !== undefined ? data["model"] : <any>null;
            this.allocationMethod = data["allocationMethod"] !== undefined ? data["allocationMethod"] : <any>null;
            if (Array.isArray(data["dimensions"])) {
                this.dimensions = [] as any;
                for (let item in data["dimensions"])
                    this.dimensions!.push(data["dimensions"][item]);
            }
            else {
                this.dimensions = <any>null;
            }
            if (Array.isArray(data["tuples"])) {
                this.tuples = [] as any;
                for (let item in data["tuples"])
                    this.tuples!.push(WritebackTuple.fromJS(data["tuples"][item]));
            }
            else {
                this.tuples = <any>null;
            }
        }
    }

    static fromJS(data: any): WritebackData {
        data = typeof data === 'object' ? data : {};
        let result = new WritebackData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["model"] = this.model !== undefined ? this.model : <any>null;
        data["allocationMethod"] = this.allocationMethod !== undefined ? this.allocationMethod : <any>null;
        if (Array.isArray(this.dimensions)) {
            data["dimensions"] = [];
            for (let item in this.dimensions)
                data["dimensions"].push(this.dimensions[item]);
        }
        if (Array.isArray(this.tuples)) {
            data["tuples"] = [];
            for (let item in this.tuples)
                data["tuples"].push(this.tuples[item].toJSON());
        }
        return data;
    }

    clone(): WritebackData {
        const json = this.toJSON();
        let result = new WritebackData();
        result.init(json);
        return result;
    }
}

export interface IWritebackData {
    model?: string | null;
    allocationMethod?: string | null;
    dimensions?: string[] | null;
    tuples?: WritebackTuple[] | null;
}

export class WritebackTuple implements IWritebackTuple {
    names?: string[] | null;
    keys?: number[] | null;
    newValue?: string | null;

    constructor(data?: IWritebackTuple) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (Array.isArray(data["names"])) {
                this.names = [] as any;
                for (let item in data["names"])
                    this.names!.push(data["names"][item]);
            }
            else {
                this.names = <any>null;
            }
            if (Array.isArray(data["keys"])) {
                this.keys = [] as any;
                for (let item in data["keys"])
                    this.keys!.push(data["keys"][item]);
            }
            else {
                this.keys = <any>null;
            }
            this.newValue = data["newValue"] !== undefined ? data["newValue"] : <any>null;
        }
    }

    static fromJS(data: any): WritebackTuple {
        data = typeof data === 'object' ? data : {};
        let result = new WritebackTuple();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.names)) {
            data["names"] = [];
            for (let item in this.names)
                data["names"].push(this.names[item]);
        }
        if (Array.isArray(this.keys)) {
            data["keys"] = [];
            for (let item in this.keys)
                data["keys"].push(this.keys[item]);
        }
        data["newValue"] = this.newValue !== undefined ? this.newValue : <any>null;
        return data;
    }

    clone(): WritebackTuple {
        const json = this.toJSON();
        let result = new WritebackTuple();
        result.init(json);
        return result;
    }
}

export interface IWritebackTuple {
    names?: string[] | null;
    keys?: number[] | null;
    newValue?: string | null;
}

export class WritebackResolvedSecurity implements IWritebackResolvedSecurity {
    restrictedHierarchies?: string[] | null;
    allowedMembers?: { [key: string]: number[]; } | null;
    allowedTuples?: TupleOfStringOfAndInt32Of[] | null;
    restrictTuples!: boolean;
    restrictMembers!: boolean;

    constructor(data?: IWritebackResolvedSecurity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (Array.isArray(data["restrictedHierarchies"])) {
                this.restrictedHierarchies = [] as any;
                for (let item in data["restrictedHierarchies"])
                    this.restrictedHierarchies!.push(data["restrictedHierarchies"][item]);
            }
            else {
                this.restrictedHierarchies = <any>null;
            }
            if (data["allowedMembers"]) {
                this.allowedMembers = {} as any;
                for (let key in data["allowedMembers"]) {
                    if (data["allowedMembers"].hasOwnProperty(key))
                        (<any>this.allowedMembers)![key] = data["allowedMembers"][key] !== undefined ? data["allowedMembers"][key] : [];
                }
            }
            else {
                this.allowedMembers = <any>null;
            }
            if (Array.isArray(data["allowedTuples"])) {
                this.allowedTuples = [] as any;
                for (let item in data["allowedTuples"])
                    this.allowedTuples!.push(TupleOfStringOfAndInt32Of.fromJS(data["allowedTuples"][item]));
            }
            else {
                this.allowedTuples = <any>null;
            }
            this.restrictTuples = data["restrictTuples"] !== undefined ? data["restrictTuples"] : <any>null;
            this.restrictMembers = data["restrictMembers"] !== undefined ? data["restrictMembers"] : <any>null;
        }
    }

    static fromJS(data: any): WritebackResolvedSecurity {
        data = typeof data === 'object' ? data : {};
        let result = new WritebackResolvedSecurity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.restrictedHierarchies)) {
            data["restrictedHierarchies"] = [];
            for (let item in this.restrictedHierarchies)
                data["restrictedHierarchies"].push(this.restrictedHierarchies[item]);
        }
        if (this.allowedMembers) {
            data["allowedMembers"] = {};
            for (let key in this.allowedMembers) {
                if (this.allowedMembers.hasOwnProperty(key))
                    (<any>data["allowedMembers"])[key] = this.allowedMembers[key] !== undefined ? this.allowedMembers[key] : <any>null;
            }
        }
        if (Array.isArray(this.allowedTuples)) {
            data["allowedTuples"] = [];
            for (let item in this.allowedTuples)
                data["allowedTuples"].push(this.allowedTuples[item].toJSON());
        }
        data["restrictTuples"] = this.restrictTuples !== undefined ? this.restrictTuples : <any>null;
        data["restrictMembers"] = this.restrictMembers !== undefined ? this.restrictMembers : <any>null;
        return data;
    }

    clone(): WritebackResolvedSecurity {
        const json = this.toJSON();
        let result = new WritebackResolvedSecurity();
        result.init(json);
        return result;
    }
}

export interface IWritebackResolvedSecurity {
    restrictedHierarchies?: string[] | null;
    allowedMembers?: { [key: string]: number[]; } | null;
    allowedTuples?: TupleOfStringOfAndInt32Of[] | null;
    restrictTuples: boolean;
    restrictMembers: boolean;
}

export class TupleOfStringOfAndInt32Of implements ITupleOfStringOfAndInt32Of {
    item1?: string[] | null;
    item2?: number[] | null;

    constructor(data?: ITupleOfStringOfAndInt32Of) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (Array.isArray(data["item1"])) {
                this.item1 = [] as any;
                for (let item in data["item1"])
                    this.item1!.push(data["item1"][item]);
            }
            else {
                this.item1 = <any>null;
            }
            if (Array.isArray(data["item2"])) {
                this.item2 = [] as any;
                for (let item in data["item2"])
                    this.item2!.push(data["item2"][item]);
            }
            else {
                this.item2 = <any>null;
            }
        }
    }

    static fromJS(data: any): TupleOfStringOfAndInt32Of {
        data = typeof data === 'object' ? data : {};
        let result = new TupleOfStringOfAndInt32Of();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.item1)) {
            data["item1"] = [];
            for (let item in this.item1)
                data["item1"].push(this.item1[item]);
        }
        if (Array.isArray(this.item2)) {
            data["item2"] = [];
            for (let item in this.item2)
                data["item2"].push(this.item2[item]);
        }
        return data;
    }

    clone(): TupleOfStringOfAndInt32Of {
        const json = this.toJSON();
        let result = new TupleOfStringOfAndInt32Of();
        result.init(json);
        return result;
    }
}

export interface ITupleOfStringOfAndInt32Of {
    item1?: string[] | null;
    item2?: number[] | null;
}

export class AddCubeCommentModel implements IAddCubeCommentModel {
    connectionKey?: string | null;
    commentXml?: string | null;
    parentMembers?: TupleOfStringAndStringAndInteger[] | null;

    constructor(data?: IAddCubeCommentModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.connectionKey = data["connectionKey"] !== undefined ? data["connectionKey"] : <any>null;
            this.commentXml = data["commentXml"] !== undefined ? data["commentXml"] : <any>null;
            if (Array.isArray(data["parentMembers"])) {
                this.parentMembers = [] as any;
                for (let item in data["parentMembers"])
                    this.parentMembers!.push(TupleOfStringAndStringAndInteger.fromJS(data["parentMembers"][item]));
            }
            else {
                this.parentMembers = <any>null;
            }
        }
    }

    static fromJS(data: any): AddCubeCommentModel {
        data = typeof data === 'object' ? data : {};
        let result = new AddCubeCommentModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["connectionKey"] = this.connectionKey !== undefined ? this.connectionKey : <any>null;
        data["commentXml"] = this.commentXml !== undefined ? this.commentXml : <any>null;
        if (Array.isArray(this.parentMembers)) {
            data["parentMembers"] = [];
            for (let item in this.parentMembers)
                data["parentMembers"].push(this.parentMembers[item].toJSON());
        }
        return data;
    }

    clone(): AddCubeCommentModel {
        const json = this.toJSON();
        let result = new AddCubeCommentModel();
        result.init(json);
        return result;
    }
}

export interface IAddCubeCommentModel {
    connectionKey?: string | null;
    commentXml?: string | null;
    parentMembers?: TupleOfStringAndStringAndInteger[] | null;
}

export class TupleOfStringAndStringAndInteger implements ITupleOfStringAndStringAndInteger {
    item1?: string | null;
    item2?: string | null;
    item3!: number;

    constructor(data?: ITupleOfStringAndStringAndInteger) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.item1 = data["item1"] !== undefined ? data["item1"] : <any>null;
            this.item2 = data["item2"] !== undefined ? data["item2"] : <any>null;
            this.item3 = data["item3"] !== undefined ? data["item3"] : <any>null;
        }
    }

    static fromJS(data: any): TupleOfStringAndStringAndInteger {
        data = typeof data === 'object' ? data : {};
        let result = new TupleOfStringAndStringAndInteger();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["item1"] = this.item1 !== undefined ? this.item1 : <any>null;
        data["item2"] = this.item2 !== undefined ? this.item2 : <any>null;
        data["item3"] = this.item3 !== undefined ? this.item3 : <any>null;
        return data;
    }

    clone(): TupleOfStringAndStringAndInteger {
        const json = this.toJSON();
        let result = new TupleOfStringAndStringAndInteger();
        result.init(json);
        return result;
    }
}

export interface ITupleOfStringAndStringAndInteger {
    item1?: string | null;
    item2?: string | null;
    item3: number;
}

export class CubeCommentsByKeyModel implements ICubeCommentsByKeyModel {
    commentKeys?: string[] | null;
    mergeComments!: boolean;
    exactMatch!: boolean;

    constructor(data?: ICubeCommentsByKeyModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (Array.isArray(data["commentKeys"])) {
                this.commentKeys = [] as any;
                for (let item in data["commentKeys"])
                    this.commentKeys!.push(data["commentKeys"][item]);
            }
            else {
                this.commentKeys = <any>null;
            }
            this.mergeComments = data["mergeComments"] !== undefined ? data["mergeComments"] : <any>null;
            this.exactMatch = data["exactMatch"] !== undefined ? data["exactMatch"] : <any>null;
        }
    }

    static fromJS(data: any): CubeCommentsByKeyModel {
        data = typeof data === 'object' ? data : {};
        let result = new CubeCommentsByKeyModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.commentKeys)) {
            data["commentKeys"] = [];
            for (let item in this.commentKeys)
                data["commentKeys"].push(this.commentKeys[item]);
        }
        data["mergeComments"] = this.mergeComments !== undefined ? this.mergeComments : <any>null;
        data["exactMatch"] = this.exactMatch !== undefined ? this.exactMatch : <any>null;
        return data;
    }

    clone(): CubeCommentsByKeyModel {
        const json = this.toJSON();
        let result = new CubeCommentsByKeyModel();
        result.init(json);
        return result;
    }
}

export interface ICubeCommentsByKeyModel {
    commentKeys?: string[] | null;
    mergeComments: boolean;
    exactMatch: boolean;
}

export class GetCubeCommentsWithDescByKeyModel implements IGetCubeCommentsWithDescByKeyModel {
    commentKeys?: string[] | null;
    defaultMembers?: string[] | null;

    constructor(data?: IGetCubeCommentsWithDescByKeyModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (Array.isArray(data["commentKeys"])) {
                this.commentKeys = [] as any;
                for (let item in data["commentKeys"])
                    this.commentKeys!.push(data["commentKeys"][item]);
            }
            else {
                this.commentKeys = <any>null;
            }
            if (Array.isArray(data["defaultMembers"])) {
                this.defaultMembers = [] as any;
                for (let item in data["defaultMembers"])
                    this.defaultMembers!.push(data["defaultMembers"][item]);
            }
            else {
                this.defaultMembers = <any>null;
            }
        }
    }

    static fromJS(data: any): GetCubeCommentsWithDescByKeyModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetCubeCommentsWithDescByKeyModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.commentKeys)) {
            data["commentKeys"] = [];
            for (let item in this.commentKeys)
                data["commentKeys"].push(this.commentKeys[item]);
        }
        if (Array.isArray(this.defaultMembers)) {
            data["defaultMembers"] = [];
            for (let item in this.defaultMembers)
                data["defaultMembers"].push(this.defaultMembers[item]);
        }
        return data;
    }

    clone(): GetCubeCommentsWithDescByKeyModel {
        const json = this.toJSON();
        let result = new GetCubeCommentsWithDescByKeyModel();
        result.init(json);
        return result;
    }
}

export interface IGetCubeCommentsWithDescByKeyModel {
    commentKeys?: string[] | null;
    defaultMembers?: string[] | null;
}

export class TupleOfStringAndStringAndString implements ITupleOfStringAndStringAndString {
    item1?: string | null;
    item2?: string | null;
    item3?: string | null;

    constructor(data?: ITupleOfStringAndStringAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.item1 = data["item1"] !== undefined ? data["item1"] : <any>null;
            this.item2 = data["item2"] !== undefined ? data["item2"] : <any>null;
            this.item3 = data["item3"] !== undefined ? data["item3"] : <any>null;
        }
    }

    static fromJS(data: any): TupleOfStringAndStringAndString {
        data = typeof data === 'object' ? data : {};
        let result = new TupleOfStringAndStringAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["item1"] = this.item1 !== undefined ? this.item1 : <any>null;
        data["item2"] = this.item2 !== undefined ? this.item2 : <any>null;
        data["item3"] = this.item3 !== undefined ? this.item3 : <any>null;
        return data;
    }

    clone(): TupleOfStringAndStringAndString {
        const json = this.toJSON();
        let result = new TupleOfStringAndStringAndString();
        result.init(json);
        return result;
    }
}

export interface ITupleOfStringAndStringAndString {
    item1?: string | null;
    item2?: string | null;
    item3?: string | null;
}

export class ApiUserDetails implements IApiUserDetails {
    userId!: number;
    userName?: string | null;
    fullName?: string | null;
    isDisabled!: boolean;
    email?: string | null;
    roles?: string[] | null;

    constructor(data?: IApiUserDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.userId = data["userId"] !== undefined ? data["userId"] : <any>null;
            this.userName = data["userName"] !== undefined ? data["userName"] : <any>null;
            this.fullName = data["fullName"] !== undefined ? data["fullName"] : <any>null;
            this.isDisabled = data["isDisabled"] !== undefined ? data["isDisabled"] : <any>null;
            this.email = data["email"] !== undefined ? data["email"] : <any>null;
            if (Array.isArray(data["roles"])) {
                this.roles = [] as any;
                for (let item in data["roles"])
                    this.roles!.push(data["roles"][item]);
            }
            else {
                this.roles = <any>null;
            }
        }
    }

    static fromJS(data: any): ApiUserDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ApiUserDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId !== undefined ? this.userId : <any>null;
        data["userName"] = this.userName !== undefined ? this.userName : <any>null;
        data["fullName"] = this.fullName !== undefined ? this.fullName : <any>null;
        data["isDisabled"] = this.isDisabled !== undefined ? this.isDisabled : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item in this.roles)
                data["roles"].push(this.roles[item]);
        }
        return data;
    }

    clone(): ApiUserDetails {
        const json = this.toJSON();
        let result = new ApiUserDetails();
        result.init(json);
        return result;
    }
}

export interface IApiUserDetails {
    userId: number;
    userName?: string | null;
    fullName?: string | null;
    isDisabled: boolean;
    email?: string | null;
    roles?: string[] | null;
}

export class PowerBIReportInfo implements IPowerBIReportInfo {
    workspaceId?: string | null;
    reportId?: string | null;

    constructor(data?: IPowerBIReportInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.workspaceId = data["workspaceId"] !== undefined ? data["workspaceId"] : <any>null;
            this.reportId = data["reportId"] !== undefined ? data["reportId"] : <any>null;
        }
    }

    static fromJS(data: any): PowerBIReportInfo {
        data = typeof data === 'object' ? data : {};
        let result = new PowerBIReportInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workspaceId"] = this.workspaceId !== undefined ? this.workspaceId : <any>null;
        data["reportId"] = this.reportId !== undefined ? this.reportId : <any>null;
        return data;
    }

    clone(): PowerBIReportInfo {
        const json = this.toJSON();
        let result = new PowerBIReportInfo();
        result.init(json);
        return result;
    }
}

export interface IPowerBIReportInfo {
    workspaceId?: string | null;
    reportId?: string | null;
}

export class ToastNotification implements IToastNotification {
    message?: string | null;
    type!: ToastType;
    operationId?: string | null;

    constructor(data?: IToastNotification) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.message = data["message"] !== undefined ? data["message"] : <any>null;
            this.type = data["type"] !== undefined ? data["type"] : <any>null;
            this.operationId = data["operationId"] !== undefined ? data["operationId"] : <any>null;
        }
    }

    static fromJS(data: any): ToastNotification {
        data = typeof data === 'object' ? data : {};
        let result = new ToastNotification();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message !== undefined ? this.message : <any>null;
        data["type"] = this.type !== undefined ? this.type : <any>null;
        data["operationId"] = this.operationId !== undefined ? this.operationId : <any>null;
        return data;
    }

    clone(): ToastNotification {
        const json = this.toJSON();
        let result = new ToastNotification();
        result.init(json);
        return result;
    }
}

export interface IToastNotification {
    message?: string | null;
    type: ToastType;
    operationId?: string | null;
}

export enum ToastType {
    Info = 0,
    Success = 1,
    Warning = 2,
    Error = 3,
}

export class ProcessRunActivity implements IProcessRunActivity {
    uid?: string | null;
    processRunId!: string;
    subProcessRunId?: string | null;
    activityRunId!: string;
    caption?: string | null;
    burstingKey?: number | null;
    nodeId?: string | null;
    activityName?: string | null;
    startTime?: Date | null;
    endTime?: Date | null;
    dueDate?: Date | null;
    status?: ActivityExecutionResultEnum | null;
    percentComplete?: number | null;
    dueDateMessageSeqNumber?: number | null;
    errorMessage?: string | null;

    constructor(data?: IProcessRunActivity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.uid = data["uid"] !== undefined ? data["uid"] : <any>null;
            this.processRunId = data["processRunId"] !== undefined ? data["processRunId"] : <any>null;
            this.subProcessRunId = data["subProcessRunId"] !== undefined ? data["subProcessRunId"] : <any>null;
            this.activityRunId = data["activityRunId"] !== undefined ? data["activityRunId"] : <any>null;
            this.caption = data["caption"] !== undefined ? data["caption"] : <any>null;
            this.burstingKey = data["burstingKey"] !== undefined ? data["burstingKey"] : <any>null;
            this.nodeId = data["nodeId"] !== undefined ? data["nodeId"] : <any>null;
            this.activityName = data["activityName"] !== undefined ? data["activityName"] : <any>null;
            this.startTime = data["startTime"] ? new Date(data["startTime"].toString()) : <any>null;
            this.endTime = data["endTime"] ? new Date(data["endTime"].toString()) : <any>null;
            this.dueDate = data["dueDate"] ? new Date(data["dueDate"].toString()) : <any>null;
            this.status = data["status"] !== undefined ? data["status"] : <any>null;
            this.percentComplete = data["percentComplete"] !== undefined ? data["percentComplete"] : <any>null;
            this.dueDateMessageSeqNumber = data["dueDateMessageSeqNumber"] !== undefined ? data["dueDateMessageSeqNumber"] : <any>null;
            this.errorMessage = data["errorMessage"] !== undefined ? data["errorMessage"] : <any>null;
        }
    }

    static fromJS(data: any): ProcessRunActivity {
        data = typeof data === 'object' ? data : {};
        let result = new ProcessRunActivity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uid"] = this.uid !== undefined ? this.uid : <any>null;
        data["processRunId"] = this.processRunId !== undefined ? this.processRunId : <any>null;
        data["subProcessRunId"] = this.subProcessRunId !== undefined ? this.subProcessRunId : <any>null;
        data["activityRunId"] = this.activityRunId !== undefined ? this.activityRunId : <any>null;
        data["caption"] = this.caption !== undefined ? this.caption : <any>null;
        data["burstingKey"] = this.burstingKey !== undefined ? this.burstingKey : <any>null;
        data["nodeId"] = this.nodeId !== undefined ? this.nodeId : <any>null;
        data["activityName"] = this.activityName !== undefined ? this.activityName : <any>null;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>null;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>null;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["percentComplete"] = this.percentComplete !== undefined ? this.percentComplete : <any>null;
        data["dueDateMessageSeqNumber"] = this.dueDateMessageSeqNumber !== undefined ? this.dueDateMessageSeqNumber : <any>null;
        data["errorMessage"] = this.errorMessage !== undefined ? this.errorMessage : <any>null;
        return data;
    }

    clone(): ProcessRunActivity {
        const json = this.toJSON();
        let result = new ProcessRunActivity();
        result.init(json);
        return result;
    }
}

export interface IProcessRunActivity {
    uid?: string | null;
    processRunId: string;
    subProcessRunId?: string | null;
    activityRunId: string;
    caption?: string | null;
    burstingKey?: number | null;
    nodeId?: string | null;
    activityName?: string | null;
    startTime?: Date | null;
    endTime?: Date | null;
    dueDate?: Date | null;
    status?: ActivityExecutionResultEnum | null;
    percentComplete?: number | null;
    dueDateMessageSeqNumber?: number | null;
    errorMessage?: string | null;
}

export class Item implements IItem {

    [key: string]: any;

    constructor(data?: IItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }

    static fromJS(data: any): Item {
        data = typeof data === 'object' ? data : {};
        let result = new Item();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        return data;
    }

    clone(): Item {
        const json = this.toJSON();
        let result = new Item();
        result.init(json);
        return result;
    }
}

export interface IItem {

    [key: string]: any;
}

export class Item2 implements IItem2 {

    [key: string]: any;

    constructor(data?: IItem2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }

    static fromJS(data: any): Item2 {
        data = typeof data === 'object' ? data : {};
        let result = new Item2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        return data;
    }

    clone(): Item2 {
        const json = this.toJSON();
        let result = new Item2();
        result.init(json);
        return result;
    }
}

export interface IItem2 {

    [key: string]: any;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}
